{
 "Biomes": {
  "(Sub)tropical coniferous forest": [
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8413.1
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16926.4
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6798.9
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19537.8
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10454.8
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9304.7
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12858.9
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10731.1
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8479.2
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22888.4
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12169.9
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12116.8
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8309.4
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4905.8
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11655.7
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11629.3
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11363.5
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15032.6
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13982.6
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11131.8
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9643.6
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15153.5
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 17272.4
   },
   {
    "Region Name": "(Sub)tropical coniferous forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8374.8
   }
  ],
  "(Sub)tropical dry broadleaf forest": [
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 73046.0
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 87870.5
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 102361.0
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 84913.9
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 79868.1
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 87414.1
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 78422.2
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 69036.9
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 95702.3
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 76797.9
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 76463.7
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 66161.3
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 70290.3
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 71717.4
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 73510.1
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 74632.1
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 75757.6
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 84435.0
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 84411.0
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 75689.0
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 74723.9
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 63197.5
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 103179.2
   },
   {
    "Region Name": "(Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 62049.5
   }
  ],
  "(Sub)tropical grassland, savannah & shrubland": [
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3066717.3
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3096908.8
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3444643.2
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3187500.7
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3173039.1
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3298720.0
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2931609.7
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2879536.2
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3027309.8
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3151338.3
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3116809.9
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2662365.7
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2674181.2
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2789675.8
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2584371.6
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2664228.5
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2544723.6
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2513192.1
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2464913.8
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2543528.7
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2421023.0
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2600515.9
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2567986.5
   },
   {
    "Region Name": "(Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2437644.1
   }
  ],
  "(Sub)tropical moist broadleaf forest": [
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 241715.8
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 306724.5
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 334639.2
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 293788.9
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 279299.0
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 359228.2
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 242374.8
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 264828.2
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 328003.2
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 239434.1
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 260097.8
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 215362.8
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 243604.6
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 312529.4
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 232468.8
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 229938.4
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 202272.8
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 267028.7
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 254532.1
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 208133.9
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 215745.7
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 228743.9
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 301132.7
   },
   {
    "Region Name": "(Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 183546.4
   }
  ],
  "Boreal forest": [
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 77996.0
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 118040.8
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 48893.3
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 47718.1
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 50125.7
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 31072.6
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 61040.7
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 37364.1
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 44716.9
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 60933.5
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 94713.6
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 75848.0
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 105513.1
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 68641.4
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 52144.0
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 51907.3
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 57089.0
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 69601.1
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 62565.7
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 112234.2
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 35763.0
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 146206.5
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 96709.1
   },
   {
    "Region Name": "Boreal forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 66441.3
   }
  ],
  "Deserts & xeric shrublands": [
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 560216.5
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 125009.5
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 265466.4
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 162147.4
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 342998.3
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 275271.7
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 144646.8
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 115926.9
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 182419.0
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 652973.5
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 459599.2
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 112536.0
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 198424.0
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 219020.8
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 96197.2
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 380725.3
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 292332.4
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 142554.7
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 109163.1
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 211134.6
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 157049.7
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 472768.7
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 144730.6
   },
   {
    "Region Name": "Deserts & xeric shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 211180.3
   }
  ],
  "Flooded grassland & savannah": [
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 208349.3
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 177602.1
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 191255.5
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 205879.8
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 183828.1
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 199075.5
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 191890.5
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 185521.6
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 175812.4
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 182740.6
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 172463.1
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 150583.1
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 154106.7
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 187188.9
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 165948.2
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 163187.3
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 181002.7
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 162921.5
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 175891.3
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 179280.9
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 135989.0
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 160121.0
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 186673.8
   },
   {
    "Region Name": "Flooded grassland & savannah",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 138186.1
   }
  ],
  "Mangroves": [
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8213.1
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10213.6
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10898.9
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7913.6
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12066.2
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7866.3
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7359.3
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9992.8
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7352.0
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8104.9
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7856.2
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8677.4
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9533.0
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11782.1
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8151.6
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6264.1
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7686.6
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10284.6
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7495.8
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5831.9
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5479.5
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8514.3
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8449.1
   },
   {
    "Region Name": "Mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5317.4
   }
  ],
  "Mediterranean forests,  woodlands and scrub": [
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 27837.7
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 21095.4
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 29265.9
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18948.9
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16013.6
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22818.7
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13843.3
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 26906.3
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14001.1
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14917.5
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19241.8
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16241.5
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17853.9
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22982.1
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19110.4
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 32541.0
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19356.0
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 39735.9
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19599.8
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 19370.6
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15318.2
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16452.4
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18734.4
   },
   {
    "Region Name": "Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 25534.6
   }
  ],
  "Montane grassland & shrubland": [
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 73594.2
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 61168.9
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 52160.5
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 67582.2
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 59007.2
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 62730.2
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 56704.2
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51385.1
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 62387.8
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 56929.1
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 48579.0
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 54556.1
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 50060.3
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 44471.9
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 39794.0
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 43245.7
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 42044.6
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 47370.4
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 51035.3
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 46953.7
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 43584.0
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 48874.6
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 62150.1
   },
   {
    "Region Name": "Montane grassland & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 39183.9
   }
  ],
  "Temperate broadleaf & mixed forest": [
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 82046.7
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 66753.4
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 70367.9
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 79797.4
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 106561.5
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 78436.8
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 121468.8
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 103109.6
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 84885.6
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 81415.8
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 87405.5
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 61339.5
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 86629.3
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 62448.0
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 48914.9
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 54214.1
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 72014.3
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 100530.1
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 44349.3
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 51624.8
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 51042.1
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 52564.8
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 58453.3
   },
   {
    "Region Name": "Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 40988.9
   }
  ],
  "Temperate conifer forest": [
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 22039.3
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 21958.5
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7107.4
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8050.0
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12431.0
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 17857.6
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 25757.9
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9465.2
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9662.7
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17648.8
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22616.4
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16052.2
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14421.7
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16754.2
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11013.0
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24193.3
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 28012.7
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6384.6
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21079.1
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 27467.3
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12302.2
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18646.5
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23896.6
   },
   {
    "Region Name": "Temperate conifer forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8401.5
   }
  ],
  "Temperate grassland, savannah & shrubland": [
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 229945.7
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 164375.6
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 141444.1
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 171387.8
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 179425.8
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 147645.4
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 209273.4
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 97827.7
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 139210.2
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 102921.1
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 115821.4
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 47396.3
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 160374.8
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 138311.1
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 101285.1
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 148843.3
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 67074.8
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 108202.1
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 83116.9
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 64375.7
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 80170.8
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 73399.7
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 56134.0
   },
   {
    "Region Name": "Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 57275.1
   }
  ],
  "Tundra": [
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5630.8
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 21000.0
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17474.7
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6129.5
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2527.0
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3747.0
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3958.8
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4137.5
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12545.5
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2743.7
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3184.2
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2955.7
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2086.5
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7262.2
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8997.3
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2851.5
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1892.4
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7670.3
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3717.2
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6473.5
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5151.3
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5806.4
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7237.7
   },
   {
    "Region Name": "Tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5159.4
   }
  ]
 },
 "Countries": {
  "Afghanistan": [
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 196.1
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1024.7
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 173.9
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 137.0
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 156.5
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 541.3
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 99.0
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 471.4
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 178.4
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 277.6
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghanistan",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.9
   }
  ],
  "Albania": [
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1052.3
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 125.4
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 379.9
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 424.2
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 251.0
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 186.5
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 250.4
   },
   {
    "Region Name": "Albania",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 439.9
   }
  ],
  "Algeria": [
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 426.2
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 919.0
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1123.5
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1160.0
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 517.9
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2008.2
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 988.7
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1307.7
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 821.9
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 632.6
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2834.6
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 336.6
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1220.8
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 494.5
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 486.4
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1249.8
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 732.7
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1208.6
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1489.4
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 551.8
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 608.8
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Algeria",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 127.5
   }
  ],
  "American Samoa": [
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "American Samoa",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Andorra": [
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andorra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Angola": [
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 347649.7
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 406338.4
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 407196.3
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 401063.8
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 357580.4
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 389099.5
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 360787.3
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 361055.9
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 381362.5
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 398870.4
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 360604.5
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 374541.7
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 347820.6
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 365291.4
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 363549.5
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 372222.0
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 314291.1
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 368343.8
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 335243.3
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 340466.8
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 334164.4
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 353088.9
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 374156.9
   },
   {
    "Region Name": "Angola",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 346506.3
   }
  ],
  "Anguilla": [
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anguilla",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Antarctica": [
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Antigua and Barbuda": [
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antigua and Barbuda",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Argentina": [
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 48640.8
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 59541.8
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 48452.8
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 35481.5
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 31950.0
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 40213.7
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 50500.6
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30919.3
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 25202.9
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 39113.8
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 25181.5
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35439.9
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17470.9
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22358.9
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 46895.8
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 49456.4
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 24293.2
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 21953.5
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 56685.8
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 42859.9
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 29262.2
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17867.7
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22808.9
   },
   {
    "Region Name": "Argentina",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18487.8
   }
  ],
  "Armenia": [
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 140.6
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 98.4
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 641.4
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 106.1
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 188.6
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 133.6
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 130.6
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 216.9
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Armenia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 233.4
   }
  ],
  "Aruba": [
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aruba",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Australia": [
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 748511.2
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 285551.5
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 652070.6
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 267164.7
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 588211.2
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 518358.4
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 302018.3
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 415197.2
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 180665.9
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 929511.1
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 876608.0
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 266650.4
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 464230.0
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 418692.7
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 236709.0
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 502212.5
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 560762.9
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 342301.4
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 137886.9
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 279581.3
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 271262.3
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 738943.0
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 378920.4
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 477001.7
   }
  ],
  "Austria": [
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Austria",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Azerbaijan": [
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2000.7
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2030.1
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2367.3
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1331.2
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2919.1
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1196.6
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 863.0
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 811.2
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2200.5
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1973.5
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1053.4
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 955.4
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 346.0
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3471.5
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1629.8
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1542.8
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1298.2
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2478.3
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 429.2
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1792.8
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 690.5
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 258.5
   },
   {
    "Region Name": "Azerbaijan",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 852.3
   }
  ],
  "Bahamas": [
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 175.1
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 552.9
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 151.1
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 143.2
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 168.9
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 519.4
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 99.7
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 493.0
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 131.4
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 343.2
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 105.5
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 146.0
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 272.7
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 346.2
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 242.7
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 193.6
   },
   {
    "Region Name": "Bahamas",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 239.0
   }
  ],
  "Bahrain": [
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahrain",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bangladesh": [
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 284.3
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 164.4
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 413.3
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1409.0
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 394.2
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 881.9
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1035.0
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 200.2
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 251.2
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 259.8
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1105.5
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1012.3
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 203.2
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 265.4
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 195.7
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 991.0
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 701.6
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 95.8
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 204.7
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 800.7
   },
   {
    "Region Name": "Bangladesh",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2461.4
   }
  ],
  "Barbados": [
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbados",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bassas Da India": [
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bassas Da India",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Belarus": [
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1701.4
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 626.6
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 222.1
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 380.7
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 675.5
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 185.4
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 396.8
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 345.1
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 131.0
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 163.8
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 370.2
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 207.5
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 628.7
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 671.8
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 483.8
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 250.0
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 460.0
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 86.0
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 162.9
   },
   {
    "Region Name": "Belarus",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 78.2
   }
  ],
  "Belgium": [
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belgium",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Belize": [
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 276.8
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 797.2
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 86.6
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 397.7
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 149.4
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 552.6
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 338.7
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 175.6
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 291.5
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1087.9
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 646.5
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 144.7
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 308.9
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 302.3
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 328.6
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 225.5
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 478.5
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 486.8
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 211.8
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 141.7
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 629.0
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 866.3
   },
   {
    "Region Name": "Belize",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 359.5
   }
  ],
  "Benin": [
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 29472.7
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 24246.4
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 29237.1
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25540.1
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25875.8
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24434.6
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18470.0
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19381.3
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18702.2
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18688.3
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18744.0
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 17929.4
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16373.1
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18234.9
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15476.2
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14751.2
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14013.7
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17033.3
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13731.8
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12914.9
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13150.0
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10622.6
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12566.3
   },
   {
    "Region Name": "Benin",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10950.0
   }
  ],
  "Bermuda": [
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bhutan": [
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 176.4
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 144.9
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 91.7
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 136.3
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 138.9
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 93.9
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 89.8
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Bhutan",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.4
   }
  ],
  "Bolivia": [
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 45427.1
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 28131.6
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 63867.4
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 56332.7
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 46419.2
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 61408.6
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 31601.6
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20295.4
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 92147.2
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 32754.7
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 26269.8
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 17283.1
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10847.3
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22924.4
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 34613.9
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24937.3
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18466.2
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 53099.0
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 43576.9
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 45027.8
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 42618.5
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 55890.3
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 106971.4
   },
   {
    "Region Name": "Bolivia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15635.2
   }
  ],
  "Bonaire, Sint Eustatius and Saba": [
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire, Sint Eustatius and Saba",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bosnia and Herzegovina": [
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 728.2
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 490.5
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 328.8
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 610.7
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 500.8
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 96.7
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 320.7
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 294.5
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 107.0
   },
   {
    "Region Name": "Bosnia and Herzegovina",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 132.9
   }
  ],
  "Botswana": [
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 78337.1
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12373.6
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17316.3
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 26852.5
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 51974.4
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 26538.0
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 108682.1
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20973.2
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 133017.9
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 164030.0
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 48647.4
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 39762.2
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 29477.2
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17251.3
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13194.8
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 48156.7
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 26120.4
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11442.8
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 31395.2
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 105074.0
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 75072.0
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 105031.8
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20718.8
   },
   {
    "Region Name": "Botswana",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 25466.2
   }
  ],
  "Bouvet Island": [
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouvet Island",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Brazil": [
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 234740.9
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 163239.2
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 204650.8
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 225539.3
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 128281.6
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 379749.1
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 153987.0
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 93125.8
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 359364.3
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 144117.5
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 241335.1
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 95139.7
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 160922.9
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 203742.1
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 153695.5
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 207056.9
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 91674.7
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 193474.5
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 210974.7
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 160265.5
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 133744.8
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 124816.1
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 243265.7
   },
   {
    "Region Name": "Brazil",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 102815.0
   }
  ],
  "British Indian Ocean Territory": [
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Indian Ocean Territory",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "British Virgin Islands": [
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "British Virgin Islands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Brunei": [
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Bulgaria": [
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 294.3
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 481.7
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1220.0
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1049.3
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1837.6
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1098.6
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 706.8
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 270.5
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 685.6
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 691.1
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1581.8
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 613.3
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 353.1
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 465.6
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 621.5
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 701.2
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 418.0
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1537.2
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 138.3
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 232.6
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 229.2
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 318.6
   },
   {
    "Region Name": "Bulgaria",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 271.8
   }
  ],
  "Burkina Faso": [
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 36281.3
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 34403.9
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 34997.9
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 37057.5
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 30287.1
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 27014.4
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24750.2
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 28427.9
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26517.0
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 26268.1
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18753.4
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21215.9
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19072.4
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16627.7
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19739.3
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18083.5
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14261.1
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13953.9
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15505.5
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17137.9
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14433.3
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 32316.1
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 33204.3
   },
   {
    "Region Name": "Burkina Faso",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 34840.3
   }
  ],
  "Burundi": [
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 675.5
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 636.0
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 556.9
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 348.3
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 223.2
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 196.6
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 383.5
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 288.8
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 323.7
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 209.4
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 238.6
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 302.3
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 168.1
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 327.1
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 301.4
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 255.7
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 252.7
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 254.0
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 271.6
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 219.3
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 275.0
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 262.6
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 389.7
   },
   {
    "Region Name": "Burundi",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 211.8
   }
  ],
  "Cambodia": [
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 27807.1
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30590.5
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32305.0
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 30151.4
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 33202.1
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 26595.7
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 29837.2
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 24064.2
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 32633.4
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25357.1
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27510.6
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 23817.9
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 27923.1
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 28923.5
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 24152.3
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24558.1
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25193.9
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26402.3
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22158.9
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16056.0
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15621.9
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21239.0
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22227.9
   },
   {
    "Region Name": "Cambodia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 17015.5
   }
  ],
  "Cameroon": [
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 56132.7
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 66880.1
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 48641.0
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 60933.5
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 47812.2
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 46106.3
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 43895.5
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 40212.4
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 40316.4
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 34771.5
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 31643.2
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 25449.0
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 25854.4
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24586.4
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 23587.9
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22351.2
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22867.0
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23839.5
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 27081.5
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 23376.9
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 25295.8
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17821.8
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23414.2
   },
   {
    "Region Name": "Cameroon",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20909.8
   }
  ],
  "Canada": [
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24853.3
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18800.8
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23380.6
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14897.6
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18794.6
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13650.4
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14908.1
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7067.3
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 25067.2
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16382.1
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15736.4
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 38655.9
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 31641.7
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 29656.2
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9695.9
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 29301.5
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18061.4
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12791.6
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2637.4
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 36321.0
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11991.2
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 133110.3
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 46325.8
   },
   {
    "Region Name": "Canada",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 44157.7
   }
  ],
  "Cape Verde": [
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cayman Islands": [
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayman Islands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Central African Republic": [
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 226833.1
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 212295.2
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 230318.3
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 205493.3
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 242761.3
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 215787.9
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 195811.7
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 189040.7
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 200722.9
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 208783.0
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 170258.7
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 163472.9
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 164733.4
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 201407.4
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 180694.0
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 171743.0
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 176096.8
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 164106.5
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 163094.1
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 158805.2
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 159201.1
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 136727.3
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 143306.3
   },
   {
    "Region Name": "Central African Republic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 127566.3
   }
  ],
  "Chad": [
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 126987.5
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 122799.4
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 124209.0
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 139025.6
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 119820.3
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 119895.9
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 113707.7
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 93326.0
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 98727.0
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 111780.1
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 98698.7
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 86652.9
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 83131.4
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 85916.3
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 93718.3
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 77964.5
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 86619.7
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 71772.7
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 92388.8
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 76222.3
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 69021.9
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 69421.3
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 65560.9
   },
   {
    "Region Name": "Chad",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 67719.0
   }
  ],
  "Chile": [
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 248.7
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 798.1
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 878.1
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 881.1
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 585.4
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 625.5
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 973.4
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 719.4
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 743.9
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1241.6
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 643.5
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 852.3
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1166.2
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1863.9
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5309.5
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 376.2
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 719.0
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1083.8
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 700.8
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1335.1
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4217.5
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 888.3
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 701.2
   },
   {
    "Region Name": "Chile",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 989.5
   }
  ],
  "China": [
   {
    "Region Name": "China",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17469.6
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 36334.7
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21739.4
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 32033.4
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 43649.4
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 42961.9
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 32784.7
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 33756.7
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37142.0
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 31950.4
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 49176.2
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35510.2
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 53063.4
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 41378.8
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14674.2
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 41950.1
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29160.6
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10511.6
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 24966.7
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 25401.4
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 29913.3
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23331.9
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 38332.8
   },
   {
    "Region Name": "China",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 26379.2
   }
  ],
  "Christmas Island": [
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas Island",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Clipperton Island": [
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cocos (Keeling) Islands": [
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos (Keeling) Islands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Colombia": [
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 28805.4
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 41292.4
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14691.1
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 23700.0
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35047.8
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22122.9
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18979.8
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 24887.2
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15465.0
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11378.7
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19031.7
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21179.9
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12402.7
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21971.8
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13622.3
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22684.1
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17616.2
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17648.8
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18150.8
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20431.7
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13992.5
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15111.3
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13517.0
   },
   {
    "Region Name": "Colombia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9641.0
   }
  ],
  "Comoros": [
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 116.0
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Comoros",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Congo": [
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19988.0
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29698.3
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 33046.9
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 35490.7
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 39061.7
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 32870.9
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 30464.6
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30106.6
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 34702.1
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 37315.2
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 33797.8
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35206.9
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 29695.9
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 37548.4
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 34403.0
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 34405.6
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 36874.7
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 38161.3
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 29642.9
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 30689.1
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 36700.6
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 30575.9
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 41475.7
   },
   {
    "Region Name": "Congo",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 32874.8
   }
  ],
  "Cook Islands": [
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Costa Rica": [
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 319.2
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 293.5
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 327.1
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 163.3
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 177.1
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 279.1
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 232.6
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 251.9
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 254.2
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 177.1
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 397.0
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 504.8
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 457.9
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 542.1
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 394.9
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 339.6
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 439.7
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 411.6
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 322.2
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 460.5
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 275.7
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 269.9
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 280.4
   },
   {
    "Region Name": "Costa Rica",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 242.2
   }
  ],
  "Croatia": [
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 241.8
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 397.0
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 302.3
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 227.7
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 62.6
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 551.1
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 151.3
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 62.6
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 148.1
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 98.0
   },
   {
    "Region Name": "Croatia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 25.7
   }
  ],
  "Cuba": [
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1639.3
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2745.0
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4472.2
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2599.4
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3382.7
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2377.8
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2000.5
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3399.0
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1522.0
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2430.1
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1582.9
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1286.0
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1225.1
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1756.8
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1419.1
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1251.5
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 952.2
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 978.6
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2643.2
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1792.1
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2914.6
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1566.4
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3116.3
   },
   {
    "Region Name": "Cuba",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2498.9
   }
  ],
  "Cura\u00e7ao": [
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cura\u00e7ao",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cyprus": [
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Cyprus",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 138.1
   }
  ],
  "Czechia": [
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Czechia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19.9
   }
  ],
  "C\u00f4te d'Ivoire": [
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 40346.0
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 34533.8
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 34462.8
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27781.8
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 37933.7
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 33490.0
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21522.6
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 26830.4
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 24336.0
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 28691.8
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 23388.9
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 24196.0
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18444.7
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 23969.0
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18377.6
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16720.8
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14373.9
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16880.3
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11586.4
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13847.0
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6962.5
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12672.9
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12246.0
   },
   {
    "Region Name": "C\u00f4te d'Ivoire",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10509.4
   }
  ],
  "Democratic Republic of The Congo": [
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 311441.7
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 354037.9
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 378488.2
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 365165.2
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 376114.5
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 330924.4
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 333989.3
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 348377.7
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 359025.8
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 338490.6
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 322235.4
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 339905.2
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 323391.5
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 342876.4
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 334612.2
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 341835.8
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 327313.6
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 333706.7
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 333045.8
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 330808.9
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 331348.2
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 313367.6
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 329539.2
   },
   {
    "Region Name": "Democratic Republic of The Congo",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 311006.3
   }
  ],
  "Denmark": [
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 130.1
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 154.1
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Denmark",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Djibouti": [
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djibouti",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dominica": [
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dominica",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dominican Republic": [
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 225.9
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 189.7
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 606.2
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 196.4
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 234.7
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 238.4
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 203.2
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 318.6
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 228.7
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 153.9
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 223.8
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 188.6
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 263.9
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 125.0
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 91.7
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 164.6
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 276.3
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 97.3
   },
   {
    "Region Name": "Dominican Republic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 77.2
   }
  ],
  "Ecuador": [
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 197.0
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 250.4
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 471.0
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 229.2
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 293.5
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 437.1
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 588.0
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 475.7
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 289.2
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 117.7
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 263.5
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 820.2
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 184.8
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 267.7
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 614.0
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 427.7
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 329.5
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 750.3
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 256.6
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 901.9
   },
   {
    "Region Name": "Ecuador",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 75.5
   }
  ],
  "Egypt": [
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 105.9
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 215.0
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 184.4
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 687.1
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 667.5
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 302.5
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 341.3
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 386.9
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 318.6
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 385.2
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 987.2
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 719.6
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 444.8
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 751.1
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 382.2
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 151.3
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 182.4
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 329.5
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 910.4
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1421.5
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1497.4
   },
   {
    "Region Name": "Egypt",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1796.8
   }
  ],
  "El Salvador": [
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 119.8
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 266.7
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 131.4
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 211.4
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 281.3
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 204.9
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "El Salvador",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 47.8
   }
  ],
  "Equatorial Guinea": [
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Equatorial Guinea",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Eritrea": [
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 569.4
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 397.0
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 128.2
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 236.0
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 371.7
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1044.6
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 494.3
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 208.2
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 171.7
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 100.8
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 211.8
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 88.3
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 104.4
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 172.4
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 362.9
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 797.9
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 438.2
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 798.5
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 319.8
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 317.3
   },
   {
    "Region Name": "Eritrea",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 495.6
   }
  ],
  "Estonia": [
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Estonia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Eswatini": [
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 718.4
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 647.4
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 571.3
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 729.7
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 314.7
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1323.7
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 987.6
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 431.7
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1002.8
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 758.9
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 791.7
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 771.5
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 818.9
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 412.9
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 281.9
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 385.2
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 374.1
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1090.5
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 414.4
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 705.5
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 358.4
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 495.6
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1157.6
   },
   {
    "Region Name": "Eswatini",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 455.7
   }
  ],
  "Ethiopia": [
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 78038.7
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 59264.9
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 71542.7
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 69844.9
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 51893.6
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 71116.5
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 51712.7
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 59057.8
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 57031.8
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 64242.1
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 52716.8
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 58048.6
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 51234.2
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 55655.6
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 57882.2
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 45626.1
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 53582.2
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 33343.2
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 48400.9
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 47688.3
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 44618.1
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 36738.6
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 46086.1
   },
   {
    "Region Name": "Ethiopia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 37823.7
   }
  ],
  "Faroes": [
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroes",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Fiji": [
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 132.5
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Fiji",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Finland": [
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 94.8
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 105.7
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "France": [
   {
    "Region Name": "France",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 950.1
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 770.2
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 727.8
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 632.8
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 324.8
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 285.1
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 430.0
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 333.8
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 384.4
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 427.5
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 179.2
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 124.5
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 265.4
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 182.2
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 491.5
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 307.2
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 395.9
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 150.1
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 208.6
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 619.7
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 177.5
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "France",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 371.9
   }
  ],
  "French Polynesia": [
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Polynesia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "French Southern and Antarctic Lands": [
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "French Southern and Antarctic Lands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gabon": [
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2800.1
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3462.1
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4828.9
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3546.1
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5035.7
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4486.7
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5697.9
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3838.5
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4060.8
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5403.6
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4995.4
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5415.4
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3965.2
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4089.7
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4630.8
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5280.3
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3483.1
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5581.7
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4063.2
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3865.7
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5289.1
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4864.7
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6620.6
   },
   {
    "Region Name": "Gabon",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5033.0
   }
  ],
  "Gambia": [
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1228.1
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1789.1
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1912.8
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2088.0
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2468.7
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2023.0
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1671.6
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2121.0
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1734.2
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1814.2
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1298.2
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1270.1
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 995.7
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 971.9
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1513.4
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1146.7
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1090.5
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1435.2
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1421.5
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1395.1
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1149.4
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1871.9
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1375.4
   },
   {
    "Region Name": "Gambia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1080.6
   }
  ],
  "Georgia": [
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 244.4
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 273.3
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 387.6
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 158.8
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 353.1
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 123.7
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 445.7
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 296.9
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 194.6
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 139.3
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 492.6
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 270.3
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 104.6
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 109.8
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 91.7
   },
   {
    "Region Name": "Georgia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 368.3
   }
  ],
  "Germany": [
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 137.2
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Germany",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 65.0
   }
  ],
  "Ghana": [
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 69212.7
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 69137.4
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 69968.3
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 69778.8
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 80079.3
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 69786.1
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 57286.5
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 56331.2
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 61467.5
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 70370.5
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 60697.5
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 58470.0
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 62930.8
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 64648.5
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 56198.5
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 63218.1
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 50688.2
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 64256.9
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 51315.2
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 57464.0
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 34026.1
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 48220.4
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 47908.5
   },
   {
    "Region Name": "Ghana",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 37150.8
   }
  ],
  "Gibraltar": [
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gibraltar",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Greece": [
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 214.2
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 156.3
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 524.1
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 306.8
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 382.9
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3113.3
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1134.9
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 525.0
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 307.4
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 689.0
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 868.8
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 657.9
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 475.3
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 279.8
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 574.7
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 407.3
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 274.2
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 195.7
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 162.5
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1292.0
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 264.1
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1726.3
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 439.5
   },
   {
    "Region Name": "Greece",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 512.8
   }
  ],
  "Greenland": [
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greenland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Grenada": [
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Grenada",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Guam": [
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guam",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Guatemala": [
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3296.1
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8079.4
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1776.7
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6079.9
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2259.9
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5195.7
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2448.5
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3948.5
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2971.6
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2547.6
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2391.9
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3378.0
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2009.1
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2631.0
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3812.8
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2819.2
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1802.0
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2701.0
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3122.3
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1775.8
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2081.5
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2159.1
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3791.1
   },
   {
    "Region Name": "Guatemala",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2156.3
   }
  ],
  "Guernsey": [
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guernsey",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Guinea": [
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 43939.4
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 39673.3
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 41534.9
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 40711.0
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 49798.8
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 41427.7
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 35275.1
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 41230.4
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36896.3
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 45878.0
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 39407.9
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 42191.7
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34107.0
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 57567.7
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 35034.5
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 40039.2
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 32308.4
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 38980.0
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 32620.5
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 34695.0
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 31653.5
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 32702.8
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 30902.6
   },
   {
    "Region Name": "Guinea",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 22075.1
   }
  ],
  "Guinea-Bissau": [
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7159.1
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4315.0
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7478.3
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5598.9
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6937.2
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4396.9
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3674.3
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3363.9
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3634.2
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5209.8
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3221.3
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4848.6
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5060.0
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2553.6
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3708.4
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3991.3
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3857.6
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2970.5
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3489.7
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2539.4
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2023.4
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3094.4
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2655.2
   },
   {
    "Region Name": "Guinea-Bissau",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1495.9
   }
  ],
  "Guyana": [
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 928.0
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1721.2
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 410.7
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 664.5
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 777.3
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 441.4
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 382.6
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 973.4
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 692.4
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 424.0
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 782.2
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 784.8
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1161.2
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1632.2
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 706.1
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 884.5
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 927.1
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1343.5
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1122.7
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 390.4
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 421.9
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2209.7
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2024.5
   },
   {
    "Region Name": "Guyana",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 948.8
   }
  ],
  "Haiti": [
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Haiti",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 75.2
   }
  ],
  "Heard Island and Mcdonald Islands": [
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heard Island and Mcdonald Islands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Honduras": [
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1173.5
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6751.8
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1171.1
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5095.8
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2835.0
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1350.5
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2036.9
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2686.7
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1483.2
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4265.3
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 956.5
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2408.9
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3548.9
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1757.8
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2828.6
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1282.4
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3285.8
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3039.8
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7260.0
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1109.1
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1134.9
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4987.1
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3717.8
   },
   {
    "Region Name": "Honduras",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1038.0
   }
  ],
  "Hong Kong": [
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Hong Kong",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hungary": [
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 187.1
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 287.3
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 166.1
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 299.9
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 266.2
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 156.7
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 122.2
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 151.1
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 128.4
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 162.9
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Hungary",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.6
   }
  ],
  "Iceland": [
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Iceland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "India": [
   {
    "Region Name": "India",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21658.1
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29290.5
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 41868.2
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 35335.1
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 29162.8
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37970.5
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 40525.6
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51723.2
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 48353.7
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 51626.9
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 52058.2
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 46337.6
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 45180.6
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 40652.1
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 53334.4
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 52580.2
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 53142.3
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 47408.1
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 48964.9
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 65520.0
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 63124.6
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 36207.4
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 37629.5
   },
   {
    "Region Name": "India",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 54045.6
   }
  ],
  "Indonesia": [
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 26922.4
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7593.8
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25506.3
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6670.3
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 30858.6
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3402.5
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2418.3
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18168.8
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1066.7
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8109.6
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9043.8
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7365.1
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19819.3
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 26438.8
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1658.8
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1796.2
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7152.2
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20827.7
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1731.7
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 594.0
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 509.3
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11165.0
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1320.5
   },
   {
    "Region Name": "Indonesia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1115.4
   }
  ],
  "Iran": [
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3595.6
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3371.4
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3264.4
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3308.8
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3278.8
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4648.2
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2685.6
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1990.6
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6799.6
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2342.6
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1426.8
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2170.3
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2586.6
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2552.3
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2910.3
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2346.1
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1862.4
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4636.4
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3208.7
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2313.5
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1241.8
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4402.1
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6949.6
   },
   {
    "Region Name": "Iran",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3446.4
   }
  ],
  "Iraq": [
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1044.4
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1180.3
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 586.5
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 536.4
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 607.5
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1088.8
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1176.9
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 777.1
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1809.9
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 547.3
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 536.1
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 774.7
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1677.2
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3431.4
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2443.2
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1401.8
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1204.1
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14981.0
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7609.2
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1662.4
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 684.7
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2407.8
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4963.7
   },
   {
    "Region Name": "Iraq",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1289.6
   }
  ],
  "Ireland": [
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ireland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.2
   }
  ],
  "Isle of Man": [
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isle of Man",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Israel": [
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Israel",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Italy": [
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 774.1
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1545.4
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1678.3
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 559.1
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 516.2
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2292.2
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1299.1
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 537.2
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 718.4
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 922.9
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1528.7
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 362.7
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1025.1
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 173.2
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 560.6
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1215.0
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 179.9
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 695.0
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 390.6
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2052.6
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 409.7
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 920.3
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 159.3
   },
   {
    "Region Name": "Italy",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 511.5
   }
  ],
  "Jamaica": [
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Jamaica",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.8
   }
  ],
  "Japan": [
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 141.7
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 149.2
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 124.5
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 157.6
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 204.9
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 118.5
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 126.7
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 127.1
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 208.2
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 208.2
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 127.3
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 93.0
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 185.2
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 160.3
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 145.8
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 190.6
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "Japan",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 109.5
   }
  ],
  "Jersey": [
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jersey",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jordan": [
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jordan",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kazakhstan": [
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 233248.7
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 103669.1
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 133131.5
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 126646.6
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 141667.5
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 79686.1
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 98898.9
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 48009.2
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 117545.8
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 27830.0
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 57733.4
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12360.1
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 61348.8
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 73691.1
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 23759.4
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 142244.5
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 34950.9
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 82542.1
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 41498.2
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 51993.3
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18122.5
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10302.1
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5291.3
   },
   {
    "Region Name": "Kazakhstan",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15108.1
   }
  ],
  "Kenya": [
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3538.6
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4077.9
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2463.1
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1948.0
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2280.7
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7380.7
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1712.2
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1039.5
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2086.7
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4504.5
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6334.0
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1897.2
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1867.4
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1716.0
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1562.5
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 574.9
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2421.5
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1087.1
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6466.2
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1102.7
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1211.0
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 651.5
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4350.8
   },
   {
    "Region Name": "Kenya",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2087.1
   }
  ],
  "Kiribati": [
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiribati",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kuwait": [
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuwait",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.4
   }
  ],
  "Kyrgyzstan": [
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 473.3
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 174.7
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 202.8
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 304.6
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 404.9
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 415.7
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 180.3
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 126.3
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 162.1
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 84.0
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 97.5
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Kyrgyzstan",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 57.5
   }
  ],
  "Laos": [
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3591.3
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4898.1
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14807.5
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6953.5
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5751.9
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13251.2
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4353.8
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5490.4
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13697.8
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3131.7
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6748.6
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7719.6
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5964.6
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7128.2
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10206.8
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3792.2
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3688.6
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6675.9
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12379.2
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3876.6
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4845.8
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16453.9
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10739.0
   },
   {
    "Region Name": "Laos",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3123.4
   }
  ],
  "Latvia": [
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 180.5
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Latvia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lebanon": [
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Lebanon",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lesotho": [
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 319.0
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1064.1
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 297.1
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 394.0
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 328.8
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 980.3
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 145.8
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 297.5
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 329.7
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 472.9
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 340.0
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 334.0
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 192.9
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 309.3
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 318.1
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 200.6
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 229.6
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 154.1
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 206.2
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 353.1
   },
   {
    "Region Name": "Lesotho",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 207.5
   }
  ],
  "Liberia": [
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 533.1
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 351.8
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 113.6
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 853.8
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 379.9
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 224.7
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4350.2
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 589.1
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 577.7
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 383.5
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 490.3
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2896.8
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2962.6
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 236.4
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 390.4
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 369.4
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1354.2
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 135.9
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 128.8
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 405.8
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 224.2
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 533.8
   },
   {
    "Region Name": "Liberia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 251.9
   }
  ],
  "Libya": [
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 92.8
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "Libya",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Liechtenstein": [
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liechtenstein",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lithuania": [
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Lithuania",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.1
   }
  ],
  "Luxembourg": [
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Macau": [
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Madagascar": [
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 34268.6
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 60986.3
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 35679.1
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 60041.1
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 40603.2
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 59230.2
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 36643.4
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 44912.2
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 42706.2
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 41995.1
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 43012.3
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 40040.9
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 33291.5
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 34928.2
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 49196.8
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31689.3
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 32634.0
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 35420.2
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 37328.3
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 30505.4
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 30269.3
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 29056.0
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 39796.1
   },
   {
    "Region Name": "Madagascar",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 31321.5
   }
  ],
  "Malawi": [
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4758.6
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6352.0
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4330.9
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6224.2
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4278.2
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5164.8
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5339.7
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3628.8
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6429.1
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5009.8
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6189.3
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4702.4
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4330.0
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4753.0
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5492.6
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3817.7
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5182.6
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4007.2
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4372.1
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3665.9
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4778.3
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3189.8
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3497.0
   },
   {
    "Region Name": "Malawi",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3576.1
   }
  ],
  "Malaysia": [
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 407.3
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 654.0
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1231.8
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 577.3
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 358.2
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 295.6
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 266.7
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1078.1
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 566.4
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 293.7
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 168.9
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 571.9
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 733.6
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 413.7
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 474.2
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 205.2
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 343.6
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 105.3
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 101.6
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 169.1
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 251.9
   },
   {
    "Region Name": "Malaysia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 123.5
   }
  ],
  "Maldives": [
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mali": [
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 68650.0
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 71198.4
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 96294.6
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 84743.7
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 95514.0
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 84941.1
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 79106.9
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 67974.1
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 72027.3
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 65579.3
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 59604.2
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 63771.3
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 54331.4
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 75825.7
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 58769.9
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 55613.5
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 51506.9
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 57623.5
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 67876.1
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 65138.4
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 66152.3
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 67075.0
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 76501.7
   },
   {
    "Region Name": "Mali",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 76547.1
   }
  ],
  "Malta": [
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malta",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Marshall Islands": [
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marshall Islands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mauritania": [
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 449.5
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 375.6
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2498.9
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2802.7
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3761.5
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8325.9
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3467.8
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3204.8
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7376.0
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1426.6
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3168.4
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2170.7
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 291.5
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 783.3
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1263.9
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 560.1
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 268.8
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1527.2
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2757.0
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1326.7
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2337.7
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1795.1
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1754.0
   },
   {
    "Region Name": "Mauritania",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3024.3
   }
  ],
  "Mauritius": [
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Mauritius",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mexico": [
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15761.5
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 25109.0
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9638.7
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25588.2
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14084.3
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16620.7
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17334.5
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15692.0
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10748.2
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 30003.9
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14331.9
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 17159.8
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5389.5
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9668.7
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13924.3
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18439.2
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13002.6
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19257.4
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14372.8
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13909.5
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12652.7
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14963.0
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19179.0
   },
   {
    "Region Name": "Mexico",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13647.8
   }
  ],
  "Micronesia": [
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micronesia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Moldova": [
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 129.5
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 270.3
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 264.3
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 221.9
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 997.5
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 180.1
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 216.9
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 310.0
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 307.8
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 461.1
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 251.0
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 442.7
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 177.9
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 94.3
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 114.3
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 142.8
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 149.8
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Moldova",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30.7
   }
  ],
  "Mongolia": [
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9832.9
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17425.2
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13263.7
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9315.4
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11742.7
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16993.0
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7852.8
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4433.2
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2554.6
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17337.3
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21392.5
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9139.6
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11912.9
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18169.5
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10428.6
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4719.1
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 313.8
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3096.6
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 525.4
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 932.7
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4164.1
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18833.6
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2526.3
   },
   {
    "Region Name": "Mongolia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1788.7
   }
  ],
  "Montenegro": [
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 361.2
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 135.9
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 313.0
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 139.8
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 322.4
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 98.8
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 210.9
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Montenegro",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 118.5
   }
  ],
  "Montserrat": [
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrat",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Morocco": [
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 131.4
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 92.4
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 132.3
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 319.4
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Morocco",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 32.2
   }
  ],
  "Mozambique": [
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 192047.2
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 205931.0
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 193576.1
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 209470.7
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 198502.7
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 208313.1
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 223175.9
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 197466.4
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 227419.1
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 196143.8
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 203470.7
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 210826.3
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 207273.4
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 203507.8
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 183852.7
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 177119.6
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 197088.5
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 184457.0
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 175855.9
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 180798.4
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 208479.2
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 175308.0
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 175488.5
   },
   {
    "Region Name": "Mozambique",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 163840.3
   }
  ],
  "Myanmar/Burma": [
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13698.8
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 39072.8
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 59625.7
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18470.9
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 32469.0
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 44400.1
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 43641.2
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 34812.5
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 43124.8
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 33681.0
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 32649.7
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 25351.7
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 37528.1
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 36195.3
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 26881.4
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24290.2
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 23909.4
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 29402.2
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 37655.6
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 27480.8
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 26842.0
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 28369.4
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 28641.4
   },
   {
    "Region Name": "Myanmar/Burma",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 43583.8
   }
  ],
  "Namibia": [
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 32110.3
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 32700.7
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 38646.7
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 35568.3
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 53867.7
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 45839.8
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 29455.2
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 54577.3
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 48347.9
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 86086.7
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 88372.1
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 38081.4
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 27212.9
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25323.0
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 21763.4
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28566.2
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20494.1
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9415.1
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 33459.8
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 39992.7
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 25741.2
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24712.7
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10919.5
   },
   {
    "Region Name": "Namibia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 22525.9
   }
  ],
  "Nauru": [
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nauru",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nepal": [
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 262.6
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1808.4
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1526.5
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1593.2
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 834.3
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 632.4
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1411.2
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1975.2
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2070.8
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1167.0
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2077.2
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2129.1
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2314.8
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 383.3
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5816.7
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1241.8
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1124.4
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3054.5
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 641.6
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3450.7
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1293.7
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2548.6
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4888.5
   },
   {
    "Region Name": "Nepal",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1414.4
   }
  ],
  "Netherlands": [
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Netherlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "New Caledonia": [
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 107.6
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 149.2
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 51.9
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "New Caledonia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "New Zealand": [
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "New Zealand",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30.7
   }
  ],
  "Nicaragua": [
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 982.2
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3481.4
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2026.0
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3190.9
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1583.5
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 956.7
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2089.2
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1551.8
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1925.9
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1533.2
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1291.1
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2322.0
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3136.6
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1298.4
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2513.5
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 803.2
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2291.2
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2199.9
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3029.5
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1244.8
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1028.5
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6394.6
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3182.7
   },
   {
    "Region Name": "Nicaragua",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1192.7
   }
  ],
  "Niger": [
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2726.1
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3823.1
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2701.9
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2896.1
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3150.6
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3008.7
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3593.7
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2502.5
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2988.1
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2554.4
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2700.8
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2747.6
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3304.9
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2463.1
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3729.4
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3222.0
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3896.8
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3343.9
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4938.0
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9227.5
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5933.1
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6073.3
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13245.2
   },
   {
    "Region Name": "Niger",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15939.8
   }
  ],
  "Nigeria": [
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 110748.8
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 117853.0
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 150039.0
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 96651.3
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 116659.2
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 97308.9
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 74139.9
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 81359.0
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 71133.4
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 69071.4
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 63227.3
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 61171.9
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 57968.0
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 80779.0
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 71183.2
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 72092.5
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 66853.8
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 71084.1
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 70903.0
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 87034.9
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 69770.9
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 83881.1
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 66720.2
   },
   {
    "Region Name": "Nigeria",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 64142.6
   }
  ],
  "Niue": [
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niue",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Norfolk Island": [
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "North Korea": [
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 98.4
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 142.6
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 823.4
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 391.2
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 175.4
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 80.2
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 242.2
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 929.3
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 184.1
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 586.7
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 129.1
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 169.4
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 886.2
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 408.4
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 104.6
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 486.4
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 161.4
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 198.7
   },
   {
    "Region Name": "North Korea",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 40.9
   }
  ],
  "North Macedonia": [
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 449.3
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 155.4
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 195.9
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 171.5
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 152.0
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 119.2
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 674.8
   },
   {
    "Region Name": "North Macedonia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 195.1
   }
  ],
  "Northern Mariana Islands": [
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Mariana Islands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Norway": [
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norway",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Oman": [
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Oman",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.4
   }
  ],
  "Pakistan": [
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1296.5
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1283.6
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2551.6
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3617.7
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1038.4
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1628.1
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1311.3
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1720.7
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1853.2
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1373.9
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1934.7
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2567.1
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1309.2
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1496.1
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2463.1
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2414.7
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3024.3
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1925.2
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1746.5
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2897.4
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2900.4
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2092.7
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3419.8
   },
   {
    "Region Name": "Pakistan",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4572.3
   }
  ],
  "Palau": [
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Palestine": [
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Palestine",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.0
   }
  ],
  "Panama": [
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 351.8
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1320.7
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1012.5
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 104.4
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 438.2
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 167.9
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 275.0
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 667.8
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 161.8
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 96.9
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 308.7
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 228.7
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 250.8
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 707.4
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 432.4
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 159.1
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 242.7
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 626.8
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 372.4
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 113.4
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 290.5
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "Panama",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 49.5
   }
  ],
  "Papua New Guinea": [
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3559.2
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3525.7
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6970.6
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1998.1
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4172.7
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1430.9
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1597.0
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1919.7
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2072.5
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1229.6
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1455.8
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1711.7
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3450.9
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7590.8
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1070.6
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1626.2
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4201.4
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1759.3
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1079.1
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1219.3
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1444.6
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3105.8
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1273.6
   },
   {
    "Region Name": "Papua New Guinea",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 610.5
   }
  ],
  "Paraguay": [
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 31527.2
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37014.7
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 20332.0
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 30364.1
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23678.8
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 40023.5
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22988.9
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17103.2
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14566.4
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 24666.8
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18989.2
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 22576.9
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10645.6
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12609.8
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18528.6
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 33813.1
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19469.2
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26397.8
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38305.0
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 37861.2
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11976.8
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19621.0
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 21077.4
   },
   {
    "Region Name": "Paraguay",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8090.9
   }
  ],
  "Peru": [
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 385.2
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1231.1
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 454.9
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2828.4
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 826.2
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1191.2
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 719.9
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 688.3
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2243.6
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 424.7
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1193.4
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 780.3
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 684.9
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 805.6
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1866.7
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 720.1
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 721.1
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1408.2
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1946.9
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 780.5
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2752.9
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1045.0
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3042.5
   },
   {
    "Region Name": "Peru",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 553.3
   }
  ],
  "Philippines": [
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1388.7
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1233.9
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1302.1
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1102.3
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1362.3
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 708.5
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 692.0
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1088.6
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1181.4
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 717.1
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 750.1
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 818.0
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 985.2
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1110.0
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1207.5
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 678.9
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 972.2
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 983.7
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 772.6
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 762.9
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 564.9
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1056.8
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 789.1
   },
   {
    "Region Name": "Philippines",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 516.2
   }
  ],
  "Pitcairn Islands": [
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pitcairn Islands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Poland": [
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 176.0
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 215.4
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 127.5
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 143.0
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Poland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 25.5
   }
  ],
  "Portugal": [
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1044.4
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4807.9
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1139.8
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3488.6
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 668.8
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 192.9
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 653.2
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1528.2
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 681.3
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 836.7
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1824.1
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 115.8
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 435.4
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1708.9
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5267.7
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 372.1
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 295.6
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 570.4
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 231.9
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 983.1
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 253.6
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1416.3
   },
   {
    "Region Name": "Portugal",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2738.6
   }
  ],
  "Puerto Rico": [
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Puerto Rico",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Qatar": [
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Qatar",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Romania": [
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 321.1
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 577.1
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1293.7
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1659.6
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2457.5
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1263.7
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5057.8
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1346.7
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2403.5
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3415.8
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2987.2
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1279.4
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1530.0
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1072.5
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1562.8
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1321.4
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 812.5
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1906.6
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 817.8
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1304.4
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 980.5
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 194.6
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 530.3
   },
   {
    "Region Name": "Romania",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 350.9
   }
  ],
  "Russian Federation": [
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 159701.0
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 225539.3
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 107620.1
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 128454.0
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 147091.2
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 114903.1
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 233773.0
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 129761.6
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 115187.5
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 123306.1
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 148700.3
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 70055.8
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 194207.8
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 95924.8
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 94433.2
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 82274.0
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 127015.1
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 112375.0
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 105816.6
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 127647.3
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 79078.4
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 80483.8
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 99100.6
   },
   {
    "Region Name": "Russian Federation",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 53164.8
   }
  ],
  "Rwanda": [
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 627.9
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 334.6
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 315.6
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 260.5
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 109.3
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 162.3
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 167.0
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 392.9
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 354.1
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 271.0
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 359.1
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 514.1
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 593.4
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 467.8
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 365.7
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 341.3
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 418.9
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 379.2
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 384.4
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 379.6
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 587.8
   },
   {
    "Region Name": "Rwanda",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 277.4
   }
  ],
  "Saint Barth\u00e9lemy": [
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Barth\u00e9lemy",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Helena, Ascension and Tristan Da Cunha": [
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Kitts and Nevis": [
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Kitts and Nevis",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Lucia": [
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Pierre and Miquelon": [
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Pierre and Miquelon",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Vincent and The Grenadines": [
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Vincent and The Grenadines",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Samoa": [
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoa",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saudi Arabia": [
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1080.6
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 653.0
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 823.6
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1114.3
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 753.7
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 610.5
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 159.1
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 263.7
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 374.9
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 114.0
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 158.4
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 93.7
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 62.6
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 106.8
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 131.0
   },
   {
    "Region Name": "Saudi Arabia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 123.3
   }
  ],
  "Senegal": [
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 43682.2
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 36220.4
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 51544.0
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 54445.2
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 58542.5
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 45707.3
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 45578.5
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 46311.4
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 49230.5
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 52150.6
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 39707.4
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 46910.6
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 35613.8
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33729.0
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 41999.4
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 42445.3
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 36486.9
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 43542.0
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 46985.2
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 46539.1
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 45789.0
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 55323.5
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 42346.0
   },
   {
    "Region Name": "Senegal",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 43194.3
   }
  ],
  "Serbia": [
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 171.3
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 374.3
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 632.0
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 145.1
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 463.0
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 886.2
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 879.8
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 496.0
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 139.1
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 905.5
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2022.1
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 72.7
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 316.6
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 594.4
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 416.7
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 166.6
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 170.2
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 124.8
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 189.5
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1214.0
   },
   {
    "Region Name": "Serbia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 233.0
   }
  ],
  "Seychelles": [
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seychelles",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sierra Leone": [
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7903.4
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11055.2
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12776.2
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5479.7
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25455.2
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7806.7
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7167.6
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7486.4
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6144.5
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7221.0
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10439.6
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6702.5
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12156.0
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16088.2
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8419.1
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8289.4
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6919.2
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7296.0
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4501.1
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7400.2
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6137.6
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7038.6
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9536.4
   },
   {
    "Region Name": "Sierra Leone",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4512.3
   }
  ],
  "Singapore": [
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singapore",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sint-Maarten": [
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint-Maarten",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Slovakia": [
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Slovakia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.1
   }
  ],
  "Slovenia": [
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Slovenia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Solomon Islands": [
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Somalia": [
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 663.3
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1081.7
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 243.1
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 190.6
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 99.9
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 532.7
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 174.9
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 189.9
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 522.0
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 523.3
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 495.6
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 98.0
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 162.7
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "Somalia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 40.1
   }
  ],
  "South Africa": [
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 53310.8
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 38022.2
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32102.0
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 53058.3
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 39728.1
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 41326.7
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 43371.1
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 42908.7
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 45642.2
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 47153.2
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 40922.4
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 38515.2
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 40967.2
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 28818.5
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16764.7
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31091.7
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 31701.3
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 28402.6
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 31085.4
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 53278.6
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 35624.1
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 57262.5
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 46516.6
   },
   {
    "Region Name": "South Africa",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27883.4
   }
  ],
  "South Georgia and The South Sandwich Islands": [
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Georgia and The South Sandwich Islands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "South Korea": [
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 270.7
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 141.3
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 167.0
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 245.5
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 116.8
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 91.3
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 99.7
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 271.6
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "South Korea",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 982.9
   }
  ],
  "South Sudan": [
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 328150.1
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 312217.9
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 315480.2
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 338313.5
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 319145.7
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 324058.2
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 309739.6
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 326548.5
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 296083.0
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 325279.0
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 314508.9
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 299019.2
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 293027.4
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 317385.5
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 301527.1
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 294187.6
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 328065.4
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 256977.2
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 284708.6
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 274074.8
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 253370.4
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 274295.0
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 268131.0
   },
   {
    "Region Name": "South Sudan",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 260797.3
   }
  ],
  "Spain": [
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1473.6
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2014.0
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1931.5
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1631.1
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1411.0
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 959.7
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 235.8
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 872.3
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 328.4
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 918.1
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1880.4
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 723.9
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 337.0
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 788.7
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 710.2
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1313.4
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 193.4
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 464.5
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 491.8
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 711.5
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2760.6
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 580.3
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 234.9
   },
   {
    "Region Name": "Spain",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3649.8
   }
  ],
  "Sri Lanka": [
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 619.1
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 701.8
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 783.1
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 906.4
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 380.5
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 427.9
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 411.6
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 624.2
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 256.8
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 335.7
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 567.4
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 248.5
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 230.7
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 274.8
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 322.4
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 125.4
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 108.7
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Sri Lanka",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 49.1
   }
  ],
  "Sudan": [
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 82949.0
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 94546.2
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 92418.3
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 99624.6
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 82365.5
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 105800.3
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 80502.0
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 81997.9
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 64493.8
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 54194.2
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 83912.8
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 71114.8
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 63749.9
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 56663.9
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 67022.0
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 60100.7
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 60162.4
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 57890.8
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 74959.5
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 62000.7
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 54386.1
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 73051.8
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 82007.7
   },
   {
    "Region Name": "Sudan",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 96693.7
   }
  ],
  "Suriname": [
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 568.7
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 362.5
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 587.8
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 329.5
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 177.7
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 477.0
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 237.1
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 433.0
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 154.8
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 441.6
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 461.3
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 122.0
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 284.5
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 168.9
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 579.0
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 256.2
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 198.5
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 570.0
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 486.8
   },
   {
    "Region Name": "Suriname",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 205.6
   }
  ],
  "Sweden": [
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 118.8
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 147.1
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sweden",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Switzerland": [
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Switzerland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Syria": [
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 333.6
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 504.6
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 260.5
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 144.5
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 135.5
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 244.0
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 242.0
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 467.3
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 305.0
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 577.5
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 189.5
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1251.7
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 369.4
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 205.6
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7865.2
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3092.1
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 367.9
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 156.7
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 861.1
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1671.9
   },
   {
    "Region Name": "Syria",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 316.8
   }
  ],
  "S\u00e3o Tom\u00e9 and Pr\u00edncipe": [
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Tajikistan": [
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 187.4
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 236.9
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 133.8
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Tajikistan",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 96.5
   }
  ],
  "Thailand": [
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11973.2
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 20506.8
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 29483.7
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13162.7
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16961.1
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16822.4
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14770.7
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13390.8
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13703.1
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10297.6
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16896.8
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13053.4
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17673.7
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13770.2
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14708.7
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11186.0
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15232.4
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18184.3
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16434.0
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5476.3
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8908.5
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8612.1
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9332.3
   },
   {
    "Region Name": "Thailand",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4197.1
   }
  ],
  "Timor-Leste": [
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 265.0
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 228.7
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 222.1
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 250.8
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 143.2
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 156.9
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 115.5
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 212.7
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 138.1
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Timor-Leste",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.1
   }
  ],
  "Togo": [
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12306.1
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12745.5
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 19133.1
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11912.1
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14753.1
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11089.7
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11659.7
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11043.0
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14914.7
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13071.6
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10709.9
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9531.9
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11622.4
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12881.0
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9793.9
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9832.9
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8449.8
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11380.6
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7838.8
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9529.1
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7455.5
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6132.9
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6451.4
   },
   {
    "Region Name": "Togo",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6304.8
   }
  ],
  "Tokelau": [
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokelau",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tonga": [
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tonga",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Trinidad and Tobago": [
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Trinidad and Tobago",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.5
   }
  ],
  "Tunisia": [
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 114.7
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 144.9
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 213.7
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 219.9
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 212.2
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 265.4
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 87.9
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Tunisia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 63.0
   }
  ],
  "Turkey": [
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3966.9
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3531.3
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4170.3
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4047.3
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5872.6
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4165.8
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2560.4
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13285.5
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8052.8
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9854.3
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2861.4
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6326.2
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3617.0
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10181.7
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8070.6
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5002.3
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3317.1
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4338.6
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5256.3
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6541.7
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3483.5
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4638.9
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5719.2
   },
   {
    "Region Name": "Turkey",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4292.1
   }
  ],
  "Turkmenistan": [
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1496.1
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4009.8
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2835.5
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1526.5
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 722.0
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1742.8
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 345.1
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 850.0
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3143.5
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 459.6
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 958.9
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2428.6
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 366.1
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1298.2
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1493.7
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 520.7
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 261.7
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4838.3
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1155.0
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 486.0
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 219.7
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 132.1
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 187.8
   },
   {
    "Region Name": "Turkmenistan",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1006.9
   }
  ],
  "Turks and Caicos Islands": [
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Turks and Caicos Islands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tuvalu": [
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuvalu",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Uganda": [
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 29674.2
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 36008.6
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 35629.4
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 43496.3
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25541.9
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 35139.6
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 30973.3
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 22210.8
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 30819.6
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 33164.2
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22262.0
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 23669.6
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 24724.5
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 26198.2
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 26508.7
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 23231.8
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 21553.3
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14045.7
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22154.2
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 22704.9
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22924.6
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15127.4
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16892.3
   },
   {
    "Region Name": "Uganda",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16740.9
   }
  ],
  "Ukraine": [
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21324.4
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4608.1
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11389.0
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 29845.3
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17560.3
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23656.0
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 45289.7
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 24328.1
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13003.0
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12842.0
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6658.1
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9068.7
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28299.5
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25086.5
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15964.3
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24061.6
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11822.2
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 21639.3
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11479.0
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6410.1
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8457.7
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6414.6
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12920.2
   },
   {
    "Region Name": "Ukraine",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11083.7
   }
  ],
  "United Arab Emirates": [
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "United Arab Emirates",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "United Kingdom": [
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 88.3
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 132.1
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 153.1
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 148.1
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United Kingdom",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 188.6
   }
  ],
  "United Republic of Tanzania": [
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 132270.4
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 169602.5
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 151457.5
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 175868.8
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 113557.3
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 150732.3
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 142880.4
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 148083.5
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 158693.3
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 134332.4
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 142731.6
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 127961.1
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 114904.8
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 128989.9
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 126270.6
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 104410.8
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 93554.1
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 103245.0
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 99734.5
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 101071.8
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 90016.3
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 82956.9
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 83899.3
   },
   {
    "Region Name": "United Republic of Tanzania",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 83690.3
   }
  ],
  "United States": [
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 25583.2
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 28734.2
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 40012.8
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 44704.1
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 36885.4
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 40599.8
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 28753.7
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 29957.6
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 25133.5
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 42344.1
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 37182.5
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20961.0
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23956.6
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 41593.2
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 29942.4
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 39312.3
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 35731.5
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 29223.2
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 50804.2
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 38738.6
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 33538.5
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22975.4
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 35986.8
   },
   {
    "Region Name": "United States",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27040.1
   }
  ],
  "United States Minor Outlying Islands": [
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "United States Minor Outlying Islands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Uruguay": [
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 284.9
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 425.3
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 609.7
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 276.5
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 310.4
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 200.4
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 533.1
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 207.1
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 386.1
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 272.7
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 358.4
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 120.5
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 346.2
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 168.3
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 195.5
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 144.5
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 297.5
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 326.7
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 486.0
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 235.6
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 160.8
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 194.0
   },
   {
    "Region Name": "Uruguay",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 179.4
   }
  ],
  "Us Virgin Islands": [
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Us Virgin Islands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Uzbekistan": [
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 498.2
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 574.3
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1076.3
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 525.2
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 499.9
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 416.1
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 423.4
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 599.2
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 120.9
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 389.9
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 860.5
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 504.4
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 743.2
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 554.8
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 319.6
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 415.7
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 791.7
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 704.8
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 481.7
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 875.3
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 336.8
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 298.0
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Uzbekistan",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 291.1
   }
  ],
  "Vanuatu": [
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Venezuela": [
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24929.4
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 33470.5
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21743.4
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 30302.3
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 34411.2
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23626.9
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23231.0
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 35680.4
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20017.3
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15730.2
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20161.0
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 27443.5
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 25454.6
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31088.9
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19439.2
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 27853.0
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 33563.1
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 38623.5
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 40171.7
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 27570.4
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 28269.7
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 45478.6
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 43395.8
   },
   {
    "Region Name": "Venezuela",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27442.4
   }
  ],
  "Vietnam": [
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4799.9
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10120.8
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10721.9
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9697.6
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8233.7
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7864.6
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9265.5
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8632.6
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11986.9
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7391.2
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14371.7
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8862.7
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12384.3
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17204.2
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8271.6
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6531.0
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10386.2
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11372.1
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8632.6
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6767.4
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3698.3
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9208.2
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10198.6
   },
   {
    "Region Name": "Vietnam",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5947.0
   }
  ],
  "Wallis and Futuna": [
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallis and Futuna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Yemen": [
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Yemen",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.3
   }
  ],
  "Zambia": [
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 220766.4
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 254984.0
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 254327.6
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 266448.7
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 224176.2
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 241125.3
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 247567.5
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 208333.2
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 240149.7
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 233678.5
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 243363.9
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 245850.4
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 234060.7
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 249595.6
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 244434.5
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 219464.1
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 218582.2
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 230471.1
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 211453.4
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 206289.9
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 225541.1
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 203861.1
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 223911.2
   },
   {
    "Region Name": "Zambia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 231050.1
   }
  ],
  "Zimbabwe": [
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24269.6
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 26611.3
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 36287.1
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 34040.5
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 31919.5
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 39621.8
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 45730.3
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 45677.3
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 48112.3
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 47574.1
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 38189.6
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 29097.4
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 31810.9
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 38933.7
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 23129.6
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 26011.7
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 27000.0
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26248.4
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10281.4
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18778.1
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 28622.5
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22359.5
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13751.1
   },
   {
    "Region Name": "Zimbabwe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13381.3
   }
  ]
 },
 "Continents": {
  "Africa": [
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2864600.3
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2976350.6
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3066502.0
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3102841.9
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2982910.8
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2968783.2
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2833019.7
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2728459.5
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2921362.0
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2984797.2
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2718387.4
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2626664.0
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2475774.4
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2664266.5
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2522313.7
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2473416.1
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2392418.5
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2358070.4
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2395611.1
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2481740.3
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2372952.3
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2402595.9
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2382615.8
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2264214.5
   }
  ],
  "Antarctica": [
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Asia": [
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 487039.9
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 529092.5
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 482045.8
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 378757.9
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 459554.6
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 370895.0
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 464316.2
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 338819.4
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 420044.5
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 340669.0
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 433465.3
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 270480.1
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 471474.6
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 409053.1
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 298047.5
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 389210.1
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 320351.1
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 397829.2
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 329439.9
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 344440.8
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 253916.4
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 274569.4
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 285692.4
   },
   {
    "Region Name": "Asia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 235112.6
   }
  ],
  "Australia": [
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 748261.4
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 285294.9
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 651839.3
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 266911.3
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 588068.8
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 518144.9
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 301904.2
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 414963.3
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 180499.8
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 929266.5
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 876280.4
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 266426.2
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 463986.1
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 418390.2
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 236598.6
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 502116.7
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 560505.9
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 342125.0
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 137727.8
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 279515.3
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 271145.9
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 738746.0
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 378768.8
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 476955.6
   }
  ],
  "Europe": [
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 95682.3
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 41742.4
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 61521.8
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 103144.7
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 94958.6
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 92292.7
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 127798.7
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 93357.3
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 70585.5
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 45731.3
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 40073.5
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 28660.9
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 71020.2
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 56469.1
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 37017.7
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 62213.5
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 46011.3
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 49600.9
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 34840.8
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 25331.1
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 31192.2
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23540.3
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 31005.0
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 35626.6
   }
  ],
  "North America": [
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 74574.9
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 96405.6
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 84841.2
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 103658.8
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 81053.3
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 82179.9
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 71247.0
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 65836.4
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 70050.2
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 101658.7
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 74674.8
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 88409.8
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 72217.9
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 90573.5
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 65648.8
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 94762.2
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 76249.6
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 72130.0
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 85444.5
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 95793.6
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 65974.0
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 187716.7
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 116928.6
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 92819.4
   }
  ],
  "Oceania": [
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 245.2
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 193.8
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 168.1
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 144.5
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 96.0
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 114.3
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 105.5
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 152.6
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 315.3
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 113.8
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 158.0
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 248.0
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 105.7
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 267.3
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 159.5
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 92.8
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 105.0
   },
   {
    "Region Name": "Oceania",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 36.7
   }
  ],
  "South America": [
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 416574.9
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 367431.5
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 376960.6
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 406946.3
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 302849.4
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 569941.4
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 304153.8
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 225543.0
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 530999.9
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 270938.8
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 354882.3
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 222004.2
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 241435.4
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 320071.1
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 295749.3
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 368439.6
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 208032.0
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 356484.7
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 412621.5
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 337375.4
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 268439.7
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 283944.2
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 458355.0
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 185074.8
   }
  ]
 },
 "Continental Biomes": {
  "Africa - (Sub)tropical dry broadleaf forest": [
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13000.6
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18042.8
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13349.0
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21400.7
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15328.5
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16873.0
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13708.3
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14332.5
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17650.7
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14407.1
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15772.0
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16386.4
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13780.9
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15211.8
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18246.9
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14958.5
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14517.3
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16659.3
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17785.1
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14846.8
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15303.2
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13348.3
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19331.2
   },
   {
    "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 17245.3
   }
  ],
  "Africa - (Sub)tropical grassland, savannah & shrubland": [
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2463760.7
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2600458.7
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2718169.1
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2694321.9
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2597982.3
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2567893.9
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2457773.0
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2362966.5
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2518461.0
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2526172.5
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2345918.6
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2291207.8
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2160445.7
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2299400.1
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2199117.5
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2156381.1
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2053588.4
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2059526.8
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2075770.4
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2090396.4
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2031883.3
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2039442.1
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2042577.5
   },
   {
    "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1978651.8
   }
  ],
  "Africa - (Sub)tropical moist broadleaf forest": [
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 98654.3
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 126237.8
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 111352.7
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 125401.1
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 119347.6
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 134302.4
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 97202.2
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 112604.6
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 117534.0
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 116230.4
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 111876.2
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 102644.6
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 99271.1
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 124764.3
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 102490.2
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 86309.5
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 99030.3
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 109314.3
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 100126.2
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 101214.3
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 100797.4
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 85393.2
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 106483.1
   },
   {
    "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 76244.8
   }
  ],
  "Africa - Deserts & xeric shrublands": [
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 59276.5
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19431.0
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12497.3
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27572.6
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 33271.4
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30254.1
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 54171.5
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18733.3
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 62584.6
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 103805.6
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 45155.1
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21405.0
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13715.1
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14100.5
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13120.7
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 25894.5
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18635.5
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8245.9
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 29355.3
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 88334.8
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 58699.4
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 75974.9
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20788.2
   },
   {
    "Region Name": "Africa - Deserts & xeric shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 22793.2
   }
  ],
  "Africa - Flooded grassland & savannah": [
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 162512.9
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 144441.6
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 151130.8
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 157463.7
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 152386.3
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 148094.9
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 145855.4
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 156594.8
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 137696.7
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 158769.2
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 142462.3
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 134469.4
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 130737.0
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 158313.7
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 140788.1
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 138148.0
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 156792.3
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 116010.7
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 117060.7
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 132272.5
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 118860.1
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 135079.5
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 126227.3
   },
   {
    "Region Name": "Africa - Flooded grassland & savannah",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 123013.7
   }
  ],
  "Africa - Mangroves": [
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3489.7
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5364.6
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5324.7
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4528.3
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6256.1
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4675.6
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4036.6
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5067.0
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4084.2
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4376.8
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4617.5
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4095.1
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4289.7
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4627.2
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4056.7
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3660.8
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4360.9
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4321.5
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3907.1
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3781.0
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3534.1
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2978.9
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4141.2
   },
   {
    "Region Name": "Africa - Mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2585.9
   }
  ],
  "Africa - Mediterranean forests,  woodlands and scrub": [
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3543.5
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3320.1
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2341.6
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4986.4
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2238.9
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3402.9
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3553.0
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6227.6
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1825.4
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3162.4
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4722.1
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2120.3
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3677.7
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3578.0
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4290.6
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5165.9
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3109.0
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1915.6
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2134.3
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3775.7
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2292.2
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2016.1
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1831.1
   },
   {
    "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5260.8
   }
  ],
  "Africa - Montane grassland & shrubland": [
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 58891.5
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 57773.5
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 50783.6
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 65618.8
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 53921.7
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 61502.3
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 55203.7
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 50324.0
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 60177.9
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 56238.2
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 46675.2
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 53503.3
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 49038.2
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 42858.6
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 38068.7
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 40849.1
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 41105.7
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 40722.8
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 49148.4
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 46134.4
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 41110.0
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 48006.4
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 60752.2
   },
   {
    "Region Name": "Africa - Montane grassland & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 38251.6
   }
  ],
  "Africa - Temperate broadleaf & mixed forest": [
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Africa - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Africa - Temperate conifer forest": [
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 122.4
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 107.8
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 337.4
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 188.0
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 324.3
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 143.6
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 214.8
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 280.8
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 225.3
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Africa - Temperate conifer forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 32.6
   }
  ],
  "Antarctica - Tundra": [
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antarctica - Tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Asia - (Sub)tropical coniferous forest": [
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 585.0
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1791.1
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1387.4
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1353.5
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 714.3
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 837.3
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1611.2
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2167.5
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1977.1
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 532.9
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2503.8
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 537.2
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1895.0
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 624.5
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3319.1
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 306.1
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1489.7
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1958.7
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 479.5
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2234.2
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1956.1
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1017.6
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3715.7
   },
   {
    "Region Name": "Asia - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 665.6
   }
  ],
  "Asia - (Sub)tropical dry broadleaf forest": [
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 38125.3
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 46575.5
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 56334.9
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 43484.5
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 44672.6
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 39012.2
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 46503.3
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 40178.3
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 48835.8
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 46915.1
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 46767.4
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 37512.2
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 45234.4
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 40070.3
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 39467.3
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 47695.4
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 46344.9
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 45365.6
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 43681.3
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 40582.6
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 40172.3
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 34222.1
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 34403.0
   },
   {
    "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 33985.4
   }
  ],
  "Asia - (Sub)tropical grassland, savannah & shrubland": [
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1758.7
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3673.0
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5396.5
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2448.5
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3621.3
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 839.3
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1060.1
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2368.6
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1536.0
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1512.4
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2391.7
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1956.3
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4676.0
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3825.8
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3344.6
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1604.8
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4877.8
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3328.5
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1165.5
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1744.7
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 900.8
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3810.2
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2504.5
   },
   {
    "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1049.8
   }
  ],
  "Asia - (Sub)tropical moist broadleaf forest": [
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 59138.8
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 86185.3
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 144150.1
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 59065.5
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 96461.5
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 98421.5
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 88628.9
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 101359.2
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 99565.6
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 70849.0
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 89940.9
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 73998.2
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 97736.2
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 108497.1
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 70485.4
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 58669.8
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 64962.8
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 89513.6
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 80514.6
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 60101.1
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 56984.0
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 78938.2
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 74248.6
   },
   {
    "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 80300.3
   }
  ],
  "Asia - Boreal forest": [
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 47589.7
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 101466.0
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22039.9
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 23809.8
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 28576.5
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 17836.6
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 47069.4
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 25216.2
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20843.3
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 44204.2
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 81155.6
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 36719.7
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 76977.3
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31331.5
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 43116.5
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 34140.0
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 47233.2
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 55819.8
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 61300.3
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 85406.5
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21645.3
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 28540.9
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 54114.9
   },
   {
    "Region Name": "Asia - Boreal forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 23608.7
   }
  ],
  "Asia - Deserts & xeric shrublands": [
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 126701.5
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 64069.7
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 104805.0
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 100903.3
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 96282.3
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 62186.5
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 52892.5
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51870.0
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 79239.6
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 41934.0
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 44111.1
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 40992.7
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 53640.3
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 63560.4
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 48645.7
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 115523.0
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 54202.6
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 86764.4
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 55814.2
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 64945.0
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 41385.9
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 31343.3
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 25619.2
   },
   {
    "Region Name": "Asia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 31517.4
   }
  ],
  "Asia - Flooded grassland & savannah": [
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5594.8
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18428.0
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8471.2
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13215.0
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9540.3
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9604.8
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 20688.8
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11465.5
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4479.5
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12055.7
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7444.8
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5986.5
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19573.8
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14444.6
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9024.9
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12141.2
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16490.8
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7969.2
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5601.0
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6185.6
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5447.5
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7491.1
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10237.0
   },
   {
    "Region Name": "Asia - Flooded grassland & savannah",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8265.4
   }
  ],
  "Asia - Mangroves": [
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2964.7
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1343.0
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2764.7
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 901.9
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3502.1
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 644.0
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 764.2
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2210.6
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1122.7
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1352.0
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1341.9
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1804.1
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3290.1
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4608.9
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1106.1
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 666.5
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1396.4
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3052.2
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 990.2
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 458.5
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 351.8
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1968.1
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 868.6
   },
   {
    "Region Name": "Asia - Mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 638.6
   }
  ],
  "Asia - Mediterranean forests,  woodlands and scrub": [
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3150.2
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2811.7
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2412.7
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2866.5
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2513.9
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3282.8
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2113.9
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6250.4
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4256.3
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3372.7
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2376.5
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4546.6
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2850.5
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7841.2
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5853.1
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3977.8
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1958.3
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7824.5
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5971.0
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6044.1
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3010.6
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4266.4
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5179.4
   },
   {
    "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3790.9
   }
  ],
  "Asia - Montane grassland & shrubland": [
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3987.0
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1628.3
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 701.2
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 629.8
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1128.9
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 927.1
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 861.1
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 481.3
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 999.8
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 570.4
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 844.2
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 547.3
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 578.6
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 969.8
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 500.3
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 579.9
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 218.9
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 898.0
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 674.8
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 386.5
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 635.2
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 168.9
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 284.0
   },
   {
    "Region Name": "Asia - Montane grassland & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 319.0
   }
  ],
  "Asia - Temperate broadleaf & mixed forest": [
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 26838.6
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 44755.1
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 36363.6
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 41466.3
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 58580.4
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 47607.9
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 60262.8
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 46473.3
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 49584.2
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 49076.4
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 61539.3
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 36166.0
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 54752.6
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 30907.3
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 23226.0
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 32865.1
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 39719.8
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15957.4
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 26117.4
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 35532.1
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 34695.4
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 36566.8
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 39426.7
   },
   {
    "Region Name": "Asia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24275.8
   }
  ],
  "Asia - Temperate conifer forest": [
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11747.6
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12434.5
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1055.6
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1847.2
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2591.7
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4240.9
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18699.2
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3212.1
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2531.1
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7317.1
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9543.9
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7529.7
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4710.8
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5382.8
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3456.5
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2467.6
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10076.6
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 597.7
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2098.5
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 587.8
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1477.2
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1396.0
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8609.9
   },
   {
    "Region Name": "Asia - Temperate conifer forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 914.9
   }
  ],
  "Asia - Temperate grassland, savannah & shrubland": [
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 154451.1
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 124266.1
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 95357.5
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 85260.3
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 109193.4
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 83114.5
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 119370.1
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 43155.3
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 93511.0
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 58355.3
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 80993.1
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21020.0
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 103844.8
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 92723.4
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 37983.0
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 76846.1
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29924.2
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 73678.2
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 41415.9
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 34840.1
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 43686.9
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 41360.1
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 21410.5
   },
   {
    "Region Name": "Asia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 22529.1
   }
  ],
  "Asia - Tundra": [
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4387.1
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19623.8
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 803.9
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1495.2
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2172.8
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2325.9
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3767.1
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2394.5
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11560.5
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2597.1
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2400.9
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1129.1
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1666.5
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4115.2
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8474.0
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1659.0
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1367.5
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4872.4
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3593.5
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5214.7
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1498.2
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3381.7
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4846.0
   },
   {
    "Region Name": "Asia - Tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2994.1
   }
  ],
  "Australia - (Sub)tropical grassland, savannah & shrubland": [
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 343719.5
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 248782.3
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 485457.0
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 238746.6
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 368274.2
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 353600.0
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 268641.4
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 363833.3
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 149616.3
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 426189.8
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 507482.4
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 207979.7
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 330956.2
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 276416.6
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 202480.1
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 256206.1
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 340315.7
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 222337.3
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 126918.0
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 225486.0
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 214633.3
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 369522.4
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 278765.7
   },
   {
    "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 317605.5
   }
  ],
  "Australia - (Sub)tropical moist broadleaf forest": [
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 598.1
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 649.8
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 560.1
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1058.8
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 161.8
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 187.4
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 579.0
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1174.5
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 632.6
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 745.1
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 760.4
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 382.6
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 917.7
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 299.7
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1167.2
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1809.3
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 896.5
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 277.4
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 343.2
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 170.4
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 265.4
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 329.9
   },
   {
    "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 688.8
   }
  ],
  "Australia - Deserts & xeric shrublands": [
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 360394.6
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30111.3
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 138678.7
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13902.5
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 190145.9
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 158024.7
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24535.8
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 34476.3
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 23463.1
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 483315.9
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 348230.7
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 42093.9
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 121198.9
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 127182.6
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 23378.2
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 223610.2
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 201629.5
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 33177.7
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5162.4
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 43697.6
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 47212.0
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 353443.7
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 85666.4
   },
   {
    "Region Name": "Australia - Deserts & xeric shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 142484.9
   }
  ],
  "Australia - Mediterranean forests,  woodlands and scrub": [
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16905.4
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1842.1
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 18554.9
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5068.3
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7839.9
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4536.0
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2621.7
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9892.3
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5010.0
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4290.8
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5412.4
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5744.7
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8328.7
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7742.4
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2751.4
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11886.5
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9352.5
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26751.8
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2471.2
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3000.1
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3925.7
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5788.0
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5718.9
   },
   {
    "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7131.4
   }
  ],
  "Australia - Montane grassland & shrubland": [
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9334.1
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 51.9
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3517.4
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 252.1
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 323.9
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 107.0
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4804.2
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Australia - Montane grassland & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 155.6
   }
  ],
  "Australia - Temperate broadleaf & mixed forest": [
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15965.1
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2742.4
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5586.0
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5411.1
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13856.8
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1254.3
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4314.4
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4335.4
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1098.2
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9209.9
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8285.8
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8120.7
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2070.4
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3557.7
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4935.2
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4181.7
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6124.7
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 53712.5
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1974.8
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3936.2
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2423.7
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5221.6
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4854.0
   },
   {
    "Region Name": "Australia - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6244.8
   }
  ],
  "Australia - Temperate grassland, savannah & shrubland": [
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1260.7
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1105.3
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2973.7
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2688.2
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4224.8
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 505.1
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 940.4
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1208.8
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1246.8
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5573.8
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5705.9
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1676.6
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 986.5
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2459.2
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2731.9
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5019.7
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1092.2
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 420.2
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 895.0
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3038.9
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2719.1
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4469.2
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3387.9
   },
   {
    "Region Name": "Australia - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2574.6
   }
  ],
  "Australia - Tundra": [
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australia - Tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Europe - Boreal forest": [
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2773.3
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1120.9
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 945.2
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 354.1
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5008.1
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 719.4
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1188.0
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3004.8
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2627.3
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1694.2
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 607.5
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 671.8
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 228.9
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 245.9
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 862.4
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 418.7
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 161.4
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 450.6
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 558.0
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 233.2
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 90.0
   },
   {
    "Region Name": "Europe - Boreal forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 33.4
   }
  ],
  "Europe - Deserts & xeric shrublands": [
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5443.5
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1537.0
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2181.8
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3271.1
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9075.7
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5636.8
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1880.0
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2386.4
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5771.7
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6938.5
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2732.1
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 842.5
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2906.8
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4016.0
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 618.5
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2013.6
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1502.3
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2209.3
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1231.8
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2053.9
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1794.1
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1436.1
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1458.1
   },
   {
    "Region Name": "Europe - Deserts & xeric shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2486.0
   }
  ],
  "Europe - Mediterranean forests,  woodlands and scrub": [
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3022.6
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8773.5
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4710.3
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4350.6
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1377.5
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7959.9
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2815.1
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2177.8
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2034.8
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3118.9
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5513.8
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2731.1
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1831.8
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1550.7
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2397.5
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7732.7
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1066.5
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1562.5
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1665.4
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4813.9
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4200.3
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2809.5
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1678.7
   },
   {
    "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7339.1
   }
  ],
  "Europe - Temperate broadleaf & mixed forest": [
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 37730.0
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14609.9
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23102.8
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 28913.0
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 30149.7
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24725.3
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 52073.4
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 49166.0
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26227.2
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15871.2
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14743.9
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13443.7
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 25986.2
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18935.2
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12618.8
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13683.6
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22975.4
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 24804.4
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12258.0
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6332.9
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6183.7
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4581.3
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8999.0
   },
   {
    "Region Name": "Europe - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5759.2
   }
  ],
  "Europe - Temperate conifer forest": [
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 168.1
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 56.0
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 193.8
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 173.9
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 579.0
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 785.9
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 604.7
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 479.3
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 617.2
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 207.9
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 283.8
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 340.4
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 142.8
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 184.8
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 126.9
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 289.2
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 525.6
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Europe - Temperate conifer forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 91.5
   }
  ],
  "Europe - Temperate grassland, savannah & shrubland": [
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 46621.4
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15522.2
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 30501.3
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 66202.9
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 49142.8
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 53060.8
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 69806.3
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 35976.0
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 33045.0
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17374.8
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16344.4
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10388.5
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 39389.7
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31181.9
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 20685.3
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 38459.5
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19357.3
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20043.1
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19173.4
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11108.6
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17450.5
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14072.9
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18407.9
   },
   {
    "Region Name": "Europe - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19723.2
   }
  ],
  "Europe - Tundra": [
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Europe - Tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "North America - (Sub)tropical coniferous forest": [
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7834.8
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15137.0
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5411.3
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18190.5
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9742.2
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8467.4
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11247.1
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8565.5
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6502.2
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22356.3
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9666.5
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11578.3
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6414.1
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4282.0
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8346.2
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11323.6
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9875.3
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13073.3
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13510.0
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8899.5
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7687.9
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14151.6
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13566.1
   },
   {
    "Region Name": "North America - (Sub)tropical coniferous forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7709.6
   }
  ],
  "North America - (Sub)tropical dry broadleaf forest": [
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8809.5
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11673.0
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9925.1
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8977.1
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8815.3
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7927.4
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8857.5
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8611.0
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6080.8
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8024.5
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6703.7
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7462.8
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5761.8
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6973.9
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7368.7
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6680.4
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6452.9
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7207.7
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8220.0
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7544.1
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7528.0
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6823.8
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7898.6
   },
   {
    "Region Name": "North America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6009.8
   }
  ],
  "North America - (Sub)tropical grassland, savannah & shrubland": [
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 339.8
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 459.6
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 744.1
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1193.6
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 616.5
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 760.4
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 948.6
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 319.8
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1056.0
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 673.1
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 740.4
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 527.1
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 531.0
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 561.0
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 722.9
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 612.5
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 346.8
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 838.0
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 596.8
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 739.4
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1081.1
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 651.7
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 470.8
   },
   {
    "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 708.7
   }
  ],
  "North America - (Sub)tropical moist broadleaf forest": [
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5619.9
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18616.0
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2841.9
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12801.5
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4177.4
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8546.2
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4116.7
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7299.9
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4567.6
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6287.0
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2851.8
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6833.7
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2179.5
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5343.4
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7290.9
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4522.1
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3024.3
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6100.1
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6817.6
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2028.8
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2498.7
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6179.2
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9048.3
   },
   {
    "Region Name": "North America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4564.3
   }
  ],
  "North America - Boreal forest": [
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 27633.0
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15453.9
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25908.2
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 23553.2
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16540.7
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12516.6
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12783.3
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9143.1
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21246.3
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15035.2
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13454.4
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 38520.8
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 27860.9
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 37080.9
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8781.6
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 17707.3
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8993.9
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13362.7
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1104.0
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26376.2
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13558.4
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 117422.1
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 42503.4
   },
   {
    "Region Name": "North America - Boreal forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 42799.2
   }
  ],
  "North America - Deserts & xeric shrublands": [
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3427.3
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2956.6
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2564.5
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10065.5
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9515.6
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10430.3
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4815.2
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3720.8
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4645.4
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12732.9
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12428.7
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4184.9
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3219.4
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3239.8
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4577.8
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8806.9
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9864.6
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3961.8
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8422.6
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3545.7
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3264.0
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2837.4
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5091.9
   },
   {
    "Region Name": "North America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5784.1
   }
  ],
  "North America - Flooded grassland & savannah": [
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1429.2
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1163.0
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2057.7
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1743.0
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2005.0
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1976.3
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1844.6
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1626.4
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1185.2
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1585.7
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1407.5
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1438.4
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1539.4
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 992.3
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1389.5
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1517.3
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1663.5
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 983.1
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1301.6
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1690.9
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1416.1
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 913.2
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1409.7
   },
   {
    "Region Name": "North America - Flooded grassland & savannah",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1883.9
   }
  ],
  "North America - Mangroves": [
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1257.1
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2478.7
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2112.0
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1997.5
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1649.8
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1780.5
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1951.2
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2095.5
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1355.0
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2053.7
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1338.1
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1807.6
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1396.8
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1566.2
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1965.1
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1586.8
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1476.8
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2003.3
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1870.8
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1393.4
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1184.6
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2781.4
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2549.3
   },
   {
    "Region Name": "North America - Mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1735.3
   }
  ],
  "North America - Mediterranean forests,  woodlands and scrub": [
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1020.8
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3690.1
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 735.9
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 949.9
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1840.6
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3206.3
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2266.5
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1796.0
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 350.3
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 461.3
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 699.9
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 694.1
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 480.0
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1369.4
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1712.8
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3450.3
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3433.3
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1029.6
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6860.5
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 811.6
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 387.4
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 839.5
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3833.1
   },
   {
    "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1450.4
   }
  ],
  "North America - Temperate broadleaf & mixed forest": [
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1457.7
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4420.3
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4903.5
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3841.3
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3534.7
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4462.7
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4309.9
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2880.0
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7615.2
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6401.5
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2573.7
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3050.9
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2987.7
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7763.4
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4832.9
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3378.5
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2888.8
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5533.1
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3616.6
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5130.5
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4926.0
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5843.3
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4483.3
   },
   {
    "Region Name": "North America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3603.5
   }
  ],
  "North America - Temperate conifer forest": [
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10194.5
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9295.7
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5924.1
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6037.1
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9533.4
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13104.4
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6942.8
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5590.3
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6287.4
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9538.8
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12266.0
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7877.4
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9417.2
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11081.2
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7182.2
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21438.4
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17741.0
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5541.0
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18476.7
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26543.6
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10224.5
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16994.7
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15229.8
   },
   {
    "Region Name": "North America - Temperate conifer forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7362.1
   }
  ],
  "North America - Temperate grassland, savannah & shrubland": [
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4308.0
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9684.3
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5049.2
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9676.6
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12729.0
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7591.7
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10953.0
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12441.5
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8170.9
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16355.5
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9718.8
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2621.3
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9853.7
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7169.6
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11018.1
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12557.3
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9998.0
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9694.4
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14518.6
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9849.4
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8564.5
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9850.9
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8451.9
   },
   {
    "Region Name": "North America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7033.9
   }
  ],
  "North America - Tundra": [
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1242.7
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1374.3
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16659.7
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4628.9
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 348.3
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1407.8
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 191.6
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1743.0
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 985.0
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 783.1
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1809.9
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 419.9
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3146.9
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 450.4
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1163.6
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 488.3
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2797.3
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 123.7
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1239.9
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3649.8
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2401.8
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2377.8
   },
   {
    "Region Name": "North America - Tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2165.3
   }
  ],
  "Oceania - (Sub)tropical dry broadleaf forest": [
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 126.0
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 89.6
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 86.6
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 128.8
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 143.8
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 160.6
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.1
   }
  ],
  "Oceania - (Sub)tropical grassland, savannah & shrubland": [
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Oceania - (Sub)tropical moist broadleaf forest": [
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 176.4
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 127.1
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Oceania - Montane grassland & shrubland": [
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Montane grassland & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Oceania - Temperate broadleaf & mixed forest": [
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Oceania - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30.7
   }
  ],
  "Oceania - Temperate grassland, savannah & shrubland": [
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Oceania - Tundra": [
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oceania - Tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "South America - (Sub)tropical dry broadleaf forest": [
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13038.1
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11454.4
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22647.7
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11017.3
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11014.9
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23555.1
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9328.7
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5810.9
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 23087.3
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7418.0
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7198.7
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4790.3
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5375.1
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9301.7
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8406.5
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5259.1
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8370.0
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15157.8
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14693.3
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12551.7
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11639.8
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8748.0
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 41513.0
   },
   {
    "Region Name": "South America - (Sub)tropical dry broadleaf forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4811.9
   }
  ],
  "South America - (Sub)tropical grassland, savannah & shrubland": [
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 256899.0
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 243258.9
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 234647.9
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 250466.4
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 202404.2
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 375376.8
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 203046.7
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 149808.1
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 356462.2
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 196560.9
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 259944.7
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 160583.0
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 177335.0
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 209182.1
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 178598.5
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 249349.9
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 145297.4
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 226908.9
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 260301.8
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 225040.5
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 172380.5
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 186867.8
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 243498.1
   },
   {
    "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 139582.7
   }
  ],
  "South America - (Sub)tropical moist broadleaf forest": [
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 77474.9
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 74961.2
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 75595.1
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 95441.6
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 59084.6
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 117752.5
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 51828.9
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 42375.0
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 106299.4
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 45395.4
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 54686.6
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 31099.4
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 44007.6
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 72837.2
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 51908.4
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 79180.2
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 33405.6
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 61078.0
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 66795.2
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 44400.5
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 55192.1
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 57940.3
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 110951.8
   },
   {
    "Region Name": "South America - (Sub)tropical moist broadleaf forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 21737.9
   }
  ],
  "South America - Deserts & xeric shrublands": [
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4972.7
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6903.5
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4737.1
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6431.1
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4691.3
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8732.1
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6348.1
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4735.4
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6711.5
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4241.9
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6937.2
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2998.4
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3733.2
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6917.3
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5846.1
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4870.5
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6475.2
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8191.3
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9173.3
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8548.8
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4681.6
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7700.8
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6101.6
   },
   {
    "Region Name": "South America - Deserts & xeric shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6114.7
   }
  ],
  "South America - Flooded grassland & savannah": [
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 38814.7
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13555.8
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 29594.7
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 33419.3
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19899.9
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 39401.7
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23503.0
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15835.2
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 32445.0
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10347.2
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21160.1
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8664.4
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2255.4
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13444.2
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14725.6
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11385.4
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6068.8
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 37956.0
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 51930.7
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 39147.6
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10280.7
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16644.3
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 48791.9
   },
   {
    "Region Name": "South America - Flooded grassland & savannah",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5033.8
   }
  ],
  "South America - Mangroves": [
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 448.5
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 984.6
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 620.8
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 431.5
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 611.0
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 723.1
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 559.5
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 564.4
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 753.1
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 239.5
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 488.3
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 861.5
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 497.1
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 872.5
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 925.9
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 278.0
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 388.9
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 773.4
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 660.3
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 147.5
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 364.4
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 699.9
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 815.5
   },
   {
    "Region Name": "South America - Mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 314.7
   }
  ],
  "South America - Mediterranean forests,  woodlands and scrub": [
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 191.6
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 638.8
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 496.3
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 721.1
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 198.9
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 399.8
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 470.1
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 557.6
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 523.3
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 510.0
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 513.8
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 397.2
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 683.8
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 881.3
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2097.0
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 321.6
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 436.0
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 641.2
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 477.8
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 916.2
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1501.4
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 721.1
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 485.8
   },
   {
    "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 554.1
   }
  ],
  "South America - Montane grassland & shrubland": [
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1381.6
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1715.2
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 664.8
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1333.2
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 433.2
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 299.7
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 385.9
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 572.6
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1200.3
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 120.5
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 735.7
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 469.9
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 437.5
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 618.7
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1202.4
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1781.2
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 613.1
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 944.7
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1157.8
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 426.0
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1835.4
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 699.3
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1103.1
   },
   {
    "Region Name": "South America - Montane grassland & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 457.7
   }
  ],
  "South America - Temperate broadleaf & mixed forest": [
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 176.9
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 398.9
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 394.7
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 348.1
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 496.7
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 244.6
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 283.4
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 854.0
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 188.2
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 464.3
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 832.0
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1284.1
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3245.3
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 280.2
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 498.4
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 369.8
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 666.3
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2811.7
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 295.8
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 624.5
   },
   {
    "Region Name": "South America - Temperate broadleaf & mixed forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1069.7
   }
  ],
  "South America - Temperate grassland, savannah & shrubland": [
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23303.4
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13782.2
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7557.4
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7537.6
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4116.5
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3352.5
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8186.3
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5039.2
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3234.2
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5250.1
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3028.2
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11675.4
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6278.2
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4730.7
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 28789.8
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15934.9
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6696.5
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4333.9
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7061.5
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5530.3
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7749.4
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3626.3
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4469.2
   },
   {
    "Region Name": "South America - Temperate grassland, savannah & shrubland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5397.2
   }
  ]
 },
 "Ecoregions": {
  "Admiralty Islands lowland rain forests": [
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Admiralty Islands lowland rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Aegean and Western Turkey sclerophyllous and mixed forests": [
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 243.1
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 205.6
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 440.3
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 485.3
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 488.3
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3250.5
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1155.9
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 551.6
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 401.5
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 603.0
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 868.8
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 722.4
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 574.3
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 340.8
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 728.0
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 468.6
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 331.2
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 371.1
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 202.8
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1939.2
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 342.6
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1386.1
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 614.0
   },
   {
    "Region Name": "Aegean and Western Turkey sclerophyllous and mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 891.6
   }
  ],
  "Afghan Mountains semi-desert": [
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afghan Mountains semi-desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Hajar montane woodlands": [
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hajar montane woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Alai-Western Tian Shan steppe": [
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4098.5
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2185.1
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6648.7
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1015.3
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 717.7
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 650.4
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 697.6
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1080.0
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 393.2
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 202.4
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1078.7
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 246.1
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 221.9
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 338.5
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 402.2
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 167.2
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 128.4
   },
   {
    "Region Name": "Alai-Western Tian Shan steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 139.6
   }
  ],
  "Alashan Plateau semi-desert": [
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 236.0
   },
   {
    "Region Name": "Alashan Plateau semi-desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 56.2
   }
  ],
  "Alaska Peninsula montane taiga": [
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alaska Peninsula montane taiga",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Alaska-St Elias Range tundra": [
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 99.7
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 126.3
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 130.3
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 271.6
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 143.2
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 133.6
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 116.8
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 127.1
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 137.8
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 224.9
   },
   {
    "Region Name": "Alaska-St Elias Range tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 212.2
   }
  ],
  "Albany thickets": [
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 366.8
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 145.6
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 105.0
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 360.6
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 401.9
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 284.5
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 118.5
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 286.2
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 398.3
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 80.0
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 259.6
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 587.8
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 253.8
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 177.1
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 198.7
   },
   {
    "Region Name": "Albany thickets",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 160.8
   }
  ],
  "Alberta Mountain forests": [
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 216.3
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 205.6
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 155.2
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 133.8
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 115.5
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 421.0
   },
   {
    "Region Name": "Alberta Mountain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Alberta-British Columbia foothills forests": [
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 93.0
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 296.7
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 221.7
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 274.0
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 179.2
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 643.5
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 282.8
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 211.6
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5571.2
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 221.9
   },
   {
    "Region Name": "Alberta-British Columbia foothills forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 158.4
   }
  ],
  "Albertine Rift montane forests": [
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10188.3
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8787.6
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11197.8
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7875.3
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8153.1
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7077.0
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6571.1
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7340.9
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8733.4
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7783.5
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5506.3
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7605.4
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6754.1
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7528.4
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7516.6
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5828.3
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6327.1
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5100.5
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7475.9
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6368.7
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6171.0
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5986.0
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7077.6
   },
   {
    "Region Name": "Albertine Rift montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5524.9
   }
  ],
  "Aldabra Island xeric scrub": [
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aldabra Island xeric scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Aleutian Islands tundra": [
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aleutian Islands tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Allegheny Highlands forests": [
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Allegheny Highlands forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Alps conifer and mixed forests": [
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Alps conifer and mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Altai alpine meadow and tundra": [
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 111.9
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 150.7
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 65.4
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 185.6
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 148.6
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 125.8
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 200.4
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Altai alpine meadow and tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 29.8
   }
  ],
  "Altai montane forest and forest steppe": [
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 92.6
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 178.8
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 89.2
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 251.2
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 127.8
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Altai montane forest and forest steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 187.6
   }
  ],
  "Altai steppe and semi-desert": [
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11297.2
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3911.4
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2989.4
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2865.7
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1936.6
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7043.1
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2342.6
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 278.5
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2558.3
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1370.5
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 255.3
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4745.9
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1213.8
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 380.5
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1980.6
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1450.8
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 462.8
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 597.9
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1917.1
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1642.9
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 195.7
   },
   {
    "Region Name": "Altai steppe and semi-desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 452.7
   }
  ],
  "Alto Parana Atlantic forests": [
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8957.0
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11118.2
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8960.2
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10805.9
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9615.7
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16992.0
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10673.2
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7756.3
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12914.0
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12890.2
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8198.3
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8067.6
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6163.5
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4984.3
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7186.7
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10847.9
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7433.7
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9831.8
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7636.3
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10198.4
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2853.5
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3629.9
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10105.1
   },
   {
    "Region Name": "Alto Parana Atlantic forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2819.4
   }
  ],
  "Amazon-Orinoco-Southern Caribbean mangroves": [
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 232.2
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 554.4
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 298.8
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 132.1
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 244.6
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 173.2
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 229.6
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 334.8
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 273.1
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 240.1
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 263.7
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 252.3
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 321.3
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 220.8
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 99.5
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 211.8
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 311.3
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 384.1
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 110.6
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 358.6
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 439.7
   },
   {
    "Region Name": "Amazon-Orinoco-Southern Caribbean mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 128.0
   }
  ],
  "Amsterdam and Saint-Paul Islands temperate grasslands": [
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amsterdam and Saint-Paul Islands temperate grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Amur meadow steppe": [
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4632.5
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16586.6
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6345.1
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11353.4
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7825.8
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7743.2
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15911.5
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8785.5
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3247.0
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9017.0
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5931.4
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3961.8
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13085.5
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9812.5
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7988.2
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6860.2
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7274.2
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5696.9
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3000.3
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3630.3
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2139.8
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4238.1
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6364.4
   },
   {
    "Region Name": "Amur meadow steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5886.8
   }
  ],
  "Anatolian conifer and deciduous mixed forests": [
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 174.5
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 75.5
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 108.7
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 259.8
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 263.0
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 107.8
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 207.1
   },
   {
    "Region Name": "Anatolian conifer and deciduous mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 249.5
   }
  ],
  "Andaman Islands rain forests": [
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Andaman Islands rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Angolan Miombo woodlands": [
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 193634.6
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 230204.4
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 229022.4
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 228758.7
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 213101.0
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 224641.1
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 216168.6
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 214078.5
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 220474.7
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 234428.8
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 199710.4
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 214180.8
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 201345.7
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 212921.2
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 209410.6
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 221221.1
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 183646.5
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 240131.9
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 194377.6
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 211710.8
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 195694.2
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 219651.3
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 222407.2
   },
   {
    "Region Name": "Angolan Miombo woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 204389.3
   }
  ],
  "Angolan Mopane woodlands": [
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2151.4
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4254.4
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7826.2
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8234.1
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14593.8
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4906.7
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1606.3
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10819.2
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4031.4
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13041.4
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16074.2
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2649.6
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3040.8
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2988.7
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3996.7
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4905.8
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3074.3
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 418.9
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9929.4
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17633.8
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1820.2
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1513.4
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5181.5
   },
   {
    "Region Name": "Angolan Mopane woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11022.2
   }
  ],
  "Angolan montane forest-grassland mosaic": [
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7743.2
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8552.0
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9086.0
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8363.0
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9387.2
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7721.1
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8307.2
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8535.3
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9731.9
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8162.1
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6557.3
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7165.7
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7418.7
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7581.4
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7690.3
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6976.9
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6627.4
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7824.7
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8334.2
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4705.0
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7257.0
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6234.7
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7442.9
   },
   {
    "Region Name": "Angolan montane forest-grassland mosaic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7726.5
   }
  ],
  "Angolan scarp savanna and woodlands": [
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7287.3
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8466.5
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8820.0
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9576.9
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8765.3
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9564.5
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9735.6
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7678.3
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8859.7
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8602.8
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5180.7
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9380.4
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6641.8
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7805.8
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10527.9
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6298.8
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7303.3
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5795.9
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11389.9
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6492.6
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9775.0
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7716.2
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11753.9
   },
   {
    "Region Name": "Angolan scarp savanna and woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9699.8
   }
  ],
  "Antipodes Subantarctic Islands tundra": [
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antipodes Subantarctic Islands tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Appalachian mixed mesophytic forests": [
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 111.5
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 135.1
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 245.5
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 116.4
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 158.2
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 99.7
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 96.5
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 107.2
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 284.7
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 109.5
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 124.1
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 171.7
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 279.1
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 116.2
   },
   {
    "Region Name": "Appalachian mixed mesophytic forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 55.5
   }
  ],
  "Appalachian-Blue Ridge forests": [
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 84.0
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 80.2
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 132.1
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 87.5
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 448.9
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 107.4
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Appalachian-Blue Ridge forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 83.0
   }
  ],
  "Appenine deciduous montane forests": [
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Appenine deciduous montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Apure-Villavicencio dry forests": [
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2053.0
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3952.3
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1238.2
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2298.7
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2182.3
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1387.6
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1718.8
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1477.4
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 702.5
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 480.2
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 746.2
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1214.0
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 928.6
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 770.9
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 318.3
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 768.7
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1219.3
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1872.1
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2481.3
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 848.3
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1596.2
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1600.7
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1653.6
   },
   {
    "Region Name": "Apure-Villavicencio dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 883.8
   }
  ],
  "Arabian Desert and East Sahero-Arabian xeric shrublands": [
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 991.5
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 881.9
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 803.5
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1348.6
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1038.0
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1154.2
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 699.5
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 485.3
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 712.8
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 365.9
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 389.3
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 487.5
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 649.3
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 438.8
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 431.1
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 385.4
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 454.9
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1104.4
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 774.1
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 672.3
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 365.7
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 943.2
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1279.6
   },
   {
    "Region Name": "Arabian Desert and East Sahero-Arabian xeric shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 579.2
   }
  ],
  "Arabian Peninsula coastal fog desert": [
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arabian Peninsula coastal fog desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Araucaria moist forests": [
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2396.2
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2922.5
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 542.4
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 220.4
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1197.0
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 850.2
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 292.8
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 816.3
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 635.6
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 448.9
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 161.0
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 165.1
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 551.6
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 156.9
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 781.8
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 290.5
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 340.2
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 640.7
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 369.4
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 398.5
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 206.0
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 272.7
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 426.0
   },
   {
    "Region Name": "Araucaria moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 162.7
   }
  ],
  "Araya and Paria xeric scrub": [
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Araya and Paria xeric scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Arctic coastal tundra": [
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 105.5
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 406.2
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Arctic coastal tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.1
   }
  ],
  "Arctic desert": [
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Arctic foothills tundra": [
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 889.6
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 291.1
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 215.9
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Arctic foothills tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 58.3
   }
  ],
  "Arizona Mountains forests": [
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2016.6
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 734.9
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 849.5
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1806.3
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 478.0
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 118.8
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 348.3
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 349.2
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 374.9
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2882.0
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1530.4
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 603.4
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 520.3
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 185.4
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 677.6
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1250.6
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 493.3
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1006.0
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2127.6
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1516.0
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1365.5
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 516.4
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 638.2
   },
   {
    "Region Name": "Arizona Mountains forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1146.9
   }
  ],
  "Arnhem Land tropical savanna": [
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 70148.4
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 50197.9
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 72817.5
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 57013.8
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 65575.5
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 51816.4
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 53887.4
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 59739.5
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 30898.7
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 58562.2
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 62830.5
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 42069.7
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 67162.0
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 54846.1
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 31896.0
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 34976.7
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 57065.7
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 54106.9
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 34382.9
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 36019.1
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 38656.5
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 39024.2
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 34696.1
   },
   {
    "Region Name": "Arnhem Land tropical savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 33664.5
   }
  ],
  "Ascension scrub and grasslands": [
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension scrub and grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Atacama desert": [
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Atlantic Coast restingas": [
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Atlantic Coast restingas",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.0
   }
  ],
  "Atlantic Equatorial coastal forests": [
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 513.6
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 622.1
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 880.8
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1179.7
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 486.4
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1418.7
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 270.7
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 272.9
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 952.2
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 866.9
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1200.9
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 339.3
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 558.2
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 792.1
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 379.4
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 563.1
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1283.0
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 350.9
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 451.5
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 941.3
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 840.8
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2233.1
   },
   {
    "Region Name": "Atlantic Equatorial coastal forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 606.9
   }
  ],
  "Atlantic coastal desert": [
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Atlantic coastal pine barrens": [
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atlantic coastal pine barrens",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 52.9
   }
  ],
  "Atlantic dry forests": [
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1734.7
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 907.0
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1125.4
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2238.7
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 478.0
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5593.1
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1868.2
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 750.9
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4309.9
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2422.4
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3968.2
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1218.3
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1449.6
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5857.6
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 931.0
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 690.5
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1573.0
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1793.0
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1860.3
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5555.2
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2876.4
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2883.7
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1430.9
   },
   {
    "Region Name": "Atlantic dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2574.8
   }
  ],
  "Atlantic mixed forests": [
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 629.6
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 110.4
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 440.3
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 134.2
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 186.7
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 349.9
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 191.2
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 87.5
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 133.1
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 126.9
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 130.8
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 435.0
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 75.5
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Atlantic mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 34.3
   }
  ],
  "Australian Alps montane grasslands": [
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9334.1
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 51.9
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3517.4
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 252.1
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 323.9
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 107.0
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4804.2
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Australian Alps montane grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 155.6
   }
  ],
  "Azerbaijan shrub desert and steppe": [
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1612.9
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1750.1
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2008.0
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1131.0
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2577.1
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1212.3
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 703.8
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 816.1
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1953.3
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1932.1
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 849.1
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 838.6
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 198.1
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3544.6
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1840.6
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1374.7
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1169.8
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2313.0
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 392.1
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1493.1
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 342.6
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 141.5
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 299.7
   },
   {
    "Region Name": "Azerbaijan shrub desert and steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 941.3
   }
  ],
  "Azores temperate mixed forests": [
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores temperate mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Badghyz and Karabil semi-desert": [
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1125.7
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3900.0
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1814.0
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 650.0
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 95.4
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1381.4
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 126.0
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 316.6
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2696.3
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 507.4
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 372.8
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 135.3
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1025.3
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 961.9
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 265.0
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2700.8
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 814.4
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Badghyz and Karabil semi-desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 405.8
   }
  ],
  "Baffin coastal tundra": [
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baffin coastal tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bahamian pine mosaic": [
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 185.9
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 104.6
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 206.9
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 245.0
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 145.1
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Bahamian pine mosaic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 94.5
   }
  ],
  "Bahamian-Antillean mangroves": [
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 132.7
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 555.4
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 125.6
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 262.2
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 162.7
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 397.2
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 196.1
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 136.6
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 365.5
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 144.9
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 239.0
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 99.7
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 168.7
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 255.3
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 278.0
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 112.1
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 319.4
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 119.4
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 111.7
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 131.4
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 258.5
   },
   {
    "Region Name": "Bahamian-Antillean mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 278.7
   }
  ],
  "Bahia coastal forests": [
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 480.2
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1120.5
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 185.4
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 435.8
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 114.7
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1078.7
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 453.6
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 358.2
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 138.3
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 322.8
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 377.7
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 322.8
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 446.5
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1450.8
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 160.3
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 296.5
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 515.3
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 194.2
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 386.5
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 121.1
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 796.6
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 189.9
   },
   {
    "Region Name": "Bahia coastal forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 96.9
   }
  ],
  "Bahia interior forests": [
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 909.8
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3329.8
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 421.7
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1087.7
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 377.5
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3303.9
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 998.7
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 193.6
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 857.3
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1567.3
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 737.4
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 266.2
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1519.7
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1724.2
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 358.4
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 639.2
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 350.1
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1464.4
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 562.9
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1068.6
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 413.3
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 385.0
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1021.0
   },
   {
    "Region Name": "Bahia interior forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 245.7
   }
  ],
  "Baja California desert": [
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 93.7
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 97.3
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 155.2
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 345.1
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 325.8
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Baja California desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.3
   }
  ],
  "Bajio dry forests": [
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 867.3
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1506.2
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1236.9
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1736.4
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 959.3
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 895.2
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1421.3
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1117.1
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 421.7
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1210.8
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 451.0
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1020.0
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 231.3
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 502.5
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1033.7
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 865.4
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 627.2
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 590.8
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 415.0
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 644.4
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 549.6
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 514.5
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 304.4
   },
   {
    "Region Name": "Bajio dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 278.9
   }
  ],
  "Balkan mixed forests": [
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 388.4
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 677.6
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1797.5
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1097.6
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2418.7
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2310.7
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2353.8
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 930.1
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1905.7
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2118.4
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2969.4
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1522.4
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1107.9
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1197.3
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1883.7
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1589.1
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 847.0
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2587.2
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 796.2
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1494.6
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 677.6
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 866.9
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1454.3
   },
   {
    "Region Name": "Balkan mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 735.5
   }
  ],
  "Balsas dry forests": [
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 499.1
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 746.6
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 650.8
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1083.6
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 705.3
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 606.2
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 623.0
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 781.2
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 439.0
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 505.5
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 583.9
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 675.3
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 338.1
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 446.1
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 555.6
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 478.3
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 583.9
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 688.8
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 872.9
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 947.5
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 528.8
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 539.4
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 890.1
   },
   {
    "Region Name": "Balsas dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 461.1
   }
  ],
  "Baltic mixed forests": [
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 128.8
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 96.0
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 192.7
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 131.2
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Baltic mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.9
   }
  ],
  "Baluchistan xeric woodlands": [
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 116.4
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 258.3
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 166.1
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 187.4
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 122.0
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 121.5
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 188.9
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 241.6
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 147.5
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 162.7
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 383.1
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 313.8
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 236.4
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 187.8
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 292.2
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 292.0
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 359.1
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 407.3
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 529.7
   },
   {
    "Region Name": "Baluchistan xeric woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 866.3
   }
  ],
  "Banda Sea Islands moist deciduous forests": [
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 95.8
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 117.0
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 115.8
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 103.3
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 131.0
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Banda Sea Islands moist deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 25.7
   }
  ],
  "Belizian pine forests": [
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 234.5
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 416.5
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 319.6
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 122.8
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 437.7
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 221.9
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 119.6
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 243.7
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 522.0
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 389.3
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 167.6
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 180.3
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 220.2
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 169.1
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 278.0
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 224.4
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 132.3
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 92.6
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 399.8
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 356.1
   },
   {
    "Region Name": "Belizian pine forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 207.7
   }
  ],
  "Beni savanna": [
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16064.8
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12662.1
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 20179.4
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 26922.2
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19425.5
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12296.8
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11566.7
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8344.1
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 30393.5
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14499.5
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10279.2
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8058.8
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3947.8
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8409.7
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14323.1
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11943.6
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6030.6
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11051.8
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16269.3
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12046.7
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16165.6
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23183.6
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23307.5
   },
   {
    "Region Name": "Beni savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5938.7
   }
  ],
  "Bering tundra": [
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3267.2
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9988.5
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 218.7
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 303.1
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 478.0
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1583.3
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 486.6
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9520.1
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 188.0
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 329.9
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3524.4
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1311.1
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 970.4
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2069.1
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 127.8
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Bering tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Beringia lowland tundra": [
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 259.4
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 710.0
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 187.8
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1356.1
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 89.8
   },
   {
    "Region Name": "Beringia lowland tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.0
   }
  ],
  "Beringia upland tundra": [
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 88.5
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 481.3
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Beringia upland tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.1
   }
  ],
  "Bermuda subtropical conifer forests": [
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bermuda subtropical conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Biak-Numfoor rain forests": [
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Biak-Numfoor rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Blue Mountains forests": [
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 310.2
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 303.3
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 740.2
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1280.9
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 101.6
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 185.9
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 237.5
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 249.3
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 677.2
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1317.9
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 204.1
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 234.1
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 312.1
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 347.7
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 337.8
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 340.0
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 80.2
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5334.8
   },
   {
    "Region Name": "Blue Mountains forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 364.0
   }
  ],
  "Bohai Sea saline meadow": [
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 125.0
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 112.8
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Bohai Sea saline meadow",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19.3
   }
  ],
  "Bolivian Yungas": [
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 310.0
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 286.2
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 392.3
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 287.7
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 145.6
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 96.0
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 503.6
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 137.8
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 285.5
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 108.7
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 204.7
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 228.5
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 336.1
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1333.8
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 114.0
   },
   {
    "Region Name": "Bolivian Yungas",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 70.7
   }
  ],
  "Bolivian montane dry forests": [
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 126.7
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 220.6
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Bolivian montane dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Borneo lowland rain forests": [
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1987.4
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 462.4
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4099.4
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 403.4
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2225.2
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 236.0
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1557.8
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 143.8
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 216.3
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 277.0
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 201.1
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1081.5
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1509.4
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 260.9
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 134.2
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 779.7
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 114.5
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 242.2
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "Borneo lowland rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 66.7
   }
  ],
  "Borneo montane rain forests": [
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 56.0
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Borneo montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Borneo peat swamp forests": [
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3049.0
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1097.1
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2699.1
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 769.4
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3509.2
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 459.6
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3333.0
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1030.0
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1248.3
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 478.5
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2315.8
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2560.4
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 141.1
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 941.9
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2046.2
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1266.7
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "Borneo peat swamp forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 60.0
   }
  ],
  "Brahmaputra Valley semi-evergreen forests": [
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 129.9
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 260.5
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 251.7
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 121.5
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 142.3
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 201.7
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 216.9
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 126.9
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 165.1
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 304.0
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 170.0
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 221.9
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 122.8
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 184.1
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 108.7
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 111.5
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 120.9
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 122.6
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 119.6
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 219.7
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 157.1
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 151.8
   },
   {
    "Region Name": "Brahmaputra Valley semi-evergreen forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 277.0
   }
  ],
  "Brigalow tropical savanna": [
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6928.8
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2477.5
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8589.3
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5638.3
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4067.9
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1292.9
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6023.1
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17797.1
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1668.4
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25564.4
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 23061.6
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11448.6
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3884.4
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4076.0
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3464.8
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4435.5
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7809.9
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3320.1
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3578.0
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2985.7
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2385.3
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11277.7
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7204.7
   },
   {
    "Region Name": "Brigalow tropical savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6993.8
   }
  ],
  "British Columbia mainland coastal forests": [
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 87.9
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 243.7
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 386.5
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 323.9
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 172.6
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "British Columbia mainland coastal forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 160.8
   }
  ],
  "Brooks-British Range tundra": [
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 417.2
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 490.5
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 88.7
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 281.0
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 149.0
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 179.6
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 140.0
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 187.8
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 139.1
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 139.3
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 298.6
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 109.8
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 207.5
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 125.2
   },
   {
    "Region Name": "Brooks-British Range tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 91.1
   }
  ],
  "Buru rain forests": [
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1446.3
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 180.3
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 378.1
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 307.0
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 877.6
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 93.7
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buru rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Caatinga": [
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3031.2
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3855.0
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3034.4
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3502.6
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2116.0
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6649.9
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4066.4
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1764.7
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5252.0
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3210.8
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5068.3
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1234.6
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1786.8
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4384.7
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3964.1
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2414.0
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3428.4
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4743.6
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4986.0
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6359.7
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2938.1
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3975.5
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2765.1
   },
   {
    "Region Name": "Caatinga",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3373.3
   }
  ],
  "Caatinga Enclaves moist forests": [
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 167.2
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 86.0
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Caatinga Enclaves moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 54.2
   }
  ],
  "Caledon conifer forests": [
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caledon conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 40.1
   }
  ],
  "California Central Valley grasslands": [
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 192.7
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 289.4
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 468.0
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 238.8
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 431.3
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 211.8
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 235.2
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 279.8
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 215.7
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 466.7
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 114.3
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 99.0
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 147.3
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 266.2
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 303.8
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 584.4
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 326.3
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 740.4
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 92.4
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 56.0
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 230.4
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 367.4
   },
   {
    "Region Name": "California Central Valley grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 116.2
   }
  ],
  "California coastal sage and chaparral": [
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 401.7
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2678.5
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 297.8
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 787.6
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 546.9
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1537.2
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 406.0
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 546.6
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 173.4
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 173.4
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 380.1
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 265.4
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 251.7
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 190.8
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 105.0
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 971.9
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 619.3
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 486.4
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 901.6
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 177.3
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 188.6
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 559.1
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 947.9
   },
   {
    "Region Name": "California coastal sage and chaparral",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 214.2
   }
  ],
  "California interior chaparral and woodlands": [
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 144.7
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 302.5
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 301.6
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 278.0
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 610.3
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 337.8
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 199.6
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 307.0
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 148.1
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 157.1
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1015.5
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 315.1
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1520.7
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2394.7
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 473.1
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4175.3
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 518.3
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 112.1
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 221.4
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1797.9
   },
   {
    "Region Name": "California interior chaparral and woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1125.7
   }
  ],
  "California montane chaparral and woodlands": [
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 588.2
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 824.9
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 200.9
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 94.8
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1163.0
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1464.6
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1201.1
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 873.8
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 178.1
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 388.2
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 136.3
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1382.9
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 896.9
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 90.2
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1478.3
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 887.1
   },
   {
    "Region Name": "California montane chaparral and woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 107.4
   }
  ],
  "Cameroonian Highlands forests": [
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2974.2
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4915.9
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3257.8
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4142.0
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3247.5
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2749.5
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2826.5
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2236.9
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2876.2
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2099.7
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1811.0
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1831.1
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1347.5
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1450.2
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1077.8
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1320.5
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1194.2
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1347.5
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1288.6
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 954.2
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1615.9
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 788.7
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1199.2
   },
   {
    "Region Name": "Cameroonian Highlands forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1012.0
   }
  ],
  "Campos Rupestres montane savanna": [
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 141.3
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 361.2
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 157.3
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 209.2
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 734.0
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 450.6
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 354.4
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 473.5
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 261.1
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 408.6
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 411.2
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 137.2
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 159.5
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 230.0
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 277.4
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 104.4
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 381.6
   },
   {
    "Region Name": "Campos Rupestres montane savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 45.7
   }
  ],
  "Canadian Aspen forests and parklands": [
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 732.3
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 502.3
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 226.2
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 720.5
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 290.9
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 535.3
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1438.4
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 406.2
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 440.3
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 839.3
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 622.7
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 341.5
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 563.1
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 651.7
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 349.4
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1327.8
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 648.7
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2709.0
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1167.7
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1812.1
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1115.4
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 312.8
   },
   {
    "Region Name": "Canadian Aspen forests and parklands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 349.4
   }
  ],
  "Canary Islands dry woodlands and forests": [
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 240.5
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 120.3
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canary Islands dry woodlands and forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cantabrian mixed forests": [
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 458.1
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 327.1
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 507.2
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2184.2
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1400.3
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 218.4
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 530.1
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1017.4
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 785.2
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 381.1
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 984.4
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 156.3
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 328.6
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1454.1
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1800.1
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 254.7
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 184.8
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 178.1
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 116.2
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 694.6
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 277.2
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1218.0
   },
   {
    "Region Name": "Cantabrian mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1542.2
   }
  ],
  "Cantebury-Otago tussock grasslands": [
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Cantebury-Otago tussock grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cape Verde Islands dry forests": [
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cape Verde Islands dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cape York Peninsula tropical savanna": [
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 39526.2
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 36065.2
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 28533.8
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 37025.0
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 39622.3
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19136.5
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 27439.2
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 49801.6
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12153.7
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 39886.8
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 47614.6
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16340.5
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 38116.1
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24309.9
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 33198.3
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14739.8
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25916.4
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 24438.1
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 23241.9
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18070.2
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 20581.1
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25120.2
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14147.5
   },
   {
    "Region Name": "Cape York Peninsula tropical savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15022.3
   }
  ],
  "Caqueta moist forests": [
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 491.1
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3707.3
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 361.6
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 745.8
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3558.3
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1111.1
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 844.0
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 737.9
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1274.9
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 397.7
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 631.5
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1380.5
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 214.8
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 804.3
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 696.7
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3689.7
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 503.6
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 589.9
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 390.8
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2160.8
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 186.3
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 218.7
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 216.7
   },
   {
    "Region Name": "Caqueta moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 204.3
   }
  ],
  "Cardamom Mountains rain forests": [
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4290.0
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4860.6
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4908.2
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3306.9
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4705.6
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3385.3
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4198.6
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3175.2
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3797.1
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2782.1
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3471.5
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2955.3
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3194.1
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3351.4
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1353.3
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2290.7
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3215.7
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3056.9
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2579.7
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 483.0
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1403.7
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2737.5
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2935.4
   },
   {
    "Region Name": "Cardamom Mountains rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1821.7
   }
  ],
  "Caribbean shrublands": [
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caribbean shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Carnarvon xeric shrublands": [
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 888.8
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 207.3
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 185.4
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 170.9
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 902.3
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 566.8
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 267.3
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6637.5
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 462.4
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 371.5
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 421.4
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3048.3
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 248.7
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1367.7
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 620.4
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 189.3
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4966.5
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1607.1
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 763.2
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "Carnarvon xeric shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 248.2
   }
  ],
  "Carolines tropical moist forests": [
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolines tropical moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Carpathian montane forests": [
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 74.4
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 151.1
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 475.0
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 660.7
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 428.7
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 305.0
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 475.0
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 141.1
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 234.7
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 296.3
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 151.8
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 192.1
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 375.8
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Carpathian montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 47.8
   }
  ],
  "Carpentaria tropical savanna": [
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 60479.1
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37394.5
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 132156.3
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 29456.9
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 66054.2
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 97065.2
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 37661.2
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 60971.3
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 30503.6
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 78020.0
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 117355.7
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16349.7
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 55119.2
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 45456.9
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 33490.7
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 54702.3
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 59099.4
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 39550.4
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 20744.5
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 57475.3
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 41890.7
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 69171.7
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 72632.3
   },
   {
    "Region Name": "Carpentaria tropical savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 78291.6
   }
  ],
  "Cascade Mountains leeward forests": [
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 202.1
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 435.0
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 486.2
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 864.1
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 556.5
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 286.0
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1050.4
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1067.3
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 931.6
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1022.8
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 91.7
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1960.0
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 368.3
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1092.0
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 435.2
   },
   {
    "Region Name": "Cascade Mountains leeward forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 418.2
   }
  ],
  "Caspian Hyrcanian mixed forests": [
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 398.5
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 386.3
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 315.1
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 120.7
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 269.2
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 236.2
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 176.2
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 249.3
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 629.2
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 208.6
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 128.4
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 92.6
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 288.8
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 213.3
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 148.6
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 62.6
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 197.4
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 114.3
   },
   {
    "Region Name": "Caspian Hyrcanian mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 191.9
   }
  ],
  "Caspian lowland desert": [
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15230.3
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2016.1
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4269.2
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4205.5
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19244.5
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12623.5
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3919.7
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6777.3
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13192.3
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10287.6
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4262.3
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 964.4
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7393.2
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6223.8
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 823.8
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15945.6
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3489.1
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4274.7
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2124.4
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2873.2
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2845.1
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1844.6
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2194.1
   },
   {
    "Region Name": "Caspian lowland desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3092.1
   }
  ],
  "Catatumbo moist forests": [
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 746.4
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 106.3
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 438.8
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 82.7
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 95.8
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 531.0
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 114.0
   },
   {
    "Region Name": "Catatumbo moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 67.7
   }
  ],
  "Cauca Valley dry forests": [
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Cauca Valley dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Cauca Valley montane forests": [
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Cauca Valley montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.0
   }
  ],
  "Caucasus mixed forests": [
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 809.2
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 605.4
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 718.6
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 594.9
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1001.3
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 198.3
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 494.3
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1851.9
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 364.4
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 586.7
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 406.4
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 342.8
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 647.8
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 474.2
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 791.0
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 611.4
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 864.1
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 508.5
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 524.8
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 729.7
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 126.9
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 155.6
   },
   {
    "Region Name": "Caucasus mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 507.6
   }
  ],
  "Cayos Miskitos-San Andres and Providencia moist forests": [
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cayos Miskitos-San Andres and Providencia moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Celtic broadleaf forests": [
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 76.5
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Celtic broadleaf forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 145.6
   }
  ],
  "Central Afghan Mountains xeric woodlands": [
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Afghan Mountains xeric woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Central African mangroves": [
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 212.7
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 532.7
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 710.6
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 427.0
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 630.0
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 423.4
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 386.3
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 128.6
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 559.3
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 481.5
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 440.3
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 538.1
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 502.7
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 306.8
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 431.1
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 482.1
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 372.4
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 850.8
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 462.4
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 500.6
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 589.1
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 357.1
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 570.0
   },
   {
    "Region Name": "Central African mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 460.7
   }
  ],
  "Central American Atlantic moist forests": [
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1298.9
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1428.1
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 176.9
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 119.8
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 167.2
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 397.2
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 56.0
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 529.5
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 344.3
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 254.9
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 768.5
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 289.8
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 250.0
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1247.0
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2088.8
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1176.5
   },
   {
    "Region Name": "Central American Atlantic moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 33.4
   }
  ],
  "Central American dry forests": [
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2045.3
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3330.4
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2063.9
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2820.5
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2497.8
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1938.5
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1975.6
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2392.8
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1665.0
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3052.6
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1882.2
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2526.3
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2804.8
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2360.8
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2546.3
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2293.7
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2863.5
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2828.2
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3564.5
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2000.1
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2079.6
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2176.3
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2288.2
   },
   {
    "Region Name": "Central American dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1688.8
   }
  ],
  "Central American montane forests": [
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 128.0
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 549.9
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 297.3
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 135.9
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 166.4
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 109.5
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 232.4
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 300.8
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 132.5
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 215.2
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 184.1
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 189.5
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 187.6
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 200.4
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 239.5
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 715.1
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 82.7
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 195.7
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 272.5
   },
   {
    "Region Name": "Central American montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 50.4
   }
  ],
  "Central American pine-oak forests": [
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 588.0
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2363.8
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 234.3
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1530.0
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 639.5
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 482.3
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 646.5
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 819.3
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 295.6
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1546.5
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 144.9
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 905.1
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 626.8
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 679.8
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 770.0
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 566.4
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 935.9
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1265.2
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2254.7
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 335.1
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 383.9
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 949.7
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1031.3
   },
   {
    "Region Name": "Central American pine-oak forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 122.6
   }
  ],
  "Central Anatolian steppe": [
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 107.8
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 154.1
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 134.0
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 120.5
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 457.7
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1278.1
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 492.8
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 800.5
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 119.8
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 216.5
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 259.2
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 157.6
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 157.6
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 213.3
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 264.3
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Central Anatolian steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 35.2
   }
  ],
  "Central Anatolian steppe and woodlands": [
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 156.7
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 611.6
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1127.6
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 559.9
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2256.0
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 217.6
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 120.5
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3888.0
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1681.5
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3915.7
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 930.6
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 833.0
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 337.4
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 252.7
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 194.6
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 260.7
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 189.3
   },
   {
    "Region Name": "Central Anatolian steppe and woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 86.8
   }
  ],
  "Central Andean dry puna": [
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Central Andean dry puna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 37.7
   }
  ],
  "Central Andean puna": [
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 168.1
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 151.6
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 192.1
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 108.5
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 141.5
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 119.8
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 121.8
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 86.0
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 128.2
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 221.0
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 123.3
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 199.6
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 371.3
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 90.0
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Central Andean puna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 114.7
   }
  ],
  "Central Andean wet puna": [
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 196.8
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 459.4
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 125.2
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 168.1
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 492.6
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 107.0
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 149.4
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 116.8
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 290.5
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 301.6
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 466.0
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 108.0
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1001.1
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 221.9
   },
   {
    "Region Name": "Central Andean wet puna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 91.5
   }
  ],
  "Central Asian northern desert": [
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7036.9
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6089.8
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10721.7
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5679.7
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3195.8
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10383.8
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 776.7
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5159.0
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 803.5
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1260.3
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 933.8
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 719.0
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1359.1
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1930.8
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1010.7
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2932.4
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4293.0
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5416.2
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3118.6
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2207.6
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 665.4
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 950.5
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 661.5
   },
   {
    "Region Name": "Central Asian northern desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 975.6
   }
  ],
  "Central Asian riparian woodlands": [
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 453.8
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3311.8
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2244.7
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1830.9
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3911.2
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1277.2
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1994.5
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2311.5
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 440.7
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2295.2
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3179.1
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3011.5
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1716.7
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3313.5
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 704.8
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1894.8
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2510.5
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5863.2
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5095.8
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5845.6
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2076.8
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1848.1
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1134.0
   },
   {
    "Region Name": "Central Asian riparian woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2446.0
   }
  ],
  "Central Asian southern desert": [
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 344.9
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 454.7
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1211.2
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 934.6
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 388.2
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 195.9
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 162.9
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 362.3
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 123.0
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 228.3
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 385.2
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1686.4
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 322.8
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 237.5
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 179.2
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 290.9
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1362.7
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 800.0
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 258.3
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 191.2
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 140.4
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 133.8
   },
   {
    "Region Name": "Central Asian southern desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 377.9
   }
  ],
  "Central British Columbia Mountain forests": [
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 179.6
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 932.9
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 249.5
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 140.6
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 539.4
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 382.6
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1609.7
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Central British Columbia Mountain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 26.8
   }
  ],
  "Central Canadian Shield forests": [
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3452.4
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1192.5
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1115.6
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1095.9
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 487.9
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 665.0
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1190.6
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2011.2
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 176.4
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4082.4
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 163.3
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 289.4
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 763.8
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11774.4
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 393.6
   },
   {
    "Region Name": "Central Canadian Shield forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 182.0
   }
  ],
  "Central China loess plateau mixed forests": [
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1327.6
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 555.0
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 438.0
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1196.2
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1432.0
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2206.9
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 152.0
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 903.8
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 491.8
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 787.8
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 968.3
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1148.2
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1096.5
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 839.5
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 470.1
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 577.5
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 577.3
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 451.0
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 225.5
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 117.3
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 149.6
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 576.0
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 659.6
   },
   {
    "Region Name": "Central China loess plateau mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 296.3
   }
  ],
  "Central Congolian lowland forests": [
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 772.2
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 931.4
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1929.7
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1555.5
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1717.1
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1306.6
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 903.6
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1502.7
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1874.0
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1727.8
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1411.0
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3792.4
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2261.8
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1903.8
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2179.7
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1672.1
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2095.9
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2354.8
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3219.8
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2516.9
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3222.8
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2050.9
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3468.9
   },
   {
    "Region Name": "Central Congolian lowland forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1898.7
   }
  ],
  "Central Deccan Plateau dry deciduous forests": [
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 545.8
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 731.6
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2513.3
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 702.5
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 667.3
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1470.8
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1985.9
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3684.8
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2024.3
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4114.2
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2853.9
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1883.0
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1692.9
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1335.5
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1026.8
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2676.2
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3895.7
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1305.3
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1468.4
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4730.1
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4697.3
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2252.2
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1325.4
   },
   {
    "Region Name": "Central Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1316.0
   }
  ],
  "Central European mixed forests": [
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5514.4
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2778.7
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1815.5
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3640.6
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2885.6
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3664.6
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6030.2
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7553.9
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2992.4
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3334.9
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3244.3
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3175.9
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7120.1
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6773.4
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3384.5
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2788.3
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4290.0
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5537.6
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4028.2
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 755.9
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2282.4
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 284.9
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1962.3
   },
   {
    "Region Name": "Central European mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1110.0
   }
  ],
  "Central Indochina dry forests": [
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 25291.9
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29046.6
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 31813.9
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27742.3
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 28902.3
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23151.6
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24841.7
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20726.9
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26428.9
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22135.3
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22630.7
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20356.7
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 25235.1
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21723.3
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22485.8
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21557.8
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22767.7
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 22871.2
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 20417.8
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14741.9
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14466.7
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17280.5
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 17748.9
   },
   {
    "Region Name": "Central Indochina dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14237.1
   }
  ],
  "Central Korean deciduous forests": [
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 119.8
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 224.7
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 341.7
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 358.6
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 166.1
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 121.8
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 438.0
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 239.5
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 602.4
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 117.5
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 156.1
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 296.7
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 116.8
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 105.9
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 121.1
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 113.6
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 260.7
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Central Korean deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 973.0
   }
  ],
  "Central Mexican matorral": [
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 311.5
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 108.3
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 164.6
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 129.3
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 444.2
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 263.7
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 175.1
   },
   {
    "Region Name": "Central Mexican matorral",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 447.4
   }
  ],
  "Central Pacific coastal forests": [
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 86.0
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 177.9
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 149.4
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 176.0
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Central Pacific coastal forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 221.0
   }
  ],
  "Central Persian desert basins": [
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 145.1
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 130.1
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 111.7
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 146.4
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 80.0
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 112.5
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 156.3
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Central Persian desert basins",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 65.2
   }
  ],
  "Central Polynesian tropical moist forests": [
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Polynesian tropical moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Central Range montane rain forests": [
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 440.1
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 192.1
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 288.3
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 177.9
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 233.9
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 215.0
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 245.7
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 146.4
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 320.9
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 172.1
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 174.1
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 170.0
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 182.6
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 535.1
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 140.2
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 189.1
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 185.0
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 157.3
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 170.2
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 162.9
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 171.9
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 137.4
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 151.8
   },
   {
    "Region Name": "Central Range montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 104.8
   }
  ],
  "Central Range sub-alpine grasslands": [
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 222.3
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Central Range sub-alpine grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Central Ranges xeric scrub": [
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 74983.1
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 763.4
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4320.4
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 375.4
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2692.3
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4480.7
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 126.3
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 799.0
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1551.8
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 57340.9
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 34024.9
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1515.6
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2221.3
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1288.6
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 565.7
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9682.4
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13484.7
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3549.1
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4183.8
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7915.1
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 28426.0
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2271.5
   },
   {
    "Region Name": "Central Ranges xeric scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2016.1
   }
  ],
  "Central Tibetan Plateau alpine steppe": [
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Central Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Central US hardwood forests": [
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 175.6
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 312.6
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 289.2
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 368.7
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 170.4
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 198.5
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 293.5
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 336.1
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 574.1
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 454.2
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 117.7
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 172.6
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 299.0
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 263.0
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 246.5
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 237.9
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 346.4
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 256.6
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 248.0
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 298.4
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 302.9
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 456.8
   },
   {
    "Region Name": "Central US hardwood forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 451.9
   }
  ],
  "Central Zambezian Miombo woodlands": [
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 344902.1
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 394179.4
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 400634.9
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 405920.3
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 382864.1
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 347739.1
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 377612.3
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 354466.9
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 372264.6
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 363496.5
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 364541.6
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 365710.3
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 345285.0
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 367037.7
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 358089.3
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 359078.8
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 321103.1
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 353198.7
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 328460.5
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 319196.9
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 330434.0
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 306544.7
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 319833.0
   },
   {
    "Region Name": "Central Zambezian Miombo woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 342247.0
   }
  ],
  "Central and Southern Cascades forests": [
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 334.4
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 233.9
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 181.4
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 127.8
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 106.3
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 774.5
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 201.3
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2926.8
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 471.6
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 501.8
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 187.8
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 207.3
   },
   {
    "Region Name": "Central and Southern Cascades forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 211.4
   }
  ],
  "Central and Southern mixed grasslands": [
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 531.2
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2052.6
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1213.3
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1316.0
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 720.7
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3073.0
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1563.0
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 910.0
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 829.4
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2267.6
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 543.4
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 587.4
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 335.9
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 489.8
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1067.6
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1850.6
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1399.0
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 546.2
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 500.6
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 446.1
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1041.2
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 334.0
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 453.2
   },
   {
    "Region Name": "Central and Southern mixed grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 610.5
   }
  ],
  "Central forest-grasslands transition": [
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 289.6
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1291.4
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 580.5
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1631.1
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1092.0
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 349.6
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1213.5
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2232.9
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1064.3
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2325.7
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 573.2
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 345.1
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1480.2
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1140.4
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1366.4
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 591.7
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1592.1
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1036.9
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1974.6
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 878.9
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1258.8
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 566.6
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 921.4
   },
   {
    "Region Name": "Central forest-grasslands transition",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 522.4
   }
  ],
  "Central tall grasslands": [
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 51.9
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 108.5
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 385.6
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 173.9
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 131.4
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 137.0
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 153.1
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 385.2
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 268.2
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 97.3
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 237.3
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 81.9
   },
   {
    "Region Name": "Central tall grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 150.5
   }
  ],
  "Cerrado": [
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 131224.5
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 91601.4
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 114837.7
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 112940.1
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 69905.3
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 239035.6
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 88713.8
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 43482.6
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 234486.5
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 93867.0
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 164668.6
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 63221.5
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 109281.7
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 113617.1
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 92799.5
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 121637.3
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 55308.9
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 111182.9
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 108559.9
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 97683.9
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 77396.4
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 56657.5
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 121525.6
   },
   {
    "Region Name": "Cerrado",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 74446.7
   }
  ],
  "Changbai Mountains mixed forests": [
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 426.6
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 192.7
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 291.1
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 90.0
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 500.1
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 217.2
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 72.7
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 157.1
   },
   {
    "Region Name": "Changbai Mountains mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 75.9
   }
  ],
  "Changjiang Plain evergreen forests": [
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 684.1
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1802.2
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1593.4
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3142.9
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4474.7
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5739.1
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5211.7
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4937.8
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4910.8
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3709.7
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4161.5
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5449.7
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1770.0
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1705.5
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 689.4
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 576.7
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 225.9
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 188.0
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 452.7
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 701.8
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 889.6
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1053.2
   },
   {
    "Region Name": "Changjiang Plain evergreen forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1423.2
   }
  ],
  "Chao Phraya freshwater swamp forests": [
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1742.2
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3161.5
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3042.5
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1323.7
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1609.5
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2479.4
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1339.8
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2727.8
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1627.9
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2317.8
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5255.9
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2118.0
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2558.3
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1369.2
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1456.4
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1459.6
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2910.7
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2050.2
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1160.2
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 558.2
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1285.6
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1250.2
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 724.6
   },
   {
    "Region Name": "Chao Phraya freshwater swamp forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 748.8
   }
  ],
  "Chao Phraya lowland moist deciduous forests": [
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 406.7
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 285.5
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 497.1
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 92.6
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 294.1
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 156.9
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 210.1
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 142.1
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 191.6
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 106.1
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 126.3
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 174.5
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 299.5
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 96.9
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 104.6
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 210.3
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 164.0
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 195.5
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 236.9
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 208.4
   },
   {
    "Region Name": "Chao Phraya lowland moist deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 99.9
   }
  ],
  "Chatham Island temperate forests": [
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Island temperate forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cherskii-Kolyma mountain tundra": [
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 365.7
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1994.9
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 341.3
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 305.5
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 207.7
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 388.0
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 876.6
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 914.3
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 228.7
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 526.3
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 130.6
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 240.1
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 246.7
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 576.7
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1209.0
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1262.0
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1538.5
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 225.7
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1072.1
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1011.8
   },
   {
    "Region Name": "Cherskii-Kolyma mountain tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 275.2
   }
  ],
  "Chhota-Nagpur dry deciduous forests": [
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 580.7
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 408.2
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 498.4
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 208.8
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 152.4
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 520.9
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 300.1
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2030.3
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1095.2
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 183.1
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 517.1
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 232.8
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 411.4
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 301.8
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1001.7
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 645.7
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 202.4
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 536.4
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1654.5
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1319.0
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 180.9
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 148.3
   },
   {
    "Region Name": "Chhota-Nagpur dry deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 814.2
   }
  ],
  "Chiapas Depression dry forests": [
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 867.3
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 852.3
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 897.8
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 791.7
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 603.7
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 649.1
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 638.0
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 835.8
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 451.5
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 372.8
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 322.6
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 819.1
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 357.8
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 678.9
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 651.9
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 709.6
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 559.9
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1172.2
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 726.9
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 849.5
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 874.6
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 999.6
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 974.3
   },
   {
    "Region Name": "Chiapas Depression dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 593.8
   }
  ],
  "Chiapas montane forests": [
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Chiapas montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Chihuahuan desert": [
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 525.0
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 262.8
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 234.5
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 213.3
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 357.1
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 269.7
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1453.4
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1197.3
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 692.6
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4397.8
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 521.3
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 419.1
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 477.2
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 473.8
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 467.3
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 954.6
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1324.4
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 616.7
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 680.0
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 612.2
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 627.9
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 680.8
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 439.0
   },
   {
    "Region Name": "Chihuahuan desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 242.0
   }
  ],
  "Chilean matorral": [
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 174.1
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 592.1
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 447.8
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 655.5
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 180.3
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 368.1
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 425.3
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 498.2
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 444.6
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 402.2
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 478.9
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 386.7
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 612.9
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 782.7
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1394.0
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 308.7
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 360.6
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 559.3
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 445.2
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 790.6
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1116.9
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 627.2
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 418.0
   },
   {
    "Region Name": "Chilean matorral",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 471.8
   }
  ],
  "Chimalapas montane forests": [
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 168.9
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 177.9
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 128.8
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 176.4
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 164.0
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 155.0
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 239.9
   },
   {
    "Region Name": "Chimalapas montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.6
   }
  ],
  "Chin Hills-Arakan Yoma montane forests": [
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1244.2
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3203.1
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4768.6
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1937.5
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2097.0
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4197.6
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2418.9
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3227.3
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3932.2
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2885.2
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2315.2
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2876.2
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2027.7
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2219.6
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1043.1
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 850.8
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1064.1
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 996.2
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2159.1
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2690.3
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1469.7
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2401.6
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3281.6
   },
   {
    "Region Name": "Chin Hills-Arakan Yoma montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9071.0
   }
  ],
  "Chiquitano dry forests": [
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8603.5
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4247.9
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 19358.6
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6339.7
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7741.9
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 17837.2
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6123.2
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3103.6
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18712.5
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5237.9
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3417.0
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2351.0
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2650.0
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3488.6
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5994.2
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2868.0
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4324.7
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10729.8
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8301.2
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6909.1
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7489.8
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4431.9
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 33906.3
   },
   {
    "Region Name": "Chiquitano dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2054.9
   }
  ],
  "Choco-Darien moist forests": [
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 305.9
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 409.4
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 95.8
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Choco-Darien moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.1
   }
  ],
  "Christmas and Cocos Islands tropical forests": [
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christmas and Cocos Islands tropical forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chukchi Peninsula tundra": [
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 132.5
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 413.1
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 280.8
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 220.8
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 200.0
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 110.6
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 281.0
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 362.5
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 615.9
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 187.8
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 150.1
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 182.2
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 374.9
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 341.5
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 243.5
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 971.3
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 368.5
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 195.5
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Chukchi Peninsula tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 129.5
   }
  ],
  "Clipperton Island shrub and grasslands": [
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clipperton Island shrub and grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cocos Island moist forests": [
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cocos Island moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Colorado Plateau shrublands": [
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 727.8
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 425.1
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 289.8
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1017.2
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 475.0
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 272.7
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 127.5
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 141.1
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 217.4
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 342.1
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 159.5
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 249.1
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1081.1
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 166.4
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 143.4
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "Colorado Plateau shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1103.6
   }
  ],
  "Colorado Rockies forests": [
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1733.8
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 110.6
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 96.7
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 304.2
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 118.8
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 793.2
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1047.6
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 716.6
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 498.2
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 152.4
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1349.2
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2103.6
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 444.4
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1754.8
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 90.0
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 332.3
   },
   {
    "Region Name": "Colorado Rockies forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 286.4
   }
  ],
  "Comoros forests": [
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 116.0
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Comoros forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Cook Inlet taiga": [
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 118.3
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 293.0
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 330.6
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Cook Inlet taiga",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cook Islands tropical moist forests": [
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cook Islands tropical moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Coolgardie woodlands": [
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3612.3
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 147.9
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6776.0
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 505.1
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1140.4
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 956.3
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1671.4
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 148.6
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 85.7
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 173.9
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 141.9
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 508.3
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 455.3
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2634.0
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3014.9
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8851.5
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 395.9
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 398.3
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 292.8
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 595.7
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 391.0
   },
   {
    "Region Name": "Coolgardie woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 89.4
   }
  ],
  "Copper Plateau taiga": [
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 207.3
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Copper Plateau taiga",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.4
   }
  ],
  "Cordillera Central paramo": [
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 136.8
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 144.5
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 238.4
   },
   {
    "Region Name": "Cordillera Central paramo",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.2
   }
  ],
  "Cordillera La Costa montane forests": [
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 121.1
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 354.6
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 197.2
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 168.5
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 178.8
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 114.3
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 308.0
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 161.2
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 96.5
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 152.6
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 214.4
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 272.0
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 243.1
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 137.2
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 241.0
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 235.2
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 699.9
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 114.5
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 299.3
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 465.4
   },
   {
    "Region Name": "Cordillera La Costa montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 133.1
   }
  ],
  "Cordillera Oriental montane forests": [
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 474.4
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1323.3
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 174.1
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 304.0
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1079.3
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 508.1
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 239.7
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 385.2
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 127.3
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 147.9
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 209.4
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 340.0
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 320.7
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 324.8
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 509.8
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 455.3
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 445.7
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 378.4
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 574.3
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 216.3
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 136.8
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 186.3
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 219.5
   },
   {
    "Region Name": "Cordillera Oriental montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 135.3
   }
  ],
  "Cordillera de Merida paramo": [
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cordillera de Merida paramo",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Corsican montane broadleaf and mixed forests": [
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corsican montane broadleaf and mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Costa Rican seasonal moist forests": [
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 163.3
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 155.0
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 189.9
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 206.7
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 166.1
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 171.7
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 144.1
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 211.4
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 160.8
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 153.5
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 106.1
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 93.9
   },
   {
    "Region Name": "Costa Rican seasonal moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 57.9
   }
  ],
  "Crete Mediterranean forests": [
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Crete Mediterranean forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.1
   }
  ],
  "Crimean Submediterranean forest complex": [
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 254.9
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 245.0
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 453.2
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 573.4
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 747.7
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 947.1
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 638.0
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 316.8
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1031.1
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 197.2
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 457.9
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 360.8
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 411.8
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 176.4
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 808.4
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 168.3
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 469.0
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 253.4
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 386.3
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 122.6
   },
   {
    "Region Name": "Crimean Submediterranean forest complex",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 198.1
   }
  ],
  "Cross-Niger transition forests": [
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 570.4
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 608.6
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 977.7
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 185.0
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 251.0
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 372.6
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 212.2
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 278.3
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 195.5
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 351.4
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 271.6
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 147.7
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 373.9
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 346.8
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 469.9
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 273.5
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 175.6
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1224.7
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 402.2
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 399.6
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 244.4
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 483.6
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 446.3
   },
   {
    "Region Name": "Cross-Niger transition forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 156.5
   }
  ],
  "Cross-Sanaga-Bioko coastal forests": [
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 727.4
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1303.8
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1560.6
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 485.1
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 596.2
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1358.9
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 246.5
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 634.1
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 582.7
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 468.0
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 645.5
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 558.9
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1007.3
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1551.8
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 991.9
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 536.4
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 466.9
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2842.3
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1066.5
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 851.9
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 659.2
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 716.6
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 894.1
   },
   {
    "Region Name": "Cross-Sanaga-Bioko coastal forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 320.5
   }
  ],
  "Cuban cactus scrub": [
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Cuban cactus scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.2
   }
  ],
  "Cuban dry forests": [
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1056.8
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1942.6
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2855.4
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1650.4
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2174.3
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1533.6
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1292.4
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2281.5
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 960.6
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1354.8
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1097.6
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 749.2
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 724.6
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1006.9
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 798.5
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 635.4
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 628.3
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 609.9
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1665.9
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1089.0
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1842.7
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 849.1
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2273.8
   },
   {
    "Region Name": "Cuban dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1382.5
   }
  ],
  "Cuban moist forests": [
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 290.3
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 457.0
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 691.3
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 350.7
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 592.9
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 367.4
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 323.3
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 599.4
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 217.8
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 514.5
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 228.3
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 224.9
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 217.2
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 390.4
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 267.7
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 235.6
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 154.3
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 177.9
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 467.5
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 267.3
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 530.1
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 399.8
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 319.2
   },
   {
    "Region Name": "Cuban moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 531.0
   }
  ],
  "Cuban pine forests": [
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Cuban pine forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 68.8
   }
  ],
  "Cuban wetlands": [
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 245.0
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 248.7
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 704.8
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 529.9
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 453.8
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 424.7
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 281.5
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 407.7
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 286.0
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 408.6
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 214.4
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 270.7
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 255.7
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 271.2
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 272.9
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 302.7
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 132.3
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 161.8
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 359.5
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 354.1
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 421.7
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 210.3
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 394.4
   },
   {
    "Region Name": "Cuban wetlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 379.9
   }
  ],
  "Cyprus Mediterranean forests": [
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Cyprus Mediterranean forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 138.1
   }
  ],
  "Da Hinggan-Dzhagdy Mountains conifer forests": [
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7948.8
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11431.0
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 355.0
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 875.5
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1392.5
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2470.0
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17191.8
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 418.4
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1503.4
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5331.1
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4752.6
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6277.6
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3042.3
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3233.8
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2775.0
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1795.3
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9619.4
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 279.8
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1044.6
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 213.7
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 597.0
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1028.5
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7757.6
   },
   {
    "Region Name": "Da Hinggan-Dzhagdy Mountains conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 125.2
   }
  ],
  "Daba Mountains evergreen forests": [
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Daba Mountains evergreen forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 37.9
   }
  ],
  "Daurian forest steppe": [
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4851.6
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18586.0
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1555.0
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5048.8
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8704.0
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14395.3
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9747.6
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1207.5
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1906.6
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8036.7
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6134.6
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4975.9
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 24803.6
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17312.7
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2757.2
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2641.5
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4496.0
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7791.2
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2676.0
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 201.7
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2151.6
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4459.3
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4550.2
   },
   {
    "Region Name": "Daurian forest steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3340.5
   }
  ],
  "Davis Highlands tundra": [
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davis Highlands tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Deccan thorn scrub forests": [
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 123.0
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 271.2
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 926.3
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 518.8
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 627.7
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 737.6
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 921.4
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 756.9
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1110.4
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1852.1
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 582.0
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 596.2
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 919.6
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 333.6
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 805.4
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 946.2
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1108.5
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 727.8
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1779.9
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2659.2
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3920.0
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1234.1
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1884.7
   },
   {
    "Region Name": "Deccan thorn scrub forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2264.0
   }
  ],
  "Dinaric Mountains mixed forests": [
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 585.4
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 335.3
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 290.0
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 631.1
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 142.6
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 133.1
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 583.3
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 410.7
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 193.6
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 137.6
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 106.3
   },
   {
    "Region Name": "Dinaric Mountains mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 58.7
   }
  ],
  "Drakensberg alti-montane grasslands and woodlands": [
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 651.3
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 982.9
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 650.4
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 636.0
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 621.7
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 923.9
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 486.4
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 767.4
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 638.0
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 868.8
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 815.9
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 498.2
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 438.6
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 766.6
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 605.4
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 383.7
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 327.8
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 423.2
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 464.1
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 806.2
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 474.8
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 499.5
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 564.2
   },
   {
    "Region Name": "Drakensberg alti-montane grasslands and woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 358.9
   }
  ],
  "Drakensberg montane grasslands woodlands and forests": [
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17419.8
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14727.4
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12042.8
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18650.1
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14972.0
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 20076.9
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14830.0
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15855.8
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15407.3
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15076.8
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14497.6
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16999.2
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15257.1
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9205.6
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6958.8
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11242.6
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10596.0
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12825.1
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11724.7
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15781.0
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9455.6
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14693.5
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20452.7
   },
   {
    "Region Name": "Drakensberg montane grasslands woodlands and forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8659.9
   }
  ],
  "Dry Chaco": [
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 26657.2
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 25451.4
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21303.8
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16341.6
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16573.5
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 26036.0
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22627.7
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19521.3
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16587.0
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17890.8
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14295.6
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18706.9
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11508.2
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13953.3
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15403.9
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22869.1
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12702.9
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23442.1
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 23900.9
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18681.8
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11565.0
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12051.2
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12610.5
   },
   {
    "Region Name": "Dry Chaco",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6804.9
   }
  ],
  "East Afghan montane conifer forests": [
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "East Afghan montane conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.0
   }
  ],
  "East African halophytics": [
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "East African halophytics",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "East African mangroves": [
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1180.7
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1245.5
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1008.2
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1558.9
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1463.7
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1355.2
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1296.9
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1332.7
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1194.7
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1179.9
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1352.9
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1141.5
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 839.3
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1133.6
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1144.3
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 823.2
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1182.0
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1340.4
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1402.4
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1217.0
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 937.0
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 807.7
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1222.1
   },
   {
    "Region Name": "East African mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 842.5
   }
  ],
  "East African montane forests": [
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2391.7
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2346.7
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2526.3
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3641.9
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1833.1
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3510.3
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2883.0
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1533.0
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3074.5
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3235.5
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2622.4
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2581.4
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2697.8
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3229.0
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3009.1
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2938.8
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2734.5
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1313.0
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2237.8
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2185.3
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2704.7
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1962.8
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2354.8
   },
   {
    "Region Name": "East African montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1849.4
   }
  ],
  "East African montane moorlands": [
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 120.5
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 143.2
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 117.3
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 243.3
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 151.8
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 167.4
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 123.7
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "East African montane moorlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 29.2
   }
  ],
  "East Central Texas forests": [
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 193.6
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "East Central Texas forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 34.7
   }
  ],
  "East Deccan dry-evergreen forests": [
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "East Deccan dry-evergreen forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.9
   }
  ],
  "East European forest steppe": [
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23626.7
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5238.7
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15639.3
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20353.1
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16781.9
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13887.7
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 34318.8
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 33016.7
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10106.2
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4947.9
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2728.3
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5303.1
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14624.5
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8186.8
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4195.6
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5592.5
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5091.9
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11517.4
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4681.8
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2309.8
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1020.4
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1534.9
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3048.5
   },
   {
    "Region Name": "East European forest steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1863.7
   }
  ],
  "East Saharan montane xeric woodlands": [
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 82.7
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 78.0
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 128.8
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "East Saharan montane xeric woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 42.4
   }
  ],
  "East Siberian taiga": [
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 43436.1
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 57501.7
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5476.5
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12770.6
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19844.6
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5997.6
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 28816.6
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9782.5
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5067.0
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 33450.1
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 43923.1
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 29556.6
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 62602.0
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21589.5
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 36523.3
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 29252.4
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 41872.3
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 44109.2
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 35695.7
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 75172.6
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13865.6
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16169.9
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 43636.7
   },
   {
    "Region Name": "East Siberian taiga",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16268.5
   }
  ],
  "East Sudanian savanna": [
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 420032.9
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 388044.5
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 409755.2
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 414024.4
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 399176.9
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 392353.8
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 367747.9
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 357153.3
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 345546.3
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 366069.2
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 326877.4
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 319524.1
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 311185.3
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 337239.1
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 335925.9
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 307066.9
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 314659.4
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 271465.1
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 304912.0
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 292756.2
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 276740.1
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 269806.1
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 269399.9
   },
   {
    "Region Name": "East Sudanian savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 246848.5
   }
  ],
  "Eastern Anatolian deciduous forests": [
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1054.1
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 328.2
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 395.7
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 554.1
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 543.2
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 853.4
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 144.1
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2490.3
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1533.2
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1338.7
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 296.5
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1173.0
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 708.7
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2435.4
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1937.3
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 711.7
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 462.0
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 609.2
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 540.6
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 329.5
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 188.0
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 507.6
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1283.6
   },
   {
    "Region Name": "Eastern Anatolian deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 180.5
   }
  ],
  "Eastern Anatolian montane steppe": [
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 159.5
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 105.0
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 239.7
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 159.9
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 175.1
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 224.2
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 93.0
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 135.1
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1315.4
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 232.4
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 123.3
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 154.6
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 362.5
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 235.8
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 235.2
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 329.3
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 351.1
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 183.1
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 122.4
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 176.0
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 429.4
   },
   {
    "Region Name": "Eastern Anatolian montane steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 297.1
   }
  ],
  "Eastern Arc forests": [
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1360.0
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3888.9
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1222.8
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4125.7
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 284.3
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2674.0
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1686.7
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3253.0
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3329.8
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1229.2
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2645.3
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1448.5
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 855.8
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2255.8
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1817.2
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 353.3
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1139.8
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 459.2
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1418.7
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1814.4
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1608.0
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 730.6
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1543.9
   },
   {
    "Region Name": "Eastern Arc forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1154.4
   }
  ],
  "Eastern Australia mulga shrublands": [
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 342.1
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 179.2
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 271.4
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 231.3
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 315.6
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 204.9
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 470.3
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1702.1
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3209.3
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 191.9
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 93.0
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 228.1
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 143.6
   },
   {
    "Region Name": "Eastern Australia mulga shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 178.4
   }
  ],
  "Eastern Australian temperate forests": [
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8822.8
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1525.7
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3889.7
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1801.6
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3208.7
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 843.1
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 851.0
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3856.7
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 332.3
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4885.9
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4292.1
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4407.0
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1035.8
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1216.1
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2984.0
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1411.0
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2932.1
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 29934.7
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1606.9
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 571.9
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 821.2
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3241.5
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 768.5
   },
   {
    "Region Name": "Eastern Australian temperate forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1763.0
   }
  ],
  "Eastern Canadian Shield taiga": [
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5159.0
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 610.3
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2394.9
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 126.3
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 569.1
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 575.2
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 201.5
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1474.9
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4302.8
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 464.3
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 231.3
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 165.3
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 261.7
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 459.8
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 138.7
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 26780.5
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1100.8
   },
   {
    "Region Name": "Eastern Canadian Shield taiga",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 35.8
   }
  ],
  "Eastern Canadian forests": [
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3008.0
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 148.8
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3130.2
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 503.1
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1876.4
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 266.5
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 296.0
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6814.8
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 172.1
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 489.8
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 194.6
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2344.6
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1214.8
   },
   {
    "Region Name": "Eastern Canadian forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 149.4
   }
  ],
  "Eastern Cascades forests": [
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 374.3
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 329.1
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 173.9
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 152.4
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 264.7
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 135.9
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 595.5
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 186.9
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 471.2
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 265.6
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 412.7
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 432.0
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 129.5
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 849.3
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2925.9
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 413.1
   },
   {
    "Region Name": "Eastern Cascades forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 171.9
   }
  ],
  "Eastern Congolian swamp forests": [
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 221.0
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 303.5
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 426.0
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 385.4
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 205.6
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 290.3
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 278.9
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 140.0
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 303.1
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 659.4
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 234.1
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 731.2
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 183.5
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 494.8
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 254.5
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 260.0
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 449.7
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 308.0
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 376.0
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 857.7
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 481.5
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 342.3
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 937.9
   },
   {
    "Region Name": "Eastern Congolian swamp forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 313.0
   }
  ],
  "Eastern Cordillera real montane forests": [
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 111.5
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 297.8
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 206.4
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 184.6
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 149.0
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 107.6
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 189.5
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 239.9
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 205.6
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 398.7
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 289.8
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 335.1
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 278.5
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 356.9
   },
   {
    "Region Name": "Eastern Cordillera real montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 25.1
   }
  ],
  "Eastern Gobi desert steppe": [
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Eastern Gobi desert steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.8
   }
  ],
  "Eastern Great Lakes lowland forests": [
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Eastern Great Lakes lowland forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Eastern Guinean forests": [
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5166.7
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5672.0
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6317.7
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3320.8
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9246.4
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8077.0
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3867.9
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4137.1
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3488.6
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6018.4
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3836.8
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2853.0
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3500.2
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7791.9
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2936.9
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2827.7
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2739.9
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6056.8
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1782.9
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3001.6
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2454.3
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1956.5
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2504.9
   },
   {
    "Region Name": "Eastern Guinean forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1592.5
   }
  ],
  "Eastern Himalayan alpine shrub and meadows": [
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Eastern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.4
   }
  ],
  "Eastern Himalayan broadleaf forests": [
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 144.9
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 118.3
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 218.2
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 214.8
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 180.3
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 167.4
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 199.1
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 195.1
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 246.7
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 115.1
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 234.7
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 186.3
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 190.4
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 126.0
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 132.7
   },
   {
    "Region Name": "Eastern Himalayan broadleaf forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 282.3
   }
  ],
  "Eastern Himalayan subalpine conifer forests": [
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 98.0
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 80.2
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Eastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 85.5
   }
  ],
  "Eastern Java-Bali montane rain forests": [
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 303.5
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 84.0
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 101.6
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 140.4
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 97.8
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 349.9
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 113.4
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 377.5
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 181.6
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Eastern Java-Bali montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Eastern Java-Bali rain forests": [
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 96.7
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "Eastern Java-Bali rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.4
   }
  ],
  "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests": [
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2643.2
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2415.3
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1992.1
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2302.5
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2095.2
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2451.3
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1770.9
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4767.8
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3541.8
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2474.5
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2124.2
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3772.7
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2459.2
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6714.3
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4803.6
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3446.2
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1715.8
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7163.6
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5416.0
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4615.8
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2661.4
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3699.6
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4086.9
   },
   {
    "Region Name": "Eastern Mediterranean conifer-sclerophyllous-broadleaf forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2827.1
   }
  ],
  "Eastern Micronesia tropical moist forests": [
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Micronesia tropical moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Eastern Miombo woodlands": [
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 131004.5
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 161251.1
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 128340.6
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 171330.1
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 131843.2
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 153034.2
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 165077.4
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 157777.9
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 179268.4
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 140605.1
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 161738.2
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 164475.3
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 143705.5
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 151892.0
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 155398.9
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 135039.0
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 135896.9
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 130081.7
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 131376.5
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 128520.6
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 150415.4
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 123904.0
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 118776.1
   },
   {
    "Region Name": "Eastern Miombo woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 118675.5
   }
  ],
  "Eastern Panamanian montane forests": [
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Eastern Panamanian montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Eastern Zimbabwe montane forest-grassland mosaic": [
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 199.1
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 257.2
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 154.1
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 454.9
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 176.2
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 442.9
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 545.4
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 194.4
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 293.9
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 295.8
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 379.4
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 130.8
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 146.2
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 526.5
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 162.7
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 171.9
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 201.7
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 93.5
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 115.5
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 126.0
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 125.0
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 331.4
   },
   {
    "Region Name": "Eastern Zimbabwe montane forest-grassland mosaic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 128.2
   }
  ],
  "Eastern forest-boreal transition": [
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 298.8
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 550.5
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1399.2
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 455.3
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 129.1
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 405.4
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 947.5
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Eastern forest-boreal transition",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Eastern highlands moist deciduous forests": [
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1666.7
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3431.8
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5708.9
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3719.7
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 867.1
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6556.7
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5957.5
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8979.9
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5431.5
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7738.3
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6913.6
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5663.0
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4906.9
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4704.3
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6010.0
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11128.1
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6124.1
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4652.5
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3325.9
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10451.3
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7131.4
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2146.9
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4319.1
   },
   {
    "Region Name": "Eastern highlands moist deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2608.7
   }
  ],
  "Ecuadorian dry forests": [
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 150.3
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 358.4
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 117.0
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 315.6
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 283.8
   },
   {
    "Region Name": "Ecuadorian dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.0
   }
  ],
  "Edwards Plateau savanna": [
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 178.8
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 475.9
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 185.4
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 65.4
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 117.7
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 83.8
   },
   {
    "Region Name": "Edwards Plateau savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 73.7
   }
  ],
  "Einasleigh upland savanna": [
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12206.6
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4240.4
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4130.5
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10987.7
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3307.5
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6883.2
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6144.2
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15244.9
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1516.4
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18364.6
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18321.9
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5481.2
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3961.1
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6137.2
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3117.4
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7996.8
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8088.4
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11550.0
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3618.8
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5563.3
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4422.6
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12179.4
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10192.0
   },
   {
    "Region Name": "Einasleigh upland savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14027.9
   }
  ],
  "Elburz Range forest steppe": [
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Elburz Range forest steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 36.9
   }
  ],
  "Emin Valley steppe": [
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1672.5
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 349.6
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1063.7
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 203.7
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 858.3
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 516.0
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 536.6
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 110.4
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 212.0
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 654.5
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 485.5
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 967.7
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1033.0
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 220.2
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 457.2
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 535.5
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 497.3
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 758.2
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 366.1
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 557.1
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 201.9
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Emin Valley steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 62.4
   }
  ],
  "English Lowlands beech forests": [
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "English Lowlands beech forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Enriquillo wetlands": [
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enriquillo wetlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Eritrean coastal desert": [
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eritrean coastal desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Esperance mallee": [
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6312.7
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 82.7
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3040.4
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 818.2
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1193.0
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1398.1
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 274.8
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4181.1
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 551.8
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 857.9
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1531.0
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3225.6
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 499.5
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1894.4
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3745.5
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9465.5
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 321.6
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 529.3
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1038.0
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 776.0
   },
   {
    "Region Name": "Esperance mallee",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2543.3
   }
  ],
  "Espinal": [
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12644.1
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6633.0
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3232.5
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5395.5
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2443.4
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2415.7
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5419.7
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3525.9
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2591.5
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3815.6
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2068.9
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7800.7
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4355.8
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2945.6
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18376.1
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9804.2
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4603.4
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2625.4
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5173.4
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3810.6
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5398.7
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2503.8
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3342.7
   },
   {
    "Region Name": "Espinal",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4105.8
   }
  ],
  "Ethiopian montane forests": [
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 27650.8
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18494.0
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 26518.9
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24807.6
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16467.6
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23924.9
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17351.9
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17101.9
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19765.5
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 23290.1
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16657.5
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 17357.5
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16155.1
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17231.2
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17792.0
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14877.0
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16124.2
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10742.7
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14475.1
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14158.6
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14027.7
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11220.7
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14462.4
   },
   {
    "Region Name": "Ethiopian montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11777.9
   }
  ],
  "Ethiopian montane grasslands and woodlands": [
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1462.0
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1295.6
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1731.5
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1612.7
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 720.7
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1868.9
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1121.1
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 769.8
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1148.2
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1430.5
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1025.3
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 991.2
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1051.3
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1016.1
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1328.2
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1001.7
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1067.1
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 430.7
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 989.7
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 837.5
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 983.5
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 400.2
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1024.0
   },
   {
    "Region Name": "Ethiopian montane grasslands and woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 645.0
   }
  ],
  "Ethiopian montane moorlands": [
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 92.8
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 188.9
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 147.3
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 96.7
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 99.7
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 266.0
   },
   {
    "Region Name": "Ethiopian montane moorlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 59.0
   }
  ],
  "Ethiopian xeric grasslands and shrublands": [
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 156.9
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 101.6
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 94.5
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 388.9
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 165.5
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 202.6
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 123.3
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 180.5
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 288.1
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 256.8
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 105.3
   },
   {
    "Region Name": "Ethiopian xeric grasslands and shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 591.2
   }
  ],
  "Etosha Pan halophytics": [
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 213.7
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 188.4
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 196.8
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 115.1
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 371.5
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 209.4
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Etosha Pan halophytics",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 105.0
   }
  ],
  "Euxine-Colchic broadleaf forests": [
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 117.3
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 133.6
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Euxine-Colchic broadleaf forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 164.2
   }
  ],
  "Everglades": [
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1124.2
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 924.6
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1442.3
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1142.8
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1568.3
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1507.0
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1508.3
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1154.4
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 904.9
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1174.7
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1135.7
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1142.4
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1249.1
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 671.6
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1055.1
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1200.9
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1329.9
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 772.4
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 980.7
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1377.1
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 994.7
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 698.6
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 990.4
   },
   {
    "Region Name": "Everglades",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1452.6
   }
  ],
  "Eyre and York mallee": [
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 282.5
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1708.5
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 697.1
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 259.4
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 178.1
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 204.3
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 165.1
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 691.8
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 243.5
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 475.7
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 198.3
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 308.9
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 149.2
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 538.3
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 245.7
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Eyre and York mallee",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.1
   }
  ],
  "Faroe Islands boreal grasslands": [
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faroe Islands boreal grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Fernando de Noronha-Atol das Rocas moist forests": [
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fernando de Noronha-Atol das Rocas moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Fiji tropical dry forests": [
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 94.8
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 126.9
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 78.2
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Fiji tropical dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Fiji tropical moist forests": [
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Fiji tropical moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Fiordland temperate forests": [
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiordland temperate forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Flint Hills tall grasslands": [
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 130.3
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2202.0
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1111.5
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2944.1
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1981.0
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 181.6
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3792.4
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4839.0
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2287.3
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4365.4
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 154.6
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4560.9
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1194.7
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4430.1
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1237.6
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1475.3
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3432.7
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4731.3
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1573.0
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3314.1
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2411.2
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1993.2
   },
   {
    "Region Name": "Flint Hills tall grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2479.6
   }
  ],
  "Florida sand pine scrub": [
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 152.8
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 99.9
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 99.7
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 136.3
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 122.4
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 133.8
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 78.2
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "Florida sand pine scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 70.3
   }
  ],
  "Fraser Plateau and Basin complex": [
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 100.8
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 409.4
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 404.5
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 161.4
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 476.5
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 220.8
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 897.8
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2038.0
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 130.6
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 137.6
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1545.8
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 392.1
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 111.7
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7690.5
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5244.1
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 114.7
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1761.9
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2844.7
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 984.6
   },
   {
    "Region Name": "Fraser Plateau and Basin complex",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1205.0
   }
  ],
  "Galapagos Islands scrubland mosaic": [
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galapagos Islands scrubland mosaic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ghorat-Hazarajat alpine meadow": [
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghorat-Hazarajat alpine meadow",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gibson desert": [
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 26435.1
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1347.5
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2129.8
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 816.1
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14573.9
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5028.7
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1123.1
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1134.9
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2664.0
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 46237.0
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1212.0
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4594.8
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 737.4
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 223.6
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9003.7
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 23833.5
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1088.8
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 75.5
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6859.0
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 387.2
   },
   {
    "Region Name": "Gibson desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7134.6
   }
  ],
  "Gissaro-Alai open woodlands": [
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1305.5
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1282.8
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1538.5
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 577.9
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 572.6
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1578.8
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 268.8
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 497.3
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 305.7
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 515.8
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 151.8
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 90.2
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 161.6
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 257.5
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 344.3
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 275.7
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Gissaro-Alai open woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 150.5
   }
  ],
  "Goadavari-Krishna mangroves": [
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Goadavari-Krishna mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.7
   }
  ],
  "Gobi Lakes Valley desert steppe": [
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Gobi Lakes Valley desert steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.2
   }
  ],
  "Granitic Seychelles forests": [
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Granitic Seychelles forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Great Basin montane forests": [
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Great Basin montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Great Basin shrub steppe": [
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 371.1
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 476.8
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 613.3
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3132.8
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4124.7
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4742.9
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 315.1
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 465.0
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 380.9
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1491.8
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2933.6
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 779.2
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 219.3
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 114.0
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1390.8
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3735.2
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2597.9
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 589.1
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1952.0
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 662.8
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 342.6
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 637.7
   },
   {
    "Region Name": "Great Basin shrub steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1317.7
   }
  ],
  "Great Lakes Basin desert steppe": [
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1301.4
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 259.2
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 326.7
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 259.2
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 113.6
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 280.2
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Great Lakes Basin desert steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 31.9
   }
  ],
  "Great Sandy-Tanami desert": [
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 183203.8
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18605.7
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 115312.9
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8348.0
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 128021.6
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 122748.8
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16061.6
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19356.2
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17656.9
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 284937.1
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 180739.0
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21837.3
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 82460.9
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 102080.2
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14580.3
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 174227.8
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 106987.7
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8591.3
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1208.2
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 24371.6
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 32645.0
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 287562.5
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 77914.8
   },
   {
    "Region Name": "Great Sandy-Tanami desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 121418.2
   }
  ],
  "Great Victoria desert": [
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 40159.9
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3513.3
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3770.5
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1933.8
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10800.6
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10020.9
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1444.0
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1319.9
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 443.3
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1968.1
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 56060.3
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2974.8
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4569.7
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2718.6
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1883.9
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9256.0
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30093.5
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12484.6
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1117.1
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 435.0
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 273.5
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6103.5
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 116.4
   },
   {
    "Region Name": "Great Victoria desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1004.7
   }
  ],
  "Greater Negros-Panay rain forests": [
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 153.1
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 142.3
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 133.6
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 62.6
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 96.7
   },
   {
    "Region Name": "Greater Negros-Panay rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.9
   }
  ],
  "Guajira-Barranquilla xeric scrub": [
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 148.8
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 259.0
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 94.8
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 214.4
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 100.8
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 128.4
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 162.1
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 107.4
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Guajira-Barranquilla xeric scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 36.7
   }
  ],
  "Guayaquil flooded grasslands": [
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Guayaquil flooded grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Guianan Highlands moist forests": [
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 344.3
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 565.9
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 126.3
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 233.9
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 526.7
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 215.7
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 177.3
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 571.1
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 274.6
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 169.4
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 248.7
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 226.6
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 492.8
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 221.0
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 192.9
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 267.5
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 551.6
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 277.4
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 134.8
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 464.5
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 629.2
   },
   {
    "Region Name": "Guianan Highlands moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 152.8
   }
  ],
  "Guianan freshwater swamp forests": [
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 162.3
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 93.5
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 93.5
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 130.3
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 142.6
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 179.2
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "Guianan freshwater swamp forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.0
   }
  ],
  "Guianan moist forests": [
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 863.0
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1557.0
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 513.0
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 695.8
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 613.3
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 373.0
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 443.1
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1296.5
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 615.5
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 224.0
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 622.1
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 473.8
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 731.9
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1390.0
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 648.3
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 389.1
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 708.1
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1044.2
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1123.9
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 176.4
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 155.4
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1933.6
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1853.6
   },
   {
    "Region Name": "Guianan moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 687.5
   }
  ],
  "Guianan piedmont and lowland moist forests": [
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 568.5
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1414.8
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 323.5
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 322.4
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 789.9
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 432.2
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 319.0
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 974.3
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 668.8
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 203.9
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 286.8
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 473.8
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 490.0
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 862.6
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 434.3
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 582.0
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 648.7
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1342.6
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 643.8
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 324.3
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 212.0
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 835.4
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2799.0
   },
   {
    "Region Name": "Guianan piedmont and lowland moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 272.7
   }
  ],
  "Guianan savanna": [
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5127.1
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5195.7
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4784.5
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2762.1
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5578.3
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2301.7
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2955.9
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5520.6
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1958.9
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3250.3
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3695.7
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2866.5
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5536.1
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4917.8
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2870.2
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5983.3
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4267.9
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7099.5
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2738.8
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2457.5
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1803.7
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9053.7
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4694.0
   },
   {
    "Region Name": "Guianan savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3508.1
   }
  ],
  "Guinean forest-savanna mosaic": [
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 131232.2
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 132164.9
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 178360.2
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 110955.7
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 157656.0
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 125424.3
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 90237.8
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 105171.6
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 103058.1
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 110403.7
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 101011.5
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 100858.5
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 95810.1
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 114703.3
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 83320.1
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 88359.9
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 74720.9
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 90098.9
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 71329.6
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 91177.4
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 58649.2
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 75710.2
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 70740.3
   },
   {
    "Region Name": "Guinean forest-savanna mosaic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 57837.2
   }
  ],
  "Guinean mangroves": [
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1172.2
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2394.7
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2624.7
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1542.0
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2756.8
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1861.2
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1299.9
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1901.9
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1307.7
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1683.9
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1491.8
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1263.1
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1796.8
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1724.8
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1320.5
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1214.4
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1480.9
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1167.0
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1018.5
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 878.5
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1011.6
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 946.4
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1132.5
   },
   {
    "Region Name": "Guinean mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 568.1
   }
  ],
  "Guinean montane forests": [
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6485.1
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5605.3
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4251.6
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4775.9
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6935.3
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4781.9
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4683.1
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6308.9
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4934.1
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5601.5
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5229.3
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5799.1
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4336.0
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7963.2
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4032.9
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5763.3
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3498.5
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5095.6
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4208.3
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3797.1
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3574.2
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4275.2
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4246.9
   },
   {
    "Region Name": "Guinean montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2476.4
   }
  ],
  "Guizhou Plateau broadleaf and mixed forests": [
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 329.1
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 88.5
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 123.7
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 168.7
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 357.6
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1587.8
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 563.8
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 147.7
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 572.8
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 261.3
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Guizhou Plateau broadleaf and mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 32.4
   }
  ],
  "Gulf of California xeric scrub": [
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of California xeric scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Gulf of Oman desert and semi-desert": [
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of Oman desert and semi-desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Gulf of St Lawrence lowland forests": [
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Gulf of St Lawrence lowland forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16.1
   }
  ],
  "Gurupa varzea": [
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 87.9
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 740.9
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 206.0
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 96.0
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 217.2
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 219.5
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 140.0
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 320.3
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 656.4
   },
   {
    "Region Name": "Gurupa varzea",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 53.6
   }
  ],
  "Hainan Island monsoon rain forests": [
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Hainan Island monsoon rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.9
   }
  ],
  "Halmahera rain forests": [
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 345.1
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 262.8
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halmahera rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hawaii tropical dry forests": [
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 88.7
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 173.4
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.1
   }
  ],
  "Hawaii tropical high shrublands": [
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical high shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hawaii tropical low shrublands": [
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical low shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hawaii tropical moist forests": [
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii tropical moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Helanshan montane conifer forests": [
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 135.9
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 72.7
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Helanshan montane conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hengduan Mountains subalpine conifer forests": [
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 106.1
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 219.9
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 270.3
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 98.0
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 326.3
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 603.4
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 294.5
   },
   {
    "Region Name": "Hengduan Mountains subalpine conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.6
   }
  ],
  "High Arctic tundra": [
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "High Arctic tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "High Monte": [
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 691.6
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 697.3
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 257.5
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 194.2
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 129.5
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 332.5
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1090.1
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 163.8
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 92.8
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 119.8
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 108.0
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 188.6
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 118.3
   },
   {
    "Region Name": "High Monte",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 57.7
   }
  ],
  "Highveld grasslands": [
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10667.6
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9226.7
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6072.0
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10172.7
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8028.8
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6170.2
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7969.8
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5834.7
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9577.4
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10426.1
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6728.6
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6971.1
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7570.7
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5849.7
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1945.6
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6653.2
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7473.8
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5458.0
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8251.3
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9122.3
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5175.3
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10861.2
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8787.8
   },
   {
    "Region Name": "Highveld grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3545.9
   }
  ],
  "Himalayan subtropical broadleaf forests": [
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 433.9
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 659.0
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 487.5
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 250.4
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 381.8
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 528.2
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 857.7
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 336.3
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 698.6
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1098.9
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 597.4
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 86.6
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1780.8
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 632.2
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 408.4
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 953.7
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 129.9
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1104.2
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 373.4
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1300.1
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1889.9
   },
   {
    "Region Name": "Himalayan subtropical broadleaf forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 584.6
   }
  ],
  "Himalayan subtropical pine forests": [
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 321.6
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1486.6
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 916.2
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1145.8
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 201.9
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 635.4
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1162.5
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2060.9
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 963.4
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 185.2
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2347.3
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 303.5
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1703.2
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 354.4
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3594.1
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 254.0
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1506.2
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2089.9
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 118.5
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2119.9
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1930.4
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 820.4
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3653.3
   },
   {
    "Region Name": "Himalayan subtropical pine forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 347.5
   }
  ],
  "Hindu Kush alpine meadow": [
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hindu Kush alpine meadow",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hispaniolan dry forests": [
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Hispaniolan dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 28.9
   }
  ],
  "Hispaniolan moist forests": [
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 161.6
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 203.2
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 161.2
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 153.5
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 229.2
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 138.9
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 99.9
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 122.0
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 130.8
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "Hispaniolan moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 54.0
   }
  ],
  "Hispaniolan pine forests": [
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 421.4
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 56.0
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 93.7
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 126.9
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 129.5
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 148.1
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Hispaniolan pine forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 66.5
   }
  ],
  "Hobyo grasslands and shrublands": [
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hobyo grasslands and shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Hokkaido deciduous forests": [
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hokkaido montane conifer forests": [
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido montane conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Honshu alpine conifer forests": [
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Honshu alpine conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Huang He Plain mixed forests": [
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6194.4
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6919.6
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8482.6
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17631.4
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 27904.8
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 20466.7
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3487.1
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12957.3
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22498.9
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14542.4
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 35775.6
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16990.9
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14168.7
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8727.8
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1558.2
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2932.4
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 595.5
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 714.1
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 518.1
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 759.3
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 950.3
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1913.9
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1878.1
   },
   {
    "Region Name": "Huang He Plain mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1426.0
   }
  ],
  "Humid Chaco": [
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17757.5
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 42869.7
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25954.1
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27433.2
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 24227.6
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 33578.8
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 29258.2
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15914.1
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13908.3
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 30957.2
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18929.6
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18948.5
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7029.2
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11234.4
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14227.7
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31526.6
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18570.4
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15622.6
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 49761.5
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 41869.1
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13428.5
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17318.2
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18543.3
   },
   {
    "Region Name": "Humid Chaco",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10100.2
   }
  ],
  "Humid Pampas": [
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 625.7
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 970.2
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1498.0
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 855.1
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1175.4
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 572.8
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2143.0
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 356.7
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 257.5
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 855.3
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 293.5
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 992.5
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 242.0
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 410.7
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 648.7
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 778.4
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 543.6
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 404.1
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1250.8
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 676.8
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 934.4
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 477.8
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 312.6
   },
   {
    "Region Name": "Humid Pampas",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 400.7
   }
  ],
  "Huon Peninsula montane rain forests": [
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 334.4
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 260.9
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 335.5
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 187.6
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 204.1
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 226.6
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 195.7
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 148.3
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 256.8
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 127.3
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 165.7
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 196.8
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 289.2
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 168.9
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 129.3
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 170.4
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 120.7
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 92.8
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Huon Peninsula montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 37.5
   }
  ],
  "Iberian conifer forests": [
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 203.0
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 51.9
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Iberian conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 62.4
   }
  ],
  "Iberian sclerophyllous and semi-deciduous forests": [
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 642.0
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1238.6
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 829.2
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 388.2
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 154.8
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 296.3
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 88.3
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 289.0
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 309.3
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 163.3
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 463.9
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 577.7
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 123.7
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 368.3
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 277.6
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 424.2
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 148.8
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 303.5
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 258.7
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1151.2
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 199.4
   },
   {
    "Region Name": "Iberian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1063.9
   }
  ],
  "Iceland boreal birch forests and alpine tundra": [
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Iceland boreal birch forests and alpine tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ile Europa and Bassas da India xeric scrub": [
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ile Europa and Bassas da India xeric scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Illyrian deciduous forests": [
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 430.9
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 91.7
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1243.6
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 247.4
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 113.0
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 634.7
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 563.6
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 141.3
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 102.0
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 966.2
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 201.9
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 484.7
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 231.3
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 387.4
   },
   {
    "Region Name": "Illyrian deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 631.1
   }
  ],
  "Indochina mangroves": [
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 158.0
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 339.3
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 161.6
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 433.9
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 197.2
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 318.1
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 438.2
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 439.2
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 214.2
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 159.5
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 390.8
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 123.3
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 176.9
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 267.5
   },
   {
    "Region Name": "Indochina mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 116.2
   }
  ],
  "Indus River Delta-Arabian Sea mangroves": [
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Indus River Delta-Arabian Sea mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 35.8
   }
  ],
  "Indus Valley desert": [
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Indus Valley desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30.9
   }
  ],
  "Inner Niger Delta flooded savanna": [
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2478.1
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1176.7
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3615.1
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2097.4
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2913.3
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3228.0
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2768.6
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2694.0
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1860.1
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3003.7
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1150.5
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2436.5
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1965.1
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1454.7
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2291.2
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2597.3
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1786.8
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2111.3
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2769.2
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3999.9
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2285.2
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3349.9
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2936.6
   },
   {
    "Region Name": "Inner Niger Delta flooded savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4088.0
   }
  ],
  "Interior Alaska-Yukon lowland taiga": [
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4658.0
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1111.1
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12735.2
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11062.5
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 206.9
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 615.2
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 149.0
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5505.6
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1412.7
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 553.7
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1529.1
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10192.8
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 723.3
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2191.7
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 537.4
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4954.9
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 413.7
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3890.4
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1982.5
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1090.5
   },
   {
    "Region Name": "Interior Alaska-Yukon lowland taiga",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2324.2
   }
  ],
  "Interior Yukon-Alaska alpine tundra": [
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 438.2
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 523.3
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14174.9
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3396.7
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 188.4
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 203.7
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1190.4
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 210.7
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1107.0
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1581.6
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 206.4
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 417.6
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 317.1
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2045.7
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 603.9
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1671.0
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 788.2
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1188.2
   },
   {
    "Region Name": "Interior Yukon-Alaska alpine tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1475.9
   }
  ],
  "Iquitos varzea": [
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 293.5
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 406.7
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 166.4
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1808.2
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 186.1
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 410.5
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 128.2
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 137.2
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 442.0
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 152.6
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 138.7
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 106.1
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 147.9
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 363.8
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 140.6
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 125.0
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 194.4
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 224.0
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 393.6
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 220.2
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 636.5
   },
   {
    "Region Name": "Iquitos varzea",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 37.1
   }
  ],
  "Irrawaddy dry forests": [
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 448.9
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1371.1
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1656.2
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 457.7
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 970.4
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 993.6
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 905.5
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 547.3
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 638.2
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 557.8
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 353.5
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 460.5
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 556.5
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 655.1
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 591.0
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 899.5
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 620.2
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 721.1
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 997.0
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 532.9
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 578.2
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 552.4
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 582.7
   },
   {
    "Region Name": "Irrawaddy dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 714.3
   }
  ],
  "Irrawaddy freshwater swamp forests": [
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 226.2
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 355.9
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 353.3
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 286.0
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 345.6
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 207.1
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 154.8
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 339.3
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 282.5
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 140.6
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 163.3
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 363.4
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 299.5
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 427.5
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 403.9
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 538.1
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 201.1
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 366.1
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 273.5
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 268.2
   },
   {
    "Region Name": "Irrawaddy freshwater swamp forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 58.5
   }
  ],
  "Irrawaddy moist deciduous forests": [
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3613.4
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13812.4
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15074.0
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4322.3
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7615.0
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9755.3
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13182.8
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7926.9
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10984.7
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11046.9
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7738.3
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5989.7
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7620.4
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9568.4
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5472.6
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6996.6
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5970.2
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5681.4
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10882.9
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5361.8
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8699.1
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4462.3
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9045.1
   },
   {
    "Region Name": "Irrawaddy moist deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14875.9
   }
  ],
  "Islas Revillagigedo dry forests": [
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Revillagigedo dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Isthmian-Atlantic moist forests": [
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 981.6
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 185.6
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 99.0
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 280.0
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 334.4
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 144.3
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 355.0
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 199.4
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 155.4
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Isthmian-Atlantic moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Isthmian-Pacific moist forests": [
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 211.2
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 585.9
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 213.1
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 176.0
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 122.6
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 126.7
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 90.0
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 391.9
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 196.4
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 186.1
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Isthmian-Pacific moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Italian sclerophyllous and semi-deciduous forests": [
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 445.2
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 199.8
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 495.4
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 280.6
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 404.9
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 507.0
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 93.5
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 138.3
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 105.0
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 88.7
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 155.2
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Italian sclerophyllous and semi-deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 69.9
   }
  ],
  "Itigi-Sumbu thicket": [
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1871.4
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2209.5
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2233.9
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2341.3
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2238.0
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2009.5
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2115.0
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2313.9
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2252.8
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2146.5
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1906.6
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2332.1
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2041.7
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2368.8
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2316.7
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2322.7
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1844.6
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2414.9
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2227.9
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2283.7
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2223.4
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2042.3
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2234.8
   },
   {
    "Region Name": "Itigi-Sumbu thicket",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2116.3
   }
  ],
  "Jalisco dry forests": [
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 442.2
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 403.4
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 342.8
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 925.9
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 221.2
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 309.5
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 435.2
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 339.8
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 206.4
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 226.8
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 234.3
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 463.9
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 120.7
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 262.4
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 811.6
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 571.9
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 292.2
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 412.7
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 412.0
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 426.2
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 291.3
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 335.9
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 786.3
   },
   {
    "Region Name": "Jalisco dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 330.1
   }
  ],
  "Jamaican dry forests": [
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jamaican dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Jamaican moist forests": [
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Jamaican moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.4
   }
  ],
  "Japura-Solimoes-Negro moist forests": [
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 109.3
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 530.8
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 320.9
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 252.5
   },
   {
    "Region Name": "Japura-Solimoes-Negro moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.8
   }
  ],
  "Jarrah-Karri forest and shrublands": [
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 278.5
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 580.7
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 255.3
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 141.1
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 225.3
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 139.1
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 125.0
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 390.8
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 316.2
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 902.1
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 114.5
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1087.1
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 362.5
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 261.3
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 304.2
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 230.0
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 186.5
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 195.7
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 380.5
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 199.1
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 501.8
   },
   {
    "Region Name": "Jarrah-Karri forest and shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 220.8
   }
  ],
  "Jian Nan subtropical evergreen forests": [
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1220.0
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4895.1
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2157.8
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1409.9
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1555.7
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4399.3
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6053.6
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1695.2
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1410.8
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 738.3
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 394.7
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1877.2
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 520.7
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 665.4
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 171.3
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 363.8
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 101.6
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 361.6
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 284.5
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1074.2
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 180.3
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 203.4
   },
   {
    "Region Name": "Jian Nan subtropical evergreen forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 180.3
   }
  ],
  "Jos Plateau forest-grassland mosaic": [
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1487.7
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1368.3
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1158.7
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1469.7
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1505.5
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 881.5
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1062.0
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 902.3
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1143.4
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1330.8
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 852.8
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 694.6
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 967.7
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 835.2
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 538.3
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 476.3
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 682.3
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 391.7
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 376.4
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 216.3
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 459.2
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 240.5
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 382.6
   },
   {
    "Region Name": "Jos Plateau forest-grassland mosaic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 301.2
   }
  ],
  "Juan Fernandez Islands temperate forests": [
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juan Fernandez Islands temperate forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Junggar Basin semi-desert": [
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 808.8
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 587.6
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 435.4
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 325.4
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 453.8
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 501.0
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1380.8
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 65.4
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 141.7
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 469.5
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 470.5
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 239.9
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 867.1
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 425.5
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 505.1
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 320.5
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 242.0
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 339.8
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 313.0
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 349.6
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 265.2
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Junggar Basin semi-desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 351.8
   }
  ],
  "Juru-Purus moist forests": [
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Juru-Purus moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.1
   }
  ],
  "Kalaallit Nunaat high arctic tundra": [
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat high arctic tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kalaallit Nunaat low arctic tundra": [
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalaallit Nunaat low arctic tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kalahari Acacia-Baikiaea woodlands": [
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 35123.9
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15662.0
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 19033.2
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20135.3
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35278.9
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 31067.4
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 61822.5
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 34540.6
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 90666.5
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 108843.9
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 61161.6
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 40242.8
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 24163.0
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15375.2
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11185.1
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24576.1
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15769.6
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8084.5
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 20141.3
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 30104.5
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 33219.5
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 48599.4
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11305.2
   },
   {
    "Region Name": "Kalahari Acacia-Baikiaea woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15109.8
   }
  ],
  "Kalahari xeric savanna": [
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 46312.1
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4604.2
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1642.1
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13714.5
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13664.1
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13673.7
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 41960.8
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6292.8
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 52141.0
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 84316.0
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 29506.8
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10921.2
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5930.7
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5416.5
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 808.6
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 17283.3
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11941.4
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 814.4
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19945.3
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 77103.4
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 48548.8
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 65963.1
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9959.4
   },
   {
    "Region Name": "Kalahari xeric savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8189.8
   }
  ],
  "Kamchatka Mountain tundra and forest tundra": [
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 147.7
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Kamchatka Mountain tundra and forest tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.5
   }
  ],
  "Kamchatka-Kurile meadows and sparse forests": [
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 229.2
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 244.2
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 169.1
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1738.7
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Kamchatka-Kurile meadows and sparse forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Kamchatka-Kurile taiga": [
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 123.7
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 132.9
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kamchatka-Kurile taiga",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kaokoveld desert": [
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Kaokoveld desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Karakoram-West Tibetan Plateau alpine steppe": [
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karakoram-West Tibetan Plateau alpine steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Kayah-Karen montane rain forests": [
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4832.1
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13292.6
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23004.2
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5666.8
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15012.5
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16519.1
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18381.1
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13700.1
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10029.9
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11072.2
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14367.7
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6679.3
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19008.7
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15672.3
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12828.3
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10801.8
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12398.5
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17806.3
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15418.1
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8635.2
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8758.3
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8689.2
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10128.7
   },
   {
    "Region Name": "Kayah-Karen montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3821.1
   }
  ],
  "Kazakh forest steppe": [
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4624.2
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9382.7
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13676.3
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7591.7
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13491.7
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6891.5
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24028.4
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8293.9
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10750.8
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6081.2
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9964.1
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 957.2
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7796.8
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1806.7
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1731.2
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3285.6
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2769.6
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5015.2
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3703.4
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8275.7
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15239.5
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4840.0
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 411.8
   },
   {
    "Region Name": "Kazakh forest steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1546.9
   }
  ],
  "Kazakh semi-desert": [
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 80090.4
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 23111.6
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 55344.5
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 57282.6
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 48660.7
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13695.2
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 20627.9
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11962.0
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36341.1
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4367.6
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9028.4
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3515.9
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16312.8
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20678.7
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7328.0
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 67661.7
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12126.0
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 27917.9
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10872.4
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20720.7
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3100.4
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1618.9
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 848.9
   },
   {
    "Region Name": "Kazakh semi-desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 601.3
   }
  ],
  "Kazakh steppe": [
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 98520.3
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 55817.6
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 46471.3
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 44343.3
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 55709.8
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30501.5
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 65669.4
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 22016.1
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 69285.3
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6638.2
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 36784.6
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3980.6
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28188.7
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31733.3
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13276.3
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 44779.1
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10791.3
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 37571.8
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19759.0
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20613.7
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8062.4
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6026.6
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1824.5
   },
   {
    "Region Name": "Kazakh steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10869.6
   }
  ],
  "Kazakh upland": [
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9187.6
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3030.5
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2632.5
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4175.3
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6838.6
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2139.0
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3533.7
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 383.3
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 513.2
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3389.0
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1158.2
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 125.6
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 536.8
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8031.3
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 132.9
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1297.8
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 699.7
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4389.2
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 597.9
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 719.9
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1283.2
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Kazakh upland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 33.7
   }
  ],
  "Kermadec Islands subtropical moist forests": [
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kermadec Islands subtropical moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Khangai Mountains alpine meadow": [
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2131.0
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Khangai Mountains alpine meadow",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Khangai Mountains conifer forests": [
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1059.2
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khangai Mountains conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Khathiar-Gir dry deciduous forests": [
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 115.8
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 903.4
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 364.4
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 278.3
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 893.7
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1087.5
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 571.7
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 621.0
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1707.9
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2218.9
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2007.8
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2350.1
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1796.0
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2041.0
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4418.8
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2152.3
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4068.7
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7022.7
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4056.7
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4093.6
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3414.3
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3625.0
   },
   {
    "Region Name": "Khathiar-Gir dry deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5930.3
   }
  ],
  "Kimberly tropical savanna": [
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 90383.8
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 94911.2
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 129382.8
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 89899.5
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 119518.9
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 124507.2
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 113900.7
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 100689.8
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 53323.6
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 97093.1
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 139997.3
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 98804.2
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 102794.2
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 106648.8
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 80978.3
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 74131.8
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 144785.9
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 83145.6
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 37319.1
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 78523.6
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 89553.1
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 123351.4
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 58842.4
   },
   {
    "Region Name": "Kimberly tropical savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 120691.5
   }
  ],
  "Kinabalu montane alpine meadows": [
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kinabalu montane alpine meadows",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Klamath-Siskiyou forests": [
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1709.8
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 518.3
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1322.0
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 84.0
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 395.1
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 337.2
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 702.5
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 765.1
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 125.8
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1354.0
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2245.3
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4058.2
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2101.9
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 473.5
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 561.4
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 130.6
   },
   {
    "Region Name": "Klamath-Siskiyou forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 259.8
   }
  ],
  "Knysna-Amatole montane forests": [
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 89.6
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 183.9
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 80.0
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Knysna-Amatole montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.9
   }
  ],
  "Kola Peninsula tundra": [
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Kola Peninsula tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kopet Dag semi-desert": [
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 266.5
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 182.9
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 112.5
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 155.0
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 226.2
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 134.8
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 149.0
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 184.1
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 417.4
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Kopet Dag semi-desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 112.8
   }
  ],
  "Kopet Dag woodlands and forest steppe": [
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 288.1
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 848.5
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 467.8
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 326.1
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 395.3
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 219.1
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 129.5
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 135.3
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 628.1
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 158.4
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 161.4
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 353.5
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 113.4
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 165.7
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 291.3
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 107.2
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 553.9
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 160.1
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 240.5
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Kopet Dag woodlands and forest steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 79.5
   }
  ],
  "Kuh Rud and Eastern Iran montane woodlands": [
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 141.3
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 629.0
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 150.9
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 384.6
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 84.0
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kuh Rud and Eastern Iran montane woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.9
   }
  ],
  "KwaZulu-Cape coastal forest mosaic": [
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 384.6
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 382.9
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 412.2
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 577.7
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 446.7
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 706.3
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 442.5
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 803.0
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 511.1
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 165.9
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 467.1
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 575.4
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 541.7
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 264.7
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 195.7
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 152.0
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 222.5
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 420.6
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 410.1
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 269.0
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 148.6
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 228.5
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 586.7
   },
   {
    "Region Name": "KwaZulu-Cape coastal forest mosaic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 137.4
   }
  ],
  "La Costa xeric shrublands": [
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1429.6
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2127.0
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1363.8
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2450.7
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2250.4
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1418.9
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1701.9
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2438.4
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 954.6
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 906.1
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1150.9
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1483.0
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1511.5
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1894.2
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1127.2
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2021.3
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2574.6
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2937.3
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3304.7
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1900.4
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1444.0
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3115.4
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2732.8
   },
   {
    "Region Name": "La Costa xeric shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2316.5
   }
  ],
  "Lake Chad flooded savanna": [
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 748.8
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1751.4
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1705.7
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1986.8
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1343.5
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1499.1
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1220.4
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 940.9
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1253.0
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 659.4
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1388.7
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 792.5
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 392.1
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1546.9
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2999.9
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2170.3
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2397.3
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 998.5
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1155.0
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1889.4
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1221.0
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 955.9
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1389.5
   },
   {
    "Region Name": "Lake Chad flooded savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1456.0
   }
  ],
  "Lara-Falcon dry forests": [
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 134.4
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Lara-Falcon dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.3
   }
  ],
  "Leeward Islands moist forests": [
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leeward Islands moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lesser Antillean dry forests": [
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lesser Antillean dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lesser Sundas deciduous forests": [
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 304.4
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 274.0
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 317.3
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 437.7
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 341.7
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 242.2
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 210.1
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 202.6
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 232.6
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 271.6
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 463.0
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 257.7
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 133.1
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 294.8
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 243.5
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 594.2
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 176.0
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 155.2
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 96.0
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 331.4
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 143.2
   },
   {
    "Region Name": "Lesser Sundas deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 60.2
   }
  ],
  "Llanos": [
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 43967.5
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 52522.8
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 30545.4
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 43584.6
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 54251.2
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 36697.0
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 35375.8
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 49705.1
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 28351.6
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 23865.3
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 33397.6
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 40357.8
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 31543.1
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 42317.9
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25619.5
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 39109.7
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 41483.0
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 43812.5
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 44582.3
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 39615.0
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 37000.9
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 51261.4
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 43980.6
   },
   {
    "Region Name": "Llanos",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 31386.6
   }
  ],
  "Lord Howe Island subtropical forests": [
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lord Howe Island subtropical forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Louisiade Archipelago rain forests": [
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louisiade Archipelago rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Low Arctic tundra": [
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 93.0
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 105.5
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 143.6
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Low Arctic tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 42.0
   }
  ],
  "Low Monte": [
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8944.8
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5021.8
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2652.8
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1060.3
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 339.3
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 275.5
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 957.4
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 579.0
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 226.8
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 213.5
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 434.1
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2598.2
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1414.8
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 630.0
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9235.2
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4944.4
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1163.8
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 819.1
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 396.2
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1039.3
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1443.3
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 483.4
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 577.9
   },
   {
    "Region Name": "Low Monte",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 698.0
   }
  ],
  "Lower Gangetic Plains moist deciduous forests": [
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 125.2
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 362.3
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 295.2
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 415.4
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 980.5
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 379.6
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1019.8
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1222.1
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 959.9
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 428.1
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 812.5
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1206.9
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1193.0
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 355.2
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 419.3
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 501.0
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1535.3
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 667.3
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1451.9
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 955.2
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1471.2
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 845.3
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2230.1
   },
   {
    "Region Name": "Lower Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1135.5
   }
  ],
  "Lowland fynbos and renosterveld": [
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 873.8
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1320.3
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 414.4
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 676.1
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1121.6
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 505.1
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 866.5
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1778.8
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 385.4
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 825.5
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 660.3
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 783.1
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 469.7
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 805.2
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 700.8
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 589.1
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 433.5
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 430.2
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 364.2
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1622.1
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 844.6
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 435.0
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 842.7
   },
   {
    "Region Name": "Lowland fynbos and renosterveld",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1976.5
   }
  ],
  "Luang Prabang montane rain forests": [
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2655.6
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2972.0
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7319.8
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3613.2
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3617.5
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5612.6
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1980.6
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3219.2
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6791.0
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 913.9
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2763.2
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4240.9
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3083.1
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2663.5
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3459.5
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1337.2
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1444.0
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2588.1
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3806.1
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 700.6
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1236.7
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5544.7
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2313.0
   },
   {
    "Region Name": "Luang Prabang montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 592.1
   }
  ],
  "Luzon montane rain forests": [
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Luzon montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.7
   }
  ],
  "Luzon rain forests": [
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 909.6
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 806.0
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 839.7
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 574.3
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 925.4
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 383.7
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 579.2
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 586.5
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 766.2
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 571.7
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 544.5
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 551.8
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 720.3
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 540.0
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 733.6
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 447.2
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 597.9
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 595.7
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 414.4
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 596.6
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 478.7
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 651.3
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 474.6
   },
   {
    "Region Name": "Luzon rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 375.4
   }
  ],
  "Luzon tropical pine forests": [
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 115.8
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 152.0
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "Luzon tropical pine forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Madagascar dry deciduous forests": [
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7406.0
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8986.6
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6278.0
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11222.9
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8704.9
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8656.4
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6486.8
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7693.1
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9621.5
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6855.7
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7463.5
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9072.1
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7116.4
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6623.4
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9753.6
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7602.2
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7438.6
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7433.7
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9865.9
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7220.8
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7420.8
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5913.4
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8554.4
   },
   {
    "Region Name": "Madagascar dry deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7821.5
   }
  ],
  "Madagascar ericoid thickets": [
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Madagascar ericoid thickets",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 26.4
   }
  ],
  "Madagascar lowland forests": [
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 707.2
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1902.7
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1213.8
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2779.7
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1267.1
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2484.8
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1007.1
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2112.6
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3441.3
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3247.0
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2376.5
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1792.8
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1352.9
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3126.1
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3600.8
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1383.8
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1457.9
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1160.2
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1486.4
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1833.5
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2814.5
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1496.1
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3391.3
   },
   {
    "Region Name": "Madagascar lowland forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 316.4
   }
  ],
  "Madagascar mangroves": [
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 121.5
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 65.4
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 96.9
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 141.5
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 95.8
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Madagascar mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 50.8
   }
  ],
  "Madagascar spiny thickets": [
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1950.8
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1933.0
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1591.0
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2211.6
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1216.8
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2508.5
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1132.7
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 926.1
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 517.5
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 995.1
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1320.9
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1380.1
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 981.8
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1450.0
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1889.4
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1197.3
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 621.2
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1168.1
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 881.1
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 730.1
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 301.4
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1050.8
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1011.4
   },
   {
    "Region Name": "Madagascar spiny thickets",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 647.8
   }
  ],
  "Madagascar subhumid forests": [
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18338.6
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 40322.6
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21285.3
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 37135.4
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25085.9
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 36590.4
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22646.6
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 28645.1
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 25499.2
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25849.5
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27075.9
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 22021.7
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20314.5
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20124.5
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 26692.2
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 17321.7
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20275.9
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 21944.3
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 20200.2
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17857.2
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17973.6
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17797.6
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23024.5
   },
   {
    "Region Name": "Madagascar subhumid forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18769.7
   }
  ],
  "Madagascar succulent woodlands": [
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5816.9
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7790.8
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5260.0
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6564.8
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4281.6
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8921.6
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5345.3
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5448.6
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3550.6
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4964.1
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4750.4
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5670.5
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3511.4
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3541.6
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7170.6
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4114.4
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2743.5
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3673.4
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4753.2
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2767.5
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1673.8
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2747.4
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3760.0
   },
   {
    "Region Name": "Madagascar succulent woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3688.9
   }
  ],
  "Madeira evergreen forests": [
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Madeira evergreen forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Madeira-Tapajos moist forests": [
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11413.0
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9026.4
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13655.5
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19569.5
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10344.2
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13738.1
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5828.1
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3351.0
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17832.7
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8116.7
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5350.2
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2504.0
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4976.1
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7798.5
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7824.9
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8330.8
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5056.8
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9522.7
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14338.9
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10250.3
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12216.0
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12341.9
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 30801.2
   },
   {
    "Region Name": "Madeira-Tapajos moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3646.0
   }
  ],
  "Magdalena Valley dry forests": [
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 108.5
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 280.6
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 169.4
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 141.7
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 94.8
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 109.5
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 110.6
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 403.7
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 251.9
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 277.6
   },
   {
    "Region Name": "Magdalena Valley dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 34.5
   }
  ],
  "Magdalena Valley montane forests": [
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 141.9
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 191.9
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 138.3
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 121.1
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 142.6
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 303.5
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Magdalena Valley montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.6
   }
  ],
  "Magdalena-Uraba moist forests": [
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 466.3
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 517.1
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 219.9
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 300.5
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 134.6
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 176.2
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 161.4
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 174.3
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 193.6
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 199.6
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 779.9
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 495.2
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 159.1
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 100.8
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 158.0
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 293.3
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Magdalena-Uraba moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.4
   }
  ],
  "Magellanic subpolar forests": [
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 149.8
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 213.5
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 158.8
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Magellanic subpolar forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.0
   }
  ],
  "Malabar Coast moist forests": [
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Malabar Coast moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests": [
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldives-Lakshadweep-Chagos Archipelago tropical moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Malpelo Island xeric scrub": [
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malpelo Island xeric scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Manchurian mixed forests": [
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10255.2
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 23004.2
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3389.8
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4876.3
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9303.0
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5121.9
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24010.8
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5074.3
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1773.3
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8953.1
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5602.3
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4256.9
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9845.1
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5503.9
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8867.2
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7183.3
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18426.9
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3396.9
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3745.0
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4065.9
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5092.3
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7900.1
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9205.9
   },
   {
    "Region Name": "Manchurian mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3934.7
   }
  ],
  "Mandara Plateau mosaic": [
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1544.5
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1247.2
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1336.6
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1643.6
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1363.2
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 864.3
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 988.5
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 816.1
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 656.0
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 780.5
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 476.8
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 473.8
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 400.7
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 549.9
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 520.3
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 322.0
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 277.8
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 372.4
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 418.7
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 320.9
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 258.7
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 304.6
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 345.8
   },
   {
    "Region Name": "Mandara Plateau mosaic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 355.9
   }
  ],
  "Maputaland coastal forest mosaic": [
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2953.8
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2166.0
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3891.4
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4300.9
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2185.5
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4367.3
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2851.8
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3098.7
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3917.6
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4096.4
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3999.9
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3878.4
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4006.8
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3213.4
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 624.7
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1909.0
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2674.0
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2718.2
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1955.5
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2274.2
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1779.7
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1537.0
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1860.9
   },
   {
    "Region Name": "Maputaland coastal forest mosaic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1414.6
   }
  ],
  "Maputaland-Pondoland bushland and thickets": [
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 806.2
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1149.0
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 492.8
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1175.8
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 890.1
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1889.4
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1348.4
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1367.7
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1364.0
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 434.3
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1035.4
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1899.5
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1135.9
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 403.9
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 344.1
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 416.7
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 486.8
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 748.1
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 992.1
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1137.9
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 443.3
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1219.1
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2109.0
   },
   {
    "Region Name": "Maputaland-Pondoland bushland and thickets",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 525.4
   }
  ],
  "Maracaibo dry forests": [
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 408.6
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 661.3
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 132.5
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 178.1
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 170.9
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 265.8
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 173.9
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 194.4
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 199.8
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 314.1
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 271.8
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 367.6
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 306.8
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1212.0
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 837.8
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1025.3
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 618.2
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 134.8
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 350.5
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 632.4
   },
   {
    "Region Name": "Maracaibo dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 260.2
   }
  ],
  "Marajo varzea": [
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1384.6
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1332.7
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1853.0
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1133.8
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 861.1
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 720.7
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 978.4
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1541.5
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 364.0
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1090.1
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1736.0
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 765.1
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1339.6
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1816.1
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 986.7
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1202.2
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 416.7
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 490.3
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 476.1
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 114.7
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 389.3
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1663.5
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1502.9
   },
   {
    "Region Name": "Marajo varzea",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 434.7
   }
  ],
  "Maranhao Babacu forests": [
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3402.5
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3497.9
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3710.1
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6651.4
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1345.2
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8882.8
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2119.5
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2019.4
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4523.2
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1481.7
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8343.2
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1210.3
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3048.8
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9194.1
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6116.6
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5362.0
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1955.3
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3016.2
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1984.8
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1191.0
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1833.1
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2541.6
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2492.7
   },
   {
    "Region Name": "Maranhao Babacu forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3041.5
   }
  ],
  "Maranon dry forests": [
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Maranon dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.8
   }
  ],
  "Marianas tropical dry forests": [
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marianas tropical dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Marielandia Antarctic tundra": [
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marielandia Antarctic tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Marquesas tropical moist forests": [
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marquesas tropical moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Masai xeric grasslands and shrublands": [
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 81.9
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 255.7
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 545.6
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 174.7
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 689.4
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1171.3
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 203.4
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 346.6
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 142.3
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 119.8
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 675.7
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 170.2
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1200.9
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 195.3
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 74.2
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1888.6
   },
   {
    "Region Name": "Masai xeric grasslands and shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 755.2
   }
  ],
  "Mascarene forests": [
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mascarene forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mato Grosso seasonal forests": [
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21954.8
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15325.0
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22438.4
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19978.3
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13336.8
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 41302.3
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12699.6
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6939.8
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 35030.5
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9709.0
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16378.6
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9364.5
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15328.7
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17707.3
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16370.1
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 23835.9
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9197.3
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16365.1
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 20001.3
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9432.2
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16122.3
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9882.0
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 17344.2
   },
   {
    "Region Name": "Mato Grosso seasonal forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6311.5
   }
  ],
  "Maudlandia Antarctic desert": [
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maudlandia Antarctic desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mediterranean High Atlas juniper steppe": [
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean High Atlas juniper steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mediterranean acacia-argania dry woodlands and succulent thickets": [
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean acacia-argania dry woodlands and succulent thickets",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mediterranean conifer and mixed forests": [
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 107.4
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 177.5
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 140.0
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 398.5
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 173.9
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 118.5
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 280.8
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 486.4
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 123.9
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 266.9
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 189.7
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 303.3
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 424.7
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 321.6
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Mediterranean conifer and mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 36.7
   }
  ],
  "Mediterranean dry woodlands and steppe": [
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 208.4
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 128.6
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 134.6
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mediterranean dry woodlands and steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mediterranean woodlands and forests": [
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 400.7
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 791.9
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1147.5
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1003.5
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 449.7
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1577.5
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 832.4
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1026.8
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 630.0
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 454.2
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2445.1
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 476.3
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1247.0
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 541.5
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 493.3
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1187.0
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 94.8
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 629.8
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1076.3
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1241.0
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 855.8
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 392.3
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Mediterranean woodlands and forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 175.4
   }
  ],
  "Meghalaya subtropical forests": [
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 82.7
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 275.2
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 872.1
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 392.1
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 735.7
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 413.7
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 352.0
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1150.3
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1926.7
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 747.5
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1214.0
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1072.9
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1026.4
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1003.9
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 552.9
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 615.0
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 407.3
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 457.2
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1000.2
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 664.1
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 370.6
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 424.2
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 519.0
   },
   {
    "Region Name": "Meghalaya subtropical forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1889.4
   }
  ],
  "Mentawai Islands rain forests": [
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mentawai Islands rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Meseta Central matorral": [
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 129.1
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 383.9
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 103.3
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 164.4
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 114.5
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 108.9
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 491.1
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 235.8
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 175.6
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 349.9
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 214.4
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 92.4
   },
   {
    "Region Name": "Meseta Central matorral",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 320.1
   }
  ],
  "Mesoamerican Gulf-Caribbean mangroves": [
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 293.7
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 691.8
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 259.2
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 650.8
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 331.6
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 584.2
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 284.9
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 626.0
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 278.7
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 490.0
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 254.2
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 323.5
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 215.2
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 311.0
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 596.8
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 298.6
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 450.0
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 556.7
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 394.2
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 283.4
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 205.6
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 994.9
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 764.9
   },
   {
    "Region Name": "Mesoamerican Gulf-Caribbean mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 526.3
   }
  ],
  "Mesopotamian shrub desert": [
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 88.3
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 200.2
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 288.1
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 392.3
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 269.7
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 937.4
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 360.4
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6398.3
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2746.5
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 210.3
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 692.4
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1444.2
   },
   {
    "Region Name": "Mesopotamian shrub desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 220.8
   }
  ],
  "Mid-Continental Canadian forests": [
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3899.2
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1292.6
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 507.0
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 617.6
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2095.9
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1710.2
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1033.0
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 455.1
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 606.7
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4369.5
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1740.0
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 404.9
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1434.3
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9846.8
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3520.8
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1124.2
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 379.9
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2181.8
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 199.1
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2547.1
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 722.0
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11926.8
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3920.2
   },
   {
    "Region Name": "Mid-Continental Canadian forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9733.9
   }
  ],
  "Middle Arctic tundra": [
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Arctic tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.6
   }
  ],
  "Middle Atlantic coastal forests": [
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 204.1
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 205.8
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 487.5
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 353.7
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 471.8
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 400.9
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 689.6
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 332.3
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 400.0
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 714.9
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 620.8
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 436.2
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 300.8
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 256.8
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 434.3
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 438.4
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 259.4
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 280.6
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 246.5
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 422.7
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 452.5
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 383.1
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 184.1
   },
   {
    "Region Name": "Middle Atlantic coastal forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 81.9
   }
  ],
  "Middle East steppe": [
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 688.6
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 734.9
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 290.0
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 185.9
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 171.7
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 254.9
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 168.3
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 873.1
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 348.8
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 271.0
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 481.7
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 482.3
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1815.1
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1243.8
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 762.9
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 219.5
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10651.8
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4542.9
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 319.4
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 214.2
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 741.5
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2448.7
   },
   {
    "Region Name": "Middle East steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 254.0
   }
  ],
  "Midwestern Canadian Shield forests": [
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4969.3
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5577.5
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2424.5
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1861.8
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10139.7
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3173.3
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6632.6
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14296.1
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5669.2
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3480.1
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5099.0
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2816.4
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9685.8
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2087.5
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4308.0
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2297.6
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3164.1
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17852.7
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2209.1
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7222.5
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8085.6
   },
   {
    "Region Name": "Midwestern Canadian Shield forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19203.6
   }
  ],
  "Mindanao montane rain forests": [
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Mindanao montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mindanao-Eastern Visayas rain forests": [
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 115.5
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 142.6
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 119.6
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 175.4
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 186.1
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 76.5
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 127.5
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Mindanao-Eastern Visayas rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.8
   }
  ],
  "Mindoro rain forests": [
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 229.4
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 183.1
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 135.9
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 191.4
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 190.8
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 104.6
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 84.0
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 113.0
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 162.1
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 121.1
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 128.0
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 195.7
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 200.0
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 113.8
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 91.7
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 228.9
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "Mindoro rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 111.7
   }
  ],
  "Miskito pine forests": [
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 380.9
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3637.2
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1650.0
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3098.3
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2088.2
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 711.5
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2132.3
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1730.0
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2183.6
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1502.9
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1183.1
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2019.8
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3574.8
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 703.3
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2190.2
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 419.1
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2384.2
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1989.1
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3823.5
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1107.6
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 841.2
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6348.3
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3451.6
   },
   {
    "Region Name": "Miskito pine forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1434.1
   }
  ],
  "Mississippi lowland forests": [
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 788.9
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2680.0
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3356.6
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2285.8
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1973.9
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2833.5
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2598.6
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1289.9
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4414.7
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4017.5
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1011.4
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1845.5
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1831.6
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6205.1
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2924.6
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2302.3
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1346.2
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4287.0
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2411.9
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3095.3
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3521.4
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3487.8
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2895.9
   },
   {
    "Region Name": "Mississippi lowland forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1699.1
   }
  ],
  "Mitchell grass downs": [
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6829.6
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3355.3
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9412.5
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1692.4
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9113.3
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5794.6
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3686.3
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6036.0
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4700.5
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 40939.8
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19564.6
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2238.7
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1764.5
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3324.9
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 588.0
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3828.0
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1353.7
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2173.7
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1829.2
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3346.7
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2008.6
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17876.0
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 37949.1
   },
   {
    "Region Name": "Mitchell grass downs",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4838.1
   }
  ],
  "Mizoram-Manipur-Kachin rain forests": [
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 989.3
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2950.8
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4740.8
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2753.6
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5974.2
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6471.6
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6125.4
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8302.7
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9896.3
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5097.5
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4878.0
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5959.2
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6382.6
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4367.3
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1527.8
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 799.0
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1314.7
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1670.1
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4142.5
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4810.2
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2212.5
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6144.7
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3303.6
   },
   {
    "Region Name": "Mizoram-Manipur-Kachin rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16495.1
   }
  ],
  "Mojave desert": [
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1423.6
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 301.2
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 87.5
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 364.0
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 339.8
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Mojave desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 46.1
   }
  ],
  "Mongolian-Manchurian grassland": [
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1763.8
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18755.4
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13600.0
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10908.0
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8001.5
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8757.0
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1752.3
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2636.1
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3474.9
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17020.7
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17586.6
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7722.9
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21004.3
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20533.5
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14003.0
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12173.2
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6759.3
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5972.3
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4003.8
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2278.3
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8219.1
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23088.8
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8266.7
   },
   {
    "Region Name": "Mongolian-Manchurian grassland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3859.1
   }
  ],
  "Montana Valley and Foothill grasslands": [
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 585.9
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 317.1
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 236.9
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 380.9
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 99.7
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 142.1
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 89.8
   },
   {
    "Region Name": "Montana Valley and Foothill grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 56.0
   }
  ],
  "Montane fynbos and renosterveld": [
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2139.6
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1122.7
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 782.9
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2993.4
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 596.8
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 937.2
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1599.4
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3081.3
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 662.0
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1806.1
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1169.4
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 666.7
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1698.0
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2467.8
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3178.0
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3205.2
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2422.2
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 545.1
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 548.6
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 713.6
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 502.5
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1057.3
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 880.8
   },
   {
    "Region Name": "Montane fynbos and renosterveld",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3101.9
   }
  ],
  "Monte Alegre varzea": [
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 188.2
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 155.4
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 290.9
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 388.7
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 98.4
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 159.1
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 150.3
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 254.9
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 116.4
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 111.5
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 362.5
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 148.3
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 183.3
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 144.3
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 252.7
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 217.4
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 283.4
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 639.9
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 887.1
   },
   {
    "Region Name": "Monte Alegre varzea",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 55.3
   }
  ],
  "Motagua Valley thornscrub": [
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Motagua Valley thornscrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.3
   }
  ],
  "Mount Cameroon and Bioko montane forests": [
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Mount Cameroon and Bioko montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.4
   }
  ],
  "Mount Lofty woodlands": [
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 146.8
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 397.9
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 105.0
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 110.2
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 830.5
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 94.5
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 250.2
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 383.9
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 213.7
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2159.1
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Mount Lofty woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 57.2
   }
  ],
  "Murray-Darling woodlands and mallee": [
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2836.7
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 92.8
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1354.8
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 914.1
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2016.1
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 309.3
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 637.5
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 402.4
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 311.7
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 830.9
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 433.5
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3539.0
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 831.1
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 117.7
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 183.1
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1161.0
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 721.8
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 307.8
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 281.0
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 832.6
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 122.0
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 638.8
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1810.3
   },
   {
    "Region Name": "Murray-Darling woodlands and mallee",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 996.6
   }
  ],
  "Muskwa-Slave Lake forests": [
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 996.6
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3465.1
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 618.5
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 157.3
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 227.2
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 188.2
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 281.7
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4519.5
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1617.4
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4909.1
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3452.8
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 142.6
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 305.7
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 413.3
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1090.9
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 119.4
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 339.3
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 959.3
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 32246.5
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14480.6
   },
   {
    "Region Name": "Muskwa-Slave Lake forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4218.4
   }
  ],
  "Myanmar Coast mangroves": [
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 440.7
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 353.5
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 164.8
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 405.8
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 303.5
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 291.5
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 497.1
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 416.9
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 285.3
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 342.6
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 476.1
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 404.1
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 341.9
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 520.1
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 319.0
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 337.6
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 337.2
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 237.7
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 220.2
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 498.0
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 285.3
   },
   {
    "Region Name": "Myanmar Coast mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 306.1
   }
  ],
  "Myanmar coastal rain forests": [
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 406.7
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 765.9
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1730.6
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 875.7
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1361.2
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1468.2
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1181.0
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1446.3
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1163.4
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 781.4
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 859.6
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 974.1
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1316.2
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 948.2
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 695.2
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 577.9
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 826.4
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1165.5
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1216.1
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 680.0
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 680.4
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1164.0
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 988.9
   },
   {
    "Region Name": "Myanmar coastal rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 511.1
   }
  ],
  "Nama Karoo": [
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 627.9
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 895.2
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 559.3
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 652.1
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 486.4
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 427.2
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 813.5
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 316.4
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 632.4
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1014.6
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 548.1
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 959.9
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 663.9
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 550.1
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 625.3
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 807.3
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 805.4
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 426.2
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 677.2
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2862.9
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1519.4
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1227.9
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 629.4
   },
   {
    "Region Name": "Nama Karoo",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 415.7
   }
  ],
  "Namib desert": [
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 192.7
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namib desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.2
   }
  ],
  "Namibian savanna woodlands": [
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1076.3
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 663.0
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1353.7
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1274.6
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11017.3
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 140.2
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 154.3
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3605.0
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1648.7
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6977.3
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3945.7
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 379.0
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1176.7
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 127.3
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1819.3
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3329.6
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 261.5
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 273.5
   },
   {
    "Region Name": "Namibian savanna woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5004.0
   }
  ],
  "Nansei Islands subtropical evergreen forests": [
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nansei Islands subtropical evergreen forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Napo moist forests": [
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 780.3
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 122.0
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 260.0
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 177.9
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 683.0
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 126.9
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Napo moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.7
   }
  ],
  "Naracoorte woodlands": [
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 197.6
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 122.6
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 219.1
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 252.5
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 250.2
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 344.7
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 145.8
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Naracoorte woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 41.6
   }
  ],
  "Narmada Valley dry deciduous forests": [
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 412.2
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 619.1
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2122.7
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1046.1
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 346.6
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2084.3
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3995.8
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4088.9
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3274.1
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4832.1
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5022.7
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1594.3
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1567.7
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1323.1
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2743.9
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5565.4
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4730.1
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4315.9
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4023.5
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6805.1
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6603.0
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1959.8
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2299.8
   },
   {
    "Region Name": "Narmada Valley dry deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4437.7
   }
  ],
  "Nebraska Sand Hills mixed grasslands": [
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 596.8
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 138.3
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 91.3
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 99.9
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 216.5
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Nebraska Sand Hills mixed grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 149.0
   }
  ],
  "Negro-Branco moist forests": [
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 850.2
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1475.3
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 367.4
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 805.0
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1451.1
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 683.4
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 553.5
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 787.6
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 611.0
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 341.5
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 620.6
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 950.3
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 213.7
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1321.6
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 348.3
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1037.1
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 550.9
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 453.8
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 501.8
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1111.1
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 528.0
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 525.6
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 277.0
   },
   {
    "Region Name": "Negro-Branco moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 400.9
   }
  ],
  "Nelson Coast temperate forests": [
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson Coast temperate forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nenjiang River grassland": [
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 169.1
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 232.8
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 157.6
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 133.8
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 144.7
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 396.2
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 506.1
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 537.9
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1463.3
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1917.7
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 249.3
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2023.9
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4127.9
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 247.8
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1707.2
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 595.1
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1247.0
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1446.8
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2410.4
   },
   {
    "Region Name": "Nenjiang River grassland",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1324.2
   }
  ],
  "New Britain-New Ireland lowland rain forests": [
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 88.7
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "New Britain-New Ireland lowland rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "New Britain-New Ireland montane rain forests": [
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Britain-New Ireland montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "New Caledonia dry forests": [
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "New Caledonia dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "New Caledonia rain forests": [
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 139.6
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "New Caledonia rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "New England-Acadian forests": [
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 90.0
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 206.0
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "New England-Acadian forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 86.8
   }
  ],
  "New Guinea mangroves": [
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 628.1
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 204.7
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 576.9
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 130.1
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 411.4
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 130.1
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 112.5
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 137.2
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 254.9
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 449.7
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 758.2
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 326.9
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 356.1
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 124.5
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 220.6
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "New Guinea mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 17.6
   }
  ],
  "Newfoundland Highland forests": [
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland Highland forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nicobar Islands rain forests": [
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicobar Islands rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Niger Delta swamp forests": [
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 463.3
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 113.6
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 374.1
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 245.9
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 238.6
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 198.9
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 781.4
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 140.8
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 481.7
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 208.4
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 491.1
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 270.3
   },
   {
    "Region Name": "Niger Delta swamp forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Nigerian lowland forests": [
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3387.5
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2190.0
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2804.8
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 240.7
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2265.9
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2985.1
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1059.2
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 800.9
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1486.0
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1138.7
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1248.9
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 774.3
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1125.2
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4015.6
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3407.6
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1830.9
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1575.6
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8053.4
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2204.1
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4800.2
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4553.0
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3393.9
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2465.7
   },
   {
    "Region Name": "Nigerian lowland forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1219.8
   }
  ],
  "Nihonkai evergreen forests": [
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai evergreen forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Nihonkai montane deciduous forests": [
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nihonkai montane deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 21.0
   }
  ],
  "Nile Delta flooded savanna": [
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 104.2
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 212.0
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 179.4
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 683.0
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 665.8
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 302.3
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 336.1
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 382.0
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 318.3
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 383.9
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 974.7
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 715.8
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 436.9
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 637.1
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 275.2
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 403.7
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Nile Delta flooded savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.6
   }
  ],
  "Norfolk Island subtropical forests": [
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norfolk Island subtropical forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "North Atlantic moist mixed forests": [
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 80.0
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Atlantic moist mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.6
   }
  ],
  "North Central Rockies forests": [
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 165.1
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2779.5
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 247.2
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 360.4
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 382.0
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1877.0
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 206.9
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 247.4
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 140.2
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 168.5
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1101.2
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 426.4
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1739.4
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 233.2
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3044.7
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 876.1
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 201.9
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1626.4
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 487.7
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1193.8
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1033.9
   },
   {
    "Region Name": "North Central Rockies forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 403.4
   }
  ],
  "North Island temperate forests": [
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "North Island temperate forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30.7
   }
  ],
  "North Saharan steppe and woodlands": [
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "North Saharan steppe and woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.5
   }
  ],
  "North Tibetan Plateau-Kunlun Mountains alpine desert": [
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Tibetan Plateau-Kunlun Mountains alpine desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "North Western Ghats moist deciduous forests": [
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 143.8
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 395.5
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 143.2
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 88.7
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 305.9
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 189.5
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 287.5
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 375.6
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 331.4
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 270.1
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 191.2
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 169.4
   },
   {
    "Region Name": "North Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 118.5
   }
  ],
  "North Western Ghats montane rain forests": [
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 273.5
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 92.6
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 250.2
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 111.3
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 102.0
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 210.3
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 176.9
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 104.8
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 172.4
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "North Western Ghats montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.9
   }
  ],
  "Northeast China Plain deciduous forests": [
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 217.8
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 213.3
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 188.9
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 143.4
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 478.5
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 965.9
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 536.8
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 823.0
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 286.6
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2745.9
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 632.0
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1163.2
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9992.0
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6799.8
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2684.8
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16124.8
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8490.3
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1312.4
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12097.7
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17616.2
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14256.2
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8975.8
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18957.1
   },
   {
    "Region Name": "Northeast China Plain deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12493.4
   }
  ],
  "Northeast India-Myanmar pine forests": [
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 350.7
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 350.1
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 141.7
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 320.3
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 191.4
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 438.0
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 235.6
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 563.4
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 228.7
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 369.4
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 188.0
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 242.9
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 232.6
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 156.5
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 82.7
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 129.5
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 109.8
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 172.4
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 163.8
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 171.3
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 239.9
   },
   {
    "Region Name": "Northeast India-Myanmar pine forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 198.1
   }
  ],
  "Northeast Siberian coastal tundra": [
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Siberian coastal tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Northeast Siberian taiga": [
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1780.1
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14379.9
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1682.8
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 338.7
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 754.6
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1632.2
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6972.1
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8426.4
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1948.2
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2361.1
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 735.5
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 703.6
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 397.9
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 850.6
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 294.5
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2260.5
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11300.2
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21427.0
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8510.0
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2233.1
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7584.2
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10806.1
   },
   {
    "Region Name": "Northeast Siberian taiga",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 915.4
   }
  ],
  "Northeastern Brazil restingas": [
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Northeastern Brazil restingas",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.1
   }
  ],
  "Northeastern Congolian lowland forests": [
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12999.1
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12803.0
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12739.5
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11835.7
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16840.6
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 18025.0
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9676.2
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11370.6
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16684.8
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18208.5
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14404.5
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11580.0
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12124.7
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17210.6
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11529.2
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14839.5
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17820.1
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16895.5
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18152.8
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 19164.6
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17232.9
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14554.2
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14507.0
   },
   {
    "Region Name": "Northeastern Congolian lowland forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12353.2
   }
  ],
  "Northeastern Himalayan subalpine conifer forests": [
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northeastern Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.6
   }
  ],
  "Northeastern Spain and Southern France Mediterranean forests": [
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 105.3
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 364.9
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 101.4
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 165.1
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 161.2
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 114.7
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 628.5
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 149.6
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 147.1
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 97.5
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 228.7
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Northeastern Spain and Southern France Mediterranean forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 183.3
   }
  ],
  "Northeastern coastal forests": [
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Northeastern coastal forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Northern Acacia-Commiphora bushlands and thickets": [
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5398.2
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9992.4
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6121.5
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9125.3
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5696.4
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16433.3
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10275.8
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3676.6
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12710.8
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13884.7
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15859.0
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10231.6
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9783.8
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10971.8
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7419.7
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8793.4
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7845.7
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5694.5
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15303.6
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10940.8
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9867.0
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7527.1
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10393.0
   },
   {
    "Region Name": "Northern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9520.3
   }
  ],
  "Northern Anatolian conifer and deciduous forests": [
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 108.9
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 234.9
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 522.0
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 340.8
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 467.1
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 160.3
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 114.9
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Northern Anatolian conifer and deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 173.0
   }
  ],
  "Northern Andean paramo": [
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 107.2
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 120.3
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 164.6
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 129.3
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 93.9
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 188.4
   },
   {
    "Region Name": "Northern Andean paramo",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 35.6
   }
  ],
  "Northern Annamites rain forests": [
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 254.0
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 515.3
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 529.9
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1164.9
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 381.4
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 428.3
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 563.6
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 459.0
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 847.2
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 509.3
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 418.0
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 463.7
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 490.3
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 848.3
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 635.6
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 293.3
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 834.8
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 499.7
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 513.8
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 549.0
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1120.1
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 890.1
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1094.8
   },
   {
    "Region Name": "Northern Annamites rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 551.4
   }
  ],
  "Northern California coastal forests": [
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 341.5
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern California coastal forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Northern Canadian Shield taiga": [
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1208.0
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1594.9
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3255.6
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 285.5
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 981.4
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3081.6
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3556.2
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2290.5
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2171.3
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 548.1
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6844.8
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9529.6
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1123.1
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1319.7
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6663.2
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 666.3
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 480.8
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2560.9
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2596.9
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13021.8
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4243.9
   },
   {
    "Region Name": "Northern Canadian Shield taiga",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2305.8
   }
  ],
  "Northern Congolian forest-savanna mosaic": [
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 220528.7
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 231368.2
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 218745.8
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 227193.2
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 227861.2
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 216250.7
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 197512.5
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 199535.3
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 204634.7
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 208056.7
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 182253.1
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 171338.3
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 169929.2
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 194216.6
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 180978.2
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 171820.6
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 176658.1
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 166895.1
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 163663.7
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 147905.0
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 154803.4
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 131459.6
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 140124.2
   },
   {
    "Region Name": "Northern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 131166.2
   }
  ],
  "Northern Cordillera forests": [
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2012.7
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 726.7
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 631.3
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 703.3
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 131.4
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 231.9
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 706.3
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 259.4
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1666.7
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 94.3
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3197.3
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 209.7
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 467.5
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 933.8
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1546.0
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 355.6
   },
   {
    "Region Name": "Northern Cordillera forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 109.1
   }
  ],
  "Northern Indochina subtropical forests": [
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5288.1
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14972.4
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 28802.0
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10389.0
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14202.8
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23005.9
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12240.3
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11061.9
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21128.2
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8829.9
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13033.8
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11601.0
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11860.2
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14271.8
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14856.2
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8553.5
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6963.6
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11907.6
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17248.3
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10757.7
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9592.4
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14915.6
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12133.1
   },
   {
    "Region Name": "Northern Indochina subtropical forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14271.0
   }
  ],
  "Northern Khorat Plateau moist deciduous forests": [
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 182.0
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 267.3
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 284.5
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 256.4
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 179.0
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 182.6
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 82.7
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 175.8
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 86.0
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 99.7
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 120.3
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 85.7
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 74.2
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 155.2
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Northern Khorat Plateau moist deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 40.3
   }
  ],
  "Northern Mesoamerican Pacific mangroves": [
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 137.4
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 147.5
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 226.2
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 173.0
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 121.5
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 145.8
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 127.8
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 91.3
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 123.3
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 96.5
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Northern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24.4
   }
  ],
  "Northern New Guinea lowland rain and freshwater swamp forests": [
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 749.0
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 502.5
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1341.9
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 376.6
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 497.3
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 665.8
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 989.3
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 241.4
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1238.0
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 338.7
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 347.1
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 574.9
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 449.1
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1559.1
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 498.6
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 893.3
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 274.2
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 388.9
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 444.4
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 835.6
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 843.5
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 519.0
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 742.4
   },
   {
    "Region Name": "Northern New Guinea lowland rain and freshwater swamp forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 330.1
   }
  ],
  "Northern New Guinea montane rain forests": [
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern New Guinea montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Northern Pacific coastal forests": [
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Northern Pacific coastal forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.1
   }
  ],
  "Northern Thailand-Laos moist deciduous forests": [
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1590.2
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2361.3
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5888.9
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1888.2
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2502.3
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4053.3
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2333.8
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2325.7
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4333.5
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1119.4
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2356.3
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3197.5
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1891.4
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2490.5
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3118.6
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2101.5
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2541.1
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2383.4
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3786.6
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1219.5
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1660.3
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3039.1
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3357.7
   },
   {
    "Region Name": "Northern Thailand-Laos moist deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 678.9
   }
  ],
  "Northern Triangle subtropical forests": [
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 109.3
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 65.4
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 124.8
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 149.0
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 115.8
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 320.9
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 661.8
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 136.8
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 201.3
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 125.6
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 315.8
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Northern Triangle subtropical forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 154.3
   }
  ],
  "Northern Triangle temperate forests": [
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 95.8
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 97.3
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Northern Triangle temperate forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.4
   }
  ],
  "Northern Vietnam lowland rain forests": [
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 105.0
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 88.3
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 119.4
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 105.3
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 150.9
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 87.9
   },
   {
    "Region Name": "Northern Vietnam lowland rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 113.8
   }
  ],
  "Northern Zanzibar-Inhambane coastal forest mosaic": [
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5340.1
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7725.4
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6675.7
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9623.5
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4380.8
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10700.9
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7668.8
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8977.3
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9021.9
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5936.3
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8110.4
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5488.3
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5319.4
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6561.8
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5545.1
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3088.8
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4911.2
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3939.7
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5136.9
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4533.7
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4191.3
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3060.5
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3514.2
   },
   {
    "Region Name": "Northern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3493.8
   }
  ],
  "Northern dry deciduous forests": [
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 89.6
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 197.6
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 374.7
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 483.4
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 296.0
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 360.6
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 502.1
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 491.3
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 659.4
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 386.5
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 392.7
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 837.5
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 274.4
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 487.9
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 522.6
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 606.2
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 160.6
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 965.7
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 310.6
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 171.9
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 242.7
   },
   {
    "Region Name": "Northern dry deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 327.8
   }
  ],
  "Northern mixed grasslands": [
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 219.1
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 207.7
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 147.1
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 118.5
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 370.2
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 120.3
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 458.7
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 172.8
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 313.8
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 128.4
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 224.2
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 207.1
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 194.9
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 127.5
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 98.4
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 510.8
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 111.5
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 178.6
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Northern mixed grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 62.2
   }
  ],
  "Northern short grasslands": [
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 728.2
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1188.5
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 209.9
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 299.7
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2774.1
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 643.8
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 480.2
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 149.2
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 497.3
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 782.2
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4132.2
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 161.0
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 223.2
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 475.9
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 574.1
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2659.2
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 311.0
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 162.9
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1076.8
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1616.8
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 424.5
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2425.6
   },
   {
    "Region Name": "Northern short grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 234.1
   }
  ],
  "Northern tall grasslands": [
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 372.8
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 761.2
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 183.9
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 557.6
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 407.9
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 526.3
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 222.7
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1619.3
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1092.0
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 203.7
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 574.5
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 227.7
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 199.8
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 246.1
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 192.1
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 762.9
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 184.4
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1170.7
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 97.3
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 117.3
   },
   {
    "Region Name": "Northern tall grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 155.4
   }
  ],
  "Northern transitional alpine forests": [
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 117.7
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Northern transitional alpine forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 33.9
   }
  ],
  "Northland temperate kauri forests": [
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Northland temperate kauri forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Northwest Iberian montane forests": [
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 334.8
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1107.6
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 552.6
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1185.2
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 157.1
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 156.7
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 429.8
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 278.5
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 489.6
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 386.3
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 362.3
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 402.6
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 264.5
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1289.6
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 223.8
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 261.7
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1419.8
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 125.0
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Northwest Iberian montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3362.6
   }
  ],
  "Northwest Russian-Novaya Zemlya tundra": [
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 115.8
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwest Russian-Novaya Zemlya tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Northwest Territories taiga": [
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 499.5
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 824.2
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 924.4
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 353.5
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 356.9
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1335.5
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 137.4
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 373.2
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1420.2
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7947.3
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 854.3
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 552.2
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2054.5
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 99.7
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 576.7
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1403.7
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1815.1
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3502.8
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7188.7
   },
   {
    "Region Name": "Northwest Territories taiga",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4449.7
   }
  ],
  "Northwestern Andean montane forests": [
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 90.2
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 121.5
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 258.3
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 110.4
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 51.9
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Northwestern Andean montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.3
   }
  ],
  "Northwestern Congolian lowland forests": [
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2961.7
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4848.0
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5751.5
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5246.3
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7421.7
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6124.3
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3536.7
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3417.0
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4102.4
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5692.8
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5018.4
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4876.7
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4136.5
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6695.4
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5170.8
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4080.9
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5740.2
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6952.8
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5292.8
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4594.1
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6322.8
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5134.4
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7980.7
   },
   {
    "Region Name": "Northwestern Congolian lowland forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4739.9
   }
  ],
  "Northwestern Hawaii scrub": [
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Hawaii scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Northwestern Himalayan alpine shrub and meadows": [
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northwestern Himalayan alpine shrub and meadows",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Northwestern thorn scrub forests": [
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17800.3
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18564.6
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22325.0
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25144.0
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19692.8
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21235.6
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18955.6
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 22607.6
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22375.2
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 23033.5
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 23715.0
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 27133.1
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23573.3
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24902.2
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 31562.2
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 20809.0
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 27559.7
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 24803.1
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25162.8
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26422.3
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27198.1
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 20095.2
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12891.1
   },
   {
    "Region Name": "Northwestern thorn scrub forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18495.3
   }
  ],
  "Novosibirsk Islands arctic desert": [
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novosibirsk Islands arctic desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nujiang Langcang Gorge alpine conifer and mixed forests": [
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 105.7
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 123.9
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 357.4
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Nujiang Langcang Gorge alpine conifer and mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 56.8
   }
  ],
  "Nullarbor Plains xeric shrublands": [
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 146.0
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 131.2
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 268.2
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 996.0
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 383.1
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 275.2
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 154.1
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15914.5
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1634.1
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 119.4
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 186.9
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 410.9
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1132.9
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 879.8
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 137.4
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 496.3
   },
   {
    "Region Name": "Nullarbor Plains xeric shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.7
   }
  ],
  "Oaxacan montane forests": [
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 207.1
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 129.3
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 122.0
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 212.2
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 195.3
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 287.7
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 212.7
   },
   {
    "Region Name": "Oaxacan montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 32.6
   }
  ],
  "Ogasawara subtropical moist forests": [
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogasawara subtropical moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ogilvie-MacKenzie alpine tundra": [
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 94.8
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2143.0
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 753.7
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 96.7
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 153.1
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 583.7
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 123.7
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 192.9
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 640.5
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 384.1
   },
   {
    "Region Name": "Ogilvie-MacKenzie alpine tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 217.4
   }
  ],
  "Okanagan dry forests": [
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 726.1
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 156.9
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1318.4
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 760.4
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 187.4
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2686.0
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 313.8
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 152.6
   },
   {
    "Region Name": "Okanagan dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 56.8
   }
  ],
  "Okhotsk-Manchurian taiga": [
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 803.2
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5178.1
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2215.7
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 413.1
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2353.8
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4598.0
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 942.4
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 270.3
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2782.1
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11968.4
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 263.9
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 726.3
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 185.0
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 232.6
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 710.6
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1972.2
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 269.5
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 178.6
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 139.6
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 449.3
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2659.0
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 566.8
   },
   {
    "Region Name": "Okhotsk-Manchurian taiga",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 143.2
   }
  ],
  "Ordos Plateau steppe": [
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 194.4
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Ordos Plateau steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 34.9
   }
  ],
  "Orinoco Delta swamp forests": [
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 323.5
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 89.8
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 228.5
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 208.4
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 115.1
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 192.3
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 221.2
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 179.0
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 566.1
   },
   {
    "Region Name": "Orinoco Delta swamp forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 21.0
   }
  ],
  "Orinoco wetlands": [
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 704.2
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 174.1
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 335.7
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 366.1
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 816.7
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 203.4
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 148.8
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 938.9
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 478.9
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 135.1
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 343.8
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 866.7
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 184.1
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 235.2
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 693.5
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 547.9
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 150.3
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 466.5
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1250.6
   },
   {
    "Region Name": "Orinoco wetlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 185.2
   }
  ],
  "Orissa semi-evergreen forests": [
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Orissa semi-evergreen forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.0
   }
  ],
  "Ozark Mountain forests": [
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 121.8
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 551.8
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 350.3
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 339.8
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 419.3
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 143.0
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 426.6
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 293.5
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 432.6
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 378.1
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 381.6
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 243.7
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 382.2
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 297.3
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 270.1
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 288.1
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 243.7
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 170.0
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 411.6
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 382.6
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 347.7
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 274.8
   },
   {
    "Region Name": "Ozark Mountain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 387.4
   }
  ],
  "Pacific Coastal Mountain icefields and tundra": [
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 206.9
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Pacific Coastal Mountain icefields and tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.1
   }
  ],
  "Palau tropical moist forests": [
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palau tropical moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Palawan rain forests": [
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 94.5
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Palawan rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Palouse grasslands": [
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 437.7
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 568.3
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 343.0
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 981.6
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 906.4
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1060.3
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 704.4
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 376.4
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 591.4
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 670.8
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 888.6
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 299.7
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1095.6
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1073.1
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 549.2
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 388.4
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1099.5
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 372.1
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1935.5
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1610.1
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 916.0
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 577.9
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1049.6
   },
   {
    "Region Name": "Palouse grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 590.4
   }
  ],
  "Pamir alpine desert and tundra": [
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 132.9
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamir alpine desert and tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Panamanian dry forests": [
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 203.2
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 150.7
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 135.3
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 128.2
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 93.7
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 127.5
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 207.1
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 195.9
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 99.0
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 143.6
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 181.4
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 138.3
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 95.8
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Panamanian dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 48.7
   }
  ],
  "Pannonian mixed forests": [
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 548.1
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 885.6
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1253.6
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 345.3
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 960.6
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1024.9
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1309.6
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 847.0
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 292.0
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1751.4
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3571.6
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 368.9
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 369.4
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 171.7
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 504.2
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 660.9
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 366.8
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 245.9
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 104.2
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 498.4
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 207.9
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1116.6
   },
   {
    "Region Name": "Pannonian mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 99.0
   }
  ],
  "Pantanal": [
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 38317.8
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8834.8
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23157.4
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 29639.1
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15277.2
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 35469.5
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14883.2
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13910.4
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 30663.6
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7512.8
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18825.7
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6494.5
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1754.2
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11983.4
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13155.4
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9603.3
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4894.7
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 35315.1
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 42811.6
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 31696.2
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6309.1
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15362.1
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 46047.3
   },
   {
    "Region Name": "Pantanal",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3429.5
   }
  ],
  "Pantanos de Centla": [
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 306.3
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1280.9
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 321.3
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 921.4
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 169.4
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1142.8
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 207.1
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 962.3
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 266.9
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 404.1
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 193.8
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 504.0
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 458.5
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 726.1
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 766.6
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 749.6
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1108.9
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 313.4
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 252.1
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 150.9
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 805.2
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 906.1
   },
   {
    "Region Name": "Pantanos de Centla",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1556.5
   }
  ],
  "Pantepui": [
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 299.5
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 220.8
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 114.5
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 199.1
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 408.6
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 178.8
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 447.0
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 88.7
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 106.1
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 174.3
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 200.4
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 119.8
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 256.2
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 86.0
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 163.8
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 159.5
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 238.8
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 167.6
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 97.5
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 240.5
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 264.7
   },
   {
    "Region Name": "Pantepui",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 59.4
   }
  ],
  "Paraguana xeric scrub": [
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Paraguana xeric scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Parana flooded savanna": [
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1217.4
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1774.3
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 551.6
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2410.2
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 356.7
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5727.7
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 492.4
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 109.8
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 379.0
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 536.6
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 257.9
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 602.4
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 336.1
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 214.4
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 197.9
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5239.6
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1940.0
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2929.4
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 231.1
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 418.7
   },
   {
    "Region Name": "Parana flooded savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 548.6
   }
  ],
  "Paropamisus xeric woodlands": [
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 138.7
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 383.1
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paropamisus xeric woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Patagonian steppe": [
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 966.2
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1215.0
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 342.8
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 291.3
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 506.6
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 332.1
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 149.4
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 172.6
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 348.1
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 262.6
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 183.9
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 247.8
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 777.5
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 559.5
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 365.9
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 429.2
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 491.5
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 437.5
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 296.5
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 256.0
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 217.6
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 209.4
   },
   {
    "Region Name": "Patagonian steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 228.5
   }
  ],
  "Patia Valley dry forests": [
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Patia Valley dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.9
   }
  ],
  "Peninsular Malaysian montane rain forests": [
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Peninsular Malaysian montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Peninsular Malaysian peat swamp forests": [
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 112.8
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Peninsular Malaysian peat swamp forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.1
   }
  ],
  "Peninsular Malaysian rain forests": [
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 347.1
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 613.7
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 309.5
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 168.7
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 145.8
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 266.7
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 286.0
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 179.9
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 457.9
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 502.1
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 167.6
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 143.2
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 98.0
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 216.9
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Peninsular Malaysian rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 74.0
   }
  ],
  "Pernambuco coastal forests": [
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 752.0
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 346.0
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 836.9
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 817.8
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 671.4
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 633.5
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 773.9
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 528.8
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 378.1
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 626.0
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 777.9
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 192.5
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 331.6
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 410.7
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 533.8
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 145.3
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 196.4
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 305.5
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 244.6
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 201.9
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 198.9
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 147.3
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 184.1
   },
   {
    "Region Name": "Pernambuco coastal forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 198.3
   }
  ],
  "Pernambuco interior forests": [
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 400.9
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 184.8
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 445.0
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 405.2
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 319.4
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 417.8
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 358.4
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 215.4
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 398.9
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 353.7
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 584.2
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 116.2
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 207.3
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 345.3
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 554.6
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 103.3
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 191.9
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 201.5
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 147.3
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 121.8
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 97.5
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 106.1
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 274.2
   },
   {
    "Region Name": "Pernambuco interior forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 223.2
   }
  ],
  "Persian Gulf desert and semi-desert": [
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 178.8
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Persian Gulf desert and semi-desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.2
   }
  ],
  "Peruvian Yungas": [
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 174.5
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 801.3
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 101.4
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 170.4
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 466.9
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 150.7
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 142.3
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 154.6
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 524.1
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 388.4
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 727.1
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 738.3
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 116.2
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 530.6
   },
   {
    "Region Name": "Peruvian Yungas",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 85.3
   }
  ],
  "Peten-Veracruz moist forests": [
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3579.3
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11713.3
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 907.9
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8450.9
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1669.5
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5991.2
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2277.2
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3674.1
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2670.6
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2894.2
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1502.1
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3086.5
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 843.5
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2235.7
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3499.8
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2113.2
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1147.3
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2751.6
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2777.2
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 943.2
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1286.0
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1713.7
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4592.4
   },
   {
    "Region Name": "Peten-Veracruz moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1633.7
   }
  ],
  "Pilbara shrublands": [
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17515.0
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2900.8
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7040.9
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1199.6
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 28030.7
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11210.6
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4407.4
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10223.7
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 860.3
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2709.0
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14253.6
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10862.3
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21741.3
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13620.8
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3709.9
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12830.0
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18240.4
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5066.0
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1905.3
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8010.5
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3852.0
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17011.3
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1939.4
   },
   {
    "Region Name": "Pilbara shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5948.1
   }
  ],
  "Pindus Mountains mixed forests": [
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 881.9
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 336.3
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 97.8
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Pindus Mountains mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 120.9
   }
  ],
  "Piney Woods forests": [
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 110.6
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 291.8
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 196.4
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 353.9
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 214.2
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 304.0
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 364.0
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 192.7
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 389.9
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 668.6
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 198.1
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 234.7
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 194.6
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 384.8
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 314.1
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 135.1
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 265.6
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 158.8
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 346.6
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 301.6
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 406.4
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Piney Woods forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 339.6
   }
  ],
  "Po Basin mixed forests": [
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 204.9
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 556.9
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 196.6
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 117.5
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 313.4
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 198.9
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 156.1
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 285.5
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 171.5
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Po Basin mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16.7
   }
  ],
  "Pontic steppe": [
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 53890.2
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16465.5
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32173.1
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 70730.6
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 57804.8
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 54055.3
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 67880.4
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 35264.3
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 35294.1
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19690.9
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19189.7
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10127.4
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 41664.3
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 34317.7
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 20869.0
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 43393.9
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18087.6
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18544.2
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18654.0
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10056.9
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16044.9
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13667.5
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18292.7
   },
   {
    "Region Name": "Pontic steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18599.7
   }
  ],
  "Puerto Rican dry forests": [
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Puerto Rican dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Puerto Rican moist forests": [
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Rican moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Puget lowland forests": [
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Puget lowland forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.1
   }
  ],
  "Purus varzea": [
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 74.4
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 151.6
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 123.7
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 178.4
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 80.2
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 92.6
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 182.2
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 155.6
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 136.3
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 163.6
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 355.0
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 323.7
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 455.5
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 389.1
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 641.2
   },
   {
    "Region Name": "Purus varzea",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 34.3
   }
  ],
  "Purus-Madeira moist forests": [
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 883.4
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1117.1
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 617.0
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2440.8
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1365.3
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1167.9
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 951.8
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 373.9
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2133.8
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 241.0
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 999.4
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 267.3
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 588.4
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1465.9
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1248.9
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1048.5
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1167.0
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1536.6
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1890.3
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2596.2
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2986.8
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2055.6
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3674.9
   },
   {
    "Region Name": "Purus-Madeira moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 440.1
   }
  ],
  "Pyrenees conifer and mixed forests": [
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 93.0
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 115.1
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 179.0
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 65.4
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 197.9
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 177.3
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pyrenees conifer and mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 81.9
   }
  ],
  "Qaidam Basin semi-desert": [
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaidam Basin semi-desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Qilian Mountains conifer forests": [
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Qilian Mountains subalpine meadows": [
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 131.4
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qilian Mountains subalpine meadows",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Qin Ling Mountains deciduous forests": [
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 179.9
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 596.6
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 232.6
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 751.1
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 813.5
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 142.8
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 217.6
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 178.1
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 669.7
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 376.2
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 146.2
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 270.5
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Qin Ling Mountains deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 241.0
   }
  ],
  "Qionglai-Minshan conifer forests": [
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Qionglai-Minshan conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.1
   }
  ],
  "Queen Charlotte Islands": [
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Queen Charlotte Islands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Queensland tropical rain forests": [
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 598.5
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 651.0
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 561.9
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1058.8
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 161.8
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 189.3
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 579.0
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1162.1
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 641.4
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 745.1
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 765.3
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 385.9
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 918.1
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 301.2
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1177.5
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1809.5
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 887.7
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 277.6
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 343.4
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 172.6
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 265.4
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 329.9
   },
   {
    "Region Name": "Queensland tropical rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 689.0
   }
  ],
  "Rakiura Island temperate forests": [
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakiura Island temperate forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rann of Kutch seasonal salt marsh": [
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Rann of Kutch seasonal salt marsh",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 39.0
   }
  ],
  "Rapa Nui subtropical broadleaf forests": [
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapa Nui subtropical broadleaf forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Red River freshwater swamp forests": [
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red River freshwater swamp forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Red Sea Nubo-Sindian tropical desert and semi-desert": [
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 214.2
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 167.2
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 162.3
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 241.0
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 131.8
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Red Sea Nubo-Sindian tropical desert and semi-desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.2
   }
  ],
  "Red Sea coastal desert": [
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Red Sea coastal desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Registan-North Pakistan sandy desert": [
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 131.0
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 271.8
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 91.7
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 170.9
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 119.4
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 216.1
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Registan-North Pakistan sandy desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Richmond temperate forests": [
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Richmond temperate forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rio Negro campinarana": [
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 116.4
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 254.0
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 185.4
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 895.8
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 155.6
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 406.2
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 719.0
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 329.9
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 423.6
   },
   {
    "Region Name": "Rio Negro campinarana",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 21.0
   }
  ],
  "Rodope montane mixed forests": [
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Rodope montane mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 39.2
   }
  ],
  "Rwenzori-Virunga montane moorlands": [
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Rwenzori-Virunga montane moorlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Sahara desert": [
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 113.4
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 103.3
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 216.5
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 115.8
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 313.2
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 801.7
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1016.8
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1502.1
   },
   {
    "Region Name": "Sahara desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1794.3
   }
  ],
  "Saharan flooded grasslands": [
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 92729.4
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 77229.6
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 79483.7
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 79405.5
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 84381.2
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 80583.9
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 77406.5
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 94647.1
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 68254.0
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 90390.0
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 75685.8
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 73338.4
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 68440.1
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 91252.0
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 74288.7
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 74406.6
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 97529.7
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 57119.3
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 64852.8
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 69030.5
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 61587.1
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 77518.0
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 70757.6
   },
   {
    "Region Name": "Saharan flooded grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 68543.8
   }
  ],
  "Saharan halophytics": [
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Saharan halophytics",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.2
   }
  ],
  "Sahelian Acacia savanna": [
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 152112.4
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 184678.3
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 175864.5
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 205088.1
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 174054.3
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 201344.6
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 165235.6
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 150185.8
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 153953.6
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 130871.8
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 167670.4
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 140415.6
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 127171.8
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 120404.0
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 136442.2
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 125800.5
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 141375.7
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 129303.7
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 175439.8
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 151156.5
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 132969.0
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 161918.5
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 183893.7
   },
   {
    "Region Name": "Sahelian Acacia savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 213278.5
   }
  ],
  "Sakhalin Island taiga": [
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 113.0
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 490.7
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 109.3
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 99.5
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 229.4
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 244.8
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sakhalin Island taiga",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 29.4
   }
  ],
  "Samoan tropical moist forests": [
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samoan tropical moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "San Felix-San Ambrosio Islands temperate forests": [
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Felix-San Ambrosio Islands temperate forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "San Lucan xeric scrub": [
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lucan xeric scrub",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Santa Marta montane forests": [
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Marta montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Santa Marta paramo": [
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Marta paramo",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sao Tome Principe and Annobon moist lowland forests": [
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sao Tome Principe and Annobon moist lowland forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Sarmatic mixed forests": [
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5809.2
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2853.9
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1057.7
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 813.5
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4452.2
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2184.2
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7104.2
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6074.8
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8411.8
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2294.4
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 700.1
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2041.0
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2291.6
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1704.4
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1280.4
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 130.3
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11306.2
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3908.6
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1530.6
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1164.7
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 628.7
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1113.9
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 217.6
   },
   {
    "Region Name": "Sarmatic mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 306.1
   }
  ],
  "Sayan Alpine meadows and tundra": [
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 203.2
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 185.9
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 89.8
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Sayan Alpine meadows and tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 45.7
   }
  ],
  "Sayan Intermontane steppe": [
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1932.8
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 620.8
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 427.0
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 203.9
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1266.9
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 277.6
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 490.3
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 314.5
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 101.6
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 726.1
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1137.4
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 76.5
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 369.8
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 304.6
   },
   {
    "Region Name": "Sayan Intermontane steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 148.6
   }
  ],
  "Sayan montane conifer forests": [
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3259.5
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 858.3
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 355.2
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 358.2
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 601.3
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1456.4
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1088.8
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1781.8
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 233.0
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 834.3
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4268.7
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 128.6
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1176.7
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1834.8
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 162.5
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 380.3
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 99.0
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 141.1
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 286.0
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 250.4
   },
   {
    "Region Name": "Sayan montane conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 190.4
   }
  ],
  "Scandinavian Montane Birch forest and grasslands": [
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian Montane Birch forest and grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Scandinavian and Russian taiga": [
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2760.4
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1062.8
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 925.2
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 302.3
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4949.4
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 714.1
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1076.6
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2993.9
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2500.6
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1638.2
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 99.7
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 606.4
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 669.9
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 227.2
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 242.7
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 850.4
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 414.6
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 123.0
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 396.4
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 556.3
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 218.7
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Scandinavian and Russian taiga",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 33.4
   }
  ],
  "Scandinavian coastal conifer forests": [
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scandinavian coastal conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Scotia Sea Islands tundra": [
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotia Sea Islands tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sechura desert": [
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 107.8
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 217.2
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 96.9
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 81.9
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 136.8
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 182.6
   },
   {
    "Region Name": "Sechura desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 120.9
   }
  ],
  "Selenge-Orkhon forest steppe": [
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3442.1
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2463.1
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 246.1
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 153.9
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 964.2
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 598.1
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1346.9
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 114.5
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 270.3
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 296.5
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 813.7
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 266.2
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 107.4
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Selenge-Orkhon forest steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 155.8
   }
  ],
  "Seram rain forests": [
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 161.4
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 113.4
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 420.8
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 149.0
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Seram rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Serengeti volcanic grasslands": [
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1525.9
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1623.0
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 550.5
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 656.6
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 412.2
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2567.1
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 729.7
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 139.6
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 997.5
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 72.7
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 247.8
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 620.6
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 744.9
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 594.9
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1338.3
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 98.0
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 619.7
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 426.2
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2021.5
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2600.1
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 756.7
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 881.5
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1932.5
   },
   {
    "Region Name": "Serengeti volcanic grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1535.3
   }
  ],
  "Serra do Mar coastal forests": [
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 326.3
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 221.9
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 119.2
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 199.6
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 176.4
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 183.9
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 76.5
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 365.3
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 171.1
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 135.1
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 102.9
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 217.4
   },
   {
    "Region Name": "Serra do Mar coastal forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 94.5
   }
  ],
  "Sichuan Basin evergreen broadleaf forests": [
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sichuan Basin evergreen broadleaf forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.6
   }
  ],
  "Sierra Juarez and San Pedro Martir pine-oak forests": [
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Sierra Juarez and San Pedro Martir pine-oak forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 61.7
   }
  ],
  "Sierra Madre Occidental pine-oak forests": [
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1597.3
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1097.1
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 418.4
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2494.4
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1596.4
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1293.9
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2312.6
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 898.4
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 357.1
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7678.1
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3605.7
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1475.1
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 565.5
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 745.8
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3083.5
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1872.1
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1775.8
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 256.0
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2017.6
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1432.2
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1450.2
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1527.6
   },
   {
    "Region Name": "Sierra Madre Occidental pine-oak forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2491.8
   }
  ],
  "Sierra Madre Oriental pine-oak forests": [
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 314.7
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 163.8
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 148.3
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 315.1
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 320.9
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 247.4
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 145.3
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6726.0
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 255.7
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 210.3
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 167.2
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 98.4
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 520.5
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 499.3
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 164.0
   },
   {
    "Region Name": "Sierra Madre Oriental pine-oak forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 165.3
   }
  ],
  "Sierra Madre de Chiapas moist forests": [
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 452.7
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 396.4
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 466.9
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 352.0
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 327.8
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 355.4
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 365.3
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 436.0
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 417.6
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 415.9
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 433.9
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 597.2
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 489.0
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 477.4
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 479.8
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 537.4
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 445.9
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 613.7
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 464.8
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 440.3
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 567.9
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 472.7
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 540.4
   },
   {
    "Region Name": "Sierra Madre de Chiapas moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 501.2
   }
  ],
  "Sierra Madre de Oaxaca pine-oak forests": [
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 131.0
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 101.6
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 107.2
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 183.3
   },
   {
    "Region Name": "Sierra Madre de Oaxaca pine-oak forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 22.7
   }
  ],
  "Sierra Madre del Sur pine-oak forests": [
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1584.8
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2877.5
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1317.3
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3587.7
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1327.8
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2561.3
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1905.3
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1974.6
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2047.0
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1606.5
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1934.5
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2761.3
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 425.5
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1169.0
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1203.0
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2547.3
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1527.4
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3436.3
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3208.7
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1792.3
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1870.4
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1623.4
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3269.6
   },
   {
    "Region Name": "Sierra Madre del Sur pine-oak forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 834.3
   }
  ],
  "Sierra Nevada forests": [
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 597.2
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 141.1
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 147.7
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 377.3
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 534.2
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 466.0
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1087.9
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 501.4
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 508.9
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 153.3
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 277.8
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 681.1
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 226.8
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3108.8
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5359.9
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 361.0
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 559.3
   },
   {
    "Region Name": "Sierra Nevada forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 140.4
   }
  ],
  "Sierra de la Laguna dry forests": [
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sierra de la Laguna pine-oak forests": [
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sierra de la Laguna pine-oak forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sierra de los Tuxtlas": [
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 153.7
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 153.9
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 240.3
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Sierra de los Tuxtlas",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 22.9
   }
  ],
  "Simpson desert": [
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5543.2
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 588.0
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 260.2
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 186.7
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 377.3
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 172.4
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 169.8
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2053.0
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 107394.4
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8710.9
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1471.2
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 206.4
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 343.8
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 766.8
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 352.4
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 359.7
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 228.7
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2066.7
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 688.8
   },
   {
    "Region Name": "Simpson desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2345.4
   }
  ],
  "Sinaloan dry forests": [
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1198.1
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 798.1
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 631.7
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2008.2
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1618.7
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1502.5
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2146.9
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 647.6
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 748.6
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2632.7
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1699.5
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1017.2
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 310.0
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 172.1
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 942.8
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1449.3
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1094.4
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1058.1
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 519.4
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1215.7
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 836.9
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1575.2
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 813.1
   },
   {
    "Region Name": "Sinaloan dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1118.4
   }
  ],
  "Sinu Valley dry forests": [
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 777.9
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 671.2
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 560.4
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 337.0
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 497.6
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 441.8
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 171.7
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 410.3
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 409.2
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 181.1
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 268.0
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 487.3
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 176.4
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 389.9
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 340.4
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 393.6
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 469.3
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 283.0
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 132.1
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 121.8
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Sinu Valley dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 56.4
   }
  ],
  "Snake-Columbia shrub steppe": [
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1062.4
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 891.1
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 404.9
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2038.6
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3165.6
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3767.1
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 855.1
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 537.6
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2235.9
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1560.8
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7539.8
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1883.0
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1971.1
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1906.0
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1477.6
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2484.3
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3948.2
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1191.2
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1688.4
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 495.2
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 722.2
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 482.5
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2799.9
   },
   {
    "Region Name": "Snake-Columbia shrub steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 950.9
   }
  ],
  "Society Islands tropical moist forests": [
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Society Islands tropical moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Socotra Island xeric shrublands": [
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Socotra Island xeric shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Solimoes-Japura moist forests": [
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Solimoes-Japura moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.8
   }
  ],
  "Solomon Islands rain forests": [
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solomon Islands rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Somali Acacia-Commiphora bushlands and thickets": [
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2596.7
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3884.6
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2763.4
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3562.0
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1613.8
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6036.8
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2330.8
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1308.1
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3396.2
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6293.7
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5632.1
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4438.5
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3458.4
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3362.6
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2969.0
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2940.3
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3290.6
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1010.5
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4121.0
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2692.7
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2629.9
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2055.4
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5396.7
   },
   {
    "Region Name": "Somali Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2796.2
   }
  ],
  "Somali montane xeric woodlands": [
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Somali montane xeric woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.2
   }
  ],
  "Sonoran desert": [
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 278.9
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 158.8
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 822.1
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 158.4
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 209.4
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 190.6
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 229.4
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 179.0
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 230.7
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 261.5
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 219.1
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 231.9
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 374.7
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 167.9
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 121.8
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 250.6
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 513.4
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 312.8
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 341.9
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 408.2
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 121.3
   },
   {
    "Region Name": "Sonoran desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 46.3
   }
  ],
  "Sonoran-Sinaloan transition subtropical dry forest": [
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 590.4
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 517.7
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 331.8
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 378.6
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 485.8
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 555.4
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 463.9
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 273.7
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 716.4
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 674.2
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 753.3
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 387.4
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 417.6
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 130.8
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 352.4
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 275.5
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 361.2
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 527.6
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 213.1
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 456.8
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 285.1
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 468.8
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Sonoran-Sinaloan transition subtropical dry forest",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 45.9
   }
  ],
  "South American Pacific mangroves": [
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 114.3
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "South American Pacific mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.1
   }
  ],
  "South Appenine mixed montane forests": [
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 119.8
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 133.6
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 331.2
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 111.3
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 99.0
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 177.3
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 205.8
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 191.2
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 117.7
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 532.5
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "South Appenine mixed montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.3
   }
  ],
  "South Avalon-Burin oceanic barrens": [
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Avalon-Burin oceanic barrens",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "South Central Rockies forests": [
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 348.1
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 823.8
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 615.9
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1434.6
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4052.9
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 623.6
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 111.3
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 424.7
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2890.6
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1162.3
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 147.3
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 429.2
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1642.1
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 933.4
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 843.8
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 138.7
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 228.5
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1683.4
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1046.8
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 157.1
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2188.7
   },
   {
    "Region Name": "South Central Rockies forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 172.4
   }
  ],
  "South China Sea Islands": [
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South China Sea Islands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "South China-Vietnam subtropical evergreen forests": [
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 634.3
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 960.6
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 733.1
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 675.5
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 548.4
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 610.7
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 460.9
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 290.0
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 212.0
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 307.2
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 345.6
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 142.6
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 374.7
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 136.6
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 129.3
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 198.5
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 196.8
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 199.8
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 326.3
   },
   {
    "Region Name": "South China-Vietnam subtropical evergreen forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 144.9
   }
  ],
  "South Deccan Plateau dry deciduous forests": [
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 228.1
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 148.3
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 162.7
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 305.9
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 142.3
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 87.5
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 104.8
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 187.1
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 113.8
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 89.6
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 218.7
   },
   {
    "Region Name": "South Deccan Plateau dry deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 154.1
   }
  ],
  "South Florida rocklands": [
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 121.8
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "South Florida rocklands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 91.1
   }
  ],
  "South Iran Nubo-Sindian desert and semi-desert": [
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 594.2
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 635.8
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 494.8
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 932.1
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 656.4
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 699.5
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 562.5
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 254.2
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 850.8
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 427.2
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 377.9
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 606.4
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 848.7
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 423.0
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 627.5
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 722.2
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 389.5
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1660.9
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 936.1
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 881.3
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 509.6
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1711.3
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2367.7
   },
   {
    "Region Name": "South Iran Nubo-Sindian desert and semi-desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1005.2
   }
  ],
  "South Island montane grasslands": [
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island montane grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "South Island temperate forests": [
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Island temperate forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "South Malawi montane forest-grassland mosaic": [
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 645.0
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 814.2
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 687.7
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 570.0
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 755.7
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 784.4
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 598.3
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 349.2
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 553.7
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 530.8
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 680.8
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 356.9
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 518.3
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 489.6
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 544.9
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 451.2
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 434.1
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 326.5
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 413.9
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 177.1
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 443.7
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 216.1
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 177.5
   },
   {
    "Region Name": "South Malawi montane forest-grassland mosaic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 260.5
   }
  ],
  "South Saharan steppe and woodlands": [
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 210.9
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 121.5
   },
   {
    "Region Name": "South Saharan steppe and woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 76.7
   }
  ],
  "South Sakhalin-Kurile mixed forests": [
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Sakhalin-Kurile mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "South Siberian forest steppe": [
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4316.1
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3332.4
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2987.7
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3080.1
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2647.2
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3232.7
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8939.0
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3304.1
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2477.0
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6651.4
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3000.1
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 629.8
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5818.0
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3545.0
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2380.8
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2867.4
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1047.0
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2694.4
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3601.2
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1138.3
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5025.5
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 929.3
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 534.4
   },
   {
    "Region Name": "South Siberian forest steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 849.3
   }
  ],
  "South Taiwan monsoon rain forests": [
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Taiwan monsoon rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "South Western Ghats moist deciduous forests": [
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 329.5
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 94.5
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 246.5
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 196.4
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "South Western Ghats moist deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "South Western Ghats montane rain forests": [
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 196.8
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 144.5
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "South Western Ghats montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.2
   }
  ],
  "Southeast Australia temperate forests": [
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6799.1
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 328.0
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1932.1
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3638.1
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9483.5
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 122.8
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3294.0
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 647.2
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 774.5
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5116.1
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3492.5
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3792.2
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 988.5
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1388.5
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1949.9
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2725.5
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1577.8
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23569.2
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 440.5
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3379.3
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1650.0
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2148.4
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3319.7
   },
   {
    "Region Name": "Southeast Australia temperate forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4619.0
   }
  ],
  "Southeast Australia temperate savanna": [
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 887.7
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 890.7
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2619.8
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2424.1
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4091.9
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 462.6
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 552.6
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 938.1
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 759.9
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3754.0
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2334.3
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1413.5
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 906.4
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2331.3
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2453.7
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4933.5
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1038.0
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 290.9
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 852.5
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2974.8
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2653.9
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4166.0
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3189.8
   },
   {
    "Region Name": "Southeast Australia temperate savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2365.8
   }
  ],
  "Southeast Tibet shrublands and meadows": [
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 122.4
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 116.2
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 122.2
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Southeast Tibet shrublands and meadows",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.1
   }
  ],
  "Southeastern Iberian shrubs and woodlands": [
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Southeastern Iberian shrubs and woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.6
   }
  ],
  "Southeastern Indochina dry evergreen forests": [
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6686.6
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7892.4
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9299.5
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7566.4
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7501.8
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5608.1
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8000.9
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5080.1
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8631.4
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7455.3
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7995.7
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6261.5
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7887.5
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8512.6
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6413.7
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6947.9
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5984.5
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6288.9
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5413.5
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4495.5
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4992.9
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5661.7
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5156.0
   },
   {
    "Region Name": "Southeastern Indochina dry evergreen forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4400.8
   }
  ],
  "Southeastern Papuan rain forests": [
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 584.2
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 582.9
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 450.8
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 315.1
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 654.9
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 215.4
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 117.7
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 448.5
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 202.6
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 227.0
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 225.7
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 511.1
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 196.4
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 571.7
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 219.7
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 263.2
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 280.4
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 227.9
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 78.2
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 191.4
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 271.6
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 192.9
   },
   {
    "Region Name": "Southeastern Papuan rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 113.2
   }
  ],
  "Southeastern conifer forests": [
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1607.8
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1440.1
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2457.3
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1826.2
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2588.3
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3918.7
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2050.7
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1831.6
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2059.9
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3373.7
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2149.7
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2153.1
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2286.2
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1868.7
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1930.0
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2539.6
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1766.2
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2223.9
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1744.3
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2492.3
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1825.1
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1565.3
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1657.9
   },
   {
    "Region Name": "Southeastern conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1431.1
   }
  ],
  "Southeastern mixed forests": [
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 117.0
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 320.5
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 574.7
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 355.6
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 435.8
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 293.0
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 561.2
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 248.5
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 321.1
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 699.5
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 218.9
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 376.6
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 403.4
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 519.2
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 232.4
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 325.2
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 199.8
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 363.1
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 238.4
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 482.5
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 333.3
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 320.9
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 347.1
   },
   {
    "Region Name": "Southeastern mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 334.6
   }
  ],
  "Southern Acacia-Commiphora bushlands and thickets": [
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 25659.8
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 23033.9
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21180.3
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19010.9
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9253.0
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 26767.4
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 20167.0
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16858.6
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 23279.6
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17607.0
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15959.6
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16524.8
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14911.9
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12825.1
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19528.6
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9678.8
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13248.6
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13717.5
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19646.3
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18022.4
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11697.3
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13275.0
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20406.6
   },
   {
    "Region Name": "Southern Acacia-Commiphora bushlands and thickets",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15996.6
   }
  ],
  "Southern Africa bushveld": [
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8078.7
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5363.1
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8562.1
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14060.2
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9689.3
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9031.6
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13493.9
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14550.1
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14868.2
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15370.0
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7930.2
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5533.1
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7495.4
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10680.7
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1909.8
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5498.4
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8180.1
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4981.7
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3433.1
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7705.9
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7630.7
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10331.9
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7345.6
   },
   {
    "Region Name": "Southern Africa bushveld",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5802.1
   }
  ],
  "Southern Africa mangroves": [
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Southern Africa mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.8
   }
  ],
  "Southern Anatolian montane conifer and deciduous forests": [
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 74.2
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 96.0
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 194.9
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 534.6
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 153.7
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 78.0
   },
   {
    "Region Name": "Southern Anatolian montane conifer and deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 86.8
   }
  ],
  "Southern Andean Yungas": [
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2298.7
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2119.7
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1735.5
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2205.9
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1461.1
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1737.5
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1481.3
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2627.3
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1778.8
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1155.2
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1102.5
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2853.0
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 737.6
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 836.7
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1332.7
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1267.6
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 863.5
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 683.2
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2307.7
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 713.0
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3097.2
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 964.2
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 600.7
   },
   {
    "Region Name": "Southern Andean Yungas",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 615.9
   }
  ],
  "Southern Andean steppe": [
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 112.5
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 140.8
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 102.0
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 89.6
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 86.0
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 83.8
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 187.1
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Southern Andean steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 21.7
   }
  ],
  "Southern Annamites montane rain forests": [
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 263.7
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 393.4
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 982.5
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 792.7
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 473.1
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 284.7
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 652.5
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 264.5
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 952.7
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 588.4
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 324.3
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 347.1
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 591.4
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 389.1
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 520.1
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 173.0
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 329.7
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 466.0
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 465.4
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 394.7
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 312.1
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 387.4
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 365.9
   },
   {
    "Region Name": "Southern Annamites montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 168.3
   }
  ],
  "Southern Atlantic mangroves": [
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 108.0
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Southern Atlantic mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Southern Cone Mesopotamian savanna": [
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 233.2
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1916.2
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3902.4
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2551.0
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1219.3
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2585.1
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1508.1
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 975.0
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 874.2
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1993.2
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1476.4
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1384.0
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 257.7
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 360.8
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 697.3
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 879.1
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 421.4
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1613.8
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1603.7
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4014.5
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 419.1
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 492.6
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 675.0
   },
   {
    "Region Name": "Southern Cone Mesopotamian savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 598.9
   }
  ],
  "Southern Congolian forest-savanna mosaic": [
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 132745.4
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 145021.1
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 164136.6
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 150694.5
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 152761.5
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 133183.4
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 137233.9
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 144432.4
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 144676.1
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 127953.4
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 126366.9
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 138448.3
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 137693.7
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 129517.0
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 139988.3
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 133715.7
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 133588.5
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 131153.7
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 135134.4
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 136544.3
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 136854.2
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 131012.9
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 142932.5
   },
   {
    "Region Name": "Southern Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 126641.3
   }
  ],
  "Southern Great Lakes forests": [
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Southern Great Lakes forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 22.9
   }
  ],
  "Southern Hudson Bay taiga": [
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1364.5
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2425.4
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1338.1
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 173.2
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 130.3
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 208.8
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 253.6
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 125.8
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5362.9
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 563.1
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 181.8
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 216.7
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4891.9
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 511.9
   },
   {
    "Region Name": "Southern Hudson Bay taiga",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 80.0
   }
  ],
  "Southern Indian Ocean Islands tundra": [
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Indian Ocean Islands tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Southern Korea evergreen forests": [
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Korea evergreen forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.4
   }
  ],
  "Southern Mesoamerican Pacific mangroves": [
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 360.4
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 430.5
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 539.1
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 278.7
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 286.6
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 351.6
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 302.5
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 389.9
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 286.4
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 291.1
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 458.7
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 534.6
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 498.4
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 553.7
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 469.5
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 552.2
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 469.5
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 577.9
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 412.0
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 502.3
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 413.5
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 408.2
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 385.9
   },
   {
    "Region Name": "Southern Mesoamerican Pacific mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 369.4
   }
  ],
  "Southern Miombo woodlands": [
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 54283.6
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 68216.7
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 66739.9
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 66147.6
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 59981.1
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 79947.8
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 73078.0
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 62350.3
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 79305.6
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 68807.7
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 71879.0
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 66419.7
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 67203.4
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 67920.0
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 59808.1
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 51308.1
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 63633.1
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 59155.1
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 40545.5
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 45812.8
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 62252.3
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 47070.9
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 46822.0
   },
   {
    "Region Name": "Southern Miombo woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 44633.3
   }
  ],
  "Southern New Guinea freshwater swamp forests": [
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2164.5
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 398.1
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3093.1
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 233.0
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1549.2
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 140.8
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 466.3
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 337.0
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 308.3
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 572.4
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1591.5
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5788.6
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 210.1
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1309.4
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 986.3
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 406.7
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1566.2
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 138.5
   },
   {
    "Region Name": "Southern New Guinea freshwater swamp forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19.9
   }
  ],
  "Southern New Guinea lowland rain forests": [
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 261.7
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 516.2
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 182.6
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 98.8
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 340.0
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 905.1
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 210.3
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 306.3
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Southern New Guinea lowland rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Southern Pacific dry forests": [
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 411.2
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 772.6
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 522.0
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 683.8
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 359.9
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 623.6
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 693.7
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 415.7
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 358.9
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 328.2
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 876.6
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 911.1
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 309.8
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 692.4
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 540.2
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1009.5
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 808.0
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 806.0
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 903.1
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 899.7
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 827.0
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 718.6
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 794.5
   },
   {
    "Region Name": "Southern Pacific dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 507.4
   }
  ],
  "Southern Rift montane forest-grassland mosaic": [
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3707.1
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5539.5
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3473.4
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5631.3
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2995.8
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4078.6
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3998.2
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3488.6
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5553.9
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2792.6
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4062.9
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3783.4
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2512.0
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3456.7
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3539.0
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2999.0
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2082.4
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2750.8
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2364.5
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3034.0
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2575.2
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2674.7
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2506.4
   },
   {
    "Region Name": "Southern Rift montane forest-grassland mosaic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3021.5
   }
  ],
  "Southern Vietnam lowland dry forests": [
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 244.4
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 273.3
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 396.8
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 314.9
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 161.8
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 173.6
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 275.5
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 194.4
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 189.5
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 204.1
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 429.4
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 242.7
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 372.1
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 262.6
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 219.5
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 201.1
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 243.5
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 266.2
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 234.9
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 289.2
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 165.9
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 218.7
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 289.0
   },
   {
    "Region Name": "Southern Vietnam lowland dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 114.3
   }
  ],
  "Southern Zanzibar-Inhambane coastal forest mosaic": [
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16260.5
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19938.9
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14950.7
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21920.7
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16948.2
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 17308.4
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22528.3
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 21208.6
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20758.0
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16585.7
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20469.9
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20907.6
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18300.0
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20490.2
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18269.2
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16215.3
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18379.8
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19216.3
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19266.0
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18946.6
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19576.0
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17774.6
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 17045.6
   },
   {
    "Region Name": "Southern Zanzibar-Inhambane coastal forest mosaic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15775.4
   }
  ],
  "Southwest Amazon moist forests": [
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8728.7
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6214.6
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10359.8
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12953.2
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6892.0
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10251.8
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7030.9
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3473.6
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21145.8
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7613.7
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5647.6
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3634.8
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3121.0
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4309.5
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8963.0
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5899.4
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4149.5
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8749.7
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7538.5
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7051.2
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9618.5
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18359.4
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 17048.3
   },
   {
    "Region Name": "Southwest Amazon moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3887.8
   }
  ],
  "Southwest Australia savanna": [
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1161.0
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 269.0
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3518.2
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1408.8
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1936.6
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 280.2
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 746.2
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2063.3
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2581.4
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 808.8
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3166.4
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 541.3
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3182.7
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1215.9
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 342.6
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4027.6
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 976.5
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4302.0
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 588.2
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 681.5
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1773.9
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2642.1
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 916.9
   },
   {
    "Region Name": "Southwest Australia savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2590.2
   }
  ],
  "Southwest Australia woodlands": [
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 893.3
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 492.6
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1110.0
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 384.8
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 709.6
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 414.4
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 444.8
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 683.4
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 799.0
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 409.4
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 274.4
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 313.2
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1021.5
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1279.4
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 859.0
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1239.1
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 636.0
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 650.4
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 565.3
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 413.5
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 629.6
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 485.8
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 343.4
   },
   {
    "Region Name": "Southwest Australia woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 462.2
   }
  ],
  "Southwest Borneo freshwater swamp forests": [
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4189.0
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1065.2
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3942.5
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1098.9
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5754.7
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 263.7
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4608.5
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1253.0
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1388.0
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 649.8
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4233.4
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3155.7
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 94.8
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 170.0
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1009.9
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4192.8
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1980.1
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Southwest Borneo freshwater swamp forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 67.1
   }
  ],
  "Southwest Iberian Mediterranean sclerophyllous and mixed forests": [
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 983.3
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4006.1
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1118.6
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1204.1
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 233.2
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 171.5
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 678.3
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 591.4
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 108.0
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 96.5
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 304.0
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2926.1
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 341.3
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 192.5
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 332.9
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 278.3
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 317.9
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 181.1
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Southwest Iberian Mediterranean sclerophyllous and mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 390.4
   }
  ],
  "Southwestern Arabian foothills savanna": [
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Southwestern Arabian foothills savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 31.3
   }
  ],
  "Southwestern Arabian montane woodlands": [
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southwestern Arabian montane woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 61.7
   }
  ],
  "Sri Lanka dry-zone dry evergreen forests": [
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 619.1
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 700.8
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 765.7
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 902.1
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 380.1
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 425.7
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 407.7
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 620.4
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 251.7
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 335.1
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 566.6
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 248.5
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 218.4
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 274.8
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 308.0
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 125.4
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 105.9
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Sri Lanka dry-zone dry evergreen forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 49.1
   }
  ],
  "Sri Lanka lowland rain forests": [
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka lowland rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sri Lanka montane rain forests": [
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sri Lanka montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "St Helena scrub and woodlands": [
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Helena scrub and woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "St Peter and St Paul rocks": [
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St Peter and St Paul rocks",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Succulent Karoo": [
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 161.4
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Succulent Karoo",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.6
   }
  ],
  "Suiphun-Khanka meadows and forest meadows": [
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 169.6
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1085.1
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1409.9
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 494.1
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 932.7
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1044.0
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1967.0
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1038.8
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 502.7
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1843.1
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 864.8
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 796.8
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3542.7
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1281.7
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2719.5
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3503.6
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 882.3
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 249.5
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 985.7
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1486.6
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1156.7
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 437.5
   },
   {
    "Region Name": "Suiphun-Khanka meadows and forest meadows",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 425.3
   }
  ],
  "Sulaiman Range alpine meadows": [
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sulaiman Range alpine meadows",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sulawesi lowland rain forests": [
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 699.9
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 183.7
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 353.7
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 179.9
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 597.4
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 177.1
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 112.5
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 229.8
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 549.4
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 104.8
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 316.6
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 170.4
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Sulawesi lowland rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 68.8
   }
  ],
  "Sulawesi montane rain forests": [
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 516.4
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 121.5
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 122.6
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 139.3
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 413.7
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Sulawesi montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Sulu Archipelago rain forests": [
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sulu Archipelago rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sumatran freshwater swamp forests": [
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 327.1
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 194.2
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 244.2
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 121.1
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 403.2
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 159.1
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 172.4
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 128.4
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 119.6
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 154.6
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 264.1
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 396.4
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 226.4
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Sumatran freshwater swamp forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.6
   }
  ],
  "Sumatran lowland rain forests": [
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2655.8
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1153.1
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1803.5
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 827.7
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3847.7
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 827.2
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 578.2
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1143.2
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 94.5
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 918.6
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1268.0
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 734.2
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1302.5
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2324.6
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 202.4
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 174.9
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 333.1
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2027.1
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 712.3
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 120.3
   },
   {
    "Region Name": "Sumatran lowland rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 204.3
   }
  ],
  "Sumatran montane rain forests": [
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Sumatran montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 38.8
   }
  ],
  "Sumatran peat swamp forests": [
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3511.1
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 783.5
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3548.0
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1416.6
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5649.3
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 263.2
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 301.8
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2843.0
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 240.5
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2246.2
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1983.8
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2148.0
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3104.3
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2938.1
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 501.6
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 681.3
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3896.6
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 113.4
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1880.0
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 114.0
   },
   {
    "Region Name": "Sumatran peat swamp forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 195.1
   }
  ],
  "Sumatran tropical pine forests": [
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sumatran tropical pine forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.4
   }
  ],
  "Sumba deciduous forests": [
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 105.7
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 110.4
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 130.6
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 299.3
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 175.8
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 179.4
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 155.8
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 267.1
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 168.9
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 179.9
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 257.0
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 135.9
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 123.5
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 161.8
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 178.1
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 202.6
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 164.4
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 91.7
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 188.9
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 89.4
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 121.8
   },
   {
    "Region Name": "Sumba deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 159.3
   }
  ],
  "Sunda Shelf mangroves": [
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2104.9
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 595.7
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1722.5
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 515.1
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2536.2
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 162.3
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 203.9
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1486.2
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 234.1
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 736.4
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 649.1
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1000.2
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2005.0
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2969.7
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 230.9
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 514.9
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2175.4
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 105.9
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 987.8
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 121.3
   },
   {
    "Region Name": "Sunda Shelf mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 117.7
   }
  ],
  "Sundaland heath forests": [
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1659.2
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 254.2
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2476.0
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 153.5
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2161.9
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1191.9
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 221.9
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 212.2
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 89.4
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1075.1
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1155.7
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 104.2
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1239.9
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 419.1
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Sundaland heath forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.7
   }
  ],
  "Sundarbans freshwater swamp forests": [
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans freshwater swamp forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sundarbans mangroves": [
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sundarbans mangroves",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Swan Coastal Plain Scrub and Woodlands": [
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1342.4
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 168.1
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 403.4
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 115.5
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 167.0
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 135.9
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 200.6
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 209.7
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 152.6
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 178.8
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 698.2
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 89.2
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 255.3
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 223.6
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 147.1
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 153.9
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 832.2
   },
   {
    "Region Name": "Swan Coastal Plain Scrub and Woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 229.6
   }
  ],
  "Taiheiyo evergreen forests": [
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 92.8
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 121.1
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 88.7
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 117.5
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 160.6
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 99.0
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 90.0
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 146.0
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 107.2
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 75.5
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 112.1
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 120.3
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 107.6
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 62.6
   },
   {
    "Region Name": "Taiheiyo evergreen forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 69.9
   }
  ],
  "Taiheiyo montane deciduous forests": [
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Taiheiyo montane deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.6
   }
  ],
  "Taimyr-Central Siberian tundra": [
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 74.2
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 367.0
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 186.3
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 88.7
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Taimyr-Central Siberian tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.4
   }
  ],
  "Taiwan subtropical evergreen forests": [
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taiwan subtropical evergreen forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Taklimakan desert": [
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 111.3
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 214.2
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 113.8
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taklimakan desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.4
   }
  ],
  "Talamancan montane forests": [
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Talamancan montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tamaulipan matorral": [
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 238.6
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Tamaulipan matorral",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 25.3
   }
  ],
  "Tamaulipan mezquital": [
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 236.4
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 373.0
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 242.7
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 162.7
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 434.5
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 942.4
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 214.4
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 352.6
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 426.2
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 119.6
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 96.7
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 252.3
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 270.7
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 177.9
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 182.2
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 150.3
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 239.5
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 343.0
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 496.9
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 181.8
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 204.3
   },
   {
    "Region Name": "Tamaulipan mezquital",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 172.1
   }
  ],
  "Tapajos-Xingu moist forests": [
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1565.5
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1230.5
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2800.1
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3369.9
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2088.4
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2251.9
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2864.0
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1091.6
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3380.4
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 751.4
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2260.1
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 256.2
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2231.4
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2936.0
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1447.6
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5242.8
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1033.0
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4473.7
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6640.3
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2895.1
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6429.6
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5662.8
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13602.8
   },
   {
    "Region Name": "Tapajos-Xingu moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 532.9
   }
  ],
  "Tarim Basin deciduous forests and steppe": [
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarim Basin deciduous forests and steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tasmanian Central Highland forests": [
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 166.1
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 207.1
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 242.7
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 592.9
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 92.2
   },
   {
    "Region Name": "Tasmanian Central Highland forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Tasmanian temperate forests": [
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 227.2
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 158.6
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 92.4
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 884.7
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 131.2
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 80.2
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 292.8
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 80.0
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 336.8
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 260.2
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Tasmanian temperate forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24.2
   }
  ],
  "Tasmanian temperate rain forests": [
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 758.2
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 126.7
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 367.2
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 153.9
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 168.7
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 143.0
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 508.3
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 74.2
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 807.5
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1187.8
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 808.2
   },
   {
    "Region Name": "Tasmanian temperate rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 25.5
   }
  ],
  "Tehuacan Valley matorral": [
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 121.1
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 62.6
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Tehuacan Valley matorral",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 39.9
   }
  ],
  "Tenasserim-South Thailand semi-evergreen rain forests": [
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 449.7
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 471.8
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1303.6
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 901.9
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 616.7
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 846.8
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 554.1
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 287.7
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 615.0
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 202.4
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 415.9
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 588.0
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 880.4
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 810.1
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 982.7
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 121.8
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 291.3
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 769.2
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1550.7
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 157.1
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 225.3
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 992.3
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 621.9
   },
   {
    "Region Name": "Tenasserim-South Thailand semi-evergreen rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 65.2
   }
  ],
  "Terai-Duar savanna and grasslands": [
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 280.8
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1149.9
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1104.2
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1024.3
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 784.4
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 582.2
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 802.0
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 976.0
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1332.9
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 973.4
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1307.0
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1335.5
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1404.3
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 507.6
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2550.3
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1114.7
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 609.2
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1662.4
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 575.4
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1516.9
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 736.6
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1394.9
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2098.9
   },
   {
    "Region Name": "Terai-Duar savanna and grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 909.4
   }
  ],
  "Texas blackland prairies": [
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 117.3
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Texas blackland prairies",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 39.0
   }
  ],
  "Thar desert": [
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 152.8
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 189.3
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 289.0
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 152.2
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 204.7
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 230.2
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 230.9
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 371.5
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 392.7
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 462.6
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 364.9
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 343.8
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 490.5
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 500.3
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 517.9
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 538.5
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 402.2
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 334.8
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 418.0
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 283.0
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 367.4
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 436.9
   },
   {
    "Region Name": "Thar desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 550.9
   }
  ],
  "Tian Shan foothill arid steppe": [
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1410.8
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2415.3
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 962.5
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1598.8
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1068.2
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2601.4
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 598.3
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 389.3
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 268.2
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 637.5
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 241.2
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 132.7
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 432.2
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 96.9
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 127.1
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 249.1
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 821.2
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 290.3
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 164.2
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 104.2
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Tian Shan foothill arid steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 119.6
   }
  ],
  "Tian Shan montane conifer forests": [
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 127.8
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 149.0
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Tian Shan montane conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30.0
   }
  ],
  "Tian Shan montane steppe and meadows": [
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 436.7
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 373.6
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 148.3
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 285.1
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 178.8
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 88.5
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 218.4
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 341.7
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 177.7
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 303.8
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 168.7
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 206.7
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 105.9
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Tian Shan montane steppe and meadows",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 104.6
   }
  ],
  "Tibesti-Jebel Uweinat montane xeric woodlands": [
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti-Jebel Uweinat montane xeric woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tibetan Plateau alpine shrublands and meadows": [
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Tibetan Plateau alpine shrublands and meadows",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tigris-Euphrates alluvial salt marsh": [
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 417.6
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 199.1
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 134.6
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 317.9
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 343.2
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 195.9
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1016.1
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 672.7
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 188.9
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 228.7
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 272.9
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 340.4
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 496.3
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1008.4
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 251.9
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 887.9
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 555.9
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 431.1
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 678.3
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 533.1
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 600.9
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 871.2
   },
   {
    "Region Name": "Tigris-Euphrates alluvial salt marsh",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 567.6
   }
  ],
  "Timor and Wetar deciduous forests": [
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 470.1
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 361.0
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 338.7
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 534.9
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 246.3
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 299.5
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 224.0
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 159.7
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 234.3
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 446.7
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 213.7
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 162.1
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 127.1
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 408.8
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 196.6
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 198.9
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 105.9
   },
   {
    "Region Name": "Timor and Wetar deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 44.8
   }
  ],
  "Tirari-Sturt stony desert": [
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 99.5
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 99.9
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 368.3
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 155.8
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 177.7
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Tirari-Sturt stony desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 68.8
   }
  ],
  "Tocantins-Pindare moist forests": [
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6769.8
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6090.2
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8956.8
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7173.2
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3267.6
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4081.4
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4193.9
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8225.6
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2149.9
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3729.6
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4062.9
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1613.6
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3334.1
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10568.2
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1194.0
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4795.0
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 480.2
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1791.5
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1471.6
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 656.4
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 858.3
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2750.1
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4177.4
   },
   {
    "Region Name": "Tocantins-Pindare moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 980.1
   }
  ],
  "Tongan tropical moist forests": [
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongan tropical moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tonle Sap freshwater swamp forests": [
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 705.1
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2987.4
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3015.3
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3525.5
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1681.9
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2037.6
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3290.3
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3337.7
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4509.0
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1957.2
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6159.0
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3705.2
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4761.6
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8811.4
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4219.6
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2407.8
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4701.1
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6544.3
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3243.0
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2856.7
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 783.3
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3817.7
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4078.6
   },
   {
    "Region Name": "Tonle Sap freshwater swamp forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2281.1
   }
  ],
  "Tonle Sap-Mekong peat swamp forests": [
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 382.9
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1174.7
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1336.8
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1489.7
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 766.2
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1140.4
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1438.8
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2177.6
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2562.1
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 925.9
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4300.9
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1583.5
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3699.8
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4922.1
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1941.3
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1552.5
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3477.9
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3942.7
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2879.6
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1848.7
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 472.9
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3272.8
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4041.5
   },
   {
    "Region Name": "Tonle Sap-Mekong peat swamp forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2121.2
   }
  ],
  "Torngat Mountain tundra": [
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 91.7
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 182.2
   },
   {
    "Region Name": "Torngat Mountain tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Trans Fly savanna and grasslands": [
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1310.4
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2270.2
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3777.4
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1223.6
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2501.3
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 108.3
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1156.5
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 444.8
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 847.8
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 465.4
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3016.4
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2800.3
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 117.7
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 202.8
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3999.7
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1242.5
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 461.8
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2262.5
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 119.8
   },
   {
    "Region Name": "Trans Fly savanna and grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Trans-Baikal Bald Mountain tundra": [
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 166.4
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4183.8
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 149.4
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 315.6
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 401.7
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 134.6
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1471.9
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 153.9
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1189.1
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 766.8
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 647.4
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2423.7
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 550.1
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 607.7
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 281.5
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 823.8
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 249.3
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 359.1
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 702.7
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1821.9
   },
   {
    "Region Name": "Trans-Baikal Bald Mountain tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1457.7
   }
  ],
  "Trans-Baikal conifer forests": [
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1474.4
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 23823.7
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 957.4
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2244.7
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5788.2
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8848.5
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8440.8
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7315.8
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 663.5
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4377.6
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1850.4
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 954.8
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14701.9
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10851.6
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1280.0
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1862.4
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 959.5
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 830.5
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3129.8
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 171.7
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 688.3
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 346.2
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1363.4
   },
   {
    "Region Name": "Trans-Baikal conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7800.5
   }
  ],
  "Trans-Mexican Volcanic Belt pine-oak forests": [
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 383.1
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 762.7
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 193.4
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1582.3
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 640.3
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 353.9
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 662.2
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 453.2
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 248.9
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 583.5
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 293.3
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 695.4
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 599.8
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 998.3
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 276.3
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 674.4
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 405.8
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 734.0
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 349.0
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 789.5
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 596.6
   },
   {
    "Region Name": "Trans-Mexican Volcanic Belt pine-oak forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 376.0
   }
  ],
  "Trindade-Martin Vaz Islands tropical forests": [
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trindade-Martin Vaz Islands tropical forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Trinidad and Tobago moist forests": [
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Trinidad and Tobago moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.6
   }
  ],
  "Tristan Da Cunha-Gough Islands shrub and grasslands": [
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan Da Cunha-Gough Islands shrub and grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Trobriand Islands rain forests": [
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 56.0
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Trobriand Islands rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.7
   }
  ],
  "Tuamotu tropical moist forests": [
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamotu tropical moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tubuai tropical moist forests": [
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tubuai tropical moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tumbes-Piura dry forests": [
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 245.0
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 139.8
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Tumbes-Piura dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 48.9
   }
  ],
  "Tyrrhenian-Adriatic Sclerophyllous and mixed forests": [
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 941.3
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 888.1
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 144.7
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 144.3
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1297.4
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 559.1
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 410.7
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 426.8
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 442.9
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1211.6
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 257.2
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 715.1
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 130.3
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 410.7
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 720.7
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 138.7
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 526.7
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 290.9
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1324.2
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 253.4
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 823.4
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 93.0
   },
   {
    "Region Name": "Tyrrhenian-Adriatic Sclerophyllous and mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 414.4
   }
  ],
  "Uatuma-Trombetas moist forests": [
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1191.5
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1242.7
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1779.0
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 828.1
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 681.1
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 310.6
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 733.8
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1395.3
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 195.5
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 582.4
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 645.3
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 231.3
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1012.3
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3664.0
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 532.5
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1632.6
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 478.5
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1177.3
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 331.2
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 205.8
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 323.3
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1518.4
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2515.0
   },
   {
    "Region Name": "Uatuma-Trombetas moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 428.1
   }
  ],
  "Ucayali moist forests": [
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 235.6
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 424.9
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 184.8
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 526.5
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 387.4
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 407.9
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 220.2
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 243.5
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 734.4
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 153.7
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 627.9
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 239.2
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 227.2
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 225.5
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 263.2
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 115.1
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 232.4
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 190.6
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 197.0
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 180.1
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 313.8
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 159.7
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 708.9
   },
   {
    "Region Name": "Ucayali moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 65.6
   }
  ],
  "Upper Gangetic Plains moist deciduous forests": [
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 520.1
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 992.3
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1512.2
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1263.1
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 982.0
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 958.7
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1612.3
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2452.2
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2486.9
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1984.0
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3193.2
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2060.5
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2424.5
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1568.5
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4096.2
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3604.8
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3237.6
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4328.5
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1913.2
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3798.8
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3890.4
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2266.1
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4749.6
   },
   {
    "Region Name": "Upper Gangetic Plains moist deciduous forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4115.7
   }
  ],
  "Upper Midwest forest-savanna transition": [
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 120.9
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 90.0
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 282.5
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Upper Midwest forest-savanna transition",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 80.0
   }
  ],
  "Ural montane forests and tundra": [
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 86.6
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 74.4
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 112.8
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 209.9
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 75.5
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 101.6
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Ural montane forests and tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Uruguayan savanna": [
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 407.9
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 716.0
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 945.4
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 451.2
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 436.2
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 387.4
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 698.8
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 397.7
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 562.9
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 447.4
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 487.5
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 326.1
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 216.1
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 563.4
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 493.9
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 430.2
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 299.9
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 761.2
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 832.0
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1307.4
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 675.0
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 310.4
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 406.4
   },
   {
    "Region Name": "Uruguayan savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 380.1
   }
  ],
  "Ussuri broadleaf and mixed forests": [
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3204.0
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6029.6
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2690.3
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8505.9
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2376.3
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5529.4
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11559.8
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7861.8
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1316.4
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4430.4
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3073.2
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1886.4
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8022.3
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2313.7
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4708.4
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2570.7
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7743.0
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5811.1
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2122.3
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2447.5
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1668.4
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3197.1
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3323.4
   },
   {
    "Region Name": "Ussuri broadleaf and mixed forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 237.9
   }
  ],
  "Valdivian temperate forests": [
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 218.4
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 301.2
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 209.0
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 409.9
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 380.1
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 539.8
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 307.0
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 361.9
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 755.0
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 222.7
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 470.5
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 873.3
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1372.2
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3937.3
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 85.7
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 210.7
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 577.9
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 398.5
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 779.4
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3118.6
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 393.8
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 697.3
   },
   {
    "Region Name": "Valdivian temperate forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1152.0
   }
  ],
  "Vanuatu rain forests": [
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vanuatu rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Venezuelan Andes montane forests": [
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 201.7
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1046.8
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 383.1
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 185.6
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 116.4
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 255.7
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 74.4
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 155.6
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 272.7
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 318.3
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 453.6
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 126.7
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 110.4
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 227.7
   },
   {
    "Region Name": "Venezuelan Andes montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 51.2
   }
  ],
  "Veracruz dry forests": [
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 159.1
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 108.9
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 164.4
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 157.8
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 166.1
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 194.6
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 249.1
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 203.0
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 228.5
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 115.8
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 265.8
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 200.6
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 230.2
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 187.1
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 148.8
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 293.3
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 202.1
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 152.4
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 185.0
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 278.9
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 163.3
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 169.8
   },
   {
    "Region Name": "Veracruz dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 142.3
   }
  ],
  "Veracruz moist forests": [
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 252.7
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 285.1
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 162.1
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 447.2
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 259.2
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 292.4
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 255.7
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 317.1
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 367.4
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 667.5
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 226.4
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 668.6
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 271.6
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 302.7
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 295.4
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 421.9
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 343.4
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 378.6
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 391.0
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 349.6
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 467.3
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 375.6
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 429.6
   },
   {
    "Region Name": "Veracruz moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 615.0
   }
  ],
  "Veracruz montane forests": [
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Veracruz montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Victoria Basin forest-savanna mosaic": [
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 20411.1
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16027.9
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21163.8
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19162.7
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10010.0
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16662.7
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12362.4
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13484.5
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15684.7
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16073.6
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11327.5
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16100.4
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14161.6
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15481.9
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17430.6
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11948.3
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13946.6
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4954.3
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13209.6
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11390.5
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11512.9
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8272.5
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12308.0
   },
   {
    "Region Name": "Victoria Basin forest-savanna mosaic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8550.5
   }
  ],
  "Victoria Plains tropical savanna": [
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 59126.0
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 20963.1
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 104239.3
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7204.7
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 62953.1
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 49333.6
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 20330.8
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 54196.8
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15494.6
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 70150.3
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 81071.4
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15654.7
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 60065.1
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33042.4
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15956.6
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 65262.7
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 36441.9
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4220.5
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2288.4
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 24779.1
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15820.9
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 74962.1
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 44622.2
   },
   {
    "Region Name": "Victoria Plains tropical savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 45946.6
   }
  ],
  "Vogelkop montane rain forests": [
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vogelkop montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vogelkop-Aru lowland rain forests": [
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 140.4
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 78.0
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 51.9
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 215.2
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Vogelkop-Aru lowland rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Wasatch and Uinta montane forests": [
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 504.4
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 97.5
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 214.6
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 140.8
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 417.8
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 161.0
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 378.1
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1102.1
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 344.3
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 397.4
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 304.2
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 114.7
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 97.3
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 245.0
   },
   {
    "Region Name": "Wasatch and Uinta montane forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 520.1
   }
  ],
  "West Saharan montane xeric woodlands": [
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Saharan montane xeric woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.3
   }
  ],
  "West Siberian taiga": [
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 552.0
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4374.2
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15734.9
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4976.6
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3737.7
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1201.8
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6678.7
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1468.9
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6869.0
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3678.1
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21740.7
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5634.9
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2631.8
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 331.0
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3463.8
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2994.3
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 585.9
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 633.9
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2260.5
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1907.5
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4832.1
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2963.2
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "West Siberian taiga",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 50.8
   }
  ],
  "West Sudanian savanna": [
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 309094.6
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 284506.9
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 326623.8
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 318904.3
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 330168.3
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 281274.9
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 259179.4
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 252442.2
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 248208.2
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 260821.5
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 215024.5
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 228579.1
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 207574.1
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 242905.2
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 224778.5
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 224470.3
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 195760.3
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 211965.3
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 218032.4
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 221504.3
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 199811.8
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 237673.3
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 210159.0
   },
   {
    "Region Name": "West Sudanian savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 201946.5
   }
  ],
  "Western Australian Mulga shrublands": [
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9677.9
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1374.7
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1200.9
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 582.9
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1644.0
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1909.2
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 319.4
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 280.6
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 312.1
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3652.2
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1103.4
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3081.1
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2283.5
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1188.7
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2195.8
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6494.5
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1073.8
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 292.0
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 96.5
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 890.1
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 213.5
   },
   {
    "Region Name": "Western Australian Mulga shrublands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 198.1
   }
  ],
  "Western Congolian forest-savanna mosaic": [
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 73316.8
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 95428.1
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 95696.7
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 94865.4
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 99837.2
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 94779.4
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 87273.0
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 91591.1
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 97639.5
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 97890.5
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 97346.7
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 94141.6
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 85029.7
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 97321.4
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 91050.0
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 96314.7
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 90891.4
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 92136.9
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 90309.8
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 85139.0
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 92776.8
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 82462.0
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 95798.5
   },
   {
    "Region Name": "Western Congolian forest-savanna mosaic",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 88450.8
   }
  ],
  "Western Congolian swamp forests": [
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 398.9
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1154.8
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1900.8
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1646.8
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2095.7
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1476.1
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1223.2
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1030.5
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2680.9
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2254.5
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2287.7
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2265.5
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1006.0
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2566.2
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1232.0
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1206.5
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1993.6
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1863.7
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2078.3
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2289.0
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1737.5
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1125.2
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3378.7
   },
   {
    "Region Name": "Western Congolian swamp forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1693.3
   }
  ],
  "Western Ecuador moist forests": [
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 81.7
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 408.8
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 182.4
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 156.3
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Western Ecuador moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.9
   }
  ],
  "Western European broadleaf forests": [
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 265.4
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 112.1
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 169.6
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 127.8
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 164.4
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Western European broadleaf forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 22.5
   }
  ],
  "Western Great Lakes forests": [
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 310.0
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 229.8
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 308.9
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 170.4
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 123.5
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 440.3
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 491.1
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 115.5
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 215.9
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 688.8
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Western Great Lakes forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 362.1
   }
  ],
  "Western Guinean lowland forests": [
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4162.2
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8262.2
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9161.7
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3669.8
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16956.8
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6911.7
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4731.1
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10312.9
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4665.1
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6323.7
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7686.2
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5405.1
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11712.9
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14040.1
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5568.7
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6645.7
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5622.5
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6801.5
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3367.5
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5530.3
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4631.9
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4097.0
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7079.5
   },
   {
    "Region Name": "Western Guinean lowland forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2802.7
   }
  ],
  "Western Gulf coastal grasslands": [
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 339.8
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 460.5
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 749.9
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1207.5
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 621.7
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 765.3
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 963.6
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 323.7
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1059.0
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 681.5
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 742.8
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 528.6
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 532.9
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 561.0
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 730.1
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 616.5
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 352.6
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 847.4
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 605.8
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 747.1
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1093.7
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 654.7
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 478.7
   },
   {
    "Region Name": "Western Gulf coastal grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 713.2
   }
  ],
  "Western Himalayan alpine shrub and Meadows": [
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Western Himalayan alpine shrub and Meadows",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Western Himalayan broadleaf forests": [
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 177.5
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 215.7
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 156.9
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 157.3
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 89.8
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 169.6
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 87.9
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 97.8
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 205.2
   },
   {
    "Region Name": "Western Himalayan broadleaf forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.3
   }
  ],
  "Western Himalayan subalpine conifer forests": [
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 92.8
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 205.8
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 78.0
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 146.2
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 177.1
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 84.0
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 259.0
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 238.8
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 246.1
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 259.4
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 189.3
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 282.3
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 242.0
   },
   {
    "Region Name": "Western Himalayan subalpine conifer forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 97.8
   }
  ],
  "Western Java montane rain forests": [
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 92.2
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Western Java montane rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Western Java rain forests": [
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 154.8
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 113.8
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 123.3
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 123.9
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Western Java rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.9
   }
  ],
  "Western Polynesian tropical moist forests": [
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Polynesian tropical moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Western Siberian hemiboreal forests": [
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1346.2
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2845.7
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15763.2
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2612.9
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7664.8
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2671.0
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14773.5
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7406.0
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9604.2
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7698.8
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9232.9
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1353.5
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7728.9
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 511.5
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1129.1
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1911.1
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1867.6
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1021.5
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4363.7
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8453.6
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11386.6
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10586.0
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 230.9
   },
   {
    "Region Name": "Western Siberian hemiboreal forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 572.4
   }
  ],
  "Western Zambezian grasslands": [
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10800.3
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13109.5
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14323.7
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13824.9
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12367.6
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13535.7
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13258.5
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11151.3
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13821.9
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14032.2
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15116.0
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13756.9
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13278.4
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13964.2
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13904.0
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13655.3
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12916.6
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13052.1
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13600.2
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14804.3
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13483.8
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14295.8
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13810.7
   },
   {
    "Region Name": "Western Zambezian grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14749.0
   }
  ],
  "Western short grasslands": [
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 199.4
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 330.3
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 398.1
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 591.9
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2910.1
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 438.4
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 974.3
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 604.7
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 645.7
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3677.1
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 551.6
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 156.5
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 262.4
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 558.4
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1786.3
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3393.5
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1838.2
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 504.6
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 637.1
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 461.8
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 759.1
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3289.5
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 494.8
   },
   {
    "Region Name": "Western short grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1346.2
   }
  ],
  "Westland temperate forests": [
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westland temperate forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Willamette Valley forests": [
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 191.0
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Willamette Valley forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 36.9
   }
  ],
  "Windward Islands moist forests": [
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Windward Islands moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Wrangel Island arctic desert": [
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wrangel Island arctic desert",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Wyoming Basin shrub steppe": [
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 99.7
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 78.2
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 147.1
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 408.2
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 197.2
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 138.3
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Wyoming Basin shrub steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 515.6
   }
  ],
  "Xingu-Tocantins-Araguaia moist forests": [
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13076.7
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5989.9
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8806.9
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16035.9
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6452.9
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 26528.4
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7224.2
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1492.2
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 24790.9
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2452.8
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5463.8
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1951.4
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2665.7
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5911.4
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2721.6
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16385.7
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 880.4
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5336.5
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8133.8
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1366.4
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6357.1
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2089.9
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13901.4
   },
   {
    "Region Name": "Xingu-Tocantins-Araguaia moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1391.3
   }
  ],
  "Yamal-Gydan tundra": [
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 404.3
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 95.8
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3005.5
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 216.3
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Yamal-Gydan tundra",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 26.6
   }
  ],
  "Yap tropical dry forests": [
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap tropical dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Yapen rain forests": [
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Yapen rain forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Yarlung Tsangpo arid steppe": [
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yarlung Tsangpo arid steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Yellow Sea saline meadow": [
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 90.2
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 98.8
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 228.9
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Yellow Sea saline meadow",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.0
   }
  ],
  "Yucatan dry forests": [
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2486.3
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3087.1
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 564.6
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 927.4
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 836.3
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 719.4
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1245.9
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 534.0
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 323.5
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1067.1
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 248.9
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 618.2
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 291.3
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 593.2
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 536.6
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 289.4
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 219.5
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 424.9
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 468.8
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 179.9
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 283.4
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 529.3
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 656.2
   },
   {
    "Region Name": "Yucatan dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 431.1
   }
  ],
  "Yucatan moist forests": [
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 778.2
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2641.2
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 230.4
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 961.2
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1627.9
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 595.5
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 776.0
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1478.7
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 604.9
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1686.7
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 258.5
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1483.6
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 101.6
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1286.6
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1193.6
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 870.1
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 251.7
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 969.4
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1729.7
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 196.8
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 328.6
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 735.7
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1651.7
   },
   {
    "Region Name": "Yucatan moist forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 598.1
   }
  ],
  "Yukon Interior dry forests": [
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 489.4
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 517.5
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 361.2
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 450.2
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 195.9
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 104.6
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 119.6
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 153.3
   },
   {
    "Region Name": "Yukon Interior dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 92.8
   }
  ],
  "Yunnan Plateau subtropical evergreen forests": [
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 398.5
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 929.7
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 915.1
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 487.3
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 685.1
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 650.4
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 994.5
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3317.8
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1769.2
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 646.8
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1226.0
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 914.5
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 908.9
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1050.8
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 737.2
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 575.2
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 409.7
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 448.0
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 827.5
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 480.8
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1632.4
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1091.4
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 377.9
   },
   {
    "Region Name": "Yunnan Plateau subtropical evergreen forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 375.4
   }
  ],
  "Zagros Mountains forest steppe": [
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2193.2
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1841.4
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1725.5
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1625.3
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1604.8
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3255.6
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 722.2
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 862.0
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4430.1
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1246.8
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 664.3
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1080.8
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1423.4
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1886.7
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1875.7
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1242.7
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1044.0
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2145.2
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2652.6
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1422.6
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 295.0
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2485.4
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4147.2
   },
   {
    "Region Name": "Zagros Mountains forest steppe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1987.4
   }
  ],
  "Zambezian Baikiaea woodlands": [
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 96515.8
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 106399.5
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 114989.9
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 105663.1
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 76915.4
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 101553.7
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 91999.5
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 84700.2
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 99912.0
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 115191.6
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 105550.4
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 99243.2
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 89582.2
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 86467.9
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 86298.7
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 89443.1
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 71555.1
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 60896.2
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 66513.6
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 67182.8
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 74591.6
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 76680.0
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 73900.5
   },
   {
    "Region Name": "Zambezian Baikiaea woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 67305.6
   }
  ],
  "Zambezian Cryptosepalum dry forests": [
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4024.6
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5971.7
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5535.4
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7048.9
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4926.8
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5572.3
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5900.3
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4576.1
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6197.6
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6011.5
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6331.6
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5767.0
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5378.9
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7010.5
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6612.6
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6249.9
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5785.2
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7408.2
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6300.9
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6582.8
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6642.7
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6338.7
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9221.9
   },
   {
    "Region Name": "Zambezian Cryptosepalum dry forests",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8652.1
   }
  ],
  "Zambezian and Mopane woodlands": [
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 80143.8
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 71313.1
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 90756.1
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 73866.0
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 78847.5
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 76169.8
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 85202.5
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 73176.8
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 81698.8
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 86371.6
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 69491.1
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 66631.0
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 80011.3
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 78161.3
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 46697.9
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 61263.9
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 65677.1
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 60324.5
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 47532.9
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 69215.2
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 65447.5
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 63597.3
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 51788.1
   },
   {
    "Region Name": "Zambezian and Mopane woodlands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 44004.2
   }
  ],
  "Zambezian coastal flooded savanna": [
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5736.9
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6299.7
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4066.6
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6548.3
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6349.4
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6222.1
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6869.0
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6777.1
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6229.6
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6021.8
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6302.7
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6085.3
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4847.3
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5927.7
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6450.6
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4883.5
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5585.0
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4951.1
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5594.0
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5817.1
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4141.6
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4678.4
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5269.4
   },
   {
    "Region Name": "Zambezian coastal flooded savanna",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4092.3
   }
  ],
  "Zambezian flooded grasslands": [
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 52792.4
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 52257.8
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 55003.4
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 60108.2
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 49223.2
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 49309.2
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 49986.8
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 42535.7
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 47793.4
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 50561.5
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 48791.9
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 44996.9
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 46889.4
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 49495.7
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 48576.0
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 47125.0
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 39703.7
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 45193.3
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 35634.6
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 41759.3
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 42342.8
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 40716.4
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 38727.0
   },
   {
    "Region Name": "Zambezian flooded grasslands",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 38545.7
   }
  ],
  "Zambezian halophytics": [
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 795.1
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 143.2
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 603.2
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1118.4
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 461.8
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 796.8
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 493.9
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4811.9
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 547.5
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1723.7
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 128.8
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1208.8
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 348.6
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1176.0
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1625.6
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 995.5
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 146.8
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2662.9
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2375.0
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1676.8
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1038.4
   },
   {
    "Region Name": "Zambezian halophytics",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 772.4
   }
  ]
 },
 "Global": {
  "Global": [
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4687410.6
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4296924.6
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4724339.3
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4362810.0
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4509807.3
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4602730.5
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4102748.1
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3867470.6
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4193863.9
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4673502.1
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4498245.4
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3503091.9
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3796433.8
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3959637.9
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3455750.5
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3890565.0
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3604111.2
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3576891.0
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3396105.5
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3564662.4
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3264010.9
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3911604.2
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3653785.0
   },
   {
    "Region Name": "Global",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3289962.6
   }
  ]
 },
 "Global Fire Emissions Database Regions": {
  "Australia": [
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 748492.5
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 285559.4
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 652066.8
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 267156.9
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 588219.1
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 518392.9
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 302017.8
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 415191.2
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 180669.3
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 929510.8
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 876614.6
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 266659.6
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 464240.5
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 418730.2
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 236740.5
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 502221.1
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 560767.4
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 342327.4
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 137966.0
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 279606.8
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 271261.9
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 738948.8
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 378931.5
   },
   {
    "Region Name": "Australia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 477030.6
   }
  ],
  "Boreal Asia": [
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 100506.0
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 201492.5
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 68088.3
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 64174.8
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 88820.4
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 59979.2
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 165035.0
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 72867.5
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 73413.5
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 103379.5
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 125857.5
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 58837.2
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 154713.5
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 69136.1
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 80731.2
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 55163.8
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 101488.5
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 90489.2
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 86989.9
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 115509.3
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 63987.6
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 67665.8
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 85752.1
   },
   {
    "Region Name": "Boreal Asia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 38115.7
   }
  ],
  "Boreal North America": [
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30621.8
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 20883.0
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 44063.8
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 29714.5
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19312.7
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15791.5
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14846.8
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13898.4
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26923.9
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16559.4
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16706.2
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 41236.2
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 32246.9
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 42572.8
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10814.7
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 30967.3
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18890.0
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19592.0
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2828.6
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 37284.1
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18521.9
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 134476.7
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 48295.0
   },
   {
    "Region Name": "Boreal North America",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 47649.5
   }
  ],
  "Central America": [
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24187.9
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 49966.8
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21447.2
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 44128.9
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25562.6
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 28361.0
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 27540.6
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 28746.5
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19861.7
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 42641.6
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21467.8
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 28632.2
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16605.2
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 19341.7
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25964.6
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 26137.2
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22343.9
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 30203.3
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 32115.9
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20943.9
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 20487.9
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 31651.4
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 34655.5
   },
   {
    "Region Name": "Central America",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 21629.0
   }
  ],
  "Central Asia": [
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 345939.9
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 192377.7
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 225014.4
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 265685.7
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 276253.9
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 220613.1
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 254420.6
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 169621.8
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 216652.5
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 112027.5
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 160538.8
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 80792.7
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 195620.3
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 189118.5
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 79467.4
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 240764.7
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 102465.2
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 146662.9
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 99948.3
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 99052.4
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 76818.9
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 72998.6
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 73816.9
   },
   {
    "Region Name": "Central Asia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 73429.7
   }
  ],
  "Equatorial Asia": [
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 31306.2
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11964.1
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 34136.5
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9600.9
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35716.9
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5307.6
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4475.0
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 21388.5
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3760.5
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9695.5
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10778.3
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9668.0
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 24332.0
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 34755.9
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3282.2
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3659.1
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11664.9
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23249.4
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3020.0
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1975.2
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2009.1
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14575.4
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2969.7
   },
   {
    "Region Name": "Equatorial Asia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1866.9
   }
  ],
  "Europe": [
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6945.1
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13906.1
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10593.7
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10881.6
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10297.9
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14553.5
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13182.8
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6815.4
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8335.5
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11748.3
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14048.7
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6968.1
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6781.8
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5706.3
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9153.6
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14709.1
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6364.0
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7488.3
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3977.2
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7557.6
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8125.9
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3672.8
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5975.5
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10063.6
   }
  ],
  "Middle East": [
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11635.5
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12206.0
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11981.3
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11673.7
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13856.0
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14700.1
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9164.9
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18557.9
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20575.8
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15353.5
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9893.6
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12516.8
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10652.9
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20860.9
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16274.3
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11882.0
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7545.4
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 35014.2
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21463.5
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14561.4
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7495.0
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14627.9
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20077.6
   },
   {
    "Region Name": "Middle East",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11044.5
   }
  ],
  "Northern Hemisphere Africa": [
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1430623.0
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1401153.5
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1504379.5
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1456447.9
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1480386.9
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1421614.6
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1239223.9
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1242333.3
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1222884.5
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1282682.9
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1164757.7
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1121258.8
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1071007.5
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1217356.3
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1124591.3
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1078347.7
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1088760.6
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1009294.5
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1088547.1
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1066345.4
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 969827.0
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1024643.5
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1036540.4
   },
   {
    "Region Name": "Northern Hemisphere Africa",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 987313.9
   }
  ],
  "Northern Hemisphere South America": [
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 60189.2
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 82653.6
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 42782.9
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 57455.6
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 75750.1
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 48529.9
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 46072.8
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 67892.4
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37945.9
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 30611.5
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 44563.9
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 51990.3
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 44591.8
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 61593.6
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 37271.9
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 57069.7
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 56779.3
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 66417.5
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 62171.3
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 50656.9
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 44292.1
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 73431.5
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 65323.0
   },
   {
    "Region Name": "Northern Hemisphere South America",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 41310.0
   }
  ],
  "Southeast Asia": [
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 87324.7
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 140151.9
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 195570.6
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 121479.9
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 131055.3
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 151134.4
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 147238.3
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 144689.6
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 169290.8
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 135463.4
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 156002.5
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 132002.4
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 152723.1
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 147373.3
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 147542.0
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 127329.4
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 137105.1
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 145724.0
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 150525.0
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 133078.6
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 127953.0
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 126152.9
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 128710.8
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 136867.5
   }
  ],
  "Southern Hemisphere Africa": [
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1433102.4
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1573505.5
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1560208.9
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1644366.1
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1500423.3
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1543645.4
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1591974.7
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1483844.2
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1696768.8
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1700678.9
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1549738.2
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1503573.2
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1402395.4
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1445212.8
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1395515.6
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1392560.7
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1302948.5
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1347551.8
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1305480.6
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1413290.0
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1401945.0
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1376458.2
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1345540.0
   },
   {
    "Region Name": "Southern Hemisphere Africa",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1276273.9
   }
  ],
  "Southern Hemisphere South America": [
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 356396.4
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 284822.9
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 334201.9
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 349502.7
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 227126.7
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 521440.6
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 258103.7
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 157702.9
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 493096.7
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 240339.8
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 310339.9
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 170049.5
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 196850.1
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 258502.0
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 258527.5
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 311375.9
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 151271.4
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 290113.9
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 350487.1
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 286728.2
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 224162.4
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 210571.2
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 393079.4
   },
   {
    "Region Name": "Southern Hemisphere South America",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 143787.1
   }
  ],
  "Temperate North America": [
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19763.5
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 25548.5
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 19335.0
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 29831.6
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 36185.5
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 38034.0
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 28558.5
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 23161.7
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 23244.5
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 42482.4
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 36524.0
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18554.7
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23387.4
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 28657.9
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 28899.5
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 37636.1
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 35037.1
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 22341.3
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 50513.1
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 37591.5
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 26990.1
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21525.9
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 33858.3
   },
   {
    "Region Name": "Temperate North America",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 23500.8
   }
  ]
 },
 "Hemispheres": {
  "Northern Hemisphere": [
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2120832.7
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2143000.8
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2149384.3
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2095508.2
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2160414.4
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2014845.9
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1947008.2
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1792898.3
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1820637.4
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1794390.1
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1751710.5
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1557381.4
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1712023.7
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1805138.8
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1563154.7
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1680936.6
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1578480.2
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1575520.0
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1599559.3
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1583341.9
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1364802.3
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1571580.3
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1533728.1
   },
   {
    "Region Name": "Northern Hemisphere",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1391709.5
   }
  ],
  "Southern Hemisphere": [
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2566577.9
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2153923.8
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2574955.0
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2267301.8
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2349392.9
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2587884.6
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2155739.9
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2074572.3
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2373226.5
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2879112.0
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2746534.9
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1945710.6
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2084410.1
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2154499.1
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1892595.7
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2209628.4
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2025631.0
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2001371.1
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1796546.2
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1981320.5
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1899208.6
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2340023.9
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2120056.9
   },
   {
    "Region Name": "Southern Hemisphere",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1898253.1
   }
  ]
 },
 "Hemispheres and Tropics": {
  "Northern Hemisphere Extratropics": [
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 523622.4
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 469774.2
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 386129.8
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 420300.7
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 452270.4
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 369590.6
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 485440.5
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 311804.0
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 377073.4
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 312967.6
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 376287.5
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 230681.8
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 436551.3
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 369031.5
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 245124.3
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 401181.7
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 288486.7
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 336078.1
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 282143.7
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 326846.5
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 216590.3
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 326583.2
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 274741.1
   },
   {
    "Region Name": "Northern Hemisphere Extratropics",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 212671.2
   }
  ],
  "Northern Hemisphere Tropics": [
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1597210.3
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1673226.6
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1763254.5
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1675207.6
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1708144.1
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1645255.3
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1461567.6
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1481094.3
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1443564.1
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1481422.5
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1375423.0
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1326699.5
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1275472.4
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1436107.2
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1318030.4
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1279754.8
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1289993.5
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1239441.9
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1317415.6
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1256495.4
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1148212.0
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1244997.1
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1258987.0
   },
   {
    "Region Name": "Northern Hemisphere Tropics",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1179038.3
   }
  ],
  "Southern Hemisphere Extratropics": [
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 76454.9
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 33279.7
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 38980.6
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 32008.1
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 43602.7
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22441.2
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 32104.5
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 32668.3
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18498.8
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 39985.2
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27504.8
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 38768.8
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28546.2
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 28511.1
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 50586.4
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 46736.9
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 31438.9
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 86953.9
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 23903.0
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28645.3
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 28541.5
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 26922.6
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 30688.6
   },
   {
    "Region Name": "Southern Hemisphere Extratropics",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 29707.7
   }
  ],
  "Southern Hemisphere Tropics": [
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2490123.0
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2120644.0
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2535974.3
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2235293.7
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2305790.3
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2565443.4
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2123635.4
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2041904.0
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2354727.7
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2839126.8
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2719030.0
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1906941.7
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2055863.9
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2125988.1
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1842009.4
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2162891.5
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1994192.1
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1914417.2
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1772643.2
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1952675.2
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1870667.1
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2313101.3
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2089368.3
   },
   {
    "Region Name": "Southern Hemisphere Tropics",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1868545.5
   }
  ]
 },
 "IPCC Regions": {
  "ARP": [
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 599.6
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 307.6
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 392.9
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 705.1
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 465.2
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 298.2
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 142.6
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 233.7
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 347.1
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 116.0
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 141.1
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 56.0
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 65.4
   },
   {
    "Region Name": "ARP",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 118.1
   }
  ],
  "CAF": [
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 851861.0
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 902986.1
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 928729.0
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 911210.6
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 937283.4
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 867886.4
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 834408.6
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 816947.2
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 836899.4
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 825666.0
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 763212.6
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 760060.1
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 718746.2
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 767061.2
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 768298.7
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 740122.3
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 735176.1
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 726478.5
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 749963.9
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 713990.9
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 710759.9
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 669570.9
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 710175.3
   },
   {
    "Region Name": "CAF",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 660877.3
   }
  ],
  "CAR": [
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1766.4
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3020.9
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4845.2
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3345.2
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3708.2
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2664.8
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2387.2
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3713.7
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1917.5
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2816.0
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1828.1
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1616.6
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1474.9
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2116.3
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1568.5
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1379.9
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1127.4
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1185.0
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2752.7
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2018.1
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3019.0
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1920.5
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3311.4
   },
   {
    "Region Name": "CAR",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2720.8
   }
  ],
  "CAU": [
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 312851.8
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 23917.8
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 73804.5
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13165.0
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 142917.9
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 92596.5
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18252.4
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27523.5
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15326.7
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 382341.0
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 315239.9
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 30809.1
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 86554.3
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 73827.4
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16907.1
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 153856.3
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 177239.0
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 33032.3
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6313.6
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28154.6
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 33189.9
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 237271.8
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 68805.8
   },
   {
    "Region Name": "CAU",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 96570.2
   }
  ],
  "CNA": [
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4094.9
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11030.4
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7814.0
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11078.4
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11431.4
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8077.2
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11487.4
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12995.5
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12521.5
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18899.8
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6361.2
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4370.6
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9983.2
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10690.4
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13628.1
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10573.3
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9070.6
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10868.7
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13257.4
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8707.2
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11574.2
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12136.3
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8274.4
   },
   {
    "Region Name": "CNA",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8874.9
   }
  ],
  "EAN": [
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "EAN",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "EAS": [
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13441.6
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 24969.5
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 31815.1
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 32825.5
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 46595.9
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 51006.1
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 25672.2
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 34661.8
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 43783.8
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 29057.5
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 51230.8
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35523.7
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 33353.7
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 23671.9
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12155.6
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16155.7
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11327.0
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10583.4
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22139.4
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15788.3
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15014.0
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23261.2
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20619.9
   },
   {
    "Region Name": "EAS",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10162.6
   }
  ],
  "EAU": [
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19023.1
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6222.3
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15126.3
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10849.2
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11555.1
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2999.7
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11184.1
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27821.0
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3703.2
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 47311.5
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 35859.4
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18948.1
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6595.1
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8138.5
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8755.9
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10984.5
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12678.0
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 36282.6
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6833.2
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7703.4
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6502.0
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 20926.7
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14751.4
   },
   {
    "Region Name": "EAU",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13183.1
   }
  ],
  "ECA": [
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2258.8
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2234.2
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2155.7
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2445.7
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1441.2
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2810.2
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 414.4
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1266.5
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 660.0
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 478.7
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 704.2
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 916.0
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1230.5
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1061.8
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 411.2
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1429.4
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1763.2
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 907.4
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 491.3
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 260.9
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 433.9
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 461.1
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 826.4
   },
   {
    "Region Name": "ECA",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 510.4
   }
  ],
  "EEU": [
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 101642.6
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 38801.4
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 72752.6
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 75394.0
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 103922.0
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 62135.3
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 70355.9
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 61894.5
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 76943.5
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20166.3
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 23286.7
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7381.6
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 43816.4
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31195.0
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12597.4
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 71637.6
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22379.7
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19720.2
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18585.8
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12112.5
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13858.3
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8903.8
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9175.4
   },
   {
    "Region Name": "EEU",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9415.1
   }
  ],
  "ENA": [
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3730.2
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3860.1
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6439.0
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6131.0
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6394.2
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8555.7
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6433.4
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4802.7
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6381.1
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7604.1
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5245.0
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5136.3
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4858.0
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5135.4
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5355.8
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5431.7
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4899.6
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4764.4
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4932.6
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5818.4
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4802.3
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11405.5
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4250.3
   },
   {
    "Region Name": "ENA",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4486.7
   }
  ],
  "ESAF": [
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 482383.4
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 505088.3
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 494882.6
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 546388.9
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 489646.7
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 513969.6
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 568923.5
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 485274.4
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 579079.9
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 526555.6
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 513157.8
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 516589.0
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 500252.8
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 507626.4
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 451851.5
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 441006.6
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 464123.7
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 458185.7
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 413639.1
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 436989.5
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 485253.0
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 439244.2
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 437559.1
   },
   {
    "Region Name": "ESAF",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 409585.2
   }
  ],
  "ESB": [
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 80392.4
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 167554.2
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 29381.6
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 38702.6
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 57880.7
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 52823.1
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 94926.5
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27102.9
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14687.1
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 83354.2
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 63604.8
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 39141.4
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 146955.3
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 94248.8
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 72134.5
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 66051.2
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 78573.7
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 57004.6
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 41791.7
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 66968.4
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 34657.7
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 46813.3
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 85814.5
   },
   {
    "Region Name": "ESB",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 50097.8
   }
  ],
  "GIC": [
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "GIC",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "MDG": [
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 34268.6
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 60986.3
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 35679.1
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 60041.1
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 40603.2
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 59230.2
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 36643.6
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 44912.2
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 42706.2
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 41995.3
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 43012.5
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 40040.9
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 33291.5
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 34928.2
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 49197.3
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31689.3
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 32634.0
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 35420.2
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 37328.3
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 30505.4
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 30269.3
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 29056.0
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 39797.8
   },
   {
    "Region Name": "MDG",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 31321.5
   }
  ],
  "MED": [
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7540.9
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15223.4
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13541.9
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14105.5
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13658.1
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 17580.0
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11585.4
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14732.9
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12279.5
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16061.2
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15634.6
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10802.5
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7704.6
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10647.5
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10713.7
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15959.1
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4348.0
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12430.0
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9586.8
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13364.2
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9276.8
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8401.3
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8641.4
   },
   {
    "Region Name": "MED",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12960.1
   }
  ],
  "NAU": [
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 383037.5
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 251343.6
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 540761.5
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 233681.1
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 410338.7
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 416543.6
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 266293.2
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 349942.0
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 156021.6
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 478189.7
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 513685.4
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 205101.0
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 361629.6
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 325828.2
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 205068.0
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 321562.9
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 354723.5
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 219476.1
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 122067.9
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 237284.8
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 225683.2
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 472755.9
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 283681.8
   },
   {
    "Region Name": "NAU",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 355380.7
   }
  ],
  "NCA": [
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7548.8
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9857.1
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5905.0
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14286.4
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8415.7
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9383.1
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12719.4
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8029.2
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5823.3
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 30229.2
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10992.4
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8881.7
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3575.0
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3847.9
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7329.5
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11384.3
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8621.3
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9340.7
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8241.6
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10470.2
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9218.7
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8395.5
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8284.9
   },
   {
    "Region Name": "NCA",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7852.6
   }
  ],
  "NEAF": [
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 419969.5
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 400335.0
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 403543.4
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 445931.0
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 385638.3
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 428767.6
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 370010.8
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 391659.2
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 353189.9
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 391569.6
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 382153.5
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 357126.5
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 350592.1
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 388420.3
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 369042.0
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 350612.5
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 386374.2
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 287100.1
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 348920.9
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 326392.9
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 303303.4
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 325159.2
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 327827.0
   },
   {
    "Region Name": "NEAF",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 322260.1
   }
  ],
  "NEN": [
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16739.9
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11632.5
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 909.8
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9230.5
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4603.6
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6682.7
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5945.7
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2015.3
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7632.4
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6734.4
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5534.4
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 29184.2
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2171.3
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2638.7
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 967.4
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6066.2
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4770.1
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3012.1
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 705.9
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 21982.3
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2206.1
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 43151.6
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9497.0
   },
   {
    "Region Name": "NEN",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 21226.6
   }
  ],
  "NES": [
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 99421.8
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 67426.6
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 89448.9
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 95684.0
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 45959.2
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 185474.6
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 66076.5
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 42397.9
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 165026.4
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 79668.5
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 149394.0
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 47600.4
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 90053.6
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 118025.6
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 69038.0
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 93354.5
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 41011.1
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 79580.4
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 72182.5
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 72340.7
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 62741.3
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 53422.7
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 68864.3
   },
   {
    "Region Name": "NES",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 68543.8
   }
  ],
  "NEU": [
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 913.6
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1271.0
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 460.3
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 358.2
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1761.9
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 644.2
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 727.6
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 329.5
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 363.6
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 625.1
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 144.9
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 437.1
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 501.6
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 263.2
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 110.4
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 835.6
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 333.8
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 171.9
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 109.8
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 137.8
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "NEU",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 211.8
   }
  ],
  "NSA": [
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 57886.3
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 71282.8
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 46503.5
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 61555.4
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 67882.1
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 49794.5
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 47724.8
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 64607.2
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 42141.1
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 29585.3
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 44250.3
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 46850.1
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 45830.4
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 63776.9
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 34775.4
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 59002.3
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 53342.9
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 67731.0
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 67861.1
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 49106.6
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 52199.5
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 81112.9
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 88176.0
   },
   {
    "Region Name": "NSA",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 40929.9
   }
  ],
  "NWN": [
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13214.3
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7602.0
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 42861.4
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18605.3
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13390.3
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7552.2
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8995.4
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11216.0
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17185.5
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9602.4
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10216.4
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11820.1
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 29850.5
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 39384.1
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9380.4
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24069.4
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12530.3
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16374.6
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 951.6
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13414.6
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15788.7
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 83086.2
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 38482.7
   },
   {
    "Region Name": "NWN",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 25751.9
   }
  ],
  "NWS": [
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9329.1
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17243.2
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4381.9
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9366.4
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13092.4
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8111.7
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4947.6
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7635.8
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6615.4
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3946.5
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6631.5
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6686.4
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3532.6
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8344.1
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8101.6
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10111.6
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6657.2
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6709.7
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7866.5
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7316.8
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5462.3
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4381.5
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6949.0
   },
   {
    "Region Name": "NWS",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2557.4
   }
  ],
  "NZ": [
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "NZ",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30.7
   }
  ],
  "RAR": [
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2030.3
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14401.5
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 491.1
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4782.4
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1326.1
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 904.0
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1197.5
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1499.5
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4180.8
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1741.7
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3216.0
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14745.2
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2992.6
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 657.3
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6831.1
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2147.5
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9422.2
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16270.2
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25745.9
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17051.6
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1939.8
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5640.9
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11740.6
   },
   {
    "Region Name": "RAR",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1442.3
   }
  ],
  "RFE": [
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18500.5
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37269.8
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8401.3
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20977.9
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8665.9
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15918.2
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 39242.6
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27721.3
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21516.6
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18853.5
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 45960.1
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9966.4
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21538.5
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13359.7
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15436.5
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14616.8
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 23677.9
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17787.3
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18880.5
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 25849.0
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15519.5
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 26138.7
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16504.1
   },
   {
    "Region Name": "RFE",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5242.6
   }
  ],
  "SAH": [
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8050.8
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19249.3
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25029.1
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 32100.9
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25313.1
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37582.5
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 26210.7
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 21847.2
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 35854.1
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14854.3
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 23772.7
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18317.0
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11349.8
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14745.2
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13377.5
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9835.0
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13148.3
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13712.3
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 32288.7
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 31041.9
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 32761.6
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 32232.1
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 54512.1
   },
   {
    "Region Name": "SAH",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 64531.3
   }
  ],
  "SAM": [
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 146848.6
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 97745.6
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 153310.1
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 153937.5
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 101295.1
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 221896.4
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 93590.9
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 48462.6
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 250467.7
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 74309.3
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 95908.0
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 53131.6
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 61150.0
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 84931.7
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 100403.8
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 111601.6
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 54355.2
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 140743.1
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 153826.0
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 106596.1
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 98188.1
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 100458.5
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 228126.3
   },
   {
    "Region Name": "SAM",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 41511.7
   }
  ],
  "SAS": [
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16403.7
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 43528.7
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 71729.8
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 30771.0
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35756.7
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 55295.0
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 58761.3
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 59355.1
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 64950.8
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 59745.7
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 56336.4
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 45486.1
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 51673.0
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 50788.7
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 45084.2
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 55460.5
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 49403.9
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 46883.6
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 58295.5
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 67149.6
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 61358.2
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 42956.5
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 49339.2
   },
   {
    "Region Name": "SAS",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 83880.2
   }
  ],
  "SAU": [
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 33636.4
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4091.0
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22416.8
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9507.1
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23463.5
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6245.4
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6320.2
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10008.0
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5630.4
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21680.9
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11849.7
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11828.7
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9477.0
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10930.0
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6036.4
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15865.4
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16123.1
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 53552.6
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2689.3
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6445.2
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5896.6
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8005.6
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11692.8
   },
   {
    "Region Name": "SAU",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11897.5
   }
  ],
  "SCA": [
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15677.7
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 38632.9
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11591.8
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 28217.2
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14451.9
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 18254.4
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15000.0
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18393.1
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13073.3
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17901.5
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10904.5
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 19130.3
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12221.2
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14072.3
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17997.6
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14623.8
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14429.2
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 21173.2
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 24249.4
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10808.3
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11016.9
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22086.0
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 24156.4
   },
   {
    "Region Name": "SCA",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11825.9
   }
  ],
  "SEA": [
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 82959.9
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 82965.7
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 122542.1
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 71545.2
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 104403.5
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 67466.2
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 70730.0
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 79122.5
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 75082.1
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 61777.9
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 79754.9
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 64484.6
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 97039.1
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 103445.3
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 61825.1
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 54908.5
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 72918.9
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 90330.8
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 61627.4
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 39167.1
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 39769.5
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 65227.3
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 56093.1
   },
   {
    "Region Name": "SEA",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 36009.1
   }
  ],
  "SEAF": [
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 218219.1
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 260794.7
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 254341.5
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 264360.3
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 204711.5
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 234165.3
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 222908.4
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 224843.3
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 244129.4
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 218601.9
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 219080.8
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 204007.7
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 191453.0
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 210199.5
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 202100.7
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 184330.3
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 163451.2
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 172902.3
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 176938.9
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 176593.1
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 161113.7
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 149096.4
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 156114.2
   },
   {
    "Region Name": "SEAF",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 152206.3
   }
  ],
  "SES": [
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 99908.0
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 111939.2
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 81758.6
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 85002.0
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 73508.4
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 103760.4
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 90473.4
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 61450.2
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 65789.0
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 81661.9
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 57628.8
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 66460.4
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 38666.8
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 41947.5
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 75688.1
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 93201.4
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 51166.9
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 59625.0
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 109413.5
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 99241.3
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 45132.8
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 43118.2
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 64543.7
   },
   {
    "Region Name": "SES",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 29371.1
   }
  ],
  "SSA": [
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2312.0
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 689.0
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 523.1
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 117.3
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 180.1
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 198.3
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 340.2
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 196.1
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 545.8
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 346.4
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2221.7
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 546.6
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 464.8
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 410.7
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 203.7
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 903.1
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 344.3
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 176.2
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 304.4
   },
   {
    "Region Name": "SSA",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 301.6
   }
  ],
  "SWS": [
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 880.4
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1472.3
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1054.7
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1270.8
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 969.4
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 849.5
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1150.3
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1008.4
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1002.6
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1439.1
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1029.6
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1107.0
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1696.7
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2727.8
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5640.3
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 616.5
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1060.1
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1769.2
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1320.1
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1882.2
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4386.8
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1313.9
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1407.3
   },
   {
    "Region Name": "SWS",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1881.5
   }
  ],
  "TIB": [
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12194.0
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15968.6
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17092.9
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17322.5
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14136.1
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15905.5
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16366.9
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18620.5
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18280.5
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17667.4
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20756.5
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20609.2
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19127.7
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14562.9
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 27292.2
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13825.3
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17404.8
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20147.3
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16828.4
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20133.1
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18535.8
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14886.6
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12441.5
   },
   {
    "Region Name": "TIB",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10382.1
   }
  ],
  "WAF": [
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 461395.0
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 440565.8
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 529007.6
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 437460.5
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 522021.3
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 427145.2
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 359192.8
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 377198.5
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 364066.9
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 392787.9
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 334981.1
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 343281.7
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 326702.6
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 391709.8
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 328335.9
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 333388.2
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 290349.7
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 335747.7
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 304660.2
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 333420.8
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 274753.7
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 328371.7
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 304417.3
   },
   {
    "Region Name": "WAF",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 275668.9
   }
  ],
  "WAN": [
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "WAN",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "WCA": [
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 28448.3
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 28666.9
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 35706.6
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25188.6
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 26745.7
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 32442.6
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16010.1
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 23100.4
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 29244.2
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19039.2
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15476.4
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 19290.6
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18319.5
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31379.5
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 26381.3
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19681.2
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22332.3
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 50272.7
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 31089.9
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 19350.2
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15074.0
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18629.7
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23851.8
   },
   {
    "Region Name": "WCA",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 21485.1
   }
  ],
  "WCE": [
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 43813.0
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12060.8
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23345.9
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 42958.5
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 34279.7
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37116.3
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 70961.9
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 48833.5
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26407.3
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20964.2
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15114.7
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15032.0
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 40643.3
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33398.3
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 20048.4
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 29159.3
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 28638.0
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 30161.1
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17513.7
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9395.6
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12351.3
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10218.1
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18159.2
   },
   {
    "Region Name": "WCE",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14968.1
   }
  ],
  "WNA": [
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11807.0
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10447.5
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4463.6
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12792.9
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18655.9
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21014.2
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8307.4
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4613.9
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5496.0
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7899.9
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 23619.0
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8286.4
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8069.9
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12691.7
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9367.9
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21209.5
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20816.7
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5388.0
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 30352.1
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 22600.1
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8376.9
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5501.8
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20684.3
   },
   {
    "Region Name": "WNA",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10080.3
   }
  ],
  "WSAF": [
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 387908.2
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 385264.0
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 393817.7
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 403919.0
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 376363.8
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 397332.5
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 413415.1
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 364088.6
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 464038.4
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 571690.0
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 435497.3
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 385714.1
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 341169.5
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 348545.8
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 338832.1
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 380645.8
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 307068.4
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 327682.1
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 330325.7
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 431002.4
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 373698.1
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 428687.4
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 352027.6
   },
   {
    "Region Name": "WSAF",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 347549.0
   }
  ],
  "WSB": [
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 171623.6
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 86072.8
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 114638.5
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 104405.0
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 104438.2
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 53217.5
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 115984.1
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 34809.2
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 102986.3
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 37614.9
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 85128.5
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16550.6
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 59562.0
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 57683.3
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 24912.7
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 92112.6
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 23359.6
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 75394.4
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 43181.6
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 64827.3
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 48146.8
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 27531.6
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3592.2
   },
   {
    "Region Name": "WSB",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14039.5
   }
  ]
 },
 "RECCAP2 Regions": {
  "Africa": [
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2856589.8
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2966018.1
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3057581.5
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3090370.9
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2972939.8
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2956003.6
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2822681.7
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2718813.1
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2910683.8
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2975091.2
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2709044.3
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2618158.3
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2468099.8
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2653328.7
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2509096.5
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2464397.0
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2382276.9
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2348913.4
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2387111.6
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2473543.2
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2364246.3
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2396217.3
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2373130.2
   },
   {
    "Region Name": "Africa",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2257479.4
   }
  ],
  "Australasia": [
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 737693.9
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 276345.0
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 641176.0
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 256935.2
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 576624.3
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 505561.6
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 292218.6
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 403458.5
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 175584.7
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 916544.5
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 863322.7
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 257644.3
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 449954.3
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 407321.9
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 229296.8
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 493064.6
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 547925.7
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 325672.8
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 130470.5
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 269264.4
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 262926.8
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 728359.8
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 372661.2
   },
   {
    "Region Name": "Australasia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 467561.1
   }
  ],
  "East Asia": [
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 28713.2
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 56680.2
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 36614.2
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 44427.8
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 56199.2
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 61918.3
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 43624.9
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 40914.9
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 41324.1
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 51502.8
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 73494.5
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 44481.6
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 70211.2
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 61510.2
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 26184.3
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 48501.4
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 32774.9
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17389.8
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 26455.3
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 27601.5
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 35954.0
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 43568.6
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 42380.3
   },
   {
    "Region Name": "East Asia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 29513.3
   }
  ],
  "Europe": [
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 29057.7
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18502.8
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21380.5
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 39707.4
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 26631.9
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 35900.4
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 56628.6
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30166.4
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20589.7
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22984.9
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19693.0
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15664.8
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34446.1
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 29672.5
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22275.1
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 35742.4
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17858.0
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 28439.5
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15932.1
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12980.9
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15936.6
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9423.9
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18111.2
   },
   {
    "Region Name": "Europe",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20448.9
   }
  ],
  "North America": [
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 72466.8
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 93199.3
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 81106.5
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 101205.5
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 78226.9
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 79612.4
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 67793.8
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 63260.5
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 67528.2
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 97969.6
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 72498.1
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 85638.7
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 68524.1
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 88396.8
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 63062.0
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 92395.6
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 74532.9
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 70113.2
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 82559.1
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 93777.9
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 64051.3
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 184379.2
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 114279.5
   },
   {
    "Region Name": "North America",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 90725.7
   }
  ],
  "Oceans - Exclude": [
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 29474.0
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30291.8
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32594.4
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 32156.9
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35575.8
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 35792.5
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 29641.4
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 31208.9
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22912.8
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 32589.2
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 31674.9
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 25778.5
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34238.2
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 38475.8
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 27972.8
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24786.0
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30310.9
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 36536.2
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 23033.7
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 25269.0
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22666.9
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 27940.9
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23094.8
   },
   {
    "Region Name": "Oceans - Exclude",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 22301.2
   }
  ],
  "Russia": [
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 158018.9
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 220445.7
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 106070.2
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 123030.7
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 147420.7
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 110356.9
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 229537.1
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 125434.6
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 114326.0
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 121505.2
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 145454.7
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 69770.7
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 188186.0
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 91973.3
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 93576.8
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 80832.1
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 120926.0
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 108268.8
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 104052.4
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 125426.2
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 77653.5
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 78704.3
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 98299.1
   },
   {
    "Region Name": "Russia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 52019.0
   }
  ],
  "Small Islands - Exclude": [
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Small Islands - Exclude",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "South America": [
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 415439.2
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 365516.7
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 375842.4
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 405819.8
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 301794.9
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 568593.8
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 303140.3
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 224657.6
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 529995.0
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 270205.1
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 353704.8
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 220655.2
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 240287.1
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 318245.4
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 294509.8
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 367941.5
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 207122.3
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 355079.3
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 411191.0
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 336875.7
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 267731.9
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 282204.8
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 456654.4
   },
   {
    "Region Name": "South America",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 184325.6
   }
  ],
  "South Asia": [
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23796.2
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 33142.7
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 46523.0
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 41323.1
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 32566.5
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 41682.8
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 44846.9
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 57576.5
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 53437.9
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 54954.8
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 56799.6
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 52730.3
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 51098.5
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 43836.1
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 62127.4
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 56241.6
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 57663.8
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 53062.1
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 53193.7
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 73034.4
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 67487.2
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 42948.2
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 46729.2
   },
   {
    "Region Name": "South Asia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 60105.9
   }
  ],
  "Southeast Asia": [
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 89387.8
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 115850.2
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 177316.0
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 86598.2
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 127109.0
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 112980.4
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 105295.9
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 104600.9
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 117948.4
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 87628.7
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 107025.0
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 86226.7
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 120844.7
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 131222.3
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 87254.2
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 73492.8
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 88078.2
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 111304.0
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 98855.0
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 61107.2
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 61755.2
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 94289.8
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 83410.3
   },
   {
    "Region Name": "Southeast Asia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 77746.3
   }
  ],
  "West Asia": [
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 246773.0
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 120932.0
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 148134.6
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 141234.7
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 154718.3
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 94327.7
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 107338.8
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 67378.5
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 139533.2
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 42526.1
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 65533.7
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 26342.9
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 70543.9
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 95654.9
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 40394.8
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 153170.1
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 44641.7
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 122111.9
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 63251.1
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 65781.9
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 23601.2
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23567.5
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 25034.7
   },
   {
    "Region Name": "West Asia",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27736.3
   }
  ]
 },
 "States and Provinces": {
  "'Asir (Province of Saudi Arabia)": [
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Asir (Province of Saudi Arabia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "'Eua (Island Group of Tonga)": [
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "'Eua (Island Group of Tonga)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "A'ana (District of Samoa)": [
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A'ana (District of Samoa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Aargau (Canton of Switzerland)": [
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aargau (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Abia (State of Nigeria)": [
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 105.0
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 439.0
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 98.4
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Abia (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.0
   }
  ],
  "Abidjan (Autonomous district of C\u00f4te d'Ivoire)": [
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abidjan (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Abkhazia (Autonomous Republic of Georgia)": [
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 111.3
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Abra (Province of Philippines)": [
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Abra (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.6
   }
  ],
  "Abruzzo (Region of Italy)": [
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 150.7
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Abruzzo (Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Absheron (Region of Azerbaijan)": [
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 108.3
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Absheron (Region of Azerbaijan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.1
   }
  ],
  "Abu Dhabi (Emirate of United Arab Emirates)": [
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Abyan (Governorate of Yemen)": [
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Abyan (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Aceh (Province of Indonesia)": [
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 194.6
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 119.4
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 110.4
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aceh (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 46.5
   }
  ],
  "Acklins (District of Bahamas)": [
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Acklins (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Acre (State of Brazil)": [
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 551.1
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 768.3
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 433.5
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2880.9
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 286.8
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 253.8
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 219.1
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 702.7
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 138.7
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 105.3
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 478.5
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 138.5
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 169.6
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 213.7
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 381.4
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 500.1
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 920.5
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 124.8
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 373.2
   },
   {
    "Region Name": "Acre (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.9
   }
  ],
  "Ad Dakhliyah (Region of Oman)": [
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dakhliyah (Region of Oman)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ad Daqahliyah (Governorate of Egypt)": [
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 122.0
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 137.0
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 409.7
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 382.4
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 183.7
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 256.0
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 288.8
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 218.9
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 271.4
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 552.6
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 367.0
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 269.2
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 413.7
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 164.8
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 273.1
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ad Dawhah (Municipality of Qatar)": [
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ad Dawhah (Municipality of Qatar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Adamaoua (Region of Cameroon)": [
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13721.8
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 20528.8
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9625.8
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16270.4
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8740.5
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6347.9
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7310.4
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5670.3
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7353.9
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4363.5
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3776.1
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2731.9
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2512.4
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1832.4
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1714.7
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2121.2
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2161.1
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1913.2
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2606.5
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1857.5
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2813.0
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1284.5
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1958.3
   },
   {
    "Region Name": "Adamaoua (Region of Cameroon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1475.7
   }
  ],
  "Adamawa (State of Nigeria)": [
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6362.0
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6418.0
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6496.0
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7840.5
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6905.5
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4892.1
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4574.4
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3953.2
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2721.6
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2313.0
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1687.5
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1241.8
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1307.9
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1685.6
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 872.3
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1001.3
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1204.5
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 965.3
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1099.1
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 822.5
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1150.5
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 841.2
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 928.6
   },
   {
    "Region Name": "Adamawa (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 589.1
   }
  ],
  "Adana (Province of Turkey)": [
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 642.9
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 939.4
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 717.3
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 753.9
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 701.0
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 512.8
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 340.6
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 465.2
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 280.8
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 200.9
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 248.5
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 254.0
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 178.6
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 285.3
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 106.3
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 87.9
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Adana (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.9
   }
  ],
  "Addis Abeba (City of Ethiopia)": [
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Addis Abeba (City of Ethiopia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Adiyaman (Province of Turkey)": [
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 106.1
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 153.5
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 96.7
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 420.8
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 109.5
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 189.1
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 81.9
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 172.1
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 244.2
   },
   {
    "Region Name": "Adiyaman (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.0
   }
  ],
  "Adjumani (District of Uganda)": [
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 886.6
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 839.9
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 669.0
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 983.7
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 732.1
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 747.1
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 538.7
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 669.0
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 465.6
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 714.9
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 705.5
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 629.8
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 735.3
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 944.7
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 926.3
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 561.6
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 609.5
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 439.2
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 429.6
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 439.5
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 539.8
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 290.5
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 296.9
   },
   {
    "Region Name": "Adjumani (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 383.1
   }
  ],
  "Adjuntas (Municipality of Puerto Rico)": [
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adjuntas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Adrar (Province of Algeria)": [
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Adrar (Region of Mauritania)": [
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Adrar (Region of Mauritania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Adygey (Republic of Russia)": [
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 263.5
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 125.4
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 236.2
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 242.2
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 279.1
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 210.5
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 184.6
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 78.2
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 183.5
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 178.8
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 227.2
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 76.5
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 121.8
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Adygey (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 145.3
   }
  ],
  "Aegean (Decentralized administration of Greece)": [
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 136.8
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 178.4
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 218.7
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Aegean (Decentralized administration of Greece)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 138.5
   }
  ],
  "Afar (State of Ethiopia)": [
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 100.8
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 191.9
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 235.8
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 89.4
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 245.2
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 144.1
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 82.7
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 325.2
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 123.5
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 298.8
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 240.3
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 100.8
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 118.1
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 198.7
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 374.7
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 324.1
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 415.4
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 270.1
   },
   {
    "Region Name": "Afar (State of Ethiopia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 838.6
   }
  ],
  "Afyon (Province of Turkey)": [
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 251.5
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 135.9
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Afyon (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.3
   }
  ],
  "Agadez (Department of Niger)": [
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 319.2
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 143.4
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 99.7
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 174.9
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1072.7
   },
   {
    "Region Name": "Agadez (Department of Niger)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 935.1
   }
  ],
  "Agalega Islands (Region of Mauritius)": [
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agalega Islands (Region of Mauritius)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Agat (Municipality of Guam)": [
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agat (Municipality of Guam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Agri (Province of Turkey)": [
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Agri (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.5
   }
  ],
  "Aguadilla (Municipality of Puerto Rico)": [
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguadilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Aguascalientes (State of M\u00e9xico)": [
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Aguascalientes (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 57.0
   }
  ],
  "Agusan del Norte (Province of Philippines)": [
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Norte (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Agusan del Sur (Province of Philippines)": [
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Agusan del Sur (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ahafo (Region of Ghana)": [
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 177.3
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 189.5
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 203.9
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Ahafo (Region of Ghana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16.9
   }
  ],
  "Ahal (Province of Turkmenistan)": [
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 354.8
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 664.3
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 483.0
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 430.2
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 231.7
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 250.2
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 86.0
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 276.8
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 217.4
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 185.6
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 216.3
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 875.7
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 88.5
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 106.8
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 198.5
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 641.2
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 283.4
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 105.7
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Ahal (Province of Turkmenistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 149.0
   }
  ],
  "Ahuachap\u00e1n (Department of El Salvador)": [
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ahuachap\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Aichi (Prefecture of Japan)": [
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aichi (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Aiga-i-le-Tai (District of Samoa)": [
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aiga-i-le-Tai (District of Samoa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Aileu (District of Timor-Leste)": [
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Aileu (District of Timor-Leste)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ailinglaplap (Atol of Marshall Islands)": [
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ailuk (Atol of Marshall Islands)": [
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ailuk (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Aimeliik (State of Palau)": [
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aimeliik (State of Palau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ainaro (District of Timor-Leste)": [
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ainaro (District of Timor-Leste)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Airai (State of Palau)": [
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Airai (State of Palau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Aitutaki (Island Council of Cook Islands)": [
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aitutaki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ajaria (Autonomous Republic of Georgia)": [
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajaria (Autonomous Republic of Georgia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ajlun (Province of Jordan)": [
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajlun (Province of Jordan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ajman (Emirate of United Arab Emirates)": [
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ajman (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Akershus (County of Norway)": [
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akershus (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Akita (Prefecture of Japan)": [
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akita (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Akkar (Governorate of Lebanon)": [
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akkar (Governorate of Lebanon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Aklan (Province of Philippines)": [
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aklan (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)": [
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.4
   }
  ],
  "Aksaray (Province of Turkey)": [
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Aksaray (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.0
   }
  ],
  "Akwa Ibom (State of Nigeria)": [
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 142.3
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Akwa Ibom (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Al Ahmadi (Province of Kuwait)": [
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Ahmadi (Province of Kuwait)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Al Bahah (Province of Saudi Arabia)": [
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 28.1
   }
  ],
  "Al Bahr al Ahmar (Governorate of Egypt)": [
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Al Batinah North (Region of Oman)": [
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah North (Region of Oman)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Al Batinah South (Region of Oman)": [
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Batinah South (Region of Oman)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Bayda' (Governorate of Yemen)": [
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Bayda' (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Buhayrah (Governorate of Egypt)": [
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Al Buhayrah (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Buraymi (Region of Oman)": [
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Buraymi (Region of Oman)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Butnan (District of Libya)": [
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Butnan (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Daayen (Municipality of Qatar)": [
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Daayen (Municipality of Qatar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Dali' (Governorate of Yemen)": [
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dali' (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Dhahira (Region of Oman)": [
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Dhahira (Region of Oman)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Al Farwaniyah (Province of Kuwait)": [
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Farwaniyah (Province of Kuwait)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Fayyum (Governorate of Egypt)": [
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Fayyum (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Gharbiyah (Governorate of Egypt)": [
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 114.9
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Al Gharbiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Hudaydah (Governorate of Yemen)": [
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Al Hudaydah (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Al Hudud ash Shamaliyah (Province of Saudi Arabia)": [
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Iskandariyah (Governorate of Egypt)": [
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Iskandariyah (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Isma`iliyah (Governorate of Egypt)": [
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Jabal al Akhdar (District of Libya)": [
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Akhdar (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Jabal al Gharbi (District of Libya)": [
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jabal al Gharbi (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Jahrah (Province of Kuwait)": [
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jahrah (Province of Kuwait)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Al Jawf (Governorate of Yemen)": [
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jawf (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Jawf (Province of Saudi Arabia)": [
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 595.9
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 549.6
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 608.0
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 724.4
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 580.7
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 543.6
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 149.0
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 127.5
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Al Jawf (Province of Saudi Arabia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 17.4
   }
  ],
  "Al Jazirah (State of Sudan)": [
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 291.3
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 206.4
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 331.2
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 120.7
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 663.0
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1146.4
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 120.7
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 201.9
   },
   {
    "Region Name": "Al Jazirah (State of Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 84.7
   }
  ],
  "Al Jifarah (District of Libya)": [
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jifarah (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Jizah (Governorate of Egypt)": [
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Al Jizah (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.1
   }
  ],
  "Al Jufrah (District of Libya)": [
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Jufrah (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Khor (Municipality of Qatar)": [
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Al Khor (Municipality of Qatar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Kufrah (District of Libya)": [
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "Al Kufrah (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Al Kuwayt (Province of Kuwait)": [
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Kuwayt (Province of Kuwait)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Madinah (Province of Saudi Arabia)": [
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Al Madinah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Mahrah (Governorate of Yemen)": [
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahrah (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Mahwit (Governorate of Yemen)": [
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Mahwit (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Marj (District of Libya)": [
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marj (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Marqab (District of Libya)": [
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Marqab (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Minufiyah (Governorate of Egypt)": [
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minufiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Minya (Governorate of Egypt)": [
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Al Minya (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.2
   }
  ],
  "Al Qadarif (State of Sudan)": [
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2874.7
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3992.2
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3584.0
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2063.7
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1455.4
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1866.1
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1149.2
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1670.4
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 290.7
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 310.2
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 259.4
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 574.7
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 237.5
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 113.6
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 205.8
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 407.3
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 546.6
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1063.1
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1500.4
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1609.7
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2201.6
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1913.2
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1049.6
   },
   {
    "Region Name": "Al Qadarif (State of Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1146.7
   }
  ],
  "Al Qahirah (Governorate of Egypt)": [
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qahirah (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Qalyubiyah (Governorate of Egypt)": [
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Qassim (Province of Saudi Arabia)": [
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 171.1
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Qassim (Province of Saudi Arabia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Uqsur (Governorate of Egypt)": [
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Uqsur (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Wadi al Jadid (Governorate of Egypt)": [
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 113.0
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 135.5
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 109.3
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 272.2
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 700.3
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 845.7
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1072.9
   },
   {
    "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1368.7
   }
  ],
  "Al Wahat (District of Libya)": [
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wahat (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Wakrah (Municipality of Qatar)": [
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wakrah (Municipality of Qatar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al Wusta (Region of Oman)": [
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Al Wusta (Region of Oman)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Al-Anbar (Province of Iraq)": [
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 90.2
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 121.1
   },
   {
    "Region Name": "Al-Anbar (Province of Iraq)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 53.4
   }
  ],
  "Al-Basrah (Province of Iraq)": [
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 232.8
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 123.9
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 219.7
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 177.1
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 166.6
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 224.9
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 108.0
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 300.1
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 171.5
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 180.5
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 86.6
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 144.5
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 141.3
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Al-Basrah (Province of Iraq)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 126.7
   }
  ],
  "Al-Muthannia (Province of Iraq)": [
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Al-Muthannia (Province of Iraq)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.7
   }
  ],
  "Al-Qadisiyah (Province of Iraq)": [
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 124.5
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 134.2
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "Al-Qadisiyah (Province of Iraq)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 45.4
   }
  ],
  "Al-\u1e24asakah (Governorate of Syria)": [
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 194.6
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 159.9
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 119.6
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 313.4
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 218.7
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 107.2
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 90.0
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 116.0
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3930.9
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1598.8
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 76.5
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 450.4
   },
   {
    "Region Name": "Al-\u1e24asakah (Governorate of Syria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Alabama (State of United States)": [
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 135.7
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 130.6
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 406.0
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 254.2
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 295.0
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 242.9
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 640.3
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 355.2
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 152.2
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 419.3
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 122.4
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 275.2
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 329.7
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 397.9
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 187.1
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 238.6
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 155.4
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 281.5
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 207.5
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 329.9
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 121.8
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 183.3
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 152.4
   },
   {
    "Region Name": "Alabama (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 265.6
   }
  ],
  "Alagoas (State of Brazil)": [
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1506.4
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 827.2
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1457.3
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1458.8
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1297.4
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1263.7
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1223.2
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1031.3
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 763.8
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1183.1
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1554.0
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 623.4
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 593.4
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 742.4
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 918.8
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 271.2
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 401.9
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 407.9
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 337.4
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 441.6
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 325.0
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 354.8
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 546.2
   },
   {
    "Region Name": "Alagoas (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 318.6
   }
  ],
  "Alajuela (Province of Costa Rica)": [
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Alajuela (Province of Costa Rica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Alaska (State of United States)": [
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5765.7
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2056.4
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 20653.6
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14711.1
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 334.8
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1996.6
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 265.4
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6824.4
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1852.1
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 174.5
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 963.6
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2575.6
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 603.7
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12911.4
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1115.6
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1542.6
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 777.7
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6784.1
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 185.2
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 945.6
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6474.2
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1295.6
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2051.7
   },
   {
    "Region Name": "Alaska (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3509.6
   }
  ],
  "Alba (County of Romania)": [
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alba (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Albay (Province of Philippines)": [
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Albay (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Alberta (Province of Canada)": [
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3575.0
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1937.3
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3495.9
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 598.1
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1710.2
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2068.4
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 270.1
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 635.8
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 758.4
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5966.5
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5751.3
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 507.8
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 922.2
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6746.4
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3702.4
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1182.2
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 493.7
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6299.9
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 456.4
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 753.1
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1269.1
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22950.1
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7308.7
   },
   {
    "Region Name": "Alberta (Province of Canada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2711.8
   }
  ],
  "Alborz (Province of Iran)": [
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Alborz (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 22.1
   }
  ],
  "Alderney (Parish of Guernsey)": [
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alderney (Parish of Guernsey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Aleppo (Governorate of Syria)": [
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 154.1
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 583.7
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 822.7
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 175.1
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 195.3
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 262.2
   },
   {
    "Region Name": "Aleppo (Governorate of Syria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.5
   }
  ],
  "Alger (Province of Algeria)": [
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alger (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ali Sabieh (Region of Djibouti)": [
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ali Sabieh (Region of Djibouti)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Alibori (Department of Benin)": [
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7080.8
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6267.5
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6541.5
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7606.9
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7122.6
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6460.7
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6157.3
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5352.4
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5175.3
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5337.4
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5492.3
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5738.0
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6470.1
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4828.7
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4913.8
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6049.3
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5119.1
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6409.2
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4831.4
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4981.9
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3820.1
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3886.9
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3793.7
   },
   {
    "Region Name": "Alibori (Department of Benin)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3286.5
   }
  ],
  "Almaty (Region of Kazakhstan)": [
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3106.2
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2038.0
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3336.7
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3038.9
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2862.9
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3838.5
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1002.6
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1836.9
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 314.3
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 299.5
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1174.3
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1265.6
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1845.7
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2085.2
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 259.4
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 904.2
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1671.4
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1934.7
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1179.0
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2109.0
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1280.0
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 905.7
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 543.0
   },
   {
    "Region Name": "Almaty (Region of Kazakhstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 329.7
   }
  ],
  "Alo (Kingdom of Wallis and Futuna)": [
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alo (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Alta Verapaz (Department of Guatemala)": [
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 256.0
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 96.5
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 161.4
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 217.6
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 91.3
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 75.5
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 130.3
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 117.3
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 208.4
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 65.4
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 270.1
   },
   {
    "Region Name": "Alta Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 23.6
   }
  ],
  "Altay (Territory of Russia)": [
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2780.8
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3879.7
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3387.0
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1747.1
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1042.3
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2410.8
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3942.0
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 828.5
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2199.6
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1517.3
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1814.2
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 191.2
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2543.1
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 294.8
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 544.1
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 509.3
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 327.8
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2200.1
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1546.7
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 182.2
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1411.8
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 584.4
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 120.7
   },
   {
    "Region Name": "Altay (Territory of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1018.3
   }
  ],
  "Alto Paraguay (Department of Paraguay)": [
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7493.3
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3059.9
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2290.3
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6153.7
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3885.9
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5407.2
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3625.8
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4779.1
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3084.8
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2542.0
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4275.4
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3156.6
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1952.0
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2802.2
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3759.0
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2243.6
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1912.0
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5506.7
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4082.0
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4005.5
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2225.2
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3256.3
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5455.0
   },
   {
    "Region Name": "Alto Paraguay (Department of Paraguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 948.6
   }
  ],
  "Alto Paran\u00e1 (Department of Paraguay)": [
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 335.7
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 439.5
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 354.8
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 193.4
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 133.6
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 212.0
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 178.4
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 143.8
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 271.2
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 138.7
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 206.0
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 140.6
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 89.2
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 185.9
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 177.9
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 166.4
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 228.5
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 139.8
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 262.4
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 56.0
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 118.5
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 94.3
   },
   {
    "Region Name": "Alto Paran\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 59.4
   }
  ],
  "Alytaus (County of Lithuania)": [
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Alytaus (County of Lithuania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Amajyaruguru (Province of Rwanda)": [
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyaruguru (Province of Rwanda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Amajyepfo (Province of Rwanda)": [
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amajyepfo (Province of Rwanda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Amambay (Department of Paraguay)": [
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3030.7
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1585.0
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 605.6
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1724.0
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 785.0
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3694.4
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 399.2
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 230.0
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 846.3
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 578.6
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 335.7
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1172.0
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 319.4
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 326.5
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2408.2
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 408.4
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2453.7
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 305.5
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2554.8
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 231.7
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 653.2
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1458.4
   },
   {
    "Region Name": "Amambay (Department of Paraguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 274.2
   }
  ],
  "Amanat Al Asimah (Governorate of Yemen)": [
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Amap\u00e1 (State of Brazil)": [
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1030.9
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1311.7
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1644.6
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 712.8
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 934.6
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 410.3
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 988.7
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1247.2
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 475.7
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 634.7
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1616.6
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 473.1
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 745.6
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1564.0
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1248.5
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 633.7
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 592.3
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 893.7
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 330.8
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 638.8
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 431.1
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1875.1
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1248.9
   },
   {
    "Region Name": "Amap\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 654.3
   }
  ],
  "Amasya (Province of Turkey)": [
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amasya (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.9
   }
  ],
  "Amazonas (Commissiary of Colombia)": [
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Amazonas (Commissiary of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Amazonas (Region of Peru)": [
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 93.7
   },
   {
    "Region Name": "Amazonas (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.4
   }
  ],
  "Amazonas (State of Brazil)": [
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1195.1
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2133.2
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1030.3
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3911.2
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2120.5
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2186.6
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1898.5
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 758.2
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3651.8
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1131.0
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1580.1
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 397.4
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2137.7
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3653.5
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1924.6
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2360.6
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2118.6
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3534.1
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4043.0
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4137.3
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5421.6
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4699.8
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9004.6
   },
   {
    "Region Name": "Amazonas (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 967.9
   }
  ],
  "Amazonas (State of Venezuela)": [
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 698.2
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 713.0
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 366.1
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 401.5
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1001.7
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 342.3
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 360.6
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 825.5
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 225.9
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 215.7
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 404.7
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 477.8
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 463.7
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 903.6
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 247.6
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 542.4
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 571.1
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 420.8
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 407.9
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 357.6
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 240.5
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 526.5
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 334.4
   },
   {
    "Region Name": "Amazonas (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 191.2
   }
  ],
  "Ambeno (District of Timor-Leste)": [
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 120.7
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Ambeno (District of Timor-Leste)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.3
   }
  ],
  "Amhara (State of Ethiopia)": [
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10188.7
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8837.8
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9096.7
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7897.1
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6159.5
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6271.8
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5735.4
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6479.1
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5299.2
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5891.5
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5495.1
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5232.7
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3988.5
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4209.8
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5180.7
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4115.7
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5012.4
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4346.3
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4808.9
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3989.2
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3456.9
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3879.0
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4025.4
   },
   {
    "Region Name": "Amhara (State of Ethiopia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2820.5
   }
  ],
  "Amman (Province of Jordan)": [
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amman (Province of Jordan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Amnat Charoen (Province of Thailand)": [
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Amnat Charoen (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.1
   }
  ],
  "Ampara (District of Sri Lanka)": [
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 170.0
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 81.7
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 76.5
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 222.7
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 192.7
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 219.7
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 114.7
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 165.7
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 176.4
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 103.3
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 138.9
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 89.8
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ampara (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 38.8
   }
  ],
  "Amran (Governorate of Yemen)": [
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Amran (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Amur (Region of Russia)": [
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18259.1
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30298.3
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1887.1
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8125.0
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13022.7
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7453.8
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 38931.3
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4749.1
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2874.0
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17619.8
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14883.2
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9780.8
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7055.5
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10453.3
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12944.2
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4708.8
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29927.4
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1910.0
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2235.0
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 525.4
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2879.4
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12452.5
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19526.9
   },
   {
    "Region Name": "Amur (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4106.9
   }
  ],
  "An Giang (Province of Vietnam)": [
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1005.8
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 934.4
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1274.4
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 475.7
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 779.9
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1396.4
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 994.5
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1524.8
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 719.9
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2164.1
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1457.7
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1618.9
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2615.5
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1495.0
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1161.0
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1226.0
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2076.2
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1423.2
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 989.7
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 218.0
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1537.0
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1620.4
   },
   {
    "Region Name": "An Giang (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1375.4
   }
  ],
  "An Nuqat al Khams (District of Libya)": [
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "An Nuqat al Khams (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "An-Najaf (Province of Iraq)": [
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 146.0
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 117.0
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 112.5
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 109.5
   },
   {
    "Region Name": "An-Najaf (Province of Iraq)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16.3
   }
  ],
  "Anafu (Atoll of Tokelau)": [
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anafu (Atoll of Tokelau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Anambra (State of Nigeria)": [
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 226.2
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 538.5
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 524.6
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 74.2
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 141.3
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 426.2
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 147.1
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 267.1
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 74.4
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 145.3
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 270.7
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 260.7
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 274.4
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 537.4
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 174.3
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 125.2
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 226.6
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 282.8
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 633.2
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 123.0
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 380.5
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "Anambra (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 340.4
   }
  ],
  "Ancash (Region of Peru)": [
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 87.5
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 127.8
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 120.7
   },
   {
    "Region Name": "Ancash (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 29.2
   }
  ],
  "Andaluc\u00eda (Autonomous Community of Spain)": [
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 954.4
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 441.2
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 641.4
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 164.2
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 127.3
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 143.4
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 252.3
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 355.0
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 127.1
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 154.8
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 130.3
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 224.4
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 184.4
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 153.9
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 169.8
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Andaluc\u00eda (Autonomous Community of Spain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 61.5
   }
  ],
  "Andaman and Nicobar (Union Territory of India)": [
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Andaman and Nicobar (Union Territory of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Andhra Pradesh (State of India)": [
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 147.9
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 466.9
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1715.8
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 508.1
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 779.9
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 793.4
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1646.6
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1390.6
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1264.8
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3410.8
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 635.0
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 690.3
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1587.2
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 707.6
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1205.8
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2200.3
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2392.6
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1113.9
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2002.6
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4304.1
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4983.0
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2206.9
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2240.2
   },
   {
    "Region Name": "Andhra Pradesh (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2130.8
   }
  ],
  "Andijon (Region of Uzbekistan)": [
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Andijon (Region of Uzbekistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.4
   }
  ],
  "Andreas (Parish District of Isle of Man)": [
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andreas (Parish District of Isle of Man)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Andrijevica (Municipality of Montenegro)": [
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Andrijevica (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Anegada (District of British Virgin Islands)": [
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anegada (District of British Virgin Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Anenii Noi (District of Moldova)": [
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anenii Noi (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ang Thong (Province of Thailand)": [
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Ang Thong (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Angaur (State of Palau)": [
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Angaur (State of Palau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Anhui (Province of China)": [
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 514.1
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1670.8
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3265.3
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4055.2
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10389.6
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6993.8
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 757.4
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7976.0
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13963.4
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7133.8
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19424.6
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7556.1
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5472.2
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1026.2
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 253.2
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 170.4
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 270.1
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 295.0
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 202.6
   },
   {
    "Region Name": "Anhui (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 412.0
   }
  ],
  "Ankara (Province of Turkey)": [
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 194.9
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 441.2
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 274.0
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 372.8
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 92.8
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 56.0
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ankara (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 17.8
   }
  ],
  "Annaba (Province of Algeria)": [
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 85.7
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annaba (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16.7
   }
  ],
  "Annob\u00f3n (Province of Equatorial Guinea)": [
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Annob\u00f3n (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Anseba (Region of Eritrea)": [
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anseba (Region of Eritrea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Antalya (Province of Turkey)": [
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 186.3
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 713.0
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Antalya (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.6
   }
  ],
  "Antananarivo (NA of Madagascar)": [
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4276.0
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9708.3
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4819.9
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9871.3
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6771.1
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7903.8
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5905.0
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7298.4
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6449.5
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5947.2
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6564.6
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5567.8
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5084.4
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4799.7
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5619.7
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3910.9
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4921.5
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4442.2
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4926.8
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4943.3
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4437.0
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3833.8
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4622.7
   },
   {
    "Region Name": "Antananarivo (NA of Madagascar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4529.6
   }
  ],
  "Antioquia (Department of Colombia)": [
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 110.6
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 342.8
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 104.8
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Antioquia (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Antique (Province of Philippines)": [
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Antique (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Antofagasta (Region of Chile)": [
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Antofagasta (Region of Chile)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Antsiranana (NA of Madagascar)": [
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 325.2
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1990.6
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 908.7
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2186.3
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 569.4
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2083.0
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 237.7
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1839.7
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1189.3
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1492.0
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1801.8
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1148.6
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1112.8
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1730.0
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1644.4
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1113.2
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1076.1
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 933.1
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1254.7
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 770.0
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1278.9
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 691.1
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 983.3
   },
   {
    "Region Name": "Antsiranana (NA of Madagascar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 568.5
   }
  ],
  "Anuradhapura (District of Sri Lanka)": [
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 132.7
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 182.9
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 180.7
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Anuradhapura (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Anzo\u00e1tegui (State of Venezuela)": [
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 949.7
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1068.0
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1478.3
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2035.0
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2395.6
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1503.8
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1316.7
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1990.8
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1389.1
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1158.5
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1523.3
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1817.0
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1902.3
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1886.2
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1201.1
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1903.8
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3301.7
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3436.8
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2217.9
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2706.8
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1644.0
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4731.8
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2693.5
   },
   {
    "Region Name": "Anzo\u00e1tegui (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2769.0
   }
  ],
  "Aomori (Prefecture of Japan)": [
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aomori (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Apac (District of Uganda)": [
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1000.9
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 981.8
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 724.6
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 491.8
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 134.2
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 510.6
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 342.1
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 348.1
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 379.4
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 332.3
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 144.9
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 206.4
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 178.4
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 231.7
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 326.7
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 175.6
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Apac (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 34.1
   }
  ],
  "Apayao (Province of Philippines)": [
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Apayao (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Appenzell Ausserrhoden (Canton of Switzerland)": [
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Appenzell Innerrhoden (Canton of Switzerland)": [
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Apulia (Region of Italy)": [
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 218.4
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 92.6
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 321.6
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 259.4
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 156.7
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 384.1
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Apulia (Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 42.0
   }
  ],
  "Apure (State of Venezuela)": [
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9750.6
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12192.7
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7923.7
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11700.3
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12937.0
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8990.4
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10022.2
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13903.3
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7521.6
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7290.0
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8657.5
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11224.4
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9244.4
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12309.3
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7040.3
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11309.7
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11109.5
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12705.2
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15563.0
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11968.4
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14562.1
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15941.3
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15633.3
   },
   {
    "Region Name": "Apure (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9726.4
   }
  ],
  "Apur\u00edmac (Region of Peru)": [
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 163.3
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 93.5
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 314.3
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Apur\u00edmac (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Aqaba (Province of Jordan)": [
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aqaba (Province of Jordan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Aqmola (Region of Kazakhstan)": [
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 20935.7
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8872.5
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5093.8
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3230.3
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4117.0
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6246.1
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7760.6
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1429.4
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11287.8
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 668.6
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8177.1
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 273.5
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5659.3
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4236.6
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1569.0
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5631.5
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 735.7
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3509.4
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3089.7
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3587.9
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 260.0
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1420.6
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Aqmola (Region of Kazakhstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1335.9
   }
  ],
  "Aqt\u00f6be (Region of Kazakhstan)": [
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 37816.4
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15847.4
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 42630.7
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16099.8
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 42891.8
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9623.2
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 20665.2
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11998.2
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31595.8
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 615.7
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4327.5
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 950.7
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8357.8
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10852.4
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3008.9
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 23915.2
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7681.9
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11371.8
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4755.3
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3614.5
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 904.2
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 407.5
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 869.5
   },
   {
    "Region Name": "Aqt\u00f6be (Region of Kazakhstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1699.9
   }
  ],
  "Ar Raqqah (Governorate of Syria)": [
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 81.9
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1182.5
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 109.8
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 138.7
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 378.8
   },
   {
    "Region Name": "Ar Raqqah (Governorate of Syria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Ar Rayyan (Municipality of Qatar)": [
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Rayyan (Municipality of Qatar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ar Riyad (Province of Saudi Arabia)": [
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ar Riyad (Province of Saudi Arabia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Arad (County of Romania)": [
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 263.5
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Arad (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Aragatsotn (Province of Armenia)": [
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aragatsotn (Province of Armenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Aragua (State of Venezuela)": [
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 120.5
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 130.6
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 201.5
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 178.8
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 116.4
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 117.7
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 246.3
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 99.9
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 171.9
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 135.5
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 186.7
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 218.7
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 275.9
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 213.9
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 105.9
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 277.2
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 283.0
   },
   {
    "Region Name": "Aragua (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 230.7
   }
  ],
  "Arag\u00f3n (Autonomous Community of Spain)": [
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 197.9
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 143.8
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 280.6
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Arag\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.1
   }
  ],
  "Aran (Region of Azerbaijan)": [
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 154.6
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 102.0
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 92.2
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 121.5
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 216.1
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 165.7
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 150.9
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Aran (Region of Azerbaijan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 86.4
   }
  ],
  "Ararat (Province of Armenia)": [
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ararat (Province of Armenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.6
   }
  ],
  "Arauca (Intendancy of Colombia)": [
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1759.3
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3070.2
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1436.7
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2567.7
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2028.8
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1554.6
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1648.5
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2290.5
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 908.1
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 614.6
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1246.1
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1239.9
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1414.6
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1460.7
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1077.0
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1462.0
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1436.3
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1679.4
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2384.0
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1067.6
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1278.9
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1333.4
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1386.3
   },
   {
    "Region Name": "Arauca (Intendancy of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1238.8
   }
  ],
  "Araucan\u00eda (Region of Chile)": [
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 449.7
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 323.5
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 449.3
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 345.6
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 317.1
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 184.8
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 295.2
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 346.0
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 456.4
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 168.5
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 511.9
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1481.3
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 176.6
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 216.1
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 278.9
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 283.4
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 373.6
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 837.8
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 993.6
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 372.1
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 453.0
   },
   {
    "Region Name": "Araucan\u00eda (Region of Chile)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 322.8
   }
  ],
  "Arbil (Province of Iraq)": [
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 132.9
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 130.3
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 185.4
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 91.7
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 135.7
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 793.6
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 668.4
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 158.8
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 481.7
   },
   {
    "Region Name": "Arbil (Province of Iraq)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 51.4
   }
  ],
  "Arbory & Rushen (Parish District of Isle of Man)": [
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Archipelago (Sub-Region of \u00c5land)": [
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Archipelago (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ardahan (Province of Turkey)": [
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ardahan (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ardebil (Province of Iran)": [
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 332.9
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 319.8
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 204.3
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 112.1
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 282.5
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 185.2
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 598.3
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 261.3
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 347.7
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 340.4
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 134.6
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 108.5
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 106.3
   },
   {
    "Region Name": "Ardebil (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 130.6
   }
  ],
  "Arecibo (Municipality of Puerto Rico)": [
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arecibo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Arequipa (Region of Peru)": [
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 140.8
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 96.7
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Arequipa (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 40.7
   }
  ],
  "Arge\u0219 (County of Romania)": [
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arge\u0219 (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Arhangay (Province of Mongolia)": [
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 977.1
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arhangay (Province of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Ariana (Governorate of Tunisia)": [
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ariana (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Arica y Parinacota (Region of Chile)": [
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arica y Parinacota (Region of Chile)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Arizona (State of United States)": [
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2203.1
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 717.1
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 833.3
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3041.9
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 505.3
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 317.1
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 440.1
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 603.0
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 341.3
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3347.2
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 567.4
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 269.9
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 535.5
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 300.5
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 727.6
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1826.4
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 331.6
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1120.7
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3396.5
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1959.1
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 565.5
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 659.2
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 962.3
   },
   {
    "Region Name": "Arizona (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1306.6
   }
  ],
  "Arkansas (State of United States)": [
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 439.2
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2014.9
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2434.2
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1453.9
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1164.7
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1122.4
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1447.6
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 841.2
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2331.0
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2319.3
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 280.8
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 908.5
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 803.5
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3960.5
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1559.1
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1359.3
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 725.9
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1984.4
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1222.5
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1988.5
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2256.0
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2266.7
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1867.8
   },
   {
    "Region Name": "Arkansas (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1048.9
   }
  ],
  "Arkhangel'sk (Region of Russia)": [
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 96.7
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 388.9
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1212.5
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 135.1
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 513.2
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 104.2
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Arkhangel'sk (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Armavir (Province of Armenia)": [
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Armavir (Province of Armenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Arno (Atol of Marshall Islands)": [
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arno (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Arta (Region of Djibouti)": [
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Arta (Region of Djibouti)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Artigas (Department of Uruguay)": [
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 129.3
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Artigas (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.4
   }
  ],
  "Artvin (Province of Turkey)": [
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Artvin (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Arua (District of Uganda)": [
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 911.3
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 874.0
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 618.5
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 895.8
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 733.8
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 611.2
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 604.3
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 641.6
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 344.7
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 700.3
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 551.1
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 312.1
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 525.2
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 523.7
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 654.7
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 473.8
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 628.5
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 483.6
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 286.4
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 543.9
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 517.7
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 265.6
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 173.0
   },
   {
    "Region Name": "Arua (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 346.8
   }
  ],
  "Arunachal Pradesh (State of India)": [
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 153.1
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 88.5
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 94.8
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 124.1
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 112.5
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 87.9
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 202.6
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 215.2
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 90.0
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 185.0
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 113.8
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 188.4
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Arunachal Pradesh (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 151.8
   }
  ],
  "Arusha (Region of Tanzania)": [
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1569.6
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1484.9
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 383.5
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 669.3
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 283.2
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1593.0
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 287.0
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 410.7
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 170.9
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 112.1
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 143.8
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 129.9
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 611.4
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 388.9
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 87.5
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 790.8
   },
   {
    "Region Name": "Arusha (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 435.2
   }
  ],
  "As Suwayda' (Governorate of Syria)": [
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suwayda' (Governorate of Syria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "As Suways (Governorate of Egypt)": [
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "As Suways (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "As-Sulaymaniyah (Province of Iraq)": [
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 123.5
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 157.6
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 186.3
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 444.6
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 135.5
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 701.8
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 161.8
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 85.7
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 128.2
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 225.7
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 600.7
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 306.5
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 255.1
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 160.1
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 424.7
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 571.7
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 168.3
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 632.4
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 470.5
   },
   {
    "Region Name": "As-Sulaymaniyah (Province of Iraq)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 236.0
   }
  ],
  "Ascension (Administrative Area of Saint Helena, Ascension and Tris)": [
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ash Sharqiyah (Governorate of Egypt)": [
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 127.8
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 124.5
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 231.1
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 128.2
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 135.3
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 96.5
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.2
   }
  ],
  "Ash Sharqiyah North (Region of Oman)": [
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah North (Region of Oman)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ash Sharqiyah South (Region of Oman)": [
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ash Sharqiyah South (Region of Oman)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ash-Sharq\u012byah (Province of Saudi Arabia)": [
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 148.8
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ash-Sharq\u012byah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 17.8
   }
  ],
  "Ashanti (Region of Ghana)": [
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2977.6
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3781.9
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2665.0
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2087.5
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5005.9
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3082.8
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3665.9
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3091.0
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2471.5
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3666.6
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3512.7
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2576.7
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2274.7
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3962.0
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2310.7
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3013.2
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2112.6
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3481.6
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2469.5
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3285.6
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1746.2
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2921.4
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3276.0
   },
   {
    "Region Name": "Ashanti (Region of Ghana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1608.8
   }
  ],
  "Ashmore and Cartier Islands (Territory of Australia)": [
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Assaba (Region of Mauritania)": [
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 721.4
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 89.6
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 805.2
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2401.4
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 633.0
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 499.7
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1543.9
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 195.7
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 373.4
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 259.8
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 407.5
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 344.7
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 537.4
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 367.0
   },
   {
    "Region Name": "Assaba (Region of Mauritania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1112.1
   }
  ],
  "Assam (State of India)": [
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 198.1
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 371.9
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 151.3
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 200.4
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 408.6
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 345.8
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 395.7
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 861.5
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1133.6
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 514.9
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1079.3
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 854.0
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 871.0
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 495.2
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 347.3
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 259.0
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 207.9
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 241.2
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 483.2
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 325.2
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 294.3
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 299.5
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 299.9
   },
   {
    "Region Name": "Assam (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 930.1
   }
  ],
  "Astrakhan' (Region of Russia)": [
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1727.2
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1466.1
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1381.6
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1289.2
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4106.9
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1379.0
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1435.8
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2409.1
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5300.1
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2588.1
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2443.2
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 742.6
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2652.0
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1686.9
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 522.6
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2490.8
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1161.0
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2089.5
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1246.3
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2073.6
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2082.2
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1465.9
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1421.7
   },
   {
    "Region Name": "Astrakhan' (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1995.3
   }
  ],
  "Asunci\u00f3n (Capital District of Paraguay)": [
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asunci\u00f3n (Capital District of Paraguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Aswan (Governorate of Egypt)": [
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 62.6
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 147.5
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 298.6
   },
   {
    "Region Name": "Aswan (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 406.9
   }
  ],
  "Asyut (Governorate of Egypt)": [
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Asyut (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "At-Ta'mim (Province of Iraq)": [
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 121.3
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 228.7
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 196.6
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 192.3
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 271.6
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1699.7
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 692.0
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 162.3
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 438.8
   },
   {
    "Region Name": "At-Ta'mim (Province of Iraq)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 53.6
   }
  ],
  "Atacama (Region of Chile)": [
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atacama (Region of Chile)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Atakora (Department of Benin)": [
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7150.7
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6300.7
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5936.5
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7510.0
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6486.2
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7106.5
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6192.5
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5777.7
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6302.4
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6422.7
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5719.2
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5655.3
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5853.6
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5032.5
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5633.8
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4831.9
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5187.9
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5338.0
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5537.2
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5032.7
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5017.9
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4634.4
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4763.5
   },
   {
    "Region Name": "Atakora (Department of Benin)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4326.6
   }
  ],
  "Athos (Decentralized administration of Greece)": [
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Athos (Decentralized administration of Greece)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Atiu (Island Council of Cook Islands)": [
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atiu (Island Council of Cook Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Atlantique (Department of Benin)": [
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 262.4
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 139.1
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 65.4
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 130.1
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Atlantique (Department of Benin)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.9
   }
  ],
  "Atl\u00e1ntico (Department of Colombia)": [
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Atl\u00e1ntico (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)": [
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 163.1
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1890.9
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 968.7
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1766.6
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 847.4
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 370.9
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1419.6
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 868.8
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1398.1
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 808.2
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 584.6
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1196.0
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1939.6
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 450.8
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1340.0
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 164.6
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1360.8
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1116.4
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2178.8
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 490.9
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 392.7
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4757.3
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2193.9
   },
   {
    "Region Name": "Atl\u00e1ntico Norte (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 742.4
   }
  ],
  "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)": [
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 296.5
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 478.7
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 167.9
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 198.3
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 163.3
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 156.3
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 433.2
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 140.6
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 189.7
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 199.1
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 938.3
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 174.1
   },
   {
    "Region Name": "Atl\u00e1ntico Sur (Autonomous Region of Nicaragua)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.6
   }
  ],
  "Atl\u00e1ntida (Department of Honduras)": [
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Atl\u00e1ntida (Department of Honduras)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Attapu (Province of Laos)": [
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 343.0
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 364.6
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 451.9
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 405.2
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 329.3
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 326.3
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 310.6
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 157.6
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 284.0
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 328.2
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 314.5
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 159.1
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 266.0
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 303.5
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 218.0
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 249.7
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 159.9
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 339.3
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 197.2
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 340.6
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 466.7
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 469.7
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 379.4
   },
   {
    "Region Name": "Attapu (Province of Laos)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 270.1
   }
  ],
  "Attica (Decentralized administration of Greece)": [
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 88.5
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 191.0
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 245.2
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 169.4
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Attica (Decentralized administration of Greece)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 64.5
   }
  ],
  "Atua (District of Samoa)": [
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Atua (District of Samoa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Atyrau (Region of Kazakhstan)": [
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6420.8
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 741.5
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2005.4
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1806.7
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6784.6
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5145.9
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2542.4
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5245.6
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1721.8
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2416.4
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1218.7
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 125.0
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1567.7
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2676.4
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 515.3
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5776.4
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1813.1
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2081.5
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 704.6
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 982.7
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 556.9
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 464.1
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 947.1
   },
   {
    "Region Name": "Atyrau (Region of Kazakhstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 832.0
   }
  ],
  "Au Vent (Parish of Saint-Barth\u00e9lemy)": [
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Au Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Auckland (Region of New Zealand)": [
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auckland (Region of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Aur (Atol of Marshall Islands)": [
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aur (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Aurora (Province of Philippines)": [
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Aurora (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Aust-Agder (County of Norway)": [
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aust-Agder (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Australian Capital Territory (Territory of Australia)": [
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1097.1
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 561.6
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Australian Capital Territory (Territory of Australia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Austurland (Region of Iceland)": [
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Austurland (Region of Iceland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Auvergne-Rh\u00f4ne-Alpes (Region of France)": [
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Auvergne-Rh\u00f4ne-Alpes (Region of France)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Aveiro (District of Portugal)": [
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 106.8
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 174.1
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 245.7
   },
   {
    "Region Name": "Aveiro (District of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24.4
   }
  ],
  "Awdal (Region of Somalia)": [
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Awdal (Region of Somalia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ayacucho (Region of Peru)": [
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 112.8
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 205.6
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 187.8
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Ayacucho (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 23.2
   }
  ],
  "Aydin (Province of Turkey)": [
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Aydin (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.7
   }
  ],
  "Ayeyarwady (Division of Myanmar)": [
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 389.9
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 937.9
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 830.9
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 571.9
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 902.9
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 629.6
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 744.5
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 864.8
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 591.4
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 650.6
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 353.7
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 653.2
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 921.4
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 673.5
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 629.0
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 716.8
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 783.1
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 514.5
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 689.2
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 545.6
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 452.5
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 780.7
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 851.7
   },
   {
    "Region Name": "Ayeyarwady (Division of Myanmar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 651.0
   }
  ],
  "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)": [
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 159.5
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Ays\u00e9n del General Ib\u00e1\u00f1ez del Campo (Region of Chile)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.6
   }
  ],
  "Az Zawiyah (District of Libya)": [
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Az Zawiyah (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Azad Kashmir (Centrally Administered Area of Pakistan)": [
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 180.1
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 159.3
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 250.8
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 114.9
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 151.8
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 214.4
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 198.7
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 367.4
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 255.7
   },
   {
    "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 80.0
   }
  ],
  "Azores ('Autonomous Region' of Portugal)": [
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azores ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Azua (Province of Dominican Republic)": [
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Azua (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.5
   }
  ],
  "Azuay (Province of Ecuador)": [
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Azuay (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "A\u00efn Defla (Province of Algeria)": [
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 96.9
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 146.4
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 74.4
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn Defla (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "A\u00efn T\u00e9mouchent (Province of Algeria)": [
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u00efn T\u00e9mouchent (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "A\u015fgabat (Capital City District of Turkmenistan)": [
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "A\u015fgabat (Capital City District of Turkmenistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Baalbak - Hermel (Governorate of Lebanon)": [
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Babil (Province of Iraq)": [
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Babil (Province of Iraq)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19.9
   }
  ],
  "Bac\u0103u (County of Romania)": [
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bac\u0103u (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Badakhshan (Province of Afghanistan)": [
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badakhshan (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Baden-W\u00fcrttemberg (State of Germany)": [
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baden-W\u00fcrttemberg (State of Germany)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Badghis (Province of Afghanistan)": [
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 298.6
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 149.6
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badghis (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Badulla (District of Sri Lanka)": [
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Badulla (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bafat\u00e1 (Region of Guinea-Bissau)": [
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1466.7
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 595.7
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1307.4
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 930.6
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 879.8
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 557.8
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 619.7
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 597.4
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 498.6
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 587.8
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 412.2
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 663.0
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 818.9
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 385.9
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 397.4
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 392.3
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 593.4
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 389.9
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 470.1
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 277.6
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 228.1
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 356.7
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 316.4
   },
   {
    "Region Name": "Bafat\u00e1 (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 156.1
   }
  ],
  "Baghdad (Province of Iraq)": [
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghdad (Province of Iraq)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Baghlan (Province of Afghanistan)": [
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baghlan (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bago (Division of Myanmar)": [
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 560.6
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1182.5
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1435.4
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 667.5
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1121.6
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 683.8
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1199.8
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1207.3
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 876.6
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1125.7
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 938.7
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1047.8
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1693.1
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1063.3
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1062.2
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1044.0
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1144.7
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1480.6
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1343.0
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1056.4
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1147.9
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1091.6
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1248.1
   },
   {
    "Region Name": "Bago (Division of Myanmar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1554.2
   }
  ],
  "Bahia (State of Brazil)": [
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 14909.4
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6923.7
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9346.7
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12055.9
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5285.1
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30365.4
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13665.8
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4063.4
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17694.0
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12744.5
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21885.8
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4056.1
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8075.9
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16757.7
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3881.6
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5506.1
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3841.3
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5579.6
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7711.9
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15172.0
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7695.6
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7454.5
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8431.3
   },
   {
    "Region Name": "Bahia (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8813.1
   }
  ],
  "Bahoruco (Province of Dominican Republic)": [
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Bahoruco (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.9
   }
  ],
  "Baie Lazare (District of Seychelles)": [
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Lazare (District of Seychelles)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Baie Sainte Anne (District of Seychelles)": [
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baie Sainte Anne (District of Seychelles)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Baja California (State of M\u00e9xico)": [
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 229.8
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 583.7
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 647.2
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 185.2
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 223.4
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 218.4
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 781.8
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 135.9
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 200.6
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 295.6
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 150.1
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 163.8
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 225.1
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 647.8
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 247.0
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 424.2
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 942.8
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 162.3
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 386.1
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 648.3
   },
   {
    "Region Name": "Baja California (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 240.5
   }
  ],
  "Baja California Sur (State of M\u00e9xico)": [
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 108.3
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baja California Sur (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Baja Verapaz (Department of Guatemala)": [
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Baja Verapaz (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Baker (Island of United States Minor Outlying Isl)": [
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baker (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bakool (Region of Somalia)": [
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bakool (Region of Somalia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Balaka (District of Malawi)": [
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Balaka (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.1
   }
  ],
  "Bali (Province of Indonesia)": [
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bali (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Balikesir (Province of Turkey)": [
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Balikesir (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.6
   }
  ],
  "Balkan (Province of Turkmenistan)": [
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 387.4
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 212.2
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 268.6
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 183.3
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 128.0
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 92.8
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 526.1
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 145.8
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 141.9
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 164.4
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 289.0
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 90.2
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 622.5
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 251.5
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Balkan (Province of Turkmenistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 81.9
   }
  ],
  "Balkh (Province of Afghanistan)": [
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balkh (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Balochistan (Province of Pakistan)": [
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 146.2
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 138.3
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 330.6
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 276.1
   },
   {
    "Region Name": "Balochistan (Province of Pakistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 485.5
   }
  ],
  "Balqa (Province of Jordan)": [
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balqa (Province of Jordan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Balzers (Commune of Liechtenstein)": [
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Balzers (Commune of Liechtenstein)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bamako (District of Mali)": [
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamako (District of Mali)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bamingui-Bangoran (Prefecture of Central African Republic)": [
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 39566.1
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 35535.9
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 38733.0
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 35486.2
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 39798.7
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 35984.2
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 34918.6
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 35124.4
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36162.8
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 35935.7
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 35191.7
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35171.3
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 35632.4
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 37693.8
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 34996.8
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 32072.8
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 32859.3
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 31113.3
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 34441.6
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 33792.7
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 34084.5
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 32928.2
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 28505.5
   },
   {
    "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 32593.7
   }
  ],
  "Bamyan (Province of Afghanistan)": [
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bamyan (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Banaadir (Region of Somalia)": [
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banaadir (Region of Somalia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bandrele (Commune of Mayotte)": [
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bandrele (Commune of Mayotte)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bangka Belitung (Province of Indonesia)": [
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 239.0
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 132.1
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 335.1
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 568.3
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Bangka Belitung (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Bangkok Metropolis (Province of Thailand)": [
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bangkok Metropolis (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bani Suwayf (Governorate of Egypt)": [
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bani Suwayf (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Banjul (Independent City of Gambia)": [
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banjul (Independent City of Gambia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Banskobystrick\u00fd (Region of Slovakia)": [
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banskobystrick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Banten (Province of Indonesia)": [
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Banten (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Bar (Municipality of Montenegro)": [
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bar (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Barahona (Province of Dominican Republic)": [
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Barahona (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.4
   }
  ],
  "Baranya (County of Hungary)": [
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Baranya (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.4
   }
  ],
  "Barbuda (Dependency of Antigua and Barbuda)": [
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Barceloneta (Municipality of Puerto Rico)": [
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barceloneta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Barh el Ghazel (Region of Chad)": [
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 82.7
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 265.6
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 357.8
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 878.5
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1063.7
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 118.3
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2703.0
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 442.9
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 873.1
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1070.6
   },
   {
    "Region Name": "Barh el Ghazel (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2029.9
   }
  ],
  "Bari (Region of Somalia)": [
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bari (Region of Somalia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Barima-Waini (Region of Guyana)": [
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 78.0
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Barima-Waini (Region of Guyana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Barinas (State of Venezuela)": [
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 953.5
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2367.3
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 931.2
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1408.4
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1598.8
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 680.2
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1287.3
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1130.6
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 524.3
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 191.4
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 356.7
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 745.1
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 981.2
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 616.3
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 131.0
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 282.3
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 641.0
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1233.7
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1699.1
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 499.3
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 958.7
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1023.0
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1066.7
   },
   {
    "Region Name": "Barinas (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 256.4
   }
  ],
  "Baringo (County of Kenya)": [
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Baringo (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Barisal (Division of Bangladesh)": [
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Barisal (Division of Bangladesh)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bart\u0131n (Province of Turkey)": [
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bart\u0131n (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bas-Sassandra (District of C\u00f4te d'Ivoire)": [
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bas-Sassandra (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Bas-Uele (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7441.8
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9915.2
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8873.2
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9674.3
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11450.3
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11233.1
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8321.8
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9655.0
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8956.3
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9552.9
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8253.8
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8330.2
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7881.9
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10265.5
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7838.4
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8952.9
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7984.6
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8896.3
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9501.7
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7851.3
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7952.9
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7076.7
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6307.0
   },
   {
    "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5109.9
   }
  ],
  "Basarabeasca (District of Moldova)": [
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Basarabeasca (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Basel-Landschaft (Canton of Switzerland)": [
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Landschaft (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Basel-Stadt (Canton of Switzerland)": [
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basel-Stadt (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bashkortostan (Republic of Russia)": [
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 386.7
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 753.1
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 206.9
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 188.4
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 447.6
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 145.3
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 932.9
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 230.0
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 328.4
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 180.7
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 92.4
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 380.5
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 209.4
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 234.3
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 443.7
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 163.8
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Bashkortostan (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 119.8
   }
  ],
  "Basilan (Province of Philippines)": [
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basilan (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Basilicata (Region of Italy)": [
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 93.5
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 126.5
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Basilicata (Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.4
   }
  ],
  "Basse-Kotto (Prefecture of Central African Republic)": [
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1895.2
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2702.8
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2630.3
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1698.4
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3143.5
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1824.3
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2429.4
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1493.7
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1797.5
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2056.9
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1086.2
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 925.0
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 978.2
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 896.9
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 730.8
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1547.1
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1480.4
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1267.1
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1442.3
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1223.8
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 929.1
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 612.2
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 660.9
   },
   {
    "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 672.0
   }
  ],
  "Basse-Terre (District of Guadeloupe)": [
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Basse-Terre (District of Guadeloupe)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bataan (Province of Philippines)": [
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bataan (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Batanes (Province of Philippines)": [
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batanes (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Batangas (Province of Philippines)": [
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batangas (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.6
   }
  ],
  "Batd\u00e2mb\u00e2ng (Province of Cambodia)": [
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2217.2
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2606.9
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2815.1
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1695.4
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3152.1
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2130.4
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2338.1
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1982.3
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2678.3
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1998.1
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1290.3
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1217.8
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1517.9
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1078.3
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1364.5
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 450.6
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 813.5
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1730.4
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 490.0
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 192.5
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 248.5
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 604.5
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 917.1
   },
   {
    "Region Name": "Batd\u00e2mb\u00e2ng (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 475.0
   }
  ],
  "Batha (Region of Chad)": [
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4954.1
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6316.2
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5066.2
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10927.2
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4672.6
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10191.5
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4607.0
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1138.9
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7585.0
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4300.9
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9174.4
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1120.1
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8538.3
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2616.8
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4048.4
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 998.7
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5575.5
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2368.8
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11783.6
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6115.7
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5743.4
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1860.7
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2545.4
   },
   {
    "Region Name": "Batha (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8958.3
   }
  ],
  "Batken (Province of Kyrgyzstan)": [
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batken (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Batman (Province of Turkey)": [
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 185.0
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 174.9
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 119.6
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 150.3
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 322.2
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 261.3
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 126.0
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 112.3
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 98.8
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Batman (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Batna (Province of Algeria)": [
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 135.7
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 117.7
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batna (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Batticaloa (District of Sri Lanka)": [
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 122.2
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 128.0
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 182.4
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 129.1
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Batticaloa (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.4
   }
  ],
  "Baucau (District of Timor-Leste)": [
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Baucau (District of Timor-Leste)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bauchi (State of Nigeria)": [
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5805.8
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5980.7
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6502.5
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5934.4
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6770.8
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3811.3
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4141.0
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3733.7
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3428.2
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3203.5
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2584.9
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2546.7
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2631.2
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2729.8
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3147.2
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2330.4
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1560.0
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1149.7
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1614.6
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1030.3
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1016.5
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1534.0
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1225.5
   },
   {
    "Region Name": "Bauchi (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 986.3
   }
  ],
  "Bay (Region of Somalia)": [
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay (Region of Somalia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bay of Plenty (Region of New Zealand)": [
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bay of Plenty (Region of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bayan-\u00d6lgiy (Province of Mongolia)": [
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 113.6
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 122.0
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 129.9
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Bayan-\u00d6lgiy (Province of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 180.1
   }
  ],
  "Bayanhongor (Province of Mongolia)": [
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Bayanhongor (Province of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Bayburt (Province of Turkey)": [
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayburt (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Bayelsa (State of Nigeria)": [
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayelsa (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Bayern (Free State of Germany)": [
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bayern (Free State of Germany)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.9
   }
  ],
  "Beijing (Municipality of China)": [
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beijing (Municipality of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Beirut (Governorate of Lebanon)": [
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beirut (Governorate of Lebanon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Beja (District of Portugal)": [
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 337.8
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 76.5
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 261.5
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Beja (District of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.2
   }
  ],
  "Bekaa (Governorate of Lebanon)": [
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bekaa (Governorate of Lebanon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Belait (District of Brunei)": [
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belait (District of Brunei)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Belgorod (Region of Russia)": [
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 334.6
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 389.5
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 111.9
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 387.8
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 679.8
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 144.1
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Belgorod (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 68.6
   }
  ],
  "Belize (District of Belize)": [
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 149.6
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 198.3
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 189.1
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Belize (District of Belize)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 47.6
   }
  ],
  "Ben Arous (Tunis Sud) (Governorate of Tunisia)": [
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bender (City of Moldova)": [
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bender (City of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Benghazi (District of Libya)": [
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benghazi (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bengkulu (Province of Indonesia)": [
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bengkulu (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.4
   }
  ],
  "Bengo (Province of Angola)": [
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2321.0
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2371.3
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1403.9
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3031.8
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2172.8
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3719.1
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3662.1
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2257.5
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1893.3
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3406.1
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1236.5
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3035.3
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2414.2
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2033.5
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4230.4
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1064.3
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2180.8
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1313.9
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4011.3
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1955.3
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3387.0
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2157.6
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5121.9
   },
   {
    "Region Name": "Bengo (Province of Angola)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3353.8
   }
  ],
  "Benguela (Province of Angola)": [
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4826.3
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5691.7
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6743.0
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6388.2
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5249.7
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4708.4
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4500.5
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4160.3
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5127.1
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4109.9
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2759.6
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3466.1
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3718.0
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3169.0
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3763.9
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3610.4
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3192.8
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4123.2
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5083.8
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1668.0
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3552.1
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3946.1
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3366.5
   },
   {
    "Region Name": "Benguela (Province of Angola)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3909.7
   }
  ],
  "Benguet (Province of Philippines)": [
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 158.6
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 111.7
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 56.0
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Benguet (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Beni (Department of Bolivia)": [
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23598.2
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17715.9
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 28647.8
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 38234.9
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25640.7
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 17139.2
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16775.9
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11800.8
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 45439.8
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21176.2
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14559.5
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11225.9
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6133.3
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12921.9
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19837.3
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 17059.5
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9313.7
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16958.7
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22398.3
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17584.7
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 24373.3
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 37271.3
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 35981.6
   },
   {
    "Region Name": "Beni (Department of Bolivia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9298.7
   }
  ],
  "Benshangul-Gumaz (State of Ethiopia)": [
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 25870.5
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18180.8
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25235.1
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24383.0
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 21584.2
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23993.0
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 20662.2
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 22967.7
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21317.7
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 26460.4
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18401.6
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20576.0
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18634.0
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20596.1
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19797.0
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15979.3
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17990.1
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16318.4
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16443.8
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16569.4
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15136.2
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14463.3
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14541.7
   },
   {
    "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14804.5
   }
  ],
  "Benue (State of Nigeria)": [
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5969.5
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7771.9
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11198.4
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3643.8
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5347.6
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7435.4
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3144.6
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4131.3
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6493.0
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5751.9
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4351.9
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5860.8
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5374.0
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3634.0
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3053.7
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3543.3
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3891.9
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3274.1
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2983.6
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5270.3
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3282.2
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3209.3
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3161.3
   },
   {
    "Region Name": "Benue (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3554.9
   }
  ],
  "Berane (Municipality of Montenegro)": [
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berane (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Berat (County of Albania)": [
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Berat (County of Albania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.1
   }
  ],
  "Berea (District of Lesotho)": [
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Berea (District of Lesotho)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Berlin (State of Germany)": [
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berlin (State of Germany)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bern (Canton of Switzerland)": [
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bern (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Berovo (Municipality of North Macedonia)": [
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Berry Islands (District of Bahamas)": [
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Berry Islands (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bihar (State of India)": [
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 241.8
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 295.6
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 231.9
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 143.8
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 227.0
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 460.0
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 829.6
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 902.7
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 323.3
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 667.5
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1050.4
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 842.0
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 216.5
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 468.6
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 562.9
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1439.7
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 650.4
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 972.2
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 740.6
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1419.6
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 731.2
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1564.9
   },
   {
    "Region Name": "Bihar (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 807.3
   }
  ],
  "Bihor (County of Romania)": [
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 216.7
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Bihor (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Bijelo Polje (Municipality of Montenegro)": [
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bijelo Polje (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bilecik (Province of Turkey)": [
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bilecik (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 75.0
   }
  ],
  "Biliran (Province of Philippines)": [
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biliran (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Biminis (District of Bahamas)": [
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biminis (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bing\u00f6l (Province of Turkey)": [
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Bing\u00f6l (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.6
   }
  ],
  "Biob\u00edo (Region of Chile)": [
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 123.5
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 137.4
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 200.0
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 104.8
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 166.4
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 92.4
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 540.4
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 152.6
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 125.4
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1889.0
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Biob\u00edo (Region of Chile)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 293.9
   }
  ],
  "Bioko Norte (Province of Equatorial Guinea)": [
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bioko Sur (Province of Equatorial Guinea)": [
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Biombo (Region of Guinea-Bissau)": [
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Biombo (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Biskra (Province of Algeria)": [
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Biskra (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bissau (Autonomous Sector of Guinea-Bissau)": [
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)": [
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Bistri\u021ba-N\u0103s\u0103ud (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bitlis (Province of Turkey)": [
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Bitlis (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.9
   }
  ],
  "Bitola (Municipality of North Macedonia)": [
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bitola (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bizerte (Governorate of Tunisia)": [
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Bizerte (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30.0
   }
  ],
  "Bi\u00e9 (Province of Angola)": [
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13962.3
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16077.5
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15686.9
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16629.2
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15272.5
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 17541.6
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16662.7
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17900.2
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16063.3
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17844.3
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14762.5
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16543.9
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15228.3
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15568.1
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17001.2
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19666.4
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12711.0
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20039.9
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15125.4
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17653.9
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14986.8
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17436.1
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20403.0
   },
   {
    "Region Name": "Bi\u00e9 (Province of Angola)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19670.5
   }
  ],
  "Bi\u015fkek (City of Kyrgyzstan)": [
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bi\u015fkek (City of Kyrgyzstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bjelovarska-Bilogorska (County of Croatia)": [
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Black Point (District of Bahamas)": [
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black Point (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Black River (District of Mauritius)": [
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Black River (District of Mauritius)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Blagoevgrad (Province of Bulgaria)": [
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Blagoevgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 33.9
   }
  ],
  "Blantyre (District of Malawi)": [
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 125.2
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 80.2
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Blantyre (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 21.0
   }
  ],
  "Blekinge (County of Sweden)": [
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blekinge (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Blida (Province of Algeria)": [
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 174.9
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Blida (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Blue Nile (State of Sudan)": [
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9477.0
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8418.5
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10372.5
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11620.3
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7887.7
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7810.7
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7621.0
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6060.0
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4753.0
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4697.5
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8234.8
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8075.5
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7543.2
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6389.3
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7500.1
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5980.9
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5349.8
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4834.2
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5394.2
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3763.5
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2710.5
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3678.8
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4912.5
   },
   {
    "Region Name": "Blue Nile (State of Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3547.8
   }
  ],
  "Boa Vista (County of Cabo Verde)": [
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boa Vista (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Boaco (Department of Nicaragua)": [
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Boaco (Department of Nicaragua)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 29.6
   }
  ],
  "Bobonaro (District of Timor-Leste)": [
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Bobonaro (District of Timor-Leste)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bocas del Toro (Province of Panama)": [
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bocas del Toro (Province of Panama)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bogdanci (Municipality of North Macedonia)": [
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogdanci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bogot\u00e1 D.C. (Capital District of Colombia)": [
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Bogot\u00e1 D.C. (Capital District of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bogovinje (Municipality of North Macedonia)": [
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bogovinje (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bohol (Province of Philippines)": [
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Bohol (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bokeo (Province of Laos)": [
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 248.9
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 251.5
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 89.8
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 184.4
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 166.1
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 774.7
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 150.7
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 811.6
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 418.4
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 328.2
   },
   {
    "Region Name": "Bokeo (Province of Laos)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 49.1
   }
  ],
  "Bok\u00e9 (Region of Guinea)": [
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3220.7
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3775.3
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4511.6
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3600.5
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4029.3
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3690.4
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2440.2
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3275.1
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2803.3
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4939.5
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2876.6
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3849.0
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3505.4
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2436.1
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3060.5
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3249.2
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3449.8
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2738.1
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2457.7
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2736.0
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1979.5
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2030.9
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2219.4
   },
   {
    "Region Name": "Bok\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1367.9
   }
  ],
  "Bolama (Region of Guinea-Bissau)": [
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Bolama (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16.7
   }
  ],
  "Bolikhamxai (Province of Laos)": [
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 402.4
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 253.4
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 546.9
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 271.2
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 310.8
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 230.2
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 409.2
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 270.7
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 150.9
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 315.6
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 215.4
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 433.5
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 211.2
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 147.1
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 335.3
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 302.5
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 154.6
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 285.1
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 224.0
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 514.9
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 471.8
   },
   {
    "Region Name": "Bolikhamxai (Province of Laos)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 167.0
   }
  ],
  "Bolivar (Province of Ecuador)": [
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Bolivar (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bolu (Province of Turkey)": [
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Bolu (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Bol\u00edvar (Department of Colombia)": [
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 286.2
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 344.5
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 112.5
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 295.6
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 108.7
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 108.5
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 113.0
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 446.7
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 343.6
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 117.0
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 213.3
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Bol\u00edvar (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Bol\u00edvar (State of Venezuela)": [
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2705.6
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3322.7
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1727.8
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2408.4
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3750.2
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1775.8
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1370.0
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4099.4
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2670.2
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1143.4
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1594.3
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2422.4
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2622.4
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3551.7
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1645.1
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2758.5
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2971.4
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4600.1
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3010.0
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1775.4
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1138.7
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4439.8
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6089.2
   },
   {
    "Region Name": "Bol\u00edvar (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2297.0
   }
  ],
  "Bomet (County of Kenya)": [
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomet (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bomi (County of Liberia)": [
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 229.2
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Bomi (County of Liberia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)": [
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bong (County of Liberia)": [
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 104.4
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 645.7
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 158.6
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 329.9
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 202.4
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 119.4
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 133.6
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 105.9
   },
   {
    "Region Name": "Bong (County of Liberia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 74.8
   }
  ],
  "Bono (Region of Ghana)": [
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2455.0
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1950.8
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2900.2
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1892.9
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3593.7
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3932.0
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1460.9
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2559.4
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1819.8
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2731.3
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2274.2
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1702.9
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2115.6
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2332.5
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1598.1
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1757.4
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1520.5
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1766.0
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 905.9
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 914.5
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 457.7
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 768.1
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 734.9
   },
   {
    "Region Name": "Bono (Region of Ghana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 128.0
   }
  ],
  "Bono East (Region of Ghana)": [
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10447.9
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8943.3
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12479.1
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9230.9
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13031.7
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10525.1
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7933.8
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8677.2
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8492.4
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8860.1
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9329.6
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7083.8
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9117.1
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9605.7
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7255.7
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8559.8
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6454.4
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8711.5
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6876.7
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9339.0
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4227.1
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6325.2
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7415.0
   },
   {
    "Region Name": "Bono East (Region of Ghana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6756.9
   }
  ],
  "Boquer\u00f3n (Department of Paraguay)": [
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 998.3
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 821.9
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 697.6
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 562.9
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1120.1
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 695.6
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1714.5
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1193.8
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 964.9
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1298.4
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1420.4
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4246.4
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2576.1
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3133.6
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1686.2
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2023.2
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2139.0
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2303.6
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1699.3
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1991.3
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1488.8
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1095.6
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 921.4
   },
   {
    "Region Name": "Boquer\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 835.4
   }
  ],
  "Bordj Bou Arr\u00e9ridj (Province of Algeria)": [
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bordj Bou Arr\u00e9ridj (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.9
   }
  ],
  "Borgou (Department of Benin)": [
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6452.5
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3803.5
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3009.7
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3762.2
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2892.3
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3146.5
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1859.0
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1555.2
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1594.5
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1397.7
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1725.7
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1159.3
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 597.2
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1090.5
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 657.0
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 533.1
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 741.1
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1095.6
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 583.1
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 408.6
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 677.0
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 244.8
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 544.9
   },
   {
    "Region Name": "Borgou (Department of Benin)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 244.4
   }
  ],
  "Borkou (Region of Chad)": [
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 531.2
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 371.9
   },
   {
    "Region Name": "Borkou (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 179.9
   }
  ],
  "Borno (State of Nigeria)": [
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5798.5
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7790.0
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7946.4
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6793.1
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6342.7
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5972.3
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5644.3
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4359.4
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2958.7
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3754.5
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3531.1
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4044.9
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3808.9
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12427.6
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19938.0
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21835.0
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19095.6
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16070.0
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19392.0
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20722.2
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13109.1
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19006.6
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12633.2
   },
   {
    "Region Name": "Borno (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15245.9
   }
  ],
  "Borski (District of Serbia)": [
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 127.3
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Borski (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16.3
   }
  ],
  "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)": [
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 98.4
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Borsod-Aba\u00faj-Zempl\u00e9n (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bosilovo (Municipality of North Macedonia)": [
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bosilovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Boto\u0219ani (County of Romania)": [
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Boto\u0219ani (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Boucle du Mouhoun (Region of Burkina Faso)": [
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4145.5
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3864.0
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5328.6
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4076.0
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3082.6
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2814.5
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2565.8
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3601.2
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2310.7
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2754.9
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1530.6
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2370.7
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1940.9
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1467.6
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1823.9
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1799.8
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1192.3
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1348.0
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1044.6
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1259.4
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1270.6
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2471.2
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3415.3
   },
   {
    "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4042.8
   }
  ],
  "Boueni (Commune of Mayotte)": [
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boueni (Commune of Mayotte)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bouenza (Region of Republic of the Congo)": [
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 469.3
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1659.6
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3441.5
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3517.6
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3115.0
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3342.7
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3344.6
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2186.6
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3507.3
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3328.5
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3108.6
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3789.2
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2838.0
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3792.6
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3652.4
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2444.9
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4392.8
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3555.1
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 994.2
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3573.3
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3635.5
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2638.7
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3967.3
   },
   {
    "Region Name": "Bouenza (Region of Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3377.2
   }
  ],
  "Bougainville (Autonomous Region of Papua New Guinea)": [
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bouira (Province of Algeria)": [
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 93.7
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 137.0
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bouira (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Boujdour (Province of Western Sahara)": [
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boujdour (Province of Western Sahara)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Boumerd\u00e8s (Province of Algeria)": [
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boumerd\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Bourgogne-Franche-Comt\u00e9 (Region of France)": [
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Bourgogne-Franche-Comt\u00e9 (Region of France)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Boyac\u00e1 (Department of Colombia)": [
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Boyac\u00e1 (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Braga (District of Portugal)": [
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 62.6
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Braga (District of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Bragan\u00e7a (District of Portugal)": [
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 100.8
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 134.4
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 99.9
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 81.7
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 252.7
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 62.6
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 198.9
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Bragan\u00e7a (District of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 237.5
   }
  ],
  "Brakna (Region of Mauritania)": [
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Brakna (Region of Mauritania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.6
   }
  ],
  "Brandenburg (State of Germany)": [
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Brandenburg (State of Germany)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.4
   }
  ],
  "Brani\u010devski (District of Serbia)": [
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Brani\u010devski (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.6
   }
  ],
  "Bratislavsk\u00fd (Region of Slovakia)": [
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bratislavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Brava (County of Cabo Verde)": [
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Brazzaville (Region of Republic of the Congo)": [
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brazzaville (Region of Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bra\u0219ov (County of Romania)": [
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 101.4
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bra\u0219ov (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bremen (State of Germany)": [
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bremen (State of Germany)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Brest (Region of Belarus)": [
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 244.8
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 107.4
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 121.3
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 230.4
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 155.0
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 149.4
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 212.2
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Brest (Region of Belarus)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 39.4
   }
  ],
  "Bretagne (Region of France)": [
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bretagne (Region of France)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Briceni (District of Moldova)": [
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Briceni (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bride (Parish District of Isle of Man)": [
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bride (Parish District of Isle of Man)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "British Columbia (Province of Canada)": [
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 334.2
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2621.7
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2218.1
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 300.1
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1214.6
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 345.6
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 356.1
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2071.9
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2904.7
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 315.6
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 791.7
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 293.7
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3211.2
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2629.5
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 839.9
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9874.7
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10543.7
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 336.1
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 322.0
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7335.5
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1090.1
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21828.3
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8290.7
   },
   {
    "Region Name": "British Columbia (Province of Canada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3206.3
   }
  ],
  "Brodsko-Posavska (County of Croatia)": [
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brodsko-Posavska (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Brokopondo (District of Suriname)": [
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Brokopondo (District of Suriname)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Brunei and Muara (District of Brunei)": [
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brunei and Muara (District of Brunei)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bruxelles (Region of Belgium)": [
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bruxelles (Region of Belgium)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Brvenica (Municipality of North Macedonia)": [
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Brvenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bryansk (Region of Russia)": [
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 506.6
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 340.0
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 218.0
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 714.5
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 610.5
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 418.4
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 338.7
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 827.9
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 264.3
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 651.9
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 848.9
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 430.7
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 124.5
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 121.3
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 685.3
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 289.0
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 118.5
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 265.6
   },
   {
    "Region Name": "Bryansk (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 131.6
   }
  ],
  "Br\u0103ila (County of Romania)": [
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 168.3
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 100.8
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Br\u0103ila (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Br\u010dko (District of Bosnia and Herzegovina)": [
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Br\u010dko (District of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bubanza (Province of Burundi)": [
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Bubanza (Province of Burundi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.8
   }
  ],
  "Bucharest (Municipality of Romania)": [
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bucharest (Municipality of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Budapest (Capital City of Hungary)": [
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budapest (Capital City of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Budva (Municipality of Montenegro)": [
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Budva (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.7
   }
  ],
  "Bueng Kan (Province of Thailand)": [
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 62.6
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Bueng Kan (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.0
   }
  ],
  "Buenos Aires (Province of Argentina)": [
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1806.1
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1281.7
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1401.5
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 855.5
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 704.2
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 574.1
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1377.7
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 215.9
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 192.1
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 756.7
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 334.8
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1514.7
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 955.2
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 571.1
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2442.5
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 860.3
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 585.7
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 430.2
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 653.0
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 624.5
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 721.4
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 410.7
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 230.7
   },
   {
    "Region Name": "Buenos Aires (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 761.7
   }
  ],
  "Bugiri (District of Uganda)": [
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bugiri (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bujumbura Rural (Province of Burundi)": [
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Bujumbura Rural (Province of Burundi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.2
   }
  ],
  "Bukidnon (Province of Philippines)": [
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Bukidnon (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.9
   }
  ],
  "Bulacan (Province of Philippines)": [
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulacan (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Bulawayo (City of Zimbabwe)": [
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulawayo (City of Zimbabwe)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Bulgan (Province of Mongolia)": [
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1338.1
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 118.8
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 794.9
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1078.1
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 115.1
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bulgan (Province of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.2
   }
  ],
  "Bumthang (District of Bhutan)": [
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bumthang (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bundibugyo (District of Uganda)": [
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 223.4
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 279.5
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 284.5
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 234.1
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 326.7
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 273.5
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 183.1
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 114.7
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 178.8
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 182.9
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 101.6
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 135.9
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 108.3
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 160.6
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 180.5
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 86.0
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 136.6
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 161.2
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 199.8
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 140.2
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 143.4
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 149.4
   },
   {
    "Region Name": "Bundibugyo (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 96.0
   }
  ],
  "Bungoma (County of Kenya)": [
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Bungoma (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Bur Sa`id (Governorate of Egypt)": [
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bur Sa`id (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Burdur (Province of Turkey)": [
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burdur (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Burgas (Province of Bulgaria)": [
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 97.8
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Burgas (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.7
   }
  ],
  "Burgenland (State of Austria)": [
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Burgenland (State of Austria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Buri Ram (Province of Thailand)": [
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 139.8
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 425.5
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 747.1
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 465.8
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 255.1
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 203.2
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 143.6
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 155.0
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 126.9
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 145.8
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 132.9
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 196.4
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 153.3
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Buri Ram (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 32.6
   }
  ],
  "Bursa (Province of Turkey)": [
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Bursa (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 67.7
   }
  ],
  "Bururi (Province of Burundi)": [
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Bururi (Province of Burundi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Buryat (Republic of Russia)": [
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1081.1
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37569.5
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 533.1
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3327.2
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1000.0
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2317.8
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3207.8
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4738.8
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 418.4
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8341.3
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1388.7
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1604.1
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4428.2
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12175.7
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4762.4
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2068.0
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 229.2
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1588.9
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3311.8
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 410.5
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 757.2
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4208.5
   },
   {
    "Region Name": "Buryat (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6817.8
   }
  ],
  "Busan (Metropolitan City of South Korea)": [
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Bushehr (Province of Iran)": [
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 178.8
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 51.9
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 199.8
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Bushehr (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.4
   }
  ],
  "Bushenyi (District of Uganda)": [
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 117.0
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 151.3
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 118.1
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 167.2
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 105.5
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 170.0
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 125.4
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 149.0
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 141.1
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 128.0
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 212.4
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 125.0
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 112.1
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 121.1
   },
   {
    "Region Name": "Bushenyi (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 104.2
   }
  ],
  "Busia (County of Kenya)": [
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Busia (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Busia (District of Uganda)": [
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Busia (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Buskerud (County of Norway)": [
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buskerud (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Butha-Buthe (District of Lesotho)": [
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Butha-Buthe (District of Lesotho)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.2
   }
  ],
  "Buxoro (Region of Uzbekistan)": [
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 96.0
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Buxoro (Region of Uzbekistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 67.3
   }
  ],
  "Buz\u0103u (County of Romania)": [
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Buz\u0103u (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.2
   }
  ],
  "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)": [
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "B\u00e0 R\u1ecba - V\u0169ng T\u00e0u (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "B\u00e1cs-Kiskun (County of Hungary)": [
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e1cs-Kiskun (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)": [
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1423.8
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1915.0
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2751.9
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1746.2
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2380.6
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1469.1
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1079.8
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1078.1
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1565.3
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1374.7
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 765.9
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 465.2
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1558.9
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 940.7
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 682.6
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 543.0
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 746.9
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 659.4
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 163.3
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 202.8
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 266.5
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 458.3
   },
   {
    "Region Name": "B\u00e2nt\u00e9ay M\u00e9anchey (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 383.1
   }
  ],
  "B\u00e9char (Province of Algeria)": [
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9char (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "B\u00e9ja (Governorate of Tunisia)": [
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9ja (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.0
   }
  ],
  "B\u00e9ja\u00efa (Province of Algeria)": [
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 116.4
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 86.6
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 140.4
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 242.7
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 268.2
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "B\u00e9ja\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.9
   }
  ],
  "B\u00e9k\u00e9s (County of Hungary)": [
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 177.5
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "B\u00e9k\u00e9s (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)": [
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "B\u00ecnh D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.0
   }
  ],
  "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)": [
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 209.4
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 132.5
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 156.5
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 190.8
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 177.7
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 145.8
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 116.2
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 95.4
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 122.6
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 113.4
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 141.7
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 97.5
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 112.5
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "B\u00ecnh Ph\u01b0\u1edbc (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 38.6
   }
  ],
  "B\u00ecnh Thu\u1eadn (Province of Vietnam)": [
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 166.6
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 127.1
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 189.5
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 135.5
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 111.5
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 94.3
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 113.4
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 113.4
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 92.2
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 114.5
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 96.0
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 125.6
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "B\u00ecnh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 53.2
   }
  ],
  "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)": [
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 104.2
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "B\u00ecnh \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.6
   }
  ],
  "B\u1ea1c Li\u00eau (Province of Vietnam)": [
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 105.7
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "B\u1ea1c Li\u00eau (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "B\u1eafc Giang (Province of Vietnam)": [
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "B\u1eafc Giang (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "B\u1eafc K\u1ea1n (Province of Vietnam)": [
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc K\u1ea1n (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "B\u1eafc Ninh (Province of Vietnam)": [
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1eafc Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "B\u1ebfn Tre (Province of Vietnam)": [
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "B\u1ebfn Tre (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Caaguaz\u00fa (Department of Paraguay)": [
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 638.8
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1250.8
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1065.8
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 790.8
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 555.9
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 777.9
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 705.1
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 539.8
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 333.6
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 843.1
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 461.5
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 762.7
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 265.0
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 503.8
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 744.3
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 618.5
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 777.9
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 791.5
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 609.7
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1173.9
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 411.4
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 426.4
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 569.1
   },
   {
    "Region Name": "Caaguaz\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 426.6
   }
  ],
  "Caazap\u00e1 (Department of Paraguay)": [
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 224.7
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 779.7
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1124.2
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1224.0
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 476.5
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1164.7
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 582.7
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 577.3
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 349.6
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1090.7
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 437.3
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 637.3
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 278.5
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 349.2
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 733.8
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 717.3
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 772.8
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 508.1
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1190.0
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1295.2
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 562.1
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 292.8
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 453.4
   },
   {
    "Region Name": "Caazap\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 240.3
   }
  ],
  "Caba\u00f1as (Department of El Salvador)": [
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caba\u00f1as (Department of El Salvador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cabinda (Province of Angola)": [
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 206.4
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 235.2
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 89.4
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 135.7
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 154.6
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 102.0
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 127.5
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 133.8
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 181.1
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 474.6
   },
   {
    "Region Name": "Cabinda (Province of Angola)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 231.9
   }
  ],
  "Cabo Delgado (Province of Mozambique)": [
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21905.1
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 22279.4
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 18578.5
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19939.7
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16387.0
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19928.2
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18827.4
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20815.4
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17842.1
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18188.1
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18976.4
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 23318.6
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18638.1
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 19333.5
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17715.7
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 17293.1
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18909.5
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18759.2
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18714.4
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16893.3
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19971.9
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19089.3
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 17191.1
   },
   {
    "Region Name": "Cabo Delgado (Province of Mozambique)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 17168.8
   }
  ],
  "Cabo Rojo (Municipality of Puerto Rico)": [
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cacheu (Region of Guinea-Bissau)": [
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 174.1
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 128.6
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 255.3
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 236.2
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 95.8
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 130.8
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 115.8
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Cacheu (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.6
   }
  ],
  "Cagayan (Province of Philippines)": [
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 93.0
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 95.8
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Cagayan (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.4
   }
  ],
  "Caguas (Municipality of Puerto Rico)": [
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caguas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cahul (District of Moldova)": [
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cahul (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cajamarca (Region of Peru)": [
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 192.5
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 254.5
   },
   {
    "Region Name": "Cajamarca (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19.1
   }
  ],
  "Calabria (Region of Italy)": [
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 245.5
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 113.6
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 173.6
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 254.5
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 248.7
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 115.1
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Calabria (Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 38.2
   }
  ],
  "Calarasi (District of Moldova)": [
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Calarasi (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Caldas (Department of Colombia)": [
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Caldas (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "California (State of United States)": [
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2048.1
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3768.0
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1475.3
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1181.4
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3071.1
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4075.4
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4328.1
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1955.3
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 676.3
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1021.0
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2734.9
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2087.5
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1964.7
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2722.9
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2211.4
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4646.0
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5948.5
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1385.0
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15091.4
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9226.2
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1221.7
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1352.9
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4250.3
   },
   {
    "Region Name": "California (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1862.7
   }
  ],
  "Callao (Province of Peru)": [
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Callao (Province of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Camag\u00fcey (Province of Cuba)": [
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 440.7
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 497.6
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 804.3
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 522.8
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 525.4
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 406.2
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 427.2
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 759.1
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 276.1
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 510.2
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 345.3
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 277.8
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 342.6
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 405.2
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 276.1
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 130.1
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 174.7
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 224.0
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 666.9
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 289.2
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 620.4
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 341.3
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 562.7
   },
   {
    "Region Name": "Camag\u00fcey (Province of Cuba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 434.5
   }
  ],
  "Camarines Norte (Province of Philippines)": [
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Norte (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Camarines Sur (Province of Philippines)": [
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Camarines Sur (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Camiguin (Province of Philippines)": [
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camiguin (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Campania (Region of Italy)": [
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 107.4
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Campania (Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 23.4
   }
  ],
  "Campeche (State of M\u00e9xico)": [
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1656.0
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3750.0
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 751.4
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1982.1
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 954.8
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1445.3
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 988.0
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1772.8
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 859.0
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1337.2
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 580.3
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1657.7
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 250.0
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1392.1
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2117.5
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1410.1
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 750.3
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1463.5
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1877.2
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 569.1
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 515.8
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1505.9
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2063.1
   },
   {
    "Region Name": "Campeche (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1618.7
   }
  ],
  "Camuy (Municipality of Puerto Rico)": [
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Camuy (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Canaries (Quarter of Saint Lucia)": [
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canaries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Canelones (Department of Uruguay)": [
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canelones (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Canillo (Parish of Andorra)": [
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canillo (Parish of Andorra)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Canindey\u00fa (Department of Paraguay)": [
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 877.4
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1254.3
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 940.2
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1144.3
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 964.4
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1445.3
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 710.2
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 368.1
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 579.2
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1322.2
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 507.0
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 769.6
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 427.0
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 293.3
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 664.3
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 842.0
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 692.6
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 970.4
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 734.9
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 920.3
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 160.1
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 328.4
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 896.5
   },
   {
    "Region Name": "Canindey\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 269.7
   }
  ],
  "Cankuzo (Province of Burundi)": [
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 93.5
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 88.3
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 84.0
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 74.2
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 75.5
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 111.9
   },
   {
    "Region Name": "Cankuzo (Province of Burundi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 43.7
   }
  ],
  "Cantabria (Autonomous Community of Spain)": [
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Cantabria (Autonomous Community of Spain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16.5
   }
  ],
  "Cantemir (District of Moldova)": [
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cantemir (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Canterbury (Region of New Zealand)": [
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Canterbury (Region of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cao B\u1eb1ng (Province of Vietnam)": [
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Cao B\u1eb1ng (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Capital (Governorate of Bahrain)": [
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capital (Governorate of Bahrain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Capiz (Province of Philippines)": [
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Capiz (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Caquet\u00e1 (Intendancy of Colombia)": [
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1694.6
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 352.6
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1178.2
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 460.5
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 315.3
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 144.9
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 765.7
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 194.6
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 292.0
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 484.3
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 118.8
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 332.5
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 346.8
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2265.0
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 188.0
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 183.9
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 987.0
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 98.8
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 94.8
   },
   {
    "Region Name": "Caquet\u00e1 (Intendancy of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 26.2
   }
  ],
  "Carabobo (State of Venezuela)": [
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 97.8
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 80.0
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 98.0
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 98.0
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 85.7
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 95.4
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 129.3
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 135.5
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "Carabobo (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 62.6
   }
  ],
  "Carazo (Department of Nicaragua)": [
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carazo (Department of Nicaragua)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cara\u0219-Severin (County of Romania)": [
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 134.8
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 99.7
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Cara\u0219-Severin (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.2
   }
  ],
  "Carchi (Province of Ecuador)": [
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Carchi (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Carlow (County of Ireland)": [
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carlow (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Carolina (Municipality of Puerto Rico)": [
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carolina (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Carriacou (Dependency of Grenada)": [
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Carriacou (Dependency of Grenada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cartago (Province of Costa Rica)": [
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cartago (Province of Costa Rica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Casanare (Intendancy of Colombia)": [
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1461.8
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2166.6
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 948.8
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1698.9
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1643.8
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1499.7
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1464.8
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1740.5
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 765.3
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 693.7
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 852.3
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1370.0
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1757.8
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1415.0
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1164.9
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1388.9
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1803.9
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2171.6
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2160.8
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1595.1
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1636.1
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1663.3
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1780.5
   },
   {
    "Region Name": "Casanare (Intendancy of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1378.0
   }
  ],
  "Cascades (Region of Burkina Faso)": [
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4791.4
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3757.2
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3635.9
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3225.4
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3177.4
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2903.8
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2660.7
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3100.4
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2935.4
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2763.4
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2368.8
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1608.6
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1132.5
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 914.5
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1215.5
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 973.9
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 667.1
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 679.8
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 624.2
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 467.3
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 534.2
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2361.9
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1408.0
   },
   {
    "Region Name": "Cascades (Region of Burkina Faso)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1358.0
   }
  ],
  "Castelo Branco (District of Portugal)": [
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 152.2
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 847.2
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 150.5
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 486.4
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 234.1
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Castelo Branco (District of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 305.5
   }
  ],
  "Castilla y Le\u00f3n (Autonomous Community of Spain)": [
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 277.8
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 426.8
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 316.2
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 345.8
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 105.5
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 186.5
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 179.9
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 254.5
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 144.5
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 258.3
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 280.0
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 897.3
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Castilla y Le\u00f3n (Autonomous Community of Spain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1537.0
   }
  ],
  "Castilla-La Mancha (Autonomous Community of Spain)": [
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 173.2
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 213.3
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 144.7
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 33.9
   }
  ],
  "Castries (Quarter of Saint Lucia)": [
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Castries (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cat Island (District of Bahamas)": [
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cat Island (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Catalu\u00f1a (Autonomous Community of Spain)": [
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 171.5
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Catalu\u00f1a (Autonomous Community of Spain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 83.8
   }
  ],
  "Catamarca (Province of Argentina)": [
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1211.4
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 798.5
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 460.3
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 270.3
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 243.1
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 175.4
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 146.0
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 575.6
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 434.1
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 142.3
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 195.1
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 170.9
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 317.5
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 498.4
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 202.1
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 392.7
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 179.2
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 225.5
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 135.5
   },
   {
    "Region Name": "Catamarca (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 73.1
   }
  ],
  "Catanduanes (Province of Philippines)": [
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Catanduanes (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cauca (Department of Colombia)": [
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 88.3
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 96.7
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Cauca (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.6
   }
  ],
  "Causeni (District of Moldova)": [
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Causeni (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Cavan (County of Ireland)": [
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavan (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cavite (Province of Philippines)": [
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cavite (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cayenne (Arrondissement of French Guiana)": [
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Cayenne (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24.0
   }
  ],
  "Cayo (District of Belize)": [
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 91.3
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 188.0
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 378.6
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 105.5
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 168.7
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 62.6
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 150.9
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 123.5
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 295.8
   },
   {
    "Region Name": "Cayo (District of Belize)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 77.4
   }
  ],
  "Ca\u00f1ar (Province of Ecuador)": [
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Ca\u00f1ar (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.3
   }
  ],
  "Cear\u00e1 (State of Brazil)": [
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 350.3
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 907.4
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 462.2
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 257.5
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 197.0
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 561.2
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 318.1
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 177.3
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 219.1
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 586.1
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 425.7
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 500.3
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 316.8
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 396.2
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 769.4
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 598.3
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 394.0
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 362.7
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 509.8
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 194.4
   },
   {
    "Region Name": "Cear\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 515.3
   }
  ],
  "Cebu (Province of Philippines)": [
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Cebu (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ceiba (Municipality of Puerto Rico)": [
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceiba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Centar \u017dupa (Municipality of North Macedonia)": [
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centar \u017dupa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Central (Department of Paraguay)": [
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 246.3
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 147.5
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 136.8
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 152.8
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 125.0
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 115.5
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 204.9
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 133.6
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 556.5
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 382.4
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 153.7
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 126.9
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 248.2
   },
   {
    "Region Name": "Central (Department of Paraguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 252.5
   }
  ],
  "Central (Development Region of Nepal)": [
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 168.9
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 880.6
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 283.2
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 413.1
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 423.2
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 367.0
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 397.9
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 699.3
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 330.6
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 232.2
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1176.2
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 638.8
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 111.3
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 619.5
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 406.9
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 337.4
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 280.2
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 694.6
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 128.6
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 512.8
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 720.9
   },
   {
    "Region Name": "Central (Development Region of Nepal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 584.2
   }
  ],
  "Central (District of Botswana)": [
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4917.2
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 683.4
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 583.3
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2134.5
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6892.0
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 452.7
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12689.1
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1715.6
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26610.9
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11900.1
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4943.3
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2303.8
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1849.4
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1174.5
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 577.7
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4668.7
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1942.8
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1834.6
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1566.0
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6389.7
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6012.8
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9236.5
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1080.6
   },
   {
    "Region Name": "Central (District of Botswana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2364.9
   }
  ],
  "Central (Division of Fiji)": [
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Division of Fiji)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Central (Province of Papua New Guinea)": [
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 315.3
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 369.4
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 174.3
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 135.7
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 327.8
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 99.5
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 231.5
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 178.6
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 74.4
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 265.6
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 180.9
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 167.6
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 143.2
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 98.4
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 74.2
   },
   {
    "Region Name": "Central (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 59.0
   }
  ],
  "Central (Province of Solomon Islands)": [
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Province of Solomon Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Central (Province of Zambia)": [
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 36868.3
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 40306.5
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 41418.2
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 46428.0
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 32296.6
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 38697.9
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 38621.6
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 33433.0
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37810.0
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 36199.6
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 39636.0
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 40070.3
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 40412.6
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 39748.3
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 41943.4
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31636.8
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 33707.0
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 36955.3
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 35350.7
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28853.2
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 33959.1
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 30870.4
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 32593.9
   },
   {
    "Region Name": "Central (Province of Zambia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30832.7
   }
  ],
  "Central (Region of Ghana)": [
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 506.8
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 117.7
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Central (Region of Ghana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Central (Region of Singapore)": [
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central (Region of Singapore)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Central Abaco (District of Bahamas)": [
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 114.0
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Central Abaco (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 61.3
   }
  ],
  "Central Andros (District of Bahamas)": [
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Central Andros (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Central Darfur (State of Sudan)": [
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3845.6
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6253.8
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5044.1
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2523.8
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2005.6
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3243.8
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2913.5
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1661.8
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3173.3
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3991.1
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3358.9
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4287.8
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1707.9
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1463.1
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2332.1
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1890.3
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1659.0
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1891.2
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1058.1
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1311.5
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 479.3
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2093.1
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1946.5
   },
   {
    "Region Name": "Central Darfur (State of Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1923.5
   }
  ],
  "Central Eleuthera (District of Bahamas)": [
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Central Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Central Equatoria (State of South Sudan)": [
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21519.4
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 24045.6
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21545.6
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 26695.6
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23259.7
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24448.6
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22057.5
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 21501.0
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21624.9
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22575.8
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20255.5
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20712.5
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21738.3
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 19709.7
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22949.5
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 23985.1
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22286.7
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20034.3
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19544.9
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18333.7
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19743.8
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19795.9
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16672.5
   },
   {
    "Region Name": "Central Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 23298.3
   }
  ],
  "Centre (Department of Haiti)": [
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Centre (Department of Haiti)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 54.2
   }
  ],
  "Centre (Region of Burkina Faso)": [
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 93.7
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Centre (Region of Burkina Faso)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Centre (Region of Cameroon)": [
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3445.3
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5053.1
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2700.4
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5184.9
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3825.4
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4861.7
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2977.6
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3211.7
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4240.0
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4158.5
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4237.4
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1845.3
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3717.4
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3332.6
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2357.8
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2353.6
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2088.2
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4463.8
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3081.8
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2226.7
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2565.1
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1053.0
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2208.0
   },
   {
    "Region Name": "Centre (Region of Cameroon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1201.3
   }
  ],
  "Centre (Region of Togo)": [
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2136.8
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1832.9
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2760.4
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1872.9
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2118.6
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1650.0
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1852.4
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1877.7
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2415.3
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2537.3
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2017.6
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1867.8
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1802.8
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2464.0
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1977.3
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2020.0
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1961.9
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2030.5
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1305.7
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1382.7
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1605.4
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1259.2
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1216.1
   },
   {
    "Region Name": "Centre (Region of Togo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1716.2
   }
  ],
  "Centre-Est (Region of Burkina Faso)": [
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1023.4
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1113.0
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1287.1
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1903.6
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 840.3
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 392.7
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 606.4
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 991.7
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 871.6
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 660.0
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 348.8
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 322.6
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 192.7
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 165.9
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 192.3
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 318.1
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 167.6
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 284.9
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 101.4
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1742.8
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1997.9
   },
   {
    "Region Name": "Centre-Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2280.5
   }
  ],
  "Centre-Nord (Region of Burkina Faso)": [
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 605.6
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1607.6
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 631.5
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3990.9
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3272.6
   },
   {
    "Region Name": "Centre-Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4252.7
   }
  ],
  "Centre-Ouest (Region of Burkina Faso)": [
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5917.0
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6209.2
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4185.3
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6172.5
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4111.4
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3134.1
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3717.8
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3559.4
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3254.1
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3963.7
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1850.2
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2863.1
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2794.1
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2152.9
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2887.8
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2222.4
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1472.5
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1479.1
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1719.5
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1474.9
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1186.7
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1529.7
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1281.9
   },
   {
    "Region Name": "Centre-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 912.4
   }
  ],
  "Centre-Sud (Region of Burkina Faso)": [
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2501.0
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2282.8
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2189.8
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3082.6
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2257.1
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2053.2
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1978.4
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2252.4
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2276.8
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1889.2
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1374.5
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1812.5
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1533.0
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1172.4
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1713.5
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1716.0
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1429.4
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1464.6
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1398.8
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1537.2
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1062.8
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1371.5
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1585.3
   },
   {
    "Region Name": "Centre-Sud (Region of Burkina Faso)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1091.6
   }
  ],
  "Centre-Val de Loire (Region of France)": [
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 462.6
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 259.4
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 83.8
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 283.6
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Centre-Val de Loire (Region of France)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.1
   }
  ],
  "Centro Sur (Province of Equatorial Guinea)": [
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Centro Sur (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cerro Largo (Department of Uruguay)": [
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Cerro Largo (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 31.3
   }
  ],
  "Cesar (Department of Colombia)": [
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 694.6
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 719.9
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 444.8
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 384.6
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 661.5
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 486.8
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 193.1
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 395.1
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 372.4
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 250.4
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 257.9
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 481.3
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 187.8
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 425.3
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 342.3
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 396.6
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 437.5
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 329.3
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 163.1
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Cesar (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 51.2
   }
  ],
  "Cetinje (Municipality of Montenegro)": [
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Cetinje (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Ceuta y Melilla (Autonomous City of Spain)": [
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chachoengsao (Province of Thailand)": [
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 167.9
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 83.8
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 211.2
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Chachoengsao (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.4
   }
  ],
  "Chaco (Province of Argentina)": [
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1989.1
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7013.7
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5258.0
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2952.7
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1901.9
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4232.5
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3725.5
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2201.8
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1400.9
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2425.4
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2417.7
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2641.5
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1360.2
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1591.7
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1573.5
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7114.9
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1565.8
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2369.4
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5757.5
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1919.0
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1574.5
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1437.8
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2134.5
   },
   {
    "Region Name": "Chaco (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1319.0
   }
  ],
  "Chagang-do (Province of North Korea)": [
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Chagang-do (Province of North Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Chahar Mahall and Bakhtiari (Province of Iran)": [
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.9
   }
  ],
  "Chai Nat (Province of Thailand)": [
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 147.1
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 140.2
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 114.0
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 260.9
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 155.6
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 140.2
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 91.3
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 115.5
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Chai Nat (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 77.2
   }
  ],
  "Chaiyaphum (Province of Thailand)": [
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 328.4
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 498.4
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 676.8
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 478.7
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 266.5
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 289.0
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 244.2
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 182.6
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 259.2
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 125.8
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 228.9
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 352.4
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 525.6
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 325.4
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 562.5
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 300.3
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 376.0
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 643.3
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 407.5
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 167.4
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 380.1
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 516.8
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 287.9
   },
   {
    "Region Name": "Chaiyaphum (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 178.1
   }
  ],
  "Chalatenango (Department of El Salvador)": [
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Chalatenango (Department of El Salvador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Champasak (Province of Laos)": [
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 582.9
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 550.7
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 707.6
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 696.9
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 681.1
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 552.4
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 691.8
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 537.2
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 590.4
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 642.5
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 616.3
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 592.3
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 614.8
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 637.5
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 482.1
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 552.4
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 664.5
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 645.7
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 624.0
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 763.6
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 779.7
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 842.7
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 564.0
   },
   {
    "Region Name": "Champasak (Province of Laos)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 461.5
   }
  ],
  "Chandigarh (Union Territory of India)": [
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chandigarh (Union Territory of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chanthaburi (Province of Thailand)": [
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 180.7
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 187.6
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 154.8
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 118.8
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 128.8
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Chanthaburi (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.8
   }
  ],
  "Chaouia - Ouardigha (Region of Morocco)": [
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chari-Baguirmi (Region of Chad)": [
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5610.0
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5966.5
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8142.6
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7266.7
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5221.6
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4566.5
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5721.7
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4008.1
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5152.6
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8129.9
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4610.9
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4663.8
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2551.8
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2717.8
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4237.4
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3126.8
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2423.2
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2235.4
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2962.6
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2694.0
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1737.7
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2548.8
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1853.6
   },
   {
    "Region Name": "Chari-Baguirmi (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2281.3
   }
  ],
  "Charlotte (Parish of Saint Vincent and the Grenadines)": [
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chatham Islands (Territory of New Zealand)": [
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chatham Islands (Territory of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chechnya (Republic of Russia)": [
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 210.5
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 205.8
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 358.9
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 415.4
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 153.5
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 108.7
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 105.9
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Chechnya (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 56.8
   }
  ],
  "Chelyabinsk (Region of Russia)": [
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 325.0
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1188.5
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1111.9
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 779.2
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 587.6
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 515.6
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2793.4
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 866.7
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 570.0
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 130.1
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1972.4
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 163.8
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 470.1
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 304.0
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 363.6
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 521.1
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 771.3
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 646.8
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 192.7
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 865.6
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 138.9
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 330.1
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Chelyabinsk (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 269.5
   }
  ],
  "Cherkasy (Region of Ukraine)": [
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1364.0
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 426.2
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 882.8
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1471.4
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 827.7
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 846.1
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2298.7
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1030.0
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 387.4
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 556.9
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 270.3
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 464.1
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1115.6
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 672.7
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 428.1
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 659.6
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 226.4
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1447.4
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 179.4
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 114.9
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Cherkasy (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 52.9
   }
  ],
  "Chernihiv (Region of Ukraine)": [
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 505.7
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 132.7
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 753.9
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 755.4
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 279.8
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 657.7
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1256.2
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1284.5
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 224.9
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 245.5
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 278.7
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 534.6
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1682.8
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1106.1
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 151.8
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 158.2
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 287.5
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1098.4
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 283.0
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 108.3
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 559.5
   },
   {
    "Region Name": "Chernihiv (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 182.9
   }
  ],
  "Chernivtsi (Region of Ukraine)": [
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 125.6
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 80.2
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 105.7
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Chernivtsi (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Chhattisgarh (State of India)": [
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 571.1
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1548.0
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1748.0
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1588.5
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 175.1
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2955.7
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1910.0
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4156.0
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3044.3
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3239.8
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3384.7
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1999.2
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 915.1
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1240.8
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2703.4
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4674.1
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1991.1
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1800.5
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 437.1
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3376.1
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1870.2
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 673.8
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1286.4
   },
   {
    "Region Name": "Chhattisgarh (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 892.0
   }
  ],
  "Chhukha (District of Bhutan)": [
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chhukha (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chiang Mai (Province of Thailand)": [
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 358.9
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 755.7
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1873.6
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 258.3
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 995.3
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1066.3
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1459.4
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 844.6
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 531.4
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 881.9
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 548.1
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 504.6
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1140.0
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1039.0
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 854.7
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 820.4
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 946.4
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 900.8
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1839.3
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 320.1
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 573.9
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 330.6
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 641.8
   },
   {
    "Region Name": "Chiang Mai (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 132.9
   }
  ],
  "Chiang Rai (Province of Thailand)": [
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 200.2
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 400.9
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 938.5
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 258.1
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 692.6
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 629.0
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 513.4
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 496.5
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 663.3
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 200.4
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 502.3
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 376.2
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 322.4
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 353.3
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1183.5
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 894.1
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 520.7
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 306.5
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 185.9
   },
   {
    "Region Name": "Chiang Rai (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 17.8
   }
  ],
  "Chiapas (State of M\u00e9xico)": [
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1415.9
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2473.0
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1274.4
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1803.1
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 976.2
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1451.5
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 914.9
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1452.3
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 902.1
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 749.9
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 678.3
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1629.6
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 546.0
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1239.5
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1206.0
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1206.3
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 803.0
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2092.5
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1190.4
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1217.4
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1264.3
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1404.5
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1687.1
   },
   {
    "Region Name": "Chiapas (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 798.5
   }
  ],
  "Chiba (Prefecture of Japan)": [
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiba (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chihuahua (State of M\u00e9xico)": [
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 894.6
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 398.7
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 189.9
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 107.2
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 492.4
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 406.2
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 571.9
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 702.5
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 622.7
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2532.3
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1242.7
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 518.6
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 487.5
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 359.1
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 265.4
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1177.5
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2068.0
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 476.3
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1042.9
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 958.9
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 638.8
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 759.3
   },
   {
    "Region Name": "Chihuahua (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1555.2
   }
  ],
  "Chikwawa (District of Malawi)": [
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1049.8
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 995.5
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 903.4
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 821.7
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 893.1
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1051.1
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 803.9
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 491.5
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 716.8
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1087.1
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 807.3
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 441.6
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 743.9
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 700.3
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 777.3
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 676.3
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 947.9
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 477.2
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 808.2
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 328.0
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 585.4
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 359.9
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 156.5
   },
   {
    "Region Name": "Chikwawa (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 356.1
   }
  ],
  "Chimaltenango (Department of Guatemala)": [
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Chimaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16.1
   }
  ],
  "Chimborazo (Province of Ecuador)": [
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Chimborazo (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.9
   }
  ],
  "Chimbu (Province of Papua New Guinea)": [
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Chimbu (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chin (State of Myanmar)": [
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1560.8
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4004.2
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6258.3
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2036.1
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2594.3
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5616.3
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3853.9
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5492.8
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5424.2
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4117.2
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3677.7
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4070.7
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3658.9
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3233.8
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1278.5
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 928.9
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1474.9
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1216.5
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3694.6
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3641.5
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2016.1
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4862.3
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2840.6
   },
   {
    "Region Name": "Chin (State of Myanmar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12322.8
   }
  ],
  "Chinandega (Department of Nicaragua)": [
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 344.7
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 305.0
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 508.5
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 191.9
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 259.4
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 272.5
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 290.3
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 335.3
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 199.4
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 180.9
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 320.9
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 370.0
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 349.6
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 396.8
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 269.2
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 293.0
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 295.0
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 333.8
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 230.2
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 283.0
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 252.1
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 282.3
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 223.2
   },
   {
    "Region Name": "Chinandega (Department of Nicaragua)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 170.6
   }
  ],
  "Chiquimula (Department of Guatemala)": [
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Chiquimula (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chiradzulu (District of Malawi)": [
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Chiradzulu (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Chiriqu\u00ed (Province of Panama)": [
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Chiriqu\u00ed (Province of Panama)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chirongui (Commune of Mayotte)": [
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chirongui (Commune of Mayotte)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chitipa (District of Malawi)": [
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 212.9
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 331.2
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 174.9
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 363.8
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 150.5
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 232.8
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 210.7
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 195.3
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 259.6
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 148.6
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 233.0
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 247.0
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 159.5
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 179.6
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 195.1
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 170.2
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 158.8
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 205.4
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 177.1
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 162.1
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 185.9
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 165.9
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 166.4
   },
   {
    "Region Name": "Chitipa (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 171.9
   }
  ],
  "Chittagong (Division of Bangladesh)": [
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 276.8
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 93.7
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 394.2
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1331.2
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 348.3
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 850.0
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1004.5
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 215.4
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 232.4
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1088.4
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 955.0
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 187.1
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 251.7
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 188.9
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 954.2
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 677.8
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 172.6
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 788.4
   },
   {
    "Region Name": "Chittagong (Division of Bangladesh)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2435.9
   }
  ],
  "Chi\u0219in\u0103u (City of Moldova)": [
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chlef (Province of Algeria)": [
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chlef (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chobe (District of Botswana)": [
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4081.2
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 591.7
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4962.4
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1818.7
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6559.7
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2813.6
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6493.9
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4619.4
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5036.0
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8112.2
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3217.7
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2884.1
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4059.7
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2457.7
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3577.2
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5767.2
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4862.1
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 844.8
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2290.3
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3636.6
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4745.3
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4754.3
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 948.2
   },
   {
    "Region Name": "Chobe (District of Botswana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1572.2
   }
  ],
  "Choc\u00f3 (Department of Colombia)": [
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 130.3
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 283.4
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Choc\u00f3 (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Choiseul (Province of Solomon Islands)": [
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Province of Solomon Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Choiseul (Quarter of Saint Lucia)": [
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Choiseul (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Choluteca (Department of Honduras)": [
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 150.3
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 119.2
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 98.0
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 117.3
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 123.3
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 125.2
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 93.9
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 139.8
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Choluteca (Department of Honduras)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 69.0
   }
  ],
  "Chon Buri (Province of Thailand)": [
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Chon Buri (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.4
   }
  ],
  "Chongqing (Municipality of China)": [
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 81.7
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Chongqing (Municipality of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chontales (Department of Nicaragua)": [
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 90.0
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Chontales (Department of Nicaragua)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Christ Church (Parish of Barbados)": [
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Christ Church (Parish of Barbados)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chubut (Province of Argentina)": [
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 311.0
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 118.3
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 51.9
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 369.6
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 175.8
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 342.8
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 121.1
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 986.7
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 196.6
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 440.7
   },
   {
    "Region Name": "Chubut (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 940.7
   }
  ],
  "Chukot (Autonomous Province of Russia)": [
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3067.6
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9640.2
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 388.7
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 601.3
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 290.5
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 931.6
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 756.3
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 396.6
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4118.2
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 162.9
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 457.2
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 165.7
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 263.5
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 636.0
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1017.0
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 152.6
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 948.4
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2328.5
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3434.0
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 766.2
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 352.4
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 441.2
   },
   {
    "Region Name": "Chukot (Autonomous Province of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 153.7
   }
  ],
  "Chumphon (Province of Thailand)": [
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chumphon (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chungcheongbuk-do (Province of South Korea)": [
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Chungcheongbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chungcheongnam-do (Province of South Korea)": [
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chungcheongnam-do (Province of South Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chuquisaca (Department of Bolivia)": [
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 186.1
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 149.2
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 355.2
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 185.6
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Chuquisaca (Department of Bolivia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.4
   }
  ],
  "Chuuk (State of Micronesia)": [
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuuk (State of Micronesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Chuvash (Republic of Russia)": [
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 108.7
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 116.8
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 142.8
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Chuvash (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.4
   }
  ],
  "Ch\u00fcy (Province of Kyrgyzstan)": [
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 156.1
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 134.4
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 116.0
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 128.2
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 211.4
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 171.3
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 108.9
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Ch\u00fcy (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 28.9
   }
  ],
  "Cibitoke (Province of Burundi)": [
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cibitoke (Province of Burundi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cidra (Municipality of Puerto Rico)": [
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cidra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ciego de \u00c1vila (Province of Cuba)": [
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 200.9
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 333.6
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 565.9
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 275.9
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 454.7
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 369.6
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 386.3
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 482.8
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 141.5
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 350.5
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 218.7
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 260.2
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 150.9
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 205.4
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 189.7
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 97.8
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 118.8
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 339.3
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 297.3
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 455.7
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 209.9
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 560.4
   },
   {
    "Region Name": "Ciego de \u00c1vila (Province of Cuba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 286.4
   }
  ],
  "Cienfuegos (Province of Cuba)": [
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 109.3
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 92.4
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 88.7
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 87.5
   },
   {
    "Region Name": "Cienfuegos (Province of Cuba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 104.8
   }
  ],
  "Cimi\u0219lia (District of Moldova)": [
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cimi\u0219lia (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "City of St. Petersburg (City of Russia)": [
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "City of St. Petersburg (City of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ciudad de Buenos Aires (Federal District of Argentina)": [
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ciudad de la Habana (Province of Cuba)": [
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ciudad de la Habana (Province of Cuba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Clare (County of Ireland)": [
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clare (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Clarendon (Parish of Jamaica)": [
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Clarendon (Parish of Jamaica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cluj (County of Romania)": [
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cluj (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Coahuila (State of M\u00e9xico)": [
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 307.0
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 160.8
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 130.3
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 175.6
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6038.6
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 283.8
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 201.9
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Coahuila (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 34.5
   }
  ],
  "Coamo (Municipality of Puerto Rico)": [
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coamo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cochabamba (Department of Bolivia)": [
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 238.6
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 482.8
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 455.3
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 542.6
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 368.1
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 744.1
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 334.4
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1116.2
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 412.0
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 170.0
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 200.9
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 118.1
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 743.4
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 177.3
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 347.3
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 572.6
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 464.8
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 294.1
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 897.6
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1101.2
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 518.8
   },
   {
    "Region Name": "Cochabamba (Department of Bolivia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 117.3
   }
  ],
  "Cocl\u00e9 (Province of Panama)": [
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 108.7
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 105.3
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 88.3
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 92.4
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Cocl\u00e9 (Province of Panama)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 28.5
   }
  ],
  "Coimbra (District of Portugal)": [
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 467.3
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1219.1
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Coimbra (District of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 257.7
   }
  ],
  "Cojedes (State of Venezuela)": [
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1458.4
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1725.5
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 827.2
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1525.4
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1334.2
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1253.4
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 947.3
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2068.0
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 830.7
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 846.1
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1113.2
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1658.8
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1313.4
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2014.4
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 898.0
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1406.0
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1655.6
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1648.9
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1826.4
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1268.6
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1417.8
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1913.5
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2060.9
   },
   {
    "Region Name": "Cojedes (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1719.0
   }
  ],
  "Colima (State of M\u00e9xico)": [
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Colima (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 17.4
   }
  ],
  "Collines (Department of Benin)": [
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2131.5
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1313.9
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4201.0
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1810.3
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2979.5
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2066.3
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 795.7
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1434.6
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1014.6
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 820.4
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1822.8
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1331.7
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 466.3
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2873.8
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 878.7
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 521.1
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 593.8
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 755.2
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 244.4
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 220.2
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 289.2
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 356.7
   },
   {
    "Region Name": "Collines (Department of Benin)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 88.7
   }
  ],
  "Colombo (District of Sri Lanka)": [
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Colombo (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Colonia (Department of Uruguay)": [
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Colonia (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Colorado (State of United States)": [
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1494.4
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 242.5
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 144.7
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 131.2
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 249.3
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 392.7
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 158.0
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 198.9
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 453.2
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 758.0
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 756.5
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 151.6
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 560.8
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 330.3
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1612.7
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 174.3
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2065.2
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 564.6
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 451.5
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 238.8
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 369.1
   },
   {
    "Region Name": "Colorado (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 947.9
   }
  ],
  "Col\u00f3n (Department of Honduras)": [
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 258.3
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 124.1
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 98.4
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 163.3
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 142.3
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 115.5
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 123.9
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 227.0
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Col\u00f3n (Department of Honduras)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Col\u00f3n (Province of Panama)": [
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Col\u00f3n (Province of Panama)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Comayagua (Department of Honduras)": [
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 127.1
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Comayagua (Department of Honduras)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.8
   }
  ],
  "Comer\u00edo (Municipality of Puerto Rico)": [
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comer\u00edo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Commewijne (District of Suriname)": [
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Commewijne (District of Suriname)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Como\u00e9 (District of C\u00f4te d'Ivoire)": [
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 89.8
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Como\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Compostela Valley (Province of Philippines)": [
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Compostela Valley (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Comunidad Foral de Navarra (Autonomous Community of Spain)": [
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 188.0
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Comunidad Valenciana (Autonomous Community of Spain)": [
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 122.8
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 672.0
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 352.4
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.1
   }
  ],
  "Comunidad de Madrid (Autonomous Community of Spain)": [
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 49.9
   }
  ],
  "Conakry (Region of Guinea)": [
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Conakry (Region of Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Concepci\u00f3n (Department of Paraguay)": [
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5457.8
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3384.0
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1553.3
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3166.4
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2570.5
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6924.3
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1443.6
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1084.3
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1369.2
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2493.8
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1311.7
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1076.8
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 577.3
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 663.7
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1343.5
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5528.1
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1849.4
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2750.1
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1561.7
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5278.8
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 663.7
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1405.8
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1590.6
   },
   {
    "Region Name": "Concepci\u00f3n (Department of Paraguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 150.1
   }
  ],
  "Connecticut (State of United States)": [
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Connecticut (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Constantine (Province of Algeria)": [
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Constantine (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Constan\u021ba (County of Romania)": [
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 140.4
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 344.9
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 371.7
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 220.2
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1144.9
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 137.4
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 476.3
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 420.8
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 124.1
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 282.5
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 158.4
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 135.1
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Constan\u021ba (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.1
   }
  ],
  "Copperbelt (Province of Zambia)": [
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6264.9
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7208.2
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7532.7
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8301.9
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7171.3
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7048.7
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7557.4
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5679.7
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6467.9
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8043.6
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8535.5
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8812.3
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8427.5
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8253.4
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7816.8
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6926.0
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8058.8
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9134.7
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8087.9
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7279.8
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9587.9
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8245.1
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9360.0
   },
   {
    "Region Name": "Copperbelt (Province of Zambia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8820.6
   }
  ],
  "Cop\u00e1n (Department of Honduras)": [
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Cop\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.1
   }
  ],
  "Coquimbo (Region of Chile)": [
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Coquimbo (Region of Chile)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Coral Sea Islands Territory (Territory of Australia)": [
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cordillera (Department of Paraguay)": [
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 133.8
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 704.4
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 182.0
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 330.6
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 238.4
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 241.6
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 381.6
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 170.6
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 105.9
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 332.7
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 173.4
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 507.4
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 129.1
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 203.0
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 287.0
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 341.5
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 244.0
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 631.1
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 427.0
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 315.8
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 381.6
   },
   {
    "Region Name": "Cordillera (Department of Paraguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 150.9
   }
  ],
  "Cork (County of Ireland)": [
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cork (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Coronie (District of Suriname)": [
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Coronie (District of Suriname)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Corozal (District of Belize)": [
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Corozal (District of Belize)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.4
   }
  ],
  "Corrientes (Province of Argentina)": [
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 649.5
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4866.0
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6456.2
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5108.2
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3552.7
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4872.0
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4142.9
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3527.9
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1956.3
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4304.5
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3758.1
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2797.7
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 599.2
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1209.3
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1805.0
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1499.7
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1235.0
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2895.5
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6074.6
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11248.2
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2546.1
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1430.5
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2382.7
   },
   {
    "Region Name": "Corrientes (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1544.3
   }
  ],
  "Corse (Region of France)": [
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 256.6
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Corse (Region of France)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cort\u00e9s (Department of Honduras)": [
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 81.7
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 119.2
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 96.0
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 110.4
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 87.5
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 105.5
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Cort\u00e9s (Department of Honduras)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 32.6
   }
  ],
  "Cotopaxi (Province of Ecuador)": [
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Cotopaxi (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Countryside (Sub-Region of \u00c5land)": [
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Countryside (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)": [
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Covalima (District of Timor-Leste)": [
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covalima (District of Timor-Leste)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Covasna (County of Romania)": [
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Covasna (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Crete (Decentralized administration of Greece)": [
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Crete (Decentralized administration of Greece)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.1
   }
  ],
  "Crimea (Autonomous Republic of Ukraine)": [
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 272.9
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 351.4
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 986.5
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1055.6
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2681.8
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1150.1
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 358.2
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 306.3
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 564.4
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 202.8
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 165.7
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 144.5
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 132.1
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 263.9
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 113.4
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Crimea (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 59.4
   }
  ],
  "Criuleni (District of Moldova)": [
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Criuleni (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Crooked Island (District of Bahamas)": [
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Crooked Island (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cross River (State of Nigeria)": [
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1502.3
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2047.4
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3666.6
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 890.7
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1374.5
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1600.9
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 421.7
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1223.0
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1472.5
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1067.1
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1318.8
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1225.3
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2160.0
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2035.0
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1351.6
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 871.0
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 802.4
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3062.5
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1471.6
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1579.3
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1072.1
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1077.2
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1131.4
   },
   {
    "Region Name": "Cross River (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 631.3
   }
  ],
  "Csongr\u00e1d (County of Hungary)": [
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Csongr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cuando Cubango (Province of Angola)": [
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 82698.0
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 96917.5
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 96761.9
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 97374.8
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 71738.4
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 91384.6
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 84862.3
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 68687.9
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 86227.8
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 102644.0
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 88925.4
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 92748.5
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 77353.1
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 86249.0
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 74091.1
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 74558.8
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 67792.7
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 74961.4
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 52204.2
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 74619.1
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 67888.7
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 84699.1
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 77681.8
   },
   {
    "Region Name": "Cuando Cubango (Province of Angola)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 68832.0
   }
  ],
  "Cuanza Norte (Province of Angola)": [
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3543.5
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5533.7
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4161.8
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2967.3
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4305.6
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4535.6
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3976.1
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3353.2
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4361.3
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4082.4
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3060.1
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3981.9
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3261.4
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3371.6
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4114.2
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3337.1
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3474.5
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3386.6
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4668.5
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3158.9
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3871.7
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3410.4
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4017.9
   },
   {
    "Region Name": "Cuanza Norte (Province of Angola)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3650.5
   }
  ],
  "Cuanza Sul (Province of Angola)": [
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18457.0
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19820.3
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22128.0
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20317.5
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22302.1
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21461.3
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 20544.3
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 21761.9
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 23853.3
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21181.2
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20013.5
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 19197.0
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 22021.3
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 19134.8
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 21543.2
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21230.0
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19439.2
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 21812.9
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 24893.0
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20025.3
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19872.4
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 20026.1
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18266.2
   },
   {
    "Region Name": "Cuanza Sul (Province of Angola)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 21767.9
   }
  ],
  "Culebra (Municipality of Puerto Rico)": [
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Culebra (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cundinamarca (Department of Colombia)": [
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 86.6
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 122.8
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Cundinamarca (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.4
   }
  ],
  "Cunene (Province of Angola)": [
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16964.1
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 23078.5
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23531.7
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18915.7
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9609.1
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19724.3
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6422.5
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13956.9
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11616.9
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14841.8
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10715.7
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13714.3
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12046.5
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14812.5
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16193.9
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13139.1
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10593.3
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8337.5
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13244.1
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9393.6
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9567.7
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9104.7
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18379.8
   },
   {
    "Region Name": "Cunene (Province of Angola)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13358.6
   }
  ],
  "Cuscatl\u00e1n (Department of El Salvador)": [
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Cuscatl\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Cusco (Region of Peru)": [
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 144.9
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 481.0
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 106.8
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 111.3
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 185.2
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 118.8
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 107.6
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 249.3
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 307.8
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 410.7
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 78.0
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 505.3
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 151.3
   },
   {
    "Region Name": "Cusco (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 48.4
   }
  ],
  "Cuvette (Region of Republic of the Congo)": [
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1150.9
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1720.7
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3172.9
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2684.1
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3812.8
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2490.8
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1626.8
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2155.3
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2531.3
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3683.9
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3013.0
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3061.6
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1624.7
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3390.0
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2696.5
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2196.2
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3021.1
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2729.1
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2879.2
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2349.3
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3268.5
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2172.4
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4709.0
   },
   {
    "Region Name": "Cuvette (Region of Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3173.3
   }
  ],
  "Cuvette-Ouest (Region of Republic of the Congo)": [
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 193.6
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 673.1
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 725.9
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 552.0
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 998.1
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 597.0
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 341.1
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 584.8
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 644.4
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 884.9
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 869.7
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 913.6
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 405.2
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 964.7
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 613.5
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 794.5
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 700.3
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 786.9
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 732.3
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 676.5
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1078.7
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1022.8
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1230.9
   },
   {
    "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 825.5
   }
  ],
  "Cuyuni-Mazaruni (Region of Guyana)": [
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.4
   }
  ],
  "C\u00e0 Mau (Province of Vietnam)": [
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "C\u00e0 Mau (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "C\u00f3rdoba (Department of Colombia)": [
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "C\u00f3rdoba (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.4
   }
  ],
  "C\u00f3rdoba (Province of Argentina)": [
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1855.6
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2010.6
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 685.3
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 883.6
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1244.8
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 468.0
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1695.9
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1962.8
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 402.6
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1097.8
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 308.3
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1737.2
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 471.0
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 736.4
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 521.1
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 922.9
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 369.4
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 635.4
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3611.5
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 960.8
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 859.4
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 393.4
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1495.2
   },
   {
    "Region Name": "C\u00f3rdoba (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 507.8
   }
  ],
  "C\u0103l\u0103ra\u0219i (County of Romania)": [
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 127.5
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 215.4
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 228.5
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 697.6
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 144.5
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 251.2
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 341.1
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 17.8
   }
  ],
  "C\u1ea7n Th\u01a1 (City of Vietnam)": [
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 418.7
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 225.9
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 252.1
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 228.1
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 350.1
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 293.9
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 504.2
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 197.4
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 794.5
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 390.8
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 697.3
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1086.0
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 240.5
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 172.1
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 867.1
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 610.7
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 184.1
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 390.4
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 116.8
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 468.0
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 210.7
   },
   {
    "Region Name": "C\u1ea7n Th\u01a1 (City of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 92.8
   }
  ],
  "Dadra and Nagar Haveli (Union Territory of India)": [
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Daegu (Metropolitan City of South Korea)": [
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daegu (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Daejeon (Metropolitan City of South Korea)": [
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daejeon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dagana (District of Bhutan)": [
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dagana (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dagestan (Republic of Russia)": [
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 121.8
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 114.7
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 170.4
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 142.1
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 272.5
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 171.7
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 231.5
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 122.0
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 146.0
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 190.6
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 111.9
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 229.6
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 177.5
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 114.0
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 318.3
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 117.3
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 180.7
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Dagestan (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 643.8
   }
  ],
  "Daglig-Shirvan (Region of Azerbaijan)": [
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 134.4
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 196.4
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.2
   }
  ],
  "Dajab\u00f3n (Province of Dominican Republic)": [
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dajab\u00f3n (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dakar (Region of Senegal)": [
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakar (Region of Senegal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dakhlet Nouadhibou (Region of Mauritania)": [
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dalarna (County of Sweden)": [
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dalarna (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Daman and Diu (Union Territory of India)": [
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daman and Diu (Union Territory of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Danilovgrad (Municipality of Montenegro)": [
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Danilovgrad (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dar es Salaam (Region of Tanzania)": [
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Dar es Salaam (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dar`a (Governorate of Syria)": [
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Dar`a (Governorate of Syria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Darhan-Uul (Municipality of Mongolia)": [
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 168.7
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darhan-Uul (Municipality of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dari\u00e9n (Province of Panama)": [
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 428.1
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 98.4
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Dari\u00e9n (Province of Panama)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Darnah (District of Libya)": [
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnah (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Darnytskyi (Distict of Ukraine)": [
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Darnytskyi (Distict of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Davao Oriental (Province of Philippines)": [
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao Oriental (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Davao del Norte (Province of Philippines)": [
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Davao del Sur (Province of Philippines)": [
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Davao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Daykundi (Province of Afghanistan)": [
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Daykundi (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dayr Az Zawr (Governorate of Syria)": [
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 188.6
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Dayr Az Zawr (Governorate of Syria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.7
   }
  ],
  "Da\u015foguz (Province of Turkmenistan)": [
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 83.8
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Da\u015foguz (Province of Turkmenistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 46.7
   }
  ],
  "Debar (Municipality of North Macedonia)": [
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Debarca (Municipality of North Macedonia)": [
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debarca (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Debub (Region of Eritrea)": [
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debub (Region of Eritrea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Debubawi Keyih Bahri (Region of Eritrea)": [
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 99.5
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 132.7
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Dededo (Municipality of Guam)": [
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dededo (Municipality of Guam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dedza (District of Malawi)": [
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 90.2
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 88.3
   },
   {
    "Region Name": "Dedza (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 42.2
   }
  ],
  "Delaware (State of United States)": [
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Delaware (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Delta (State of Nigeria)": [
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 757.6
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 375.4
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 217.4
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 279.8
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 707.6
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 292.4
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 205.4
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 241.2
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 170.9
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 303.1
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 435.6
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 224.0
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 281.3
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 189.9
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1178.4
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 424.5
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1185.9
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 584.6
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 733.1
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 449.1
   },
   {
    "Region Name": "Delta (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.4
   }
  ],
  "Delta Amacuro (State of Venezuela)": [
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 497.8
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 229.8
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 225.1
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 432.6
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 135.9
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 802.2
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 233.9
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 250.8
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 890.7
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 367.9
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 173.9
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 138.5
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 300.8
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 979.9
   },
   {
    "Region Name": "Delta Amacuro (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 139.3
   }
  ],
  "Del\u010devo (Municipality of North Macedonia)": [
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Del\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dembeni (Commune of Mayotte)": [
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dembeni (Commune of Mayotte)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Demerara-Mahaica (Region of Guyana)": [
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 130.3
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 114.5
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 162.5
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 185.6
   },
   {
    "Region Name": "Demerara-Mahaica (Region of Guyana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.8
   }
  ],
  "Demir Hisar (Municipality of North Macedonia)": [
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Demir Hisar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Demir Kapija (Municipality of North Macedonia)": [
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Demir Kapija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)": [
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5213.7
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3244.5
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5371.7
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2996.0
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4191.8
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2864.6
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1894.0
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3280.1
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2578.4
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2814.2
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1813.1
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1505.7
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 950.9
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3136.0
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1110.2
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 488.5
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 305.5
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1021.0
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 438.2
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 286.4
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 597.7
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 472.7
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 309.1
   },
   {
    "Region Name": "Dengu\u00e9l\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 184.1
   }
  ],
  "Denizli (Province of Turkey)": [
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Denizli (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 39.0
   }
  ],
  "Dennery (Quarter of Saint Lucia)": [
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dennery (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dependencias Federales (State of Venezuela)": [
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dependencias Federales (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Devonshire (Parish of Bermuda)": [
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Devonshire (Parish of Bermuda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dhaka (Division of Bangladesh)": [
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Dhaka (Division of Bangladesh)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dhamar (Governorate of Yemen)": [
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhamar (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)": [
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dhi-Qar (Province of Iraq)": [
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 247.0
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 363.1
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 217.6
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 210.5
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Dhi-Qar (Province of Iraq)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 28.1
   }
  ],
  "Dhofar (Province of Oman)": [
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dhofar (Province of Oman)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dib\u00ebr (County of Albania)": [
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Dib\u00ebr (County of Albania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 35.8
   }
  ],
  "Diego Martin (Region of Trinidad and Tobago)": [
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Diekirch (District of Luxembourg)": [
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diekirch (District of Luxembourg)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Diffa (Department of Niger)": [
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 296.9
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 331.0
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 897.3
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 323.9
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 315.8
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 268.4
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 730.1
   },
   {
    "Region Name": "Diffa (Department of Niger)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 875.3
   }
  ],
  "Dihok (Province of Iraq)": [
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 94.8
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 179.0
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 125.0
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 156.7
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 212.7
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 195.9
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 234.9
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 234.7
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 131.2
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 232.8
   },
   {
    "Region Name": "Dihok (Province of Iraq)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 76.7
   }
  ],
  "Dikhil (Region of Djibouti)": [
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dikhil (Region of Djibouti)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dili (District of Timor-Leste)": [
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Dili (District of Timor-Leste)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dinagat Islands (Province of Philippines)": [
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dinagat Islands (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Diourbel (Region of Senegal)": [
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Diourbel (Region of Senegal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dire Dawa (City of Ethiopia)": [
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dire Dawa (City of Ethiopia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "District of Columbia (Federal District of United States)": [
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "District of Columbia (Federal District of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)": [
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.7
   }
  ],
  "Distrito Capital (State of Venezuela)": [
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Capital (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Distrito Federal (Federal District of Brazil)": [
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 81.9
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 258.5
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 343.4
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 160.6
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 181.4
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 99.9
   },
   {
    "Region Name": "Distrito Federal (Federal District of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 39.2
   }
  ],
  "Distrito Federal (Federal District of M\u00e9xico)": [
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Distrito Federal (Federal District of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Distrito Nacional (National District of Dominican Republic)": [
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Distrito Nacional (National District of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Diyala (Province of Iraq)": [
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 102.0
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 237.3
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 99.5
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 190.6
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 392.3
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1868.2
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 668.0
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 162.1
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 318.1
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 326.1
   },
   {
    "Region Name": "Diyala (Province of Iraq)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 116.4
   }
  ],
  "Diyarbakir (Province of Turkey)": [
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1185.9
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 338.3
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 443.7
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 562.7
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 524.6
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 906.4
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2782.1
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1528.7
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1513.0
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 237.7
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1126.3
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 750.9
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2312.6
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1822.1
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 646.1
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 448.5
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 357.4
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 489.0
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 220.2
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 494.3
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1365.3
   },
   {
    "Region Name": "Diyarbakir (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 138.1
   }
  ],
  "Djelfa (Province of Algeria)": [
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djelfa (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Djiboutii (Region of Djibouti)": [
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Djiboutii (Region of Djibouti)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dnipropetrovs'k (Region of Ukraine)": [
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1558.5
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 300.5
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 963.6
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4369.7
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1800.3
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1427.5
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5842.2
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1921.6
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1404.1
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 929.5
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 183.1
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 988.0
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1823.2
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1855.4
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1166.8
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2046.8
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 659.6
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1450.0
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1046.8
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1138.9
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 546.2
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 360.1
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 845.9
   },
   {
    "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 797.2
   }
  ],
  "Dobrich (Province of Bulgaria)": [
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 169.4
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 448.9
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 364.9
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 107.2
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 143.8
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 371.1
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 88.5
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 144.9
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 97.3
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 319.8
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Dobrich (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.4
   }
  ],
  "Dodoma (Region of Tanzania)": [
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 756.9
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 279.1
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 696.3
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 467.8
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 258.3
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1323.3
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 897.8
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 298.2
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 291.5
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 491.8
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 281.3
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 147.9
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 116.0
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 163.6
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 94.3
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 231.7
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 220.4
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 797.5
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 382.9
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 113.4
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 608.4
   },
   {
    "Region Name": "Dodoma (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 226.6
   }
  ],
  "Dog Island (Island of Anguilla)": [
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dog Island (Island of Anguilla)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dolj (County of Romania)": [
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 148.6
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 236.7
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 139.3
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 150.9
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 176.9
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 286.8
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 437.7
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 131.4
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 183.1
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 258.3
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 156.5
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 123.7
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 250.0
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 74.2
   },
   {
    "Region Name": "Dolj (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 37.5
   }
  ],
  "Dolneni (Municipality of North Macedonia)": [
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Dolneni (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Dolno\u015bl\u0105skie (Voivodeship of Poland)": [
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Dolno\u015bl\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.1
   }
  ],
  "Donduseni (District of Moldova)": [
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Donduseni (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Donegal (County of Ireland)": [
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Donegal (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Donets'k (Region of Ukraine)": [
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 812.5
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 258.1
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 330.6
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2471.9
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1016.5
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1382.3
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1937.5
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 539.4
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1339.2
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 693.7
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 225.1
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 441.0
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3033.1
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1337.2
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1643.4
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3412.3
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1532.3
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1132.5
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1495.7
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 577.7
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2032.4
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1068.6
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1925.5
   },
   {
    "Region Name": "Donets'k (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2637.6
   }
  ],
  "Donga (Department of Benin)": [
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3836.3
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3076.6
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3479.9
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2951.0
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2802.4
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2787.0
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1523.9
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2347.1
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2399.9
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2051.3
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1740.5
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1664.6
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 914.9
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1461.4
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1166.2
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 711.1
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 935.3
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 638.0
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 703.6
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 287.9
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1213.8
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 303.3
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1030.3
   },
   {
    "Region Name": "Donga (Department of Benin)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1740.7
   }
  ],
  "Dornod (Province of Mongolia)": [
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 977.3
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16915.2
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9776.3
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7745.2
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3894.0
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10365.6
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 906.4
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1358.2
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2268.7
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16210.2
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18228.2
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6516.6
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6443.7
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13415.4
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7534.0
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3758.3
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2719.7
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 375.8
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 658.1
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3622.6
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18831.2
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2287.7
   },
   {
    "Region Name": "Dornod (Province of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 652.1
   }
  ],
  "Dornogovi (Province of Mongolia)": [
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dornogovi (Province of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Dosso (Department of Niger)": [
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 220.2
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 289.4
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 105.7
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 287.0
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 137.6
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 127.3
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Dosso (Department of Niger)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 37.7
   }
  ],
  "Douglas (Town District of Isle of Man)": [
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Douglas (Town District of Isle of Man)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Doukkala - Abda (Region of Morocco)": [
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Doukkala - Abda (Region of Morocco)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dowa (District of Malawi)": [
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Dowa (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Drenthe (Province of Netherlands)": [
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drenthe (Province of Netherlands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Drochia (District of Moldova)": [
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Drochia (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Duarte (Province of Dominican Republic)": [
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Duarte (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dubai (Emirate of United Arab Emirates)": [
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubai (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dublin (Region of Ireland)": [
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dublin (Region of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dubrovacko-Neretvanska (County of Croatia)": [
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 193.6
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16.7
   }
  ],
  "Dub\u0103sari (District of Moldova)": [
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dub\u0103sari (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dumyat (Governorate of Egypt)": [
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dumyat (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dundgovi (Province of Mongolia)": [
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Dundgovi (Province of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Durango (State of M\u00e9xico)": [
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 449.5
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 354.1
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 123.7
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1075.5
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1453.4
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 985.2
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2244.7
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 318.3
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 234.9
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3379.5
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1740.2
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 425.7
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 93.5
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 291.3
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 909.4
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 562.5
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1264.1
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 160.6
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 913.9
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 586.7
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 473.5
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 285.1
   },
   {
    "Region Name": "Durango (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 416.3
   }
  ],
  "Durazno (Department of Uruguay)": [
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Durazno (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.1
   }
  ],
  "Durr\u00ebs (County of Albania)": [
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Durr\u00ebs (County of Albania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dushanbe (City of Tajikistan)": [
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dushanbe (City of Tajikistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dzaoudzi (Commune of Mayotte)": [
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzaoudzi (Commune of Mayotte)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Dzavhan (Province of Mongolia)": [
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2989.8
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Dzavhan (Province of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "D\u00e2mbovi\u021ba (County of Romania)": [
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00e2mbovi\u021ba (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "D\u00fczce (Province of Turkey)": [
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "D\u00fczce (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "East (Development Region of Nepal)": [
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 111.7
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 161.6
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 128.4
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 93.5
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 147.1
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 177.7
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 147.5
   },
   {
    "Region Name": "East (Development Region of Nepal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 424.5
   }
  ],
  "East (Region of Singapore)": [
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East (Region of Singapore)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "East Azarbaijan (Province of Iran)": [
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 72.7
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 159.5
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 80.0
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 385.2
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 190.8
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 136.6
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 232.2
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 114.0
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "East Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 28.5
   }
  ],
  "East Berbice-Corentyne (Region of Guyana)": [
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 125.4
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 293.0
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 93.5
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 87.9
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 123.0
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 163.1
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 113.8
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 291.8
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 380.7
   },
   {
    "Region Name": "East Berbice-Corentyne (Region of Guyana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 171.7
   }
  ],
  "East Darfur (State of Sudan)": [
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6481.4
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9138.6
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8516.2
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12276.5
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8668.7
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11937.1
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8424.9
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10911.2
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9739.4
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4539.0
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9203.1
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7672.7
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7341.7
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6717.5
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6747.7
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7059.2
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5803.6
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3894.2
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4575.1
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3599.5
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3954.9
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6611.6
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3745.2
   },
   {
    "Region Name": "East Darfur (State of Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11058.0
   }
  ],
  "East End (District of Cayman Islands)": [
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East End (District of Cayman Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "East Grand Bahama (District of Bahamas)": [
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 102.0
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "East Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 36.7
   }
  ],
  "East Kazakhstan (Region of Kazakhstan)": [
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 31002.3
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8181.8
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5844.8
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9338.6
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6687.9
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12864.9
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8241.8
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 326.7
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1210.5
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8800.5
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3083.5
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1840.4
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8994.9
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15035.2
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 900.1
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5225.7
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4544.6
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6585.8
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5103.7
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3323.6
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4673.2
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1285.6
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 320.1
   },
   {
    "Region Name": "East Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 905.3
   }
  ],
  "East New Britain (Province of Papua New Guinea)": [
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "East New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "East Sepik (Province of Papua New Guinea)": [
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 383.7
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 229.6
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 903.8
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 199.8
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 251.2
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 437.5
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 814.0
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1024.7
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 207.3
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 158.4
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 382.4
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 311.5
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1054.3
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 371.9
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 680.8
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 97.5
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 238.4
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 324.1
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 644.8
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 694.1
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 308.3
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 647.6
   },
   {
    "Region Name": "East Sepik (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 201.7
   }
  ],
  "Eastern (District of American Samoa)": [
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (District of American Samoa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Eastern (Division of Fiji)": [
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern (Division of Fiji)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Eastern (Province of Sierra Leone)": [
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 350.1
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 913.9
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 445.7
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 488.8
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2059.7
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 657.3
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 327.6
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 522.2
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 276.5
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 372.1
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 718.6
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 406.9
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1534.7
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1993.8
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 443.5
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 620.6
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 334.8
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 417.2
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 256.6
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 400.7
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 312.8
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 295.6
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 579.7
   },
   {
    "Region Name": "Eastern (Province of Sierra Leone)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 125.4
   }
  ],
  "Eastern (Province of Zambia)": [
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11027.8
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11604.7
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11216.0
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11028.4
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8945.0
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9314.1
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9418.5
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8267.6
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9098.9
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9485.6
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9325.3
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9814.2
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8518.4
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10363.7
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10108.4
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8099.1
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10490.8
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9542.0
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6424.4
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6917.7
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8279.8
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6173.2
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7614.0
   },
   {
    "Region Name": "Eastern (Province of Zambia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5151.5
   }
  ],
  "Eastern (Region of Ghana)": [
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2090.7
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2572.0
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3007.0
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1841.2
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3709.2
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3023.0
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2781.0
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2051.5
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2528.3
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2211.9
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2224.9
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2205.0
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2091.8
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2908.8
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2209.1
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2251.1
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1692.2
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3119.1
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2056.9
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2524.4
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1032.0
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1627.7
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2066.1
   },
   {
    "Region Name": "Eastern (Region of Ghana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 974.5
   }
  ],
  "Eastern Cape (Province of South Africa)": [
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6776.8
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6977.7
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3401.2
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7580.9
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4174.8
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8514.1
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6106.3
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5803.8
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5544.2
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4175.3
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5376.4
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7012.2
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6832.2
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4252.4
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3712.9
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4372.3
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3345.2
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3346.1
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3306.4
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7104.2
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3342.7
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7193.2
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8437.3
   },
   {
    "Region Name": "Eastern Cape (Province of South Africa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3542.4
   }
  ],
  "Eastern Equatoria (State of South Sudan)": [
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16264.6
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18696.0
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 18137.1
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20427.4
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18892.6
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23785.3
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22648.9
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17289.1
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19107.6
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19011.7
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21596.2
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18915.1
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20678.7
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 23500.2
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 20055.9
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16779.3
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20964.6
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11319.8
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22043.6
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20680.0
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18989.2
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22471.2
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22151.6
   },
   {
    "Region Name": "Eastern Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19675.6
   }
  ],
  "Eastern Finland (Province of Finland)": [
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Finland (Province of Finland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Eastern Highlands (Province of Papua New Guinea)": [
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 141.9
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 85.7
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.4
   }
  ],
  "Eastern Samar (Province of Philippines)": [
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eastern Samar (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ebon (Atol of Marshall Islands)": [
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ebon (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ebonyi (State of Nigeria)": [
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 248.5
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 797.7
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2523.3
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 308.9
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 214.2
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 349.4
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 220.8
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 277.2
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 200.2
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 388.0
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 284.9
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 192.1
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 518.8
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 559.3
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 367.9
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 237.7
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 143.0
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 493.3
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 369.4
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 435.4
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 434.3
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 396.8
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 574.9
   },
   {
    "Region Name": "Ebonyi (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 237.7
   }
  ],
  "Edine\u021b (District of Moldova)": [
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Edine\u021b (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Edirne (Province of Turkey)": [
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 149.2
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 104.2
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 80.2
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 140.4
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 176.2
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 140.0
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 153.3
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 106.8
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 167.9
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Edirne (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 51.4
   }
  ],
  "Edo (State of Nigeria)": [
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1833.7
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1717.5
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2359.1
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 201.5
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1324.2
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2090.3
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 708.3
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 672.5
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1556.7
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 977.7
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1084.5
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 459.2
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 931.6
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2258.8
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1905.3
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1157.4
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1125.0
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3497.0
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1240.8
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2808.7
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2630.7
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2451.5
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1709.4
   },
   {
    "Region Name": "Edo (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 516.2
   }
  ],
  "Ehime (Prefecture of Japan)": [
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ehime (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Ekiti (State of Nigeria)": [
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 194.2
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 174.5
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 123.5
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 121.1
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 123.9
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 135.3
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 99.9
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Ekiti (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 183.9
   }
  ],
  "El Bayadh (Province of Algeria)": [
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Bayadh (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "El Oro (Province of Ecuador)": [
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "El Oro (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.7
   }
  ],
  "El Oued (Province of Algeria)": [
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Oued (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.2
   }
  ],
  "El Para\u00edso (Department of Honduras)": [
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 340.0
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 339.8
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 154.6
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 89.2
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 197.0
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 410.9
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 123.7
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 149.2
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 175.4
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 156.7
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 389.9
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 89.2
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 154.8
   },
   {
    "Region Name": "El Para\u00edso (Department of Honduras)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24.7
   }
  ],
  "El Progreso (Department of Guatemala)": [
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "El Progreso (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "El Seybo (Province of Dominican Republic)": [
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "El Seybo (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.1
   }
  ],
  "El Tarf (Province of Algeria)": [
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 120.3
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 86.6
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 189.7
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 256.6
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "El Tarf (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.1
   }
  ],
  "Elaz\u0131\u011f (Province of Turkey)": [
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Elaz\u0131\u011f (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.8
   }
  ],
  "Elbasan (County of Albania)": [
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elbasan (County of Albania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30.9
   }
  ],
  "Elgeyo-Marakwet (County of Kenya)": [
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Elgeyo-Marakwet (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Ember\u00e1 (Indigenous Territory of Panama)": [
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 104.2
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ember\u00e1 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Embu (County of Kenya)": [
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Embu (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Emilia-Romagna (Region of Italy)": [
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Emilia-Romagna (Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.1
   }
  ],
  "Encamp (Parish of Andorra)": [
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Encamp (Parish of Andorra)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Enewetok (Atol of Marshall Islands)": [
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Enewetok (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Enga (Province of Papua New Guinea)": [
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 150.9
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Enga (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "England (Constituent Country of United Kingdom)": [
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "England (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.2
   }
  ],
  "Ennedi Est (Region of Chad)": [
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ennedi Est (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24.9
   }
  ],
  "Ennedi Ouest (Region of Chad)": [
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Ennedi Ouest (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 60.0
   }
  ],
  "Entre R\u00edos (Province of Argentina)": [
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 287.5
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1678.1
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 513.4
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2311.1
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 209.2
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5672.2
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 298.6
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 189.1
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 417.8
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 248.7
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 319.6
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 218.7
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 310.2
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 298.2
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3380.6
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1351.2
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2775.4
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 224.2
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 130.6
   },
   {
    "Region Name": "Entre R\u00edos (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 170.9
   }
  ],
  "Enugu (State of Nigeria)": [
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1692.4
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1591.9
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3917.4
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 717.5
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1222.8
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1311.3
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 882.3
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1047.8
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1284.1
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1404.1
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1144.9
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1183.1
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1312.6
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1455.1
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1057.5
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1093.5
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 999.8
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1613.3
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 842.5
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1148.2
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1122.2
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1342.6
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 962.7
   },
   {
    "Region Name": "Enugu (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 369.4
   }
  ],
  "Epirus and Western Macedonia (Decentralized administration of Greece)": [
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 137.0
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 90.0
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 76.1
   }
  ],
  "Erevan (City of Armenia)": [
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erevan (City of Armenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ermera (District of Timor-Leste)": [
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ermera (District of Timor-Leste)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Erongo (Region of Namibia)": [
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1961.3
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3009.7
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 921.1
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 452.1
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erongo (Region of Namibia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 406.4
   }
  ],
  "Erzincan (Province of Turkey)": [
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Erzincan (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.2
   }
  ],
  "Erzurum (Province of Turkey)": [
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Erzurum (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.8
   }
  ],
  "Es Semara (Province of Western Sahara)": [
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Es Semara (Province of Western Sahara)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Escaldes-Engordany (Parish of Andorra)": [
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Escaldes-Engordany (Parish of Andorra)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Escuintla (Department of Guatemala)": [
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 747.9
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 765.7
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 919.9
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 891.8
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 919.6
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 874.8
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 938.3
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 943.2
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 993.6
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 968.1
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 949.2
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 917.7
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1015.9
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 959.9
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1000.0
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1040.5
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 961.4
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1091.6
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1056.6
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 905.9
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1010.1
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 957.4
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 964.4
   },
   {
    "Region Name": "Escuintla (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1064.6
   }
  ],
  "Esfahan (Province of Iran)": [
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Esfahan (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.6
   }
  ],
  "Eskisehir (Province of Turkey)": [
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 111.7
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 120.7
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Eskisehir (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.1
   }
  ],
  "Esmeraldas (Province of Ecuador)": [
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Esmeraldas (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.2
   }
  ],
  "Espaillat (Province of Dominican Republic)": [
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Espaillat (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Esp\u00edrito Santo (State of Brazil)": [
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 296.7
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 306.5
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 108.9
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 65.4
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 142.8
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 136.1
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 260.5
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 176.0
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 330.8
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 130.1
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 153.5
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 188.9
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 90.0
   },
   {
    "Region Name": "Esp\u00edrito Santo (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24.7
   }
  ],
  "Essequibo Islands-West Demerara (Region of Guyana)": [
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 40.5
   }
  ],
  "Est (Region of Burkina Faso)": [
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9691.6
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10097.9
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12025.5
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10930.2
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10916.3
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10612.8
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8197.7
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9906.4
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9439.7
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9677.0
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8038.2
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8668.0
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8930.2
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8256.4
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8701.0
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9015.9
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8504.0
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8011.8
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7345.6
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8523.7
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7279.1
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9969.9
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11371.4
   },
   {
    "Region Name": "Est (Region of Burkina Faso)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10500.9
   }
  ],
  "Est (Region of Cameroon)": [
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9110.0
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9645.5
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8935.5
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7970.0
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4102.8
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4861.9
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4734.6
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4488.5
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4947.4
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3613.6
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2826.0
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 980.3
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1099.9
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 660.5
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1170.0
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1191.0
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1481.5
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1361.2
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2667.4
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1648.9
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2157.4
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1214.2
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2584.6
   },
   {
    "Region Name": "Est (Region of Cameroon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2788.1
   }
  ],
  "Estel\u00ed (Department of Nicaragua)": [
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Estel\u00ed (Department of Nicaragua)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Estuaire (Province of Gabon)": [
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Estuaire (Province of Gabon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Extremadura (Autonomous Community of Spain)": [
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 99.9
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 762.1
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 299.5
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 158.6
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 111.5
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 95.8
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 108.5
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 107.8
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 110.4
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Extremadura (Autonomous Community of Spain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 505.5
   }
  ],
  "Extr\u00eame-Nord (Region of Cameroon)": [
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2906.0
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2949.9
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3978.7
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3235.0
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3694.0
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2995.6
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2649.2
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3009.3
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1747.8
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3448.8
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2193.9
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2959.4
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2116.7
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2241.9
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2518.2
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2598.6
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2538.3
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1513.4
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2977.2
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3109.4
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2312.8
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2715.8
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2200.7
   },
   {
    "Region Name": "Extr\u00eame-Nord (Region of Cameroon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2567.3
   }
  ],
  "Exuma (District of Bahamas)": [
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Exuma (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Eysturoyar (Region of Faroe Islands)": [
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Eysturoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Fa'asaleleaga (District of Samoa)": [
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fa'asaleleaga (District of Samoa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Faetano (Municipality of San Marino)": [
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faetano (Municipality of San Marino)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Fajardo (Municipality of Puerto Rico)": [
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fajardo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Fakaofo (Atoll of Tokelau)": [
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fakaofo (Atoll of Tokelau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Falc\u00f3n (State of Venezuela)": [
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 115.8
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 89.8
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Falc\u00f3n (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 21.2
   }
  ],
  "Famagusta (District of Cyprus)": [
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Famagusta (District of Cyprus)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Far-Western (Development Region of Nepal)": [
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 298.6
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 119.8
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 245.5
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 231.7
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 286.4
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 273.1
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 209.2
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 241.0
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 299.5
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1219.1
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 289.6
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 240.3
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 632.6
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 599.2
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 267.3
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 289.8
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 879.6
   },
   {
    "Region Name": "Far-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 141.5
   }
  ],
  "Farah (Province of Afghanistan)": [
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farah (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Faranah (Region of Guinea)": [
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6854.7
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5928.2
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5827.8
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5830.2
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7582.7
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5982.0
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6271.6
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5227.0
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5673.3
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6509.3
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6338.9
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6466.7
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4557.9
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10641.9
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6119.4
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5597.8
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5299.2
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6106.7
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5926.2
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6458.1
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4751.5
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6344.9
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5618.2
   },
   {
    "Region Name": "Faranah (Region of Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3725.5
   }
  ],
  "Farg'ona (Region of Uzbekistan)": [
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Farg'ona (Region of Uzbekistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Faro (District of Portugal)": [
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 706.3
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 437.5
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 264.5
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 306.3
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 108.9
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Faro (District of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.2
   }
  ],
  "Fars (Province of Iran)": [
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 659.6
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 704.6
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 676.1
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 742.4
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 730.8
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 908.1
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 274.2
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 601.9
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 264.3
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 201.3
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 346.0
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 364.0
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 138.7
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 185.2
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 202.6
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 94.5
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 270.1
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 594.0
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 220.6
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 225.1
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 287.0
   },
   {
    "Region Name": "Fars (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 549.9
   }
  ],
  "Faryab (Province of Afghanistan)": [
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 143.8
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 228.1
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 118.1
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Faryab (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Fatick (Region of Senegal)": [
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 323.7
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 203.4
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 407.3
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 352.4
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 429.6
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 333.6
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 208.8
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 498.8
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 162.7
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 356.1
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 168.9
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 217.8
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 103.3
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 263.5
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 172.1
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 160.8
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 131.8
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 216.3
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 170.4
   },
   {
    "Region Name": "Fatick (Region of Senegal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 103.1
   }
  ],
  "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)": [
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 565.5
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 213.1
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 201.9
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 298.0
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 233.4
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 182.9
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 164.0
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 21.0
   }
  ],
  "Federal Capital Territory (State of Nigeria)": [
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 259.6
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 597.2
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1458.4
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 615.5
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 903.6
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 464.5
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 321.6
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 625.1
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 132.3
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 306.1
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 870.6
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 204.1
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 711.3
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 156.7
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 410.1
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 179.0
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 155.2
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 270.5
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 448.0
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 186.9
   },
   {
    "Region Name": "Federal Capital Territory (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 228.1
   }
  ],
  "Federally Administered Tribal Ar (Territory of Pakistan)": [
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 111.9
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 138.1
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 141.3
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 182.4
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 161.2
   },
   {
    "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 185.9
   }
  ],
  "Fej\u00e9r (County of Hungary)": [
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Fej\u00e9r (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Fianarantsoa (NA of Madagascar)": [
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8513.9
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18392.4
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7722.0
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13936.1
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10710.5
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15299.1
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10774.0
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9974.8
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9882.4
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11291.2
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10153.4
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7122.8
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7510.4
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7560.6
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10969.9
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7499.5
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6819.5
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7768.1
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6200.8
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6681.0
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6638.6
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7954.2
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9571.6
   },
   {
    "Region Name": "Fianarantsoa (NA of Madagascar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8198.5
   }
  ],
  "Fier (County of Albania)": [
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fier (County of Albania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Finnmark (County of Norway)": [
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Finnmark (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Fiorentino (Municipality of San Marino)": [
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fiorentino (Municipality of San Marino)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Flacq (District of Mauritius)": [
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flacq (District of Mauritius)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Flevoland (Province of Netherlands)": [
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flevoland (Province of Netherlands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Flores (Department of Uruguay)": [
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Flores (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Flore\u0219ti (District of Moldova)": [
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Flore\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Florida (Department of Uruguay)": [
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Florida (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.9
   }
  ],
  "Florida (Municipality of Puerto Rico)": [
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Florida (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Florida (State of United States)": [
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2140.5
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2167.7
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3212.3
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2684.1
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3519.7
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3521.0
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3087.8
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2762.6
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2600.3
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2864.4
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2680.3
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2848.1
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2964.7
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2141.3
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2757.0
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2776.3
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2881.5
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2584.9
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2294.4
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3466.1
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2475.5
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2015.9
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2491.2
   },
   {
    "Region Name": "Florida (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2659.9
   }
  ],
  "Formosa (Province of Argentina)": [
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1429.2
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8292.0
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4207.4
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3339.4
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3390.9
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3343.5
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6053.8
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3502.1
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2831.2
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6999.4
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4934.1
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3688.2
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2423.9
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2723.3
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3380.0
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9355.5
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4106.0
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3870.0
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9148.6
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9727.4
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2315.8
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3635.1
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3798.8
   },
   {
    "Region Name": "Formosa (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1740.9
   }
  ],
  "Fort-de-France (Arrondissement of Martinique)": [
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fort-de-France (Arrondissement of Martinique)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Francisco Moraz\u00e1n (Department of Honduras)": [
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 184.8
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 414.2
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 216.7
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 338.9
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 200.0
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 463.0
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 87.5
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 287.3
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 253.2
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 286.6
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 262.6
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 235.4
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 317.7
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 736.6
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 511.9
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 955.7
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 93.7
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 325.2
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 269.5
   },
   {
    "Region Name": "Francisco Moraz\u00e1n (Department of Honduras)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 80.8
   }
  ],
  "Free State (Province of South Africa)": [
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4027.6
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3905.8
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1695.4
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2449.8
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2166.8
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2278.7
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2597.9
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1936.2
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3947.8
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3249.2
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2763.0
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2852.6
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3200.7
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1597.9
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 344.3
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2831.8
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2222.4
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 993.6
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2775.6
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5655.1
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2014.6
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5910.6
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3304.9
   },
   {
    "Region Name": "Free State (Province of South Africa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 902.7
   }
  ],
  "Fribourg (Canton of Switzerland)": [
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fribourg (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Friuli-Venezia Giulia (Autonomous Region of Italy)": [
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Frysl\u00e2n (Province of Netherlands)": [
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Frysl\u00e2n (Province of Netherlands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Fujairah (Emirate of United Arab Emirates)": [
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujairah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Fujian (Province of China)": [
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 627.2
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 154.6
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 104.6
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 135.5
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 130.3
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 569.6
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 104.4
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 196.6
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Fujian (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 61.7
   }
  ],
  "Fujian (Province of Taiwan)": [
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fujian (Province of Taiwan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Fukui (Prefecture of Japan)": [
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukui (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.6
   }
  ],
  "Fukuoka (Prefecture of Japan)": [
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Fukuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Fukushima (Prefecture of Japan)": [
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Fukushima (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Funafuti (Town Council of Tuvalu)": [
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Funafuti (Town Council of Tuvalu)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "F\u00e8s - Boulemane (Region of Morocco)": [
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u00e8s - Boulemane (Region of Morocco)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "F\u0103le\u0219ti (District of Moldova)": [
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "F\u0103le\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gaborone (City of Botswana)": [
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaborone (City of Botswana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gabrovo (Province of Bulgaria)": [
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gabrovo (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gab\u00e8s (Governorate of Tunisia)": [
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gab\u00e8s (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gab\u00fa (Region of Guinea-Bissau)": [
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2763.2
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1866.7
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2985.5
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2549.7
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2954.6
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1831.6
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1590.2
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1623.4
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1683.7
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2840.2
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1295.9
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2483.0
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2288.0
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1384.4
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2301.0
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2164.9
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1901.7
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1439.1
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1748.8
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1575.0
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1218.9
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1584.2
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1803.9
   },
   {
    "Region Name": "Gab\u00fa (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1000.0
   }
  ],
  "Gafsa (Governorate of Tunisia)": [
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gafsa (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gaga'emauga (District of Samoa)": [
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaga'emauga (District of Samoa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gagaifomauga (District of Samoa)": [
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gagaifomauga (District of Samoa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gala\u021bi (County of Romania)": [
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 105.0
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 180.3
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gala\u021bi (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Galguduud (Region of Somalia)": [
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Galguduud (Region of Somalia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Galicia (Autonomous Community of Spain)": [
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 222.5
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 293.7
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 496.7
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1024.0
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 101.4
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 317.9
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 119.4
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 98.8
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 400.0
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 96.5
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 493.3
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Galicia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1257.1
   }
  ],
  "Galle (District of Sri Lanka)": [
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galle (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Galway (County of Ireland)": [
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Galway (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.1
   }
  ],
  "Gal\u00e1pagos (Province of Ecuador)": [
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gal\u00e1pagos (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gambela Peoples (State of Ethiopia)": [
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16727.6
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12395.5
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12913.8
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13369.3
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10992.8
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15690.3
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10235.9
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16739.4
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12171.2
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12123.4
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11354.7
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13676.7
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11460.4
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14655.3
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14518.8
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9781.2
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13981.4
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5434.9
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10901.1
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12372.1
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9400.7
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8280.4
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10137.3
   },
   {
    "Region Name": "Gambela Peoples (State of Ethiopia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7882.1
   }
  ],
  "Gampaha (District of Sri Lanka)": [
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gampaha (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gamprin (Commune of Liechtenstein)": [
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gamprin (Commune of Liechtenstein)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gangwon-do (Province of South Korea)": [
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gangwon-do (Province of South Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ganja-Qazakh (Region of Azerbaijan)": [
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 96.0
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 107.8
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 28.3
   }
  ],
  "Gansu (Province of China)": [
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 174.3
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 176.4
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 98.0
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 191.4
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Gansu (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Gao (Region of Mali)": [
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 338.3
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 590.6
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 148.3
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 271.6
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 445.9
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 190.8
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 317.1
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 140.0
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 802.8
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 585.4
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 164.4
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 92.4
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 234.3
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 288.3
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 498.6
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1669.7
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2942.2
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2696.5
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3336.4
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3787.3
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13201.9
   },
   {
    "Region Name": "Gao (Region of Mali)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10923.6
   }
  ],
  "Garff (Parish District of Isle of Man)": [
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Garff (Parish District of Isle of Man)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Garissa (County of Kenya)": [
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 366.6
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 107.8
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 108.5
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 612.7
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 185.4
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 165.9
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 158.2
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 189.3
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Garissa (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 45.0
   }
  ],
  "Gasa (District of Bhutan)": [
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gasa (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gash Barka (Region of Eritrea)": [
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 268.0
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 169.8
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 138.9
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 98.8
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 678.3
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 342.1
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 144.1
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 145.8
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 312.8
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 698.0
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 314.1
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 425.5
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 148.8
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 204.5
   },
   {
    "Region Name": "Gash Barka (Region of Eritrea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 407.5
   }
  ],
  "Gauteng (Province of South Africa)": [
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1390.0
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1291.6
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1001.3
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1874.0
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2149.3
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 979.2
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1461.6
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1006.2
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1585.3
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1763.0
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1175.2
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1148.2
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1241.8
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1316.0
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 411.2
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 952.0
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1162.1
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1328.0
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1130.6
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1093.7
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 809.7
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 789.5
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1505.9
   },
   {
    "Region Name": "Gauteng (Province of South Africa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 752.0
   }
  ],
  "Gaza (District of Palestine)": [
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gaza (District of Palestine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.4
   }
  ],
  "Gaza (Province of Mozambique)": [
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10743.3
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5892.8
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14838.0
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7087.5
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5414.7
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3383.6
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4721.0
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3212.1
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7484.3
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7197.7
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6500.1
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4226.9
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13469.7
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9579.9
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 456.4
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4313.5
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5800.2
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3947.6
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 837.1
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8091.6
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7445.5
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6902.5
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9843.6
   },
   {
    "Region Name": "Gaza (Province of Mozambique)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3391.3
   }
  ],
  "Gazi Baba (Municipality of North Macedonia)": [
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazi Baba (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gaziantep (Province of Turkey)": [
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 101.4
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Gaziantep (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.5
   }
  ],
  "Gazima\u011fusa (District of Northern Cyprus)": [
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Gazima\u011fusa (District of Northern Cyprus)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gbapolu (County of Liberia)": [
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 777.1
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 419.7
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 582.4
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 107.2
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 156.9
   },
   {
    "Region Name": "Gbapolu (County of Liberia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.8
   }
  ],
  "Gedo (Region of Somalia)": [
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 128.6
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 108.0
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 296.5
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Gedo (Region of Somalia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gegharkunik (Province of Armenia)": [
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 207.9
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Gegharkunik (Province of Armenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 55.1
   }
  ],
  "Geita (Region of Tanzania)": [
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1212.9
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2061.4
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2612.9
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3466.1
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2109.0
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2190.0
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1903.8
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1581.2
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 819.5
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1973.9
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1356.5
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 904.4
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1301.0
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1138.3
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1069.9
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2526.1
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 775.2
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1305.1
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 738.7
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 859.4
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1169.8
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 756.9
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 264.5
   },
   {
    "Region Name": "Geita (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 263.5
   }
  ],
  "Gelderland (Province of Netherlands)": [
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gelderland (Province of Netherlands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Gen\u00e8ve (Canton of Switzerland)": [
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gen\u00e8ve (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "George Town (District of Cayman Islands)": [
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "George Town (District of Cayman Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Georgia (State of United States)": [
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 609.7
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 303.5
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 796.6
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 364.2
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 698.4
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1916.0
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 529.9
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 330.3
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 502.7
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2033.7
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 772.2
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 538.3
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 577.5
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 558.4
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 482.5
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1201.5
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 404.5
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 554.6
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 522.4
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 675.5
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 598.9
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 427.7
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 347.5
   },
   {
    "Region Name": "Georgia (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 351.6
   }
  ],
  "Gevgelija (Municipality of North Macedonia)": [
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Gevgelija (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ghanzi (District of Botswana)": [
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 25744.2
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 741.7
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2638.2
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9686.7
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9513.9
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7872.9
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 49073.4
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2501.9
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 39460.0
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 53478.2
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10664.2
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11637.0
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7100.1
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2541.6
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 581.8
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13862.0
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1452.8
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3281.6
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12217.3
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26966.3
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 28117.9
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 39627.6
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7764.7
   },
   {
    "Region Name": "Ghanzi (District of Botswana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7243.5
   }
  ],
  "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)": [
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharb - Chrarda - B\u00e9ni Hssen (Region of Morocco)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Gharda\u00efa (Province of Algeria)": [
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gharda\u00efa (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.5
   }
  ],
  "Ghat (District of Libya)": [
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghat (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ghazni (Province of Afghanistan)": [
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghazni (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ghor (Province of Afghanistan)": [
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ghor (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gia Lai (Province of Vietnam)": [
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 676.5
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1042.9
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1350.5
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 660.0
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 744.1
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 356.1
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 982.2
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 368.5
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 805.2
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 698.4
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 506.3
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 466.7
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 451.9
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 484.9
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 332.5
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 342.8
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 573.2
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 393.4
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 334.2
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 302.0
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 296.9
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 297.8
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 413.3
   },
   {
    "Region Name": "Gia Lai (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 333.1
   }
  ],
  "Gifu (Prefecture of Japan)": [
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gifu (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.4
   }
  ],
  "Gilan (Province of Iran)": [
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gilan (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Gilgit-Baltistan (Centrally Administered Area of Pakistan)": [
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Giresun (Province of Turkey)": [
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Giresun (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Girne (District of Northern Cyprus)": [
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Girne (District of Northern Cyprus)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gisborne (Region of New Zealand)": [
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gisborne (Region of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gitega (Province of Burundi)": [
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Gitega (Province of Burundi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Giurgiu (County of Romania)": [
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 96.9
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 274.2
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 233.4
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 168.5
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 148.8
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 105.3
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 247.0
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 118.1
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 140.6
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Giurgiu (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Gjirokast\u00ebr (County of Albania)": [
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Gjirokast\u00ebr (County of Albania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.9
   }
  ],
  "Gjor\u010de Petrov (Municipality of North Macedonia)": [
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gjor\u010de Petrov (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.4
   }
  ],
  "Glacis (District of Seychelles)": [
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glacis (District of Seychelles)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Glarus (Canton of Switzerland)": [
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glarus (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Glodeni (District of Moldova)": [
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Glodeni (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gnjilane (District of Kosovo)": [
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Gnjilane (District of Kosovo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.4
   }
  ],
  "Goa (State of India)": [
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Goa (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Goi\u00e1s (State of Brazil)": [
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15102.5
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5657.4
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12278.0
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8580.5
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5971.2
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22642.1
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7376.0
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3846.9
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 25202.5
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9162.6
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13462.4
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3639.3
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13106.3
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10803.1
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9582.5
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13685.3
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4409.8
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14757.6
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8616.3
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11133.5
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6028.7
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3465.5
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7769.6
   },
   {
    "Region Name": "Goi\u00e1s (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8770.3
   }
  ],
  "Golan (District of Israel)": [
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Golan (District of Israel)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.1
   }
  ],
  "Golestan (Province of Iran)": [
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 182.9
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 461.8
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 413.1
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 196.4
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 249.1
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 164.6
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 275.7
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 552.0
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 148.3
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 222.1
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 160.3
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 152.0
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Golestan (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 60.5
   }
  ],
  "Gombe (State of Nigeria)": [
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1780.1
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1975.4
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2479.4
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1939.4
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2368.3
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1150.9
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1208.6
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 854.7
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 662.0
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 533.6
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 514.5
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 252.7
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 154.1
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 112.8
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 212.7
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 126.7
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 116.8
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Gombe (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 59.0
   }
  ],
  "Gomel (Region of Belarus)": [
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 631.7
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 227.7
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 134.6
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 340.2
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 118.1
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 272.5
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 328.6
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 174.9
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Gomel (Region of Belarus)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.2
   }
  ],
  "Gorenjska (Statistical Region of Slovenia)": [
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorenjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gorgol (Region of Mauritania)": [
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 137.0
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 231.3
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 303.3
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 244.0
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 86.0
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 635.2
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 300.5
   },
   {
    "Region Name": "Gorgol (Region of Mauritania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 131.8
   }
  ],
  "Gori\u0161ka (Statistical Region of Slovenia)": [
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gorj (County of Romania)": [
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Gorj (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Gorno-Altay (Republic of Russia)": [
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 93.0
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 85.7
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 153.5
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 162.1
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Gorno-Altay (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.9
   }
  ],
  "Gorno-Badakhshan (Autonomous Region of Tajikistan)": [
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gorontalo (Province of Indonesia)": [
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 229.6
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 97.3
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Gorontalo (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gostivar (Municipality of North Macedonia)": [
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gostivar (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gotland (County of Sweden)": [
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gotland (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Govi-Altay (Province of Mongolia)": [
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govi-Altay (Province of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Govis\u00fcmber (Municipality of Mongolia)": [
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Govis\u00fcmber (Municipality of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gracias a Dios (Department of Honduras)": [
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 278.7
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1908.1
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 707.4
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1794.5
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1251.5
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 388.9
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 749.4
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 976.7
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 867.6
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 775.2
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 648.7
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1021.0
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1848.7
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 335.5
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1003.9
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 261.3
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1171.3
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1083.8
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2372.6
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 647.8
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 460.9
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3148.4
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1978.8
   },
   {
    "Region Name": "Gracias a Dios (Department of Honduras)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 718.6
   }
  ],
  "Grad Beograd (City of Serbia)": [
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Grad Beograd (City of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Grad Sofiya (Province of Bulgaria)": [
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Sofiya (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Grad Zagreb (City of Croatia)": [
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grad Zagreb (City of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gradsko (Municipality of North Macedonia)": [
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gradsko (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Granada (Department of Nicaragua)": [
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Granada (Department of Nicaragua)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.2
   }
  ],
  "Grand Bassa (County of Liberia)": [
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 419.3
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 101.6
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 65.4
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Grand Bassa (County of Liberia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 22.7
   }
  ],
  "Grand Cape Mount (County of Liberia)": [
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 444.6
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 271.6
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Grand Cape Mount (County of Liberia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Grand Casablanca (Region of Morocco)": [
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Casablanca (Region of Morocco)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Grand Cay (District of Bahamas)": [
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Cay (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Grand Est (Region of France)": [
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 181.8
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 83.8
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Est (Region of France)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Grand Gedeh (County of Liberia)": [
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Grand Gedeh (County of Liberia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Grand Kru (County of Liberia)": [
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Grand Kru (County of Liberia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.5
   }
  ],
  "Grand Port (District of Mauritius)": [
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Grand Port (District of Mauritius)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Grand Turk (District of Turks and Caicos Islands)": [
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Grand' Anse (District of Seychelles)": [
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand' Anse (District of Seychelles)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Grand'Anse (Department of Haiti)": [
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse (Department of Haiti)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Grand'Anse Praslin (District of Seychelles)": [
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grand'Anse Praslin (District of Seychelles)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Granma (Province of Cuba)": [
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 182.2
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 305.5
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 385.0
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 219.9
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 360.4
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 221.9
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 190.4
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 286.0
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 206.9
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 171.7
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 193.6
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 138.3
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 154.8
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 212.4
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 144.5
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 140.2
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 131.2
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 227.0
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 164.8
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 213.9
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 98.0
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 242.9
   },
   {
    "Region Name": "Granma (Province of Cuba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 136.3
   }
  ],
  "Graub\u00fcnden (Canton of Switzerland)": [
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Graub\u00fcnden (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Greater Accra (Region of Ghana)": [
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 143.6
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 259.2
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 215.7
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 80.2
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 291.5
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 316.6
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 262.4
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 207.5
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 112.3
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 234.5
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 177.1
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 256.8
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 97.5
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Greater Accra (Region of Ghana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.4
   }
  ],
  "Grenadines (Parish of Saint Vincent and the Grenadines)": [
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Grevenmacher (District of Luxembourg)": [
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grevenmacher (District of Luxembourg)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Grodno (Region of Belarus)": [
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Grodno (Region of Belarus)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Groningen (Province of Netherlands)": [
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Groningen (Province of Netherlands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gros Islet (Quarter of Saint Lucia)": [
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gros Islet (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Guadalcanal (Province of Solomon Islands)": [
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guadalcanal (Province of Solomon Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Guain\u00eda (Commissiary of Colombia)": [
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 102.0
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guain\u00eda (Commissiary of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Guair\u00e1 (Department of Paraguay)": [
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 343.6
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 308.0
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 330.6
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 101.4
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 236.2
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 135.9
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 104.6
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 248.7
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 78.0
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 197.9
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 189.7
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 191.9
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 263.0
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 176.6
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 266.7
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 312.3
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 143.6
   },
   {
    "Region Name": "Guair\u00e1 (Department of Paraguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 56.0
   }
  ],
  "Guanacaste (Province of Costa Rica)": [
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 274.8
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 268.2
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 264.5
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 159.5
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 144.1
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 256.8
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 167.0
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 206.4
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 234.7
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 166.4
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 329.1
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 481.0
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 430.2
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 410.9
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 313.4
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 313.8
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 404.3
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 372.8
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 292.0
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 440.3
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 254.2
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 243.7
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 269.0
   },
   {
    "Region Name": "Guanacaste (Province of Costa Rica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 230.7
   }
  ],
  "Guanajuato (State of M\u00e9xico)": [
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 522.0
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 504.6
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 675.9
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 655.3
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 367.4
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 333.1
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 491.8
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 259.4
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 271.6
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 159.9
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 195.9
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 195.7
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 249.3
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Guanajuato (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 212.9
   }
  ],
  "Guangdong (Province of China)": [
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 899.7
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2293.3
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1397.9
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 873.3
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 856.6
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1095.4
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2077.7
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 276.5
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 628.1
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 403.7
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 736.4
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 241.0
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 322.2
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 168.5
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 94.8
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 187.6
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Guangdong (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 83.4
   }
  ],
  "Guangxi (Autonomous Region of China)": [
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 627.7
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1112.4
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 822.3
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 671.0
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 554.1
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1624.3
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 594.9
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1130.4
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 452.1
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 173.0
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 257.0
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 210.1
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 181.4
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 259.8
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 132.3
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 250.4
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 209.0
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 726.9
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 193.4
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 355.6
   },
   {
    "Region Name": "Guangxi (Autonomous Region of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 122.2
   }
  ],
  "Guant\u00e1namo (Province of Cuba)": [
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Guant\u00e1namo (Province of Cuba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.4
   }
  ],
  "Guarda (District of Portugal)": [
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 89.2
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 480.6
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 76.5
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 261.5
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 185.4
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 252.5
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 109.5
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 114.0
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 96.7
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 754.2
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 306.5
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guarda (District of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 851.5
   }
  ],
  "Guatemala (Department of Guatemala)": [
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Guatemala (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.6
   }
  ],
  "Guaviare (Commissiary of Colombia)": [
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 124.1
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 590.4
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 864.1
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 312.6
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 241.0
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 208.6
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 186.7
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 231.1
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 402.6
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 307.2
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 258.5
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 975.6
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 239.5
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 233.2
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 168.7
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 771.3
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 119.6
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 93.7
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Guaviare (Commissiary of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 35.4
   }
  ],
  "Guayama (Municipality of Puerto Rico)": [
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayama (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Guayanilla (Municipality of Puerto Rico)": [
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guayanilla (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Guayas (Province of Ecuador)": [
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 110.4
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 88.3
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 124.8
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 244.2
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 173.0
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 96.9
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 193.6
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 166.6
   },
   {
    "Region Name": "Guayas (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.8
   }
  ],
  "Guaynabo (Municipality of Puerto Rico)": [
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guaynabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Guelma (Province of Algeria)": [
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 92.4
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 75.5
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Guelma (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.2
   }
  ],
  "Guelmim - Es-Semara (Region of Morocco)": [
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Guerrero (State of M\u00e9xico)": [
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1527.2
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2688.8
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1284.9
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3668.1
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1435.2
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2649.6
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2220.9
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2086.5
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2040.6
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1761.5
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2155.3
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2660.7
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 412.7
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1160.6
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1098.2
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2688.4
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1897.8
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3416.6
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3763.7
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2179.7
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2116.7
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1785.5
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3259.1
   },
   {
    "Region Name": "Guerrero (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 739.6
   }
  ],
  "Guidimaka (Region of Mauritania)": [
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 112.8
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 177.7
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 380.9
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 162.5
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 195.7
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 248.9
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 170.0
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 146.8
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 141.5
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 210.1
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 627.2
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 816.3
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 796.2
   },
   {
    "Region Name": "Guidimaka (Region of Mauritania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 507.6
   }
  ],
  "Guimaras (Province of Philippines)": [
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guimaras (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Guizhou (Province of China)": [
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 543.4
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 141.3
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 237.5
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 187.6
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 198.7
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 598.7
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2789.4
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 912.4
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 112.1
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 288.5
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 283.2
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 421.4
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 119.4
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 955.2
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 594.2
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "Guizhou (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 55.7
   }
  ],
  "Gujarat (State of India)": [
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 157.1
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 196.4
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 489.4
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 199.1
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 241.4
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 195.9
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 531.2
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 335.3
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 240.3
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 458.3
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 295.4
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 447.6
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 481.5
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 450.4
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 534.9
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 835.2
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 329.7
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 287.5
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 450.8
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 683.4
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 286.6
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 212.0
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 245.9
   },
   {
    "Region Name": "Gujarat (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 629.2
   }
  ],
  "Gulf (Province of Papua New Guinea)": [
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Gulf (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.1
   }
  ],
  "Gulu (District of Uganda)": [
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5253.5
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5026.1
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5540.8
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7211.6
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4701.3
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5129.6
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4277.1
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3706.4
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3444.3
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3854.6
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2733.2
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2763.4
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3166.7
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3979.8
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4616.9
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2597.7
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2831.2
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1383.8
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2303.2
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2245.1
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2419.4
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1658.1
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1648.1
   },
   {
    "Region Name": "Gulu (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1570.0
   }
  ],
  "Gunma (Prefecture of Japan)": [
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gunma (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gurabo (Municipality of Puerto Rico)": [
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gurabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Guria (Region of Georgia)": [
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Guria (Region of Georgia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gu\u00e1nica (Municipality of Puerto Rico)": [
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gu\u00e1nica (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gu\u00e1rico (State of Venezuela)": [
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5777.9
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5015.2
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6015.0
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6570.2
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7079.8
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5181.3
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5522.4
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7708.9
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3205.7
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3562.4
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4934.1
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5722.6
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5692.8
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6422.9
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4202.1
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6733.3
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7340.6
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8430.9
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6977.1
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6002.3
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5391.0
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9557.4
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8232.2
   },
   {
    "Region Name": "Gu\u00e1rico (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6227.2
   }
  ],
  "Gu\u00e9ra (Region of Chad)": [
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16774.4
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17839.8
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17970.1
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18911.6
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14819.8
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16182.7
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16587.9
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14406.7
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13943.0
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13902.9
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14012.0
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13277.8
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12403.8
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12439.8
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14145.1
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13447.8
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14413.1
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12188.8
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12148.3
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10570.5
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12410.3
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12448.2
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10731.3
   },
   {
    "Region Name": "Gu\u00e9ra (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10061.2
   }
  ],
  "Gwangju (Metropolitan City of South Korea)": [
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gwangju (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gyeonggi-do (Province of South Korea)": [
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeonggi-do (Province of South Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Gyeongsangbuk-do (Province of South Korea)": [
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 138.3
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 963.2
   }
  ],
  "Gyeongsangnam-do (Province of South Korea)": [
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Gyeongsangnam-do (Province of South Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.9
   }
  ],
  "Gyor-Moson-Sopron (County of Hungary)": [
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "G\u00e4vleborg (County of Sweden)": [
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00e4vleborg (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)": [
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 80.2
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 107.6
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 275.7
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 459.6
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "G\u00f4h-Djiboua (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.1
   }
  ],
  "G\u00fcm\u00fc\u015fhane (Province of Turkey)": [
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "G\u00fcm\u00fc\u015fhane (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "G\u00fczelyurt (District of Northern Cyprus)": [
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u00fczelyurt (District of Northern Cyprus)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "G\u0103g\u0103uzia (Autonomous Territory of Moldova)": [
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 189.3
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "G\u0127awdex (Region of Malta)": [
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "G\u0127awdex (Region of Malta)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ha'apai (Island Group of Tonga)": [
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ha'apai (Island Group of Tonga)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "HaDarom (District of Israel)": [
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaDarom (District of Israel)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "HaMerkaz (District of Israel)": [
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaMerkaz (District of Israel)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "HaZafon (District of Israel)": [
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "HaZafon (District of Israel)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Haa (District of Bhutan)": [
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Haa (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hadjer-Lamis (Region of Chad)": [
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 562.7
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 967.9
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1534.7
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1672.1
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1208.0
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 742.6
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 792.5
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 384.6
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 435.2
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 461.5
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 535.5
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 488.5
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 234.1
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 170.0
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 298.8
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 500.8
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 357.4
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 206.0
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 514.7
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 239.0
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 580.5
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 283.4
   },
   {
    "Region Name": "Hadjer-Lamis (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1008.8
   }
  ],
  "Hadramawt (Governorate of Yemen)": [
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hadramawt (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Haifa (District of Israel)": [
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haifa (District of Israel)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hainan (Province of China)": [
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 221.2
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Hainan (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24.0
   }
  ],
  "Hajd\u00fa-Bihar (County of Hungary)": [
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hajd\u00fa-Bihar (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Hajjah (Governorate of Yemen)": [
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hajjah (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.9
   }
  ],
  "Hakkari (Province of Turkey)": [
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 187.8
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 149.0
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 150.3
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hakkari (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 29.6
   }
  ],
  "Halland (County of Sweden)": [
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Halland (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hamadan (Province of Iran)": [
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 114.5
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Hamadan (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.2
   }
  ],
  "Hamah (Governorate of Syria)": [
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 98.0
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 95.4
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 112.1
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 614.2
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 272.7
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 209.9
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 202.4
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 299.9
   },
   {
    "Region Name": "Hamah (Governorate of Syria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 72.0
   }
  ],
  "Hambantota (District of Sri Lanka)": [
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hambantota (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hamburg (State of Germany)": [
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamburg (State of Germany)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hamgy\u014fng-bukto (Province of North Korea)": [
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 335.5
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 170.2
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 150.3
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "Hamgy\u014fng-bukto (Province of North Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.1
   }
  ],
  "Hamgy\u014fng-namdo (Province of North Korea)": [
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 136.8
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 91.7
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 106.8
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 135.5
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 105.0
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Hamgy\u014fng-namdo (Province of North Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hanover (Parish of Jamaica)": [
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hanover (Parish of Jamaica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Harare (City of Zimbabwe)": [
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harare (City of Zimbabwe)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Harari People (State of Ethiopia)": [
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harari People (State of Ethiopia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Harbour Island (District of Bahamas)": [
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harbour Island (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hardap (Region of Namibia)": [
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 215.7
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 330.6
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 237.3
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 850.6
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 726.7
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 457.7
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 950.5
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Hardap (Region of Namibia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 25.9
   }
  ],
  "Harghita (County of Romania)": [
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Harghita (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Harju (County of Estonia)": [
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Harju (County of Estonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Haryana (State of India)": [
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2803.9
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3658.2
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3851.1
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5490.4
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2428.8
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2737.9
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3035.5
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4263.6
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3483.7
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3625.0
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3918.2
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5885.5
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3420.5
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3571.6
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5293.6
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5272.6
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4832.1
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3458.8
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2216.1
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4130.2
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3443.2
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1402.2
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1898.2
   },
   {
    "Region Name": "Haryana (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1884.9
   }
  ],
  "Haskovo (Province of Bulgaria)": [
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 197.6
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Haskovo (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 68.6
   }
  ],
  "Hatay (Province of Turkey)": [
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 185.2
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 149.0
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 92.6
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Hatay (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 49.9
   }
  ],
  "Hatillo (Municipality of Puerto Rico)": [
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hato Mayor (Province of Dominican Republic)": [
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Hato Mayor (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hatohobei (State of Palau)": [
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hatohobei (State of Palau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Haut-Bassins (Region of Burkina Faso)": [
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3643.8
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2831.8
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3097.8
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2515.8
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2589.8
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1919.0
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1832.9
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2250.7
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1559.3
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1882.6
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1054.3
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1349.5
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1002.0
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1045.3
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1642.3
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 978.0
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 766.8
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 640.7
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 792.7
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 519.0
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 393.4
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1902.5
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1360.8
   },
   {
    "Region Name": "Haut-Bassins (Region of Burkina Faso)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 890.9
   }
  ],
  "Haut-Katanga (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 37485.2
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 45944.6
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 46711.2
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 44117.1
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 47326.9
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 42558.7
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 45852.7
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 42368.7
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 45945.7
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 45931.3
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 47084.4
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 44058.8
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 41570.7
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 45680.3
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 43772.0
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 42239.7
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 39725.1
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 41317.5
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 40471.4
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 42030.3
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 41747.3
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 37950.4
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 39299.6
   },
   {
    "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 44840.4
   }
  ],
  "Haut-Lomami (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 47246.9
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 51331.1
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 51580.0
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 54154.5
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 53478.6
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 44549.7
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 49971.3
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 53047.1
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 49218.3
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 47944.7
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 45340.3
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 49384.4
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 44760.5
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 47351.8
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 48049.1
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 50024.5
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 44647.7
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 49602.6
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 45764.1
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 46383.7
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 46041.7
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 45673.7
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 47224.4
   },
   {
    "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 45964.6
   }
  ],
  "Haut-Mbomou (Prefecture of Central African Republic)": [
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 27154.3
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 22869.3
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 27012.2
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 26662.4
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 27374.9
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25044.9
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23682.2
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 22674.2
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22669.3
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 23246.2
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21150.3
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21523.1
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19051.8
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20624.0
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 20488.7
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18281.2
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17576.1
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18483.8
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17249.4
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12382.0
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17585.3
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16739.9
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18567.1
   },
   {
    "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18081.4
   }
  ],
  "Haut-Ogoou\u00e9 (Province of Gabon)": [
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2752.9
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3342.0
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4601.0
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3004.0
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4060.1
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4156.2
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3948.5
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3797.1
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4029.5
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4537.8
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4662.7
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4529.8
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3803.5
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3695.9
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4199.5
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5151.1
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3392.2
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4322.8
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3937.5
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3753.2
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4610.6
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4075.2
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4505.8
   },
   {
    "Region Name": "Haut-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4669.2
   }
  ],
  "Haut-Uele (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8009.9
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11881.0
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9462.2
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11289.5
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10990.1
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11499.4
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8310.0
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8322.2
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11836.4
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11249.0
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8015.3
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9887.8
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9873.2
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12549.4
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10388.8
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10392.2
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7826.8
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9259.7
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9994.5
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6628.7
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7835.2
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9800.1
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7269.0
   },
   {
    "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6982.0
   }
  ],
  "Haute-Kotto (Prefecture of Central African Republic)": [
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 42950.1
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 43354.4
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 47454.7
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 45876.7
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 47085.3
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 44389.4
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 40290.4
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 37636.3
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 40639.2
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 43383.4
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 29244.4
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 25729.6
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 29040.8
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 32372.7
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 31880.1
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 33851.4
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 34384.1
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 32239.6
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 33162.2
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 31774.8
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 33999.1
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 26175.1
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 29107.7
   },
   {
    "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24518.7
   }
  ],
  "Hauts-de-France (Region of France)": [
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hauts-de-France (Region of France)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Hawaii (State of United States)": [
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 173.4
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawaii (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.1
   }
  ],
  "Hawalli (Province of Kuwait)": [
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawalli (Province of Kuwait)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hawke's Bay (Region of New Zealand)": [
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hawke's Bay (Region of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hebei (Province of China)": [
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1060.9
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 958.7
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 324.1
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 844.2
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1475.9
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2035.4
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 422.7
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 186.5
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 400.9
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 790.2
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 762.7
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 603.7
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 547.9
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 330.1
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1837.6
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 348.3
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 279.1
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 129.1
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 256.6
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 267.1
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 606.2
   },
   {
    "Region Name": "Hebei (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 279.8
   }
  ],
  "Hedmark (County of Norway)": [
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hedmark (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Heilongjiang (Province of China)": [
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2943.9
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9858.8
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3595.8
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2549.1
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1831.4
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4092.5
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3803.1
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4625.2
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2248.7
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5501.6
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1398.3
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3837.4
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 22558.7
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20967.2
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7409.5
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 26890.7
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16308.8
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5046.7
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7713.2
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11398.2
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13887.0
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9633.7
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22583.1
   },
   {
    "Region Name": "Heilongjiang (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16134.9
   }
  ],
  "Hela (Province of Papua New Guinea)": [
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Hela (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Henan (Province of China)": [
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2894.6
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1454.5
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1635.6
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4827.4
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8546.5
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9432.7
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5577.7
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5484.4
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7412.2
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8099.5
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9788.5
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8180.3
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7723.9
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6326.2
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 219.7
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 458.1
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 162.3
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 277.6
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 273.7
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 368.7
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1808.6
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1159.3
   },
   {
    "Region Name": "Henan (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 392.1
   }
  ],
  "Hentiy (Province of Mongolia)": [
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 875.3
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 582.7
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 133.6
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4845.8
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3802.5
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5370.4
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 358.9
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 546.9
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 276.5
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 326.9
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 264.7
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1807.8
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 218.0
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 501.0
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Hentiy (Province of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 176.0
   }
  ],
  "Herceg Novi (Municipality of Montenegro)": [
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Herceg Novi (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Heredia (Province of Costa Rica)": [
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heredia (Province of Costa Rica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Herrera (Province of Panama)": [
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Herrera (Province of Panama)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.4
   }
  ],
  "Hessen (State of Germany)": [
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hessen (State of Germany)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Heves (County of Hungary)": [
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Heves (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hhohho (District of Swaziland)": [
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 165.1
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 253.0
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 172.8
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 188.9
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 577.9
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 293.5
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 176.0
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 248.0
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 195.7
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 247.2
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 192.7
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 264.3
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 135.5
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 89.2
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 266.5
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 102.9
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 154.3
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 412.7
   },
   {
    "Region Name": "Hhohho (District of Swaziland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 106.5
   }
  ],
  "Hidalgo (State of M\u00e9xico)": [
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Hidalgo (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.5
   }
  ],
  "Hiiraan (Region of Somalia)": [
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 277.2
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 317.1
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Hiiraan (Region of Somalia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hiiu (County of Estonia)": [
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiiu (County of Estonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hilmand (Province of Afghanistan)": [
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hilmand (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Himachal Pradesh (Union Territory of India)": [
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 108.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 273.5
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 250.6
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 153.7
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 127.8
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 489.4
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Himachal Pradesh (Union Territory of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hims (Governorate of Syria)": [
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 103.3
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 220.8
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 670.1
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 244.8
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "Hims (Governorate of Syria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hirat (Province of Afghanistan)": [
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 329.3
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hirat (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hiroshima (Prefecture of Japan)": [
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hiroshima (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hodh ech Chargui (Region of Mauritania)": [
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 278.9
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1410.5
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2393.2
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2979.3
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3966.9
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2583.6
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2641.5
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5636.8
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1258.3
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3276.6
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2211.9
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 212.9
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 275.9
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 517.7
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 162.9
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 261.1
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1636.5
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2447.5
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1198.1
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1102.9
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 366.8
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 504.8
   },
   {
    "Region Name": "Hodh ech Chargui (Region of Mauritania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1432.0
   }
  ],
  "Hodh el Gharbi (Region of Mauritania)": [
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 95.4
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 170.4
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 755.9
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 523.9
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 382.4
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2169.6
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 424.5
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 567.2
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 484.3
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 435.4
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 371.5
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 81.9
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 318.3
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 187.4
   },
   {
    "Region Name": "Hodh el Gharbi (Region of Mauritania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 286.4
   }
  ],
  "Hoima (District of Uganda)": [
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 167.0
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 130.8
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 194.4
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 217.8
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 126.0
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 195.7
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 119.8
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 129.9
   },
   {
    "Region Name": "Hoima (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 49.1
   }
  ],
  "Hokkaido (Circuit of Japan)": [
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hokkaido (Circuit of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Holgu\u00edn (Province of Cuba)": [
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 162.3
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 78.2
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 290.5
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 154.8
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 178.4
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 107.2
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 116.8
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 120.9
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 163.1
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 153.5
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 300.1
   },
   {
    "Region Name": "Holgu\u00edn (Province of Cuba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 177.5
   }
  ],
  "Homa Bay (County of Kenya)": [
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Homa Bay (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.2
   }
  ],
  "Hong Kong (Special Administrative Region of China)": [
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Hong Kong (Special Administrative Region of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Honiara (Capital Territory of Solomon Islands)": [
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Honiara (Capital Territory of Solomon Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hope Town (District of Bahamas)": [
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hope Town (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Hordaland (County of Norway)": [
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hordaland (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hormigueros (Municipality of Puerto Rico)": [
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormigueros (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hormozgan (Province of Iran)": [
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Hormozgan (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Houaphan (Province of Laos)": [
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 78.2
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 454.9
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 659.6
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1055.6
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 351.6
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 625.7
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 199.8
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 715.1
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 302.5
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 163.6
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 197.2
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 640.3
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 339.6
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 119.8
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 143.4
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 587.8
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 457.2
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 117.0
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1089.0
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 394.9
   },
   {
    "Region Name": "Houaphan (Province of Laos)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 50.6
   }
  ],
  "Hovd (Province of Mongolia)": [
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 110.4
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 105.5
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovd (Province of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Hovedstaden (Region of Denmark)": [
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hovedstaden (Region of Denmark)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Howland (Island of United States Minor Outlying Isl)": [
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Howland (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Huambo (Province of Angola)": [
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4741.8
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5826.3
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6005.3
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5966.3
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7294.5
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6076.5
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6924.5
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6888.1
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7876.1
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6568.5
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4823.7
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5291.7
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5356.2
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5589.5
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5825.9
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5839.6
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5892.8
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7210.3
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7595.3
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4136.0
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5483.3
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5437.7
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7223.6
   },
   {
    "Region Name": "Huambo (Province of Angola)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6746.6
   }
  ],
  "Huancavelica (Region of Peru)": [
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Huancavelica (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.2
   }
  ],
  "Hubei (Province of China)": [
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 281.7
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 306.8
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 733.4
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 529.3
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 747.3
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1305.9
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 877.8
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 280.6
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 335.7
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 736.4
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1300.6
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 359.1
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 349.4
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 160.1
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 235.4
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 280.6
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 170.9
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 245.7
   },
   {
    "Region Name": "Hubei (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 669.9
   }
  ],
  "Huehuetenango (Department of Guatemala)": [
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Huehuetenango (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.4
   }
  ],
  "Huila (Department of Colombia)": [
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 109.8
   },
   {
    "Region Name": "Huila (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.9
   }
  ],
  "Humacao (Municipality of Puerto Rico)": [
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Humacao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hunan (Province of China)": [
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 128.4
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 841.6
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 155.2
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 299.5
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 295.6
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1525.0
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1386.1
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 424.2
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 215.4
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 124.5
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 695.4
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 117.0
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 169.1
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 146.2
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 96.5
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 489.0
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 284.0
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "Hunan (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 155.4
   }
  ],
  "Hunedoara (County of Romania)": [
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Hunedoara (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Hu\u00e1nuco (Region of Peru)": [
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 230.4
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 74.4
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 168.5
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 154.6
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 111.9
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 94.8
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 93.0
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 197.6
   },
   {
    "Region Name": "Hu\u00e1nuco (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.7
   }
  ],
  "Hu\u00edla (Province of Angola)": [
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10586.2
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16003.1
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17626.7
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14807.3
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11306.7
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16920.6
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11552.1
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13095.8
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10608.7
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12167.8
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10706.4
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11924.7
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12614.5
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13690.0
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13865.6
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15663.9
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13318.1
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16344.4
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15045.7
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9144.8
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11450.1
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12881.9
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19703.3
   },
   {
    "Region Name": "Hu\u00edla (Province of Angola)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13386.1
   }
  ],
  "Hwanghae-bukto (Province of North Korea)": [
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Hwanghae-bukto (Province of North Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Hwanghae-namdo (Province of North Korea)": [
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hwanghae-namdo (Province of North Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Hy\u014dgo (Prefecture of Japan)": [
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Hy\u014dgo (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "H\u00e0 Giang (Province of Vietnam)": [
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "H\u00e0 Giang (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.9
   }
  ],
  "H\u00e0 Nam (Province of Vietnam)": [
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 Nam (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "H\u00e0 N\u1ed9i (City of Vietnam)": [
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 N\u1ed9i (City of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "H\u00e0 T\u0129nh (Province of Vietnam)": [
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "H\u00e0 T\u0129nh (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "H\u00eence\u0219ti (District of Moldova)": [
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00eence\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.9
   }
  ],
  "H\u00f2a B\u00ecnh (Province of Vietnam)": [
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "H\u00f2a B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.8
   }
  ],
  "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)": [
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6fu\u00f0borgarsv\u00e6\u00f0i\u00f0 (Region of Iceland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "H\u00f6vsg\u00f6l (Province of Mongolia)": [
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 913.9
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 237.7
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2693.3
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "H\u00f6vsg\u00f6l (Province of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "H\u01b0ng Y\u00ean (Province of Vietnam)": [
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u01b0ng Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)": [
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i D\u01b0\u01a1ng (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "H\u1ea3i Ph\u00f2ng (City of Vietnam)": [
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ea3i Ph\u00f2ng (City of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "H\u1eadu Giang (Province of Vietnam)": [
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 151.6
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 139.3
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 275.2
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 104.6
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 113.6
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 178.8
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 113.0
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 94.3
   },
   {
    "Region Name": "H\u1eadu Giang (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 94.8
   }
  ],
  "H\u1ed3 Ch\u00ed Minh (City of Vietnam)": [
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "H\u1ed3 Ch\u00ed Minh (City of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "IJsselmeer (Water body of Netherlands)": [
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "IJsselmeer (Water body of Netherlands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ialomi\u021ba (County of Romania)": [
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 106.1
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 254.2
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 184.6
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 566.4
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 122.0
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 168.5
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 167.2
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ialomi\u021ba (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.9
   }
  ],
  "Ialoveni (District of Moldova)": [
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ialoveni (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ia\u0219i (County of Romania)": [
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ia\u0219i (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ibaraki (Prefecture of Japan)": [
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibaraki (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ibb (Governorate of Yemen)": [
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ibb (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Iburasirazuba (Province of Rwanda)": [
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 570.4
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 312.1
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 259.0
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 203.0
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 98.0
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 156.7
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 339.6
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 351.1
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 240.1
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 358.2
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 464.3
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 568.7
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 444.0
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 329.7
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 316.2
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 417.2
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 354.6
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 341.5
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 309.8
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 490.5
   },
   {
    "Region Name": "Iburasirazuba (Province of Rwanda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 275.7
   }
  ],
  "Iburengerazuba (Province of Rwanda)": [
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "Iburengerazuba (Province of Rwanda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Ica (Region of Peru)": [
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ica (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.3
   }
  ],
  "Ida-Viru (County of Estonia)": [
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ida-Viru (County of Estonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Idaho (State of United States)": [
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 619.1
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1424.9
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 483.4
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2523.1
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3158.5
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7090.0
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 810.7
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 480.0
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2326.8
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1447.6
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5718.9
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2490.5
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 614.8
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2358.9
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1678.5
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2169.6
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2151.2
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1020.0
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1256.6
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1692.7
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1717.1
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 619.1
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3540.5
   },
   {
    "Region Name": "Idaho (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 719.4
   }
  ],
  "Idlib (Governorate of Syria)": [
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 122.0
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 400.2
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 275.5
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 93.0
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "Idlib (Governorate of Syria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ifugao (Province of Philippines)": [
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Ifugao (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.8
   }
  ],
  "Iganga (District of Uganda)": [
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Iganga (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ilam (Province of Iran)": [
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 124.1
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 219.1
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 374.7
   },
   {
    "Region Name": "Ilam (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 86.8
   }
  ],
  "Ilfov (County of Romania)": [
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ilfov (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ilinden (Municipality of North Macedonia)": [
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilinden (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Illinois (State of United States)": [
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 174.7
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 138.5
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 126.9
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 122.8
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Illinois (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 40.3
   }
  ],
  "Illizi (Province of Algeria)": [
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Illizi (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ilocos Norte (Province of Philippines)": [
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Ilocos Norte (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 28.3
   }
  ],
  "Ilocos Sur (Province of Philippines)": [
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ilocos Sur (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Iloilo (Province of Philippines)": [
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Iloilo (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Imbabura (Province of Ecuador)": [
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Imbabura (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 17.6
   }
  ],
  "Imereti (Region of Georgia)": [
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Imereti (Region of Georgia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Imo (State of Nigeria)": [
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 151.6
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 259.6
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 94.3
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Imo (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Inagua (District of Bahamas)": [
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inagua (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Inarajan (Municipality of Guam)": [
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inarajan (Municipality of Guam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Incheon (Metropolitan City of South Korea)": [
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Incheon (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Inchiri (Region of Mauritania)": [
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Inchiri (Region of Mauritania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Independencia (Province of Dominican Republic)": [
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Independencia (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.9
   }
  ],
  "Indiana (State of United States)": [
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Indiana (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 23.6
   }
  ],
  "Ingush (Republic of Russia)": [
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 104.2
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 157.3
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 174.7
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Ingush (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 40.3
   }
  ],
  "Inhambane (Province of Mozambique)": [
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2798.8
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2367.7
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4523.2
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3304.1
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4096.2
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3408.5
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4090.2
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2588.1
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4034.4
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3306.9
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3013.2
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2673.8
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5569.5
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3239.5
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 875.1
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1845.7
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6613.3
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4911.4
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1462.9
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4480.7
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3569.9
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2728.9
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4458.2
   },
   {
    "Region Name": "Inhambane (Province of Mozambique)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4394.1
   }
  ],
  "Intibuc\u00e1 (Department of Honduras)": [
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Intibuc\u00e1 (Department of Honduras)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Iowa (State of United States)": [
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 189.5
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 90.0
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 299.3
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 201.5
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Iowa (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 75.0
   }
  ],
  "Irbid (Province of Jordan)": [
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Irbid (Province of Jordan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Iringa (Region of Tanzania)": [
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4556.6
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4778.9
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3065.3
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4641.5
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1363.4
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5090.4
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4021.3
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4427.6
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5159.0
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3950.6
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3862.9
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4022.0
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3644.3
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3630.3
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4212.4
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1923.1
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3738.8
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3381.9
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3747.6
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4136.0
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1514.7
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2519.1
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3524.2
   },
   {
    "Region Name": "Iringa (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3107.3
   }
  ],
  "Irkutsk (Region of Russia)": [
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1749.5
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11702.8
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1404.3
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1348.2
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7373.7
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2407.4
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5632.1
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 951.4
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1014.8
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5873.7
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1055.3
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1349.7
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10885.0
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5004.9
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11940.6
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7293.0
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1973.9
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10237.8
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2184.2
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3506.4
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1845.7
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 385.2
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2313.0
   },
   {
    "Region Name": "Irkutsk (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 430.2
   }
  ],
  "Isabel (Province of Solomon Islands)": [
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabel (Province of Solomon Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Isabela (Municipality of Puerto Rico)": [
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isabela (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Isabela (Province of Philippines)": [
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 120.9
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Isabela (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.4
   }
  ],
  "Ishikawa (Prefecture of Japan)": [
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ishikawa (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Isiolo (County of Kenya)": [
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 446.5
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 206.9
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 182.4
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 130.1
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 227.7
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 138.7
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 461.8
   },
   {
    "Region Name": "Isiolo (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 114.3
   }
  ],
  "Iskele (District of Northern Cyprus)": [
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Iskele (District of Northern Cyprus)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Isla de la Juventud (Province of Cuba)": [
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 173.9
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 110.6
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 96.7
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 107.4
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 172.1
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 99.5
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Isla de la Juventud (Province of Cuba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 75.9
   }
  ],
  "Islamabad (Capital Territory of Pakistan)": [
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islamabad (Capital Territory of Pakistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Islas Baleares (Autonomous Community of Spain)": [
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Islas Baleares (Autonomous Community of Spain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Islas Canarias (Autonomous Community of Spain)": [
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 240.5
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 120.3
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas Canarias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Islas de la Bah\u00eda (Department of Honduras)": [
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Islas de la Bah\u00eda (Department of Honduras)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Isparta (Province of Turkey)": [
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Isparta (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Istanbul (Province of Turkey)": [
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Istanbul (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Istarska (County of Croatia)": [
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Istarska (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Itap\u00faa (Department of Paraguay)": [
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 156.3
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 699.3
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 946.0
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 967.0
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 338.1
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 771.1
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 487.3
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 333.6
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 264.7
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 615.9
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 462.8
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 560.4
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 185.0
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 286.8
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 538.9
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 559.7
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 557.4
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 755.0
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1240.8
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 955.2
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 483.6
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 328.8
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 493.3
   },
   {
    "Region Name": "Itap\u00faa (Department of Paraguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 252.1
   }
  ],
  "Ituri (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1678.1
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2704.9
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2261.6
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1565.8
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2069.7
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1156.9
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1039.9
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 621.9
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1386.5
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2137.0
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 393.8
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1291.1
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 823.2
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1542.2
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1229.2
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1133.8
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 743.4
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 790.6
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1252.3
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1032.4
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 995.7
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1109.1
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 954.2
   },
   {
    "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 486.6
   }
  ],
  "Ivano-Frankivs'k (Region of Ukraine)": [
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 116.0
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 123.3
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 166.1
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 151.6
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 128.2
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 116.8
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 115.1
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24.7
   }
  ],
  "Ivanovo (Region of Russia)": [
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 117.5
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 210.9
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 416.7
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 508.5
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 124.8
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Ivanovo (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.4
   }
  ],
  "Iwate (Prefecture of Japan)": [
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Iwate (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Izabal (Department of Guatemala)": [
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 225.3
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 97.5
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 346.0
   },
   {
    "Region Name": "Izabal (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Izmir (Province of Turkey)": [
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 86.6
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Izmir (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 240.7
   }
  ],
  "I\u011fd\u0131r (Province of Turkey)": [
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "I\u011fd\u0131r (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 45.9
   }
  ],
  "Jabat (Island of Marshall Islands)": [
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jabat (Island of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jablani\u010dki (District of Serbia)": [
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Jablani\u010dki (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Jaffna (District of Sri Lanka)": [
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaffna (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jakarta Raya (Province of Indonesia)": [
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jakarta Raya (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jalal-Abad (Province of Kyrgyzstan)": [
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 195.5
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 104.2
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 117.7
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 92.6
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Jalapa (Department of Guatemala)": [
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Jalapa (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jalisco (State of M\u00e9xico)": [
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 837.3
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1446.1
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 693.7
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3437.2
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 608.0
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 701.0
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1317.5
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 976.5
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 460.3
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1231.1
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 702.9
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1015.0
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 202.4
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 291.1
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1498.0
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2102.5
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 546.6
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 913.6
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 531.8
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 907.0
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 685.6
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1392.5
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 875.9
   },
   {
    "Region Name": "Jalisco (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 665.6
   }
  ],
  "Jaluit (Atol of Marshall Islands)": [
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jaluit (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jambi (Province of Indonesia)": [
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 190.1
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 367.9
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 571.7
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 123.9
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 257.9
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 135.9
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 120.9
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 212.4
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 597.7
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Jambi (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.1
   }
  ],
  "Jammu and Kashmir (State of India)": [
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 127.8
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 101.6
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 226.8
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 113.8
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 103.3
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 167.4
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 293.9
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 372.1
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 282.1
   },
   {
    "Region Name": "Jammu and Kashmir (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 103.3
   }
  ],
  "Jan Mayen (Territory of Svalbard and Jan Mayen)": [
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Janub Sina' (Governorate of Egypt)": [
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Janub Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jarash (Province of Jordan)": [
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarash (Province of Jordan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jarvis island (Island of United States Minor Outlying Isl)": [
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jawa Barat (Province of Indonesia)": [
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 124.8
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 107.0
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Jawa Barat (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Jawa Tengah (Province of Indonesia)": [
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Jawa Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Jawa Timur (Province of Indonesia)": [
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 384.4
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 112.3
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 165.5
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 139.8
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 185.2
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 382.6
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 131.0
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 402.8
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 186.9
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Jawa Timur (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.9
   }
  ],
  "Jawzjan (Province of Afghanistan)": [
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jawzjan (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jayuya (Municipality of Puerto Rico)": [
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jayuya (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jeju (Province of South Korea)": [
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeju (Province of South Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jendouba (Governorate of Tunisia)": [
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jendouba (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.2
   }
  ],
  "Jeollabuk-do (Province of South Korea)": [
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Jeollabuk-do (Province of South Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jeollanam-do (Province of South Korea)": [
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jeollanam-do (Province of South Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jerusalem (District of Israel)": [
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jerusalem (District of Israel)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Jervis Bay Territory (Territory of Australia)": [
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jervis Bay Territory (Territory of Australia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jharkhand (State of India)": [
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 115.5
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 154.3
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 138.9
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 198.5
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 155.4
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 225.3
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 950.9
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 297.3
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 374.1
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 143.0
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 177.5
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 611.0
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1042.5
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 380.1
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 101.6
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "Jharkhand (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 347.9
   }
  ],
  "Jiangsu (Province of China)": [
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 426.6
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1479.6
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1296.9
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6506.5
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6916.0
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3728.5
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 441.4
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1938.3
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4303.7
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2022.6
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5801.5
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2981.0
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 428.7
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 283.0
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 212.9
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 268.0
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 151.3
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 231.7
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 119.2
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 159.9
   },
   {
    "Region Name": "Jiangsu (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 191.0
   }
  ],
  "Jiangxi (Province of China)": [
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 171.9
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1571.3
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 335.3
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 310.6
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 390.8
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 958.4
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2210.8
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 280.0
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 378.8
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 130.1
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 928.4
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 197.2
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 192.7
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 131.8
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 122.4
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 155.8
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 191.9
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 201.1
   },
   {
    "Region Name": "Jiangxi (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 337.4
   }
  ],
  "Jigawa (State of Nigeria)": [
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 92.6
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Jigawa (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Jihomoravsk\u00fd (Region of Czechia)": [
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jihomoravsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Jiho\u010desk\u00fd (Region of Czechia)": [
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Jiho\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Jijel (Province of Algeria)": [
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 204.3
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 135.7
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 51.9
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jijel (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Jilin (Province of China)": [
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 243.3
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 115.1
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 128.2
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 213.5
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 122.6
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 352.6
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1058.1
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 204.1
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 681.5
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4135.6
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1665.0
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 222.9
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5059.5
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4913.6
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 533.8
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9600.7
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10463.6
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6747.0
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5125.8
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6726.0
   },
   {
    "Region Name": "Jilin (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3486.7
   }
  ],
  "Jinja (District of Uganda)": [
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jinja (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Jinotega (Department of Nicaragua)": [
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 254.9
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 121.3
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 240.7
   },
   {
    "Region Name": "Jinotega (Department of Nicaragua)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Jiwaka (Province of Papua New Guinea)": [
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jiwaka (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jizan (Province of Saudi Arabia)": [
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Jizan (Province of Saudi Arabia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16.5
   }
  ],
  "Jizzax (Region of Uzbekistan)": [
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 229.8
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 89.2
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 93.7
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jizzax (Region of Uzbekistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Johnston (Atoll of United States Minor Outlying Isl)": [
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Johor (State of Malaysia)": [
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Johor (State of Malaysia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.3
   }
  ],
  "Jost Van Dyke (District of British Virgin Islands)": [
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Juana D\u00edaz (Municipality of Puerto Rico)": [
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Juana D\u00edaz (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jubbada Dhexe (Region of Somalia)": [
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jubbada Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.5
   }
  ],
  "Jubbada Hoose (Region of Somalia)": [
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 336.3
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 499.3
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 157.3
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 304.6
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 201.5
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Jubbada Hoose (Region of Somalia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30.9
   }
  ],
  "Jugovzhodna Slovenija (Statistical Region of Slovenia)": [
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jujuy (Province of Argentina)": [
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 684.9
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 674.2
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 509.8
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 681.1
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 618.0
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 540.4
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 545.1
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 735.1
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 673.8
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 452.5
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 513.8
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 672.7
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 284.5
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 314.3
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 424.0
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 383.3
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 355.2
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 292.2
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 583.5
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 220.2
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 356.5
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 167.2
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 150.1
   },
   {
    "Region Name": "Jujuy (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 141.7
   }
  ],
  "Jungoli (State of South Sudan)": [
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 72174.0
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 65791.6
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 64934.9
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 67358.8
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 67610.5
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 72995.4
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 67556.0
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 72727.9
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 56729.1
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 74260.0
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 64103.0
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 64760.2
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 64350.8
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 73774.4
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 63997.5
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 62441.6
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 75782.4
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 40910.8
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 62489.8
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 64767.5
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 59309.5
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 62071.6
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 65857.4
   },
   {
    "Region Name": "Jungoli (State of South Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 57747.6
   }
  ],
  "Jun\u00edn (Region of Peru)": [
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 278.9
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 252.3
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 126.3
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 139.8
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 324.1
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 144.5
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 92.8
   },
   {
    "Region Name": "Jun\u00edn (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 25.3
   }
  ],
  "Jura (Canton of Switzerland)": [
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jura (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jurby (Parish District of Isle of Man)": [
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Jurby (Parish District of Isle of Man)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Jutiapa (Department of Guatemala)": [
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Jutiapa (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Ju\u017eno-Banatski (District of Serbia)": [
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 127.8
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 89.8
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 335.7
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 199.8
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Ju\u017eno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.4
   }
  ],
  "Ju\u017eno-Ba\u010dki (District of Serbia)": [
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 103.3
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 83.8
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 148.3
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 76.5
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 160.1
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 116.4
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 175.6
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 266.5
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Ju\u017eno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "J\u00e1sz-Nagykun-Szolnok (County of Hungary)": [
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e1sz-Nagykun-Szolnok (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "J\u00e4mtland (County of Sweden)": [
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4mtland (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "J\u00e4rva (County of Estonia)": [
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00e4rva (County of Estonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "J\u00f5geva (County of Estonia)": [
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f5geva (County of Estonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "J\u00f6nk\u00f6ping (County of Sweden)": [
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "J\u00f6nk\u00f6ping (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "K. Maras (Province of Turkey)": [
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 101.4
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 108.9
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 119.4
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 139.8
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 170.6
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 165.9
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 96.0
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "K. Maras (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 59.4
   }
  ],
  "Kabale (District of Uganda)": [
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kabale (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kabardin-Balkar (Republic of Russia)": [
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 98.4
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 187.8
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 142.8
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 106.3
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 191.6
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 131.4
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 454.2
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 121.5
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 190.1
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 245.2
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 265.0
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 374.1
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 150.7
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 177.5
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 139.8
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Kabardin-Balkar (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 144.3
   }
  ],
  "Kabarole (District of Uganda)": [
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 207.5
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 156.3
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 140.4
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 121.5
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 232.6
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 130.8
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 136.1
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 178.6
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 114.9
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 149.8
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 136.1
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 135.7
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 133.8
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 93.0
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 123.0
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 151.8
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 130.8
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 129.5
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Kabarole (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 63.5
   }
  ],
  "Kaberamaido (District of Uganda)": [
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 212.4
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 260.7
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 129.5
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 94.3
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kaberamaido (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Kabul (Province of Afghanistan)": [
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kabul (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kachin (State of Myanmar)": [
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 178.6
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 384.8
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 185.9
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 197.2
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 301.8
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 381.1
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 377.9
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 473.3
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 308.0
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 193.4
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 350.7
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 971.7
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1052.1
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 234.5
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 161.2
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 267.3
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 101.6
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 377.3
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 493.5
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 290.5
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 673.3
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 113.6
   },
   {
    "Region Name": "Kachin (State of Myanmar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 448.9
   }
  ],
  "Kaduna (State of Nigeria)": [
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6767.0
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4869.6
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5451.0
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5936.7
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7371.7
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5603.6
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4268.3
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4851.0
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3593.9
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5530.5
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3729.2
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3002.5
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4822.7
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3755.5
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3789.0
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4789.6
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3683.9
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3544.8
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5098.1
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4477.1
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4925.6
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5206.8
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4378.3
   },
   {
    "Region Name": "Kaduna (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2524.6
   }
  ],
  "Kaes\u014fng (Special Administrative Region of North Korea)": [
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 86.6
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaes\u014fng (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.8
   }
  ],
  "Kaffrine (Region of Senegal)": [
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1817.8
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1590.4
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1931.0
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2622.2
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4145.7
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2205.0
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1909.2
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2796.2
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2844.5
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2859.9
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2639.7
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2547.3
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 821.5
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 655.3
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1546.0
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1107.9
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 464.8
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 501.4
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1234.8
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1576.3
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1310.4
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1934.7
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 979.7
   },
   {
    "Region Name": "Kaffrine (Region of Senegal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 788.7
   }
  ],
  "Kafr ash Shaykh (Governorate of Egypt)": [
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 119.2
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kagawa (Prefecture of Japan)": [
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kagera (Region of Tanzania)": [
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4486.1
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5041.3
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4590.9
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4482.0
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3128.7
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4027.4
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4526.0
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3256.7
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4050.5
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3224.5
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1802.0
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2449.0
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2420.9
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1991.1
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2577.8
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1517.1
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1648.3
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3682.9
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2871.3
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2420.0
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2246.2
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2188.7
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2575.9
   },
   {
    "Region Name": "Kagera (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2044.4
   }
  ],
  "Kagoshima (Prefecture of Japan)": [
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kagoshima (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kairouan (Governorate of Tunisia)": [
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kairouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kajiado (County of Kenya)": [
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 241.8
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 284.3
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 146.4
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Kajiado (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 21.7
   }
  ],
  "Kakamega (County of Kenya)": [
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kakamega (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kakheti (Region of Georgia)": [
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 128.2
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 216.9
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 197.6
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 164.6
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 98.4
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 336.8
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 245.2
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 143.2
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 134.4
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 382.9
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 171.1
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 104.2
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 65.4
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Kakheti (Region of Georgia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 308.3
   }
  ],
  "Kalasin (Province of Thailand)": [
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 104.8
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 93.0
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 114.7
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 119.4
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 113.8
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 108.5
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 130.1
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Kalasin (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.8
   }
  ],
  "Kalbajar-Lachin (Region of Azerbaijan)": [
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 407.9
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 207.9
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 437.7
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 221.7
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 357.8
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 155.8
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 680.6
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 166.1
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 218.9
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 144.3
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 342.1
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 178.8
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 295.8
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 238.2
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 373.6
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 455.3
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 412.4
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 140.0
   }
  ],
  "Kalimantan Barat (Province of Indonesia)": [
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2977.8
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 791.5
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3516.7
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 367.0
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3716.3
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 260.9
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 119.8
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2284.3
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 452.3
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 845.9
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 709.6
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2031.6
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 561.9
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 151.8
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 726.5
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1807.8
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 108.3
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 96.7
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 567.2
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 88.5
   },
   {
    "Region Name": "Kalimantan Barat (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 173.9
   }
  ],
  "Kalimantan Selatan (Province of Indonesia)": [
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3271.5
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 640.3
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2312.6
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 665.2
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2967.9
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 212.2
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2430.7
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 875.5
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 653.2
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 245.9
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1865.2
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2473.0
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 163.6
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 472.5
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1345.0
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 976.9
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Kalimantan Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.1
   }
  ],
  "Kalimantan Tengah (Province of Indonesia)": [
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4756.0
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1690.5
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5722.6
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1204.3
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7846.5
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 321.3
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5754.1
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1726.3
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1794.3
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 493.7
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4638.5
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4591.6
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1024.0
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5474.6
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2858.2
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Kalimantan Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.4
   }
  ],
  "Kalimantan Timur (Province of Indonesia)": [
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1315.6
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2247.0
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 122.2
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 957.6
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 815.2
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 168.3
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1007.3
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2544.3
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 245.2
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 990.2
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 333.3
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 127.8
   },
   {
    "Region Name": "Kalimantan Timur (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 17.1
   }
  ],
  "Kalimantan Utara (Province of Indonesia)": [
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 108.9
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 132.5
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Kalimantan Utara (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Kalinga (Province of Philippines)": [
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 108.5
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 105.9
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Kalinga (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Kaliningrad (Region of Russia)": [
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 586.9
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 204.5
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 109.5
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 260.9
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 571.9
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 643.1
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 271.8
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 296.7
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 493.5
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1547.1
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 730.6
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 230.7
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 711.9
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Kaliningrad (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 86.2
   }
  ],
  "Kalmar (County of Sweden)": [
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalmar (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kalmyk (Republic of Russia)": [
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5018.4
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 486.2
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1048.5
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3077.3
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6182.0
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4951.1
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 924.1
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 339.1
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1173.0
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4677.7
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 433.2
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 799.6
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2609.3
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 136.8
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 949.2
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 427.7
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 446.5
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 581.2
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 326.9
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 229.2
   },
   {
    "Region Name": "Kalmyk (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 857.3
   }
  ],
  "Kaluga (Region of Russia)": [
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 269.0
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 126.3
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 546.2
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 161.4
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 437.5
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 607.3
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 681.7
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 218.4
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 129.5
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 251.9
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 122.8
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 292.2
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 563.1
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 280.6
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Kaluga (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.4
   }
  ],
  "Kalutara (District of Sri Lanka)": [
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kalutara (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kamchatka (Territory of Russia)": [
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1536.2
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2687.5
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 108.3
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 323.5
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 258.5
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 802.6
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6087.0
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 190.1
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 109.3
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4475.8
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1049.6
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 948.2
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1400.0
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Kamchatka (Territory of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.9
   }
  ],
  "Kampala (District of Uganda)": [
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kampala (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kamphaeng Phet (Province of Thailand)": [
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 205.4
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 344.9
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 381.8
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 126.0
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 96.5
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 116.4
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 152.0
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 128.4
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 123.0
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 133.8
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 132.5
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 128.8
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 218.7
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 253.4
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 338.3
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 210.5
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 229.4
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 101.6
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 239.2
   },
   {
    "Region Name": "Kamphaeng Phet (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 43.5
   }
  ],
  "Kamuli (District of Uganda)": [
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Kamuli (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Kamwenge (District of Uganda)": [
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 98.4
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 114.7
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 130.1
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 121.5
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "Kamwenge (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kanagawa (Prefecture of Japan)": [
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanagawa (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kanchanaburi (Province of Thailand)": [
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 223.2
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 281.0
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 531.8
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 220.2
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 560.1
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 419.9
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 425.5
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 300.8
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 339.8
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 349.2
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 197.2
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 426.6
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 647.0
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 882.1
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 327.6
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 435.4
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 486.4
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 770.7
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1108.5
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 201.9
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 680.0
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1193.8
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 716.4
   },
   {
    "Region Name": "Kanchanaburi (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 124.1
   }
  ],
  "Kandahar (Province of Afghanistan)": [
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandahar (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kandy (District of Sri Lanka)": [
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kandy (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kanem (Region of Chad)": [
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 288.3
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 148.6
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 383.5
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 277.2
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 276.8
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 436.9
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 139.1
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 241.4
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 284.3
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 328.4
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 393.6
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 755.7
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 485.5
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 308.0
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 122.2
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 777.7
   },
   {
    "Region Name": "Kanem (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1433.7
   }
  ],
  "Kangw\u014fn-do (Province of North Korea)": [
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 92.4
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 238.8
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 337.6
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 180.3
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 97.8
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 394.0
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 91.7
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 354.8
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 181.4
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 165.7
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Kangw\u014fn-do (Province of North Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Kani-Keli (Commune of Mayotte)": [
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kani-Keli (Commune of Mayotte)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kankan (Region of Guinea)": [
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18017.7
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15744.1
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16254.5
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16345.0
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19097.1
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15512.0
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14910.9
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15074.2
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15834.8
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18219.2
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14573.0
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16506.6
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12376.2
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21658.1
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13138.9
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14284.5
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12095.3
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14717.3
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12699.0
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12898.2
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12399.1
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12218.4
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9901.9
   },
   {
    "Region Name": "Kankan (Region of Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8238.6
   }
  ],
  "Kano (State of Nigeria)": [
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 401.7
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 325.6
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 304.4
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 431.7
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 558.6
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 366.6
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 249.1
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 198.1
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 238.4
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 223.6
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 160.6
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 188.2
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 207.9
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 286.6
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 274.2
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 176.9
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Kano (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.1
   }
  ],
  "Kansas (State of United States)": [
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 487.3
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2767.9
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1314.5
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3384.0
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2579.1
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1131.2
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4310.7
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5025.5
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2435.0
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4530.5
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 432.4
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 403.0
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4558.8
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1316.7
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5561.6
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3366.7
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1833.7
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3453.1
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5342.3
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1601.1
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3650.3
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2441.9
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1792.8
   },
   {
    "Region Name": "Kansas (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3045.1
   }
  ],
  "Kanungu (District of Uganda)": [
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 162.9
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 164.0
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 284.7
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 163.1
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 168.7
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 104.4
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 234.1
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 195.9
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 154.8
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 225.7
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 195.3
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 144.9
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 153.5
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 214.4
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 156.9
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 268.6
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 116.4
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 179.6
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 192.7
   },
   {
    "Region Name": "Kanungu (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 98.4
   }
  ],
  "Kaohsiung (Special Municipality of Taiwan)": [
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kaolack (Region of Senegal)": [
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 697.1
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 105.3
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 108.7
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 786.9
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 599.8
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 350.5
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 92.6
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 84.0
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 139.1
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 211.8
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 125.6
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 113.4
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 134.6
   },
   {
    "Region Name": "Kaolack (Region of Senegal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 44.4
   }
  ],
  "Kapchorwa (District of Uganda)": [
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 108.7
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 161.6
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 234.1
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 130.6
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Kapchorwa (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 25.9
   }
  ],
  "Kapisa (Province of Afghanistan)": [
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kapisa (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kara (Region of Togo)": [
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4538.8
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4115.2
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4038.5
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4057.4
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3594.8
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3406.8
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3373.3
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3574.6
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3811.7
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4638.5
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3119.3
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2920.6
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2758.9
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3304.1
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3395.0
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3604.4
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2573.5
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2854.8
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2232.7
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2613.4
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2587.2
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2053.4
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1914.3
   },
   {
    "Region Name": "Kara (Region of Togo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1372.6
   }
  ],
  "Karab\u00fck (Province of Turkey)": [
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karab\u00fck (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 68.8
   }
  ],
  "Karachay-Cherkess (Republic of Russia)": [
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 93.9
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 119.8
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 137.4
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 81.7
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 114.9
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 241.4
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 207.3
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 119.4
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 174.1
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Karachay-Cherkess (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 41.6
   }
  ],
  "Karak (Province of Jordan)": [
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karak (Province of Jordan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Karaman (Province of Turkey)": [
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karaman (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Karas (Region of Namibia)": [
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 178.4
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 931.4
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Karas (Region of Namibia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.1
   }
  ],
  "Karbala' (Province of Iraq)": [
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 141.3
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 359.3
   },
   {
    "Region Name": "Karbala' (Province of Iraq)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 253.8
   }
  ],
  "Karbinci (Municipality of North Macedonia)": [
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karbinci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kardzhali (Province of Bulgaria)": [
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kardzhali (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Karelia (Republic of Russia)": [
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 203.9
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karelia (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.6
   }
  ],
  "Karlovacka (County of Croatia)": [
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Karlovacka (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Karlovarsk\u00fd (Region of Czechia)": [
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karlovarsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Karnataka (State of India)": [
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 198.3
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 716.6
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 449.7
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 279.1
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 475.7
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 236.0
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 605.2
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 819.1
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 204.9
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 282.1
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 276.1
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 220.8
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 480.4
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 522.4
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 486.6
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 209.0
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 619.3
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 314.7
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1152.4
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 381.4
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 811.6
   },
   {
    "Region Name": "Karnataka (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 500.1
   }
  ],
  "Karonga (District of Malawi)": [
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 391.7
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 644.2
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 371.3
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 636.9
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 212.4
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 414.4
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 349.9
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 367.6
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 431.7
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 391.4
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 405.2
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 503.1
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 400.0
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 341.9
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 334.0
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 330.1
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 155.2
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 328.4
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 196.6
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 229.8
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 407.9
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 306.5
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 198.9
   },
   {
    "Region Name": "Karonga (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 295.8
   }
  ],
  "Kars (Province of Turkey)": [
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kars (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Karuzi (Province of Burundi)": [
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Karuzi (Province of Burundi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kasa\u00ef (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10689.5
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11657.8
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13719.4
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11914.6
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12519.4
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11262.1
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10550.2
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12314.6
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11842.2
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10455.6
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10672.6
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11648.2
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11169.1
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10723.6
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12817.6
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11296.6
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11651.2
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10658.4
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12710.2
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12820.1
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12128.4
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11598.6
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13509.1
   },
   {
    "Region Name": "Kasa\u00ef (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11666.4
   }
  ],
  "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3875.6
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4401.6
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4930.7
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4053.1
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4852.0
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3913.7
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3201.6
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3961.5
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3661.0
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2905.8
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3282.2
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3525.1
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3330.7
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3152.7
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3559.0
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3496.8
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3520.2
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2485.0
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3962.2
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3973.8
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3298.3
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3555.1
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5067.0
   },
   {
    "Region Name": "Kasa\u00ef-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3368.2
   }
  ],
  "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 441.6
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 760.6
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 805.8
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 502.5
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 441.8
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 567.9
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 434.1
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 260.0
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 273.3
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 115.8
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 128.0
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 273.7
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 400.7
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 184.1
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 201.5
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 171.1
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 116.0
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 107.4
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 123.3
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 147.3
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 323.9
   },
   {
    "Region Name": "Kasa\u00ef-Oriental (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 129.1
   }
  ],
  "Kasese (District of Uganda)": [
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 432.2
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 382.2
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 441.6
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 357.8
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 189.3
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 490.5
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 248.7
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 339.1
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 461.5
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 537.2
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 275.5
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 502.3
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 444.2
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 316.8
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 507.4
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 244.8
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 321.8
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 166.1
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 717.9
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 445.0
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 485.3
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 307.8
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 500.1
   },
   {
    "Region Name": "Kasese (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 400.9
   }
  ],
  "Kaskazini Pemba (Region of Tanzania)": [
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Kaskazini Unguja (Region of Tanzania)": [
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kaskazini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kassala (State of Sudan)": [
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 188.2
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 101.4
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 598.7
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 213.5
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 142.1
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 161.6
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 96.9
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 141.3
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 279.5
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 237.9
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 113.0
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 179.2
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 175.1
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 547.7
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 192.9
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 183.5
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 280.2
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 522.2
   },
   {
    "Region Name": "Kassala (State of Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 248.5
   }
  ],
  "Kasserine (Governorate of Tunisia)": [
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 89.6
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kasserine (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kastamonu (Province of Turkey)": [
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kastamonu (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 36.2
   }
  ],
  "Kasungu (District of Malawi)": [
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 277.6
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 251.0
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 191.2
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 205.8
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 299.3
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 260.5
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 414.8
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 292.6
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 346.6
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 310.4
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 283.6
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 392.5
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 278.5
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 280.0
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 376.2
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 290.5
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 404.1
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 255.3
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 462.0
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 177.3
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 406.7
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 204.9
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 327.1
   },
   {
    "Region Name": "Kasungu (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 308.9
   }
  ],
  "Katakwi (District of Uganda)": [
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1141.7
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 986.1
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 616.3
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 731.2
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 244.0
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 667.8
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 531.2
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 433.5
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 245.2
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 516.2
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 165.7
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 235.6
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 400.4
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 571.9
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 345.6
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 345.6
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 263.5
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 151.1
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 272.0
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 275.7
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 186.5
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 137.0
   },
   {
    "Region Name": "Katakwi (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 187.4
   }
  ],
  "Katavi (Region of Tanzania)": [
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15317.5
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18288.7
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 18848.0
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18058.0
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18773.8
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16943.1
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15362.8
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16277.0
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16319.1
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15620.0
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16585.9
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14399.8
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14229.6
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14581.8
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14762.9
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13136.5
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10423.7
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13341.0
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10901.7
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10599.3
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10386.0
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10181.0
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8443.1
   },
   {
    "Region Name": "Katavi (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8757.8
   }
  ],
  "Katsina (State of Nigeria)": [
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 224.9
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 89.2
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 221.7
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 207.5
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 232.4
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 234.9
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 247.8
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 163.6
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 226.2
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 469.9
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 616.3
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 990.0
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 925.4
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1403.0
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 912.8
   },
   {
    "Region Name": "Katsina (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 857.0
   }
  ],
  "Kauno (County of Lithuania)": [
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kauno (County of Lithuania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Kavadartsi (Municipality of North Macedonia)": [
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kavadartsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kavango (Region of Namibia)": [
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18669.6
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18480.1
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 20552.8
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18617.7
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15748.4
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21342.1
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15812.3
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19364.0
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21364.9
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 27227.9
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 26543.6
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21067.1
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14882.1
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12612.0
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13608.4
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15655.6
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8360.0
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5765.7
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13653.2
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7106.8
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9739.2
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11073.0
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7302.1
   },
   {
    "Region Name": "Kavango (Region of Namibia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4805.5
   }
  ],
  "Kayah (State of Myanmar)": [
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1394.5
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4112.0
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4478.0
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1061.1
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4288.2
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2877.5
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5507.4
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3181.9
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2151.6
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3336.9
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3734.1
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1339.6
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5266.2
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2975.2
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3417.3
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2604.8
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3222.0
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4672.8
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2446.8
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2787.0
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2816.4
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1963.8
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3194.1
   },
   {
    "Region Name": "Kayah (State of Myanmar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1529.5
   }
  ],
  "Kayangel (State of Palau)": [
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayangel (State of Palau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kayanza (Province of Burundi)": [
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayanza (Province of Burundi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kayes (Region of Mali)": [
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 36939.6
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 36169.2
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 46510.6
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 40739.1
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 49966.0
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 39539.3
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 43940.5
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 34863.9
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36004.8
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 35350.7
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 30477.7
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 32685.7
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 30841.3
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 36867.0
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 35823.2
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 33487.2
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30613.2
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 31517.8
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 37422.0
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 36408.4
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 35945.8
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 34571.9
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 31463.6
   },
   {
    "Region Name": "Kayes (Region of Mali)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 33294.5
   }
  ],
  "Kayin (State of Myanmar)": [
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 377.5
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1447.6
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2868.9
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1147.3
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1547.3
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2168.1
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1392.5
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1847.0
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 891.3
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 733.4
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1388.0
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 859.0
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2289.0
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 907.4
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1295.6
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1052.6
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1301.6
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1332.5
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1979.1
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 859.0
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 749.0
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 673.5
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1249.3
   },
   {
    "Region Name": "Kayin (State of Myanmar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 395.1
   }
  ],
  "Kayseri (Province of Turkey)": [
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 111.5
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Kayseri (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.8
   }
  ],
  "Kayunga (District of Uganda)": [
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Kayunga (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.3
   }
  ],
  "Ka\u00f4h Kong (Province of Cambodia)": [
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 174.3
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 155.0
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 147.3
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 230.0
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 203.2
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 310.8
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 105.0
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 190.4
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 169.8
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 165.3
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 170.6
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 198.7
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 192.3
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 189.5
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 108.7
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 177.1
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 185.2
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 163.1
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 241.2
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 255.1
   },
   {
    "Region Name": "Ka\u00f4h Kong (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 107.4
   }
  ],
  "Kebbi (State of Nigeria)": [
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4782.1
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4517.0
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6116.2
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4755.3
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4882.3
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3769.3
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3893.8
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4465.5
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2967.1
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3325.1
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2840.2
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2600.1
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1764.7
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1685.2
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1289.9
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1633.1
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1229.4
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1157.6
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 755.9
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1325.9
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1439.9
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2340.3
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1351.2
   },
   {
    "Region Name": "Kebbi (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 820.4
   }
  ],
  "Kebili (Governorate of Tunisia)": [
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kebili (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kedah (State of Malaysia)": [
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 207.5
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 330.6
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 138.9
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 105.5
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kedah (State of Malaysia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Kegalle (District of Sri Lanka)": [
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kegalle (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kelantan (State of Malaysia)": [
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kelantan (State of Malaysia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kemerovo (Region of Russia)": [
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1064.8
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1248.9
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1188.2
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 902.3
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 925.2
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 929.9
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1823.9
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1254.5
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1131.4
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1770.7
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1348.0
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 172.8
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 983.1
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 252.7
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 572.6
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 479.8
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 189.5
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 422.7
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1327.8
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 147.7
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2514.3
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 196.8
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 136.1
   },
   {
    "Region Name": "Kemerovo (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 216.1
   }
  ],
  "Kentucky (State of United States)": [
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 122.0
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 122.0
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 120.5
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 154.6
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 97.5
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Kentucky (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 25.3
   }
  ],
  "Kep (Province of Cambodia)": [
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kep (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kepulauan Riau (Province of Indonesia)": [
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 78.2
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 88.3
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Kepulauan Riau (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.1
   }
  ],
  "Kerala (State of India)": [
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 130.1
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 107.0
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 134.8
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Kerala (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.2
   }
  ],
  "Kerguelen (District of French Southern Territories)": [
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerguelen (District of French Southern Territories)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kericho (County of Kenya)": [
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kericho (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kerman (Province of Iran)": [
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 232.2
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 123.0
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 755.0
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 151.6
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 104.2
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 413.1
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 81.7
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Kerman (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.4
   }
  ],
  "Kermanshah (Province of Iran)": [
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 375.4
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 179.4
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 130.3
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 134.6
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 128.8
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 619.5
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 326.7
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1027.3
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 148.3
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 232.4
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 136.3
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 89.6
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 208.4
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 143.6
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 272.0
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 705.3
   },
   {
    "Region Name": "Kermanshah (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 308.7
   }
  ],
  "Kerry (County of Ireland)": [
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kerry (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Kgalagadi (District of Botswana)": [
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7271.0
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 835.4
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7495.6
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4798.7
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3186.6
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1869.9
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8808.9
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 37083.5
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4844.5
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2254.5
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3868.3
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 872.1
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 308.9
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9935.6
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3035.0
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5005.7
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 38572.3
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11672.6
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14648.5
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1966.0
   },
   {
    "Region Name": "Kgalagadi (District of Botswana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5860.2
   }
  ],
  "Kgatleng (District of Botswana)": [
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1415.0
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1029.4
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1533.2
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1624.5
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 156.5
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 484.5
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 534.2
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Kgatleng (District of Botswana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.4
   }
  ],
  "Khabarovsk (Territory of Russia)": [
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4526.8
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9227.9
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 803.9
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9832.5
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1851.3
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4747.6
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17729.4
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8567.0
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 548.8
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5130.3
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15660.5
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2235.9
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4344.2
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1245.9
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2871.3
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1785.9
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5022.7
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5608.8
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1382.5
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1098.4
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8055.6
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7529.1
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3030.7
   },
   {
    "Region Name": "Khabarovsk (Territory of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 298.8
   }
  ],
  "Khakass (Republic of Russia)": [
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1248.1
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 149.6
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 555.2
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 307.2
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 306.8
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1001.1
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 992.5
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 498.4
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 152.6
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 397.4
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 282.1
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 755.9
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1354.6
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 288.3
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Khakass (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 97.1
   }
  ],
  "Khammouan (Province of Laos)": [
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 80.0
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 148.6
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 190.8
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 112.5
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 209.0
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 107.2
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 129.1
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 117.5
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 155.6
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 147.3
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 163.6
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 261.7
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 170.6
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 149.8
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 123.5
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 180.3
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 588.4
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 298.0
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 351.4
   },
   {
    "Region Name": "Khammouan (Province of Laos)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 206.0
   }
  ],
  "Khanty-Mansiy (Autonomous Province of Russia)": [
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 507.4
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1299.9
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1543.5
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 231.5
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 229.4
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 106.8
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 739.8
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 364.0
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5623.5
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1359.5
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 143.6
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 286.2
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 977.1
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2859.0
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 113.4
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Kharkiv (Region of Ukraine)": [
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1546.0
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 189.1
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 641.8
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3607.6
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1079.8
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3256.9
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3833.8
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2060.1
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 421.4
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 822.3
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 185.0
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 733.4
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1838.9
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2015.5
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 515.8
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1059.2
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 809.2
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1270.6
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 905.3
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 371.5
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 377.7
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 487.3
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1803.9
   },
   {
    "Region Name": "Kharkiv (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1309.6
   }
  ],
  "Khartoum (State of Sudan)": [
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 186.5
   },
   {
    "Region Name": "Khartoum (State of Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 42.4
   }
  ],
  "Khatlon (Region of Tajikistan)": [
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 186.9
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 233.7
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 97.8
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Khatlon (Region of Tajikistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 88.7
   }
  ],
  "Khenchela (Province of Algeria)": [
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 94.5
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 302.0
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 121.5
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khenchela (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kherson (Region of Ukraine)": [
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 647.6
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 394.2
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1845.3
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1053.6
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 793.8
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2072.1
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 834.3
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 605.6
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 944.9
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 301.6
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 207.1
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 767.9
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1326.1
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 693.3
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1821.9
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 595.9
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 744.7
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 397.7
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 639.2
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 864.1
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1824.7
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1673.6
   },
   {
    "Region Name": "Kherson (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1688.4
   }
  ],
  "Khmel'nyts'kyy (Region of Ukraine)": [
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 460.7
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 96.5
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 214.8
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 285.5
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 377.7
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1060.9
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 292.4
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 237.9
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 180.9
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 142.6
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 290.9
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 721.8
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 725.4
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 562.7
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 628.5
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 251.0
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 258.3
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 99.7
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 76.5
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 57.5
   }
  ],
  "Khomas (Region of Namibia)": [
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 138.5
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 115.5
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 367.9
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1569.8
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 265.0
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 561.6
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 448.9
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1096.3
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 731.9
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 113.0
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 258.3
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 177.7
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 87.9
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 242.2
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3271.9
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 520.3
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 355.0
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Khomas (Region of Namibia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 139.6
   }
  ],
  "Khon Kaen (Province of Thailand)": [
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 203.4
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 326.5
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 342.3
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 106.1
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 82.7
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 195.5
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 185.0
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 264.7
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 207.9
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 114.9
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 207.3
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 230.7
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 473.5
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 98.8
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 164.2
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Khon Kaen (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 51.0
   }
  ],
  "Khost (Province of Afghanistan)": [
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Khost (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 22.7
   }
  ],
  "Khulna (Division of Bangladesh)": [
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Khulna (Division of Bangladesh)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Khuzestan (Province of Iran)": [
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1129.3
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 963.6
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 887.7
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1684.7
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1262.0
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1593.0
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1050.8
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 441.2
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1133.6
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 946.7
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 667.3
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1009.7
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1475.7
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 793.0
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1049.3
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1157.2
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 859.2
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1928.0
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1247.6
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1308.9
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 734.0
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2924.2
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3723.2
   },
   {
    "Region Name": "Khuzestan (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1523.7
   }
  ],
  "Khyber-Pakhtunkhwa (Province of Pakistan)": [
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 111.3
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 141.1
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 205.6
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 164.4
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 86.6
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 248.7
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 78.0
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 164.4
   },
   {
    "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 209.7
   }
  ],
  "Kh\u00e1nh H\u00f2a (Province of Vietnam)": [
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 97.5
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 116.2
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Kh\u00e1nh H\u00f2a (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 26.2
   }
  ],
  "Kiambu (County of Kenya)": [
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kiambu (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Kibale (District of Uganda)": [
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 98.0
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 117.3
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 232.2
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 338.1
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 288.3
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 143.8
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 122.8
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 182.4
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 128.8
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 131.4
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 114.7
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Kibale (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 25.7
   }
  ],
  "Kiboga (District of Uganda)": [
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 97.5
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 268.8
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 217.2
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 206.7
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 274.4
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 158.0
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 239.0
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 90.2
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 160.6
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Kiboga (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.3
   }
  ],
  "Kidal (Region of Mali)": [
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Kidal (Region of Mali)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 126.5
   }
  ],
  "Kiev (Region of Ukraine)": [
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1050.6
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 379.9
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 653.6
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 977.3
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 514.1
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 911.5
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1891.8
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1065.0
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 391.7
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 398.3
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 501.4
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 272.5
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 999.0
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 880.4
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 255.7
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 499.7
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 210.7
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 996.6
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 736.8
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 242.5
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 194.6
   },
   {
    "Region Name": "Kiev (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 151.1
   }
  ],
  "Kiev City (Independent City of Ukraine)": [
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Kiev City (Independent City of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.6
   }
  ],
  "Kigoma (Region of Tanzania)": [
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9706.8
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13127.3
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14128.0
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13500.7
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12715.9
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9809.3
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10935.0
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11649.9
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10177.8
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11623.3
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9345.0
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8387.8
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9701.9
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9098.9
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8723.3
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9338.6
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6880.2
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7334.2
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6416.5
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6249.3
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6793.8
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6288.1
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5878.2
   },
   {
    "Region Name": "Kigoma (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5989.7
   }
  ],
  "Kildare (County of Ireland)": [
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kildare (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kilifi (County of Kenya)": [
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Kilifi (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Kilimanjaro (Region of Tanzania)": [
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 183.1
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 234.9
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 89.8
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 321.6
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 125.8
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 116.0
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 114.3
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 488.1
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 128.2
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 105.0
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 278.3
   },
   {
    "Region Name": "Kilimanjaro (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 234.9
   }
  ],
  "Kilinochchi (District of Sri Lanka)": [
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kilinochchi (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kilis (Province of Turkey)": [
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kilis (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kilkenny (County of Ireland)": [
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kilkenny (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kindia (Region of Guinea)": [
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2416.4
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2006.9
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3113.3
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2919.1
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2342.8
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2990.7
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1539.4
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3422.2
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 899.9
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1846.4
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3037.0
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2920.8
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2778.0
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2626.7
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2616.6
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4400.4
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2115.8
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2435.0
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1095.9
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1972.2
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2946.3
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1391.7
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2623.7
   },
   {
    "Region Name": "Kindia (Region of Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1202.2
   }
  ],
  "Kingman Reef (Reef of United States Minor Outlying Isl)": [
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kingston (Parish of Jamaica)": [
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kingston (Parish of Jamaica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kinkkale (Province of Turkey)": [
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 120.5
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 170.6
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 409.2
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 151.8
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 364.6
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 137.0
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Kinkkale (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kinshasa (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2516.5
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2973.3
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3193.5
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3031.4
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2772.0
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2545.8
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2244.2
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2582.3
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2915.8
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2151.4
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1956.8
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1907.2
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1517.7
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2049.2
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1979.1
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1751.6
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2995.8
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1429.0
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1618.9
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1461.6
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1474.6
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1683.9
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2719.7
   },
   {
    "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1938.1
   }
  ],
  "Kirinyaga (County of Kenya)": [
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirinyaga (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.4
   }
  ],
  "Kirklareli (Province of Turkey)": [
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Kirklareli (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.0
   }
  ],
  "Kirov (Region of Russia)": [
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 122.4
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 414.8
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 192.9
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 250.0
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 155.8
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 93.9
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 86.6
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Kirov (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.4
   }
  ],
  "Kirovohrad (Region of Ukraine)": [
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2661.8
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 794.0
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1447.2
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2457.1
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2542.6
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1414.8
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5449.0
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2494.0
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1061.8
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1427.9
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 360.1
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 682.1
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2971.2
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2308.8
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1089.4
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1400.9
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 544.1
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2867.8
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 564.0
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 288.3
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 318.1
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 308.7
   },
   {
    "Region Name": "Kirovohrad (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 119.6
   }
  ],
  "Kirsehir (Province of Turkey)": [
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 104.8
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 114.5
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 472.7
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 444.0
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 161.8
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 598.7
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 206.2
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Kirsehir (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.7
   }
  ],
  "Kirundo (Province of Burundi)": [
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kirundo (Province of Burundi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kisela Voda (Municipality of North Macedonia)": [
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisela Voda (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kisii (County of Kenya)": [
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisii (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kisoro (District of Uganda)": [
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Kisoro (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kisumu (County of Kenya)": [
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Kisumu (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16.5
   }
  ],
  "Kitgum (District of Uganda)": [
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4518.5
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5491.9
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5748.1
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7900.4
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5752.4
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5892.8
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6046.1
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4162.6
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4508.0
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4782.6
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3438.7
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3626.9
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3965.8
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4110.5
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4375.5
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4771.6
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3628.8
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2330.0
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3169.0
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3435.9
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3494.6
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2791.9
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2484.5
   },
   {
    "Region Name": "Kitgum (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2597.7
   }
  ],
  "Kitui (County of Kenya)": [
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 249.1
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 132.5
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 127.1
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 72.7
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 120.5
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 99.0
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 282.1
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 203.4
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 201.1
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 192.9
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 105.3
   },
   {
    "Region Name": "Kitui (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 39.0
   }
  ],
  "Ki\u00e9-Ntem (Province of Equatorial Guinea)": [
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Ki\u00e9-Ntem (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Ki\u00ean Giang (Province of Vietnam)": [
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 791.5
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 530.3
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 801.1
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 117.5
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 274.4
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 835.0
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 755.9
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1059.4
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 346.4
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1994.1
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 715.6
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1505.7
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2239.1
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1030.7
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 500.8
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1709.2
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1442.5
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1192.1
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1145.8
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 275.5
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1652.4
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1613.3
   },
   {
    "Region Name": "Ki\u00ean Giang (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 887.5
   }
  ],
  "Ki\u010devo (Municipality of North Macedonia)": [
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Ki\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.1
   }
  ],
  "Klaipedos (County of Lithuania)": [
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Klaipedos (County of Lithuania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kocaeli (Province of Turkey)": [
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kocaeli (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.5
   }
  ],
  "Kochi (Prefecture of Japan)": [
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kochi (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kogi (State of Nigeria)": [
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4153.0
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6336.3
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7463.0
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1852.6
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2735.1
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3202.9
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1233.1
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2175.8
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1940.7
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1755.5
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2666.8
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2036.9
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2220.4
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5023.1
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2965.8
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2325.0
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2264.4
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3013.2
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2033.7
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4702.0
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1058.1
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2306.8
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1881.5
   },
   {
    "Region Name": "Kogi (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2349.7
   }
  ],
  "Kohgiluyeh and Buyer Ahmad (Province of Iran)": [
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 104.6
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 142.3
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 133.8
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 92.2
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 93.7
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 190.8
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 134.8
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 322.8
   },
   {
    "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 51.4
   }
  ],
  "Kola\u0161in (Municipality of Montenegro)": [
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kola\u0161in (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kolda (Region of Senegal)": [
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6127.7
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3668.1
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6753.9
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7478.7
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6318.5
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4844.1
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4934.1
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6504.0
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5469.8
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6533.3
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5232.1
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6664.1
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4902.4
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3949.7
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5796.8
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4868.5
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5481.8
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6600.2
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5699.4
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6427.9
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4522.8
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7146.0
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4825.4
   },
   {
    "Region Name": "Kolda (Region of Senegal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4888.3
   }
  ],
  "Kolubarski (District of Serbia)": [
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kolubarski (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Komi (Republic of Russia)": [
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 185.6
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 114.9
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 411.6
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 308.5
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 379.9
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Komi (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kom\u00e1rom-Esztergom (County of Hungary)": [
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kom\u00e1rom-Esztergom (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kon Tum (Province of Vietnam)": [
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 146.2
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 156.1
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 288.1
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 361.9
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 174.3
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 154.8
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 349.4
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 305.0
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 411.8
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 214.6
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 141.5
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 211.4
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 142.6
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 255.7
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 124.8
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Kon Tum (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.1
   }
  ],
  "Kongo-Central (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5410.5
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7593.4
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8417.6
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8765.5
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7979.7
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8579.5
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7916.2
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9493.5
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9326.8
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8353.3
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10334.5
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10185.7
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8026.8
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11312.9
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7136.8
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8350.1
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8651.5
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6938.1
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8683.2
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7958.4
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7960.4
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8515.8
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10127.2
   },
   {
    "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8115.2
   }
  ],
  "Konya (Province of Turkey)": [
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 136.8
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 552.2
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 434.3
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 845.3
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 111.7
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 107.8
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2107.0
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 564.4
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1302.1
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 119.4
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 166.6
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 297.8
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 117.5
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 317.7
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 359.5
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 223.4
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Konya (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 35.6
   }
  ],
  "Kon\u010de (Municipality of North Macedonia)": [
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kon\u010de (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)": [
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koprivni\u010dko-Kri\u017eeva\u010dka (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kordestan (Province of Iran)": [
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 165.7
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 581.8
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 51.9
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 106.1
   },
   {
    "Region Name": "Kordestan (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 32.2
   }
  ],
  "Koror (State of Palau)": [
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koror (State of Palau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Koro\u0161ka (Statistical Region of Slovenia)": [
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kor\u00e7\u00eb (County of Albania)": [
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Kor\u00e7\u00eb (County of Albania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Kosovska Mitrovica (District of Kosovo)": [
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kosovska Mitrovica (District of Kosovo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Kosrae (State of Micronesia)": [
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kosrae (State of Micronesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kostroma (Region of Russia)": [
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 289.0
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 316.4
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Kostroma (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Kotayk (Province of Armenia)": [
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotayk (Province of Armenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.0
   }
  ],
  "Kotido (District of Uganda)": [
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3435.5
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3986.4
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3386.4
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4489.3
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2335.3
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5635.3
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5366.3
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2729.3
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6894.1
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6435.4
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4621.4
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4106.2
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4902.4
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4958.4
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3791.5
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5207.9
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4496.0
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3587.5
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5100.9
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5376.6
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5778.3
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3516.7
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4015.3
   },
   {
    "Region Name": "Kotido (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4263.6
   }
  ],
  "Kotor (Municipality of Montenegro)": [
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kotor (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kouffo (Department of Benin)": [
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 111.5
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 147.5
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 439.2
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 154.8
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 115.5
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 95.4
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Kouffo (Department of Benin)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.6
   }
  ],
  "Kouilou (Region of Republic of the Congo)": [
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 116.8
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 169.1
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 206.0
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 296.7
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 162.5
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 125.6
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 193.4
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 195.7
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 132.3
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 141.1
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 128.8
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 98.4
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 168.3
   },
   {
    "Region Name": "Kouilou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 107.8
   }
  ],
  "Koulikoro (Region of Mali)": [
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13632.6
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14859.2
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21199.6
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21333.4
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 21656.0
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21496.7
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17992.8
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14922.2
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15547.3
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13723.5
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13422.5
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14831.3
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14786.5
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17541.2
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12736.7
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12953.2
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11329.4
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12918.9
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12061.0
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13569.3
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15242.7
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12541.4
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13022.7
   },
   {
    "Region Name": "Koulikoro (Region of Mali)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14103.8
   }
  ],
  "Koungou (Commune of Mayotte)": [
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Koungou (Commune of Mayotte)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ko\u010dani (Municipality of North Macedonia)": [
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ko\u0161ick\u00fd (Region of Slovakia)": [
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ko\u0161ick\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.1
   }
  ],
  "Krabi (Province of Thailand)": [
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krabi (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Kraj Vyso\u010dina (Region of Czechia)": [
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kraj Vyso\u010dina (Region of Czechia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Krapinsko-Zagorska (County of Croatia)": [
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krapinsko-Zagorska (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Krasnodar (Territory of Russia)": [
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6869.0
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1135.3
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4677.3
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4889.1
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5554.9
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5896.6
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5425.5
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3569.2
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4680.1
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2107.2
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4148.3
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1872.3
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4476.0
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4874.5
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1046.1
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3841.9
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2343.3
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2601.8
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2919.5
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 962.3
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1401.5
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2183.3
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2193.2
   },
   {
    "Region Name": "Krasnodar (Territory of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2306.6
   }
  ],
  "Krasnoyarsk (Territory of Russia)": [
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2959.1
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5613.0
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6883.8
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4020.7
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9914.4
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2990.4
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9492.0
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3892.7
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2258.8
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9467.0
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18923.0
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8527.6
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6182.6
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2613.2
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22163.2
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7903.1
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8559.3
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17035.7
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4610.4
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1644.6
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4099.2
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1050.0
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 665.8
   },
   {
    "Region Name": "Krasnoyarsk (Territory of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 852.8
   }
  ],
  "Kratovo (Municipality of North Macedonia)": [
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kratovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kriva Palanka (Municipality of North Macedonia)": [
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Krivoga\u0161tani (Municipality of North Macedonia)": [
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Krong Pailin (Municipality of Cambodia)": [
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 448.0
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 489.8
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 451.9
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 371.9
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 354.1
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 236.2
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 446.3
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 265.8
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 244.4
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 141.9
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 144.5
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Krong Pailin (Municipality of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24.2
   }
  ],
  "Krong Preah Sihanouk (Municipality of Cambodia)": [
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 117.5
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 147.3
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 167.2
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 222.1
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 153.1
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 88.7
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 92.2
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 162.7
   },
   {
    "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.9
   }
  ],
  "Kronoberg (County of Sweden)": [
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kronoberg (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kru\u0161evo (Municipality of North Macedonia)": [
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.4
   }
  ],
  "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)": [
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kr\u00e1lov\u00e9hradeck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kr\u00e2ch\u00e9h (Province of Cambodia)": [
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3064.6
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3059.0
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3005.7
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3460.3
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3606.5
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2957.0
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3055.0
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2729.8
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3647.3
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2560.9
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3215.7
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2795.8
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3286.3
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3236.1
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2943.1
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3152.1
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2500.0
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2620.0
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2334.9
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1739.8
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1977.8
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1887.3
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2042.7
   },
   {
    "Region Name": "Kr\u00e2ch\u00e9h (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1498.7
   }
  ],
  "Kuala Lumpur (Federal Territory of Malaysia)": [
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kujalleq (Commune of Greenland)": [
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujalleq (Commune of Greenland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kujawsko-Pomorskie (Voivodeship of Poland)": [
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Kuk\u00ebs (County of Albania)": [
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 102.9
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Kuk\u00ebs (County of Albania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kumamoto (Prefecture of Japan)": [
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 80.0
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Kumamoto (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 33.4
   }
  ],
  "Kumanovo (Municipality of North Macedonia)": [
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Kumanovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Kumgangsan (Special Administrative Region of North Korea)": [
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kumi (District of Uganda)": [
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kumi (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kuna Yala (Indigenous Territory of Panama)": [
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Kunar (Province of Afghanistan)": [
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunar (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Kunduz (Province of Afghanistan)": [
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 84.0
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunduz (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kunene (Region of Namibia)": [
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 493.0
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 583.7
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 413.5
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5645.2
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2414.4
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 275.0
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1308.9
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2397.7
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 230.9
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 419.1
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 251.2
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 397.4
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5067.5
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 636.9
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 111.7
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Kunene (Region of Namibia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2008.2
   }
  ],
  "Kurgan (Region of Russia)": [
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 107.2
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 755.2
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2943.9
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 477.0
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1417.2
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 809.2
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3890.6
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 748.4
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1289.0
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 321.6
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1311.9
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 107.4
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 463.9
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 131.2
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 161.0
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 272.0
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 695.6
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 483.0
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 137.6
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2249.4
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1138.1
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 543.2
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Kurgan (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 92.8
   }
  ],
  "Kursk (Region of Russia)": [
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1382.7
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 88.5
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 772.4
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1695.2
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 506.6
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 833.7
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2302.8
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1783.6
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 383.1
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 119.6
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 119.2
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 232.2
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 618.7
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 280.4
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 122.4
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 137.2
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 287.5
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 100.8
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 227.9
   },
   {
    "Region Name": "Kursk (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 243.1
   }
  ],
  "Kurunegala (District of Sri Lanka)": [
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurunegala (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kurzeme (Province of Latvia)": [
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kurzeme (Province of Latvia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kusini Pemba (Region of Tanzania)": [
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Pemba (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Kusini Unguja (Region of Tanzania)": [
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kusini Unguja (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Kvemo Kartli (Region of Georgia)": [
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 141.9
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 75.5
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kvemo Kartli (Region of Georgia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "KwaZulu-Natal (Province of South Africa)": [
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10024.3
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8103.6
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7902.3
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11859.8
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10345.0
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11818.2
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9683.3
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10608.9
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10162.6
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9508.6
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9116.5
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10944.2
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9030.9
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4882.0
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3774.0
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7108.7
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7058.1
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8834.6
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8155.7
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8471.6
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5776.0
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7395.5
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11331.5
   },
   {
    "Region Name": "KwaZulu-Natal (Province of South Africa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5083.1
   }
  ],
  "Kwajalein (Atol of Marshall Islands)": [
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwajalein (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Kwale (County of Kenya)": [
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 236.0
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 272.7
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 627.5
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 266.0
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Kwale (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 25.3
   }
  ],
  "Kwango (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 34254.2
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 40193.1
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 42444.6
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 39021.6
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 42501.2
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 38492.7
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 40716.6
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 37358.3
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 40933.8
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 38946.6
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 34728.6
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 36900.8
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 37359.6
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33254.2
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 38374.8
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 35306.8
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 40034.3
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 37048.3
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38593.5
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 38491.5
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 37992.2
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 33966.8
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 35630.5
   },
   {
    "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 35567.0
   }
  ],
  "Kwara (State of Nigeria)": [
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8851.3
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7361.4
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8663.3
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4166.3
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4955.4
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5437.0
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3836.8
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3944.8
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3898.9
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2874.7
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3911.6
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2730.8
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1989.1
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4024.1
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2594.5
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1769.4
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2126.3
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2150.3
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1288.1
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 931.4
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 776.7
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 558.9
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 707.8
   },
   {
    "Region Name": "Kwara (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2165.1
   }
  ],
  "Kweneng (District of Botswana)": [
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9592.4
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 554.4
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 477.0
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4455.2
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 714.7
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1011.8
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11021.8
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 122.4
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12871.6
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6306.3
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1961.7
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2277.7
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 206.7
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1827.9
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 350.3
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5456.8
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 157.3
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 809.5
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3363.0
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6219.3
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9172.2
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2191.9
   },
   {
    "Region Name": "Kweneng (District of Botswana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 67.1
   }
  ],
  "Kwilu (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12386.7
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14857.3
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17800.1
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15416.1
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16304.3
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16191.1
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13690.2
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15504.0
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15663.5
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13597.9
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13874.0
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13513.0
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14093.3
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12055.9
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15876.8
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13618.4
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14036.5
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14219.1
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15256.9
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14182.9
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15849.2
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13047.8
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13657.9
   },
   {
    "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12399.1
   }
  ],
  "Kyenjojo (District of Uganda)": [
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 80.0
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 295.8
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 331.2
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 106.3
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 179.0
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 179.0
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 228.5
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 102.9
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 104.6
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 147.7
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 232.2
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Kyenjojo (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 89.2
   }
  ],
  "Kyoto (Urban Prefecture of Japan)": [
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyoto (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Kyustendil (Province of Bulgaria)": [
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Kyustendil (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.6
   }
  ],
  "K\u00e2mp\u00f3ng Cham (Province of Cambodia)": [
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 109.5
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Cham (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.7
   }
  ],
  "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)": [
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 222.1
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 196.6
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 282.5
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 194.2
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 109.8
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 186.1
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 153.9
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 225.5
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 185.2
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 256.6
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 76.5
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 263.5
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 292.6
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 285.5
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 205.6
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 244.4
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Chhnang (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 179.4
   }
  ],
  "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)": [
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1524.8
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1052.3
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1356.5
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 896.7
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1256.4
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1407.1
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1321.8
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1192.7
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1185.5
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 860.9
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 752.4
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 838.2
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 854.5
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1034.5
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 390.8
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1101.6
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 883.4
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 922.4
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 865.6
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 155.2
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 224.0
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 885.8
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1256.8
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Sp\u0153 (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 857.9
   }
  ],
  "K\u00e2mp\u00f3ng Thum (Province of Cambodia)": [
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 190.4
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 501.0
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 678.3
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 640.5
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 412.4
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 294.1
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 294.8
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 339.3
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 859.8
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 382.6
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 640.3
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 415.9
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 715.6
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1287.1
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 452.3
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 304.6
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 575.4
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 762.5
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 346.2
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 268.0
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 280.2
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 414.6
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 358.9
   },
   {
    "Region Name": "K\u00e2mp\u00f3ng Thum (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 149.8
   }
  ],
  "K\u00e2mp\u00f4t (Province of Cambodia)": [
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 413.7
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 383.1
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 373.6
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 132.3
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 345.6
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 294.5
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 206.0
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 191.9
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 270.1
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 89.6
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 262.8
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 245.2
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 279.8
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 337.0
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 169.8
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 198.3
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 113.8
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 92.8
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 152.4
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 198.3
   },
   {
    "Region Name": "K\u00e2mp\u00f4t (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 42.2
   }
  ],
  "K\u00e2ndal (Province of Cambodia)": [
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 180.9
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 102.0
   },
   {
    "Region Name": "K\u00e2ndal (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.4
   }
  ],
  "K\u00e4rnten (State of Austria)": [
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "K\u00e4rnten (State of Austria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "K\u00e9dougou (Region of Senegal)": [
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7562.5
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6345.1
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7109.3
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7312.6
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7625.5
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7303.6
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7119.0
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6722.2
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6905.7
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6768.5
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6155.0
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5472.4
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5975.3
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5804.7
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5603.6
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6187.5
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4894.0
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5756.5
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6510.4
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5997.4
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6188.8
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5996.5
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5702.9
   },
   {
    "Region Name": "K\u00e9dougou (Region of Senegal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5244.5
   }
  ],
  "K\u00e9mo (Prefecture of Central African Republic)": [
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2238.2
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2534.5
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2420.9
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1919.7
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3124.0
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2594.9
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2334.7
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2148.2
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2664.2
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3292.5
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2189.1
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1750.5
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1553.1
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3234.0
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2232.2
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1839.9
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2196.2
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2452.4
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1456.0
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3332.4
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2224.7
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1480.6
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2027.5
   },
   {
    "Region Name": "K\u00e9mo (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 796.0
   }
  ],
  "K\u00fctahya (Province of Turkey)": [
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "K\u00fctahya (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.4
   }
  ],
  "L'Artibonite (Department of Haiti)": [
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "L'Artibonite (Department of Haiti)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.4
   }
  ],
  "L'viv (Region of Ukraine)": [
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 111.5
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 104.4
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 156.1
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 607.7
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 708.9
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 459.2
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 242.2
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 620.2
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 231.7
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 440.1
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 290.9
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 65.4
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 212.7
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 353.5
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 415.0
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "L'viv (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.7
   }
  ],
  "La Altagracia (Province of Dominican Republic)": [
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "La Altagracia (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.6
   }
  ],
  "La Digue and Inner Islands (District of Seychelles)": [
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Digue and Inner Islands (District of Seychelles)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "La Estrelleta (Province of Dominican Republic)": [
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "La Estrelleta (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.3
   }
  ],
  "La Guajira (Department of Colombia)": [
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 171.7
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 301.0
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 88.5
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 115.8
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 201.3
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 112.8
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 130.8
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 145.6
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 112.1
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "La Guajira (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.8
   }
  ],
  "La Habana (Province of Cuba)": [
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "La Habana (Province of Cuba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.8
   }
  ],
  "La Libertad (Department of El Salvador)": [
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "La Libertad (Department of El Salvador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "La Libertad (Region of Peru)": [
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 119.4
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 135.1
   },
   {
    "Region Name": "La Libertad (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 57.2
   }
  ],
  "La Pampa (Province of Argentina)": [
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9306.0
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1896.5
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2556.1
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2326.1
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 565.5
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 470.8
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1864.8
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 191.0
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 290.7
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1021.9
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 142.8
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4340.3
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2352.3
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 910.6
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12317.0
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8384.2
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2055.6
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 864.6
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1075.1
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 561.0
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1824.1
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 770.7
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 445.2
   },
   {
    "Region Name": "La Pampa (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1974.8
   }
  ],
  "La Paz (Department of Bolivia)": [
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1210.3
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1296.7
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1773.5
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2117.8
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2057.5
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4126.4
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2299.3
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 640.7
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6879.1
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 710.0
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2222.6
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 818.5
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1010.1
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 938.7
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3209.7
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2057.3
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 992.5
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3114.4
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2458.6
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2530.2
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1505.1
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5039.0
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5201.9
   },
   {
    "Region Name": "La Paz (Department of Bolivia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 742.4
   }
  ],
  "La Paz (Department of El Salvador)": [
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "La Paz (Department of El Salvador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.8
   }
  ],
  "La Paz (Department of Honduras)": [
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "La Paz (Department of Honduras)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "La Rioja (Autonomous Community of Spain)": [
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Rioja (Autonomous Community of Spain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "La Rioja (Province of Argentina)": [
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 332.7
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 899.5
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 324.6
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 105.7
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 227.4
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 156.1
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 169.6
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 170.4
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 219.1
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1052.8
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 104.4
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 88.5
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 236.7
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 425.5
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 120.7
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 293.5
   },
   {
    "Region Name": "La Rioja (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 181.6
   }
  ],
  "La Romana (Province of Dominican Republic)": [
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "La Romana (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "La Union (Province of Philippines)": [
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Union (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "La Uni\u00f3n (Department of El Salvador)": [
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "La Uni\u00f3n (Department of El Salvador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "La Vega (Province of Dominican Republic)": [
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La Vega (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Laayoune (Province of Western Sahara)": [
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laayoune (Province of Western Sahara)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Laborie (Quarter of Saint Lucia)": [
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laborie (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Labuan (Federal Territory of Malaysia)": [
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Labuan (Federal Territory of Malaysia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lab\u00e9 (Region of Guinea)": [
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3858.9
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3286.9
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3005.9
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3883.1
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3524.4
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3333.0
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3237.0
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4245.6
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3764.3
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3724.0
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3469.6
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3710.9
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4431.4
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5104.8
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3155.5
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4527.7
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3486.9
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4487.0
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4523.4
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3140.7
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4051.8
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4028.6
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3734.7
   },
   {
    "Region Name": "Lab\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3754.2
   }
  ],
  "Lac (Region of Chad)": [
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1271.0
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1158.2
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1660.7
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1598.3
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1430.7
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1110.4
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1317.7
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1356.1
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1194.0
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1204.8
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 684.7
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 457.9
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 731.0
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 977.1
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1521.6
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1360.4
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 909.4
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 936.1
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 435.0
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 269.5
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 272.7
   },
   {
    "Region Name": "Lac (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 142.6
   }
  ],
  "Lacs (District of C\u00f4te d'Ivoire)": [
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2416.4
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1974.8
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1496.7
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1972.6
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2469.7
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3635.5
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1259.0
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1478.5
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1209.3
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1875.7
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1971.8
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2116.9
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1826.4
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3319.1
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2537.1
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1797.5
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1600.3
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2002.8
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1137.9
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1310.4
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 393.6
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 504.8
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1022.8
   },
   {
    "Region Name": "Lacs (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1195.3
   }
  ],
  "Lae (Atol of Marshall Islands)": [
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Laghman (Province of Afghanistan)": [
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghman (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Laghouat (Province of Algeria)": [
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laghouat (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lago Nicaragua (Water body of Nicaragua)": [
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Lagos (State of Nigeria)": [
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 137.2
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 51.9
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Lagos (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.5
   }
  ],
  "Laguna (Province of Philippines)": [
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Laguna (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Lagunes (District of C\u00f4te d'Ivoire)": [
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 229.8
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 137.8
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 133.8
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 495.0
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 397.2
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 179.0
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 271.6
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 181.8
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 249.7
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Lagunes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 71.6
   }
  ],
  "Lahij (Governorate of Yemen)": [
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lahij (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lai Ch\u00e2u (Province of Vietnam)": [
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 104.6
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1083.2
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 777.9
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 442.9
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 949.2
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 870.8
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 387.8
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 478.7
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 618.2
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 216.7
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 305.3
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 272.7
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 238.8
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 151.1
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 177.5
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 112.8
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 144.3
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Lai Ch\u00e2u (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.1
   }
  ],
  "Laikipia (County of Kenya)": [
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 106.8
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 144.9
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Laikipia (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.2
   }
  ],
  "Lajas (Municipality of Puerto Rico)": [
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lajas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Lake Albert (Water body of Uganda)": [
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Lake Albert (Water body of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16.7
   }
  ],
  "Lake Ohrid (Water body of North Macedonia)": [
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Ohrid (Water body of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lake Victoria (Water body of Uganda)": [
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Lake Victoria (Water body of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Lakes (State of South Sudan)": [
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23467.6
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19073.9
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23504.9
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24256.9
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 21547.1
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22129.3
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19807.1
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 25591.6
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21209.0
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22658.8
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 23525.7
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20042.0
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20185.4
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24664.7
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22142.6
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21689.0
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25636.8
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19361.0
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19357.1
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 19947.9
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19287.0
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 20134.8
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15233.1
   },
   {
    "Region Name": "Lakes (State of South Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16403.3
   }
  ],
  "Lakshadweep (Union Territory of India)": [
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lakshadweep (Union Territory of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lambayeque (Region of Peru)": [
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 108.3
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 78.0
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Lambayeque (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.2
   }
  ],
  "Lampang (Province of Thailand)": [
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 460.9
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 433.9
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 163.6
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 359.1
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 192.5
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 361.0
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 215.4
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 236.9
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 325.4
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 313.0
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 273.3
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 442.7
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 322.8
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 679.1
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 845.7
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 379.0
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 337.4
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 225.1
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 391.2
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 159.3
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 621.5
   },
   {
    "Region Name": "Lampang (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 124.3
   }
  ],
  "Lamphun (Province of Thailand)": [
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 168.9
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 605.6
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 488.5
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 145.3
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 504.8
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 151.8
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 523.3
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 370.9
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 170.9
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 293.3
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 353.1
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 296.9
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 521.6
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 234.9
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 580.3
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 799.4
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 261.3
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 273.1
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 221.0
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 281.9
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 383.1
   },
   {
    "Region Name": "Lamphun (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 190.4
   }
  ],
  "Lampung (Province of Indonesia)": [
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1081.7
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 373.4
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 787.4
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 205.6
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1188.9
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 329.1
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 283.8
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 354.8
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 436.7
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 540.0
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 642.5
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 705.1
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 274.4
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 943.2
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 386.9
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Lampung (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Lamu (County of Kenya)": [
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 662.8
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 547.7
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 646.3
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 429.0
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 477.8
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1174.3
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 657.0
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 204.9
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 429.6
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 221.9
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 175.1
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 427.5
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 511.1
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 151.3
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 119.8
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 470.3
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 667.8
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 267.7
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 223.4
   },
   {
    "Region Name": "Lamu (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 207.3
   }
  ],
  "Lanao del Norte (Province of Philippines)": [
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lanao del Sur (Province of Philippines)": [
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lanao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lankaran (Region of Azerbaijan)": [
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 340.8
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 235.4
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 167.4
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 323.5
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 91.7
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 122.8
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 177.9
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 158.4
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Lankaran (Region of Azerbaijan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.7
   }
  ],
  "Laois (County of Ireland)": [
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laois (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lapland (Province of Finland)": [
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lapland (Province of Finland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Lara (State of Venezuela)": [
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 186.3
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 126.0
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 138.1
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Lara (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.6
   }
  ],
  "Lares (Municipality of Puerto Rico)": [
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lares (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Larnaca (District of Cyprus)": [
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Larnaca (District of Cyprus)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Las Mar\u00edas (Municipality of Puerto Rico)": [
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Mar\u00edas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Las Piedras (Municipality of Puerto Rico)": [
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Las Piedras (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Las Tunas (Province of Cuba)": [
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 206.2
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 405.2
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 460.9
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 114.5
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 262.2
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 192.9
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 159.3
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 413.1
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 231.7
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 198.3
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 215.9
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 147.9
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 140.4
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 156.3
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 126.7
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 117.3
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 189.1
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 191.6
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 133.1
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 310.0
   },
   {
    "Region Name": "Las Tunas (Province of Cuba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 166.4
   }
  ],
  "Latgale (Province of Latvia)": [
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Latgale (Province of Latvia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lattakia (Governorate of Syria)": [
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 269.0
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 109.8
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Lattakia (Governorate of Syria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 208.2
   }
  ],
  "Laut\u00e9m (District of Timor-Leste)": [
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Laut\u00e9m (District of Timor-Leste)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lavalleja (Department of Uruguay)": [
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Lavalleja (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.2
   }
  ],
  "Lazio (Region of Italy)": [
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Lazio (Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.7
   }
  ],
  "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)": [
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "La\u00e2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Le Kef (Governorate of Tunisia)": [
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Kef (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Le Marin (Arrondissement of Martinique)": [
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Marin (Arrondissement of Martinique)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Le Trinit\u00e9 (Arrondissement of Martinique)": [
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Le Trinit\u00e9 (Arrondissement of Martinique)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lebap (Province of Turkmenistan)": [
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 161.8
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 161.4
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 329.7
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 156.5
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 108.3
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 178.6
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 56.0
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 162.7
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 678.5
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 191.6
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Lebap (Province of Turkmenistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 556.9
   }
  ],
  "Leiria (District of Portugal)": [
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 80.0
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 223.8
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 553.9
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Leiria (District of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.5
   }
  ],
  "Leitrim (County of Ireland)": [
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leitrim (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lempira (Department of Honduras)": [
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lempira (Department of Honduras)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Leningrad (Region of Russia)": [
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 675.7
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 651.9
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 236.4
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 253.6
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1009.5
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 396.6
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 442.7
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 223.4
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 198.5
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 246.5
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 88.5
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 356.3
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 330.1
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 148.6
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 334.8
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 119.6
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Leningrad (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Leova (District of Moldova)": [
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leova (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Leribe (District of Lesotho)": [
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 105.5
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 145.3
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 81.7
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Leribe (District of Lesotho)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.2
   }
  ],
  "Leyte (Province of Philippines)": [
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Leyte (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lezayre (Parish District of Isle of Man)": [
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezayre (Parish District of Isle of Man)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lezh\u00eb (County of Albania)": [
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 145.6
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Lezh\u00eb (County of Albania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.2
   }
  ],
  "Le\u00f3n (Department of Nicaragua)": [
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 265.6
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 152.4
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 260.0
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 151.8
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 165.1
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 128.8
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 83.8
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 143.4
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 123.3
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 152.8
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 111.9
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 156.1
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 182.2
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 131.8
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 92.2
   },
   {
    "Region Name": "Le\u00f3n (Department of Nicaragua)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 105.0
   }
  ],
  "Lhuentse (District of Bhutan)": [
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lhuentse (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Liaoning (Province of China)": [
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 358.4
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 374.9
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 166.6
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 345.3
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 181.1
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 242.5
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 484.0
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 374.9
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 304.2
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 287.7
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 262.8
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 247.6
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 257.9
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 109.5
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 213.1
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 438.6
   },
   {
    "Region Name": "Liaoning (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 135.9
   }
  ],
  "Lib (Island of Marshall Islands)": [
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lib (Island of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Libereck\u00fd (Region of Czechia)": [
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Libereck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Libertador General Bernardo O'Hi (Region of Chile)": [
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 103.3
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 65.4
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 97.3
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 766.2
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 23.8
   }
  ],
  "Licko-Senjska (County of Croatia)": [
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Licko-Senjska (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Liguria (Region of Italy)": [
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liguria (Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Likiep (Atol of Marshall Islands)": [
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likiep (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Likoma (District of Malawi)": [
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Likoma (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Likouala (Region of Republic of the Congo)": [
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 547.7
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 477.6
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 366.6
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 579.0
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 369.1
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 392.3
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 446.1
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 913.4
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 618.9
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 898.4
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 385.6
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 429.6
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 775.8
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 346.0
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 341.1
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 653.0
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 586.7
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 594.7
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 755.9
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 492.6
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 506.8
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1131.9
   },
   {
    "Region Name": "Likouala (Region of Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 768.9
   }
  ],
  "Lilongwe (District of Malawi)": [
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 99.0
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 117.7
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 114.3
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 123.7
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 118.1
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 97.3
   },
   {
    "Region Name": "Lilongwe (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 66.0
   }
  ],
  "Lima (Region of Peru)": [
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Lima (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 33.2
   }
  ],
  "Lima Province (Province of Peru)": [
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lima Province (Province of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Limassol (District of Cyprus)": [
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Limassol (District of Cyprus)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 109.1
   }
  ],
  "Limburg (Province of Netherlands)": [
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limburg (Province of Netherlands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Limerick (County of Ireland)": [
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Limerick (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Limpopo (Province of South Africa)": [
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6062.6
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2649.2
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4128.7
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5427.8
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4349.5
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3619.8
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7362.3
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3556.0
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5563.5
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4986.0
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4044.7
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3640.8
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5890.9
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3731.3
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 871.0
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2407.4
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2525.9
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2370.7
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1333.8
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4934.1
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4000.3
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6869.0
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4915.7
   },
   {
    "Region Name": "Limpopo (Province of South Africa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3662.1
   }
  ],
  "Lim\u00f3n (Province of Costa Rica)": [
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Lim\u00f3n (Province of Costa Rica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lindi (Region of Tanzania)": [
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12207.9
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19300.9
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13605.8
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19323.7
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10815.8
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16721.4
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18177.2
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20346.8
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20544.3
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16520.3
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20880.4
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18795.0
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16213.8
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20410.9
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16064.8
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15592.8
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14291.3
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16408.4
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11883.3
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12592.7
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10786.2
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9350.1
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6474.6
   },
   {
    "Region Name": "Lindi (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8504.9
   }
  ],
  "Lipetsk (Region of Russia)": [
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1238.4
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 207.5
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1392.5
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1342.6
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 530.6
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 668.2
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2342.8
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1372.6
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 516.2
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 56.0
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 231.5
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 423.2
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 75.5
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Lipetsk (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 57.7
   }
  ],
  "Lipkovo (Municipality of North Macedonia)": [
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Lipkovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.9
   }
  ],
  "Liqui\u00e7\u00e1 (District of Timor-Leste)": [
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Liqui\u00e7\u00e1 (District of Timor-Leste)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lira (District of Uganda)": [
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 583.1
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 993.2
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 948.4
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1262.0
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 337.0
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 472.0
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 239.2
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 158.8
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 134.8
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 204.9
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 111.3
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 109.3
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Lira (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.3
   }
  ],
  "Lisboa (District of Portugal)": [
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lisboa (District of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Litoral (Province of Equatorial Guinea)": [
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Litoral (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Littoral (Department of Benin)": [
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Littoral (Department of Benin)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Littoral (Region of Cameroon)": [
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 101.4
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 93.7
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 150.3
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 89.2
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 139.1
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 247.2
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 65.4
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 78.0
   },
   {
    "Region Name": "Littoral (Region of Cameroon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 31.7
   }
  ],
  "Lobaye (Prefecture of Central African Republic)": [
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3355.5
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2235.4
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2765.1
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2716.3
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3112.4
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3054.5
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2356.1
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2675.3
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3199.7
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3826.3
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2623.0
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2965.8
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2466.1
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3125.7
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2303.2
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2519.3
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3382.1
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2176.9
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1405.6
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1759.5
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2053.9
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 984.6
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 973.2
   },
   {
    "Region Name": "Lobaye (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 347.7
   }
  ],
  "Loei (Province of Thailand)": [
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 524.8
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 832.2
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1087.7
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 581.6
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 927.8
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 450.2
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 419.3
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 644.0
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 775.4
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 189.5
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 380.1
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 459.6
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 299.9
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 142.3
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 371.7
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 148.6
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 140.2
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 279.5
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 227.2
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 197.9
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Loei (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.8
   }
  ],
  "Lofa (County of Liberia)": [
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 217.4
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 582.9
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 279.8
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 119.2
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 388.4
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 266.9
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 199.8
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 95.8
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 268.4
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1288.1
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1380.1
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 84.0
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 117.0
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 553.7
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 176.2
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 148.6
   },
   {
    "Region Name": "Lofa (County of Liberia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30.4
   }
  ],
  "Logar (Province of Afghanistan)": [
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Logar (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Logone Occidental (Region of Chad)": [
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2711.1
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2210.1
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1742.6
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1892.7
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1985.5
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1561.7
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1791.1
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1408.6
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1268.2
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1987.8
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 948.4
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 740.2
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 468.0
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1111.9
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1066.7
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 890.7
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 316.4
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 361.2
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 628.3
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 261.3
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 705.3
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 261.3
   },
   {
    "Region Name": "Logone Occidental (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 51.9
   }
  ],
  "Logone Oriental (Region of Chad)": [
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10703.0
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8383.1
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6342.5
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8054.3
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8969.4
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7920.1
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5528.1
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6174.7
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4626.1
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7763.8
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5041.3
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3640.4
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4180.6
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6592.3
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5752.6
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3555.1
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3287.3
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3275.1
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4695.3
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2620.9
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1430.7
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2645.7
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2643.4
   },
   {
    "Region Name": "Logone Oriental (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2373.3
   }
  ],
  "Loja (Province of Ecuador)": [
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 96.7
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 188.0
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 131.4
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 153.5
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 108.0
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 114.7
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 158.2
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 160.1
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 140.4
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 359.9
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 244.4
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 293.7
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 248.5
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 250.6
   },
   {
    "Region Name": "Loja (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.2
   }
  ],
  "Lomami (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17084.6
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17677.5
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22265.2
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19891.7
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19683.1
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14472.3
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17805.3
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18367.6
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19433.2
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15949.9
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13001.3
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 17353.8
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17607.0
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16632.7
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16705.8
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16770.5
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16325.9
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15249.8
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15927.2
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16651.5
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16720.4
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17267.9
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19311.2
   },
   {
    "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15418.9
   }
  ],
  "Lombardia (Region of Italy)": [
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Lombardia (Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Long An (Province of Vietnam)": [
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 221.7
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 257.2
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 355.4
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 168.9
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 368.3
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 399.8
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 763.6
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 752.0
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 335.7
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1799.8
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 578.2
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1540.2
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1916.7
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 725.2
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 736.8
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1517.3
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1596.0
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 797.7
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 653.6
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 148.1
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1204.1
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1373.2
   },
   {
    "Region Name": "Long An (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 763.4
   }
  ],
  "Long Island (District of Bahamas)": [
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Long Island (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Longford (County of Ireland)": [
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Longford (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lop Buri (Province of Thailand)": [
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 235.2
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 411.2
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 494.3
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 192.9
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 135.1
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 267.3
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 165.9
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 225.1
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 197.0
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 262.6
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 466.9
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 336.1
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 378.1
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 216.9
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 437.3
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 261.5
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 286.0
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 275.0
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 171.3
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 148.8
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 137.4
   },
   {
    "Region Name": "Lop Buri (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 230.9
   }
  ],
  "Lorestan (Province of Iran)": [
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 307.6
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 152.4
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 243.7
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 707.0
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 90.2
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 210.1
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 102.0
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 151.1
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 94.3
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 161.0
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 822.5
   },
   {
    "Region Name": "Lorestan (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 197.9
   }
  ],
  "Loreto (Region of Peru)": [
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 127.1
   },
   {
    "Region Name": "Loreto (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.8
   }
  ],
  "Lori (Province of Armenia)": [
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 126.9
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lori (Province of Armenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 50.6
   }
  ],
  "Los Lagos (Region of Chile)": [
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 244.4
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Los Lagos (Region of Chile)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.2
   }
  ],
  "Los Rios (Province of Ecuador)": [
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 289.2
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 132.1
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Los Rios (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Los R\u00edos (Region of Chile)": [
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Los R\u00edos (Region of Chile)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Los Santos (Province of Panama)": [
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 96.0
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 188.4
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 129.5
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Los Santos (Province of Panama)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Louang Namtha (Province of Laos)": [
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 114.9
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 192.9
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 397.2
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 296.9
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 696.9
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 172.1
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 237.9
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 434.1
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 217.4
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 210.5
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 105.0
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 231.7
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 122.6
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 877.8
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 92.4
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 228.3
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 244.4
   },
   {
    "Region Name": "Louang Namtha (Province of Laos)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 51.7
   }
  ],
  "Louangphrabang (Province of Laos)": [
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 310.2
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 520.3
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3000.1
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 502.9
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 557.1
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1927.2
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 200.2
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 679.1
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2040.6
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 154.3
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1087.5
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 930.6
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 677.4
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 973.2
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1250.2
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 418.9
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 174.3
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 552.6
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2002.8
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 520.3
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 252.5
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2742.9
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1690.7
   },
   {
    "Region Name": "Louangphrabang (Province of Laos)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 204.5
   }
  ],
  "Louga (Region of Senegal)": [
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 712.8
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 222.3
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 399.2
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2213.6
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1254.7
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 373.9
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 520.1
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 299.9
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 775.8
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 565.1
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 118.3
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 795.7
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 152.4
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 244.0
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 148.3
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 262.2
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Louga (Region of Senegal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 206.2
   }
  ],
  "Louisiana (State of United States)": [
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 411.2
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1000.9
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 669.0
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1372.4
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 890.1
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 821.9
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 899.5
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 302.9
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1768.3
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 985.0
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 738.9
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 965.5
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1058.3
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 866.3
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 880.0
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 676.8
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 407.5
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1528.9
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 689.6
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 974.7
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 885.6
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1581.4
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 798.1
   },
   {
    "Region Name": "Louisiana (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1057.5
   }
  ],
  "Louth (County of Ireland)": [
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Louth (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lovech (Province of Bulgaria)": [
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Lovech (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Lower River (Division of Gambia)": [
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 254.7
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 772.2
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 444.4
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 627.5
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 426.8
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 396.4
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 354.4
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 544.3
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 473.8
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 370.0
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 394.0
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 334.4
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 481.0
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 394.0
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 505.9
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 459.4
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 416.9
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 444.2
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 457.7
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 424.9
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 272.7
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 464.5
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 508.5
   },
   {
    "Region Name": "Lower River (Division of Gambia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 339.1
   }
  ],
  "Lozovo (Municipality of North Macedonia)": [
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lozovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lo\u00edza (Municipality of Puerto Rico)": [
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lo\u00edza (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lualaba (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 44396.2
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 47957.1
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 46758.0
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 47767.0
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 49318.6
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 43937.7
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 47102.0
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 48396.8
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 47209.4
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 43295.5
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 45856.1
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 46756.5
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 41996.4
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 45500.2
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 46556.4
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 46031.7
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 43006.5
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 47730.8
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 43500.6
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 43730.8
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 44221.3
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 43479.4
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 42487.9
   },
   {
    "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 42600.1
   }
  ],
  "Luanda (Province of Angola)": [
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 189.7
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 180.9
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 158.4
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 132.5
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 116.4
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Luanda (Province of Angola)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 99.9
   }
  ],
  "Luapula (Province of Zambia)": [
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 20643.3
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 23413.0
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22938.3
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 23462.9
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 24165.0
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23100.2
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24699.6
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 22461.4
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 24662.1
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 24453.7
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24345.2
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 25826.1
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23755.3
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25371.4
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 24606.3
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24048.1
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22306.6
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23844.3
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22068.0
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 24123.8
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22705.3
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21392.5
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23058.8
   },
   {
    "Region Name": "Luapula (Province of Zambia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 23098.5
   }
  ],
  "Lubelskie (Voivodeship of Poland)": [
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lubelskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lubombo (District of Swaziland)": [
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 308.3
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 216.7
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 294.8
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 340.0
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 155.0
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 417.8
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 236.4
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 191.9
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 481.7
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 375.4
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 318.1
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 414.8
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 310.0
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 192.7
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 142.6
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 165.5
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 209.0
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 371.3
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 239.9
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 353.9
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 228.7
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 257.2
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 321.6
   },
   {
    "Region Name": "Lubombo (District of Swaziland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 177.1
   }
  ],
  "Lubuskie (Voivodeship of Poland)": [
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Lubuskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Lucerne (Canton of Switzerland)": [
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Lucerne (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Luhans'k (Region of Ukraine)": [
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1013.1
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 262.4
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 400.7
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1661.1
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1338.1
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2731.7
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3232.9
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1107.0
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1099.5
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 266.9
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 565.1
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 199.4
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2583.1
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 946.0
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 630.2
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2054.9
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1558.5
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 767.0
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1997.3
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 237.9
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 818.9
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 538.9
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1844.0
   },
   {
    "Region Name": "Luhans'k (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1387.6
   }
  ],
  "Lunda Norte (Province of Angola)": [
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 55139.4
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 59844.5
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 59841.7
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 58412.6
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 62591.9
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 55871.0
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 58015.1
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 60392.9
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 61006.8
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 58658.4
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 58253.3
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 56312.2
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 56087.3
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 55740.2
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 58699.4
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 59547.2
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 47579.6
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 55500.3
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 54405.8
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 55202.2
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 54060.0
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 51888.2
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 50478.3
   },
   {
    "Region Name": "Lunda Norte (Province of Angola)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 52345.7
   }
  ],
  "Lunda Sul (Province of Angola)": [
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 43784.4
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 44370.1
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 45126.8
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 42716.2
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 43341.6
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 41000.6
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 41949.4
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 43787.2
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 42460.9
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 41999.4
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 39278.2
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 41772.4
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 41146.8
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 39798.2
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 42183.5
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 41585.2
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 36642.1
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 40911.3
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 39915.5
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 38335.6
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 38605.5
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 37659.1
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 39191.4
   },
   {
    "Region Name": "Lunda Sul (Province of Angola)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 38240.9
   }
  ],
  "Luquillo (Municipality of Puerto Rico)": [
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luquillo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Lusaka (Province of Zambia)": [
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4834.4
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5623.3
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6534.6
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6610.5
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4676.0
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7379.9
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6198.5
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4692.5
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6288.3
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5221.2
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5852.7
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5518.5
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6112.7
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7130.3
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6656.6
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3894.2
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7050.8
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5811.1
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3921.5
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4290.6
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6874.6
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4098.1
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4721.0
   },
   {
    "Region Name": "Lusaka (Province of Zambia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4082.9
   }
  ],
  "Luwero (District of Uganda)": [
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 91.3
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 206.9
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 132.7
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 144.1
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 62.6
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 134.4
   },
   {
    "Region Name": "Luwero (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.6
   }
  ],
  "Luxembourg (District of Luxembourg)": [
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Luxembourg (District of Luxembourg)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "L\u00e0o Cai (Province of Vietnam)": [
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e0o Cai (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)": [
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 116.0
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 135.3
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 128.4
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 108.3
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "L\u00e2m \u0110\u1ed3ng (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.6
   }
  ],
  "L\u00e4\u00e4ne (County of Estonia)": [
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne (County of Estonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "L\u00e4\u00e4ne-Viru (County of Estonia)": [
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "L\u00e4\u00e4ne-Viru (County of Estonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "L\u00e9koumou (Region of Republic of the Congo)": [
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 373.6
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 201.9
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 374.9
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 375.1
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 824.2
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 299.7
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1103.1
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 233.7
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 391.2
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 814.4
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 390.8
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 623.4
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 471.0
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 384.1
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 930.6
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 718.1
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 505.3
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 793.6
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 394.4
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 610.3
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 853.8
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 632.2
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1039.0
   },
   {
    "Region Name": "L\u00e9koumou (Region of Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 550.7
   }
  ],
  "L\u1ea1ng S\u01a1n (Province of Vietnam)": [
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "L\u1ea1ng S\u01a1n (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.6
   }
  ],
  "M'Sila (Province of Algeria)": [
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'Sila (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "M'tsangamouji (Commune of Mayotte)": [
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M'tsangamouji (Commune of Mayotte)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ma'rib (Governorate of Yemen)": [
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma'rib (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ma`an (Province of Jordan)": [
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma`an (Province of Jordan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Macau (Special Administrative Region of China)": [
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Macau (Special Administrative Region of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Maccarthy Island (Division of Gambia)": [
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 265.6
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 202.6
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 373.4
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 550.3
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 620.4
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 584.8
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 552.6
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 612.0
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 502.9
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 566.4
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 276.1
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 428.3
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 208.6
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 192.5
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 413.3
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 368.1
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 244.6
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 376.0
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 335.7
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 293.9
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 245.0
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 557.4
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 280.6
   },
   {
    "Region Name": "Maccarthy Island (Division of Gambia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 238.4
   }
  ],
  "Macedonia and Thrace (Decentralized administration of Greece)": [
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 189.5
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 138.9
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 110.4
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 278.5
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 113.4
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 88.7
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 121.3
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 117.0
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 959.3
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 89.2
   },
   {
    "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.4
   }
  ],
  "Machakos (County of Kenya)": [
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Machakos (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Machinga (District of Malawi)": [
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 163.1
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 222.7
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 243.7
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 353.3
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 346.0
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 349.4
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 322.8
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 182.0
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 333.1
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 418.7
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 420.4
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 377.5
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 351.1
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 181.8
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 472.5
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 423.2
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 592.9
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 356.3
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 359.5
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 374.5
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 209.7
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 92.2
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 148.6
   },
   {
    "Region Name": "Machinga (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 102.3
   }
  ],
  "Madaba (Province of Jordan)": [
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madaba (Province of Jordan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Madang (Province of Papua New Guinea)": [
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 363.6
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 203.0
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 454.9
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 245.9
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 247.4
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 274.6
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 300.1
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 192.3
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 322.8
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 247.8
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 229.2
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 283.4
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 259.8
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 575.4
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 164.4
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 306.5
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 217.4
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 219.5
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 218.9
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 251.9
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 206.9
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 271.4
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 150.7
   },
   {
    "Region Name": "Madang (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 154.1
   }
  ],
  "Madeira ('Autonomous Region' of Portugal)": [
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Madeira ('Autonomous Region' of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Madhya Pradesh (State of India)": [
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 429.2
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 536.4
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2370.5
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1438.8
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 484.0
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2731.5
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4629.7
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4805.3
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4214.3
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6423.8
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6262.8
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2804.6
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3394.3
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2714.8
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4633.4
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10539.0
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6628.7
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7956.9
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9472.5
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11887.0
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12695.4
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5373.4
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5679.1
   },
   {
    "Region Name": "Madhya Pradesh (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10458.0
   }
  ],
  "Madinat ash Shamal (Municipality of Qatar)": [
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Madre de Dios (Region of Peru)": [
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 56.0
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 89.4
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 180.7
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 126.7
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 111.9
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 85.7
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 127.8
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 179.2
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 104.6
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 444.4
   },
   {
    "Region Name": "Madre de Dios (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 37.3
   }
  ],
  "Madriz (Department of Nicaragua)": [
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Madriz (Department of Nicaragua)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Mae Hong Son (Province of Thailand)": [
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 606.4
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1762.1
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3815.8
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 932.3
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2097.6
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3023.5
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2781.9
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2046.6
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1240.3
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1333.6
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3106.4
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 917.7
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3478.1
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2532.6
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1466.3
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1637.4
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1211.6
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2696.8
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2531.7
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1370.5
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 712.8
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 836.9
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1118.8
   },
   {
    "Region Name": "Mae Hong Son (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 237.7
   }
  ],
  "Maekel (Region of Eritrea)": [
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Maekel (Region of Eritrea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mafeteng (District of Lesotho)": [
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Mafeteng (District of Lesotho)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mafraq (Province of Jordan)": [
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mafraq (Province of Jordan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Magadan (Region of Russia)": [
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 432.8
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7268.2
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 223.6
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 320.1
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 341.7
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 907.9
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5313.6
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5005.7
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 293.7
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 234.3
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 958.9
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 159.1
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 585.9
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 627.7
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1185.5
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1651.3
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1234.8
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3265.5
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 459.0
   },
   {
    "Region Name": "Magadan (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.6
   }
  ],
  "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)": [
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 149.4
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 186.9
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Magallanes y Ant\u00e1rtica Chilena (Region of Chile)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Magdalena (Department of Colombia)": [
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 237.1
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 210.9
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 259.2
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 74.4
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 94.3
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 149.6
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 127.8
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 141.1
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 122.4
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 109.5
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Magdalena (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.1
   }
  ],
  "Maguindanao (Province of Philippines)": [
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Maguindanao (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Magway (Division of Myanmar)": [
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2417.9
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8219.1
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7006.7
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2510.3
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4195.4
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4929.4
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8018.5
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4405.1
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4708.0
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6312.5
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4076.9
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3513.9
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3828.6
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3569.0
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3345.4
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3347.2
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3260.6
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2758.1
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4069.6
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2615.1
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4284.4
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2179.3
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6213.1
   },
   {
    "Region Name": "Magway (Division of Myanmar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6436.2
   }
  ],
  "Maha Sarakham (Province of Thailand)": [
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 90.2
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 156.5
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Maha Sarakham (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 17.8
   }
  ],
  "Mahaica-Berbice (Region of Guyana)": [
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 72.7
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 371.1
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 152.0
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 159.1
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 384.6
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 120.7
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 147.1
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 140.8
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 298.2
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 593.4
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 476.8
   },
   {
    "Region Name": "Mahaica-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 170.6
   }
  ],
  "Mahajanga (NA of Madagascar)": [
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8289.9
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12027.6
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9368.8
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16429.2
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11230.8
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12630.8
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7549.2
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12188.6
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12037.5
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10209.5
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10808.5
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11824.4
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9638.2
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8933.2
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12964.6
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8670.6
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9940.9
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11236.4
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12879.3
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9168.1
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9549.9
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7814.2
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12568.7
   },
   {
    "Region Name": "Mahajanga (NA of Madagascar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8000.7
   }
  ],
  "Maharashtra (State of India)": [
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1091.4
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1596.2
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2949.5
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1123.1
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 244.8
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2921.0
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2324.2
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4267.2
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2272.3
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3370.1
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4190.5
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3570.7
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 996.0
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1940.7
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1400.5
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3517.8
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3858.0
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1752.9
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 579.0
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4027.8
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2584.9
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 532.3
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 943.9
   },
   {
    "Region Name": "Maharashtra (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1103.1
   }
  ],
  "Mahdia (Governorate of Tunisia)": [
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mahdia (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mai-Ndombe (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3998.6
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4695.3
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4730.1
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5992.0
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4851.2
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4535.6
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3061.2
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4438.1
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4926.2
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5803.6
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4023.7
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5851.0
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5093.2
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5744.9
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4048.1
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5932.2
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5299.6
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5321.5
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6304.6
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3656.7
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5513.4
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4462.1
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6510.2
   },
   {
    "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6763.1
   }
  ],
  "Maine (State of United States)": [
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maine (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Maio (County of Cabo Verde)": [
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maio (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Majuro (Atol of Marshall Islands)": [
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Majuro (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Makamba (Province of Burundi)": [
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Makamba (Province of Burundi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Makedonska Kamenica (Municipality of North Macedonia)": [
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Makedonski Brod (Municipality of North Macedonia)": [
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 28.5
   }
  ],
  "Makira Ulawa (Province of Solomon Islands)": [
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makira Ulawa (Province of Solomon Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Makkah (Province of Saudi Arabia)": [
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Makkah (Province of Saudi Arabia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 43.1
   }
  ],
  "Makueni (County of Kenya)": [
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 89.8
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 132.3
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 86.6
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 113.8
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 114.3
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 135.9
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 136.8
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 98.0
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 127.5
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 130.8
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 246.1
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 100.8
   },
   {
    "Region Name": "Makueni (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 62.4
   }
  ],
  "Malaita (Province of Solomon Islands)": [
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malaita (Province of Solomon Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Malampa (Province of Vanuatu)": [
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malampa (Province of Vanuatu)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Malanje (Province of Angola)": [
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30151.6
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 36488.6
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 39209.2
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 36056.0
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 37212.1
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37817.3
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 35162.7
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 38588.1
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37187.4
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 36096.1
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 38966.9
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 34298.0
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 35485.8
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33713.2
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 35086.8
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 40344.9
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30226.9
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 36662.9
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 36400.9
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 36079.6
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 34023.1
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 32593.1
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 31268.1
   },
   {
    "Region Name": "Malanje (Province of Angola)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 34405.2
   }
  ],
  "Malatya (Province of Turkey)": [
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Malatya (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.2
   }
  ],
  "Maldonado (Department of Uruguay)": [
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maldonado (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Malew (Parish District of Isle of Man)": [
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Malew (Parish District of Isle of Man)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Maloelap (Atol of Marshall Islands)": [
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maloelap (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Maluku (Province of Indonesia)": [
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1752.7
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 247.2
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 419.3
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 182.9
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 748.1
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 128.0
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 572.4
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 137.4
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 227.0
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 136.1
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 264.1
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1487.7
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 419.9
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 104.2
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 244.6
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Maluku (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 38.6
   }
  ],
  "Maluku Utara (Province of Indonesia)": [
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 350.1
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 263.9
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maluku Utara (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)": [
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11527.3
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10801.2
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12398.5
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6742.1
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12144.0
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9066.3
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6611.8
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9694.8
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10387.2
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9715.0
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8064.6
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6440.1
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8040.6
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9793.0
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7816.1
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8550.3
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9194.3
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8368.8
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6089.6
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6242.4
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6027.2
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3357.9
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5104.1
   },
   {
    "Region Name": "Mamb\u00e9r\u00e9-Kad\u00e9\u00ef (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4229.5
   }
  ],
  "Mamou (Region of Guinea)": [
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2255.6
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2218.7
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1717.5
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1928.9
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2234.8
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2037.4
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1412.0
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2520.3
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1568.1
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1689.4
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1656.4
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1831.8
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1992.1
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2668.3
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2091.0
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2916.5
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1114.5
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1767.3
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2051.7
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1370.0
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1742.2
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2103.6
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2074.0
   },
   {
    "Region Name": "Mamou (Region of Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1134.7
   }
  ],
  "Mamoudzou (Commune of Mayotte)": [
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mamoudzou (Commune of Mayotte)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Manabi (Province of Ecuador)": [
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 144.5
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 201.1
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 164.6
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 179.2
   },
   {
    "Region Name": "Manabi (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.9
   }
  ],
  "Managua (Department of Nicaragua)": [
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 82.7
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 125.8
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 108.5
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 170.2
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 153.3
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 137.4
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 115.8
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 128.8
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 89.4
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 122.2
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Managua (Department of Nicaragua)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 73.7
   }
  ],
  "Manatuto (District of Timor-Leste)": [
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Manatuto (District of Timor-Leste)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.3
   }
  ],
  "Manat\u00ed (Municipality of Puerto Rico)": [
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manat\u00ed (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Manawatu-Wanganui (Region of New Zealand)": [
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30.7
   }
  ],
  "Manchester (Parish of Jamaica)": [
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manchester (Parish of Jamaica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mandalay (Division of Myanmar)": [
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 231.3
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1785.7
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1311.5
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 487.3
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 888.3
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 986.5
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2051.1
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 732.7
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 529.9
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1087.7
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 653.4
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 478.9
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 832.2
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1406.0
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 854.7
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 866.9
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 925.2
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 779.9
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 537.4
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 736.6
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 936.4
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 426.2
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 695.0
   },
   {
    "Region Name": "Mandalay (Division of Myanmar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2185.1
   }
  ],
  "Mandera (County of Kenya)": [
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 143.2
   },
   {
    "Region Name": "Mandera (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mandoul (Region of Chad)": [
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7769.8
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5741.7
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6406.4
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6142.5
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4954.1
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4318.2
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2698.3
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4101.7
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3161.1
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5846.1
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3534.7
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2397.1
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1999.4
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4091.2
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3568.6
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2549.5
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2148.2
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1893.3
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2480.0
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1454.5
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1004.5
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1089.4
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 954.8
   },
   {
    "Region Name": "Mandoul (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 553.3
   }
  ],
  "Mangaia (Island Council of Cook Islands)": [
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangaia (Island Council of Cook Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mangghystau (Region of Kazakhstan)": [
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 121.8
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1952.3
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 276.5
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mangghystau (Region of Kazakhstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.2
   }
  ],
  "Mangilao (Municipality of Guam)": [
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangilao (Municipality of Guam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mangochi (District of Malawi)": [
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 413.1
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 524.6
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 458.1
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 374.7
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 417.6
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 449.1
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 358.9
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 368.7
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 584.2
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 460.5
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 475.0
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 451.9
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 338.7
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 320.3
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 312.8
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 255.7
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 526.1
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 390.6
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 348.8
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 347.9
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 666.9
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 200.2
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 449.1
   },
   {
    "Region Name": "Mangochi (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 356.9
   }
  ],
  "Mangrove Cay (District of Bahamas)": [
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Mangrove Cay (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Manica (Province of Mozambique)": [
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13904.6
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15960.4
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15013.5
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14478.5
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17590.7
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19013.2
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19012.2
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15197.5
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18546.1
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16958.3
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15712.4
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15182.9
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16095.9
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18683.5
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13352.8
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15534.5
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17023.7
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16370.1
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15144.7
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14883.2
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15522.5
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13788.6
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13931.2
   },
   {
    "Region Name": "Manica (Province of Mozambique)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15033.9
   }
  ],
  "Manicaland (Province of Zimbabwe)": [
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 722.6
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 892.0
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 713.4
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1398.8
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 777.9
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1824.9
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1822.4
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1064.3
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1728.0
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1260.3
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1403.7
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 755.4
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 841.4
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1428.1
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 647.4
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 515.1
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 541.1
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 755.0
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 327.3
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 417.2
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 626.0
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 563.6
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 965.9
   },
   {
    "Region Name": "Manicaland (Province of Zimbabwe)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 750.1
   }
  ],
  "Maniema (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8096.7
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10580.8
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11088.5
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11284.4
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9977.2
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6784.4
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9100.4
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8758.5
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8809.9
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7725.6
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7080.4
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9808.5
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9283.0
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9500.0
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9367.5
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9155.1
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8310.0
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7942.6
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7976.5
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8268.9
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8612.7
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8122.4
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10848.8
   },
   {
    "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8513.2
   }
  ],
  "Manihiki (Island Council of Cook Islands)": [
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manihiki (Island Council of Cook Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Manipur (State of India)": [
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 640.7
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 742.1
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 244.2
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 674.2
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 414.4
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 650.8
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 532.7
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1021.7
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 747.1
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 573.2
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 413.3
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 850.4
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 644.8
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 144.1
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 158.0
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 182.6
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 87.9
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 446.3
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 674.2
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 331.2
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 341.9
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 525.2
   },
   {
    "Region Name": "Manipur (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 768.1
   }
  ],
  "Manisa (Province of Turkey)": [
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 152.0
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 170.9
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 92.8
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Manisa (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 62.2
   }
  ],
  "Manitoba (Province of Canada)": [
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 894.8
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7840.5
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 302.7
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1287.9
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1585.9
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3570.7
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1834.6
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 553.7
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1734.2
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1178.8
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2251.9
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8216.1
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 542.4
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 658.3
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 286.0
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1707.7
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2468.9
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 598.1
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 744.5
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9626.2
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1296.3
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1156.5
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2386.8
   },
   {
    "Region Name": "Manitoba (Province of Canada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11090.8
   }
  ],
  "Mannar (District of Sri Lanka)": [
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mannar (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Manu'a (District of American Samoa)": [
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manu'a (District of American Samoa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Manubah (Governorate of Tunisia)": [
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manubah (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Manufahi (District of Timor-Leste)": [
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Manufahi (District of Timor-Leste)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Manus (Province of Papua New Guinea)": [
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Manus (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Manyara (Region of Tanzania)": [
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3204.0
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1557.6
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2262.2
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1496.3
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1422.3
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4212.8
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2358.5
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 563.6
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2809.9
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3531.3
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1046.1
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 647.0
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 500.1
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 358.0
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1275.5
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 444.0
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 318.3
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 464.1
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2208.6
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1247.4
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 132.7
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 343.6
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1850.9
   },
   {
    "Region Name": "Manyara (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1224.9
   }
  ],
  "Manzini (District of Swaziland)": [
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 150.1
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 158.2
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 134.0
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 204.7
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 399.4
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 158.4
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 124.1
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 167.9
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 106.1
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 180.3
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 268.0
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 118.1
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 86.6
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 282.1
   },
   {
    "Region Name": "Manzini (District of Swaziland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 109.5
   }
  ],
  "Maputo (Province of Mozambique)": [
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3884.4
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1922.0
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5451.2
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4315.5
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3571.2
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4172.0
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3127.9
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3043.8
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3285.6
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4575.1
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3425.2
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4360.3
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4742.1
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2782.3
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 422.1
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1264.3
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2640.2
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1920.3
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1772.0
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2577.1
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1704.7
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1540.5
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1766.4
   },
   {
    "Region Name": "Maputo (Province of Mozambique)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1347.5
   }
  ],
  "Maputo City (Province of Mozambique)": [
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 81.9
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 138.9
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 119.4
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Maputo City (Province of Mozambique)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16.3
   }
  ],
  "Mara (Region of Tanzania)": [
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7429.8
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8042.3
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6180.0
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5897.1
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2706.0
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6914.9
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5048.0
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5054.8
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5184.9
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3566.7
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4930.7
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5082.0
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3531.5
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4067.2
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6296.7
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2229.9
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4089.9
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2581.2
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5082.0
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5699.2
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4577.4
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4087.2
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7328.4
   },
   {
    "Region Name": "Mara (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4464.2
   }
  ],
  "Maradi (Department of Niger)": [
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 205.6
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 86.6
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 74.4
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 346.6
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 241.2
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 437.1
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 129.3
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 162.9
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 578.6
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 259.8
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 228.9
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 213.1
   },
   {
    "Region Name": "Maradi (Department of Niger)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 204.7
   }
  ],
  "Maramure\u0219 (County of Romania)": [
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Maramure\u0219 (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Maranh\u00e3o (State of Brazil)": [
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15959.8
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15876.0
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17536.2
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22198.6
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8570.7
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37437.4
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11028.9
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10837.6
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31408.5
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13741.3
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 37369.9
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12433.2
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20020.1
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31250.5
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17123.6
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 26383.3
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9030.5
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15599.2
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13275.2
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8034.3
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13286.8
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12314.2
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12867.3
   },
   {
    "Region Name": "Maranh\u00e3o (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14608.0
   }
  ],
  "Marche (Region of Italy)": [
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marche (Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mardin (Province of Turkey)": [
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 225.7
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 233.2
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 159.7
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 168.7
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 390.8
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 351.6
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1173.2
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 881.7
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 791.9
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 756.9
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1065.6
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 743.9
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1545.0
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1737.5
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1363.4
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 732.9
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1538.7
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 909.4
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1361.0
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 949.4
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1027.9
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1107.6
   },
   {
    "Region Name": "Mardin (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 794.0
   }
  ],
  "Margibi (County of Liberia)": [
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 398.3
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Margibi (County of Liberia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.7
   }
  ],
  "Maricao (Municipality of Puerto Rico)": [
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maricao (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mariehamn (Sub-Region of \u00c5land)": [
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariehamn (Sub-Region of \u00c5land)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Marijampoles (County of Lithuania)": [
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Marijampoles (County of Lithuania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Marinduque (Province of Philippines)": [
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marinduque (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Maritime (Region of Togo)": [
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1577.3
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1692.0
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3261.6
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 717.3
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2446.8
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1558.5
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1411.8
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 977.5
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2733.6
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 950.7
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1256.0
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 565.5
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2192.1
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1274.9
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 684.7
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 671.6
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 583.7
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2018.9
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1015.5
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1593.8
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 482.5
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 225.3
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 343.4
   },
   {
    "Region Name": "Maritime (Region of Togo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 301.8
   }
  ],
  "Mariy-El (Republic of Russia)": [
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 141.7
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 985.7
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Mariy-El (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Markazi (Province of Iran)": [
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Markazi (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Marlborough (Region of New Zealand)": [
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marlborough (Region of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Marowijne (District of Suriname)": [
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Marowijne (District of Suriname)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Marrakech - Tensift - Al Haouz (Region of Morocco)": [
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Marsabit (County of Kenya)": [
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 353.9
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 115.8
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 245.7
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 665.8
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 74.2
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 380.7
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 623.8
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 107.0
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 88.7
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1046.5
   },
   {
    "Region Name": "Marsabit (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 551.1
   }
  ],
  "Mary (Province of Turkmenistan)": [
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 962.1
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2797.3
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2027.9
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 649.8
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 147.3
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1241.2
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 315.3
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2319.9
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 89.4
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 559.1
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1258.3
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 957.2
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 932.9
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 175.4
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 99.9
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2809.9
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 596.4
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 90.2
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Mary (Province of Turkmenistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 172.4
   }
  ],
  "Maryland (County of Liberia)": [
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Maryland (County of Liberia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.1
   }
  ],
  "Maryland (State of United States)": [
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maryland (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)": [
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mar\u00eda Trinidad S\u00e1nchez (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Masaka (District of Uganda)": [
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 102.0
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Masaka (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.1
   }
  ],
  "Masaya (Department of Nicaragua)": [
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Masaya (Department of Nicaragua)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.8
   }
  ],
  "Masbate (Province of Philippines)": [
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Masbate (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Mascara (Province of Algeria)": [
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 113.8
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mascara (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Maseru (District of Lesotho)": [
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 164.2
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Maseru (District of Lesotho)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 62.0
   }
  ],
  "Mashonaland Central (Province of Zimbabwe)": [
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3611.3
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3383.6
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2940.1
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3613.4
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3179.9
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5056.1
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4723.6
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4389.2
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5231.5
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4699.8
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4135.8
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4795.9
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4069.6
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5146.4
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3113.3
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2801.4
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3428.6
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3939.7
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2020.9
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2643.2
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3904.3
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2662.9
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2465.5
   },
   {
    "Region Name": "Mashonaland Central (Province of Zimbabwe)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1957.0
   }
  ],
  "Mashonaland East (Province of Zimbabwe)": [
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1337.4
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2554.4
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2516.9
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3326.8
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2627.7
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4621.6
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3774.0
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3648.6
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4549.8
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3529.6
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3817.1
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2824.7
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2506.6
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2362.8
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2311.1
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1932.5
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1875.3
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3379.1
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 969.2
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1805.8
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2047.9
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1963.2
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1207.3
   },
   {
    "Region Name": "Mashonaland East (Province of Zimbabwe)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1907.2
   }
  ],
  "Mashonaland West (Province of Zimbabwe)": [
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9241.9
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11239.4
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11351.7
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10650.3
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11039.1
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14797.9
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15056.2
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13982.0
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17688.7
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14689.9
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14932.5
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13813.5
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13742.3
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14146.9
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12011.5
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10416.2
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11372.3
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10832.9
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5268.1
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7885.6
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10983.2
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8433.9
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6738.3
   },
   {
    "Region Name": "Mashonaland West (Province of Zimbabwe)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6023.3
   }
  ],
  "Masindi (District of Uganda)": [
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2699.8
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2873.6
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2427.7
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2468.9
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1045.3
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1947.5
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1556.1
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1478.1
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1939.0
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2470.8
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1539.8
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2148.4
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1931.5
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1451.5
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2384.0
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1663.7
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1735.3
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 614.8
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1343.2
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1132.1
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1530.2
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 587.4
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1137.7
   },
   {
    "Region Name": "Masindi (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1023.6
   }
  ],
  "Massachusetts (State of United States)": [
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Massachusetts (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Masvingo (Province of Zimbabwe)": [
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2221.9
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2282.8
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6965.3
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2356.3
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1761.7
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1798.1
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2537.3
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2163.6
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1845.1
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3050.3
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1736.4
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 238.4
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 816.5
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2652.6
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 162.5
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 392.3
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1069.5
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 376.4
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 747.7
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1131.2
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 711.7
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 574.7
   },
   {
    "Region Name": "Masvingo (Province of Zimbabwe)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 500.6
   }
  ],
  "Matabeleland North (Province of Zimbabwe)": [
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5018.4
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3957.3
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7609.2
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6868.6
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8575.0
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4473.7
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9582.1
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11234.9
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8322.2
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11483.1
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7203.4
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3365.4
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5542.1
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6603.9
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3655.8
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6898.0
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4109.2
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4827.2
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1190.4
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3066.3
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5748.1
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4677.5
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 552.2
   },
   {
    "Region Name": "Matabeleland North (Province of Zimbabwe)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 939.2
   }
  ],
  "Matabeleland South (Province of Zimbabwe)": [
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 959.9
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 698.4
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1692.9
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2144.3
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1212.0
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2981.7
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4264.4
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4175.5
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3147.4
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3582.1
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1115.1
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 496.9
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1272.7
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2766.9
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 251.0
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 658.5
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2245.1
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 374.3
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 858.8
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1988.7
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1268.4
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 388.4
   },
   {
    "Region Name": "Matabeleland South (Province of Zimbabwe)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 412.7
   }
  ],
  "Matagalpa (Department of Nicaragua)": [
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Matagalpa (Department of Nicaragua)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.7
   }
  ],
  "Matale (District of Sri Lanka)": [
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matale (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Matam (Region of Senegal)": [
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1279.6
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2194.9
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4347.4
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5862.8
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2967.7
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2247.4
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6589.3
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6336.1
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7626.8
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4153.0
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3522.9
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2847.7
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 611.0
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1077.2
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2522.5
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1570.3
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 626.8
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 851.9
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3521.9
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4991.2
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5559.0
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8172.4
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5511.6
   },
   {
    "Region Name": "Matam (Region of Senegal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4734.8
   }
  ],
  "Matanzas (Province of Cuba)": [
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 207.1
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 530.6
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 719.2
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 671.4
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 647.0
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 475.9
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 216.1
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 385.4
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 155.6
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 315.8
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 162.5
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 119.2
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 132.7
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 237.9
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 248.2
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 147.3
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 177.1
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 296.7
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 299.3
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 298.8
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 127.3
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 286.4
   },
   {
    "Region Name": "Matanzas (Province of Cuba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 300.8
   }
  ],
  "Matara (District of Sri Lanka)": [
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matara (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mato Grosso (State of Brazil)": [
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 60454.6
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 46539.5
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 61412.6
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 50132.8
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35342.6
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 105250.9
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 37820.5
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16278.1
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 98329.3
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25059.3
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 39153.6
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 24165.2
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 33337.0
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 39716.6
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 38086.3
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 49164.2
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 23238.0
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 48351.6
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 72216.6
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 34826.0
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 33317.9
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25999.5
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 67678.7
   },
   {
    "Region Name": "Mato Grosso (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15629.9
   }
  ],
  "Mato Grosso do Sul (State of Brazil)": [
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 27795.9
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6047.1
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10487.8
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21716.2
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6675.9
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19035.1
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9369.0
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10988.8
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15266.9
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8080.0
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13437.1
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5986.5
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3554.5
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7595.7
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12484.0
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8679.4
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5443.5
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 21334.2
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21420.4
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 21064.5
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4178.3
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9516.1
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23292.7
   },
   {
    "Region Name": "Mato Grosso do Sul (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3468.9
   }
  ],
  "Matrouh (Governorate of Egypt)": [
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Matrouh (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mauke (Island Council of Cook Islands)": [
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mauke (Island Council of Cook Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Maule (Region of Chile)": [
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 117.3
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 121.5
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 211.8
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 186.9
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2647.7
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 195.3
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 85.7
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 264.7
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Maule (Region of Chile)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 55.1
   }
  ],
  "Maunabo (Municipality of Puerto Rico)": [
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Maunabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)": [
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mayabeque (Province of Cuba)": [
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 202.8
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 125.2
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 198.3
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 137.8
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 122.6
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 105.5
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 108.7
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 154.8
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Mayabeque (Province of Cuba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 83.8
   }
  ],
  "Mayaguana (District of Bahamas)": [
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaguana (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mayag\u00fcez (Municipality of Puerto Rico)": [
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayag\u00fcez (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mayaro/Rio Claro (Region of Trinidad and Tobago)": [
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mayo (County of Ireland)": [
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayo (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Mayo-Kebbi Est (Region of Chad)": [
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3725.1
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3911.8
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4856.1
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5166.1
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4934.8
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4894.3
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4777.2
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3993.1
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4193.7
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4556.0
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2793.7
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3861.9
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2420.7
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3155.3
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3306.0
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2467.8
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2940.3
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1781.6
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3084.6
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2690.5
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1388.9
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2151.8
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1282.1
   },
   {
    "Region Name": "Mayo-Kebbi Est (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2055.6
   }
  ],
  "Mayo-Kebbi Ouest (Region of Chad)": [
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3452.8
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3646.6
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3524.9
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3301.5
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3507.5
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3046.0
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3973.5
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2435.0
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2692.9
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2945.9
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1710.7
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2069.3
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1761.7
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1700.6
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1951.8
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1333.6
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1301.2
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 771.7
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1288.1
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1084.7
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 895.2
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1016.3
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1245.3
   },
   {
    "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1003.7
   }
  ],
  "Maysan (Province of Iraq)": [
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 227.0
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 487.5
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 307.6
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 200.6
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 143.4
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 125.4
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 315.1
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 554.6
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 162.3
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 572.8
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 611.0
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 331.4
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 471.0
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 230.2
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 219.5
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 222.7
   },
   {
    "Region Name": "Maysan (Province of Iraq)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 302.5
   }
  ],
  "Mayuge (District of Uganda)": [
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mayuge (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Mazandaran (Province of Iran)": [
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Mazandaran (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 22.1
   }
  ],
  "Mazowieckie (Voivodeship of Poland)": [
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mazowieckie (Voivodeship of Poland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Ma\u010dvanski (District of Serbia)": [
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Ma\u010dvanski (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ma\u0142opolskie (Voivodeship of Poland)": [
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Mbale (District of Uganda)": [
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Mbale (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mbarara (District of Uganda)": [
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 348.6
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 224.4
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 547.7
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 354.6
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 91.7
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 170.2
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 219.5
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 123.7
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 78.0
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 378.1
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 126.7
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 93.9
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 160.3
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 89.8
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 152.0
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 216.7
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 142.1
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 115.1
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 89.2
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 185.6
   },
   {
    "Region Name": "Mbarara (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 99.0
   }
  ],
  "Mbeya (Region of Tanzania)": [
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6675.5
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6770.8
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8233.5
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7314.7
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5899.4
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6713.0
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6746.2
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7310.6
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8343.9
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7047.4
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6539.5
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7665.2
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6309.3
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6536.5
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6679.5
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5966.1
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4829.1
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5454.8
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4568.8
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4735.0
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3882.4
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3686.9
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4449.0
   },
   {
    "Region Name": "Mbeya (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4568.0
   }
  ],
  "Mbomou (Prefecture of Central African Republic)": [
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13973.6
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11652.5
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13159.9
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13075.4
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15212.9
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12634.1
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11495.3
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10504.5
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12692.1
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14427.5
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10571.2
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9731.5
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10032.3
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13552.0
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11893.8
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7419.7
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7620.0
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8858.2
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11305.8
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4338.4
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7467.8
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3789.4
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4561.1
   },
   {
    "Region Name": "Mbomou (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3514.2
   }
  ],
  "Mchinji (District of Malawi)": [
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Mchinji (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.6
   }
  ],
  "Meath (County of Ireland)": [
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meath (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Mecklenburg-Vorpommern (State of Germany)": [
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Medimurska (County of Croatia)": [
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Medimurska (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Meghalaya (State of India)": [
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 143.2
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 818.5
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 317.3
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 599.8
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 255.1
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 212.0
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 783.7
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1338.7
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 562.9
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 743.2
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 588.4
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 534.2
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 843.1
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 381.8
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 486.2
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 335.3
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 401.7
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 718.8
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 523.1
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 253.6
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 273.7
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 415.2
   },
   {
    "Region Name": "Meghalaya (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1385.7
   }
  ],
  "Mehedin\u021bi (County of Romania)": [
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 157.1
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 156.7
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 161.0
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 184.4
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 214.6
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 168.9
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 128.8
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 354.4
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Mehedin\u021bi (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 48.4
   }
  ],
  "Mejit (Island of Marshall Islands)": [
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mejit (Island of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mekn\u00e8s - Tafilalet (Region of Morocco)": [
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mekn\u00e8s - Tafilalet (Region of Morocco)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Melaka (State of Malaysia)": [
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Melaka (State of Malaysia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mendoza (Province of Argentina)": [
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2798.2
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3961.8
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 436.2
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 164.4
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 133.6
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 796.0
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 254.0
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 155.6
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 134.2
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 584.6
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1984.4
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 135.3
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 144.1
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2202.4
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2464.4
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 592.5
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 407.5
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 210.3
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 189.5
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 853.8
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 250.4
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 310.6
   },
   {
    "Region Name": "Mendoza (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 383.3
   }
  ],
  "Meneng (District of Nauru)": [
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meneng (District of Nauru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Merizo (Municipality of Guam)": [
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Merizo (Municipality of Guam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mersin (Province of Turkey)": [
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 103.3
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 111.9
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 162.1
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 147.3
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Mersin (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 68.6
   }
  ],
  "Meru (County of Kenya)": [
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 121.1
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 146.0
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 122.6
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 92.4
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 127.3
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 109.5
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Meru (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30.2
   }
  ],
  "Meta (Department of Colombia)": [
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9534.9
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12616.3
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3562.0
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6614.8
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11310.3
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6308.2
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4500.9
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7278.0
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4537.8
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3655.0
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4663.6
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6878.2
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1839.7
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5817.8
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3432.0
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6547.9
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5133.7
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3903.2
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3947.8
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5891.3
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3745.9
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3553.8
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2487.8
   },
   {
    "Region Name": "Meta (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2274.5
   }
  ],
  "Metropolitan Manila (Province of Philippines)": [
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Metropolitan Manila (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Michael (District of Isle of Man)": [
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michael (District of Isle of Man)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Michigan (State of United States)": [
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Michigan (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.6
   }
  ],
  "Michoac\u00e1n (State of M\u00e9xico)": [
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 645.0
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1164.5
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 865.0
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1478.3
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1084.1
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 838.0
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1257.3
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1188.0
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 521.6
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 978.8
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 718.8
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1442.7
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 257.0
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 791.5
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1088.4
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 922.6
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 664.8
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 765.9
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 849.1
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1210.3
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 686.8
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 692.2
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1181.0
   },
   {
    "Region Name": "Michoac\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 452.1
   }
  ],
  "Micoud (Quarter of Saint Lucia)": [
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Micoud (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mid-Western (Development Region of Nepal)": [
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1499.7
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 546.4
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1094.6
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 135.3
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 727.1
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1250.0
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1023.8
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 697.3
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1527.4
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 833.9
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1200.5
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 163.3
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3435.9
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 941.1
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 420.4
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1911.7
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2101.2
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 883.4
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1402.0
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3191.5
   },
   {
    "Region Name": "Mid-Western (Development Region of Nepal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 264.5
   }
  ],
  "Middle Caicos (District of Turks and Caicos Islands)": [
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Midlands (Province of Zimbabwe)": [
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1095.9
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1564.0
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2446.0
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3684.6
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2643.6
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4034.0
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3873.2
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4970.4
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5562.9
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5180.0
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3786.2
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2754.0
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2987.9
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3828.2
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 951.8
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2316.9
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2330.6
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1727.2
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 316.0
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1340.9
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2163.2
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2041.4
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 857.0
   },
   {
    "Region Name": "Midlands (Province of Zimbabwe)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 893.5
   }
  ],
  "Midtjylland (Region of Denmark)": [
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midtjylland (Region of Denmark)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Midway (Island of United States Minor Outlying Isl)": [
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Midway (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mie (Prefecture of Japan)": [
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mie (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Migori (County of Kenya)": [
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Migori (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mila (Province of Algeria)": [
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mila (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Mili (Atol of Marshall Islands)": [
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mili (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Milne Bay (Province of Papua New Guinea)": [
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 164.0
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 101.4
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 181.6
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 98.4
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 167.4
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 106.8
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 110.6
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Milne Bay (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 33.0
   }
  ],
  "Minas Gerais (State of Brazil)": [
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7083.0
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9997.7
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6410.1
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6794.9
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3345.4
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15797.1
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6073.5
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2015.5
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9916.1
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8659.7
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7956.9
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2412.1
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8861.2
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6830.9
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4557.7
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5254.2
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2681.8
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5859.1
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7036.7
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8415.7
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3338.2
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2264.0
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5501.4
   },
   {
    "Region Name": "Minas Gerais (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3779.5
   }
  ],
  "Minnesota (State of United States)": [
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 286.6
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 92.8
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 284.3
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 268.2
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 397.2
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 715.6
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 619.5
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 549.4
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 456.8
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 200.9
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 153.1
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 293.7
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 213.9
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 986.3
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 195.1
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Minnesota (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 245.5
   }
  ],
  "Minsk (City of Belarus)": [
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Minsk (City of Belarus)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Minsk (Region of Belarus)": [
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 126.7
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Minsk (Region of Belarus)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)": [
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Miranda (State of Venezuela)": [
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 131.8
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 116.8
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 189.3
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 308.3
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Miranda (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.7
   }
  ],
  "Misamis Occidental (Province of Philippines)": [
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Occidental (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Misamis Oriental (Province of Philippines)": [
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Misamis Oriental (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Misiones (Department of Paraguay)": [
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 208.8
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1708.7
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1875.3
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1242.3
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 707.6
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 968.1
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 736.6
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 738.5
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 448.5
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1050.0
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 651.7
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 868.6
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 243.3
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 291.3
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 692.8
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 558.2
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 686.4
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1024.9
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1307.9
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1702.7
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 708.7
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 470.3
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 568.5
   },
   {
    "Region Name": "Misiones (Department of Paraguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 374.3
   }
  ],
  "Misiones (Province of Argentina)": [
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 122.4
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 126.0
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Misiones (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.4
   }
  ],
  "Misratah (District of Libya)": [
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Misratah (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mississippi (State of United States)": [
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 196.4
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 238.8
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 346.2
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 384.6
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 441.6
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 552.6
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 854.0
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 382.6
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 995.5
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1131.9
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 558.6
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 747.7
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 623.4
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 860.5
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 814.2
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 347.1
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 444.8
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 761.9
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 312.8
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 453.6
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 659.6
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 367.6
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 633.5
   },
   {
    "Region Name": "Mississippi (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 391.4
   }
  ],
  "Missouri (State of United States)": [
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 258.5
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 588.4
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 719.0
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 534.2
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 495.6
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1274.6
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 536.1
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 653.0
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1028.3
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 981.0
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 122.8
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 329.7
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 349.0
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1763.4
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 606.7
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 598.7
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 393.2
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1007.7
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1083.6
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 777.7
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 666.3
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 661.1
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 615.2
   },
   {
    "Region Name": "Missouri (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 484.7
   }
  ],
  "Mitiaro (Island Council of Cook Islands)": [
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mitiaro (Island Council of Cook Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Miyagi (Prefecture of Japan)": [
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyagi (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Miyazaki (Prefecture of Japan)": [
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Miyazaki (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mizoram (State of India)": [
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 107.8
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 626.0
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1578.8
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 848.5
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1821.3
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1657.3
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 728.6
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2106.8
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1982.3
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 663.0
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 745.1
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 977.5
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1117.3
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 783.9
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 300.1
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 111.3
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 284.0
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 200.9
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 413.5
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 977.5
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 320.1
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 175.1
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 825.3
   },
   {
    "Region Name": "Mizoram (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9384.6
   }
  ],
  "Mjini Magharibi (Region of Tanzania)": [
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mjini Magharibi (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Moca (Municipality of Puerto Rico)": [
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moca (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mogila (Municipality of North Macedonia)": [
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mogila (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mogilev (Region of Belarus)": [
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 253.2
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 132.3
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 78.2
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 200.2
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 104.6
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 129.5
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 135.9
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Mogilev (Region of Belarus)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.2
   }
  ],
  "Mohale's Hoek (District of Lesotho)": [
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Mohale's Hoek (District of Lesotho)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Mojkovac (Municipality of Montenegro)": [
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mojkovac (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Moka (District of Mauritius)": [
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moka (District of Mauritius)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mokhotlong (District of Lesotho)": [
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 280.6
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 128.6
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 232.2
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 174.9
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Mokhotlong (District of Lesotho)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 79.3
   }
  ],
  "Molise (Region of Italy)": [
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 154.6
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 85.7
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Molise (Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Mombasa (County of Kenya)": [
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mombasa (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Mon (State of Myanmar)": [
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 194.4
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 247.2
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 972.6
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 319.0
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 336.3
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 639.7
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 288.1
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 234.3
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 210.9
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 157.1
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 239.7
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 302.9
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 466.5
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 256.4
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 242.2
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 257.9
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 250.0
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 276.8
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 409.4
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 197.4
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 151.1
   },
   {
    "Region Name": "Mon (State of Myanmar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 80.6
   }
  ],
  "Monagas (State of Venezuela)": [
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 687.9
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1497.2
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1194.2
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1853.0
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2165.3
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1830.7
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 698.0
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1780.5
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1421.1
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 545.4
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 403.7
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1326.7
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 780.3
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1334.4
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 927.4
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1101.4
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2585.3
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2483.5
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2588.7
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1177.3
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 893.3
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4354.3
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3292.3
   },
   {
    "Region Name": "Monagas (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2486.9
   }
  ],
  "Monaghan (County of Ireland)": [
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monaghan (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.9
   }
  ],
  "Monastir (Governorate of Tunisia)": [
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Monastir (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Moneragala (District of Sri Lanka)": [
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 209.4
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 239.9
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 179.0
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 137.4
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 123.3
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 92.2
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Moneragala (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mongala (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 247.8
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 295.6
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 393.4
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 767.4
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1269.5
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 228.5
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 109.5
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1675.1
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1410.1
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 768.5
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 701.2
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 232.4
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 892.2
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 233.7
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 717.7
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 572.6
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1239.3
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 856.8
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2145.4
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1620.0
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1099.5
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1098.2
   },
   {
    "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 454.0
   }
  ],
  "Monggar (District of Bhutan)": [
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Monggar (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.1
   }
  ],
  "Mono (Department of Benin)": [
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 353.5
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 222.1
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 109.8
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51.9
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 105.5
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 91.3
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Mono (Department of Benin)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Monse\u00f1or Nouel (Province of Dominican Republic)": [
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monse\u00f1or Nouel (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mont Fleuri (District of Seychelles)": [
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mont Fleuri (District of Seychelles)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Montagnes (District of C\u00f4te d'Ivoire)": [
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 344.3
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 266.9
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 477.8
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 240.5
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1104.9
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 470.3
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 319.2
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 392.5
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 121.8
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 700.1
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 205.4
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 131.4
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 180.5
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 289.6
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 215.4
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 344.9
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 120.3
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 331.6
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 92.2
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 307.4
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 210.3
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 126.3
   },
   {
    "Region Name": "Montagnes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 42.0
   }
  ],
  "Montana (Province of Bulgaria)": [
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 125.4
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 102.0
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 249.3
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 88.7
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 99.0
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 149.6
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Montana (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.1
   }
  ],
  "Montana (State of United States)": [
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 385.6
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2518.2
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 381.6
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2899.1
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2534.1
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 509.8
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 183.5
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 336.8
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 567.4
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3657.6
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 384.6
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 154.3
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1163.4
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 420.8
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4120.8
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 501.8
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 185.2
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 996.4
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2706.8
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 472.7
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 412.9
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1226.8
   },
   {
    "Region Name": "Montana (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 281.0
   }
  ],
  "Monte Cristi (Province of Dominican Republic)": [
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Monte Cristi (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.5
   }
  ],
  "Monte Plata (Province of Dominican Republic)": [
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Monte Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Montegiardino (Municipality of San Marino)": [
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montegiardino (Municipality of San Marino)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Montevideo (Department of Uruguay)": [
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Montevideo (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Montserrado (County of Liberia)": [
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 352.4
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Montserrado (County of Liberia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Moore's Island (District of Bahamas)": [
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moore's Island (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mopti (Region of Mali)": [
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3708.6
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5130.7
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5815.4
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4954.3
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5705.4
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6409.2
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3637.4
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5484.8
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4923.4
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4428.4
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4451.8
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3595.0
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2159.1
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3589.2
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3286.1
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3154.2
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3429.9
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4077.1
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6669.0
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6760.1
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5843.9
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7796.0
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7618.9
   },
   {
    "Region Name": "Mopti (Region of Mali)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7923.1
   }
  ],
  "Moquegua (Region of Peru)": [
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Moquegua (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Moravi\u010dki (District of Serbia)": [
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravi\u010dki (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Moravskoslezsk\u00fd (Region of Czechia)": [
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moravskoslezsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Moraz\u00e1n (Department of El Salvador)": [
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moraz\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mordovia (Republic of Russia)": [
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 475.5
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 291.8
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 279.3
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 525.6
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 393.4
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 651.0
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1339.6
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 403.2
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 196.6
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 120.3
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 363.6
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 161.0
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 420.8
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 133.8
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Mordovia (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.1
   }
  ],
  "Morelos (State of M\u00e9xico)": [
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 99.0
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 126.9
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 80.0
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 74.2
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 109.8
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 104.4
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 84.0
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 107.0
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 92.6
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Morelos (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 117.3
   }
  ],
  "Morobe (Province of Papua New Guinea)": [
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 654.3
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 486.0
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 545.6
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 260.5
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 379.6
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 315.8
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 238.4
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 213.7
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 312.8
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 139.3
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 224.7
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 227.0
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 221.4
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 501.0
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 180.1
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 210.5
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 234.3
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 211.4
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 152.8
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 145.1
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 162.3
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 155.6
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Morobe (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 96.5
   }
  ],
  "Morogoro (Region of Tanzania)": [
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11594.4
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19298.8
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10629.5
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21676.4
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5048.2
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16725.9
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13226.1
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17850.7
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18792.2
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10733.0
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16839.1
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10912.2
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9257.7
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14182.7
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13214.3
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5800.6
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8860.3
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5702.0
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9606.9
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12319.6
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10134.1
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7755.7
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7818.5
   },
   {
    "Region Name": "Morogoro (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8496.5
   }
  ],
  "Morona Santiago (Province of Ecuador)": [
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Morona Santiago (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Moroto (District of Uganda)": [
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1490.5
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3145.7
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2229.2
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3238.3
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2136.8
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4012.3
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3479.6
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1432.8
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3710.5
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3962.4
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3112.0
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1907.2
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2257.3
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2602.4
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1596.6
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2283.5
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2133.2
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1864.4
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3533.0
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3165.6
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3028.4
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2079.6
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2324.4
   },
   {
    "Region Name": "Moroto (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2229.4
   }
  ],
  "Morovis (Municipality of Puerto Rico)": [
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Morovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Moscow City (City of Russia)": [
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moscow City (City of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Moskva (Region of Russia)": [
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 563.8
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 74.4
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 471.4
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 352.9
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 245.0
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1812.7
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1305.9
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 897.3
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 165.1
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 648.3
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 127.8
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 143.0
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Moskva (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.9
   }
  ],
  "Mostaganem (Province of Algeria)": [
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mostaganem (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mosteiros (County of Cabo Verde)": [
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mosteiros (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mount Lebanon (Governorate of Lebanon)": [
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mount Lebanon (Governorate of Lebanon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mountain Province (Province of Philippines)": [
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Mountain Province (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Moxico (Province of Angola)": [
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 45503.9
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 55508.3
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 52344.6
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 62016.5
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 46075.0
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 52598.2
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 51034.4
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 50291.0
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 54672.9
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 58432.9
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 51442.1
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 54345.3
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 47463.9
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 53444.3
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 51537.3
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 58097.9
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 46560.1
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 64514.1
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 44851.4
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 53872.9
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 49770.9
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 57866.3
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 60878.9
   },
   {
    "Region Name": "Moxico (Province of Angola)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 50911.1
   }
  ],
  "Moyen-Chari (Region of Chad)": [
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21585.9
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19659.8
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 19147.0
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20392.3
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19563.1
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 18822.5
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17966.3
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16820.7
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15845.1
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18388.4
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16643.0
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15446.4
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13989.9
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16253.2
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15165.7
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14482.3
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14570.0
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11905.8
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11712.3
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9875.1
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10776.8
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10131.7
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10738.4
   },
   {
    "Region Name": "Moyen-Chari (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7717.5
   }
  ],
  "Moyen-Ogoou\u00e9 (Province of Gabon)": [
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Moyen-Ogoou\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Moyo (District of Uganda)": [
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 607.1
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 872.3
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 732.1
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 846.3
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 647.0
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 687.9
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 639.0
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 726.5
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 654.7
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 698.2
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 800.2
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 633.2
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 803.2
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 734.0
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 778.2
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 737.9
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 621.9
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 777.7
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 385.2
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 606.9
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 586.5
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 478.3
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 419.5
   },
   {
    "Region Name": "Moyo (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 529.3
   }
  ],
  "Mpigi (District of Uganda)": [
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 149.0
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 257.2
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 120.9
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Mpigi (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 59.0
   }
  ],
  "Mpumalanga (Province of South Africa)": [
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12090.0
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6798.3
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8270.6
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13645.4
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9105.8
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9646.6
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8780.6
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8759.3
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9751.2
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10407.2
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7992.1
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9367.5
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10543.5
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7620.0
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3901.5
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6213.1
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6597.6
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8623.2
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7013.3
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8954.0
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4941.2
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9010.8
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11684.2
   },
   {
    "Region Name": "Mpumalanga (Province of South Africa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6476.9
   }
  ],
  "Mtsamboro (Commune of Mayotte)": [
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mtsamboro (Commune of Mayotte)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mtskheta-Mtianeti (Region of Georgia)": [
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Mtwara (Region of Tanzania)": [
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2129.5
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2101.2
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1909.4
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2643.2
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 972.6
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1547.3
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2035.2
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2233.9
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1547.3
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1629.2
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2035.0
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2167.9
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1776.9
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2232.9
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1816.1
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1471.9
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1900.0
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2181.8
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1883.2
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1392.3
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1421.3
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1092.6
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1173.5
   },
   {
    "Region Name": "Mtwara (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 912.4
   }
  ],
  "Mubarak Al-Kabeer (Province of Kuwait)": [
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mubende (District of Uganda)": [
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 132.5
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 667.3
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 247.6
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 281.0
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 308.7
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 308.3
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 267.7
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 496.7
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 297.8
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 174.5
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 227.0
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 219.3
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 212.0
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 135.1
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 131.0
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 147.7
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Mubende (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 52.1
   }
  ],
  "Muchinga (Province of Zambia)": [
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 33980.3
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37822.6
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 34920.3
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 37958.7
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 34033.0
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34054.7
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 37868.5
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 31057.6
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36515.2
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 33254.4
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 33519.0
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 36060.1
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 32229.3
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 34687.0
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 34032.2
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31836.8
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30856.1
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 29507.2
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 30206.5
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 27296.2
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 29779.9
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 26864.1
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 29816.6
   },
   {
    "Region Name": "Muchinga (Province of Zambia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 29507.9
   }
  ],
  "Mudug (Region of Somalia)": [
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mudug (Region of Somalia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mugla (Province of Turkey)": [
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 595.9
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Mugla (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.4
   }
  ],
  "Muharraq (Governorate of Bahrain)": [
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muharraq (Governorate of Bahrain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mukdahan (Province of Thailand)": [
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Mukdahan (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.0
   }
  ],
  "Mukono (District of Uganda)": [
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Mukono (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.4
   }
  ],
  "Mulanje (District of Malawi)": [
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Mulanje (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 38.6
   }
  ],
  "Mullaitivu (District of Sri Lanka)": [
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Mullaitivu (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Muramvya (Province of Burundi)": [
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muramvya (Province of Burundi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Murang'a (County of Kenya)": [
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Murang'a (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Mure\u0219 (County of Romania)": [
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mure\u0219 (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Murmansk (Region of Russia)": [
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 137.6
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Murmansk (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Murzuq (District of Libya)": [
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Murzuq (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mus (Province of Turkey)": [
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 354.4
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 111.9
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 351.1
   },
   {
    "Region Name": "Mus (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 51.2
   }
  ],
  "Musandam (Province of Oman)": [
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Musandam (Province of Oman)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Muscat (Province of Oman)": [
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Muscat (Province of Oman)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Muyinga (Province of Burundi)": [
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 78.2
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 74.2
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Muyinga (Province of Burundi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 43.9
   }
  ],
  "Mwali (Autonomous Island of Comoros)": [
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mwali (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mwanza (District of Malawi)": [
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 147.1
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 127.1
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 139.6
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 114.5
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 223.8
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 236.2
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 180.9
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 134.6
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 164.8
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 88.3
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 84.0
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 108.9
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 90.2
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 141.7
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Mwanza (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 29.8
   }
  ],
  "Mwanza (Region of Tanzania)": [
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Mwanza (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.6
   }
  ],
  "Mwaro (Province of Burundi)": [
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mwaro (Province of Burundi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mykolayiv (Region of Ukraine)": [
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2339.2
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 941.1
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1029.0
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1499.1
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 485.8
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3429.3
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 803.9
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 718.8
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 774.1
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 85.7
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 460.7
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1296.9
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1517.7
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1140.4
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1206.0
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 280.8
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 846.8
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 315.3
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 726.1
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 486.2
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 530.3
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 681.3
   },
   {
    "Region Name": "Mykolayiv (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 438.6
   }
  ],
  "Mymensingh (Division of Bangladesh)": [
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Mymensingh (Division of Bangladesh)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Mzimba (District of Malawi)": [
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 156.1
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 210.3
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 113.4
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 104.2
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 143.8
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 173.2
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 145.6
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 207.9
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 138.7
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 160.3
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 166.6
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 115.5
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 113.6
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 83.8
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 106.3
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Mzimba (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 54.4
   }
  ],
  "M\u00e9denine (Governorate of Tunisia)": [
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9denine (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "M\u00e9d\u00e9a (Province of Algeria)": [
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 120.3
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 228.9
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 263.2
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 117.3
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 175.4
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 412.4
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 89.4
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 169.6
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 105.7
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 128.0
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9d\u00e9a (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.9
   }
  ],
  "M\u00e9rida (State of Venezuela)": [
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "M\u00e9rida (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "M\u00e9xico (State of M\u00e9xico)": [
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 164.2
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 184.6
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 153.3
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 122.6
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 125.4
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 138.3
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 140.2
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 107.6
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 177.9
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 195.1
   },
   {
    "Region Name": "M\u00e9xico (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 75.5
   }
  ],
  "M\u00f4nd\u00f3l Kiri (Province of Cambodia)": [
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5927.1
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5926.2
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5665.3
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6173.4
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6457.4
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5284.6
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5500.3
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5075.0
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6698.2
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4833.4
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5448.2
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5122.8
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6214.6
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5609.0
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5698.1
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4835.5
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5295.6
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5376.4
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5132.9
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4293.8
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4888.9
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5082.7
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5588.2
   },
   {
    "Region Name": "M\u00f4nd\u00f3l Kiri (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4780.0
   }
  ],
  "M\u00f8re og Romsdal (County of Norway)": [
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "M\u00f8re og Romsdal (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "NA (Atol of Marshall Islands)": [
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "NA (NA of NA)": [
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of NA)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "NA (NA of Netherlands)": [
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NA (NA of Netherlands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "NCT of Delhi (Union Territory of India)": [
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "NCT of Delhi (Union Territory of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.3
   }
  ],
  "Nabatiyeh (Governorate of Lebanon)": [
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Nabatiyeh (Governorate of Lebanon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nabeul (Governorate of Tunisia)": [
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nabeul (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nagaland (State of India)": [
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 134.2
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 416.1
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 332.3
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 697.3
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 550.5
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 310.6
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 787.4
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 685.1
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 992.1
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 386.3
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 578.2
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 350.1
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 404.5
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 473.1
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 329.9
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 134.4
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 176.0
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 345.1
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 268.8
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 337.0
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 328.8
   },
   {
    "Region Name": "Nagaland (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 450.6
   }
  ],
  "Nagano (Prefecture of Japan)": [
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nagano (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.4
   }
  ],
  "Naguabo (Municipality of Puerto Rico)": [
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naguabo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nairobi (County of Kenya)": [
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Nairobi (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Najran (Province of Saudi Arabia)": [
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Najran (Province of Saudi Arabia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nakapiripirit (District of Uganda)": [
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1275.3
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1781.8
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1627.9
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2628.8
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1080.0
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2950.1
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2235.0
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 983.3
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2555.3
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2817.5
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1908.1
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1546.7
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1618.1
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2148.0
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1277.2
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1643.8
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1440.3
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1116.6
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1725.0
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1839.9
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1719.2
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1553.7
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1341.5
   },
   {
    "Region Name": "Nakapiripirit (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1633.1
   }
  ],
  "Nakasongola (District of Uganda)": [
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 137.2
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 123.9
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 159.7
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 159.7
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 102.9
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 208.6
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 203.4
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 202.1
   },
   {
    "Region Name": "Nakasongola (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24.4
   }
  ],
  "Nakhchivan (Region of Azerbaijan)": [
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nakhchivan (Region of Azerbaijan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.5
   }
  ],
  "Nakhon Nayok (Province of Thailand)": [
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 105.3
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 198.1
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Nakhon Nayok (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.9
   }
  ],
  "Nakhon Pathom (Province of Thailand)": [
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Nakhon Pathom (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Nakhon Phanom (Province of Thailand)": [
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 128.2
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 99.9
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 83.8
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 88.7
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 108.9
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Nakhon Phanom (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.6
   }
  ],
  "Nakhon Ratchasima (Province of Thailand)": [
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 216.9
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1145.2
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 833.0
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 310.2
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 244.0
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 187.1
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 130.6
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 201.7
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 173.6
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 164.0
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 201.5
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 168.3
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 597.2
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 401.3
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 347.1
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 330.1
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 326.9
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 340.4
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 144.7
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 209.4
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 192.5
   },
   {
    "Region Name": "Nakhon Ratchasima (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 238.8
   }
  ],
  "Nakhon Sawan (Province of Thailand)": [
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 325.2
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1161.7
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1273.8
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 530.3
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 636.0
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 570.0
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 311.0
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 436.7
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 339.1
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 608.6
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 781.8
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 510.4
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 693.9
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 538.1
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 395.7
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 537.4
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1007.3
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 893.5
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 423.6
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 305.3
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 232.8
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 173.6
   },
   {
    "Region Name": "Nakhon Sawan (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 102.9
   }
  ],
  "Nakhon Si Thammarat (Province of Thailand)": [
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 115.8
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 94.3
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nakuru (County of Kenya)": [
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Nakuru (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.9
   }
  ],
  "Nalut (District of Libya)": [
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nalut (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nam \u0110\u1ecbnh (Province of Vietnam)": [
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nam \u0110\u1ecbnh (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Namangan (Region of Uzbekistan)": [
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namangan (Region of Uzbekistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Namibe (Province of Angola)": [
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 74.4
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 193.1
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 224.9
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 88.7
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 105.5
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 127.3
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 106.3
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 279.5
   },
   {
    "Region Name": "Namibe (Province of Angola)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 151.8
   }
  ],
  "Namorik (Atol of Marshall Islands)": [
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namorik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nampula (Province of Mozambique)": [
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23229.5
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29060.3
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23419.4
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 28060.0
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23897.0
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25047.5
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 27739.3
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 28266.7
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 30365.4
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 24568.8
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 26932.5
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 30144.1
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 26498.2
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25780.2
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 27716.6
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22573.9
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 21269.7
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23174.1
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25707.6
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 19200.4
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 25513.1
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23443.4
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 24919.5
   },
   {
    "Region Name": "Nampula (Province of Mozambique)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19930.7
   }
  ],
  "Namu (Atol of Marshall Islands)": [
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Namu (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nan (Province of Thailand)": [
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 795.3
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 325.2
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1115.4
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 734.6
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 638.8
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1496.3
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 891.6
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 741.9
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1444.4
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 182.9
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 876.8
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 933.1
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 533.1
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 382.4
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 650.8
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 262.6
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 250.2
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 300.3
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 497.1
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 89.4
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 346.2
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 332.3
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 355.4
   },
   {
    "Region Name": "Nan (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 83.6
   }
  ],
  "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)": [
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5288.5
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2583.6
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4105.8
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4399.3
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5951.5
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3604.4
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2830.5
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3765.2
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4031.0
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5114.2
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3509.2
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3156.6
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2512.6
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7016.5
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4078.6
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3436.5
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4711.2
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5288.7
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4352.5
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6641.6
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4437.2
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3190.5
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4103.9
   },
   {
    "Region Name": "Nana-Gr\u00e9bizi (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4299.6
   }
  ],
  "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)": [
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5419.7
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7304.8
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5408.3
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4044.9
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6328.2
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5351.3
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5135.4
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4928.8
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5996.5
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5287.4
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3674.7
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3462.9
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4153.6
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4661.7
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4355.1
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4599.5
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4699.6
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4204.0
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3453.3
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2994.9
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4012.3
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2411.7
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3706.4
   },
   {
    "Region Name": "Nana-Mamb\u00e9r\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4587.1
   }
  ],
  "Nandi (County of Kenya)": [
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nandi (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nangarhar (Province of Afghanistan)": [
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nangarhar (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nanumanga (Island Council of Tuvalu)": [
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumanga (Island Council of Tuvalu)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nanumea (Island Council of Tuvalu)": [
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nanumea (Island Council of Tuvalu)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Naoasaki (Prefecture of Japan)": [
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naoasaki (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Napo (Province of Ecuador)": [
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Napo (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Nara (Prefecture of Japan)": [
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nara (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Naranjito (Municipality of Puerto Rico)": [
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naranjito (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Narathiwat (Province of Thailand)": [
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Narathiwat (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nari\u00f1o (Department of Colombia)": [
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 135.5
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Nari\u00f1o (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.8
   }
  ],
  "Narok (County of Kenya)": [
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 978.2
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 769.4
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 325.2
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 325.2
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 558.2
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 182.4
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 215.0
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 111.7
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 86.0
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 212.7
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 238.8
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 189.7
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 235.8
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 194.9
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 175.8
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 208.6
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 339.3
   },
   {
    "Region Name": "Narok (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 310.4
   }
  ],
  "Naryn (Province of Kyrgyzstan)": [
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 126.3
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Naryn (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.1
   }
  ],
  "Nasarawa (State of Nigeria)": [
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2716.3
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3985.5
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5540.4
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3174.4
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5362.9
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3697.9
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1633.7
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3042.8
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1836.5
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1677.2
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2195.8
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1224.0
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1154.4
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2198.4
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 696.1
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1282.8
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1356.3
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 912.6
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1626.0
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2415.7
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 786.1
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1266.7
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1010.1
   },
   {
    "Region Name": "Nasarawa (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1158.2
   }
  ],
  "Nassa (Province of Mozambique)": [
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 37658.4
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 42614.2
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 35894.6
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 45992.9
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 43389.8
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 42980.6
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 48388.7
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 38740.3
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 47670.3
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 40549.4
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 42394.7
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 45624.6
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 39837.7
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 42515.6
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 46138.0
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 40922.6
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 39970.8
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 35241.6
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 36412.1
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 37411.9
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 49238.2
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 34940.6
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 38920.2
   },
   {
    "Region Name": "Nassa (Province of Mozambique)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 42632.8
   }
  ],
  "National Capital District (District of Papua New Guinea)": [
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "National Capital District (District of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Navassa (Island of United States Minor Outlying Isl)": [
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Navoiy (Region of Uzbekistan)": [
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 51.9
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 105.7
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Navoiy (Region of Uzbekistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.3
   }
  ],
  "Nayarit (State of M\u00e9xico)": [
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 172.8
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 384.4
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 206.0
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2165.3
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 305.9
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 691.8
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 413.9
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 311.0
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 196.1
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1030.7
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 785.7
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 403.2
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 413.7
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1036.5
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 380.5
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 678.7
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 156.3
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 501.8
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 494.5
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 733.1
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 802.6
   },
   {
    "Region Name": "Nayarit (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 453.6
   }
  ],
  "Naypyitaw (Union territory of Myanmar)": [
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Naypyitaw (Union territory of Myanmar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Na\u00e2ma (Province of Algeria)": [
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Na\u00e2ma (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Neam\u021b (County of Romania)": [
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Neam\u021b (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nebbi (District of Uganda)": [
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 691.3
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 849.8
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 495.2
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 571.1
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 305.3
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 450.8
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 602.2
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 472.7
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 401.9
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 718.6
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 577.5
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 474.4
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 523.5
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 464.1
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 632.8
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 407.5
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 355.6
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 394.2
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 245.9
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 498.6
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 306.8
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 207.3
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Nebbi (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 376.6
   }
  ],
  "Nebraska (State of United States)": [
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 118.1
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 300.1
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 158.4
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1176.5
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 129.9
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 214.4
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 82.7
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 121.3
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 141.9
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 218.4
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 447.4
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 251.0
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 112.8
   },
   {
    "Region Name": "Nebraska (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 218.2
   }
  ],
  "Negeri Sembilan (State of Malaysia)": [
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Negeri Sembilan (State of Malaysia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Negotino (Municipality of North Macedonia)": [
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Negotino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Negros Occidental (Province of Philippines)": [
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "Negros Occidental (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.2
   }
  ],
  "Negros Oriental (Province of Philippines)": [
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Negros Oriental (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nei Mongol (Autonomous Region of China)": [
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2276.6
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7439.7
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 847.0
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1822.6
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2952.1
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1256.0
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10135.6
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1339.2
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1177.5
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2430.7
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2097.6
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1576.9
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4992.0
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3274.7
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2206.1
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3222.8
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5079.5
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1357.2
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3683.7
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 901.6
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3190.2
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2121.6
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3351.9
   },
   {
    "Region Name": "Nei Mongol (Autonomous Region of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2002.6
   }
  ],
  "Nelson (Region of New Zealand)": [
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nelson (Region of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nenets (Autonomous Province of Russia)": [
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Neno (District of Malawi)": [
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 235.8
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 331.2
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 131.8
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 160.6
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 245.5
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 330.1
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 190.8
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 163.6
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 282.1
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 169.8
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 280.6
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 160.8
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 163.3
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 169.6
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 138.7
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 143.6
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 106.1
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 168.9
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 148.1
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Neno (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 99.5
   }
  ],
  "Neuch\u00e2tel (Canton of Switzerland)": [
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Neuch\u00e2tel (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Neuqu\u00e9n (Province of Argentina)": [
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 352.2
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 243.7
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 144.3
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 263.7
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 150.5
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 206.2
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 230.9
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 137.0
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 732.1
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 99.5
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 74.4
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 338.9
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 335.5
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 138.1
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 275.2
   },
   {
    "Region Name": "Neuqu\u00e9n (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 48.7
   }
  ],
  "Nevada (State of United States)": [
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 161.0
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 241.2
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 262.0
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3660.8
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4169.7
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2773.1
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 294.3
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 137.2
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1280.6
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2111.3
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 546.4
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 209.2
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 929.3
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3609.8
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3434.6
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 263.5
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1038.4
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 291.3
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 200.4
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 137.4
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 652.1
   },
   {
    "Region Name": "Nevada (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1367.7
   }
  ],
  "Nevsehir (Province of Turkey)": [
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 125.4
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 343.6
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 104.6
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 161.8
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 501.2
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 142.1
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Nevsehir (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "New Brunswick (Province of Canada)": [
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "New Brunswick (Province of Canada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 21.0
   }
  ],
  "New Hampshire (State of United States)": [
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Hampshire (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "New Ireland (Province of Papua New Guinea)": [
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "New Ireland (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "New Jersey (State of United States)": [
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Jersey (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 52.9
   }
  ],
  "New Mexico (State of United States)": [
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 733.8
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 607.1
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 320.3
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 343.4
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 582.9
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 138.9
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 538.9
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 806.7
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 259.6
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2928.3
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1293.9
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 582.2
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 138.1
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 129.9
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 277.6
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 275.0
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 867.8
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 239.7
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 387.4
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 419.3
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2751.6
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 183.1
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 192.1
   },
   {
    "Region Name": "New Mexico (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 449.7
   }
  ],
  "New Providence (District of Bahamas)": [
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "New Providence (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "New South Wales (State of Australia)": [
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 14074.6
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1974.3
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4307.5
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3820.1
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9304.9
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 959.3
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 865.8
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2828.8
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1221.5
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7705.3
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6369.8
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5910.4
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2252.6
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3124.4
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5475.6
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8334.0
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2931.5
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 42107.2
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1096.5
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5112.5
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3856.7
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7156.1
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3845.4
   },
   {
    "Region Name": "New South Wales (State of Australia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3765.0
   }
  ],
  "New Taipei (Special Municipality of Taiwan)": [
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "New York (State of United States)": [
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "New York (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Newfoundland and Labrador (Province of Canada)": [
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 385.6
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 192.1
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 337.4
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1383.8
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 747.5
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 184.4
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 98.0
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 181.1
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 153.3
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 488.8
   },
   {
    "Region Name": "Newfoundland and Labrador (Province of Canada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 146.4
   }
  ],
  "Ngarchelong (State of Palau)": [
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngarchelong (State of Palau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ngardmau (State of Palau)": [
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngardmau (State of Palau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ngatpang (State of Palau)": [
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngatpang (State of Palau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ngchesar (State of Palau)": [
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngchesar (State of Palau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ngeremlengui (State of Palau)": [
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngeremlengui (State of Palau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ngh\u1ec7 An (Province of Vietnam)": [
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 164.8
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 155.8
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 160.8
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 126.7
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 163.1
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 204.7
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Ngh\u1ec7 An (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 59.0
   }
  ],
  "Ngiwal (State of Palau)": [
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngiwal (State of Palau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ngouni\u00e9 (Province of Gabon)": [
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 168.7
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Ngouni\u00e9 (Province of Gabon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 22.1
   }
  ],
  "Ngozi (Province of Burundi)": [
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Ngozi (Province of Burundi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)": [
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 145.3
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ng\u00f6be Bugl\u00e9 (Indigenous Territory of Panama)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Niamey (Capital District of Niger)": [
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niamey (Capital District of Niger)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Niari (Region of Republic of the Congo)": [
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 279.1
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1228.1
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1748.2
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2882.4
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3476.2
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3142.9
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3600.8
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1802.2
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1746.2
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2076.4
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2110.2
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2791.3
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1913.5
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2872.8
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2655.8
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1754.0
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1828.8
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2961.1
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1333.4
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1779.0
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2616.4
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2020.6
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3452.4
   },
   {
    "Region Name": "Niari (Region of Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2295.9
   }
  ],
  "Nickerie (District of Suriname)": [
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 160.8
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 255.5
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 157.3
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 127.8
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 203.7
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 134.6
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 238.4
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 210.1
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 297.1
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 218.0
   },
   {
    "Region Name": "Nickerie (District of Suriname)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 29.2
   }
  ],
  "Nicosia (District of Cyprus)": [
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Cyprus)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nicosia (District of Northern Cyprus)": [
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nicosia (District of Northern Cyprus)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nidwalden (Canton of Switzerland)": [
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nidwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Niedersachsen (State of Germany)": [
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Niedersachsen (State of Germany)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Nieder\u00f6sterreich (State of Austria)": [
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nieder\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Nigde (Province of Turkey)": [
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Nigde (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.5
   }
  ],
  "Niger (State of Nigeria)": [
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 22651.5
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19649.1
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 27088.5
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20655.3
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23738.4
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21275.9
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17481.8
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20376.2
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16597.9
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17421.6
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14592.5
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13377.7
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10031.6
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11132.6
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7183.7
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8596.8
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6898.8
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7339.6
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10107.9
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12232.5
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10539.2
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12605.3
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11490.6
   },
   {
    "Region Name": "Niger (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8321.8
   }
  ],
  "Niigata (Prefecture of Japan)": [
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niigata (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Nik\u0161i\u0107 (Municipality of Montenegro)": [
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 124.5
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 127.1
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.9
   }
  ],
  "Nimba (County of Liberia)": [
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 123.3
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 588.7
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 107.0
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 177.7
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 415.2
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 207.9
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 284.7
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Nimba (County of Liberia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 69.9
   }
  ],
  "Nimroz (Province of Afghanistan)": [
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 85.7
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 123.0
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 158.8
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 148.3
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nimroz (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Ninawa (Province of Iraq)": [
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 320.1
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 256.2
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 674.6
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 214.6
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1327.6
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 851.5
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 361.9
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6376.0
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3047.0
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 116.4
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 111.9
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1145.6
   },
   {
    "Region Name": "Ninawa (Province of Iraq)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 52.9
   }
  ],
  "Ningxia Hui (Autonomous Region of China)": [
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 200.0
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 104.4
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 149.2
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Ningxia Hui (Autonomous Region of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ninh B\u00ecnh (Province of Vietnam)": [
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ninh B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.4
   }
  ],
  "Ninh Thu\u1eadn (Province of Vietnam)": [
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 194.6
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 127.5
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 150.1
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Ninh Thu\u1eadn (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.4
   }
  ],
  "Nippes (Department of Haiti)": [
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nippes (Department of Haiti)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nisporeni (District of Moldova)": [
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nisporeni (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.4
   }
  ],
  "Nitriansky (Region of Slovakia)": [
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nitriansky (Region of Slovakia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Niuas (Island Group of Tonga)": [
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niuas (Island Group of Tonga)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Niulakita (Island Council of Tuvalu)": [
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niulakita (Island Council of Tuvalu)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Niutao (Island Council of Tuvalu)": [
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Niutao (Island Council of Tuvalu)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nizhegorod (Region of Russia)": [
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 357.8
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 196.8
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 243.5
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1526.1
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 292.0
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 267.5
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1942.0
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2434.8
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 157.1
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 347.5
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 140.6
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 405.2
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 143.8
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 132.9
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Nizhegorod (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 40.5
   }
  ],
  "Ni\u0161avski (District of Serbia)": [
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ni\u0161avski (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.3
   }
  ],
  "Njaz\u00eddja (Autonomous Island of Comoros)": [
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 115.8
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Njaz\u00eddja (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Njombe (Region of Tanzania)": [
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 954.4
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3085.0
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 888.1
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3125.3
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 669.7
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1887.7
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1818.9
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1648.9
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2860.5
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 982.0
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1910.9
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1859.4
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 892.8
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1895.0
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1802.2
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1017.8
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 642.5
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1338.5
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1275.9
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1974.8
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1019.5
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1496.9
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1042.7
   },
   {
    "Region Name": "Njombe (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1946.5
   }
  ],
  "Nkhata Bay (District of Malawi)": [
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 223.6
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 585.2
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 153.9
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 877.0
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 115.8
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 178.4
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 505.1
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 199.6
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 752.2
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 193.8
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 792.5
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 340.4
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 287.9
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 743.6
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 678.7
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 185.6
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 353.3
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 320.7
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 197.9
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 516.2
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 447.0
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 545.1
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 395.7
   },
   {
    "Region Name": "Nkhata Bay (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 488.8
   }
  ],
  "Nkhotakota (District of Malawi)": [
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 201.7
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 565.7
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 190.6
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 642.5
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 194.2
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 294.8
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 454.9
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 265.6
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 769.8
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 603.4
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 784.8
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 573.4
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 593.2
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 552.0
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1006.0
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 305.9
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 583.5
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 421.0
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 604.1
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 395.7
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 397.0
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 238.6
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 295.8
   },
   {
    "Region Name": "Nkhotakota (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 293.3
   }
  ],
  "Nofsinhar (Region of Malta)": [
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nofsinhar (Region of Malta)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nong Bua Lam Phu (Province of Thailand)": [
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 178.8
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 256.2
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 315.1
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 308.0
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 176.6
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 123.3
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 33.9
   }
  ],
  "Nong Khai (Province of Thailand)": [
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Nong Khai (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.8
   }
  ],
  "Nonthaburi (Province of Thailand)": [
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nonthaburi (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Noord-Brabant (Province of Netherlands)": [
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Brabant (Province of Netherlands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Noord-Holland (Province of Netherlands)": [
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Noord-Holland (Province of Netherlands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nord (Department of Haiti)": [
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Nord (Department of Haiti)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Nord (Province of New Caledonia)": [
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 86.0
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 93.9
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Nord (Province of New Caledonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nord (Region of Burkina Faso)": [
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 295.2
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 188.2
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 362.7
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 173.0
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 118.5
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 227.9
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 290.9
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 283.4
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 140.0
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 141.3
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 203.9
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 310.2
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 219.7
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 114.5
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 110.4
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 96.5
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 197.0
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 252.1
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1274.6
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1607.8
   },
   {
    "Region Name": "Nord (Region of Burkina Faso)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1710.5
   }
  ],
  "Nord (Region of Cameroon)": [
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23937.9
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 23542.2
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 20485.7
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 23517.6
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 24273.4
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24557.5
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23403.5
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20975.1
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19345.9
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16687.8
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16960.2
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15618.9
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14826.8
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14609.9
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14829.4
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13010.7
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13573.0
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12439.4
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14610.1
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13626.6
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14042.0
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10904.5
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12817.3
   },
   {
    "Region Name": "Nord (Region of Cameroon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11799.7
   }
  ],
  "Nord-Est (Department of Haiti)": [
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Nord-Est (Department of Haiti)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.3
   }
  ],
  "Nord-Kivu (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1549.9
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 966.8
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1982.3
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1654.7
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 945.4
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1071.6
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 895.4
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1192.7
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1776.5
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2533.8
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1010.5
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1577.8
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1200.5
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1871.4
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1258.1
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 841.2
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1636.5
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1117.3
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1216.1
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1163.8
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1468.0
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1276.4
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1520.3
   },
   {
    "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 473.3
   }
  ],
  "Nord-Ouest (Department of Haiti)": [
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Ouest (Department of Haiti)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nord-Ouest (Region of Cameroon)": [
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 825.7
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2068.0
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1365.5
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1880.4
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1213.3
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 944.1
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1348.6
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1148.6
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1317.1
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1068.8
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 608.8
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 728.2
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 850.0
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1019.3
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 452.1
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 667.8
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 650.0
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1105.7
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 743.9
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 447.4
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 909.8
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 478.5
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 954.6
   },
   {
    "Region Name": "Nord-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 776.2
   }
  ],
  "Nord-Tr\u00f8ndelag (County of Norway)": [
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nord-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nord-Ubangi (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5622.7
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5273.7
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6071.1
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5729.2
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6991.6
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7187.8
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4431.0
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5289.1
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6609.6
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7318.3
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5926.0
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5085.9
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5143.8
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6543.2
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5169.5
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6498.2
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8523.3
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7426.8
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7098.2
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7634.8
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6971.9
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5891.1
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6540.8
   },
   {
    "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6121.7
   }
  ],
  "Norder\u00f8erne (Region of Faroe Islands)": [
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norder\u00f8erne (Region of Faroe Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nordjylland (Region of Denmark)": [
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordjylland (Region of Denmark)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nordland (County of Norway)": [
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordland (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nordrhein-Westfalen (State of Germany)": [
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nordrhein-Westfalen (State of Germany)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Normandie (Region of France)": [
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 128.4
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Normandie (Region of France)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.6
   }
  ],
  "Norrbotten (County of Sweden)": [
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Norrbotten (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Norte de Santander (Department of Colombia)": [
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Norte de Santander (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.4
   }
  ],
  "North (Governorate of Lebanon)": [
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Governorate of Lebanon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "North (Region of Singapore)": [
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North (Region of Singapore)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "North Abaco (District of Bahamas)": [
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "North Abaco (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.4
   }
  ],
  "North Andros (District of Bahamas)": [
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 143.8
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 142.8
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 93.7
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 119.2
   },
   {
    "Region Name": "North Andros (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 91.7
   }
  ],
  "North Bahr-al-Ghazal (State of South Sudan)": [
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 14246.5
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14227.7
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14434.1
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15067.8
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11902.0
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12137.1
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11901.8
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11669.6
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13473.3
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11665.5
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12518.3
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12599.3
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13734.6
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13246.5
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12933.7
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13078.7
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12767.8
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11852.9
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13013.9
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10977.6
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8635.9
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10321.9
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9097.6
   },
   {
    "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9332.3
   }
  ],
  "North Bank (Division of Gambia)": [
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 241.6
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 307.4
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 398.7
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 355.9
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 521.6
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 404.5
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 320.1
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 420.4
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 325.6
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 236.2
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 188.2
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 152.2
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 156.9
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 151.1
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 169.6
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 188.2
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 182.2
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 187.4
   },
   {
    "Region Name": "North Bank (Division of Gambia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 113.8
   }
  ],
  "North Caicos (District of Turks and Caicos Islands)": [
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "North Carolina (State of United States)": [
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 89.2
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 104.8
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 108.5
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 111.7
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 178.8
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 168.5
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 381.8
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 165.9
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 439.2
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 276.3
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 167.2
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 102.0
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 134.2
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 531.6
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 159.9
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 78.2
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 164.0
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 143.8
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 190.8
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 315.6
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 128.6
   },
   {
    "Region Name": "North Carolina (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 54.2
   }
  ],
  "North Cotabato (Province of Philippines)": [
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "North Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "North Dakota (State of United States)": [
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 331.6
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 252.3
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 243.3
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 224.4
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 446.1
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 141.1
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 128.4
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1303.1
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 558.9
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 128.4
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 246.7
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 141.3
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 305.9
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 215.4
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 225.5
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 152.6
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 118.8
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1033.9
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 167.2
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 56.0
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 207.7
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 125.8
   },
   {
    "Region Name": "North Dakota (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 86.6
   }
  ],
  "North Darfur (State of Sudan)": [
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1268.6
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5879.1
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4388.3
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6062.4
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2678.1
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12272.8
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6047.6
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9496.3
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4534.3
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 699.5
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8473.8
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6408.1
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4665.7
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2116.9
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4047.9
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2740.5
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5551.5
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5822.5
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11141.0
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7521.8
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6463.9
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4535.0
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14937.0
   },
   {
    "Region Name": "North Darfur (State of Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18390.3
   }
  ],
  "North East (Region of Ghana)": [
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3221.8
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2988.5
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2720.6
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4050.1
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2846.0
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2425.8
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2472.3
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2518.6
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2288.6
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3349.1
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2404.4
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2770.5
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2764.9
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2581.6
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2790.9
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2772.4
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2436.7
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2312.6
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2439.5
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2793.7
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2525.1
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2556.8
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2004.6
   },
   {
    "Region Name": "North East (Region of Ghana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2068.9
   }
  ],
  "North Eleuthera (District of Bahamas)": [
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "North Kazakhstan (Region of Kazakhstan)": [
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4665.5
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3621.1
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6212.6
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1036.0
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2854.3
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1239.7
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7591.0
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1036.5
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4529.6
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 385.4
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6108.2
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1307.2
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1283.0
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1370.2
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4106.7
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 806.0
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2045.3
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2023.2
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1072.5
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 770.9
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 541.5
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "North Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 835.4
   }
  ],
  "North Khorasan (Province of Iran)": [
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "North Khorasan (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.4
   }
  ],
  "North Kurdufan (State of Sudan)": [
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 589.3
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1724.4
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 448.5
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 340.0
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 218.7
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1086.2
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2012.1
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1526.5
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1318.6
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 154.6
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1169.4
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 882.3
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 936.4
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 149.0
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1424.5
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 412.7
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1213.8
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 188.0
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 895.2
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 565.5
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1928.2
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1054.1
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2733.2
   },
   {
    "Region Name": "North Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4086.1
   }
  ],
  "North Ossetia (Republic of Russia)": [
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 129.3
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 190.1
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 146.4
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 110.2
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 514.5
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 122.4
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 161.6
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 182.6
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 213.1
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 156.9
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 213.5
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 133.6
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "North Ossetia (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 263.5
   }
  ],
  "North Side (District of Cayman Islands)": [
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North Side (District of Cayman Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "North West (Province of South Africa)": [
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6857.4
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3922.3
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3870.4
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5964.2
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5051.2
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1860.1
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4472.0
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4131.5
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5482.5
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7487.9
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3399.0
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1363.0
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1989.8
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1491.6
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 112.1
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2509.6
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4631.2
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1569.6
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5363.7
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6632.4
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5599.1
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13284.7
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3026.0
   },
   {
    "Region Name": "North West (Province of South Africa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2155.5
   }
  ],
  "North-East (District of Botswana)": [
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 251.9
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 131.0
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "North-East (District of Botswana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 78.9
   }
  ],
  "North-East (Region of Singapore)": [
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "North-East (Region of Singapore)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "North-West (District of Botswana)": [
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18040.0
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9234.6
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8689.0
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7655.3
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 20494.1
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9035.4
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24276.9
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9517.1
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 29047.4
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 40628.3
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20046.9
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18002.1
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12207.7
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8269.1
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8197.7
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13494.7
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9033.7
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5313.8
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9420.9
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 22879.2
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11636.4
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17661.9
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5377.4
   },
   {
    "Region Name": "North-West (District of Botswana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7574.1
   }
  ],
  "North-Western (Province of Zambia)": [
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 29233.9
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 34039.7
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 37232.0
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 38506.0
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 30373.1
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 33117.0
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 34074.2
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27667.1
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 32978.7
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 32737.6
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 34390.8
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 33694.7
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 32803.6
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 39790.3
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 35987.0
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 36413.1
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 36785.9
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 40261.5
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38265.5
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 36219.6
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 41511.3
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 36952.7
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 45416.4
   },
   {
    "Region Name": "North-Western (Province of Zambia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 53207.9
   }
  ],
  "Northeast Greenland National Par (National Park of Greenland)": [
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Northern (Division of Fiji)": [
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Northern (Division of Fiji)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Northern (Governorate of Bahrain)": [
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (Governorate of Bahrain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Northern (Province of Sierra Leone)": [
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7126.7
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7469.9
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10281.1
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4386.2
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19386.5
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6128.0
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5630.0
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4602.5
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5157.7
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5828.1
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7762.3
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4891.0
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7672.7
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11559.6
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6795.9
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6164.2
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4962.2
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5947.7
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3744.0
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5683.4
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4591.4
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5712.5
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6185.6
   },
   {
    "Region Name": "Northern (Province of Sierra Leone)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3672.6
   }
  ],
  "Northern (Province of Zambia)": [
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 37303.6
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 41335.3
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 40413.7
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 41284.9
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 42380.3
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 39351.5
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 42739.4
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 36590.4
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 38891.9
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 34143.8
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 33548.3
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 37473.0
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34763.4
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 37197.1
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 35467.1
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 36655.6
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 31087.8
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 34068.4
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 32460.0
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 32927.9
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 32903.7
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 29820.4
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 32676.7
   },
   {
    "Region Name": "Northern (Province of Zambia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 36579.9
   }
  ],
  "Northern (Region of Ghana)": [
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8414.0
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7177.3
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7475.5
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9799.2
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8324.8
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6385.6
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6548.3
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7284.7
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7591.0
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9934.3
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6959.1
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7748.4
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7643.8
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9320.5
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8452.6
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9510.5
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9156.1
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9749.9
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8853.2
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8984.0
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6592.7
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8034.8
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6475.4
   },
   {
    "Region Name": "Northern (Region of Ghana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5415.0
   }
  ],
  "Northern (State of Sudan)": [
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Northern (State of Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Northern Cape (Province of South Africa)": [
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3642.6
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2093.3
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 734.4
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1358.5
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 803.5
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1357.0
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1022.5
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2597.9
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2539.0
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2987.9
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5403.2
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 925.0
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 467.8
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 774.5
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 669.3
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1024.7
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1736.4
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 345.3
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1173.5
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8255.4
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7937.9
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5613.5
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 712.1
   },
   {
    "Region Name": "Northern Cape (Province of South Africa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 567.0
   }
  ],
  "Northern Ireland (Constituent Country of United Kingdom)": [
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.6
   }
  ],
  "Northern Islands (Group of islands of New Zealand)": [
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Northern Islands (Municipality of Northern Mariana Islands)": [
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Northern Samar (Province of Philippines)": [
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northern Samar (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Northern Territory (Territory of Australia)": [
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 337515.2
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 116273.1
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 335644.0
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 102919.6
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 228160.0
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 280659.0
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 110987.2
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 167698.1
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 97232.8
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 524327.3
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 289376.7
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 90911.3
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 207459.2
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 225543.6
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 81480.4
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 213483.7
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 182595.7
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 107419.7
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 54574.3
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 117660.3
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 125036.7
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 353550.2
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 195693.4
   },
   {
    "Region Name": "Northern Territory (Territory of Australia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 202430.6
   }
  ],
  "Northland (Region of New Zealand)": [
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Northland (Region of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Northwest Territories (Territory of Canada)": [
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 194.2
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 922.6
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3576.7
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1270.6
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 470.3
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1925.5
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2791.1
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 104.8
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 934.6
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1086.6
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1613.1
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4282.4
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 22960.6
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3805.3
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1471.4
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8390.6
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 198.9
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 922.2
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1605.4
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4014.3
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 28134.9
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15716.5
   },
   {
    "Region Name": "Northwest Territories (Territory of Canada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8217.2
   }
  ],
  "Nor\u00f0urland eystra (Region of Iceland)": [
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland eystra (Region of Iceland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nor\u00f0urland vestra (Region of Iceland)": [
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nor\u00f0urland vestra (Region of Iceland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)": [
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Nouakchott (District of Mauritania)": [
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nouakchott (District of Mauritania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nouvelle-Aquitaine (Region of France)": [
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 223.4
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 146.2
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 265.0
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 110.2
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 208.2
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 99.7
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 340.0
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 396.4
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Nouvelle-Aquitaine (Region of France)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 178.6
   }
  ],
  "Nova Scotia (Province of Canada)": [
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 110.6
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 202.4
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nova Scotia (Province of Canada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 83.4
   }
  ],
  "Novatsi (Municipality of North Macedonia)": [
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "Novatsi (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Novgorod (Region of Russia)": [
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 254.7
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 113.8
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 171.7
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 185.4
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 274.2
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 350.5
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 264.7
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Novgorod (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.6
   }
  ],
  "Novo Selo (Municipality of North Macedonia)": [
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Novo Selo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Novosibirsk (Region of Russia)": [
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1245.5
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2503.6
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10929.0
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3823.3
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9404.2
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3309.2
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8564.0
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5771.2
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5618.0
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5990.8
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7035.6
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 748.1
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4717.0
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 504.4
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 830.9
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2130.0
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 743.0
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2381.0
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5315.9
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2857.1
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9607.8
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3175.7
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 194.6
   },
   {
    "Region Name": "Novosibirsk (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 82.1
   }
  ],
  "Nsanje (District of Malawi)": [
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 339.8
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 300.8
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 296.5
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 185.6
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 189.9
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 175.6
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 219.9
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 206.9
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 192.3
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 289.4
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 181.8
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 173.2
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 230.7
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 192.1
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 131.8
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 146.8
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 292.0
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 200.0
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 223.6
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 248.7
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 203.9
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 152.6
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 110.6
   },
   {
    "Region Name": "Nsanje (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 87.5
   }
  ],
  "Ntcheu (District of Malawi)": [
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 175.1
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 132.5
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 111.7
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 115.5
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 164.8
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 146.0
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 78.0
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 123.5
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Ntcheu (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 56.0
   }
  ],
  "Ntchisi (District of Malawi)": [
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 106.8
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Ntchisi (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30.4
   }
  ],
  "Ntungamo (District of Uganda)": [
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Ntungamo (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19.3
   }
  ],
  "Nueva Ecija (Province of Philippines)": [
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 113.0
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 91.7
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Nueva Ecija (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 32.8
   }
  ],
  "Nueva Esparta (State of Venezuela)": [
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nueva Esparta (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nueva Segovia (Department of Nicaragua)": [
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 124.8
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 177.7
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Nueva Segovia (Department of Nicaragua)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Nueva Vizcaya (Province of Philippines)": [
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Nueva Vizcaya (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 23.4
   }
  ],
  "Nuevo Le\u00f3n (State of M\u00e9xico)": [
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 72.7
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 462.0
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 364.9
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 94.5
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Nuevo Le\u00f3n (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 50.8
   }
  ],
  "Nugaal (Region of Somalia)": [
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nugaal (Region of Somalia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nui (Island Council of Tuvalu)": [
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nui (Island Council of Tuvalu)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nukufetau (Island Council of Tuvalu)": [
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukufetau (Island Council of Tuvalu)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nukulaelae (Island Council of Tuvalu)": [
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukulaelae (Island Council of Tuvalu)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nukunonu (Atoll of Tokelau)": [
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nukunonu (Atoll of Tokelau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nunavut (Territory of Canada)": [
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Nunavut (Territory of Canada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.6
   }
  ],
  "Nuristan (Province of Afghanistan)": [
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuristan (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nusa Tenggara Barat (Province of Indonesia)": [
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 183.3
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 186.9
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 207.9
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 136.8
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 91.3
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 123.7
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 140.0
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 265.8
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 193.1
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 78.2
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 210.1
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 179.4
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 504.6
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 123.9
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 264.3
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 114.9
   },
   {
    "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 31.5
   }
  ],
  "Nusa Tenggara Timur (Province of Indonesia)": [
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 370.9
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 275.7
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 358.2
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 308.9
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 689.2
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 481.5
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 419.1
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 327.3
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 308.0
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 329.1
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 339.6
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 423.2
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 525.2
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 306.8
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 226.4
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 342.8
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 224.9
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 450.6
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 322.4
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 131.0
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 266.0
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 261.7
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 216.5
   },
   {
    "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 205.8
   }
  ],
  "Nuwara Eliya (District of Sri Lanka)": [
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nuwara Eliya (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nyamira (County of Kenya)": [
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyamira (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nyandarua (County of Kenya)": [
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Nyandarua (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nyanga (Province of Gabon)": [
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 114.5
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 217.2
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 472.0
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 962.5
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 251.5
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1526.5
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 796.2
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 314.7
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 863.7
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 305.0
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 418.0
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 123.5
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1207.8
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 106.8
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 663.7
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 768.1
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1991.3
   },
   {
    "Region Name": "Nyanga (Province of Gabon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 324.6
   }
  ],
  "Nyeri (County of Kenya)": [
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 211.8
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 152.4
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Nyeri (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.1
   }
  ],
  "Nzwani (Autonomous Island of Comoros)": [
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Nzwani (Autonomous Island of Comoros)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)": [
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7248.2
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6671.4
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7062.0
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6153.0
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10917.6
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7870.3
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5446.0
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7443.5
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6308.2
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8900.6
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7413.1
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6891.7
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4451.6
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12362.4
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4825.4
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5034.2
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4701.5
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6712.1
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3777.6
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6078.9
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3742.7
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4530.7
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4701.1
   },
   {
    "Region Name": "Nz\u00e9r\u00e9kor\u00e9 (Region of Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2644.0
   }
  ],
  "N\u00f3gr\u00e1d (County of Hungary)": [
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "N\u00f3gr\u00e1d (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Oaxaca (State of M\u00e9xico)": [
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1171.5
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1937.3
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 710.6
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1723.5
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 729.7
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1205.8
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 994.2
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 688.8
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 665.8
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 961.4
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1091.4
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1391.7
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 455.7
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 821.5
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1033.9
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1487.5
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 784.4
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1814.0
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 948.4
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 953.1
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1078.5
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 988.7
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1776.9
   },
   {
    "Region Name": "Oaxaca (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 872.3
   }
  ],
  "Obalno-kra\u0161ka (Statistical Region of Slovenia)": [
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ober\u00f6sterreich (State of Austria)": [
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ober\u00f6sterreich (State of Austria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Obock (Region of Djibouti)": [
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obock (Region of Djibouti)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Obwalden (Canton of Switzerland)": [
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Obwalden (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Occidental Mindoro (Province of Philippines)": [
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 194.2
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 141.9
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 127.5
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 178.1
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 82.7
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 165.9
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 89.6
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 108.3
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 138.1
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 108.3
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 76.5
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 192.3
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 194.2
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 93.5
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 105.7
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 209.4
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Occidental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 92.8
   }
  ],
  "Occitanie (Region of France)": [
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Occitanie (Region of France)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 152.6
   }
  ],
  "Ocni\u021ba (District of Moldova)": [
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ocni\u021ba (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ocotepeque (Department of Honduras)": [
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ocotepeque (Department of Honduras)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Odessa (Region of Ukraine)": [
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1335.3
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 156.9
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 975.2
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1456.0
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1375.2
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1821.9
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3425.8
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1743.0
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1400.9
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1377.5
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 496.0
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1045.7
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2443.8
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2616.6
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3561.7
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2976.3
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1254.3
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1193.2
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 204.1
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 797.7
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 379.2
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 338.5
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 548.4
   },
   {
    "Region Name": "Odessa (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 474.0
   }
  ],
  "Odisha (State of India)": [
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 156.7
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 662.8
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1350.3
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 926.3
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 361.9
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1057.7
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 982.7
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1426.8
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1262.6
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1245.9
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1523.7
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1145.8
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1932.1
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 614.8
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1245.9
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 942.2
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1030.3
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 241.6
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 627.5
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2487.5
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 484.3
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 418.4
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 536.6
   },
   {
    "Region Name": "Odisha (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 418.9
   }
  ],
  "Offaly (County of Ireland)": [
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Offaly (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Ogoou\u00e9-Ivindo (Province of Gabon)": [
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Ogoou\u00e9-Ivindo (Province of Gabon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.5
   }
  ],
  "Ogoou\u00e9-Lolo (Province of Gabon)": [
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Ogoou\u00e9-Lolo (Province of Gabon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.2
   }
  ],
  "Ogoou\u00e9-Maritime (Province of Gabon)": [
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Ogoou\u00e9-Maritime (Province of Gabon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.6
   }
  ],
  "Ogun (State of Nigeria)": [
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1562.3
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 760.2
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1920.5
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 263.5
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 877.6
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 722.0
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 473.8
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 415.0
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 379.2
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 264.3
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 414.8
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 858.5
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 250.8
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1310.0
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 948.8
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 648.9
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 320.5
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2188.7
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 483.0
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 944.9
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1072.1
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 346.8
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 429.0
   },
   {
    "Region Name": "Ogun (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 600.2
   }
  ],
  "Ohangwena (Region of Namibia)": [
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 563.4
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 728.2
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 316.4
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 151.8
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 118.5
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 318.3
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 173.2
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 258.7
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 241.6
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 181.6
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Ohangwena (Region of Namibia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 144.9
   }
  ],
  "Ohio (State of United States)": [
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ohio (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.3
   }
  ],
  "Ohrid (Municipality of North Macedonia)": [
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ohrid (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Oio (Region of Guinea-Bissau)": [
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2124.2
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 808.2
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1647.9
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1257.5
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1955.0
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 978.4
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 823.4
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 578.4
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1020.8
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 844.8
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 897.3
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1037.3
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1333.4
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 277.2
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 510.0
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1002.8
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 780.7
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 683.2
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 787.6
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 344.1
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 326.1
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 797.2
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 243.1
   },
   {
    "Region Name": "Oio (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 168.1
   }
  ],
  "Oita (Prefecture of Japan)": [
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Oita (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24.7
   }
  ],
  "Okayama (Prefecture of Japan)": [
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okayama (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.9
   }
  ],
  "Okinawa (Prefecture of Japan)": [
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Okinawa (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Oklahoma (State of United States)": [
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 395.3
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2850.5
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1584.2
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2112.8
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 969.2
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1627.1
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2488.0
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2478.3
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1794.5
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2272.5
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 790.8
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 522.2
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1909.2
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1329.9
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2333.6
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1891.8
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2845.7
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1479.1
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1644.0
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1223.8
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1034.1
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 744.3
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1558.5
   },
   {
    "Region Name": "Oklahoma (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1359.3
   }
  ],
  "Olancho (Department of Honduras)": [
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 317.9
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3062.5
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2039.9
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 759.1
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 411.8
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 727.1
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 523.5
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 226.6
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2075.7
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 584.6
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 728.0
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 428.7
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 866.5
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 712.8
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 564.6
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2554.6
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 133.8
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 154.1
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 886.4
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 858.1
   },
   {
    "Region Name": "Olancho (Department of Honduras)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 47.6
   }
  ],
  "Olomouck\u00fd (Region of Czechia)": [
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Olomouck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Olt (County of Romania)": [
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 150.1
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 83.8
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 102.0
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 101.4
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 169.1
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 78.0
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Olt (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.9
   }
  ],
  "Omaheke (Region of Namibia)": [
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1453.4
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3157.4
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 337.4
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 272.2
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6657.0
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2075.7
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4385.1
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6171.0
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15706.0
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11718.3
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5014.5
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 347.1
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1342.8
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 705.1
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 274.2
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1623.2
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3002.5
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1077.6
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 586.1
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3415.5
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 183.3
   },
   {
    "Region Name": "Omaheke (Region of Namibia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 239.2
   }
  ],
  "Ombella-M'Poko (Prefecture of Central African Republic)": [
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9814.2
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9411.2
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9193.2
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5990.8
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10428.6
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11346.8
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8199.0
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9302.5
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8771.8
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11293.4
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8407.6
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7388.4
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7351.1
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9377.4
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7249.5
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6652.1
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8977.1
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6859.2
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4814.7
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6632.4
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6001.3
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3927.0
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5374.4
   },
   {
    "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1532.7
   }
  ],
  "Omsk (Region of Russia)": [
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 352.2
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1447.8
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7605.6
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 927.8
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4048.1
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 808.8
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9262.2
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4425.2
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7793.4
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2337.5
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4560.7
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 917.1
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5451.8
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 370.2
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 342.8
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 547.1
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1159.3
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 618.5
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1765.1
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4838.7
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9303.4
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6893.5
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Omsk (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.4
   }
  ],
  "Omusati (Region of Namibia)": [
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 590.6
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 228.1
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3615.5
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3613.0
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13006.2
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 484.7
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 428.3
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4490.6
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2177.3
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5846.7
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5750.0
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 885.8
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1548.8
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 340.6
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 971.3
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4877.1
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2143.3
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 118.1
   },
   {
    "Region Name": "Omusati (Region of Namibia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8686.9
   }
  ],
  "Onchan (District of Isle of Man)": [
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Onchan (District of Isle of Man)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ondo (State of Nigeria)": [
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 227.0
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 208.6
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 275.0
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 235.8
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 111.9
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 141.3
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 166.1
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 609.7
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 616.1
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 312.6
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 302.3
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1087.7
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 219.5
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 589.3
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 410.1
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 310.2
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 251.7
   },
   {
    "Region Name": "Ondo (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 115.8
   }
  ],
  "Ontario (Province of Canada)": [
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1580.8
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2896.8
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 414.6
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1311.1
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4547.6
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 988.0
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 325.6
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 259.2
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 575.2
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 756.3
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2101.5
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2207.4
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 102.9
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7157.4
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3431.6
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 739.1
   },
   {
    "Region Name": "Ontario (Province of Canada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4253.1
   }
  ],
  "Opolskie (Voivodeship of Poland)": [
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Opolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Oppland (County of Norway)": [
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oppland (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Oran (Province of Algeria)": [
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Oran (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Orange Walk (District of Belize)": [
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 134.2
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 300.3
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 173.6
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 111.3
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 107.8
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 135.9
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 153.3
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 86.6
   },
   {
    "Region Name": "Orange Walk (District of Belize)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 99.7
   }
  ],
  "Ordino (Parish of Andorra)": [
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordino (Parish of Andorra)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ordu (Province of Turkey)": [
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ordu (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Orebro (County of Sweden)": [
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orebro (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Oregon (State of United States)": [
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3300.0
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 887.1
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 523.9
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 731.2
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1787.2
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2093.7
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 838.4
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 428.7
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 495.8
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 959.1
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4566.9
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 955.0
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2999.5
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2096.7
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 706.3
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2276.8
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2626.2
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 402.4
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4433.8
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2823.5
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1546.0
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 771.1
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6701.2
   },
   {
    "Region Name": "Oregon (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1348.2
   }
  ],
  "Orel (Region of Russia)": [
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1654.5
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1090.9
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 866.7
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1455.6
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 648.3
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1478.1
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1963.4
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 614.2
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 447.6
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 127.1
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 114.7
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 138.3
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 93.7
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 113.6
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Orel (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 58.7
   }
  ],
  "Orellana (Province of Ecuador)": [
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orellana (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Orenburg (Region of Russia)": [
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4296.6
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6342.3
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2298.5
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7969.8
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2145.0
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4898.8
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6221.2
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4051.8
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4763.1
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 179.2
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2881.1
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 534.4
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3235.5
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2314.1
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 818.9
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3889.9
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3292.7
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2010.4
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1661.6
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2209.7
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2282.2
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1159.7
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 385.4
   },
   {
    "Region Name": "Orenburg (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1717.7
   }
  ],
  "Orhei (District of Moldova)": [
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhei (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Orhon (Municipality of Mongolia)": [
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orhon (Municipality of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Oriental (Region of Morocco)": [
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oriental (Region of Morocco)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Oriental Mindoro (Province of Philippines)": [
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Oriental Mindoro (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.9
   }
  ],
  "Oro (Province of Papua New Guinea)": [
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 162.1
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 168.9
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 213.1
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 111.9
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 111.3
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 89.4
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 136.3
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 235.2
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 102.0
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 101.6
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 93.5
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Oro (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 38.4
   }
  ],
  "Orocovis (Municipality of Puerto Rico)": [
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Orocovis (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Oromia (State of Ethiopia)": [
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12878.4
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9261.2
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10701.9
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11280.3
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8622.8
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9560.6
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7910.6
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7382.0
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9198.4
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9300.0
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7113.6
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7727.8
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7551.8
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6707.0
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7501.8
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6656.4
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6481.2
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4838.7
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6714.0
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6030.8
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6609.6
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5296.0
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6626.1
   },
   {
    "Region Name": "Oromia (State of Ethiopia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5410.2
   }
  ],
  "Oruro (Department of Bolivia)": [
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Oruro (Department of Bolivia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 21.4
   }
  ],
  "Osaka (Urban Prefecture of Japan)": [
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osaka (Urban Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Osh (Province of Kyrgyzstan)": [
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 112.8
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Osh (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.4
   }
  ],
  "Osh (city) (City of Kyrgyzstan)": [
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osh (city) (City of Kyrgyzstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Oshana (Region of Namibia)": [
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 252.5
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 91.3
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 278.3
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 795.7
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2151.6
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 319.0
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 434.3
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2629.9
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 379.0
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 867.6
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2965.8
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 308.5
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 138.1
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 349.6
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 311.3
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1423.6
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "Oshana (Region of Namibia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1089.9
   }
  ],
  "Oshikoto (Region of Namibia)": [
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 192.5
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 123.0
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2197.1
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1591.7
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1661.8
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 388.2
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 93.5
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2481.3
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 263.0
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5121.9
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5478.6
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 399.8
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 279.5
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 190.8
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 751.1
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1908.5
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 391.9
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5252.0
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5154.7
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 127.5
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Oshikoto (Region of Namibia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1504.0
   }
  ],
  "Osjecko-Baranjska (County of Croatia)": [
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osjecko-Baranjska (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Oslo (County of Norway)": [
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oslo (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Osmaniye (Province of Turkey)": [
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 326.3
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 278.3
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 643.3
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 238.2
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 413.5
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 242.7
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 174.1
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 135.5
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 165.1
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 204.9
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 251.5
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 215.7
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 319.4
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 486.6
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 144.1
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 196.1
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 104.2
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 176.6
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 121.3
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Osmaniye (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.0
   }
  ],
  "Osrednjeslovenska (Statistical Region of Slovenia)": [
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Osun (State of Nigeria)": [
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 219.7
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 94.8
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 222.7
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 135.5
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 251.2
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 135.5
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 425.7
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 115.1
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 143.4
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Osun (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Otago (Region of New Zealand)": [
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Otago (Region of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Otdar Mean Chey (Province of Cambodia)": [
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1027.0
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1632.8
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1796.6
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1310.2
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1952.3
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1224.0
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1650.4
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1316.2
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1907.0
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1856.9
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1478.1
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1138.7
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1425.1
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1362.5
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1419.3
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1664.4
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 958.9
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 664.3
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 678.3
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 271.6
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 386.1
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 388.0
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 511.9
   },
   {
    "Region Name": "Otdar Mean Chey (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 528.8
   }
  ],
  "Other Islands (District of British Virgin Islands)": [
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Other Islands (District of British Virgin Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Oti (Region of Ghana)": [
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1799.0
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2034.1
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3409.8
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1652.4
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3866.1
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2468.2
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1787.2
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1644.0
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2402.9
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2194.9
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1693.7
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1290.9
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2370.9
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2748.2
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1901.9
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1579.5
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1508.3
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3248.1
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1841.4
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1974.6
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1867.6
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1560.0
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1483.9
   },
   {
    "Region Name": "Oti (Region of Ghana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1483.4
   }
  ],
  "Otjozondjupa (Region of Namibia)": [
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4066.4
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4197.6
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4312.7
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5689.8
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5771.0
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10852.9
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4269.4
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14087.3
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12849.5
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19367.0
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 25590.3
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6932.1
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5699.9
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4265.9
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2585.3
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3588.3
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4841.1
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 346.8
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6414.6
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7068.2
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6034.7
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5726.2
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1172.0
   },
   {
    "Region Name": "Otjozondjupa (Region of Namibia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1169.4
   }
  ],
  "Ouadda\u00ef (Region of Chad)": [
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 144.5
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 244.6
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 101.4
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 180.9
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 329.3
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 240.5
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 87.5
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 112.1
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 127.1
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 51.9
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Ouadda\u00ef (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 48.2
   }
  ],
  "Ouaka (Prefecture of Central African Republic)": [
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13022.5
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13111.7
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11975.3
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8647.9
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15832.2
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9809.5
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10773.8
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9528.9
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11347.6
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10336.9
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8294.4
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8654.7
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7076.5
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11560.9
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7971.5
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9224.7
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8373.7
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7415.0
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5672.0
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7200.4
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6437.1
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5675.8
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5533.3
   },
   {
    "Region Name": "Ouaka (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5885.9
   }
  ],
  "Ouangani (Commune of Mayotte)": [
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouangani (Commune of Mayotte)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ouargla (Province of Algeria)": [
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouargla (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Oud\u00f4mxai (Province of Laos)": [
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 120.3
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 267.3
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2085.8
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 117.7
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 258.5
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1331.7
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 307.2
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 311.3
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1130.8
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 207.7
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 706.6
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 861.5
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 605.4
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 821.7
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1830.5
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 570.7
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 216.9
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 674.6
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2491.0
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 666.7
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 530.3
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3461.8
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2364.9
   },
   {
    "Region Name": "Oud\u00f4mxai (Province of Laos)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 694.6
   }
  ],
  "Oued el Dahab (Province of Western Sahara)": [
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oued el Dahab (Province of Western Sahara)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ouest (Department of Haiti)": [
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ouest (Department of Haiti)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Ouest (Region of Cameroon)": [
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2173.7
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2850.5
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1506.4
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2846.4
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1771.1
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1170.2
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1478.5
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1597.7
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1319.7
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1275.3
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 958.9
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 491.3
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 598.3
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 555.9
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 284.3
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 279.1
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 335.3
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 506.6
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 300.3
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 301.8
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 285.3
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 152.4
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 505.1
   },
   {
    "Region Name": "Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 266.7
   }
  ],
  "Ouham (Prefecture of Central African Republic)": [
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13896.9
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11153.8
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15475.3
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11137.1
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14968.5
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14208.8
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8379.5
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10876.4
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10256.7
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13556.7
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11637.0
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9701.3
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9522.7
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16326.6
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13599.4
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10467.4
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13324.5
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10418.1
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11258.4
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13976.9
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9924.4
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9718.0
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10643.0
   },
   {
    "Region Name": "Ouham (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5237.7
   }
  ],
  "Ouham-Pend\u00e9 (Prefecture of Central African Republic)": [
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2499.3
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4152.8
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3003.1
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3623.7
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4746.6
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6695.6
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4254.8
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4937.1
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3622.6
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3542.9
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2582.9
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2488.2
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3116.9
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6170.0
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5246.9
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3754.9
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4682.2
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3604.6
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3418.5
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2946.7
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2068.9
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3526.8
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4512.0
   },
   {
    "Region Name": "Ouham-Pend\u00e9 (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2343.5
   }
  ],
  "Oulu (Province of Finland)": [
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oulu (Province of Finland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Oum el Bouaghi (Province of Algeria)": [
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Oum el Bouaghi (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Outer Islands (Outer Islands of Seychelles)": [
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Outer Islands (Outer Islands of Seychelles)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ou\u00e9m\u00e9 (Department of Benin)": [
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 242.5
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 126.0
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 160.1
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 169.8
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Ou\u00e9m\u00e9 (Department of Benin)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.4
   }
  ],
  "Overijssel (Province of Netherlands)": [
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Overijssel (Province of Netherlands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Oyo (State of Nigeria)": [
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4173.3
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3848.6
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7337.4
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1150.5
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3955.1
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2466.1
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1674.9
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2069.9
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2255.6
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1520.3
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1986.8
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1887.1
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 726.3
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2313.0
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1184.8
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 522.0
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1050.2
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1787.8
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 640.5
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 864.3
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1259.0
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 692.4
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 436.5
   },
   {
    "Region Name": "Oyo (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1233.3
   }
  ],
  "P'y\u014fngan-bukto (Province of North Korea)": [
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 90.2
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 55.5
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 86.6
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "P'y\u014fngan-bukto (Province of North Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.9
   }
  ],
  "P'y\u014fngan-namdo (Province of North Korea)": [
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 176.9
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "P'y\u014fngan-namdo (Province of North Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "P'y\u014fngyang (Special City of North Korea)": [
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "P'y\u014fngyang (Special City of North Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pader (District of Uganda)": [
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2136.8
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4227.1
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4517.0
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6960.8
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3553.6
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4068.3
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3692.1
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2496.1
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2003.1
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2473.0
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1202.8
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1313.4
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1442.7
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1480.4
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2012.5
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1669.9
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1263.1
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 622.1
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1107.0
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1444.0
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1301.6
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 732.1
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 653.2
   },
   {
    "Region Name": "Pader (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 943.0
   }
  ],
  "Pahang (State of Malaysia)": [
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 169.1
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 90.2
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 264.7
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 105.0
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 96.0
   },
   {
    "Region Name": "Pahang (State of Malaysia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.1
   }
  ],
  "Paktika (Province of Afghanistan)": [
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktika (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Paktya (Province of Afghanistan)": [
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paktya (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Palauli (District of Samoa)": [
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palauli (District of Samoa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Palawan (Province of Philippines)": [
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 94.5
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Palawan (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Pallisa (District of Uganda)": [
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Pallisa (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Palmerston (Island Council of Cook Islands)": [
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmerston (Island Council of Cook Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Palmyra (Atoll of United States Minor Outlying Isl)": [
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pamandzi (Commune of Mayotte)": [
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamandzi (Commune of Mayotte)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pampanga (Province of Philippines)": [
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Pampanga (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 33.4
   }
  ],
  "Pamplemousses (District of Mauritius)": [
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pamplemousses (District of Mauritius)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Panam\u00e1 (Province of Panama)": [
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 461.1
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 191.4
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 156.3
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 300.3
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 156.5
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 181.6
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Panam\u00e1 (Province of Panama)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.1
   }
  ],
  "Panam\u00e1 Oeste (Province of Panama)": [
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Panam\u00e1 Oeste (Province of Panama)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pando (Department of Bolivia)": [
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 355.2
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 208.2
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 267.7
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1063.3
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 238.2
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 770.4
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 226.2
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 176.0
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 832.8
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 160.3
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 219.9
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 251.9
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 167.4
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 261.1
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 116.0
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 194.6
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 172.8
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 291.1
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 250.6
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 476.8
   },
   {
    "Region Name": "Pando (Department of Bolivia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 134.4
   }
  ],
  "Panevezio (County of Lithuania)": [
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Panevezio (County of Lithuania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Pangasinan (Province of Philippines)": [
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Pangasinan (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.8
   }
  ],
  "Panjshir (Province of Afghanistan)": [
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Panjshir (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Paphos (District of Cyprus)": [
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Paphos (District of Cyprus)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.6
   }
  ],
  "Papua (Province of Indonesia)": [
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3032.2
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 999.8
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3481.8
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 682.3
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2082.6
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 189.3
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 198.7
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 928.6
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 555.0
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 792.7
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1081.3
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2990.9
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5901.8
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 389.3
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2518.2
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1862.4
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 771.3
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2296.1
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 208.4
   },
   {
    "Region Name": "Papua (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19.5
   }
  ],
  "Papua Barat (Province of Indonesia)": [
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 141.3
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 195.7
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Papua Barat (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Para (District of Suriname)": [
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Para (District of Suriname)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Paraguar\u00ed (Department of Paraguay)": [
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 205.6
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1551.0
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1092.2
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1789.8
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 636.2
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 801.7
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 895.0
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 903.6
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 314.3
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1478.7
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 678.0
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 885.6
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 226.8
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 412.7
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 884.5
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1079.1
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1247.2
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 872.1
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2227.7
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1991.3
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 868.0
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 562.3
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 648.5
   },
   {
    "Region Name": "Paraguar\u00ed (Department of Paraguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 737.4
   }
  ],
  "Paramaribo (District of Suriname)": [
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paramaribo (District of Suriname)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Paran\u00e1 (State of Brazil)": [
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1744.3
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1792.8
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1305.3
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1349.2
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1949.7
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1825.1
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1826.6
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1352.0
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2193.4
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2668.7
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2176.9
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1404.5
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1892.9
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1255.8
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1625.8
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1691.6
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1037.1
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1239.7
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 510.2
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 643.1
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 171.3
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 342.6
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1176.5
   },
   {
    "Region Name": "Paran\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 216.3
   }
  ],
  "Para\u00edba (State of Brazil)": [
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 279.8
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 339.1
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 348.1
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 312.8
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 293.9
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 289.8
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 155.6
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 148.8
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 347.9
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 463.5
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 262.2
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 125.6
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 380.1
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 121.5
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 274.0
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 450.4
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 335.7
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 273.7
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 188.9
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 241.0
   },
   {
    "Region Name": "Para\u00edba (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 112.8
   }
  ],
  "Pardubick\u00fd (Region of Czechia)": [
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pardubick\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Paro (District of Bhutan)": [
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Paro (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Parwan (Province of Afghanistan)": [
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Parwan (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Par\u00e1 (State of Brazil)": [
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23733.4
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12879.7
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23341.6
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27942.8
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13328.6
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 35107.9
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15718.6
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12188.8
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 34942.6
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7893.7
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13423.8
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4330.9
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11157.3
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21094.1
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7397.2
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 30846.8
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3838.1
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12707.8
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18420.9
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5560.7
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15524.8
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13743.6
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36427.1
   },
   {
    "Region Name": "Par\u00e1 (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3986.6
   }
  ],
  "Pasco (Region of Peru)": [
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Pasco (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Pastaza (Province of Ecuador)": [
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pastaza (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pathum Thani (Province of Thailand)": [
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 191.2
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Pathum Thani (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Patillas (Municipality of Puerto Rico)": [
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Patrick (Parish District of Isle of Man)": [
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Patrick (Parish District of Isle of Man)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pattani (Province of Thailand)": [
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pattani (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pavlodar (Region of Kazakhstan)": [
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19704.6
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9224.3
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3538.4
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7258.7
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8163.0
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6043.1
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8169.4
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1566.0
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11732.4
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1146.9
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4838.1
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 353.1
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3592.4
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3234.8
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3584.7
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2091.8
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 429.8
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8602.2
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5307.8
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2774.1
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1397.0
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1538.3
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 132.1
   },
   {
    "Region Name": "Pavlodar (Region of Kazakhstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 348.3
   }
  ],
  "Pays de la Loire (Region of France)": [
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pays de la Loire (Region of France)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Paysand\u00fa (Department of Uruguay)": [
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Paysand\u00fa (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.4
   }
  ],
  "Pazardzhik (Province of Bulgaria)": [
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Pazardzhik (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.2
   }
  ],
  "Pa\u00eds Vasco (Autonomous Community of Spain)": [
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pa\u00eds Vasco (Autonomous Community of Spain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pa\u00fal (County of Cabo Verde)": [
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pa\u00fal (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pedernales (Province of Dominican Republic)": [
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 92.4
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pedernales (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Peel (Town District of Isle of Man)": [
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peel (Town District of Isle of Man)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Peh\u010devo (Municipality of North Macedonia)": [
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Peh\u010devo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Peipsi (Water body of Estonia)": [
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peipsi (Water body of Estonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Peleliu (State of Palau)": [
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peleliu (State of Palau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Peloponnese, Western Greece and (Decentralized administration of Greece)": [
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2053.4
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 123.0
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 409.2
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 140.0
   },
   {
    "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 126.5
   }
  ],
  "Pema Gatshel (District of Bhutan)": [
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Pema Gatshel (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Pembroke (Parish of Bermuda)": [
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pembroke (Parish of Bermuda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Penal-Debe (Region of Trinidad and Tobago)": [
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Penama (Province of Vanuatu)": [
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penama (Province of Vanuatu)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Penhryn (Island Council of Cook Islands)": [
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Penhryn (Island Council of Cook Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pennsylvania (State of United States)": [
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Pennsylvania (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Penza (Region of Russia)": [
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1037.1
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 165.1
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 870.1
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 552.0
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1282.1
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 335.7
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1249.6
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2339.2
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 462.6
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 312.3
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 519.4
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 257.5
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 126.5
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 376.2
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 332.9
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 350.5
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 494.1
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 107.4
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 146.8
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 190.1
   },
   {
    "Region Name": "Penza (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30.0
   }
  ],
  "Perak (State of Malaysia)": [
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 92.2
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 75.5
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Perak (State of Malaysia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19.7
   }
  ],
  "Peravia (Province of Dominican Republic)": [
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Peravia (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Perlis (State of Malaysia)": [
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 99.7
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Perlis (State of Malaysia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Perm' (Territory of Russia)": [
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 132.1
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 147.9
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 398.5
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 156.1
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Perm' (Territory of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Pernambuco (State of Brazil)": [
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 346.6
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 179.9
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 357.1
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 382.9
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 209.0
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 271.6
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 478.0
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 245.5
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 253.4
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 361.2
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 380.1
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 173.9
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 254.5
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 399.4
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 172.8
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 263.2
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 186.3
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 115.5
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 164.2
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 178.4
   },
   {
    "Region Name": "Pernambuco (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 191.2
   }
  ],
  "Pernik (Province of Bulgaria)": [
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pernik (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pest (County of Hungary)": [
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Pest (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Petrovec (Municipality of North Macedonia)": [
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Petrovec (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pet\u00e9n (Department of Guatemala)": [
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2030.7
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6267.1
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 468.4
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4601.2
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 669.9
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3419.4
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1011.6
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2364.9
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1358.0
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1019.3
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 777.5
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1435.4
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 345.6
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 879.1
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1692.9
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 829.8
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 200.2
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 717.9
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1143.0
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 188.4
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 301.8
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 546.9
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1399.8
   },
   {
    "Region Name": "Pet\u00e9n (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 428.7
   }
  ],
  "Pe\u00f1uelas (Municipality of Puerto Rico)": [
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u00f1uelas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pe\u0107ki (District of Kosovo)": [
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pe\u0107ki (District of Kosovo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.6
   }
  ],
  "Phalombe (District of Malawi)": [
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Phalombe (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.6
   }
  ],
  "Phangnga (Province of Thailand)": [
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phangnga (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Phatthalung (Province of Thailand)": [
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phatthalung (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Phayao (Province of Thailand)": [
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 136.3
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 118.1
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 438.2
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 223.4
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 294.5
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 114.9
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 111.5
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 270.1
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 156.5
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 123.7
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 210.5
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 88.3
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 374.9
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 392.9
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 106.1
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Phayao (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 37.1
   }
  ],
  "Phetchabun (Province of Thailand)": [
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 694.6
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1023.8
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1584.2
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 767.7
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 999.8
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 774.7
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 658.1
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 496.0
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 604.7
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 175.1
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 282.1
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 566.4
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 592.3
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 316.4
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 707.4
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 193.1
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 268.6
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 614.4
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 414.6
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 117.5
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 218.2
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 312.8
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 205.6
   },
   {
    "Region Name": "Phetchabun (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 241.8
   }
  ],
  "Phetchaburi (Province of Thailand)": [
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Phetchaburi (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 39.2
   }
  ],
  "Phichit (Province of Thailand)": [
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 586.9
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 439.2
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 152.6
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 244.8
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 328.0
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 107.6
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 144.1
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 162.5
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 200.6
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 534.2
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 141.3
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 276.8
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 256.2
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 379.9
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 270.5
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 227.4
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 105.5
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Phichit (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 57.9
   }
  ],
  "Phitsanulok (Province of Thailand)": [
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 397.4
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 814.0
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 930.1
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 643.5
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 563.4
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 349.0
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 356.3
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 341.1
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 371.3
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 127.3
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 471.6
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 277.4
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 376.4
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 213.5
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 227.4
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 174.1
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 243.3
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 433.5
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 395.7
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 115.1
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 182.0
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Phitsanulok (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.6
   }
  ],
  "Phnom Penh (Municipality of Cambodia)": [
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phnom Penh (Municipality of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Phra Nakhon Si Ayutthaya (Province of Thailand)": [
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 135.3
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 314.3
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 268.0
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 165.7
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 200.2
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 236.2
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 227.9
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 405.2
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 232.8
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 268.6
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 522.8
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 260.2
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 368.3
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 115.1
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 262.0
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 451.5
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 273.5
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 283.2
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 248.5
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 124.8
   }
  ],
  "Phrae (Province of Thailand)": [
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 157.6
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 339.6
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 145.1
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 190.6
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 233.9
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 250.4
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 165.1
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 170.4
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 123.0
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 120.5
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 180.1
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 118.1
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 200.2
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 236.7
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 180.7
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 125.2
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 184.8
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 112.1
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 140.8
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 120.3
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 167.2
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 199.4
   },
   {
    "Region Name": "Phrae (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 45.9
   }
  ],
  "Phuket (Province of Thailand)": [
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Phuket (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ph\u00f4ngsali (Province of Laos)": [
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 171.1
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 492.6
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 831.5
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 187.8
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 397.0
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1999.0
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 154.1
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 198.9
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 870.3
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 323.9
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 355.2
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 217.8
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 242.2
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 456.2
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 117.7
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 74.4
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 362.7
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 666.7
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 136.1
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1272.9
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 990.2
   },
   {
    "Region Name": "Ph\u00f4ngsali (Province of Laos)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 37.1
   }
  ],
  "Ph\u00fa Th\u1ecd (Province of Vietnam)": [
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Ph\u00fa Th\u1ecd (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ph\u00fa Y\u00ean (Province of Vietnam)": [
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 87.5
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 143.4
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 152.8
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 95.8
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 105.3
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 96.5
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 109.8
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 120.9
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 177.5
   },
   {
    "Region Name": "Ph\u00fa Y\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 31.5
   }
  ],
  "Piau\u00ed (State of Brazil)": [
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10742.5
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7026.2
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7374.1
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9922.1
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4593.5
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21143.6
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5347.9
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4855.5
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 24989.4
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12854.2
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24065.3
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6975.4
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12690.9
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16961.9
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9299.1
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9469.3
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10615.1
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13821.2
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10960.7
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16642.3
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10995.8
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14060.9
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10582.3
   },
   {
    "Region Name": "Piau\u00ed (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12689.1
   }
  ],
  "Pichincha (Province of Ecuador)": [
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Pichincha (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Piemonte (Region of Italy)": [
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 115.8
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 466.7
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 110.4
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 204.7
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 180.9
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 129.3
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 237.7
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 187.8
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Piemonte (Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Pinar del R\u00edo (Province of Cuba)": [
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 199.4
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 200.6
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 93.9
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 97.5
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 110.6
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 171.1
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 123.3
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 133.1
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 149.8
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 272.9
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 144.7
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 164.8
   },
   {
    "Region Name": "Pinar del R\u00edo (Province of Cuba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 356.7
   }
  ],
  "Pirotski (District of Serbia)": [
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Pirotski (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Piti (Municipality of Guam)": [
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piti (Municipality of Guam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Piura (Region of Peru)": [
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 181.6
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 130.8
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Piura (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 43.3
   }
  ],
  "Plaines Wilhems (District of Mauritius)": [
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plaines Wilhems (District of Mauritius)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Planken (Commune of Liechtenstein)": [
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Planken (Commune of Liechtenstein)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Plasnica (Municipality of North Macedonia)": [
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Plasnica (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Plateau (Department of Benin)": [
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 321.3
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 330.6
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 733.8
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 133.1
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 362.7
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 185.4
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 135.9
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 317.5
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 250.0
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 215.2
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 261.1
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 275.0
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 244.4
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 207.3
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 210.7
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 185.6
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 141.5
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 325.6
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 271.8
   },
   {
    "Region Name": "Plateau (Department of Benin)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 62.4
   }
  ],
  "Plateau (State of Nigeria)": [
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5139.3
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5990.1
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5944.0
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6188.0
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8403.1
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4996.7
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4819.2
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3741.6
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3290.1
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2682.6
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1644.0
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3939.9
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4068.3
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3950.8
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1587.2
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1932.5
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1889.9
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1109.6
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 999.6
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 951.6
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2160.0
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1445.3
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1443.8
   },
   {
    "Region Name": "Plateau (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2141.3
   }
  ],
  "Plateau-Central (Region of Burkina Faso)": [
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 370.9
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 204.5
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 153.3
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 81.9
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 136.6
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 137.8
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 205.8
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 131.4
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 114.5
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 98.0
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Plateau-Central (Region of Burkina Faso)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.5
   }
  ],
  "Plateaux (Region of Republic of the Congo)": [
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11186.0
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13472.2
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13918.6
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14596.8
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16114.8
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13821.7
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10903.9
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13091.5
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14106.3
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15163.8
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14108.9
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14098.4
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13744.3
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15023.6
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13148.5
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15452.8
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13485.3
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16311.1
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14627.7
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12363.7
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14896.9
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12815.8
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15803.9
   },
   {
    "Region Name": "Plateaux (Region of Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13206.4
   }
  ],
  "Plateaux (Region of Togo)": [
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2178.4
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2823.5
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6771.5
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1948.8
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4414.5
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2854.1
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2742.4
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2625.4
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4325.5
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2935.1
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2612.9
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2410.2
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3364.5
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3959.6
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1785.9
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1903.6
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1813.1
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2638.2
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1625.3
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1822.1
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1411.6
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 718.6
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1284.9
   },
   {
    "Region Name": "Plateaux (Region of Togo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1322.2
   }
  ],
  "Plav (Municipality of Montenegro)": [
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plav (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pleven (Province of Bulgaria)": [
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 257.9
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 180.5
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 264.5
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 94.3
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 110.2
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 113.8
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 354.1
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Pleven (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pljevlja (Municipality of Montenegro)": [
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pljevlja (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Plovdiv (Province of Bulgaria)": [
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Plovdiv (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.5
   }
  ],
  "Plu\u017eine (Municipality of Montenegro)": [
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plu\u017eine (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.4
   }
  ],
  "Plze\u0148sk\u00fd (Region of Czechia)": [
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Plze\u0148sk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.5
   }
  ],
  "Podgorica (Municipality of Montenegro)": [
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 129.5
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 171.1
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Podgorica (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 80.0
   }
  ],
  "Podkarpackie (Voivodeship of Poland)": [
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podkarpackie (Voivodeship of Poland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Podlaskie (Voivodeship of Poland)": [
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podlaskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Podravska (Statistical Region of Slovenia)": [
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podravska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Podunavski (District of Serbia)": [
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Podunavski (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pohnpei (State of Micronesia)": [
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pohnpei (State of Micronesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Point Fortin (Borough of Trinidad and Tobago)": [
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pointe La Rue (District of Seychelles)": [
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe La Rue (District of Seychelles)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pointe Noire (Region of Republic of the Congo)": [
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe Noire (Region of Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pointe-\u00e0-Pitre (District of Guadeloupe)": [
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pointe-\u00e0-Pitre (District of Guadeloupe)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Polonnaruwa (District of Sri Lanka)": [
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Polonnaruwa (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.9
   }
  ],
  "Poltava (Region of Ukraine)": [
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3106.6
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 640.5
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1313.4
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2716.3
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1244.4
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2560.6
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3400.5
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2780.4
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 617.6
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1068.4
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 442.9
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 780.3
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2823.5
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2392.8
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 584.8
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1611.4
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 932.1
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4008.5
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 773.0
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 201.7
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 153.3
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 510.8
   },
   {
    "Region Name": "Poltava (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 295.4
   }
  ],
  "Pomeroon-Supenaam (Region of Guyana)": [
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 139.1
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 140.6
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 128.4
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 148.3
   },
   {
    "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19.3
   }
  ],
  "Pomoravski (District of Serbia)": [
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Pomoravski (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pomorskie (Voivodeship of Poland)": [
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Pomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.2
   }
  ],
  "Pomurska (Statistical Region of Slovenia)": [
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pomurska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ponce (Municipality of Puerto Rico)": [
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ponce (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pool (Region of Republic of the Congo)": [
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6460.4
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10587.9
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9836.3
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11107.1
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10405.0
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9116.3
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9382.1
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9897.8
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11246.7
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11124.5
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9733.9
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10040.2
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8611.4
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10509.2
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10659.5
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11252.9
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12843.3
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10657.1
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8407.6
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9196.0
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10230.5
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9205.6
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10743.1
   },
   {
    "Region Name": "Pool (Region of Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9085.8
   }
  ],
  "Port Erin (Village District of Isle of Man)": [
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Erin (Village District of Isle of Man)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Port Glaud (District of Seychelles)": [
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Glaud (District of Seychelles)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Port Louis (District of Mauritius)": [
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Louis (District of Mauritius)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Port Saint Mary (Village District of Isle of Man)": [
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port Saint Mary (Village District of Isle of Man)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Port of Spain (City of Trinidad and Tobago)": [
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Port of Spain (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Portalegre (District of Portugal)": [
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 902.9
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 102.9
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Portalegre (District of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.2
   }
  ],
  "Portland (Parish of Jamaica)": [
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Portland (Parish of Jamaica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Porto (District of Portugal)": [
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 202.8
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 114.0
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 164.4
   },
   {
    "Region Name": "Porto (District of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 25.9
   }
  ],
  "Porto Novo (County of Cabo Verde)": [
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Porto Novo (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Portuguesa (State of Venezuela)": [
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 810.7
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1562.3
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 874.2
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1308.5
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 980.3
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 759.7
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1030.5
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1083.6
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 770.4
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 555.4
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 666.7
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 957.4
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1090.3
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 592.9
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 553.1
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 822.1
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1055.6
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1250.4
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1714.5
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 744.3
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1373.2
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1482.1
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1178.4
   },
   {
    "Region Name": "Portuguesa (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 837.3
   }
  ],
  "Potaro-Siparuni (Region of Guyana)": [
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Potaro-Siparuni (Region of Guyana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Potos\u00ed (Department of Bolivia)": [
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Potos\u00ed (Department of Bolivia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19.9
   }
  ],
  "Pouthisat (Province of Cambodia)": [
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 774.9
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1458.8
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1661.1
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 989.3
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1269.5
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 648.3
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1096.9
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1030.5
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1352.7
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1034.8
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1663.1
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1361.2
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1447.0
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1726.7
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 493.3
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1012.3
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1690.9
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1742.8
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1314.3
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 144.1
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 738.1
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1367.7
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1504.4
   },
   {
    "Region Name": "Pouthisat (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 890.9
   }
  ],
  "Po\u017ee\u0161ko-Slavonska (County of Croatia)": [
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Po\u017ee\u0161ko-Slavonska (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Prachin Buri (Province of Thailand)": [
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 485.5
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 358.6
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 367.6
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 151.6
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 242.5
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 313.6
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 160.1
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 174.9
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 100.8
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 183.5
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 387.2
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 87.9
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 229.4
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 127.1
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 212.9
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 146.4
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 92.2
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 144.7
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Prachin Buri (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 49.9
   }
  ],
  "Prachuap Khiri Khan (Province of Thailand)": [
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 122.6
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 93.9
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Prague (Region of Czechia)": [
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prague (Region of Czechia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Prahova (County of Romania)": [
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prahova (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Praia (County of Cabo Verde)": [
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Praia (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Preah Vih\u00e9ar (Province of Cambodia)": [
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3321.6
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3765.2
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3647.9
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4064.2
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4029.5
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3532.6
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4348.0
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2940.9
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3371.0
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3400.1
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3554.7
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3367.3
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3050.9
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3539.2
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3309.2
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4126.2
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3736.9
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3732.2
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3550.8
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2966.2
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1603.7
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3422.6
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2970.1
   },
   {
    "Region Name": "Preah Vih\u00e9ar (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2384.4
   }
  ],
  "Presidente Hayes (Department of Paraguay)": [
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9526.6
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13748.8
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4765.2
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6661.3
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8032.2
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10325.7
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7505.3
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3570.5
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3777.0
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7819.5
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5800.4
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4767.1
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2660.5
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2072.1
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4953.4
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13039.2
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4549.6
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4232.1
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16923.4
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8938.8
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1942.4
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7987.8
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4048.1
   },
   {
    "Region Name": "Presidente Hayes (Department of Paraguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1605.2
   }
  ],
  "Prey V\u00e9ng (Province of Cambodia)": [
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 110.6
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 192.7
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 289.0
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 147.1
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 139.6
   },
   {
    "Region Name": "Prey V\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 80.8
   }
  ],
  "Pre\u0161ovsk\u00fd (Region of Slovakia)": [
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pre\u0161ovsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Pricly Pear Cays (Island of Anguilla)": [
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pricly Pear Cays (Island of Anguilla)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Prilep (Municipality of North Macedonia)": [
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Prilep (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24.2
   }
  ],
  "Primor'ye (Territory of Russia)": [
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 415.7
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3284.3
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3336.7
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1872.3
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2738.1
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3025.0
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5848.2
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4272.2
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1128.9
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5785.2
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2173.1
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1603.9
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7267.8
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2722.5
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 657.3
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5218.2
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7261.3
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2372.4
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1240.3
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2823.0
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2985.9
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2743.3
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1501.9
   },
   {
    "Region Name": "Primor'ye (Territory of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 389.1
   }
  ],
  "Primorsko-Goranska (County of Croatia)": [
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Primorsko-Goranska (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Prince Edward Island (Province of Canada)": [
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prince Edward Island (Province of Canada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Princes Town (Region of Trinidad and Tobago)": [
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Princes Town (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.9
   }
  ],
  "Principado de Asturias (Autonomous Community of Spain)": [
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 116.4
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 107.2
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 80.0
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 104.6
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 185.9
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 229.4
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 90.9
   }
  ],
  "Pristina (District of Kosovo)": [
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Pristina (District of Kosovo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 65.6
   }
  ],
  "Prizren (District of Kosovo)": [
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 109.8
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Prizren (District of Kosovo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Probi\u0161tip (Municipality of North Macedonia)": [
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Provence-Alpes-C\u00f4te d'Azur (Region of France)": [
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 258.5
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Provence-Alpes-C\u00f4te d'Azur (Region of France)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Providenciales and West Caicos (District of Turks and Caicos Islands)": [
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)": [
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pr\u00edncipe (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pskov (Region of Russia)": [
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1062.8
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 253.4
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 218.2
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 359.1
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 761.0
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 127.3
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 327.8
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 124.1
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 171.1
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 479.8
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 293.3
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 275.5
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 364.9
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2574.1
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 852.3
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 271.8
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 96.9
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Pskov (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 46.9
   }
  ],
  "Puducherry (Union Territory of India)": [
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puducherry (Union Territory of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Puebla (State of M\u00e9xico)": [
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 216.1
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 152.8
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 181.6
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 157.3
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 99.0
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 198.5
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 166.6
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 124.1
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 131.0
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 96.7
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 161.2
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 109.5
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 273.1
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 137.6
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 158.0
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 109.5
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 233.0
   },
   {
    "Region Name": "Puebla (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 144.1
   }
  ],
  "Puerto Plata (Province of Dominican Republic)": [
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Puerto Plata (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pukapuka (Island Council of Cook Islands)": [
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pukapuka (Island Council of Cook Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Pulau Pinang (State of Malaysia)": [
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Pulau Pinang (State of Malaysia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Punakha (District of Bhutan)": [
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Punakha (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Punjab (Province of Pakistan)": [
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1171.3
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1380.5
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2636.7
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3682.0
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1251.9
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1386.5
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 968.3
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1603.5
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2093.5
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1426.4
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1970.7
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2909.0
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1461.1
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1619.6
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2423.2
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2440.4
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3125.7
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2087.5
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1660.5
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2813.6
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2476.4
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1676.2
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2723.6
   },
   {
    "Region Name": "Punjab (Province of Pakistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3547.2
   }
  ],
  "Punjab (State of India)": [
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13486.4
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13138.7
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15290.3
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15786.8
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15737.7
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16714.6
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14261.5
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16187.6
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16524.4
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17660.6
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17638.1
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18422.7
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18229.5
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 19298.1
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 23386.6
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12891.3
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19315.1
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19005.1
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 20650.4
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18690.8
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 20670.1
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16591.3
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7582.0
   },
   {
    "Region Name": "Punjab (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12033.8
   }
  ],
  "Puno (Region of Peru)": [
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 131.0
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 193.4
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 126.7
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 185.4
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 638.4
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Puno (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 43.7
   }
  ],
  "Puntarenas (Province of Costa Rica)": [
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 128.4
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Puntarenas (Province of Costa Rica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.5
   }
  ],
  "Puttalam (District of Sri Lanka)": [
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Puttalam (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Putumayo (Intendancy of Colombia)": [
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 191.2
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 108.9
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 198.9
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Putumayo (Intendancy of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Pwani (Region of Tanzania)": [
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3115.2
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4644.3
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4262.5
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7004.9
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2339.0
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7116.0
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5422.0
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7419.5
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7257.7
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4397.6
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6190.5
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4101.7
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2749.3
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3789.4
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3757.2
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1167.0
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2597.3
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1696.3
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2602.9
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3164.1
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2732.6
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1920.7
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1945.8
   },
   {
    "Region Name": "Pwani (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1976.7
   }
  ],
  "P\u00e4rnu (County of Estonia)": [
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "P\u00e4rnu (County of Estonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "P\u00f5lva (County of Estonia)": [
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "P\u00f5lva (County of Estonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "P\u010dinjski (District of Serbia)": [
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "P\u010dinjski (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24.4
   }
  ],
  "Qaasuitsup (Commune of Greenland)": [
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qaasuitsup (Commune of Greenland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Qacha's Nek (District of Lesotho)": [
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Qacha's Nek (District of Lesotho)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.4
   }
  ],
  "Qaraghandy (Region of Kazakhstan)": [
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 44086.7
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16694.6
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24440.0
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 44234.4
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 20705.3
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5246.9
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9762.6
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2433.5
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15064.4
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5176.4
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2008.9
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3987.0
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7387.2
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 19702.0
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5499.9
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 41290.9
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2674.0
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 27760.1
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6639.0
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9698.1
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4691.9
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1291.8
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1016.1
   },
   {
    "Region Name": "Qaraghandy (Region of Kazakhstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 275.5
   }
  ],
  "Qaraqalpaqstan (Autononous Region of Uzbekistan)": [
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 168.9
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 249.1
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 485.8
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 259.8
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 373.2
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 271.0
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 279.3
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 526.5
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 301.6
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 742.8
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 363.1
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 554.8
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 180.7
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 161.6
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 303.5
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 624.9
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 587.8
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 276.3
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 756.5
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 215.4
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 169.8
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 141.9
   }
  ],
  "Qashqadaryo (Region of Uzbekistan)": [
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qashqadaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.9
   }
  ],
  "Qazvin (Province of Iran)": [
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 51.9
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Qazvin (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 47.8
   }
  ],
  "Qeqqata (Commune of Greenland)": [
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qeqqata (Commune of Greenland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Qina (Governorate of Egypt)": [
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qina (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Qinghai (Province of China)": [
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Qinghai (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Qom (Province of Iran)": [
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qom (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Qostanay (Region of Kazakhstan)": [
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 31265.1
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16064.0
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12282.1
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17300.7
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18508.8
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6297.7
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21894.6
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6523.9
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21691.6
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 347.9
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15435.6
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 340.4
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8144.1
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5351.9
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4671.1
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22134.2
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5623.1
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8805.2
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1975.8
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 19145.7
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1245.1
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 604.5
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 212.0
   },
   {
    "Region Name": "Qostanay (Region of Kazakhstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5394.4
   }
  ],
  "Quba-Khachmaz (Region of Azerbaijan)": [
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.8
   }
  ],
  "Quebradillas (Municipality of Puerto Rico)": [
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quebradillas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Queensland (State of Australia)": [
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 99593.5
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 70725.3
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 105208.2
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 75242.0
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 94396.3
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 66413.4
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 67030.8
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 119446.2
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 32444.3
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 192336.6
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 161106.0
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 47007.9
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 73400.2
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 48546.2
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 69773.7
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 58540.1
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 74545.3
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 68281.0
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 48590.4
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 58713.5
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 52714.8
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 91385.5
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 99936.7
   },
   {
    "Region Name": "Queensland (State of Australia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 87844.6
   }
  ],
  "Quer\u00e9taro (State of M\u00e9xico)": [
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Quer\u00e9taro (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 29.4
   }
  ],
  "Quezaltenango (Department of Guatemala)": [
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Quezaltenango (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Quezon (Province of Philippines)": [
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Quezon (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Quich\u00e9 (Department of Guatemala)": [
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Quich\u00e9 (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 35.8
   }
  ],
  "Quinara (Region of Guinea-Bissau)": [
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 433.2
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 416.5
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 657.3
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 415.7
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 427.9
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 367.2
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 301.6
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 211.2
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 196.8
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 342.8
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 260.2
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 274.6
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 304.0
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 186.3
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 228.1
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 186.5
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 296.0
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 174.1
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 174.9
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 118.3
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 88.5
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 220.8
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Quinara (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 77.4
   }
  ],
  "Quind\u00edo (Department of Colombia)": [
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quind\u00edo (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Quintana Roo (State of M\u00e9xico)": [
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 505.1
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 138.5
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1068.8
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 111.5
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 352.0
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 478.9
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 136.1
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1171.3
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 407.7
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 357.1
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 241.6
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 252.5
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 664.5
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 100.8
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 661.3
   },
   {
    "Region Name": "Quintana Roo (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 100.1
   }
  ],
  "Quirino (Province of Philippines)": [
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Quirino (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.4
   }
  ],
  "Quneitra (Governorate of Syria)": [
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Quneitra (Governorate of Syria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Quthing (District of Lesotho)": [
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 223.6
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 93.5
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 205.8
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 185.9
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Quthing (District of Lesotho)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.2
   }
  ],
  "Qu\u00e9bec (Province of Canada)": [
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11871.3
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 677.2
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7698.0
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1260.1
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3418.3
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1249.8
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3252.8
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 108.5
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 657.7
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 19100.5
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 416.9
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 253.8
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 221.0
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 642.9
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 498.6
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 526.1
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 195.5
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 44141.1
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2316.9
   },
   {
    "Region Name": "Qu\u00e9bec (Province of Canada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 43.7
   }
  ],
  "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)": [
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 96.9
   },
   {
    "Region Name": "Qu\u1ea3ng B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.8
   }
  ],
  "Qu\u1ea3ng Nam (Province of Vietnam)": [
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 121.3
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Qu\u1ea3ng Nam (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.1
   }
  ],
  "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)": [
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Qu\u1ea3ng Ng\u00e3i (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.9
   }
  ],
  "Qu\u1ea3ng Ninh (Province of Vietnam)": [
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Qu\u1ea3ng Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.1
   }
  ],
  "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)": [
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 169.8
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 117.7
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Qu\u1ea3ng Tr\u1ecb (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.9
   }
  ],
  "Qyzylorda (Region of Kazakhstan)": [
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 179.2
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3224.3
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1165.1
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1141.7
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2360.6
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 395.5
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1360.4
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 601.9
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 491.8
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1200.7
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1621.7
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1389.5
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 826.8
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1032.4
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 527.3
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1545.0
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 994.7
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6571.9
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5614.5
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4930.7
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 857.5
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1507.4
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 955.0
   },
   {
    "Region Name": "Qyzylorda (Region of Kazakhstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2105.3
   }
  ],
  "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)": [
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rabat - Sal\u00e9 - Zemmour - Zaer (Region of Morocco)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)": [
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Radovi\u0161 (Municipality of North Macedonia)": [
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Ragged Island (District of Bahamas)": [
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ragged Island (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rajasthan (State of India)": [
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 204.5
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 294.5
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 823.0
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 328.2
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 205.6
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 298.6
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 749.0
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 667.3
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 696.5
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 878.5
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1590.2
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1433.5
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1306.4
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1013.3
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1206.3
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1841.4
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1479.4
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2119.7
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3675.8
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2013.6
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 967.7
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1230.9
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1645.1
   },
   {
    "Region Name": "Rajasthan (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2410.4
   }
  ],
  "Rajshahi (Division of Bangladesh)": [
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Rajshahi (Division of Bangladesh)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Rakahanga (Island Council of Cook Islands)": [
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rakahanga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rakai (District of Uganda)": [
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 161.0
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 255.5
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 155.8
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Rakai (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 17.8
   }
  ],
  "Rakhine (State of Myanmar)": [
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 323.3
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 178.1
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 880.0
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 525.0
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 951.8
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2378.4
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2383.6
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1845.3
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2832.5
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1572.0
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1061.8
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 657.5
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 201.7
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 369.6
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 81.9
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 99.0
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 441.6
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 516.2
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 425.7
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 418.7
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1862.4
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 675.9
   },
   {
    "Region Name": "Rakhine (State of Myanmar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 120.9
   }
  ],
  "Ramsey (Town District of Isle of Man)": [
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ramsey (Town District of Isle of Man)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rangpur (Division of Bangladesh)": [
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rangpur (Division of Bangladesh)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rankovce (Municipality of North Macedonia)": [
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rankovce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ranong (Province of Thailand)": [
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ranong (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rapla (County of Estonia)": [
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rapla (County of Estonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rarotonga (Island Council of Cook Islands)": [
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rarotonga (Island Council of Cook Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ras Al-Khaimah (Emirate of United Arab Emirates)": [
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rasinski (District of Serbia)": [
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rasinski (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Ras\u014fn (Directly Governed City of North Korea)": [
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Ras\u014fn (Directly Governed City of North Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ratchaburi (Province of Thailand)": [
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 190.1
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 172.8
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 91.3
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 162.9
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 161.6
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 194.4
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 152.2
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 176.2
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 97.8
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 137.8
   },
   {
    "Region Name": "Ratchaburi (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.3
   }
  ],
  "Ratnapura (District of Sri Lanka)": [
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ratnapura (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Raymah (Governorate of Yemen)": [
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Raymah (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rayong (Province of Thailand)": [
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 120.5
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 93.0
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Rayong (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Razavi Khorasan (Province of Iran)": [
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Razavi Khorasan (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.8
   }
  ],
  "Razgrad (Province of Bulgaria)": [
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 107.2
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Razgrad (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.4
   }
  ],
  "Ra\u0161ki (District of Serbia)": [
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ra\u0161ki (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Red Sea (State of Sudan)": [
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 90.0
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Red Sea (State of Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 236.7
   }
  ],
  "Redonda (Dependency of Antigua and Barbuda)": [
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Regi\u00f3n de Murcia (Autonomous Community of Spain)": [
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Regi\u00f3n de Murcia (Autonomous Community of Spain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Relizane (Province of Algeria)": [
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Relizane (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rennell and Bellona (Province of Solomon Islands)": [
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Repuplika Srpska (Entity of Bosnia and Herzegovina)": [
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 159.9
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 256.8
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 126.3
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 310.6
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 241.6
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 137.8
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 123.9
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 111.9
   }
  ],
  "Resen (Municipality of North Macedonia)": [
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Resen (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Retalhuleu (Department of Guatemala)": [
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 131.8
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 210.5
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 189.7
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 184.4
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 229.2
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 199.6
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 177.7
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 242.5
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 191.2
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 196.6
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 245.9
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 189.3
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 203.4
   },
   {
    "Region Name": "Retalhuleu (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 180.7
   }
  ],
  "Rezina (District of Moldova)": [
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rezina (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rheinland-Pfalz (State of Germany)": [
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rheinland-Pfalz (State of Germany)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Rhode Island (State of United States)": [
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rhode Island (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Riau (Province of Indonesia)": [
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 446.7
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 887.3
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1491.6
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1649.4
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 751.4
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 274.6
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 511.3
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1315.8
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 404.5
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 614.6
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 531.4
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3174.6
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1596.0
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 542.1
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 601.5
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 480.0
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 960.4
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 149.8
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 138.3
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 136.8
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "Riau (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 253.2
   }
  ],
  "Ribeira Brava (County of Cabo Verde)": [
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Brava (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ribeira Grande (County of Cabo Verde)": [
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ribeira Grande de Santiago (County of Cabo Verde)": [
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rif Dimashq (Governorate of Syria)": [
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rif Dimashq (Governorate of Syria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Riga (Province of Latvia)": [
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Riga (Province of Latvia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rinc\u00f3n (Municipality of Puerto Rico)": [
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rinc\u00f3n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rio Grande do Norte (State of Brazil)": [
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 207.3
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 396.8
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 365.3
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 285.5
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 148.1
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 423.6
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 237.3
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 148.6
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 231.1
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 237.1
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 179.2
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 132.7
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 149.6
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 360.8
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 338.5
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 149.0
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 114.3
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 223.8
   },
   {
    "Region Name": "Rio Grande do Norte (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 119.8
   }
  ],
  "Rio Grande do Sul (State of Brazil)": [
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1175.2
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1730.2
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 561.2
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 281.5
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 622.7
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 601.7
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 283.4
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 733.4
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 549.2
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 275.5
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 222.7
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 268.0
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 446.3
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 299.5
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 765.1
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 377.9
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 317.3
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 817.2
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 734.0
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1110.4
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 516.8
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 325.8
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 448.2
   },
   {
    "Region Name": "Rio Grande do Sul (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 260.7
   }
  ],
  "Rio de Janeiro (State of Brazil)": [
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 419.9
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 143.6
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 110.6
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 184.8
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 297.8
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 348.3
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 176.0
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 367.2
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 448.9
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 137.0
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 187.1
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 562.1
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 117.5
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 185.6
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 255.3
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 222.9
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 145.1
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 172.4
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 281.5
   },
   {
    "Region Name": "Rio de Janeiro (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 39.2
   }
  ],
  "Risaralda (Department of Colombia)": [
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Risaralda (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rivas (Department of Nicaragua)": [
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Rivas (Department of Nicaragua)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.6
   }
  ],
  "River Gee (County of Liberia)": [
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Gee (County of Liberia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.8
   }
  ],
  "River Nile (State of Sudan)": [
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 178.4
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 158.4
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 186.7
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 968.3
   },
   {
    "Region Name": "River Nile (State of Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 391.7
   }
  ],
  "Rivera (Department of Uruguay)": [
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Rivera (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.7
   }
  ],
  "Rivercess (County of Liberia)": [
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 83.8
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 107.0
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Rivercess (County of Liberia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.4
   }
  ],
  "Rivers (State of Nigeria)": [
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 83.8
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 143.6
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 92.4
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 377.3
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 128.4
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 120.5
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 160.8
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 190.1
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 192.9
   },
   {
    "Region Name": "Rivers (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rivi\u00e8re du Rempart (District of Mauritius)": [
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rivi\u00e8re du Rempart (District of Mauritius)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rivne (Region of Ukraine)": [
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 424.7
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 138.9
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 388.4
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 191.0
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 452.7
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 136.6
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 227.7
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 241.4
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 190.6
   },
   {
    "Region Name": "Rivne (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 50.6
   }
  ],
  "Rizal (Province of Philippines)": [
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rizal (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rize (Province of Turkey)": [
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Rize (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rocha (Department of Uruguay)": [
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 98.4
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 85.7
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 109.8
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 99.5
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Rocha (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24.9
   }
  ],
  "Roche Ca\u00efman (District of Seychelles)": [
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roche Ca\u00efman (District of Seychelles)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rodriguez (Autonomous island of Mauritius)": [
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rodriguez (Autonomous island of Mauritius)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rogaland (County of Norway)": [
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rogaland (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Roi Et (Province of Thailand)": [
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 114.3
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 112.8
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 256.4
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 246.7
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 139.1
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 254.0
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 87.5
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 283.4
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 244.4
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 334.6
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 154.8
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 171.9
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 147.1
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 354.4
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 223.6
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 182.0
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 88.3
   },
   {
    "Region Name": "Roi Et (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 120.5
   }
  ],
  "Romblon (Province of Philippines)": [
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Romblon (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rond\u00f4nia (State of Brazil)": [
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5673.5
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4790.3
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6252.5
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9252.4
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4871.3
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6726.5
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2527.2
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1408.2
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7996.8
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3103.8
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2579.5
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 994.5
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1497.6
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3045.1
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3816.8
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2711.3
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2379.1
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3778.5
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4806.2
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3708.6
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3836.8
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4343.5
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7478.5
   },
   {
    "Region Name": "Rond\u00f4nia (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 814.8
   }
  ],
  "Roraima (State of Brazil)": [
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2516.3
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4187.7
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1127.6
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1222.3
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3100.8
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1483.0
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 682.6
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2984.4
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 861.5
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1000.9
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1439.3
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1552.0
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2190.0
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3883.1
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1409.0
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3166.9
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2979.1
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6314.7
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1572.8
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1234.6
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 382.9
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6112.1
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4209.6
   },
   {
    "Region Name": "Roraima (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1232.0
   }
  ],
  "Roscommon (County of Ireland)": [
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Roscommon (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rosoman (Municipality of North Macedonia)": [
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Rosoman (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rostov (Region of Russia)": [
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6138.7
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1173.0
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4120.6
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7406.9
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7790.8
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5233.0
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7089.6
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3713.7
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3053.0
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 984.4
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 849.5
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 394.2
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2439.5
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2334.0
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1056.4
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2233.3
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1158.5
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1119.6
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1578.8
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 668.2
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2295.7
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1722.2
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2378.0
   },
   {
    "Region Name": "Rostov (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1130.8
   }
  ],
  "Rota (Municipality of Northern Mariana Islands)": [
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rota (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rotuma (Division of Fiji)": [
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rotuma (Division of Fiji)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ro\u017eaje (Municipality of Montenegro)": [
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ro\u017eaje (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ruggell (Commune of Liechtenstein)": [
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruggell (Commune of Liechtenstein)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rukungiri (District of Uganda)": [
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 171.5
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 111.7
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 155.8
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 193.8
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 128.8
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 119.4
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 168.7
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 172.1
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 140.2
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 129.1
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 93.9
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 124.1
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 97.8
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 164.6
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 142.1
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 161.0
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 101.6
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 177.5
   },
   {
    "Region Name": "Rukungiri (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 81.0
   }
  ],
  "Rukwa (Region of Tanzania)": [
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4073.2
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4260.4
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4715.9
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3791.5
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4054.8
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2742.2
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3190.7
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2925.9
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3034.6
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3004.8
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2739.9
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3136.9
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2269.3
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2565.4
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2438.4
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2163.2
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2042.7
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2215.5
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1832.9
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1990.8
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2131.9
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1766.8
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1814.4
   },
   {
    "Region Name": "Rukwa (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1916.5
   }
  ],
  "Rum Cay (District of Bahamas)": [
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rum Cay (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rumphi (District of Malawi)": [
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 917.1
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1098.6
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 786.9
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1111.5
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 682.3
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1005.6
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 956.7
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 809.2
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1081.5
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 664.3
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 928.2
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 767.9
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 632.2
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 836.0
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 737.9
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 775.6
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 763.2
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 760.4
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 692.4
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 738.5
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 817.8
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 698.8
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 851.7
   },
   {
    "Region Name": "Rumphi (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 745.8
   }
  ],
  "Ruse (Province of Bulgaria)": [
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 94.5
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 94.5
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ruse (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Rutana (Province of Burundi)": [
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Rutana (Province of Burundi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.8
   }
  ],
  "Ruvuma (Region of Tanzania)": [
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7392.7
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14300.8
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6423.4
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14655.3
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9664.0
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9853.3
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12497.7
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11876.5
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14017.6
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12357.3
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13314.9
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13793.8
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10702.8
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14631.3
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12073.5
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11729.8
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8324.2
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10195.2
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8242.7
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8567.3
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10458.6
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8429.6
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7149.8
   },
   {
    "Region Name": "Ruvuma (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7814.0
   }
  ],
  "Ruyigi (Province of Burundi)": [
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 331.4
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 277.0
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 241.2
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 152.0
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 192.7
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 137.4
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 149.6
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 95.4
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 122.8
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 119.6
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 82.7
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 170.9
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 107.2
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 109.3
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 117.7
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 107.0
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 89.2
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 89.4
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 151.8
   },
   {
    "Region Name": "Ruyigi (Province of Burundi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 96.3
   }
  ],
  "Ryanggang (Province of North Korea)": [
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 144.9
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 155.8
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 367.0
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Ryanggang (Province of North Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 39.4
   }
  ],
  "Ryazan' (Region of Russia)": [
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1045.0
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 655.8
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 587.8
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 848.7
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 666.9
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1251.9
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3211.0
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2280.2
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 270.3
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 769.4
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 278.9
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 373.4
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 184.8
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 259.0
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 278.9
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 323.5
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 198.5
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 317.9
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 217.4
   },
   {
    "Region Name": "Ryazan' (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 107.8
   }
  ],
  "R\u00edo Grande (Municipality of Puerto Rico)": [
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "R\u00edo Negro (Department of Uruguay)": [
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 228.9
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "R\u00edo Negro (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.4
   }
  ],
  "R\u00edo Negro (Province of Argentina)": [
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2733.2
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 529.3
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 812.5
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 634.3
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 136.1
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 129.9
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 126.5
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1114.1
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 730.8
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8419.6
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1338.9
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 889.8
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 732.7
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 262.6
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 279.3
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 360.8
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 207.1
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 157.1
   },
   {
    "Region Name": "R\u00edo Negro (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 38.6
   }
  ],
  "R\u00edo San Juan (Department of Nicaragua)": [
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 161.2
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 166.4
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "R\u00edo San Juan (Department of Nicaragua)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.4
   }
  ],
  "R\u00ee\u0219cani (District of Moldova)": [
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "R\u00ee\u0219cani (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)": [
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2222.4
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2422.8
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2339.2
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2927.4
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2519.1
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2332.1
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2817.2
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1804.3
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3033.3
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2606.9
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2497.0
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2033.9
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2443.6
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2604.4
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2512.8
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2452.4
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2778.9
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2597.7
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2608.9
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2209.7
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1940.7
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2449.8
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1795.6
   },
   {
    "Region Name": "R\u00f4t\u00e1n\u00f4kiri (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1859.4
   }
  ],
  "Sa Kaeo (Province of Thailand)": [
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 674.8
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 716.8
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 641.6
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 236.0
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 534.2
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 272.9
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 181.8
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 216.9
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 217.2
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 107.6
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 90.2
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 110.2
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 251.5
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 124.8
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 184.4
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 90.2
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 144.5
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 94.8
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 158.6
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Sa Kaeo (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 106.8
   }
  ],
  "Sa`dah (Governorate of Yemen)": [
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa`dah (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saare (County of Estonia)": [
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saare (County of Estonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saarland (State of Germany)": [
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saarland (State of Germany)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saba (Municipality of Bonaire, Sint Eustatius and Saba)": [
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sabah (State of Malaysia)": [
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 195.3
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 123.7
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 155.6
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 144.5
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 177.1
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 260.7
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 98.8
   },
   {
    "Region Name": "Sabah (State of Malaysia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Sabana Grande (Municipality of Puerto Rico)": [
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sabha (District of Libya)": [
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sabha (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sacatep\u00e9quez (Department of Guatemala)": [
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Sacatep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.9
   }
  ],
  "Sachsen (State of Germany)": [
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen (State of Germany)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19.3
   }
  ],
  "Sachsen-Anhalt (State of Germany)": [
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Sachsen-Anhalt (State of Germany)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.4
   }
  ],
  "Sada (Commune of Mayotte)": [
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sada (Commune of Mayotte)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saga (Prefecture of Japan)": [
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Saga (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sagaing (Division of Myanmar)": [
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 418.0
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2931.7
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4449.2
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1140.0
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1940.7
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2886.5
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2963.7
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1920.5
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6079.3
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2600.9
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1592.5
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2345.2
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2064.4
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4352.5
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1210.1
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1900.6
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 965.5
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2088.2
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4185.6
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2298.9
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2200.9
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2311.3
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2069.1
   },
   {
    "Region Name": "Sagaing (Division of Myanmar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4721.0
   }
  ],
  "Sahel (Region of Burkina Faso)": [
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 108.9
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1394.0
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1626.6
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1902.7
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4922.1
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6135.9
   },
   {
    "Region Name": "Sahel (Region of Burkina Faso)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8325.7
   }
  ],
  "Saint Andrew (Parish of Dominica)": [
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Dominica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Andrew (Parish of Grenada)": [
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Grenada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Andrew (Parish of Jamaica)": [
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Jamaica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Andrew (Parish of Saint Vincent and the Grenadines)": [
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Ann (Parish of Jamaica)": [
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ann (Parish of Jamaica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Anthon (Parish of Montserrat)": [
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Anthon (Parish of Montserrat)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Berlade (Parish of Jersey)": [
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Berlade (Parish of Jersey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Brandon (Region of Mauritius)": [
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Brandon (Region of Mauritius)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Catherine (Parish of Jamaica)": [
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Saint Catherine (Parish of Jamaica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Saint Croix (District of Virgin Islands, U.S.)": [
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint David (Parish of Dominica)": [
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Dominica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint David (Parish of Grenada)": [
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Grenada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint David (Parish of Saint Vincent and the Grenadines)": [
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Elizabeth (Parish of Jamaica)": [
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Saint Elizabeth (Parish of Jamaica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint George (Parish of Antigua and Barbuda)": [
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint George (Parish of Grenada)": [
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Grenada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint George (Parish of Saint Vincent and the Grenadines)": [
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint George Basseterre (Parish of Saint Kitts and Nevis)": [
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint George municipality (Municipality of Bermuda)": [
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George municipality (Municipality of Bermuda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint George's (Parish of Bermuda)": [
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint George's (Parish of Bermuda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Georges (Parish of Montserrat)": [
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Georges (Parish of Montserrat)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Helena (Dependency of Saint Helena, Ascension and Tris)": [
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint James (Parish of Jamaica)": [
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James (Parish of Jamaica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint James Windward (Parish of Saint Kitts and Nevis)": [
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint John (District of Virgin Islands, U.S.)": [
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint John (Parish of Antigua and Barbuda)": [
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint John (Parish of Barbados)": [
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Barbados)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint John (Parish of Dominica)": [
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Dominica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint John (Parish of Grenada)": [
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Grenada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint John (Parish of Jersey)": [
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John (Parish of Jersey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint John Capisterre (Parish of Saint Kitts and Nevis)": [
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint John Figtree (Parish of Saint Kitts and Nevis)": [
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Joseph (Parish of Barbados)": [
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Barbados)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Joseph (Parish of Dominica)": [
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Joseph (Parish of Dominica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Lawrence (Parish of Jersey)": [
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lawrence (Parish of Jersey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Louis (District of Seychelles)": [
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Louis (District of Seychelles)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Lucy (Parish of Barbados)": [
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Lucy (Parish of Barbados)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Luke (Parish of Dominica)": [
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Luke (Parish of Dominica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Mark (Parish of Dominica)": [
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Dominica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Mark (Parish of Grenada)": [
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mark (Parish of Grenada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Martin (Parish of Jersey)": [
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Martin (Parish of Jersey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Mary (Parish of Antigua and Barbuda)": [
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Mary (Parish of Jamaica)": [
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jamaica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Mary (Parish of Jersey)": [
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary (Parish of Jersey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Mary Cayon (Parish of Saint Kitts and Nevis)": [
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Michael (Parish of Barbados)": [
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Michael (Parish of Barbados)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Ouen (Parish of Jersey)": [
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Ouen (Parish of Jersey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Patrick (Parish of Dominica)": [
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Dominica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Patrick (Parish of Grenada)": [
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saint Patrick (Parish of Grenada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Patrick (Parish of Saint Vincent and the Grenadines)": [
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Paul (Parish of Antigua and Barbuda)": [
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Paul (Parish of Dominica)": [
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul (Parish of Dominica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)": [
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Peter (Parish of Antigua and Barbuda)": [
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Peter (Parish of Barbados)": [
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Barbados)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Peter (Parish of Dominica)": [
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Dominica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Peter (Parish of Jersey)": [
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Jersey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Peter (Parish of Montserrat)": [
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter (Parish of Montserrat)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)": [
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Peter Port (Parish of Guernsey)": [
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Peter Port (Parish of Guernsey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Philip (Parish of Antigua and Barbuda)": [
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Philip (Parish of Barbados)": [
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Philip (Parish of Barbados)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Saviour (Parish of Guernsey)": [
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Guernsey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Saviour (Parish of Jersey)": [
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Saviour (Parish of Jersey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Thomas (District of Virgin Islands, U.S.)": [
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Thomas (Parish of Barbados)": [
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Barbados)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Thomas (Parish of Jamaica)": [
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Saint Thomas (Parish of Jamaica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)": [
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)": [
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint-Beno\u00eet (Arrondissement of R\u00e9union)": [
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Beno\u00eet (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint-Denis (Arrondissement of R\u00e9union)": [
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Denis (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)": [
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Saint-Louis (Region of Senegal)": [
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 744.3
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1984.0
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 140.4
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 173.6
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 745.8
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 614.6
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 801.1
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 185.6
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 125.4
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 78.2
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 94.8
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 151.3
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 188.2
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 282.8
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 159.1
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 158.6
   },
   {
    "Region Name": "Saint-Louis (Region of Senegal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 192.1
   }
  ],
  "Saint-Paul (Arrondissement of R\u00e9union)": [
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Saint-Paul (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint-Pierre (Arrondissement of Martinique)": [
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint-Pierre (Arrondissement of R\u00e9union)": [
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Arrondissement of R\u00e9union)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saint-Pierre (Commune of Saint Pierre and Miquelon)": [
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saipan (Municipality of Northern Mariana Islands)": [
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saitama (Prefecture of Japan)": [
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saitama (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sakarya (Province of Turkey)": [
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sakarya (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 128.4
   }
  ],
  "Sakha (Republic of Russia)": [
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 37494.0
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12617.8
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 413.1
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7164.0
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1895.7
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 987.6
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9854.3
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7305.7
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6629.8
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14279.3
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 29592.6
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20584.8
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23957.2
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3268.5
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2071.4
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12325.4
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25347.8
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26991.4
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 44064.8
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 77109.8
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4731.6
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13371.5
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 26845.2
   },
   {
    "Region Name": "Sakha (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1513.9
   }
  ],
  "Sakhalin (Region of Russia)": [
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 113.4
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 509.3
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 109.8
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 105.0
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 234.7
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 246.3
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sakhalin (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 29.8
   }
  ],
  "Sakon Nakhon (Province of Thailand)": [
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 290.5
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 276.3
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 215.0
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 339.6
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 141.9
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 139.3
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 276.3
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 203.9
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 249.7
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 212.2
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 140.2
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 120.9
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 216.7
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 96.7
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Sakon Nakhon (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.7
   }
  ],
  "Sal (County of Cabo Verde)": [
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sal (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sala ad-Din (Province of Iraq)": [
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 167.9
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 407.9
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2698.5
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1188.5
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 404.5
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 737.2
   },
   {
    "Region Name": "Sala ad-Din (Province of Iraq)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 96.5
   }
  ],
  "Salamat (Region of Chad)": [
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 32551.3
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29848.3
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 31469.6
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 34666.3
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 33070.9
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 29175.2
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 31989.9
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 26114.9
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26874.4
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 29755.3
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27258.7
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 27882.8
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 24952.1
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 26556.9
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 28479.8
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 25547.9
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 27362.1
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 25552.4
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25708.0
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26570.2
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 23514.8
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25799.5
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23065.0
   },
   {
    "Region Name": "Salamat (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18204.0
   }
  ],
  "Salcedo (Province of Dominican Republic)": [
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salcedo (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Salima (District of Malawi)": [
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 137.6
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 114.9
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 110.4
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 126.9
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 118.1
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 110.6
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 127.8
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 139.3
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 121.1
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 93.9
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 99.9
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Salima (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 90.0
   }
  ],
  "Salinas (Municipality of Puerto Rico)": [
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Salinas (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Salt Cay (District of Turks and Caicos Islands)": [
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Salta (Province of Argentina)": [
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2327.6
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2354.2
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2303.0
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2941.8
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2405.6
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3140.1
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3361.1
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3166.0
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2945.6
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2559.6
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2369.4
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2875.5
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1293.3
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1647.4
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2056.2
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1921.2
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1458.1
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1521.6
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2300.6
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1563.8
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2732.6
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2041.4
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 708.3
   },
   {
    "Region Name": "Salta (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 905.7
   }
  ],
  "Salto (Department of Uruguay)": [
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Salto (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Salzburg (State of Austria)": [
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Salzburg (State of Austria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Samangan (Province of Afghanistan)": [
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 309.8
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samangan (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saman\u00e1 (Province of Dominican Republic)": [
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saman\u00e1 (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Samar (Province of Philippines)": [
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Samar (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Samara (Region of Russia)": [
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2309.8
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 722.6
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 687.1
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1278.5
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 362.9
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1447.4
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2298.9
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1126.9
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 826.2
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 168.9
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 224.7
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 480.4
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 425.5
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 203.7
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 182.9
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 375.4
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 377.7
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 164.2
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 232.8
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 88.7
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Samara (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 73.5
   }
  ],
  "Samarqand' (Region of Uzbekistan)": [
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Samarqand' (Region of Uzbekistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.4
   }
  ],
  "Samburu (County of Kenya)": [
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "Samburu (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 49.3
   }
  ],
  "Samdrup Jongkhar (District of Bhutan)": [
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samdrup Jongkhar (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Samegrelo-Zemo Svaneti (Region of Georgia)": [
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Samsun (Province of Turkey)": [
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samsun (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Samtse (District of Bhutan)": [
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtse (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Samtskhe-Javakheti (Region of Georgia)": [
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 26.4
   }
  ],
  "Samut Prakan (Province of Thailand)": [
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Prakan (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Samut Sakhon (Province of Thailand)": [
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Sakhon (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Samut Songkhram (Province of Thailand)": [
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Samut Songkhram (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "San Andr\u00e9s y Providencia (Department of Colombia)": [
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Andr\u00e9s y Providencia (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "San Crist\u00f3bal (Province of Dominican Republic)": [
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Crist\u00f3bal (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "San Fernando (City of Trinidad and Tobago)": [
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Fernando (City of Trinidad and Tobago)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "San Germ\u00e1n (Municipality of Puerto Rico)": [
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Germ\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "San Jos\u00e9 (Department of Uruguay)": [
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "San Jos\u00e9 (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "San Jos\u00e9 (Province of Costa Rica)": [
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 (Province of Costa Rica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "San Jos\u00e9 de Ocoa (Province of Dominican Republic)": [
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Jos\u00e9 de Ocoa (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "San Juan (Municipality of Puerto Rico)": [
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "San Juan (Province of Argentina)": [
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 329.3
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 97.3
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 149.6
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 184.6
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "San Juan (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.5
   }
  ],
  "San Juan (Province of Dominican Republic)": [
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 230.2
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "San Juan (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.7
   }
  ],
  "San Juan-Laventille (Region of Trinidad and Tobago)": [
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "San Lorenzo (Municipality of Puerto Rico)": [
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "San Luis (Province of Argentina)": [
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6364.4
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5388.4
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 510.8
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2273.2
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 760.4
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1005.2
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1867.2
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5033.8
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1172.6
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1338.3
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 733.1
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1838.2
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 793.0
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 415.2
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2143.0
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2102.7
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1464.8
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 913.4
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2614.2
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1003.5
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2277.5
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 951.2
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1406.3
   },
   {
    "Region Name": "San Luis (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 518.8
   }
  ],
  "San Luis Potos\u00ed (State of M\u00e9xico)": [
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 237.5
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 320.9
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 99.0
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 353.1
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 230.0
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 110.6
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 234.1
   },
   {
    "Region Name": "San Luis Potos\u00ed (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 374.3
   }
  ],
  "San Marcos (Department of Guatemala)": [
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "San Marcos (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "San Marino (Municipality of San Marino)": [
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Marino (Municipality of San Marino)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "San Mart\u00edn (Region of Peru)": [
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 167.9
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 193.8
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 141.3
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 179.4
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 123.9
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 92.6
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 422.7
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 349.9
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 176.6
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 176.0
   },
   {
    "Region Name": "San Mart\u00edn (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 36.2
   }
  ],
  "San Miguel (Department of El Salvador)": [
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 81.7
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "San Miguel (Department of El Salvador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.2
   }
  ],
  "San Pedro (Department of Paraguay)": [
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1900.0
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3701.3
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1487.3
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2853.7
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1839.7
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5739.1
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2050.0
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1233.7
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1597.3
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1803.5
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1464.6
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2283.2
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 767.0
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 862.8
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1115.6
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3052.2
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2119.3
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2186.1
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2423.4
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3079.4
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 779.7
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1438.0
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2039.5
   },
   {
    "Region Name": "San Pedro (Department of Paraguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 649.3
   }
  ],
  "San Pedro de Macor\u00eds (Province of Dominican Republic)": [
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 122.2
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 85.7
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "San Pedro de Macor\u00eds (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 22.9
   }
  ],
  "San Salvador (Department of El Salvador)": [
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "San Salvador (Department of El Salvador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.7
   }
  ],
  "San Salvador (District of Bahamas)": [
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Salvador (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "San Sebasti\u00e1n (Municipality of Puerto Rico)": [
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Sebasti\u00e1n (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "San Vicente (Department of El Salvador)": [
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "San Vicente (Department of El Salvador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.4
   }
  ],
  "San`a' (City of Yemen)": [
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "San`a' (City of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sanaag (Region of Somalia)": [
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Sanaag (Region of Somalia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.2
   }
  ],
  "Sancti Sp\u00edritus (Province of Cuba)": [
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 247.8
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 104.6
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 202.6
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 119.2
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 134.8
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 107.4
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 104.8
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "Sancti Sp\u00edritus (Province of Cuba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 50.6
   }
  ],
  "Sandaun (Province of Papua New Guinea)": [
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Sandaun (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.4
   }
  ],
  "Sandoyar (Region of Faroe Islands)": [
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sandy Hill (District of Anguilla)": [
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandy Hill (District of Anguilla)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sandys (Parish of Bermuda)": [
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sandys (Parish of Bermuda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sangha (Region of Republic of the Congo)": [
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 402.2
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Sangha (Region of Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 31.3
   }
  ],
  "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)": [
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 198.5
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 106.8
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 74.2
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 108.3
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 126.3
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 196.1
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 76.5
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 153.9
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 179.4
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 141.9
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 146.8
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Sangha-Mba\u00e9r\u00e9 (Economic Prefecture of Central African Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 38.6
   }
  ],
  "Sangre Grande (Region of Trinidad and Tobago)": [
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sankt Gallen (Canton of Switzerland)": [
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sankt Gallen (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sankuru (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4495.7
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4930.9
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9023.9
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6556.3
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6280.2
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6416.7
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5551.1
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7364.9
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6200.6
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4047.5
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5132.2
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8934.9
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8226.4
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6111.2
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7540.2
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5477.1
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7290.9
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7874.2
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9153.6
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8473.6
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9528.7
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8653.9
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11028.2
   },
   {
    "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6324.1
   }
  ],
  "Sanliurfa (Province of Turkey)": [
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 644.4
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 237.5
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 194.6
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 670.1
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 448.7
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 619.3
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 521.8
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1569.6
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 985.7
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 671.0
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 616.5
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1371.1
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 786.5
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2051.9
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1845.1
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1346.9
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 613.5
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1186.3
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2317.3
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2504.0
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1579.7
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1780.3
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1295.4
   },
   {
    "Region Name": "Sanliurfa (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1716.2
   }
  ],
  "Sanma (Province of Vanuatu)": [
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sanma (Province of Vanuatu)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)": [
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sant Juli\u00e0 de L\u00f2ria (Parish of Andorra)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Santa Ana (Department of El Salvador)": [
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Santa Ana (Department of El Salvador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Santa B\u00e1rbara (Department of Honduras)": [
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 104.6
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Santa B\u00e1rbara (Department of Honduras)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.1
   }
  ],
  "Santa Catarina (County of Cabo Verde)": [
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Santa Catarina (State of Brazil)": [
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 605.4
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1177.1
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 220.4
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 364.9
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 336.3
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 227.7
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 176.2
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 160.6
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 304.2
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 96.9
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 203.9
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 149.0
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 142.3
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 137.6
   },
   {
    "Region Name": "Santa Catarina (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 50.4
   }
  ],
  "Santa Catarina do Fogo (County of Cabo Verde)": [
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Santa Cruz (County of Cabo Verde)": [
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Santa Cruz (Department of Bolivia)": [
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19675.6
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8057.3
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32570.6
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14155.2
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18054.6
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 38437.0
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11625.2
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7254.0
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37537.7
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10188.1
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8868.2
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4578.1
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3330.2
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8625.8
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10377.4
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5258.5
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7654.3
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 32739.3
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 17490.2
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 24156.0
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14926.7
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11556.4
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 64817.3
   },
   {
    "Region Name": "Santa Cruz (Department of Bolivia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4994.4
   }
  ],
  "Santa Cruz (Province of Argentina)": [
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 279.1
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 204.5
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 138.7
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 127.3
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Santa Cruz (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.9
   }
  ],
  "Santa Elena (Province of Ecuador)": [
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Santa Elena (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Santa Fe (Province of Argentina)": [
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2720.3
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6105.9
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8981.0
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6396.3
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6657.7
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9445.5
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10215.5
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3144.4
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5673.9
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9368.8
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3979.1
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6341.7
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1550.7
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5581.7
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3015.7
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3788.8
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4727.7
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2285.6
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12936.3
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7252.3
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5539.5
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3211.5
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5730.5
   },
   {
    "Region Name": "Santa Fe (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4716.5
   }
  ],
  "Santa Isabel (Municipality of Puerto Rico)": [
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Santa Rita (Municipality of Guam)": [
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santa Rita (Municipality of Guam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Santa Rosa (Department of Guatemala)": [
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 138.5
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 161.2
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 197.2
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 129.9
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 131.4
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 169.1
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 204.9
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 96.9
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 145.8
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 146.0
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 172.6
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 158.2
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 140.2
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 146.2
   },
   {
    "Region Name": "Santa Rosa (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 183.1
   }
  ],
  "Santander (Department of Colombia)": [
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 78.0
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Santander (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Santar\u00e9m (District of Portugal)": [
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 831.3
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 411.4
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 623.6
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 105.9
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Santar\u00e9m (District of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.1
   }
  ],
  "Santiago (Province of Dominican Republic)": [
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 141.7
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Santiago (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Santiago Metropolitan (Metropolian Region of Chile)": [
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 144.5
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 352.4
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 107.8
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 45.7
   }
  ],
  "Santiago Rodr\u00edguez (Province of Dominican Republic)": [
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Santiago Rodr\u00edguez (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Santiago de Cuba (Province of Cuba)": [
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 95.8
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 56.0
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 96.5
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 130.3
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 123.9
   },
   {
    "Region Name": "Santiago de Cuba (Province of Cuba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 32.8
   }
  ],
  "Santiago del Estero (Province of Argentina)": [
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9519.3
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10718.7
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9917.1
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3696.2
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5308.0
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9631.4
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6833.2
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3623.7
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5514.0
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6171.3
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3619.4
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2647.2
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2278.1
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3792.8
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4178.3
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5685.1
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2699.5
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3280.3
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5842.2
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3386.8
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2714.1
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1541.7
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1811.8
   },
   {
    "Region Name": "Santiago del Estero (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2042.5
   }
  ],
  "Santo Domingo (Province of Dominican Republic)": [
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 87.9
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Santo Domingo (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Santo Domingo de los Tsachilas (Province of Ecuador)": [
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Santon (Parish District of Isle of Man)": [
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Santon (Parish District of Isle of Man)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saraburi (Province of Thailand)": [
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 155.0
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 182.9
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 235.4
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 104.4
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 131.2
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 88.5
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 244.6
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 50.2
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 140.0
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Saraburi (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 39.2
   }
  ],
  "Saraj (Municipality of North Macedonia)": [
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saraj (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saramacca (District of Suriname)": [
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Saramacca (District of Suriname)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sarangani (Province of Philippines)": [
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarangani (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saratov (Region of Russia)": [
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3598.4
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 943.7
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2488.6
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5396.3
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1949.0
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4750.6
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3414.5
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2891.6
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2449.6
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 178.4
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 702.5
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 540.2
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2231.8
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1126.7
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 651.0
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2693.3
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1752.0
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 270.1
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1838.6
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 437.1
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 447.2
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 653.8
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 456.4
   },
   {
    "Region Name": "Saratov (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 235.8
   }
  ],
  "Saravan (Province of Laos)": [
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 172.6
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 133.1
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 107.2
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 78.2
   },
   {
    "Region Name": "Saravan (Province of Laos)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 38.8
   }
  ],
  "Sarawak (State of Malaysia)": [
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 133.6
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 147.9
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 195.3
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 523.5
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 104.4
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 96.9
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Sarawak (State of Malaysia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 47.8
   }
  ],
  "Sardegna (Autonomous Region of Italy)": [
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 141.1
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 253.8
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 284.0
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 154.8
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Sardegna (Autonomous Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.3
   }
  ],
  "Sari Pul (Province of Afghanistan)": [
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sari Pul (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sark (Parish of Guernsey)": [
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sark (Parish of Guernsey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sarpang (District of Bhutan)": [
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sarpang (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Saskatchewan (Province of Canada)": [
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6180.7
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1123.9
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2724.8
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2178.8
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10391.1
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2005.0
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9436.7
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 400.4
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14677.2
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3058.6
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2036.7
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3493.1
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3204.6
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14336.6
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2297.2
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4979.4
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 931.6
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 565.1
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 454.2
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7942.4
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1999.0
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8137.2
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7742.2
   },
   {
    "Region Name": "Saskatchewan (Province of Canada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13319.4
   }
  ],
  "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)": [
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 873.3
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 911.9
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1199.0
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 840.5
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 961.9
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 988.9
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 431.5
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 382.0
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 227.2
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 775.6
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 207.1
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 295.8
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 130.3
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 358.6
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 130.6
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 140.4
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 72.7
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 126.0
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Sassandra-Marahou\u00e9 (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.9
   }
  ],
  "Satu Mare (County of Romania)": [
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 192.5
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satu Mare (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Satun (Province of Thailand)": [
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satun (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Satupa'itea (District of Samoa)": [
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Satupa'itea (District of Samoa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Savanes (District of C\u00f4te d'Ivoire)": [
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5825.5
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4685.5
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3642.3
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4102.6
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5284.4
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4028.4
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3218.8
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3945.2
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4083.1
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3932.6
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3541.8
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3600.5
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2623.0
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3223.7
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2578.2
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2379.1
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1962.5
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1998.3
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1672.7
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1756.8
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 756.7
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1850.9
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1880.2
   },
   {
    "Region Name": "Savanes (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1415.7
   }
  ],
  "Savanes (Region of Togo)": [
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1897.4
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2275.7
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2324.0
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3340.7
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2184.2
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1629.0
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2297.4
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1994.7
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1646.8
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2025.6
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1726.1
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1782.0
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1520.5
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1862.2
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1979.9
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1648.5
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1520.7
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1835.4
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1665.0
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2119.5
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1379.9
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1881.1
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1698.9
   },
   {
    "Region Name": "Savanes (Region of Togo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1604.1
   }
  ],
  "Savannah (Region of Ghana)": [
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 22916.0
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 23576.5
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17899.8
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22123.1
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23719.5
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22585.5
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 18240.7
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16695.3
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16846.8
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22143.0
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19582.8
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 19807.1
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19571.7
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18390.1
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16580.8
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19320.9
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15340.0
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18077.5
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15247.0
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15547.3
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5381.3
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14668.0
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15562.8
   },
   {
    "Region Name": "Savannah (Region of Ghana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11328.8
   }
  ],
  "Savannakh\u00e9t (Province of Laos)": [
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 426.0
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 182.2
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 978.4
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 675.9
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 562.9
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 255.1
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 943.2
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 709.1
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 788.7
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 422.1
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 662.4
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 215.7
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 555.0
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 309.3
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 947.9
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 292.4
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 586.1
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 399.8
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 383.5
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 265.4
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 570.0
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 458.3
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 320.7
   },
   {
    "Region Name": "Savannakh\u00e9t (Province of Laos)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 393.6
   }
  ],
  "Savanne (District of Mauritius)": [
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savanne (District of Mauritius)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Savinjska (Statistical Region of Slovenia)": [
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Savinjska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sa\u00efda (Province of Algeria)": [
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sa\u00efda (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Schaffhausen (Canton of Switzerland)": [
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schaffhausen (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Schellenberg (Commune of Liechtenstein)": [
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schellenberg (Commune of Liechtenstein)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Schleswig-Holstein (State of Germany)": [
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schleswig-Holstein (State of Germany)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Schwyz (Canton of Switzerland)": [
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Schwyz (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Scotland (Constituent Country of United Kingdom)": [
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 80.2
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 95.4
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 124.8
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 147.5
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scotland (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 117.5
   }
  ],
  "Scrub Island (Island of Anguilla)": [
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Scrub Island (Island of Anguilla)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sejong (Metropolitan Autonomous City of South Korea)": [
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Selangor (State of Malaysia)": [
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 120.3
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 129.3
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 165.3
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 57.7
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 174.9
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 216.1
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 150.5
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Selangor (State of Malaysia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 44.2
   }
  ],
  "Selenge (Province of Mongolia)": [
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 972.6
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 626.2
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 108.7
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 285.1
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 265.2
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 922.0
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 840.5
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1515.2
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 256.0
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 407.5
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 499.7
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 319.8
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 124.5
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Selenge (Province of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 392.7
   }
  ],
  "Selibe Phikwe (Town of Botswana)": [
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Selibe Phikwe (Town of Botswana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sembabule (District of Uganda)": [
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 101.4
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 359.7
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 137.0
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 370.9
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 162.7
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Sembabule (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.3
   }
  ],
  "Semenawi Keyih Bahri (Region of Eritrea)": [
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16.7
   }
  ],
  "Semnan (Province of Iran)": [
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Semnan (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sennar (State of Sudan)": [
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5970.8
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4579.8
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6453.8
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5643.7
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5306.1
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4606.8
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4789.4
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4520.4
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1447.6
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2319.7
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3399.0
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2716.1
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1686.2
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1289.0
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1849.6
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1930.8
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1827.5
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3260.8
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3998.0
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2563.0
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3532.8
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4405.7
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5431.0
   },
   {
    "Region Name": "Sennar (State of Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2891.0
   }
  ],
  "Seoul (Capital Metropolitan City of South Korea)": [
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sergipe (State of Brazil)": [
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 102.0
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 152.4
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 89.2
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 98.4
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 160.6
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 186.9
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 119.2
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 181.8
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 123.0
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 116.2
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 170.6
   },
   {
    "Region Name": "Sergipe (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 95.0
   }
  ],
  "Sermersooq (Commune of Greenland)": [
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sermersooq (Commune of Greenland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Serravalle (Municipality of San Marino)": [
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Serravalle (Municipality of San Marino)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Set\u00fabal (District of Portugal)": [
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 116.4
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Set\u00fabal (District of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sevastopol' (Autonomous Republic of Ukraine)": [
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Severno-Banatski (District of Serbia)": [
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 76.5
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Severno-Banatski (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Severno-Ba\u010dki (District of Serbia)": [
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 93.5
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Severno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Sfax (Governorate of Tunisia)": [
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sfax (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Shaanxi (Province of China)": [
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1121.1
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1507.4
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2316.5
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1987.0
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2107.9
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1968.3
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 565.7
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 195.1
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 569.1
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 186.5
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 201.1
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Shaanxi (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 116.4
   }
  ],
  "Shabeellaha Dhexe (Region of Somalia)": [
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Shabeellaha Hoose (Region of Somalia)": [
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 254.2
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 365.9
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 72.7
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 118.5
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Shabeellaha Hoose (Region of Somalia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Shabwah (Governorate of Yemen)": [
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shabwah (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Shaki-Zaqatala (Region of Azerbaijan)": [
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 140.8
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 85.7
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 63.7
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 112.1
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 143.8
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 105.7
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 96.5
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16.3
   }
  ],
  "Shamal Sina' (Governorate of Egypt)": [
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shamal Sina' (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Shan (State of Myanmar)": [
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5442.0
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13565.1
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 28267.1
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7166.4
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13243.1
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19971.0
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14797.2
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12793.3
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18767.1
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11745.3
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14662.0
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8933.8
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14751.6
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16599.7
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12675.4
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11097.5
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9838.3
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13141.0
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16542.2
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12135.9
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11188.3
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10624.8
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8998.1
   },
   {
    "Region Name": "Shan (State of Myanmar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14679.6
   }
  ],
  "Shandong (Province of China)": [
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1842.1
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1320.9
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1230.0
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3034.6
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3548.5
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2713.1
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 424.7
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1403.3
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1528.0
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 878.3
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4068.5
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1951.8
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2119.3
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2412.5
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 877.2
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1191.7
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 243.1
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 238.6
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 249.5
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 223.2
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 214.4
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 125.8
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 242.0
   },
   {
    "Region Name": "Shandong (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 319.6
   }
  ],
  "Shanghai (Municipality of China)": [
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 83.8
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shanghai (Municipality of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Shanxi (Province of China)": [
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 164.4
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 355.9
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 213.7
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1013.1
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 491.5
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 238.4
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 345.6
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 743.9
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 193.6
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 417.6
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 326.3
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 181.8
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 524.8
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 420.2
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 192.9
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 155.4
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 146.2
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 700.6
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 457.5
   },
   {
    "Region Name": "Shanxi (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 312.3
   }
  ],
  "Sharjah (Emirate of United Arab Emirates)": [
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sharjah (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Shefa (Province of Vanuatu)": [
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shefa (Province of Vanuatu)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Shida Kartli (Region of Georgia)": [
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Shida Kartli (Region of Georgia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30.4
   }
  ],
  "Shiga (Prefecture of Japan)": [
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shiga (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Shimane (Prefecture of Japan)": [
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shimane (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Shinyanga (Region of Tanzania)": [
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 105.3
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 322.0
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 573.7
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 603.9
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 355.6
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 469.5
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 518.3
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 223.8
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 164.0
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 303.5
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 416.3
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 205.8
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 135.7
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 198.9
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 636.9
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 206.0
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 129.3
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 114.3
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 159.3
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Shinyanga (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30.4
   }
  ],
  "Shirak (Province of Armenia)": [
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Shirak (Province of Armenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 23.6
   }
  ],
  "Shiselweni (District of Swaziland)": [
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 141.1
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 151.8
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 89.4
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 199.1
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 90.9
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 168.1
   },
   {
    "Region Name": "Shiselweni (District of Swaziland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 66.9
   }
  ],
  "Shizuoka (Prefecture of Japan)": [
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shizuoka (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.1
   }
  ],
  "Shkod\u00ebr (County of Albania)": [
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 311.9
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 142.6
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 51.9
   },
   {
    "Region Name": "Shkod\u00ebr (County of Albania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.3
   }
  ],
  "Shumen (Province of Bulgaria)": [
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Shumen (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Si Sa Ket (Province of Thailand)": [
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 92.4
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 157.3
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 72.7
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 78.2
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Si Sa Ket (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 64.3
   }
  ],
  "Siaya (County of Kenya)": [
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Siaya (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.2
   }
  ],
  "Sibiu (County of Romania)": [
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 62.6
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sibiu (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sichuan (Province of China)": [
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 156.5
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 103.3
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 116.8
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 89.2
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 127.5
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 296.0
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 332.7
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 156.5
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 417.6
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 179.4
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 926.1
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 130.1
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 252.5
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 302.9
   },
   {
    "Region Name": "Sichuan (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 40.1
   }
  ],
  "Sicily (Autonomous Region of Italy)": [
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 656.6
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 778.4
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 74.2
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 976.7
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 444.0
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 447.4
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 330.3
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1110.6
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 168.3
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 882.8
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 332.9
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 419.9
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 125.0
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 590.6
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 274.0
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1410.1
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 241.6
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 724.8
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Sicily (Autonomous Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 344.9
   }
  ],
  "Sidi Bel Abb\u00e8s (Province of Algeria)": [
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 97.8
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 149.4
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 286.0
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 168.5
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bel Abb\u00e8s (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sidi Bou Zid (Governorate of Tunisia)": [
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Siemr\u00e9ab (Province of Cambodia)": [
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1092.4
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1660.3
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1539.6
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1625.1
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1642.5
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1447.6
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1568.8
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1075.5
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2069.3
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1212.7
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1847.4
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1267.1
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1488.1
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1586.5
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1525.9
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1220.6
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1373.0
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1304.4
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 843.8
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 405.2
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 300.1
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 844.4
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 872.7
   },
   {
    "Region Name": "Siemr\u00e9ab (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 484.3
   }
  ],
  "Siirt (Province of Turkey)": [
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 187.4
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 117.7
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 133.8
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 106.1
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 242.7
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 281.3
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 107.6
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 131.0
   },
   {
    "Region Name": "Siirt (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.5
   }
  ],
  "Sikasso (Region of Mali)": [
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12640.1
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10557.0
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16488.6
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12246.5
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12548.1
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11311.2
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8622.1
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9196.0
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8772.2
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8943.0
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5231.5
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6606.0
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4930.5
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13505.5
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4386.8
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3819.4
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3056.0
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4020.9
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3554.5
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2791.5
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1859.7
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2985.3
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1582.3
   },
   {
    "Region Name": "Sikasso (Region of Mali)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1608.0
   }
  ],
  "Sikkim (State of India)": [
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sikkim (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sila (Region of Chad)": [
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7913.6
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9370.9
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8461.8
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9361.9
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7503.3
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8898.2
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8267.1
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5053.3
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5008.5
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5139.3
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5285.1
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5293.2
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2625.4
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1950.3
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3919.1
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2905.3
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5319.6
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4803.8
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5005.9
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5202.1
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4424.4
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5494.7
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4952.6
   },
   {
    "Region Name": "Sila (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4321.7
   }
  ],
  "Siliana (Governorate of Tunisia)": [
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siliana (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Silistra (Province of Bulgaria)": [
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 158.0
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Silistra (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Simiyu (Region of Tanzania)": [
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4582.6
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4511.2
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3352.1
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3152.3
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2556.1
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5406.0
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3424.1
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2726.1
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4299.0
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 945.8
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2071.9
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2648.5
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2430.7
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2053.9
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4075.8
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1235.8
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2339.8
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2722.3
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4687.2
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5670.1
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3244.0
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3469.8
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5004.2
   },
   {
    "Region Name": "Simiyu (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4165.2
   }
  ],
  "Sinaloa (State of M\u00e9xico)": [
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1132.5
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 476.1
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 755.4
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 636.7
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1276.1
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 988.9
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1643.8
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 558.4
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1218.5
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1400.0
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1312.6
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 866.9
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 532.1
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 252.5
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 888.3
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 409.0
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 567.9
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 773.9
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 496.9
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 762.5
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 324.3
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 895.8
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 314.5
   },
   {
    "Region Name": "Sinaloa (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 632.4
   }
  ],
  "Sindh (Province of Pakistan)": [
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 228.9
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 122.4
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 206.2
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 81.9
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 360.8
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 173.6
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 149.2
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 150.1
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 203.2
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 124.1
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 222.3
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 203.2
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 127.8
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 313.2
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 199.6
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 246.3
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 126.5
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 281.9
   },
   {
    "Region Name": "Sindh (Province of Pakistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 576.7
   }
  ],
  "Sing Buri (Province of Thailand)": [
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 211.2
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 133.6
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 119.2
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 244.8
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 191.9
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 146.8
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 489.2
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 140.6
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 143.0
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Sing Buri (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 34.1
   }
  ],
  "Singave (Kingdom of Wallis and Futuna)": [
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Singave (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Singida (Region of Tanzania)": [
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9376.9
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10594.5
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9850.0
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10316.7
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4579.4
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7858.6
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8260.3
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8721.2
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9998.6
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9750.6
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8461.8
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8597.9
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7873.8
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8045.1
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7709.6
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7784.4
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6446.3
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7933.4
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7303.8
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5495.8
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5460.8
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6621.2
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5329.9
   },
   {
    "Region Name": "Singida (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7015.7
   }
  ],
  "Sinoe (County of Liberia)": [
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sinoe (County of Liberia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Sinop (Province of Turkey)": [
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sinop (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)": [
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sin\u016diju (Special Administrative Region of North Korea)": [
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sin\u016diju (Special Administrative Region of North Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sipaliwini (District of Suriname)": [
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 401.5
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 423.4
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 262.6
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 86.0
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 322.2
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 192.5
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 351.1
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 340.6
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 288.1
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 255.3
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 330.3
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 171.5
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 239.2
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 139.8
   },
   {
    "Region Name": "Sipaliwini (District of Suriname)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 177.9
   }
  ],
  "Siparia (Region of Trinidad and Tobago)": [
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Siparia (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Siquijor (Province of Philippines)": [
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Siquijor (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sirdaryo (Region of Uzbekistan)": [
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sirdaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sirnak (Province of Turkey)": [
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 113.4
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 93.9
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 111.3
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 237.9
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 325.2
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 95.0
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 133.1
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 150.3
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 405.6
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 414.4
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 228.1
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 192.1
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 200.6
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 238.6
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 95.4
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 130.6
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 161.8
   },
   {
    "Region Name": "Sirnak (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 35.2
   }
  ],
  "Sironko (District of Uganda)": [
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 223.4
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 220.8
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 187.8
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 338.9
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 244.0
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 145.8
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 167.9
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 235.8
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 190.8
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 145.8
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 222.5
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 233.2
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 204.5
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 188.9
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 130.6
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 182.9
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 80.0
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 238.8
   },
   {
    "Region Name": "Sironko (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 105.7
   }
  ],
  "Sisacko-Moslavacka (County of Croatia)": [
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sisacko-Moslavacka (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sistan and Baluchestan (Province of Iran)": [
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 62.6
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sistan and Baluchestan (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.3
   }
  ],
  "Sister Islands (District of Cayman Islands)": [
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sister Islands (District of Cayman Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sivas (Province of Turkey)": [
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 126.0
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 195.9
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 125.4
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 273.7
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Sivas (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 38.6
   }
  ],
  "Sj\u00e6lland (Region of Denmark)": [
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 100.8
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sj\u00e6lland (Region of Denmark)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Skikda (Province of Algeria)": [
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 221.4
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 217.2
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 145.3
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 163.8
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 114.7
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Skikda (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.1
   }
  ],
  "Sk\u00e5ne (County of Sweden)": [
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sk\u00e5ne (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sligo (County of Ireland)": [
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sligo (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sliven (Province of Bulgaria)": [
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sliven (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Smiths (Parish of Bermuda)": [
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smiths (Parish of Bermuda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Smolensk (Region of Russia)": [
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1180.5
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 922.6
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 114.7
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 634.1
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 630.0
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3606.8
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 773.2
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 768.7
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 618.0
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 216.5
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 870.6
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 694.1
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 753.3
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 330.6
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5600.8
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1550.3
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 779.4
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 308.9
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 512.3
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Smolensk (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 152.4
   }
  ],
  "Smolyan (Province of Bulgaria)": [
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Smolyan (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sofala (Province of Mozambique)": [
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17314.2
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 20865.2
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17036.3
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19048.8
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22807.4
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 20562.9
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24004.6
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20660.9
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20270.9
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19268.6
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21737.2
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 17893.2
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17745.9
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20110.6
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14766.0
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16480.5
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19168.0
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 20798.3
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19430.4
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18126.0
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17053.7
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14948.2
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14768.3
   },
   {
    "Region Name": "Sofala (Province of Mozambique)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13774.7
   }
  ],
  "Sofia (Province of Bulgaria)": [
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Sofia (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.4
   }
  ],
  "Sogn og Fjordane (County of Norway)": [
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sogn og Fjordane (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sokoto (State of Nigeria)": [
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1399.8
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1683.2
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1803.7
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1876.4
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1976.5
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 357.1
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 675.7
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1455.4
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1421.1
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 908.7
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 937.0
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 361.2
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 431.7
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 947.3
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 607.1
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1724.0
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2697.4
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2227.1
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2507.5
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3057.8
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3587.0
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4010.8
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3552.3
   },
   {
    "Region Name": "Sokoto (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4342.3
   }
  ],
  "Solol\u00e1 (Department of Guatemala)": [
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Solol\u00e1 (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Solothurn (Canton of Switzerland)": [
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Solothurn (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Somali (State of Ethiopia)": [
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 212.2
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 151.6
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 82.7
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 184.6
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 277.0
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 94.5
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 252.7
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 252.5
   },
   {
    "Region Name": "Somali (State of Ethiopia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 119.2
   }
  ],
  "Sombrero Island (Island of Anguilla)": [
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sombrero Island (Island of Anguilla)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Somogy (County of Hungary)": [
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Somogy (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.1
   }
  ],
  "Songkhla (Province of Thailand)": [
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Songkhla (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Songwe (Region of Tanzania)": [
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5944.7
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5888.5
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7106.1
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6519.6
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6290.7
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5734.6
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5799.3
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5954.1
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5682.5
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5627.6
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5770.0
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5907.6
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5100.5
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4970.6
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5279.7
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5268.8
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4064.9
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4121.0
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3303.9
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3015.5
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3286.9
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2834.2
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3202.7
   },
   {
    "Region Name": "Songwe (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2990.2
   }
  ],
  "Sonora (State of M\u00e9xico)": [
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 883.8
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 610.7
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 251.2
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 383.3
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 394.7
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 584.8
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 393.4
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 279.3
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 256.4
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1827.1
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1143.2
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1085.6
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 580.7
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 233.0
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 695.0
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 992.7
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 619.5
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 625.1
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 192.3
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 549.4
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 616.1
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1000.9
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 98.8
   },
   {
    "Region Name": "Sonora (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 529.3
   }
  ],
  "Sonsonate (Department of El Salvador)": [
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsonate (Department of El Salvador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sonsorol (State of Palau)": [
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sonsorol (State of Palau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sool (Region of Somalia)": [
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sool (Region of Somalia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sopi\u0161te (Municipality of North Macedonia)": [
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Soriano (Department of Uruguay)": [
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Soriano (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.4
   }
  ],
  "Soroca (District of Moldova)": [
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soroca (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Soroti (District of Uganda)": [
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 122.4
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 193.1
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 176.4
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Soroti (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Sorsogon (Province of Philippines)": [
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sorsogon (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Soufri\u00e8re (Quarter of Saint Lucia)": [
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Soufri\u00e8re (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Souk Ahras (Province of Algeria)": [
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 60.5
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Souk Ahras (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.9
   }
  ],
  "Sous le Vent (Parish of Saint-Barth\u00e9lemy)": [
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sous le Vent (Parish of Saint-Barth\u00e9lemy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Souss - Massa - Dra\u00e2 (Region of Morocco)": [
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Souss - Massa - Dra\u00e2 (Region of Morocco)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sousse (Governorate of Tunisia)": [
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 80.0
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sousse (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "South (Governorate of Lebanon)": [
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "South (Governorate of Lebanon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "South Abaco (District of Bahamas)": [
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 111.3
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 201.3
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 162.9
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 191.6
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 130.6
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "South Abaco (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.6
   }
  ],
  "South Andros (District of Bahamas)": [
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Andros (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "South Australia (State of Australia)": [
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24545.9
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 336.1
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3878.8
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2020.4
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3219.2
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1662.9
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 625.5
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 693.1
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1512.6
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15718.4
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 23569.2
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5427.2
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1265.2
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 796.8
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 497.3
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4055.6
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4652.2
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6349.0
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 402.6
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 486.4
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 734.6
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6250.4
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 586.1
   },
   {
    "Region Name": "South Australia (State of Australia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1008.2
   }
  ],
  "South Caicos and East Caicos (District of Turks and Caicos Islands)": [
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "South Carolina (State of United States)": [
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 132.3
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 367.0
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 217.2
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 269.0
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 254.5
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 245.7
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 207.5
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 195.5
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 203.9
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 261.1
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 265.0
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 163.3
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 159.9
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 235.8
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 163.6
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 146.0
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 107.4
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 177.5
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 221.7
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 110.4
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 102.5
   },
   {
    "Region Name": "South Carolina (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 66.5
   }
  ],
  "South Cotabato (Province of Philippines)": [
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "South Cotabato (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.0
   }
  ],
  "South Dakota (State of United States)": [
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 258.5
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 110.6
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 106.1
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 244.2
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 237.1
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 159.5
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 475.0
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 127.1
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 324.1
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 75.5
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 292.8
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 98.8
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 154.1
   },
   {
    "Region Name": "South Dakota (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 53.2
   }
  ],
  "South Darfur (State of Sudan)": [
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 22723.8
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19285.9
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24172.5
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21724.2
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25064.5
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24242.1
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23377.6
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20230.6
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18844.5
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17120.6
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13901.2
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16041.7
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11920.2
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11062.1
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15398.6
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11776.1
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9579.3
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12131.1
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14004.3
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14526.7
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11030.1
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16743.9
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13866.5
   },
   {
    "Region Name": "South Darfur (State of Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13932.9
   }
  ],
  "South Eleuthera (District of Bahamas)": [
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Eleuthera (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "South Kazakhstan (Region of Kazakhstan)": [
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4524.0
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2923.1
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7602.0
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1534.7
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1414.6
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1593.6
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1031.1
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1508.9
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 566.4
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 643.3
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 144.1
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 340.4
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1024.9
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 603.9
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 323.3
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 490.7
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 473.1
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1445.3
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 690.1
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 268.6
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 74.4
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "South Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 234.3
   }
  ],
  "South Khorasan (Province of Iran)": [
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South Khorasan (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "South Kurdufan (State of Sudan)": [
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16188.5
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 20284.5
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 18784.9
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22494.8
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17640.9
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 20258.5
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12819.9
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13250.1
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12368.7
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13440.9
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21513.6
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13097.1
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16914.6
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14989.8
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17640.2
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16846.2
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18679.3
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16361.9
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19550.2
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17440.2
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12790.5
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21805.0
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19345.5
   },
   {
    "Region Name": "South Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19846.3
   }
  ],
  "South-East (District of Botswana)": [
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "South-East (District of Botswana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Southampton (Parish of Bermuda)": [
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southampton (Parish of Bermuda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Southern (District of Botswana)": [
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7287.5
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 484.0
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 205.2
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 171.3
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 580.1
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 977.7
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 502.9
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9657.8
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4845.6
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2743.3
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 190.6
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 225.5
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 346.6
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2962.8
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6004.3
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9218.9
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1329.1
   },
   {
    "Region Name": "Southern (District of Botswana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 708.7
   }
  ],
  "Southern (Governorate of Bahrain)": [
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern (Governorate of Bahrain)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Southern (Province of Sierra Leone)": [
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 430.9
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2653.7
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2015.3
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 604.7
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4033.1
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1022.3
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1201.5
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2294.6
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 704.6
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1011.8
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1957.0
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1398.5
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2920.1
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2546.1
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1181.2
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1505.5
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1618.5
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 923.3
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 506.6
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1319.9
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1229.6
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1032.0
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2763.6
   },
   {
    "Region Name": "Southern (Province of Sierra Leone)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 709.1
   }
  ],
  "Southern (Province of Zambia)": [
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12089.6
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14937.0
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16451.3
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16673.8
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12515.1
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16512.6
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14074.8
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12604.5
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 14239.5
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14005.2
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15935.1
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13809.2
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 13864.1
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14702.9
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12197.0
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10310.5
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9044.0
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9614.2
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7309.8
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8442.3
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8830.9
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8864.2
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6908.0
   },
   {
    "Region Name": "Southern (Province of Zambia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6406.6
   }
  ],
  "Southern Finland (Province of Finland)": [
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Finland (Province of Finland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Southern Highlands (Province of Papua New Guinea)": [
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Southern Islands (Group of islands of New Zealand)": [
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Islands (Group of islands of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Southern Leyte (Province of Philippines)": [
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southern Leyte (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Southern Nations, Nationalities (State of Ethiopia)": [
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8920.1
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7031.9
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11057.2
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10443.2
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2296.5
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12798.5
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5591.2
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4047.9
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8320.3
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9023.6
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8878.9
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9258.6
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8573.3
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8562.3
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10055.4
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7862.6
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8495.7
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1128.4
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7532.5
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6057.0
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7032.2
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1871.0
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8797.9
   },
   {
    "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5106.1
   }
  ],
  "Southland (Region of New Zealand)": [
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Southland (Region of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sowa (Town of Botswana)": [
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sowa (Town of Botswana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Spanish Wells (District of Bahamas)": [
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spanish Wells (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Splitsko-Dalmatinska (County of Croatia)": [
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 116.2
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 248.2
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Spodnjeposavska (Statistical Region of Slovenia)": [
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Srednje-Banatski (District of Serbia)": [
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 112.1
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 236.4
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 150.1
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 145.3
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 626.6
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 136.3
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 218.0
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 88.3
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 404.3
   },
   {
    "Region Name": "Srednje-Banatski (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.4
   }
  ],
  "Sremski (District of Serbia)": [
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 157.8
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 179.9
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 251.5
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 497.6
   },
   {
    "Region Name": "Sremski (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Stann Creek (District of Belize)": [
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 84.0
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Stann Creek (District of Belize)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 55.5
   }
  ],
  "Star Dojran (Municipality of North Macedonia)": [
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Star Dojran (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Stara Zagora (Province of Bulgaria)": [
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 59.4
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 100.8
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 147.1
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Stara Zagora (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16.7
   }
  ],
  "Staro Nagori\u010dane (Municipality of North Macedonia)": [
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Staro Nagori\u010dane (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19.5
   }
  ],
  "Stavropol' (Territory of Russia)": [
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3454.3
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1045.9
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3208.5
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6493.2
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8418.5
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8654.7
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6627.0
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4561.1
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3309.6
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3169.2
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1212.7
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1294.1
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3687.1
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4071.5
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1470.4
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1859.0
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 844.2
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 926.9
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 653.8
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 253.4
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 632.4
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 515.1
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 937.9
   },
   {
    "Region Name": "Stavropol' (Territory of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1769.2
   }
  ],
  "Steiermark (State of Austria)": [
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Steiermark (State of Austria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Stockholm (County of Sweden)": [
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stockholm (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Stoney Ground (District of Anguilla)": [
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Stoney Ground (District of Anguilla)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Streymoyar (Region of Faroe Islands)": [
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Streymoyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Struga (Municipality of North Macedonia)": [
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Struga (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Strumitsa (Municipality of North Macedonia)": [
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Strumitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Str\u0103\u0219eni (District of Moldova)": [
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Str\u0103\u0219eni (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Studeni\u010dani (Municipality of North Macedonia)": [
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Studeni\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "St\u0153ng Tr\u00e9ng (Province of Cambodia)": [
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3225.4
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2668.0
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2811.0
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3148.2
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2750.8
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2593.7
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3203.1
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2329.3
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2788.9
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2346.5
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3047.5
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2605.9
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2560.9
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3029.9
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2470.2
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2853.5
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2728.1
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2714.6
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2712.8
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2726.8
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2247.2
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2475.7
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2044.0
   },
   {
    "Region Name": "St\u0153ng Tr\u00e9ng (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2001.8
   }
  ],
  "St\u0159edo\u010desk\u00fd (Region of Czechia)": [
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "St\u0159edo\u010desk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.8
   }
  ],
  "Suceava (County of Romania)": [
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Suceava (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Suchitep\u00e9quez (Department of Guatemala)": [
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 195.1
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 136.6
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 153.3
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 227.0
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 211.6
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 192.5
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 159.5
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 214.2
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 248.2
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 223.2
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 209.4
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 207.7
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 223.2
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 177.7
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 222.5
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 252.1
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 245.9
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 260.9
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 218.0
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 188.0
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 239.9
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 193.4
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 219.7
   },
   {
    "Region Name": "Suchitep\u00e9quez (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 179.6
   }
  ],
  "Sucre (Department of Colombia)": [
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 51.4
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Sucre (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Sucre (State of Venezuela)": [
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 435.0
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 118.5
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 170.6
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 169.8
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 216.9
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 242.2
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 175.6
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 289.6
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 65.4
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 112.8
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 229.2
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 480.8
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 186.7
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 301.8
   },
   {
    "Region Name": "Sucre (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 40.3
   }
  ],
  "Sucumbios (Province of Ecuador)": [
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sucumbios (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sud (Department of Haiti)": [
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Department of Haiti)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sud (Province of New Caledonia)": [
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Sud (Province of New Caledonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sud (Region of Cameroon)": [
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Sud (Region of Cameroon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.0
   }
  ],
  "Sud-Est (Department of Haiti)": [
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sud-Est (Department of Haiti)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sud-Kivu (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3771.6
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2764.7
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2987.2
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2381.4
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2382.7
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1441.2
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1729.1
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1887.1
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1962.5
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1496.7
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1433.5
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1701.4
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1646.8
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1627.7
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2005.9
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1529.7
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1280.0
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1178.8
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1832.0
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1155.7
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1131.0
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1724.6
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1839.3
   },
   {
    "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1358.5
   }
  ],
  "Sud-Ouest (Region of Burkina Faso)": [
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5399.1
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4306.2
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3930.5
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5413.5
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4128.5
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4139.9
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3584.0
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3296.8
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4381.9
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3659.3
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2957.6
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2858.2
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2246.8
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2003.3
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2231.6
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1877.0
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1078.7
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1378.6
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1314.3
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 906.6
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1015.5
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1981.0
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 839.9
   },
   {
    "Region Name": "Sud-Ouest (Region of Burkina Faso)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 523.1
   }
  ],
  "Sud-Ouest (Region of Cameroon)": [
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 192.3
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 81.9
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 88.3
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 193.6
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 219.9
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 119.0
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 89.8
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 149.8
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 265.4
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 113.6
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 107.6
   },
   {
    "Region Name": "Sud-Ouest (Region of Cameroon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.7
   }
  ],
  "Sud-Ubangi (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4140.8
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3609.3
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3856.3
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3193.9
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5138.4
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6222.1
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2431.8
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3733.2
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5197.6
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5242.6
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5355.6
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3930.5
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4131.1
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5364.2
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3741.2
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4404.4
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6979.2
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5384.9
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6961.6
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6724.3
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5324.5
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5050.7
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4942.1
   },
   {
    "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4048.8
   }
  ],
  "Sughd (Region of Tajikistan)": [
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sughd (Region of Tajikistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Suhaj (Governorate of Egypt)": [
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Suhaj (Governorate of Egypt)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sukhothai (Province of Thailand)": [
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 115.3
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 287.7
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 264.3
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 119.6
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 204.7
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 104.8
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 173.2
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 241.4
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 108.3
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 135.5
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 108.5
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 109.8
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 248.2
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 254.5
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 191.4
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 95.4
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 113.0
   },
   {
    "Region Name": "Sukhothai (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.4
   }
  ],
  "Sulawesi Barat (Province of Indonesia)": [
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sulawesi Barat (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sulawesi Selatan (Province of Indonesia)": [
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 320.9
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 128.4
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 142.6
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 84.2
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Sulawesi Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.5
   }
  ],
  "Sulawesi Tengah (Province of Indonesia)": [
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 322.0
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 113.8
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 153.1
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 462.6
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulawesi Tengah (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Sulawesi Tenggara (Province of Indonesia)": [
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 172.8
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 131.8
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 204.1
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 150.7
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 320.9
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 62.6
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 97.3
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 139.3
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 139.3
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 152.2
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 140.6
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 55.1
   }
  ],
  "Sulawesi Utara (Province of Indonesia)": [
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 56.0
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 134.4
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Sulawesi Utara (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sultan Kudarat (Province of Philippines)": [
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Sultan Kudarat (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sulu (Province of Philippines)": [
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sulu (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Sumatera Barat (Province of Indonesia)": [
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 80.0
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 161.4
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Sumatera Barat (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 16.9
   }
  ],
  "Sumatera Selatan (Province of Indonesia)": [
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4599.1
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 362.3
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3103.0
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7112.3
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 530.1
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 127.1
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2278.1
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2037.4
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2260.3
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 140.8
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2886.0
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4235.3
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 414.2
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4208.3
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2303.0
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 78.0
   },
   {
    "Region Name": "Sumatera Selatan (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.4
   }
  ],
  "Sumatera Utara (Province of Indonesia)": [
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 346.2
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 328.4
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 341.7
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 577.7
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 238.4
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 194.0
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 122.4
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 217.6
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 207.7
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 122.4
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 63.5
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Sumatera Utara (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 154.8
   }
  ],
  "Sumy (Region of Ukraine)": [
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1003.5
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 105.5
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 439.7
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 890.7
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 223.8
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 353.5
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 796.4
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 800.5
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 154.3
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 114.9
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 227.4
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 526.1
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 391.4
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 128.0
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 168.1
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 282.8
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 699.7
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 772.8
   },
   {
    "Region Name": "Sumy (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 166.6
   }
  ],
  "Suphan Buri (Province of Thailand)": [
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 350.1
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 499.7
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 684.9
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 185.9
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 426.6
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 378.6
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 424.9
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 745.1
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 420.2
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 806.7
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 801.3
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 681.9
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 673.3
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 383.9
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 249.1
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 501.0
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 791.5
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 442.5
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 188.6
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 256.6
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 416.3
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 522.6
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 287.3
   },
   {
    "Region Name": "Suphan Buri (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 215.9
   }
  ],
  "Surat Thani (Province of Thailand)": [
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surat Thani (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Surigao del Norte (Province of Philippines)": [
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Norte (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Surigao del Sur (Province of Philippines)": [
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surigao del Sur (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Surin (Province of Thailand)": [
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 172.6
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 238.8
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 545.4
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 812.9
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 205.6
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 257.5
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 200.9
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 207.9
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 120.7
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 128.4
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 122.8
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 156.1
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 108.9
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 116.8
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 98.8
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 179.6
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 135.5
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 136.8
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Surin (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 86.4
   }
  ],
  "Surt (District of Libya)": [
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Surt (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Surxondaryo (Region of Uzbekistan)": [
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 129.9
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 125.6
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Surxondaryo (Region of Uzbekistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.6
   }
  ],
  "Su\u00f0urland (Region of Iceland)": [
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urland (Region of Iceland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Su\u00f0urnes (Independent Town of Iceland)": [
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Su\u00f0urnes (Independent Town of Iceland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Su\u00f0uroyar (Region of Faroe Islands)": [
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Su\u00f0uroyar (Region of Faroe Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Svalbard (Territory of Svalbard and Jan Mayen)": [
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Svay Rieng (Province of Cambodia)": [
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Svay Rieng (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.4
   }
  ],
  "Sverdlovsk (Region of Russia)": [
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 178.8
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 400.9
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3509.4
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 298.4
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 709.3
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 194.4
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1248.9
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 259.8
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2718.8
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 576.2
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 195.3
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 147.1
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 133.6
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 121.3
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 124.8
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 747.9
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 97.3
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1430.5
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Sverdlovsk (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.6
   }
  ],
  "Sveti Nikole (Municipality of North Macedonia)": [
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 87.9
   },
   {
    "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Syddanmark (Region of Denmark)": [
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 28.1
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Syddanmark (Region of Denmark)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Sylhet (Division of Bangladesh)": [
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Sylhet (Division of Bangladesh)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Syunik (Province of Armenia)": [
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 92.2
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 137.4
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Syunik (Province of Armenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 28.5
   }
  ],
  "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)": [
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 54.4
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Szabolcs-Szatm\u00e1r-Bereg (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)": [
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e1nchez Ram\u00edrez (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "S\u00e3o Domingos (County of Cabo Verde)": [
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Domingos (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "S\u00e3o Filipe (County of Cabo Verde)": [
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Filipe (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)": [
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Louren\u00e7o dos \u00d3rg\u00e3os (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "S\u00e3o Miguel (County of Cabo Verde)": [
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Miguel (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "S\u00e3o Paulo (State of Brazil)": [
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7079.8
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7646.1
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6947.5
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7813.3
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10136.4
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11411.5
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9384.0
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6481.4
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12595.7
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8354.0
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4669.0
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3040.2
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4325.1
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1961.7
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2473.2
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3635.7
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2662.7
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2271.0
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5388.4
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6117.0
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 858.3
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 941.1
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9605.0
   },
   {
    "Region Name": "S\u00e3o Paulo (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1430.1
   }
  ],
  "S\u00e3o Salvador do Mundo (County of Cabo Verde)": [
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Salvador do Mundo (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)": [
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "S\u00e3o Tom\u00e9 (Municipality of S\u00e3o Tom\u00e9 and Pr\u00edncipe)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "S\u00e3o Vicente (County of Cabo Verde)": [
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00e3o Vicente (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "S\u00e9dhiou (Region of Senegal)": [
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4227.6
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2894.2
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4816.9
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3944.4
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5319.1
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3452.0
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3273.8
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3389.0
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3566.9
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3882.4
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2072.5
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4566.7
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3423.7
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2388.1
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3360.2
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4247.1
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3432.9
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3992.0
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2959.8
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2296.3
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3016.4
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5026.5
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1795.8
   },
   {
    "Region Name": "S\u00e9dhiou (Region of Senegal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3216.2
   }
  ],
  "S\u00e9gou (Region of Mali)": [
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1250.4
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2889.3
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5195.4
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3769.9
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3727.9
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4333.7
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4009.8
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2358.9
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4272.8
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1669.7
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3267.4
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3887.6
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1396.8
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2928.9
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2085.0
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1755.9
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2023.2
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1884.1
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2417.2
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2235.9
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2691.8
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3534.1
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4959.0
   },
   {
    "Region Name": "S\u00e9gou (Region of Mali)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4915.1
   }
  ],
  "S\u00e9tif (Province of Algeria)": [
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "S\u00e9tif (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.0
   }
  ],
  "S\u00eengerei (District of Moldova)": [
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00eengerei (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "S\u00f3c Tr\u0103ng (Province of Vietnam)": [
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 238.8
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 83.8
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 150.9
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 182.4
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 206.2
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 125.2
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 490.9
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 179.2
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 365.9
   },
   {
    "Region Name": "S\u00f3c Tr\u0103ng (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 130.6
   }
  ],
  "S\u00f6dermanland (County of Sweden)": [
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f6dermanland (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "S\u00f8r-Tr\u00f8ndelag (County of Norway)": [
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00f8r-Tr\u00f8ndelag (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "S\u00fchbaatar (Province of Mongolia)": [
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 159.1
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 426.6
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3494.9
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2230.7
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2649.6
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 586.5
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 684.5
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2371.3
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5439.6
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2291.2
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3388.5
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 393.2
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 415.2
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 446.3
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 358.6
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 260.7
   },
   {
    "Region Name": "S\u00fchbaatar (Province of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 321.3
   }
  ],
  "S\u0103laj (County of Romania)": [
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "S\u0103laj (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "S\u01a1n La (Province of Vietnam)": [
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 216.5
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 965.7
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1143.0
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 932.9
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1178.6
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1025.5
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 293.0
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 430.2
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 708.5
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 334.8
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 588.0
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 519.2
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 286.4
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1338.7
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 198.3
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 144.3
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 116.2
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 576.9
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 187.8
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 136.6
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 222.7
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 164.4
   },
   {
    "Region Name": "S\u01a1n La (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 140.4
   }
  ],
  "Ta`izz (Governorate of Yemen)": [
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ta`izz (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tabasco (State of M\u00e9xico)": [
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 443.7
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1838.0
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 237.5
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1341.9
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 172.1
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1616.8
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 192.1
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1032.8
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 236.7
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 345.6
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 207.9
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 616.5
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 91.7
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 591.0
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 765.7
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 835.6
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 744.7
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1133.8
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 363.1
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 326.7
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 170.4
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 670.5
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1042.9
   },
   {
    "Region Name": "Tabasco (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1390.0
   }
  ],
  "Tabora (Region of Tanzania)": [
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13555.2
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15858.4
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 23353.4
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18830.4
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16604.4
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11553.4
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13863.5
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12763.1
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12710.8
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15412.1
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14371.1
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11487.2
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12911.4
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12188.6
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11169.3
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12825.9
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8457.3
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10574.2
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7925.4
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7305.9
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8008.2
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7650.4
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6055.5
   },
   {
    "Region Name": "Tabora (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5861.9
   }
  ],
  "Tabuk (Province of Saudi Arabia)": [
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Tabuk (Province of Saudi Arabia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Tacna (Region of Peru)": [
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tacna (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tacuaremb\u00f3 (Department of Uruguay)": [
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Tacuaremb\u00f3 (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.4
   }
  ],
  "Tadjoura (Region of Djibouti)": [
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadjoura (Region of Djibouti)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tadla - Azilal (Region of Morocco)": [
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tadla - Azilal (Region of Morocco)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tafea (Province of Vanuatu)": [
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafea (Province of Vanuatu)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tafilah (Province of Jordan)": [
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tafilah (Province of Jordan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tagant (Region of Mauritania)": [
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tagant (Region of Mauritania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tahoua (Department of Niger)": [
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 429.2
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 279.5
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 372.4
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 178.6
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 224.9
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 142.6
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 194.4
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 545.4
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3828.4
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2197.1
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 830.0
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4540.5
   },
   {
    "Region Name": "Tahoua (Department of Niger)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4798.7
   }
  ],
  "Taichung (Special Municipality of Taiwan)": [
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taichung (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Tainan (Special Municipality of Taiwan)": [
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tainan (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Taipei (Special Municipality of Taiwan)": [
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taipei (Special Municipality of Taiwan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Taita Taveta (County of Kenya)": [
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 74.4
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 597.7
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 276.5
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 192.9
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 74.2
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1766.2
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 95.4
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 230.2
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 247.8
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 116.4
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 832.4
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "Taita Taveta (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 76.5
   }
  ],
  "Taiwan (Province of Taiwan)": [
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Taiwan (Province of Taiwan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Tak (Province of Thailand)": [
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 801.7
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2363.8
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2880.5
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 882.6
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1994.1
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1821.1
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1574.1
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1557.4
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1573.0
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1056.8
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1178.4
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1784.0
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1740.9
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1307.7
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1657.7
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1820.4
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2391.1
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2108.7
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2108.1
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 634.3
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1598.5
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 354.1
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1488.6
   },
   {
    "Region Name": "Tak (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 617.4
   }
  ],
  "Takamaka (District of Seychelles)": [
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takamaka (District of Seychelles)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Takhar (Province of Afghanistan)": [
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Takhar (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tak\u00e9 (Province of Cambodia)": [
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 161.8
   },
   {
    "Region Name": "Tak\u00e9 (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.6
   }
  ],
  "Talas (Province of Kyrgyzstan)": [
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Talas (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.7
   }
  ],
  "Talofofo (Municipality of Guam)": [
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Talofofo (Municipality of Guam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tamanghasset (Province of Algeria)": [
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamanghasset (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tamaulipas (State of M\u00e9xico)": [
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 134.8
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 319.0
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 273.7
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 396.2
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 301.4
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 251.2
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 388.4
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 325.0
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 392.5
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1145.2
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 227.2
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 499.1
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 173.6
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 267.3
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 337.6
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 337.8
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 309.3
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 261.1
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 304.8
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 450.8
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 683.4
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 337.6
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 271.8
   },
   {
    "Region Name": "Tamaulipas (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 664.1
   }
  ],
  "Tambacounda (Region of Senegal)": [
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18497.0
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17979.3
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 22938.6
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22086.2
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 25160.7
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22225.8
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 20109.1
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17406.1
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19246.7
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 24527.9
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17541.8
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21590.2
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 18112.7
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18822.2
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 21275.1
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22176.5
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19366.1
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 23629.0
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25500.5
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 23859.1
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 23211.4
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23862.3
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22215.5
   },
   {
    "Region Name": "Tambacounda (Region of Senegal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 22420.2
   }
  ],
  "Tambov (Region of Russia)": [
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2512.6
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 729.5
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1990.6
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2372.9
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1150.9
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 940.4
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3672.6
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3188.1
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1358.2
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 313.0
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 185.6
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 921.6
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1035.6
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 545.6
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 330.8
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 364.2
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 228.1
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 120.7
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 565.5
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 98.0
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 111.9
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 202.4
   },
   {
    "Region Name": "Tambov (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 49.5
   }
  ],
  "Tamil Nadu (State of India)": [
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 112.3
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 151.6
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 451.2
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 107.0
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 107.0
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 172.8
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 260.5
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 196.4
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 130.6
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 315.6
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 217.8
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 187.4
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 97.5
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 88.3
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 187.1
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 164.0
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 142.6
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 294.3
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 166.1
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 175.8
   },
   {
    "Region Name": "Tamil Nadu (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 204.1
   }
  ],
  "Tamuning (Municipality of Guam)": [
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tamuning (Municipality of Guam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tana River (County of Kenya)": [
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 87.9
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 456.0
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "Tana River (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tandjil\u00e9 (Region of Chad)": [
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6781.6
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7383.5
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6616.3
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7246.7
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5984.1
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5996.1
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6423.1
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5240.3
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5576.2
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5671.3
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4324.5
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4663.2
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4270.7
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4102.4
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5268.1
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4491.0
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3267.0
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2569.4
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4534.8
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3596.5
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2396.4
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2545.2
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2141.8
   },
   {
    "Region Name": "Tandjil\u00e9 (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2109.8
   }
  ],
  "Tanga (Region of Tanzania)": [
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2265.5
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3854.6
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3544.2
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4251.2
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 951.8
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4033.1
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2594.9
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3009.1
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4122.5
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1540.7
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1777.1
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 520.7
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 784.4
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 408.6
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 713.0
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 572.2
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 349.4
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 304.2
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 599.4
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 679.5
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 315.3
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 205.8
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 928.6
   },
   {
    "Region Name": "Tanga (Region of Tanzania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 818.2
   }
  ],
  "Tanganyika (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 46235.7
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 50194.9
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 57795.0
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 55448.3
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 55976.0
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 43601.4
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 48371.5
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 52376.3
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 51667.6
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 48507.8
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 47180.7
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 45804.7
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 47056.8
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 51041.3
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 45693.0
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 56398.6
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 44345.2
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 49340.7
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 42960.6
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 45360.1
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 44803.8
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 40774.3
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 38714.4
   },
   {
    "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 41252.7
   }
  ],
  "Tanger - T\u00e9touan (Region of Morocco)": [
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 78.0
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 263.0
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Tanger - T\u00e9touan (Region of Morocco)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 31.1
   }
  ],
  "Tanintharyi (Division of Myanmar)": [
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 248.7
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 201.5
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1197.9
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 815.0
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 482.1
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 668.4
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 185.0
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 114.3
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 359.1
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 133.8
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 249.5
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 468.0
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 680.8
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 625.7
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 612.5
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 125.4
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 530.8
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 956.1
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 89.4
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 167.2
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 609.7
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 492.2
   },
   {
    "Region Name": "Tanintharyi (Division of Myanmar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 55.7
   }
  ],
  "Taraba (State of Nigeria)": [
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11230.1
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16105.8
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17022.4
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13208.1
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13900.3
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12557.3
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9785.9
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10387.9
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9033.5
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8274.4
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7868.0
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8490.1
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7357.4
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7823.6
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5900.3
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6170.8
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6923.0
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4092.7
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5468.6
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7081.3
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5135.4
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6368.5
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5837.1
   },
   {
    "Region Name": "Taraba (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5313.1
   }
  ],
  "Taraclia (District of Moldova)": [
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taraclia (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Taranaki (Region of New Zealand)": [
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taranaki (Region of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tarapac\u00e1 (Region of Chile)": [
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarapac\u00e1 (Region of Chile)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Targovishte (Province of Bulgaria)": [
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Targovishte (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tarija (Department of Bolivia)": [
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 173.6
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 213.3
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 107.8
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 189.5
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 300.8
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 294.8
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 163.8
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 221.0
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 278.5
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 269.7
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 198.3
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 417.2
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 345.1
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 563.4
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 173.0
   },
   {
    "Region Name": "Tarija (Department of Bolivia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 253.4
   }
  ],
  "Tarlac (Province of Philippines)": [
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 72.7
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 56.0
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 86.0
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 97.3
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Tarlac (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 52.7
   }
  ],
  "Tarrafal (County of Cabo Verde)": [
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)": [
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tarrafal de S\u00e3o Nicolau (County of Cabo Verde)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tartu (County of Estonia)": [
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartu (County of Estonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tartus (Governorate of Syria)": [
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tartus (Governorate of Syria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.0
   }
  ],
  "Tasman (Region of New Zealand)": [
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tasman (Region of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tasmania (State of Australia)": [
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 421.7
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 933.8
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 140.0
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 133.3
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1308.7
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 302.5
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 271.4
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 109.1
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 183.3
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1008.2
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 155.8
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1093.7
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 394.0
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 81.7
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1794.7
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 309.8
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 123.9
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 907.4
   },
   {
    "Region Name": "Tasmania (State of Australia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 52.3
   }
  ],
  "Tataouine (Governorate of Tunisia)": [
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tataouine (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tatarstan (Republic of Russia)": [
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2395.1
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 466.9
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 743.6
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 890.7
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1473.1
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 481.5
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1134.2
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 788.7
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 232.8
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 198.5
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 106.3
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 152.0
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 159.1
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 145.8
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Tatarstan (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 74.4
   }
  ],
  "Taurages (County of Lithuania)": [
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taurages (County of Lithuania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tavush (Province of Armenia)": [
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tavush (Province of Armenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24.0
   }
  ],
  "Tawi-Tawi (Province of Philippines)": [
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tawi-Tawi (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Taza - Al Hoceima - Taounate (Region of Morocco)": [
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tbilisi (Independent City of Georgia)": [
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tbilisi (Independent City of Georgia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tbong Khmum (Province of Cambodia)": [
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 219.3
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 237.5
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 403.7
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 183.9
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 173.6
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 147.5
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 128.8
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 158.2
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 177.7
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 117.5
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 131.0
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 145.6
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 166.4
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 234.3
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 179.6
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 170.6
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 363.6
   },
   {
    "Region Name": "Tbong Khmum (Province of Cambodia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 43.5
   }
  ],
  "Tearce (Municipality of North Macedonia)": [
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tearce (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tehran (Province of Iran)": [
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 49.7
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Tehran (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.6
   }
  ],
  "Tekirdag (Province of Turkey)": [
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Tekirdag (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.2
   }
  ],
  "Tel Aviv (District of Israel)": [
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel Aviv (District of Israel)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Telangana (State of India)": [
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 449.1
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 633.7
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1906.4
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1153.1
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 508.9
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1293.1
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2340.3
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1969.4
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 592.1
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3389.2
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 841.8
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 845.3
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2384.6
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2019.1
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1570.9
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2212.3
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1771.5
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1049.1
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1699.9
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2872.1
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3441.5
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1385.7
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2134.9
   },
   {
    "Region Name": "Telangana (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 993.2
   }
  ],
  "Telemark (County of Norway)": [
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telemark (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Telene\u0219ti (District of Moldova)": [
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Telene\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Teleorman (County of Romania)": [
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 161.6
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 192.7
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 63.0
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 684.5
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 179.9
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 572.6
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 332.1
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 243.1
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 265.6
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 363.6
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 176.4
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 433.5
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 236.2
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 97.1
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 343.4
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 228.7
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 283.4
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Teleorman (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19.1
   }
  ],
  "Tel\u0161iai (County of Lithuania)": [
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tel\u0161iai (County of Lithuania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Temburong (District of Brunei)": [
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temburong (District of Brunei)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.4
   }
  ],
  "Temotu (Province of Solomon Islands)": [
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Temotu (Province of Solomon Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tennessee (State of United States)": [
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 118.1
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 126.3
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 104.2
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 100.8
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 106.8
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 56.8
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 132.7
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 141.7
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 144.9
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 72.7
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 89.8
   },
   {
    "Region Name": "Tennessee (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 102.5
   }
  ],
  "Ternopil' (Region of Ukraine)": [
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 388.7
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 113.0
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 209.2
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 221.4
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 239.2
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 347.9
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 463.3
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 113.8
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 196.6
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 265.8
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 144.5
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 391.9
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 843.1
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 653.0
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 457.2
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 314.5
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 282.5
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 138.9
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Ternopil' (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 23.8
   }
  ],
  "Tete (Province of Mozambique)": [
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21830.7
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 24819.4
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 20715.1
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21245.0
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18315.7
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25986.7
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 23425.8
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 20154.8
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 23046.6
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22312.4
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18235.7
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20316.8
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19194.4
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21956.3
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 15994.3
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16277.5
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19019.0
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19526.9
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13878.9
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16118.2
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 20423.6
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15884.7
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12524.5
   },
   {
    "Region Name": "Tete (Province of Mozambique)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13550.1
   }
  ],
  "Tetovo (Municipality of North Macedonia)": [
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tetovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Texas (State of United States)": [
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 455.1
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 862.4
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1307.2
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1744.1
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3742.7
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1979.5
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3019.2
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1314.3
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1549.9
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9563.6
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 952.0
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 621.9
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 706.3
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1201.3
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1532.3
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2533.2
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1844.6
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1402.2
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1194.0
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1476.4
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2711.8
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3685.4
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 941.3
   },
   {
    "Region Name": "Texas (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1116.2
   }
  ],
  "Thaba-Tseka (District of Lesotho)": [
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 301.6
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 126.3
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 217.2
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 72.7
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 102.0
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "Thaba-Tseka (District of Lesotho)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 23.2
   }
  ],
  "Thanh H\u00f3a (Province of Vietnam)": [
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 318.8
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 46.1
   },
   {
    "Region Name": "Thanh H\u00f3a (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 55.5
   }
  ],
  "Tharaka-Nithi (County of Kenya)": [
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Tharaka-Nithi (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "The Quarter (District of Anguilla)": [
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Quarter (District of Anguilla)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "The Valley (District of Anguilla)": [
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "The Valley (District of Anguilla)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Thessaly and Central Greece (Decentralized administration of Greece)": [
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 173.6
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 78.0
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 269.5
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 161.8
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 125.6
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 681.7
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 532.5
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 232.6
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 112.3
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 322.2
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 352.4
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 411.2
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 418.4
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 179.0
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 344.3
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 158.6
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 152.4
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 155.6
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 588.4
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 311.5
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 66.7
   }
  ],
  "Thimphu (District of Bhutan)": [
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Thimphu (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Thi\u00e8s (Region of Senegal)": [
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Thi\u00e8s (Region of Senegal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.8
   }
  ],
  "Thurgau (Canton of Switzerland)": [
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Thurgau (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Thyolo (District of Malawi)": [
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 92.4
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 131.4
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 126.7
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 122.6
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 61.3
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Thyolo (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 8.1
   }
  ],
  "Th\u00e1i B\u00ecnh (Province of Vietnam)": [
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i B\u00ecnh (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Th\u00e1i Nguy\u00ean (Province of Vietnam)": [
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Th\u00e1i Nguy\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Th\u00fcringen (State of Germany)": [
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Th\u00fcringen (State of Germany)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.0
   }
  ],
  "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)": [
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Th\u1eeba Thi\u00ean Hu\u1ebf (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 37.3
   }
  ],
  "Tianjin (Municipality of China)": [
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 141.7
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 111.7
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 113.0
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 149.4
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 117.0
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 166.8
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 290.3
   },
   {
    "Region Name": "Tianjin (Municipality of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 358.4
   }
  ],
  "Tiaret (Province of Algeria)": [
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiaret (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tibesti (Region of Chad)": [
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tibesti (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ticino (Canton of Switzerland)": [
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ticino (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tierra del Fuego (Province of Argentina)": [
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tierra del Fuego (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tigray (State of Ethiopia)": [
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3642.1
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3559.6
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2550.3
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2280.5
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2253.2
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2823.7
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1444.2
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1185.7
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 619.1
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1113.4
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1453.6
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1111.3
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 978.6
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 555.9
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 671.6
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1132.3
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1324.6
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1194.5
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1539.2
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2325.5
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2767.3
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2349.5
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1472.9
   },
   {
    "Region Name": "Tigray (State of Ethiopia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 871.8
   }
  ],
  "Tillab\u00e9ry (Department of Niger)": [
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2329.3
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2889.1
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2301.7
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2538.6
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2757.4
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2147.5
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2896.8
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2395.8
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2011.9
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2065.0
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1991.5
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1937.5
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1998.6
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1960.6
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2052.8
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2913.9
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2731.1
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2496.1
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3234.6
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3756.8
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2578.0
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4351.9
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4290.4
   },
   {
    "Region Name": "Tillab\u00e9ry (Department of Niger)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5512.3
   }
  ],
  "Timbuktu (Region of Mali)": [
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 121.5
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 875.1
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 332.7
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 926.3
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 839.9
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 757.2
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 207.1
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 384.4
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1596.6
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 618.2
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1901.9
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1591.3
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1111.7
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 168.1
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 466.3
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1378.0
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2394.3
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 404.1
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 823.6
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1474.4
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4216.2
   },
   {
    "Region Name": "Timbuktu (Region of Mali)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3231.4
   }
  ],
  "Timi\u0219 (County of Romania)": [
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 172.1
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 210.9
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 132.7
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 365.7
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 93.9
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Timi\u0219 (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.9
   }
  ],
  "Tindouf (Province of Algeria)": [
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tindouf (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tinian (Municipality of Northern Mariana Islands)": [
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tipaza (Province of Algeria)": [
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 142.8
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 181.6
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipaza (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.7
   }
  ],
  "Tipperary (County of Ireland)": [
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tipperary (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tiran\u00eb (County of Albania)": [
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Tiran\u00eb (County of Albania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 39.7
   }
  ],
  "Tiris Zemmour (Region of Mauritania)": [
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tiris Zemmour (Region of Mauritania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tirol (State of Austria)": [
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tirol (State of Austria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tissemsilt (Province of Algeria)": [
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 63.2
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 60.2
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tissemsilt (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tivat (Municipality of Montenegro)": [
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tivat (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Tizi Ouzou (Province of Algeria)": [
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 72.2
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 113.6
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 222.7
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 99.0
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 554.1
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Tizi Ouzou (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.0
   }
  ],
  "Ti\u1ec1n Giang (Province of Vietnam)": [
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 165.5
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 355.2
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 199.6
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 364.9
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 513.8
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 131.2
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 352.4
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 143.8
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 124.1
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Ti\u1ec1n Giang (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.1
   }
  ],
  "Tlaxcala (State of M\u00e9xico)": [
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Tlaxcala (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.0
   }
  ],
  "Tlemcen (Province of Algeria)": [
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 114.0
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 218.9
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 137.2
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 124.5
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tlemcen (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Toa Alta (Municipality of Puerto Rico)": [
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Toa Baja (Municipality of Puerto Rico)": [
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toa Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Toamasina (NA of Madagascar)": [
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 646.3
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3324.6
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1952.3
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2918.8
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2196.0
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3455.8
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 815.9
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3195.8
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3679.6
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3472.6
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3460.8
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2727.6
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2217.9
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3672.8
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3715.0
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1439.7
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2581.4
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2730.8
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3118.0
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2256.4
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2878.5
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1884.7
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3818.1
   },
   {
    "Region Name": "Toamasina (NA of Madagascar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 941.5
   }
  ],
  "Tobago (Region of Trinidad and Tobago)": [
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tobago (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tocantins (State of Brazil)": [
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 34052.7
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 23533.2
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 33591.0
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 35657.7
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18196.7
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 63859.0
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 26868.8
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10856.3
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 69739.2
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 24730.9
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 52818.6
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 21497.8
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34684.7
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 35002.4
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 34513.6
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 41990.0
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14634.5
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 33438.6
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 31279.0
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 19407.0
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 25283.3
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15686.5
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 34945.1
   },
   {
    "Region Name": "Tocantins (State of Brazil)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24042.6
   }
  ],
  "Tochigi (Prefecture of Japan)": [
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Tochigi (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.9
   }
  ],
  "Togdheer (Region of Somalia)": [
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Togdheer (Region of Somalia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tokat (Province of Turkey)": [
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokat (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.5
   }
  ],
  "Tokushima (Prefecture of Japan)": [
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokushima (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tokyo (Metropolis of Japan)": [
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tokyo (Metropolis of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Toledo (District of Belize)": [
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 211.6
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 344.3
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 138.1
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 88.5
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 185.4
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 137.2
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 150.9
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 126.9
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 170.2
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 75.2
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 391.4
   },
   {
    "Region Name": "Toledo (District of Belize)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 74.2
   }
  ],
  "Toliary (NA of Madagascar)": [
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12217.3
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15542.6
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10907.5
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14699.3
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9125.5
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 17857.6
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11361.8
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 10414.9
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9467.8
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9582.5
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10223.3
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11649.7
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7727.8
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8232.0
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14283.6
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9055.4
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7294.5
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8309.6
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8948.6
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6686.4
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5486.3
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6878.0
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8231.8
   },
   {
    "Region Name": "Toliary (NA of Madagascar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9082.6
   }
  ],
  "Tolima (Department of Colombia)": [
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 274.8
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 181.8
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 193.1
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 101.8
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 164.8
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 421.2
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 314.3
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 277.8
   },
   {
    "Region Name": "Tolima (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 30.4
   }
  ],
  "Tolna (County of Hungary)": [
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tolna (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tombali (Region of Guinea-Bissau)": [
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 247.6
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 413.1
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 776.7
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 334.6
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 513.8
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 409.4
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 249.5
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 218.0
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 215.7
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 478.3
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 265.8
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 302.3
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 263.0
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 212.2
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 228.7
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 241.6
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 273.3
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 200.9
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 229.4
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 168.9
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 147.3
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 135.7
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 196.8
   },
   {
    "Region Name": "Tombali (Region of Guinea-Bissau)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 90.9
   }
  ],
  "Tomsk (Region of Russia)": [
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1851.5
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3875.6
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 714.3
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1164.0
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 307.4
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1091.4
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 899.7
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 774.7
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2153.8
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7818.3
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 134.0
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 545.6
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 259.2
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 792.1
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 544.9
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 309.5
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 363.4
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1008.8
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 104.8
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 523.9
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 576.4
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Tomsk (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 54.7
   }
  ],
  "Tongatapu (Island Group of Tonga)": [
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tongatapu (Island Group of Tonga)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Topli\u010dki (District of Serbia)": [
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Topli\u010dki (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 56.2
   }
  ],
  "Torba (Province of Vanuatu)": [
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torba (Province of Vanuatu)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tororo (District of Uganda)": [
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 71.6
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 61.1
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Tororo (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.5
   }
  ],
  "Torteval (Parish of Guernsey)": [
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Torteval (Parish of Guernsey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tortola (District of British Virgin Islands)": [
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tortola (District of British Virgin Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Toscana (Region of Italy)": [
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Toscana (Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.0
   }
  ],
  "Toshkent (Region of Uzbekistan)": [
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 114.5
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 62.6
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 37.5
   },
   {
    "Region Name": "Toshkent (Region of Uzbekistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 26.6
   }
  ],
  "Toshkent Shahri (City of Uzbekistan)": [
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toshkent Shahri (City of Uzbekistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Totonicap\u00e1n (Department of Guatemala)": [
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Totonicap\u00e1n (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tottori (Prefecture of Japan)": [
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tottori (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Toyama (Prefecture of Japan)": [
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Toyama (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Tozeur (Governorate of Tunisia)": [
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tozeur (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Trabzon (Province of Turkey)": [
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trabzon (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Tramuntana (Region of Malta)": [
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tramuntana (Region of Malta)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Trang (Province of Thailand)": [
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trang (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Trans Nzoia (County of Kenya)": [
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 91.7
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Trans Nzoia (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "Transnistria (Territorial Unit of Moldova)": [
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 89.4
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 231.9
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 139.3
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 143.0
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 178.8
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 162.7
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 200.4
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 133.1
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Transnistria (Territorial Unit of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.5
   }
  ],
  "Trarza (Region of Mauritania)": [
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Trarza (Region of Mauritania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.6
   }
  ],
  "Trashi Yangtse (District of Bhutan)": [
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trashi Yangtse (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Trashigang (District of Bhutan)": [
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 76.3
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Trashigang (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Trat (Province of Thailand)": [
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 46.3
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 136.8
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 87.7
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Trat (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Treinta y Tres (Department of Uruguay)": [
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Treinta y Tres (Department of Uruguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 25.9
   }
  ],
  "Trelawny (Parish of Jamaica)": [
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trelawny (Parish of Jamaica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Trengganu (State of Malaysia)": [
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Trengganu (State of Malaysia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Trentino-Alto Adige (Autonomous Region of Italy)": [
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tren\u010diansky (Region of Slovakia)": [
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tren\u010diansky (Region of Slovakia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Triesen (Commune of Liechtenstein)": [
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Triesen (Commune of Liechtenstein)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Trincomalee (District of Sri Lanka)": [
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Trincomalee (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Trinity (Parish of Jersey)": [
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity (Parish of Jersey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)": [
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tripoli (District of Libya)": [
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tripoli (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tripura (State of India)": [
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 132.3
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 748.6
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 111.7
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 271.4
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 130.3
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 126.7
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 321.1
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 387.4
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 167.4
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 116.6
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "Tripura (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 113.0
   }
  ],
  "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)": [
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Trnavsk\u00fd (Region of Slovakia)": [
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Trnavsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "Troms (County of Norway)": [
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Troms (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Trongsa (District of Bhutan)": [
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trongsa (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Trujillo (State of Venezuela)": [
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 133.8
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 96.7
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 88.5
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Trujillo (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.1
   }
  ],
  "Trujillo Alto (Municipality of Puerto Rico)": [
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tr\u00e0 Vinh (Province of Vietnam)": [
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 31.1
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Tr\u00e0 Vinh (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tshopo (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 134.2
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 159.3
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 49.3
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 127.5
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 487.9
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 331.8
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 607.3
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 230.4
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 280.4
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 177.7
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 523.9
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 342.6
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 507.2
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 313.8
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 287.0
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1503.4
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1122.7
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 584.8
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 867.6
   },
   {
    "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 317.5
   }
  ],
  "Tshuapa (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 52.7
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 188.9
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 156.5
   },
   {
    "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.9
   }
  ],
  "Tsingoni (Commune of Mayotte)": [
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Tsingoni (Commune of Mayotte)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tsirang (District of Bhutan)": [
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tsirang (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tuamasaga (District of Samoa)": [
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuamasaga (District of Samoa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tucum\u00e1n (Province of Argentina)": [
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1836.7
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1771.8
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1814.2
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1764.3
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1375.6
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1616.3
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1560.6
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2084.3
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 961.4
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1366.8
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 728.4
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1510.4
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 759.1
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 458.7
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1029.6
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1339.6
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1291.4
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 531.2
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1144.5
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 883.6
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 802.0
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 558.0
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 771.9
   },
   {
    "Region Name": "Tucum\u00e1n (Province of Argentina)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 440.1
   }
  ],
  "Tula (Region of Russia)": [
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 797.0
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 848.7
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 661.5
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1696.5
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 392.7
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1429.0
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3912.0
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 731.0
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 135.3
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 82.7
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 771.5
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 432.4
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 277.6
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 223.8
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 221.9
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 262.4
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 191.6
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 77.2
   },
   {
    "Region Name": "Tula (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 157.1
   }
  ],
  "Tulcea (County of Romania)": [
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 99.0
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 187.4
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 284.9
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 259.4
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 410.7
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 87.9
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 516.0
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 75.7
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 80.2
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 186.3
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 193.1
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 221.4
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 266.2
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 203.7
   },
   {
    "Region Name": "Tulcea (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 122.2
   }
  ],
  "Tumbes (Region of Peru)": [
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Tumbes (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9.4
   }
  ],
  "Tunapuna/Piarco (Region of Trinidad and Tobago)": [
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tunceli (Province of Turkey)": [
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tunceli (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Tungurahua (Province of Ecuador)": [
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Tungurahua (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tunis (Governorate of Tunisia)": [
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tunis (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Turkana (County of Kenya)": [
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 122.8
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 627.5
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 149.0
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 89.2
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1601.6
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 355.2
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 153.9
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 145.8
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 237.7
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 467.1
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 149.6
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1735.5
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 123.7
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 107.0
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 421.4
   },
   {
    "Region Name": "Turkana (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 419.7
   }
  ],
  "Tutong (District of Brunei)": [
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tutong (District of Brunei)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Tuva (Republic of Russia)": [
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5681.9
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 865.2
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 273.7
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 521.3
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 470.1
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2079.2
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 772.4
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 157.3
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 839.9
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 960.4
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 152.8
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1517.1
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2510.5
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 374.1
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 520.5
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 572.4
   },
   {
    "Region Name": "Tuva (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 168.7
   }
  ],
  "Tuy\u00ean Quang (Province of Vietnam)": [
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Tuy\u00ean Quang (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Tver' (Region of Russia)": [
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1394.5
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 758.0
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 695.4
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 544.9
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1054.1
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 359.5
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 561.2
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 263.0
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 289.6
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 885.8
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 192.7
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 98.4
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Tver' (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.4
   }
  ],
  "Tyumen' (Region of Russia)": [
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 262.4
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1674.0
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8713.5
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 971.5
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5669.0
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 612.5
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11162.6
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2263.7
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6197.2
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2558.9
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1594.7
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 169.4
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4308.4
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 78.5
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 92.2
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 235.2
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 349.2
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 645.5
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6369.1
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4225.4
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4990.9
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Tyumen' (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 282.1
   }
  ],
  "T\u00e1chira (State of Venezuela)": [
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "T\u00e1chira (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "T\u00e2y Ninh (Province of Vietnam)": [
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 53.6
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 81.7
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 120.5
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 145.6
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 31.7
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 136.1
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 101.6
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 129.1
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 82.7
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 56.4
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 69.0
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 90.2
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 153.9
   },
   {
    "Region Name": "T\u00e2y Ninh (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 130.3
   }
  ],
  "T\u00e9bessa (Province of Algeria)": [
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 155.6
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 92.0
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00e9bessa (Province of Algeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "T\u00f6v (Province of Mongolia)": [
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 471.2
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 213.7
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 554.4
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 261.3
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 134.0
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 74.2
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 117.3
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 361.6
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "T\u00f6v (Province of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Uasin Gishu (County of Kenya)": [
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 35.2
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 23.2
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Uasin Gishu (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Ubon Ratchathani (Province of Thailand)": [
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 126.3
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 54.9
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 75.5
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 58.5
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 56.0
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 67.7
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 111.5
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 81.9
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 143.0
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Ubon Ratchathani (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 83.6
   }
  ],
  "Ucayali (Region of Peru)": [
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 57.5
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 193.6
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 661.3
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 240.3
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 544.1
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 129.1
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 190.6
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 414.8
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 165.1
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 224.0
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 170.0
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 195.1
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 211.2
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 123.3
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 173.9
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 274.8
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 128.6
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 161.4
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 329.5
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 244.8
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 907.6
   },
   {
    "Region Name": "Ucayali (Region of Peru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 46.3
   }
  ],
  "Udmurt (Republic of Russia)": [
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 178.6
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Udmurt (Republic of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Udon Thani (Province of Thailand)": [
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 283.6
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 321.6
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 356.1
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 279.5
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 256.2
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 92.6
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 91.5
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 195.5
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 96.5
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 227.7
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 114.5
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 182.4
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 156.3
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 154.8
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 109.5
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 125.6
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 274.4
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 90.7
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Udon Thani (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 25.9
   }
  ],
  "Ujae (Atol of Marshall Islands)": [
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ujae (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ul'yanovsk (Region of Russia)": [
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1123.7
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 275.9
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 550.3
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 622.5
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 526.3
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 808.0
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1465.2
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 589.3
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 572.6
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 218.4
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 76.1
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 211.2
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 502.9
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 178.1
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 259.8
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 268.2
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 216.5
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 176.4
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 181.6
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 208.4
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Ul'yanovsk (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 54.9
   }
  ],
  "Ulaanbaatar (Municipality of Mongolia)": [
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ulcinj (Municipality of Montenegro)": [
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ulcinj (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ulsan (Metropolitan City of South Korea)": [
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ulsan (Metropolitan City of South Korea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Umatac (Municipality of Guam)": [
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umatac (Municipality of Guam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Umbria (Region of Italy)": [
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umbria (Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Umm Salal (Municipality of Qatar)": [
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm Salal (Municipality of Qatar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Umm al-Qaywayn (Emirate of United Arab Emirates)": [
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Umujyi wa Kigali (Province of Rwanda)": [
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ungheni (District of Moldova)": [
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ungheni (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Unity (State of South Sudan)": [
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 15163.8
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13133.5
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14527.4
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14422.7
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15351.8
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11419.0
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13372.1
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 17865.9
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13559.5
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15752.3
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13748.3
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11730.3
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8258.6
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15120.1
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13096.4
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 15949.9
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17402.5
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13399.6
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11310.1
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7088.1
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4932.4
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9051.9
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5520.2
   },
   {
    "Region Name": "Unity (State of South Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6623.6
   }
  ],
  "Unorganized (District of American Samoa)": [
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Unorganized (District of American Samoa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Upper Demerara-Berbice (Region of Guyana)": [
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 143.0
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 91.7
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 59.0
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 118.3
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 66.2
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 44.6
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 139.1
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 74.4
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22.1
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 127.1
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 52.3
   }
  ],
  "Upper East (Region of Ghana)": [
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2692.9
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3340.1
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3466.3
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4350.0
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3158.7
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2953.4
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2830.3
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3608.5
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3250.7
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3156.2
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2634.0
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3261.0
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3390.5
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2396.4
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3127.4
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3295.7
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2267.6
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2214.4
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1914.5
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2439.7
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1911.1
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2169.0
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1874.0
   },
   {
    "Region Name": "Upper East (Region of Ghana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1860.5
   }
  ],
  "Upper Nile (State of South Sudan)": [
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 33077.4
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 36176.7
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 26383.0
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 38940.8
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 35257.3
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 32696.2
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 25619.0
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 33308.9
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26457.2
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 28917.3
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 31920.6
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 29636.3
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 28185.9
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 31607.9
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 27046.7
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 25867.0
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30567.7
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 26007.0
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 23056.2
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 24338.6
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19490.6
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 29822.8
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 28880.2
   },
   {
    "Region Name": "Upper Nile (State of South Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24694.7
   }
  ],
  "Upper River (Division of Gambia)": [
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 286.4
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 329.5
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 449.7
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 373.4
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 561.6
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 574.5
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 479.8
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 448.9
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 381.1
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 562.5
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 338.5
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 305.7
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 142.3
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 220.4
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 411.6
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 187.8
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 154.8
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 360.1
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 368.1
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 529.3
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 368.1
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 596.2
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 376.2
   },
   {
    "Region Name": "Upper River (Division of Gambia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 300.8
   }
  ],
  "Upper Takutu-Upper Essequibo (Region of Guyana)": [
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 403.9
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 635.6
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 250.4
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 329.5
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 575.8
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 291.1
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 164.6
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 406.9
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 316.0
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 254.0
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 418.2
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 477.6
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 656.8
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 613.1
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 287.9
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 723.3
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 546.2
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 630.0
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 429.4
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 301.6
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 325.0
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 880.0
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 554.4
   },
   {
    "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 466.5
   }
  ],
  "Upper West (Region of Ghana)": [
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10611.7
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9434.8
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9461.2
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11713.8
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9107.3
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9649.8
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7786.5
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6771.1
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10890.6
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10086.3
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8508.5
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8931.5
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9055.4
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7587.2
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8421.3
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9889.1
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6897.3
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7757.4
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7458.8
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6919.2
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6704.4
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6253.4
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5702.4
   },
   {
    "Region Name": "Upper West (Region of Ghana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5296.2
   }
  ],
  "Uppsala (County of Sweden)": [
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uppsala (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Uri (Canton of Switzerland)": [
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uri (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Uro\u0161evac (District of Kosovo)": [
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Uro\u0161evac (District of Kosovo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 22.1
   }
  ],
  "Uruzgan (Province of Afghanistan)": [
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uruzgan (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Usak (Province of Turkey)": [
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 45.0
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 104.2
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Usak (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.0
   }
  ],
  "Usulut\u00e1n (Department of El Salvador)": [
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 29.2
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 117.3
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 95.6
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 58.7
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Usulut\u00e1n (Department of El Salvador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.3
   }
  ],
  "Utah (State of United States)": [
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1032.2
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 490.9
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 449.1
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1111.1
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 897.8
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1956.3
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 404.5
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 288.5
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 214.8
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1341.7
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 326.1
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 128.6
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 394.2
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 777.1
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1650.9
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 685.8
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 881.1
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 470.5
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 259.8
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 147.9
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 350.1
   },
   {
    "Region Name": "Utah (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 641.4
   }
  ],
  "Utenos (County of Lithuania)": [
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Utenos (County of Lithuania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.5
   }
  ],
  "Uthai Thani (Province of Thailand)": [
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 185.9
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 335.1
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 731.6
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 101.4
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 275.7
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 362.5
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 167.4
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 259.8
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 285.8
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 282.8
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 369.8
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 408.2
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 611.4
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 722.6
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 674.0
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 233.4
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 589.3
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 944.3
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 474.8
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 68.4
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 156.5
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 317.9
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 244.0
   },
   {
    "Region Name": "Uthai Thani (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19.9
   }
  ],
  "Utirik (Atol of Marshall Islands)": [
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utirik (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Utrecht (Province of Netherlands)": [
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utrecht (Province of Netherlands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Uttar Pradesh (State of India)": [
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 440.7
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 733.4
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1170.5
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 904.9
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 842.3
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 768.9
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1362.5
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2163.6
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2061.4
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1779.0
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2918.4
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1655.6
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1954.6
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1057.1
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2851.1
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2962.2
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2992.8
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3510.9
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 940.4
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3076.0
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3279.8
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1920.1
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4081.8
   },
   {
    "Region Name": "Uttar Pradesh (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2606.5
   }
  ],
  "Uttaradit (Province of Thailand)": [
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 218.0
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 341.5
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 630.0
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 199.6
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 211.6
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 213.9
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 170.6
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 217.6
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 273.1
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 106.3
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 237.7
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 251.7
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 198.1
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 190.8
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 191.9
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 122.8
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 212.9
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 328.2
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 388.2
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 291.1
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 292.4
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 254.2
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 297.8
   },
   {
    "Region Name": "Uttaradit (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 56.8
   }
  ],
  "Uttarakhand (State of India)": [
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 271.6
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1373.5
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1250.2
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1134.4
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 347.9
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 490.5
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1178.4
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1658.1
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1297.1
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 230.4
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2144.8
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 365.5
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1469.5
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 864.1
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2355.9
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 740.9
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1210.3
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1877.9
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 409.7
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1155.7
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1334.7
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 375.6
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1609.7
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 446.3
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uttarakhand (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Utuado (Municipality of Puerto Rico)": [
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Utuado (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Uvs (Province of Mongolia)": [
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 108.5
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 48.4
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uvs (Province of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 35.6
   }
  ],
  "Uv\u00e9a (Kingdom of Wallis and Futuna)": [
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Uv\u00e9a (Kingdom of Wallis and Futuna)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "U\u00edge (Province of Angola)": [
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8921.2
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11203.4
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8916.2
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8429.4
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10787.3
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9455.6
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8132.7
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8487.1
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 9907.5
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10735.0
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8446.6
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9515.4
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7566.4
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9175.4
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9200.5
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7629.0
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8501.0
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7437.3
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9552.9
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8290.1
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9343.9
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8203.9
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8934.0
   },
   {
    "Region Name": "U\u00edge (Province of Angola)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7749.9
   }
  ],
  "Va'a-o-Fonoti (District of Samoa)": [
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Va'a-o-Fonoti (District of Samoa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vaisigano (District of Samoa)": [
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaisigano (District of Samoa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vaitupu (Island Council of Tuvalu)": [
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaitupu (Island Council of Tuvalu)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vakaga (Prefecture of Central African Republic)": [
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 34161.8
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 32811.7
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 34357.1
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 33437.1
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 33432.3
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 30091.0
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 32099.0
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 23722.1
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26389.5
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 23628.0
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21891.8
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 24268.5
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 23988.3
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24748.9
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 25740.4
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 27379.6
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22503.0
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 21113.6
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 23449.8
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 23402.4
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 21893.7
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 22090.5
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19837.1
   },
   {
    "Region Name": "Vakaga (Prefecture of Central African Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18894.9
   }
  ],
  "Valais (Canton of Switzerland)": [
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valais (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Valandovo (Municipality of North Macedonia)": [
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Valandovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 23.8
   }
  ],
  "Valduz (Commune of Liechtenstein)": [
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valduz (Commune of Liechtenstein)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vale (Parish of Guernsey)": [
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vale (Parish of Guernsey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Valga (County of Estonia)": [
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valga (County of Estonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Valle (Department of Honduras)": [
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle (Department of Honduras)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Valle d'Aosta (Autonomous Region of Italy)": [
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Valle del Cauca (Department of Colombia)": [
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 58.1
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 120.9
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 57.0
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Valle del Cauca (Department of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.9
   }
  ],
  "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)": [
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6463.9
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5791.6
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5042.2
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4054.4
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4765.6
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5193.5
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2619.6
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3820.5
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3871.9
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3641.5
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3167.9
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3725.1
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2328.3
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2760.2
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1562.1
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1422.6
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1286.4
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1691.6
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 960.2
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1565.1
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 496.7
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 556.7
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 516.0
   },
   {
    "Region Name": "Vall\u00e9e du Bandama (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 355.4
   }
  ],
  "Valpara\u00edso (Region of Chile)": [
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 237.7
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 164.4
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 196.1
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 108.0
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 87.5
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 122.6
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Valpara\u00edso (Region of Chile)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.4
   }
  ],
  "Valverde (Province of Dominican Republic)": [
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Valverde (Province of Dominican Republic)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Van (Province of Turkey)": [
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Van (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.4
   }
  ],
  "Vara\u017edinska (County of Croatia)": [
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vara\u017edinska (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vargas (State of Venezuela)": [
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Vargas (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Varna (Province of Bulgaria)": [
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 177.9
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Varna (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Vas (County of Hungary)": [
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Vas (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.9
   }
  ],
  "Vasilevo (Municipality of North Macedonia)": [
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Vasilevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 40.5
   }
  ],
  "Vaslui (County of Romania)": [
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 142.6
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 94.8
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 96.5
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 70.5
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaslui (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vaud (Canton of Switzerland)": [
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaud (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vaup\u00e9s (Commissiary of Colombia)": [
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Vaup\u00e9s (Commissiary of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Vava'u (Island Group of Tonga)": [
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vava'u (Island Group of Tonga)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vavuniya (District of Sri Lanka)": [
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vavuniya (District of Sri Lanka)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vayots Dzor (Province of Armenia)": [
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vayots Dzor (Province of Armenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.5
   }
  ],
  "Vega Alta (Municipality of Puerto Rico)": [
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Alta (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vega Baja (Municipality of Puerto Rico)": [
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vega Baja (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Veles (Municipality of North Macedonia)": [
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Veles (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Veliko Tarnovo (Province of Bulgaria)": [
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 29.6
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 46.7
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.6
   }
  ],
  "Veneto (Region of Italy)": [
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Veneto (Region of Italy)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.0
   }
  ],
  "Veracruz (State of M\u00e9xico)": [
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 997.2
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2079.6
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 355.2
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1931.0
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 596.8
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1084.5
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 806.5
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 895.2
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1008.0
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1088.1
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 508.9
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 905.1
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 531.0
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 722.6
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 954.8
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 675.7
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1019.1
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1188.9
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 912.4
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 720.7
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1098.9
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 750.3
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1897.0
   },
   {
    "Region Name": "Veracruz (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 905.7
   }
  ],
  "Veraguas (Province of Panama)": [
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 93.3
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 344.5
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 81.2
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 89.2
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 42.7
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 142.8
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 164.2
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Veraguas (Province of Panama)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.9
   }
  ],
  "Vermont (State of United States)": [
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Vermont (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vest-Agder (County of Norway)": [
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vest-Agder (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vestfir\u00f0ir (Region of Iceland)": [
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfir\u00f0ir (Region of Iceland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vestfold (County of Norway)": [
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vestfold (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vesturland (Region of Iceland)": [
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vesturland (Region of Iceland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Veszpr\u00e9m (County of Hungary)": [
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Veszpr\u00e9m (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vev\u010dani (Municipality of North Macedonia)": [
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vev\u010dani (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Viana do Castelo (District of Portugal)": [
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 73.5
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 347.5
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 173.2
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 290.5
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 121.1
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 328.8
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 77.6
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Viana do Castelo (District of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 80.4
   }
  ],
  "Vichada (Commissiary of Colombia)": [
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 13837.5
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 18141.2
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7320.7
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10960.9
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16528.9
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10638.5
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10205.0
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11769.5
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7979.2
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5842.6
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10460.6
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10236.3
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 6194.6
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9978.4
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 6007.3
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 9092.9
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8026.4
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8036.5
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8123.9
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9562.4
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6675.2
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7871.6
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6954.3
   },
   {
    "Region Name": "Vichada (Commissiary of Colombia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4437.7
   }
  ],
  "Victoria (State of Australia)": [
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11762.4
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 228.7
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1493.3
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2777.4
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9864.2
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 375.4
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3849.2
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 599.2
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 613.3
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2161.1
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2156.8
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3921.0
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 994.5
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 925.4
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 244.2
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1146.0
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1438.2
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 14233.7
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 480.6
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2085.0
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 663.3
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1042.0
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4484.0
   },
   {
    "Region Name": "Victoria (State of Australia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4653.3
   }
  ],
  "Vidin (Province of Bulgaria)": [
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 94.3
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 165.9
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Vidin (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 13.1
   }
  ],
  "Vidzeme (Province of Latvia)": [
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 78.2
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vidzeme (Province of Latvia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vientiane (Province of Laos)": [
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 140.2
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 255.1
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 899.7
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 522.4
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 219.1
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1018.7
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 177.3
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 379.0
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 881.7
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 425.7
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 657.0
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 635.0
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 397.0
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 331.0
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 206.0
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 213.5
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 268.2
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 489.6
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 119.2
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 217.4
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 904.2
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 686.2
   },
   {
    "Region Name": "Vientiane (Province of Laos)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 83.8
   }
  ],
  "Vientiane [prefecture] (Municipality|Prefecture of Laos)": [
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 73.7
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 224.4
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 47.4
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 91.1
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 98.2
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 101.2
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 150.3
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 23.4
   }
  ],
  "Vieques (Municipality of Puerto Rico)": [
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieques (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vieux Fort (Quarter of Saint Lucia)": [
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vihiga (County of Kenya)": [
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vihiga (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vila Real (District of Portugal)": [
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 197.2
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 152.6
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 526.5
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 160.1
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 187.1
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 275.7
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 251.7
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 43.5
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 190.8
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 186.9
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 90.0
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 285.8
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 136.6
   },
   {
    "Region Name": "Vila Real (District of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 239.2
   }
  ],
  "Viljandi (County of Estonia)": [
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viljandi (County of Estonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Villa Clara (Province of Cuba)": [
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 117.0
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 183.1
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 233.9
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 253.0
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 134.8
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 77.0
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 28.9
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 150.3
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 118.8
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 69.9
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 67.3
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 171.1
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 111.5
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 101.4
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 113.8
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 199.1
   },
   {
    "Region Name": "Villa Clara (Province of Cuba)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 256.2
   }
  ],
  "Villalba (Municipality of Puerto Rico)": [
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Villalba (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Ville de N'Djamena (Region of Chad)": [
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Ville de N'Djamena (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vilniaus (County of Lithuania)": [
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Vilniaus (County of Lithuania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.3
   }
  ],
  "Vinitsa (Municipality of North Macedonia)": [
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Vinitsa (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vinnytsya (Region of Ukraine)": [
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 151.6
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 163.3
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 449.1
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 229.8
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 663.7
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1611.0
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1589.5
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 432.2
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 536.1
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 174.3
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 462.8
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 699.1
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 734.0
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 687.1
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 664.5
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 499.3
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1099.3
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 218.0
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 201.3
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Vinnytsya (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 22.7
   }
  ],
  "Viqueque (District of Timor-Leste)": [
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viqueque (District of Timor-Leste)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Virgin Gorda (District of British Virgin Islands)": [
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Virgin Gorda (District of British Virgin Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Virginia (State of United States)": [
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 102.3
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 84.7
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 38.8
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 96.0
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 80.0
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 38.6
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 37.3
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 117.9
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 67.1
   },
   {
    "Region Name": "Virginia (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 36.9
   }
  ],
  "Viroviticko-Podravska (County of Croatia)": [
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Viroviticko-Podravska (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Viseu (District of Portugal)": [
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 150.3
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 587.8
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 78.0
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 100.5
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 260.2
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 103.8
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 446.5
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 405.2
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 923.5
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 626.2
   },
   {
    "Region Name": "Viseu (District of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 614.2
   }
  ],
  "Vitebsk (Region of Belarus)": [
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 399.8
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 113.4
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 104.8
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 128.0
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 47.6
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 278.9
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Vitebsk (Region of Belarus)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.6
   }
  ],
  "Vlaanderen (Region of Belgium)": [
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vlaanderen (Region of Belgium)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Vladimir (Region of Russia)": [
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 497.6
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 225.3
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 86.0
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1322.4
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1095.4
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 101.4
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 224.7
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 187.1
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 42.9
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Vladimir (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Vlor\u00eb (County of Albania)": [
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 110.0
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 72.0
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 314.3
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 103.1
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 212.7
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 51.7
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 81.5
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Vlor\u00eb (County of Albania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 286.0
   }
  ],
  "Volgograd (Region of Russia)": [
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7321.8
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1289.9
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6029.3
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 9239.5
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7303.1
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3920.8
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4743.1
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4221.6
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3688.9
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1034.3
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2084.5
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 180.5
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4717.6
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 866.7
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3347.4
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2895.3
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1195.1
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2279.6
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2698.0
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 393.4
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2364.1
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1201.5
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 780.7
   },
   {
    "Region Name": "Volgograd (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1182.5
   }
  ],
  "Vologda (Region of Russia)": [
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 353.5
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 737.2
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24.7
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 144.7
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 108.9
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37.7
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 221.0
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Vologda (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Volta (Region of Ghana)": [
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1672.7
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3245.8
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3945.0
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1129.9
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3345.7
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2318.8
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1670.1
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1404.3
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2725.3
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1913.5
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1423.8
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1069.9
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2327.0
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2594.3
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1589.1
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1311.9
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1247.6
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3404.8
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1244.0
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2481.5
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1405.8
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1248.9
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1189.1
   },
   {
    "Region Name": "Volta (Region of Ghana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 201.1
   }
  ],
  "Volyn (Region of Ukraine)": [
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 32.2
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 68.2
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 76.7
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 233.0
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 157.8
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 189.7
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 85.3
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 35.6
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 136.3
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 47.8
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Volyn (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 24.0
   }
  ],
  "Vorarlberg (State of Austria)": [
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vorarlberg (State of Austria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Voronezh (Region of Russia)": [
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1926.5
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 682.6
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1371.3
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1834.6
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 483.0
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1941.8
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3955.8
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1893.3
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 648.9
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 105.5
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 78.2
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 300.3
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 993.0
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 246.1
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 176.2
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 208.6
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 148.6
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 357.6
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 146.0
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 48.7
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 230.2
   },
   {
    "Region Name": "Voronezh (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 82.7
   }
  ],
  "Vrancea (County of Romania)": [
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 40.5
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 67.5
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrancea (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.9
   }
  ],
  "Vrap\u010di\u0161te (Municipality of North Macedonia)": [
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vrap\u010di\u0161te (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   }
  ],
  "Vratsa (Province of Bulgaria)": [
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 83.0
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 171.7
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 59.6
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 215.2
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 171.3
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 141.3
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 158.6
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 331.4
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 207.1
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 60.9
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 190.4
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 243.5
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 158.6
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 140.6
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 342.3
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 75.0
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "Vratsa (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.6
   }
  ],
  "Vukovarsko-Srijemska (County of Croatia)": [
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "V\u00e1g\u00f8 (Region of Faroe Islands)": [
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e1g\u00f8 (Region of Faroe Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "V\u00e2lcea (County of Romania)": [
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e2lcea (County of Romania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4.3
   }
  ],
  "V\u00e4rmland (County of Sweden)": [
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4rmland (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "V\u00e4sterbotten (County of Sweden)": [
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sterbotten (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "V\u00e4sternorrland (County of Sweden)": [
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4sternorrland (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "V\u00e4stmanland (County of Sweden)": [
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 118.8
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stmanland (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "V\u00e4stra G\u00f6taland (County of Sweden)": [
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00e4stra G\u00f6taland (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "V\u00f5ru (County of Estonia)": [
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u00f5ru (County of Estonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "V\u0129nh Long (Province of Vietnam)": [
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 45.4
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 187.6
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 180.7
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 234.1
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 569.8
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 216.3
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 165.1
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 444.6
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 201.3
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 68.8
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "V\u0129nh Long (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "V\u0129nh Ph\u00fac (Province of Vietnam)": [
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "V\u0129nh Ph\u00fac (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Wadi Fira (Region of Chad)": [
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 372.1
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 95.8
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 805.4
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2003.3
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1149.9
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1819.1
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 844.4
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 665.8
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 545.6
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1638.0
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1876.6
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 460.0
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1660.9
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1125.7
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 206.0
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 814.2
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 183.7
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2521.0
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1556.1
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1015.5
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 315.1
   },
   {
    "Region Name": "Wadi Fira (Region of Chad)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3098.9
   }
  ],
  "Wadi al Hayat (District of Libya)": [
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 24.2
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi al Hayat (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Wadi ash Shati' (District of Libya)": [
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wadi ash Shati' (District of Libya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Waikato (Region of New Zealand)": [
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Waikato (Region of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Wajir (County of Kenya)": [
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 60.0
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 48.0
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 587.6
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1061.6
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 72.5
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3219.6
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1847.2
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 162.3
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 184.1
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 232.6
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 105.7
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 480.4
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 66.5
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 877.2
   },
   {
    "Region Name": "Wajir (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 45.0
   }
  ],
  "Wakayama (Prefecture of Japan)": [
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakayama (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Wake (Island of United States Minor Outlying Isl)": [
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wake (Island of United States Minor Outlying Isl)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Wakiso (District of Uganda)": [
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 130.6
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 46.9
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Wakiso (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.6
   }
  ],
  "Wales (Constituent Country of United Kingdom)": [
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wales (Constituent Country of United Kingdom)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 31.9
   }
  ],
  "Wallonie (Region of Belgium)": [
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wallonie (Region of Belgium)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Wangdue Phodrang (District of Bhutan)": [
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 147.1
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 28.5
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 27.4
   },
   {
    "Region Name": "Wangdue Phodrang (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Wanica (District of Suriname)": [
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Wanica (District of Suriname)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Warap (State of South Sudan)": [
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19590.5
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11602.7
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 17172.2
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14173.9
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12741.7
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13686.2
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13162.7
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 14880.6
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 13431.9
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14651.5
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 13592.5
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10595.2
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9718.6
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15438.0
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10928.7
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 12100.7
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 15990.4
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11217.9
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11742.9
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11259.7
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10276.0
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11171.6
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8976.5
   },
   {
    "Region Name": "Warap (State of South Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11608.3
   }
  ],
  "Wardak (Province of Afghanistan)": [
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wardak (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)": [
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 33.0
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.6
   }
  ],
  "Warwick (Parish of Bermuda)": [
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Warwick (Parish of Bermuda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Washington (State of United States)": [
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 620.8
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 947.7
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 474.8
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 758.9
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1620.2
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1189.3
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 627.2
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 552.4
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 594.2
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 390.8
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1209.7
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 621.2
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1679.6
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3876.9
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1090.1
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1527.4
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1541.1
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 684.3
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2723.6
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2645.3
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 838.2
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 892.4
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1173.2
   },
   {
    "Region Name": "Washington (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1057.5
   }
  ],
  "Wasit (Province of Iraq)": [
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 42.2
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 26.6
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 536.8
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 234.7
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 107.4
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 65.8
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 157.6
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 173.2
   },
   {
    "Region Name": "Wasit (Province of Iraq)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.2
   }
  ],
  "Waterford (County of Ireland)": [
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Waterford (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Wele-Nzas (Province of Equatorial Guinea)": [
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Wellington (Region of New Zealand)": [
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wellington (Region of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "West (Development Region of Nepal)": [
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 174.3
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 179.2
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 105.7
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 153.3
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 421.4
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 167.6
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 212.9
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 144.9
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 199.1
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 807.7
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 187.1
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 75.5
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 196.6
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 269.0
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 92.4
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 738.3
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 659.8
   },
   {
    "Region Name": "West (Development Region of Nepal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 194.9
   }
  ],
  "West (Region of Singapore)": [
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West (Region of Singapore)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "West Azarbaijan (Province of Iran)": [
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 132.9
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 37.9
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "West Azarbaijan (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.6
   }
  ],
  "West Bahr-al-Ghazal (State of South Sudan)": [
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 64697.4
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 60550.0
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 64437.0
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 61139.8
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 60769.1
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 59799.5
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 62332.5
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 61610.3
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 61577.9
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 62924.6
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 63996.9
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 63012.1
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 59150.6
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 53215.8
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 58299.4
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 53988.4
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 59158.8
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 57821.3
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 56066.7
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 53781.3
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 49634.4
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 47816.5
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 52464.2
   },
   {
    "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 48481.0
   }
  ],
  "West Bank (District of Palestine)": [
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "West Bank (District of Palestine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 14.6
   }
  ],
  "West Bay (District of Cayman Islands)": [
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Bay (District of Cayman Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "West Bengal (State of India)": [
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 80.2
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 352.2
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 210.7
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 186.5
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 117.0
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 133.1
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 459.2
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 169.8
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 108.9
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 140.6
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 217.6
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 163.3
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 453.2
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 452.3
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 323.5
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 551.6
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 200.6
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 339.1
   },
   {
    "Region Name": "West Bengal (State of India)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 372.6
   }
  ],
  "West Coast (Region of New Zealand)": [
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Coast (Region of New Zealand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "West Darfur (State of Sudan)": [
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 958.4
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2297.4
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1459.4
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 862.8
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1033.0
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1006.5
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 838.6
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 323.1
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 576.9
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 270.3
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 276.5
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 214.4
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 105.9
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 93.9
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 157.1
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 311.7
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 215.0
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 314.1
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 226.2
   },
   {
    "Region Name": "West Darfur (State of Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 737.0
   }
  ],
  "West End (District of Anguilla)": [
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West End (District of Anguilla)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "West Equatoria (State of South Sudan)": [
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 45993.1
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 46374.7
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 48325.4
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 52842.4
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 49651.1
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 48489.6
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 48645.0
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 48390.4
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 46308.8
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 50635.7
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 47074.1
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 44882.7
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 44638.1
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 44786.8
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 47783.9
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 45594.1
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 44879.9
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 42900.8
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 43940.1
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 40628.3
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 41435.4
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 39646.9
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 41764.7
   },
   {
    "Region Name": "West Equatoria (State of South Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 40677.4
   }
  ],
  "West Grand Bahama (District of Bahamas)": [
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 82.3
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Grand Bahama (District of Bahamas)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.4
   }
  ],
  "West Kazakhstan (Region of Kazakhstan)": [
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23764.5
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9576.3
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9681.3
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16376.1
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 21920.5
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11509.9
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 8346.2
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8648.5
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16552.9
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3754.0
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8926.1
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 850.0
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12452.7
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6292.4
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 860.5
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 27616.5
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3087.6
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 773.4
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3063.5
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 688.3
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1026.0
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 273.5
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 374.5
   },
   {
    "Region Name": "West Kazakhstan (Region of Kazakhstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 626.4
   }
  ],
  "West Kurdufan (State of Sudan)": [
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12622.0
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12184.9
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9025.6
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14180.5
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10677.7
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 16394.1
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10194.5
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 11741.6
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7879.8
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6852.5
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14231.5
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11067.0
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10813.2
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12557.1
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 9748.4
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 11465.7
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 10274.1
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7648.5
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11174.6
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 8505.5
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8413.3
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9999.9
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 11456.1
   },
   {
    "Region Name": "West Kurdufan (State of Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18108.0
   }
  ],
  "West New Britain (Province of Papua New Guinea)": [
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 61.7
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "West New Britain (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "West Pokot (County of Kenya)": [
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 110.6
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 44.8
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "West Pokot (County of Kenya)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.7
   }
  ],
  "West Virginia (State of United States)": [
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 74.6
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 29.8
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 34.9
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 124.5
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "West Virginia (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.9
   }
  ],
  "Western (District of American Samoa)": [
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (District of American Samoa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Western (Division of Fiji)": [
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 97.3
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17.4
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Division of Fiji)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Western (Division of Gambia)": [
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 256.8
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 257.9
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 328.2
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 310.4
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 408.6
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 242.9
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 71.8
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 214.4
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 153.9
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 228.9
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 182.6
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 111.7
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 155.8
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 147.1
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 132.5
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 132.7
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 225.7
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 195.3
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 185.2
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 163.8
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 141.7
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 229.8
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 114.9
   },
   {
    "Region Name": "Western (Division of Gambia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 145.6
   }
  ],
  "Western (Province of Papua New Guinea)": [
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1132.9
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1905.1
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4429.9
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 883.0
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2483.3
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 60.7
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 886.4
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 316.0
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 545.6
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 217.2
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2379.1
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4270.4
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 79.5
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 3306.0
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 774.7
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 235.2
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2041.4
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 93.7
   },
   {
    "Region Name": "Western (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Western (Province of Sierra Leone)": [
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 34.5
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 45.9
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Western (Province of Sierra Leone)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.1
   }
  ],
  "Western (Province of Solomon Islands)": [
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Province of Solomon Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Western (Province of Zambia)": [
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 28972.2
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 39159.4
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 36271.2
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 36574.8
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 28136.6
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 33130.9
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 32934.6
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 26576.0
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 33846.1
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 36876.4
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 38981.3
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 35408.8
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 33727.7
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 32888.5
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 36110.7
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 30114.8
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 29804.8
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 32372.7
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 27661.3
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 30472.1
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 31775.1
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 31114.2
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 32342.1
   },
   {
    "Region Name": "Western (Province of Zambia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 33695.8
   }
  ],
  "Western (Region of Ghana)": [
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 51.9
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 54.2
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Western (Region of Ghana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.2
   }
  ],
  "Western Australia (State of Australia)": [
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 259501.2
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 95069.2
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 201398.8
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 80251.6
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 241957.9
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 167985.6
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 118388.3
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 123822.5
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 47619.9
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 187079.2
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 393021.3
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 113316.7
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 178771.5
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 138662.7
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 78837.2
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 216559.0
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 292805.3
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 103039.5
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 32687.0
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 95495.8
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 88233.6
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 279434.9
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 73467.5
   },
   {
    "Region Name": "Western Australia (State of Australia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 177247.8
   }
  ],
  "Western Cape (Province of South Africa)": [
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2534.9
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2231.2
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1100.8
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2842.3
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1615.7
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1220.8
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1875.3
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4506.7
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1075.7
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2603.5
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1645.3
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1230.0
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1773.0
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3131.7
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2979.9
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3667.6
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2396.4
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 972.8
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 808.2
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2207.8
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1287.1
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1269.1
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1546.2
   },
   {
    "Region Name": "Western Cape (Province of South Africa)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 4739.3
   }
  ],
  "Western Finland (Province of Finland)": [
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Finland (Province of Finland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Western Highlands (Province of Papua New Guinea)": [
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 93.5
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Western Highlands (Province of Papua New Guinea)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.1
   }
  ],
  "Western North (Region of Ghana)": [
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 107.4
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 56.2
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Western North (Region of Ghana)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Westmeath (County of Ireland)": [
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westmeath (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Westmoreland (Parish of Jamaica)": [
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.9
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Westmoreland (Parish of Jamaica)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.1
   }
  ],
  "Wexford (County of Ireland)": [
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wexford (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "White Nile (State of Sudan)": [
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 584.6
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1056.8
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 532.5
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 681.1
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 532.9
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1103.1
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1188.7
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1210.5
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 519.4
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 426.8
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 639.7
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 813.3
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 540.0
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 600.7
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 504.6
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 484.5
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 501.4
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 569.6
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 591.2
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 848.0
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 692.8
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 621.0
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 991.7
   },
   {
    "Region Name": "White Nile (State of Sudan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1020.2
   }
  ],
  "Wicklow (County of Ireland)": [
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wicklow (County of Ireland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Wielkopolskie (Voivodeship of Poland)": [
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 12.9
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Wielkopolskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Wien (State of Austria)": [
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wien (State of Austria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Wisconsin (State of United States)": [
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 174.5
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 17.1
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 69.5
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 31.3
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Wisconsin (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19.7
   }
  ],
  "Woqooyi Galbeed (Region of Somalia)": [
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Woqooyi Galbeed (Region of Somalia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Woroba (District of C\u00f4te d'Ivoire)": [
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7080.4
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5620.3
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9369.0
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5078.0
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6086.8
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4313.7
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3973.3
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4646.2
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3759.8
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4420.9
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3945.5
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3603.3
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1846.4
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2570.3
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1152.7
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1226.0
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 729.7
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1584.8
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 774.7
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1130.2
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 863.0
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 740.0
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 735.5
   },
   {
    "Region Name": "Woroba (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 453.4
   }
  ],
  "Wotho (Atol of Marshall Islands)": [
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotho (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Wotje (Atol of Marshall Islands)": [
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wotje (Atol of Marshall Islands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Wouleu-Ntem (Province of Gabon)": [
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Wouleu-Ntem (Province of Gabon)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 15.0
   }
  ],
  "Wyoming (State of United States)": [
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 493.5
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 434.7
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 215.4
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 774.5
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 337.0
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 441.6
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 236.2
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 383.9
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1544.7
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 184.4
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 981.4
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 237.5
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 817.6
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 173.4
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 927.1
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 566.1
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 158.4
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2068.7
   },
   {
    "Region Name": "Wyoming (State of United States)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 643.1
   }
  ],
  "Xaignabouri (Province of Laos)": [
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 901.2
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 211.6
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2367.9
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 685.8
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 968.7
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2957.2
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 385.0
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1304.6
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3871.5
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 294.5
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 940.4
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2141.1
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 993.4
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1045.0
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2392.8
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 475.3
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 356.5
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1493.3
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2519.7
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 277.4
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 424.0
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2134.7
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1311.3
   },
   {
    "Region Name": "Xaignabouri (Province of Laos)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 274.2
   }
  ],
  "Xais\u00f4mboun (Special Region|Zone of Laos)": [
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 296.9
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 377.5
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 483.2
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 293.9
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 253.2
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 358.2
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 268.6
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 156.3
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 403.2
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 183.3
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 413.9
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 247.6
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 224.4
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 168.7
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 136.3
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 235.2
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 229.2
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 138.3
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 657.5
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 211.2
   },
   {
    "Region Name": "Xais\u00f4mboun (Special Region|Zone of Laos)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 74.2
   }
  ],
  "Xiangkhoang (Province of Laos)": [
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 235.6
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 509.8
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1068.2
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 758.0
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 422.3
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 537.4
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 217.4
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 257.5
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 684.5
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 146.0
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 624.7
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 365.1
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 450.4
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 646.8
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 348.6
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 357.6
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 338.7
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 350.1
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 535.1
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 174.3
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 413.7
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 942.4
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 481.3
   },
   {
    "Region Name": "Xiangkhoang (Province of Laos)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 146.4
   }
  ],
  "Xinjiang Uygur (Autonomous Region of China)": [
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 414.4
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 452.7
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 352.9
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 167.4
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 319.6
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 222.9
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 190.4
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 463.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 317.3
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 361.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 697.1
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 732.3
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 305.9
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 142.1
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 325.4
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 104.2
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 171.1
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 82.5
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 168.1
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Xizang (Autonomous Region of China)": [
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 26.8
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 20.6
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xizang (Autonomous Region of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Xlokk (Region of Malta)": [
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xlokk (Region of Malta)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Xorazm (Region of Uzbekistan)": [
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Xorazm (Region of Uzbekistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.8
   }
  ],
  "X\u00e9kong (Province of Laos)": [
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 314.9
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 233.9
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 111.7
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 75.9
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 181.6
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 257.0
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 165.7
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 92.2
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 132.9
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 114.0
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 53.4
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 86.4
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 137.0
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 118.8
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 69.2
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 143.6
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "X\u00e9kong (Province of Laos)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 85.3
   }
  ],
  "Yabucoa (Municipality of Puerto Rico)": [
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yabucoa (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Yala (Province of Thailand)": [
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yala (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Yalova (Province of Turkey)": [
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yalova (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Yamagata (Prefecture of Japan)": [
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamagata (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.1
   }
  ],
  "Yamaguchi (Prefecture of Japan)": [
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 20.2
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamaguchi (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Yamal-Nenets (Autonomous Province of Russia)": [
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 32.8
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 247.8
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 73.1
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1734.2
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 483.4
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 304.8
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 147.1
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1847.9
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3249.0
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4219.6
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1772.4
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 230.0
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 152.8
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 35.2
   }
  ],
  "Yamanashi (Prefecture of Japan)": [
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 18.4
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Yamanashi (Prefecture of Japan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Yambol (Province of Bulgaria)": [
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 104.0
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Yambol (Province of Bulgaria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 36.2
   }
  ],
  "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)": [
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 217.4
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 296.7
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 136.6
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 305.5
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 301.0
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 527.8
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 197.2
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 62.4
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 129.5
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 263.9
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 156.9
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 142.8
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 213.7
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 432.6
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 288.5
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 192.9
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 290.7
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 124.5
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 166.1
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 122.4
   },
   {
    "Region Name": "Yamoussoukro (Autonomous district of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 141.1
   }
  ],
  "Yangon (Division of Myanmar)": [
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 225.5
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 131.0
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 95.2
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 233.9
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 129.1
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 210.1
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 290.5
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 152.6
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 195.3
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 122.4
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 287.9
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 227.7
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 357.6
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 264.5
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 250.6
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 373.2
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 309.3
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 270.5
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 163.1
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 238.2
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 366.1
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 121.8
   },
   {
    "Region Name": "Yangon (Division of Myanmar)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 82.7
   }
  ],
  "Yap (State of Micronesia)": [
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yap (State of Micronesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Yaracuy (State of Venezuela)": [
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 45.2
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 300.5
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 64.3
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 22.7
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 33.9
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 83.4
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 45.7
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 50.4
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 62.2
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 42.0
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 70.7
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 65.0
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 362.3
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 33.7
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 199.4
   },
   {
    "Region Name": "Yaracuy (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 21.7
   }
  ],
  "Yaren (District of Nauru)": [
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaren (District of Nauru)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Yaroslavl' (Region of Russia)": [
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 264.3
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 556.1
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1921.0
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 89.0
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 61.5
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 29.4
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 41.4
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 84.9
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 74.8
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 117.3
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 25.3
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yaroslavl' (Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 5.6
   }
  ],
  "Yasothon (Province of Thailand)": [
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 147.9
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 81.0
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 169.6
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 85.5
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 82.1
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 64.1
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 55.7
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 53.8
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 73.3
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 56.6
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 34.1
   },
   {
    "Region Name": "Yasothon (Province of Thailand)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 48.9
   }
  ],
  "Yauco (Municipality of Puerto Rico)": [
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yauco (Municipality of Puerto Rico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Yazd (Province of Iran)": [
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yazd (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Yevrey (Autonomous Region of Russia)": [
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1948.8
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5675.2
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4647.3
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5625.9
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2274.0
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5377.9
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7506.3
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4096.4
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1953.1
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2383.8
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1268.0
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1055.1
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7693.5
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3748.2
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4082.0
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2977.6
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5331.6
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3990.7
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2552.7
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4027.6
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1115.8
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1966.2
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3407.8
   },
   {
    "Region Name": "Yevrey (Autonomous Region of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 957.8
   }
  ],
  "Yigo (Municipality of Guam)": [
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yigo (Municipality of Guam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Yobe (State of Nigeria)": [
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 673.1
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1474.9
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1482.8
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 792.5
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1230.9
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 358.9
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 258.3
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 199.8
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 200.4
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 261.7
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 160.8
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 189.3
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 105.9
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 587.2
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1011.0
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 558.9
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 303.1
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 111.0
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 158.6
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 108.0
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 183.1
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 85.7
   },
   {
    "Region Name": "Yobe (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 105.7
   }
  ],
  "Yogyakarta (Province of Indonesia)": [
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 40.1
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yogyakarta (Province of Indonesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Yona (Municipality of Guam)": [
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yona (Municipality of Guam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Yoro (Department of Honduras)": [
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 83.8
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 382.0
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 313.4
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 65.6
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 228.9
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 85.1
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 227.2
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 71.0
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 340.8
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 49.1
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 168.9
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 260.9
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 123.9
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 216.9
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 100.1
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 201.9
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 397.7
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 25.7
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 66.7
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 167.4
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 153.3
   },
   {
    "Region Name": "Yoro (Department of Honduras)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.4
   }
  ],
  "Yozgat (Province of Turkey)": [
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 50.6
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 473.3
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 205.4
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 543.0
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1337.4
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 764.0
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1166.6
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 308.5
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 424.2
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 106.5
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 30.9
   },
   {
    "Region Name": "Yozgat (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "Ysyk-K\u00f6l (Province of Kyrgyzstan)": [
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 25.1
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 40.3
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 31.5
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 41.2
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 30.0
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "Ysyk-K\u00f6l (Province of Kyrgyzstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 19.1
   }
  ],
  "Yucat\u00e1n (State of M\u00e9xico)": [
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1954.6
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2929.8
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 392.5
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 809.9
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 826.4
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 525.6
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1038.2
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 568.5
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 191.0
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 865.0
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 176.4
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 427.2
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 175.6
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 479.3
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 358.2
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 131.6
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 107.4
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 330.1
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 206.4
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 88.5
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 213.3
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 305.9
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 403.0
   },
   {
    "Region Name": "Yucat\u00e1n (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 162.1
   }
  ],
  "Yukhari-Karabakh (Region of Azerbaijan)": [
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 949.4
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1568.1
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1185.9
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 900.8
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2074.0
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 862.6
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 613.3
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 321.6
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1149.0
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1343.5
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 695.8
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 604.9
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 152.2
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2476.2
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1022.8
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 884.5
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 883.2
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1636.3
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 343.2
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1093.3
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 144.9
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 24.0
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 150.1
   },
   {
    "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 555.2
   }
  ],
  "Yukon (Territory of Canada)": [
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 195.5
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 349.0
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10966.0
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1039.7
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 772.8
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 89.8
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1493.1
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 649.3
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 108.3
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 206.4
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1621.3
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 962.1
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 151.8
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2152.9
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 667.8
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1814.6
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 18.0
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1331.9
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1788.7
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2953.6
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1333.6
   },
   {
    "Region Name": "Yukon (Territory of Canada)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1053.4
   }
  ],
  "Yumbe (District of Uganda)": [
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 864.3
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1052.1
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 898.6
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1022.1
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 932.7
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 776.7
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 723.3
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 583.7
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 782.0
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 606.0
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 774.3
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 544.9
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 705.5
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 594.2
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 680.6
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 586.1
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 450.8
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 747.5
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 301.2
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 406.0
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 408.8
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 274.8
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 270.1
   },
   {
    "Region Name": "Yumbe (District of Uganda)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 419.3
   }
  ],
  "Yunnan (Province of China)": [
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 344.1
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1147.1
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1496.3
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 898.2
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 771.9
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 916.2
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1120.5
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2419.4
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1743.5
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 843.1
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1343.5
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1051.9
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1102.5
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 935.1
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 819.5
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 459.2
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 344.1
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 470.3
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 672.9
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 454.5
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1010.1
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 863.0
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 346.2
   },
   {
    "Region Name": "Yunnan (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 454.5
   }
  ],
  "Y\u00ean B\u00e1i (Province of Vietnam)": [
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 78.7
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 83.6
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 87.0
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 115.1
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 21.7
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 39.0
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 123.5
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 74.0
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 32.4
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 51.2
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 18.2
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Y\u00ean B\u00e1i (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Zabaykal'ye (Territory of Russia)": [
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 6245.4
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 49453.6
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1874.0
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8616.1
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12455.1
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15313.0
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 17787.1
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4387.9
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3561.1
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12772.1
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7437.7
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2525.3
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 63097.8
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21702.7
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 4539.7
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4985.2
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8539.4
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11461.7
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7673.8
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 479.8
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2959.6
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4958.4
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 23363.2
   },
   {
    "Region Name": "Zabaykal'ye (Territory of Russia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20936.3
   }
  ],
  "Zabul (Province of Afghanistan)": [
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zabul (Province of Afghanistan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Zacapa (Department of Guatemala)": [
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 100.3
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 58.3
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 86.2
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 15.6
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 57.9
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 43.9
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 21.9
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36.9
   },
   {
    "Region Name": "Zacapa (Department of Guatemala)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 11.4
   }
  ],
  "Zacatecas (State of M\u00e9xico)": [
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 68.0
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 446.3
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 87.5
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 113.2
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 266.9
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 207.9
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 40.7
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 567.6
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 107.4
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 50.8
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 32.6
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 388.2
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 207.9
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 184.6
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 230.0
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 347.7
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 182.6
   },
   {
    "Region Name": "Zacatecas (State of M\u00e9xico)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 292.6
   }
  ],
  "Zachodniopomorskie (Voivodeship of Poland)": [
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 59.2
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.2
   }
  ],
  "Zadarska (County of Croatia)": [
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 14.1
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 40.9
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 35.4
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 166.6
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Zadarska (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.6
   }
  ],
  "Zaghouan (Governorate of Tunisia)": [
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 16.3
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 21.0
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 43.1
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Zaghouan (Governorate of Tunisia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 12.9
   }
  ],
  "Zagreba\u010dka (County of Croatia)": [
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zagreba\u010dka (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "Zaire (Province of Angola)": [
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5627.8
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 7045.0
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7134.2
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6312.3
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 7744.1
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5318.7
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 6644.6
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6702.0
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7845.3
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5285.3
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 6570.8
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 7814.6
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 5639.4
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 9179.1
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 5551.3
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6414.3
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5736.3
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5056.3
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 7867.3
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6467.7
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 7608.8
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 5187.7
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 8018.9
   },
   {
    "Region Name": "Zaire (Province of Angola)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7440.7
   }
  ],
  "Zaje\u010darski (District of Serbia)": [
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 13.7
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Zaje\u010darski (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 10.7
   }
  ],
  "Zakarpattia (Region of Ukraine)": [
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 16.7
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 34.3
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.9
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 80.8
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 92.2
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 36.4
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Zakarpattia (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Zala (County of Hungary)": [
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zala (County of Hungary)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Zambales (Province of Philippines)": [
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 94.3
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 121.8
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 91.3
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 92.8
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 151.6
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 38.2
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 146.6
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 121.8
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 135.1
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 145.1
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 145.6
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 154.1
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 150.3
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 141.5
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 231.1
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 179.6
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 174.5
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 156.3
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 114.0
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 113.0
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 189.5
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 174.7
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 101.0
   },
   {
    "Region Name": "Zambales (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 150.5
   }
  ],
  "Zambezi (Region of Namibia)": [
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5970.0
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 5017.7
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6241.4
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4129.0
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5505.9
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 5392.7
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 5471.8
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 3880.7
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4208.9
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 5455.9
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5183.7
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 4254.8
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4108.8
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5108.2
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3652.8
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5775.5
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4567.6
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3251.1
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3124.0
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4241.3
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3577.8
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3907.5
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1950.8
   },
   {
    "Region Name": "Zambezi (Region of Namibia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2231.4
   }
  ],
  "Zambezia (Province of Mozambique)": [
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 37968.8
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 39365.9
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 37371.2
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 45212.8
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 42309.8
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 42897.4
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 49105.1
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 43965.4
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 53968.5
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 38207.2
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 45776.1
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 46465.3
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 44808.3
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 38898.5
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 45765.9
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 40102.0
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 45901.5
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 39275.0
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 41868.4
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 42449.1
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 47327.1
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 41626.4
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 36658.2
   },
   {
    "Region Name": "Zambezia (Province of Mozambique)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 32200.4
   }
  ],
  "Zamboanga Sibugay (Province of Philippines)": [
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Zamboanga Sibugay (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Zamboanga del Norte (Province of Philippines)": [
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 52.5
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.1
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zamboanga del Norte (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Zamboanga del Sur (Province of Philippines)": [
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Zamboanga del Sur (Province of Philippines)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Zamfara (State of Nigeria)": [
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2628.6
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2531.3
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3573.7
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2973.1
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2771.8
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1717.7
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2014.6
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2800.1
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1744.7
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2057.3
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2214.4
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2598.8
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3359.2
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 6141.7
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 7056.2
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6111.9
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 5969.1
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6336.7
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8497.8
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 9663.3
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 10405.9
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 12911.7
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 9414.9
   },
   {
    "Region Name": "Zamfara (State of Nigeria)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 9139.6
   }
  ],
  "Zamora Chinchipe (Province of Ecuador)": [
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 14.8
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "Zamora Chinchipe (Province of Ecuador)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.0
   }
  ],
  "Zanjan (Province of Iran)": [
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zanjan (Province of Iran)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3.2
   }
  ],
  "Zanzan (District of C\u00f4te d'Ivoire)": [
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 11823.7
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11324.0
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 7492.0
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 8053.4
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 12059.1
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 10908.0
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7416.1
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 8747.5
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 8108.7
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 9685.0
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 8192.8
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 8955.1
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 8155.9
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7156.9
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8741.3
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 8589.8
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 8157.0
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7731.0
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6363.8
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7097.1
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3672.1
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 8177.7
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7399.6
   },
   {
    "Region Name": "Zanzan (District of C\u00f4te d'Ivoire)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6632.1
   }
  ],
  "Zapadno-Ba\u010dki (District of Serbia)": [
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 72.7
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 34.7
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 102.7
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 46.5
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 70.1
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 89.8
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 98.6
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 79.3
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 16.1
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 77.4
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 124.3
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.6
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Zapadno-Ba\u010dki (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Zaporizhia (Region of Ukraine)": [
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 612.5
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 158.8
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 491.5
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2432.4
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1069.1
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1144.7
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2977.6
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 981.6
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1078.7
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 505.1
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 126.0
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 296.9
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1159.1
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1347.1
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 962.9
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2938.4
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 515.8
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 976.9
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 327.3
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 741.9
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 931.0
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 891.8
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1400.0
   },
   {
    "Region Name": "Zaporizhia (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1025.3
   }
  ],
  "Zarqa (Province of Jordan)": [
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.7
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zarqa (Province of Jordan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Zasavska (Statistical Region of Slovenia)": [
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zasavska (Statistical Region of Slovenia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Zeeland (Province of Netherlands)": [
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeland (Province of Netherlands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Zeeuwse meren (Water body of Netherlands)": [
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zeeuwse meren (Water body of Netherlands)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Zelenikovo (Municipality of North Macedonia)": [
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zelenikovo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Zemgale (Province of Latvia)": [
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 39.2
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 54.0
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Zemgale (Province of Latvia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Zhambyl (Region of Kazakhstan)": [
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 5746.2
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6481.4
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 9225.8
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4083.9
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2231.2
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7677.2
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 516.2
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 4808.5
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 511.5
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 2340.7
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 864.6
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 614.8
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 313.4
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1593.2
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 630.2
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1590.8
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4323.0
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1627.3
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1448.7
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 204.7
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 569.6
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 311.5
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 328.4
   },
   {
    "Region Name": "Zhambyl (Region of Kazakhstan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 677.6
   }
  ],
  "Zhejiang (Province of China)": [
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 103.5
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 96.3
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 90.5
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 144.7
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 146.8
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 36.7
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 48.9
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 87.2
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 72.9
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 17.8
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Zhejiang (Province of China)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 20.2
   }
  ],
  "Zhemgang (District of Bhutan)": [
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zhemgang (District of Bhutan)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Zhytomyr (Region of Ukraine)": [
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 426.2
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 137.8
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 176.2
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 203.2
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 442.9
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 419.5
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 727.8
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 230.9
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 182.4
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 692.2
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 129.9
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1387.8
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 979.7
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 296.3
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 157.6
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 316.6
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 340.0
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1010.5
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 57.2
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 114.9
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 51.0
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 290.3
   },
   {
    "Region Name": "Zhytomyr (Region of Ukraine)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 286.2
   }
  ],
  "Ziguinchor (Region of Senegal)": [
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2282.0
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 963.8
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2566.6
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1589.5
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 2437.6
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1800.1
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 700.1
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1726.7
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1643.4
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1664.8
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1223.0
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1708.7
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1420.8
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 663.3
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1273.8
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1618.5
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1960.4
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1792.8
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1078.1
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 834.3
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1282.8
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2259.9
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 678.0
   },
   {
    "Region Name": "Ziguinchor (Region of Senegal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1281.9
   }
  ],
  "Zinder (Department of Niger)": [
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 184.4
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 49.5
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 64.5
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 147.9
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 212.0
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 116.4
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 86.8
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 66.0
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 243.7
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 322.0
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 617.6
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 329.3
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 737.6
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 120.0
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 714.5
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 149.4
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 520.3
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 787.2
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 486.0
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 463.3
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2397.9
   },
   {
    "Region Name": "Zinder (Department of Niger)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 3566.9
   }
  ],
  "Zinguldak (Province of Turkey)": [
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zinguldak (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "Zlatiborski (District of Serbia)": [
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zlatiborski (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Zl\u00ednsk\u00fd (Region of Czechia)": [
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Zl\u00ednsk\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Zomba (District of Malawi)": [
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 41.6
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 48.2
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 71.2
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 62.8
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 79.1
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 92.8
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 52.3
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 97.3
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 129.3
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 93.0
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 83.2
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 78.9
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 64.7
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 65.2
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 44.2
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 80.4
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 71.4
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 59.8
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 11.8
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 43.3
   },
   {
    "Region Name": "Zomba (District of Malawi)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 59.2
   }
  ],
  "Zou (Department of Benin)": [
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1051.1
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1704.0
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2898.5
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 543.4
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1222.3
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1059.8
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 709.6
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1194.5
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 786.5
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 834.5
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 779.7
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 786.3
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 632.4
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1290.7
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 623.8
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 546.6
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 213.5
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 772.4
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 194.4
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 361.4
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 430.5
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 132.1
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 507.4
   },
   {
    "Region Name": "Zou (Department of Benin)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 67.7
   }
  ],
  "Zrnovci (Municipality of North Macedonia)": [
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "Zrnovci (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "Zug (Canton of Switzerland)": [
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Zug (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "Zulia (State of Venezuela)": [
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 642.9
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1866.5
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 134.0
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 251.0
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 327.6
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 465.8
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 146.8
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 290.3
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 199.1
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 77.8
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 244.4
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 234.7
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 579.4
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 611.6
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1271.6
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 464.1
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1439.9
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1101.0
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2156.3
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 747.7
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 190.8
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 424.5
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 883.0
   },
   {
    "Region Name": "Zulia (State of Venezuela)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 437.3
   }
  ],
  "Z\u00fcrich (Canton of Switzerland)": [
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "Z\u00fcrich (Canton of Switzerland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "`Adan (Governorate of Yemen)": [
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "`Adan (Governorate of Yemen)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)": [
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 160.6
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 30.4
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 165.3
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 177.9
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 66.9
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 53.2
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 27.2
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 62.0
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "\u00b7\u220f\u00a7a\u00a0\u00bail (Province of Saudi Arabia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u00c7anakkale (Province of Turkey)": [
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 12.6
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 70.3
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "\u00c7anakkale (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 168.1
   }
  ],
  "\u00c7ank\u0131r\u0131 (Province of Turkey)": [
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 5.1
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 18.7
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 27.9
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.9
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 11.6
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 8.8
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "\u00c7ank\u0131r\u0131 (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.4
   }
  ],
  "\u00c7orum (Province of Turkey)": [
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 8.4
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 68.6
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 112.1
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 25.9
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 310.2
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 197.6
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 296.5
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 101.4
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 54.7
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 72.7
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 6.4
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 15.9
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "\u00c7orum (Province of Turkey)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 7.1
   }
  ],
  "\u00c9quateur (Province of Democratic Republic of the Congo)": [
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 99.3
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 203.9
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 338.9
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 391.2
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 340.8
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 258.5
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 332.1
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 160.6
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 520.3
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 466.7
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 358.4
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 319.2
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 131.4
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 287.0
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 255.5
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 263.7
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 311.0
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 250.8
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 398.7
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 431.5
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 187.8
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 173.2
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 583.3
   },
   {
    "Region Name": "\u00c9quateur (Province of Democratic Republic of the Congo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 151.6
   }
  ],
  "\u00c9vora (District of Portugal)": [
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 19.7
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 84.5
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 52.9
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 63.9
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.6
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 28.7
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u00c9vora (District of Portugal)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 18.4
   }
  ],
  "\u00cele-de-France (Region of France)": [
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 113.8
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 15.0
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 39.7
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 11.4
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 4.3
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 21.4
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 14.6
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 9.4
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00cele-de-France (Region of France)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "\u00celes Australes (Administrative subdivisions of French Polynesia)": [
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Australes (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u00celes Crozet (District of French Southern Territories)": [
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Crozet (District of French Southern Territories)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u00celes Loyaut\u00e9 (Province of New Caledonia)": [
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Loyaut\u00e9 (Province of New Caledonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u00celes Marquises (Administrative subdivisions of French Polynesia)": [
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Marquises (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)": [
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Saint Paul et Amsterdam (District of French Southern Territories)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)": [
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Sous-le-Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)": [
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u00celes du Vent (Administrative subdivisions of French Polynesia)": [
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes du Vent (Administrative subdivisions of French Polynesia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u00celes \u00c9parses (District of French Southern Territories)": [
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00celes \u00c9parses (District of French Southern Territories)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u00d1eembuc\u00fa (Department of Paraguay)": [
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 224.9
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1697.6
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1016.3
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1144.1
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1135.9
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 519.0
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1272.1
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 973.2
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 253.2
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 784.2
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 676.1
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 362.5
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 133.1
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 212.9
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 441.2
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 264.3
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 865.6
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 739.8
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 2349.5
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 2447.5
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 963.4
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 755.7
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 862.4
   },
   {
    "Region Name": "\u00d1eembuc\u00fa (Department of Paraguay)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 793.2
   }
  ],
  "\u00d1uble (Region of Chile)": [
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 36.0
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 44.4
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 136.3
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 28.3
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 47.2
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 121.1
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 309.8
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 79.7
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 162.3
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 537.9
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 49.9
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 109.3
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 185.9
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 94.1
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 205.4
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 743.6
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 137.0
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 108.3
   },
   {
    "Region Name": "\u00d1uble (Region of Chile)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 214.4
   }
  ],
  "\u00d6mn\u00f6govi (Province of Mongolia)": [
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6mn\u00f6govi (Province of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u00d6sterg\u00f6tland (County of Sweden)": [
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.9
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6sterg\u00f6tland (County of Sweden)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u00d6v\u00f6rkhangay (Province of Mongolia)": [
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.9
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "\u00d6v\u00f6rkhangay (Province of Mongolia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.3
   }
  ],
  "\u00d8stfold (County of Norway)": [
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00d8stfold (County of Norway)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u00dasteck\u00fd (Region of Czechia)": [
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "\u00dasteck\u00fd (Region of Czechia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 6.9
   }
  ],
  "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)": [
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u010cu\u010der-Sandevo (Municipality of North Macedonia)": [
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u010cu\u010der-Sandevo (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "\u0110akovica (District of Kosovo)": [
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 80.6
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 3.6
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 30.7
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 30.2
   },
   {
    "Region Name": "\u0110akovica (District of Kosovo)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.5
   }
  ],
  "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)": [
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 118.8
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 663.5
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1086.4
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 474.4
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1079.3
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1181.4
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 328.0
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 382.0
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 562.7
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 325.6
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 368.5
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 580.1
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 278.3
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 362.1
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 210.7
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 27.0
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 87.5
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 241.6
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 228.9
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 20.8
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 110.8
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 185.9
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 249.5
   },
   {
    "Region Name": "\u0110i\u1ec7n Bi\u00ean (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 32.2
   }
  ],
  "\u0110\u00e0 N\u1eb5ng (City of Vietnam)": [
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 3.4
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0110\u00e0 N\u1eb5ng (City of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u0110\u1eafk L\u1eafk (Province of Vietnam)": [
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 1883.7
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 1887.5
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1662.0
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 1627.1
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1817.4
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 1106.8
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 1761.9
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1312.4
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 2053.0
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1718.4
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1192.3
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1321.8
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1608.0
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1464.8
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1249.1
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 1539.8
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1141.1
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1115.4
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1208.8
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1094.4
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 1196.2
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 929.1
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1176.2
   },
   {
    "Region Name": "\u0110\u1eafk L\u1eafk (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 601.5
   }
  ],
  "\u0110\u1eafk N\u00f4ng (Province of Vietnam)": [
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 250.6
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 274.2
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 332.9
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 277.0
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 294.5
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 153.3
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 378.6
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 155.6
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 317.5
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 399.6
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 179.0
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 198.7
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 263.2
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 224.7
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 111.9
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 217.6
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 184.4
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 135.1
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 147.3
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 126.0
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 179.9
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 127.3
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 198.3
   },
   {
    "Region Name": "\u0110\u1eafk N\u00f4ng (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 86.4
   }
  ],
  "\u0110\u1ed3ng Nai (Province of Vietnam)": [
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 37.1
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 23.4
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 18.9
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 19.9
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 27.7
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 39.9
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 24.4
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 25.5
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 26.4
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 55.3
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 42.4
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 52.1
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 8.1
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 16.5
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 23.8
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 9.2
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 19.3
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 12.4
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 33.4
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 7.7
   },
   {
    "Region Name": "\u0110\u1ed3ng Nai (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 27.4
   }
  ],
  "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)": [
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 69.7
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 553.1
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 593.6
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 614.8
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 311.5
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 590.8
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 925.6
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1498.0
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1012.7
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 744.9
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2100.6
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 717.5
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1684.5
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 2664.6
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1048.7
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 931.2
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 1499.9
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1616.1
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 1048.7
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1051.5
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 395.9
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1318.6
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 1459.2
   },
   {
    "Region Name": "\u0110\u1ed3ng Th\u00e1p (Province of Vietnam)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 800.9
   }
  ],
  "\u0141\u00f3dzkie (Voivodeship of Poland)": [
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 10.1
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 2.8
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0141\u00f3dzkie (Voivodeship of Poland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u015al\u0105skie (Voivodeship of Poland)": [
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 36.2
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 14.4
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015al\u0105skie (Voivodeship of Poland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u015awi\u0119tokrzyskie (Voivodeship of Poland)": [
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 33.2
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 4.7
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 5.8
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 12.2
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u015awi\u0119tokrzyskie (Voivodeship of Poland)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u0160avnik (Municipality of Montenegro)": [
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 24.9
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 17.6
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 7.9
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160avnik (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u0160a\u0161ka (Municipality of North Macedonia)": [
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 13.9
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 8.6
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.3
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u0160iauliai (County of Lithuania)": [
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 6.9
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 9.9
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 2.4
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 11.1
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.9
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u0160iauliai (County of Lithuania)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u0160ibensko-Kninska (County of Croatia)": [
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 21.2
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 15.4
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 6.0
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 7.1
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 22.3
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 88.1
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 39.4
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 41.8
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 43.7
   },
   {
    "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 2.8
   }
  ],
  "\u0160tip (Municipality of North Macedonia)": [
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 23.6
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 2.6
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 13.3
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 5.6
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 10.5
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 129.7
   },
   {
    "Region Name": "\u0160tip (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u0160umadijski (District of Serbia)": [
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 3.2
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160umadijski (District of Serbia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u0160uto Orizari (Municipality of North Macedonia)": [
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u017dabljak (Municipality of Montenegro)": [
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 22.5
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 7.5
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dabljak (Municipality of Montenegro)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u017delino (Municipality of North Macedonia)": [
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 7.3
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 15.2
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 5.4
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 1.1
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017delino (Municipality of North Macedonia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ],
  "\u017dilinsk\u00fd (Region of Slovakia)": [
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.6
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u017dilinsk\u00fd (Region of Slovakia)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 1.9
   }
  ],
  "\u0218old\u0103ne\u0219ti (District of Moldova)": [
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 0.9
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 0.2
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 2.1
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 6.2
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 1.5
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 0.4
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.0
   }
  ],
  "\u0218tefan Vod\u0103 (District of Moldova)": [
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2002,
    "Burned Area (km^2)": 4.5
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2003,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2004,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2005,
    "Burned Area (km^2)": 10.3
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2006,
    "Burned Area (km^2)": 9.0
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2007,
    "Burned Area (km^2)": 38.4
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2008,
    "Burned Area (km^2)": 55.1
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2009,
    "Burned Area (km^2)": 13.5
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2010,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2011,
    "Burned Area (km^2)": 19.1
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2012,
    "Burned Area (km^2)": 4.1
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2013,
    "Burned Area (km^2)": 20.4
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2014,
    "Burned Area (km^2)": 35.8
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2015,
    "Burned Area (km^2)": 12.0
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2016,
    "Burned Area (km^2)": 31.9
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2017,
    "Burned Area (km^2)": 19.5
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2018,
    "Burned Area (km^2)": 26.2
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2019,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2020,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2021,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2022,
    "Burned Area (km^2)": 3.0
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2023,
    "Burned Area (km^2)": 1.7
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2024,
    "Burned Area (km^2)": 0.0
   },
   {
    "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
    "Fire Season Start Year": 2025,
    "Burned Area (km^2)": 0.2
   }
  ]
 }
}